// @ts-nocheck
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Cursor: { input: any; output: any }
  Time: { input: any; output: any }
  UUID: { input: any; output: any }
  /** gqlgen built-in scalar for multipart file uploads. */
  Upload: { input: any; output: any }
}

export type ArAgingBucketsAmountResponse = {
  __typename: 'ARAgingBucketsAmountResponse'
  data: Array<BucketAmountData>
}

export type ArAgingBucketsCountResponse = {
  __typename: 'ARAgingBucketsCountResponse'
  data: Array<BucketCountData>
}

export type ArAgingBucketsWithClientsResponse = {
  __typename: 'ARAgingBucketsWithClientsResponse'
  data: Array<ArBucketWithClientsData>
}

export type ArBucketClientData = {
  __typename: 'ARBucketClientData'
  amount: Scalars['Float']['output']
  customerID: Scalars['String']['output']
  customerName: Scalars['String']['output']
  invoiceCount: Scalars['Int']['output']
}

export type ArBucketWithClientsData = {
  __typename: 'ARBucketWithClientsData'
  bucket: Scalars['String']['output']
  clients: Array<ArBucketClientData>
  totalAmount: Scalars['Float']['output']
}

export type Account = {
  __typename: 'Account'
  bankAccountVerification?: Maybe<Array<Maybe<BankAccountVerification>>>
  companyName?: Maybe<Scalars['String']['output']>
  customName?: Maybe<Scalars['String']['output']>
  disconnectedAt?: Maybe<Scalars['String']['output']>
  hasAchAccountNumber?: Maybe<Scalars['Boolean']['output']>
  hasAchRoutingNumber?: Maybe<Scalars['Boolean']['output']>
  hasWireRoutingNumber?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  institution?: Maybe<Institution>
  mandates?: Maybe<Array<Maybe<Mandate>>>
  mask?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  officialName?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  subtype?: Maybe<Scalars['String']['output']>
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
  transitNumber?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type AccountData = CaAccountData | UsAccountData

export type AccountDataInput = {
  caAccount?: InputMaybe<CaAccountDataInput>
  usAccount?: InputMaybe<UsAccountDataInput>
}

export type AccountingCustomerRelation = {
  __typename: 'AccountingCustomerRelation'
  externalID: Scalars['String']['output']
  id: Scalars['ID']['output']
  platformName: PlatformName
}

/**
 * Accounting item (product or service) from external accounting systems.
 * Decimal values (unitPrice, purchaseCost) are represented as strings
 * to preserve precision for financial calculations.
 */
export type AccountingItem = {
  __typename: 'AccountingItem'
  active: Scalars['Boolean']['output']
  description?: Maybe<Scalars['String']['output']>
  expenseAccountId?: Maybe<Scalars['String']['output']>
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  incomeAccountId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  purchaseCost: Scalars['String']['output']
  taxable: Scalars['Boolean']['output']
  type: Scalars['String']['output']
  unitPrice: Scalars['String']['output']
}

/** Paginated list of accounting items. */
export type AccountingItemList = {
  __typename: 'AccountingItemList'
  items: Array<AccountingItem>
  total: Scalars['Int']['output']
}

export type AccountingPreferences = {
  __typename: 'AccountingPreferences'
  apEnabled: Scalars['Boolean']['output']
  archiveZeroedInvoices: Scalars['Boolean']['output']
  contactsFromPrimary: Scalars['Boolean']['output']
  paymentFailedNotificationEnabled: Scalars['Boolean']['output']
  pdfFromPrimary: Scalars['Boolean']['output']
  pushPaymentsTo: PushPaymentsTo
  syncPaymentsQboCw: Scalars['Boolean']['output']
  useIntegrationPDF: Scalars['Boolean']['output']
}

export type AccountingPreferencesUpdateInput = {
  apEnabled?: InputMaybe<Scalars['Boolean']['input']>
  archiveZeroedInvoices?: InputMaybe<Scalars['Boolean']['input']>
  contactsFromPrimary?: InputMaybe<Scalars['Boolean']['input']>
  paymentFailedNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  pdfFromPrimary?: InputMaybe<Scalars['Boolean']['input']>
  pushPaymentsTo?: InputMaybe<PushPaymentsTo>
  syncPaymentsQboCw?: InputMaybe<Scalars['Boolean']['input']>
  useIntegrationPDF?: InputMaybe<Scalars['Boolean']['input']>
}

/** External accounting provider integration. */
export enum AccountingProvider {
  Quickbooks = 'QUICKBOOKS'
}

export type AccountingSyncBatch = {
  __typename: 'AccountingSyncBatch'
  createdAt: Scalars['String']['output']
  externalID: Scalars['String']['output']
  id: Scalars['ID']['output']
  numberOfInvoices: Scalars['Int']['output']
  platform: PlatformName
  status: AccountingSyncBatchStatus
}

export type AccountingSyncBatchCreateInput = {
  invoiceRelationIDs?: InputMaybe<Array<Scalars['String']['input']>>
  platformName: PlatformName
  platformNameTarget: PlatformName
}

export type AccountingSyncBatchCreateReply = {
  __typename: 'AccountingSyncBatchCreateReply'
  batch?: Maybe<AccountingSyncBatch>
  notSyncedInvoiceNumbers?: Maybe<Array<Scalars['String']['output']>>
}

export type AccountingSyncBatchEdge = {
  __typename: 'AccountingSyncBatchEdge'
  cursor: Scalars['Cursor']['output']
  node: AccountingSyncBatch
}

export enum AccountingSyncBatchStatus {
  Empty = 'EMPTY',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type AccountingSyncJob = {
  __typename: 'AccountingSyncJob'
  billingTermData?: Maybe<AccountingSyncJobBillingTermData>
  customerData?: Maybe<AccountingSyncJobCustomerData>
  errorMessage?: Maybe<Scalars['String']['output']>
  internalEntityID: Scalars['ID']['output']
  invoiceData?: Maybe<AccountingSyncJobInvoiceData>
  lineItemData?: Maybe<AccountingSyncJobLineItemData>
  paymentData?: Maybe<AccountingSyncJobPaymentData>
  status: AccountingSyncJobStatus
  type: AccountingSyncJobType
}

export type AccountingSyncJobBillingTermData = {
  __typename: 'AccountingSyncJobBillingTermData'
  billingTermName: Scalars['String']['output']
}

export type AccountingSyncJobCustomerData = {
  __typename: 'AccountingSyncJobCustomerData'
  customerName: Scalars['String']['output']
}

export type AccountingSyncJobInvoiceData = {
  __typename: 'AccountingSyncJobInvoiceData'
  amount: Scalars['Float']['output']
  customerName: Scalars['String']['output']
  dueDate: Scalars['String']['output']
  invoiceDate: Scalars['String']['output']
  invoiceNumber: Scalars['String']['output']
}

export type AccountingSyncJobLineItemData = {
  __typename: 'AccountingSyncJobLineItemData'
  lineItemName: Scalars['String']['output']
}

export type AccountingSyncJobPaymentData = {
  __typename: 'AccountingSyncJobPaymentData'
  amount: Scalars['Float']['output']
}

export enum AccountingSyncJobStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum AccountingSyncJobType {
  BillingTermCreate = 'BILLING_TERM_CREATE',
  BillingTermUpdate = 'BILLING_TERM_UPDATE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  InvoiceCreate = 'INVOICE_CREATE',
  InvoiceUpdate = 'INVOICE_UPDATE',
  ItemCreate = 'ITEM_CREATE',
  ItemUpdate = 'ITEM_UPDATE',
  PaymentCreate = 'PAYMENT_CREATE'
}

/** Partner Accounts Payable configuration. */
export type AccountsPayableConfig = {
  __typename: 'AccountsPayableConfig'
  /**
   * The currently enabled accounting provider integration, if any.
   * Null means no integration is enabled.
   */
  accountingProvider?: Maybe<AccountingProvider>
  /**
   * Bank account that svc-accounts-payable debits to fund vendor payments.
   * Null until the partner picks one.
   */
  fundingBankingAccount?: Maybe<Account>
  mailbox: Scalars['String']['output']
  notificationPolicy: AccountsPayableNotificationPolicy
  onboardingStatus: AccountsPayableOnboardingStatus
}

/** Accounts Payable notification policy settings. */
export type AccountsPayableNotificationPolicy = {
  __typename: 'AccountsPayableNotificationPolicy'
  billCreatedEnabled: Scalars['Boolean']['output']
  billOverdueEnabled: Scalars['Boolean']['output']
  emailIngestionFailedEnabled: Scalars['Boolean']['output']
  paymentFailedEnabled: Scalars['Boolean']['output']
}

/** Onboarding status for Accounts Payable configuration. */
export enum AccountsPayableOnboardingStatus {
  Concluded = 'CONCLUDED',
  None = 'NONE',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Unspecified = 'UNSPECIFIED'
}

/**
 * A single vendor payment row for the Virtual Card Log screen. Mirrors the
 * svc-accounts-payable ListPayments PaymentListItem: the full payment status
 * spectrum is preserved (READY is distinct from SUCCEEDED), unlike the
 * collapsed VendorPayment view used elsewhere.
 */
export type AccountsPayablePayment = {
  __typename: 'AccountsPayablePayment'
  amount: Scalars['String']['output']
  attemptNumber: Scalars['Int']['output']
  bill: AccountsPayablePaymentBill
  createdAt: Scalars['String']['output']
  estimatedArrivalDate?: Maybe<Scalars['String']['output']>
  failureReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** ACH bank account display for this payment. Null for virtual-card payments or when the preference cannot be resolved. */
  paymentMethod?: Maybe<AccountsPayablePaymentMethod>
  paymentSpeed?: Maybe<PaymentSpeed>
  paymentType: PaymentType
  /** Human-facing reference (the funding attempt's statement descriptor). Empty when there is no correlated funding attempt. */
  reference: Scalars['String']['output']
  sentAt?: Maybe<Scalars['String']['output']>
  status: VendorPaymentStatus
  substatus?: Maybe<Scalars['String']['output']>
  vendor: AccountsPayablePaymentVendor
  virtualCard?: Maybe<AccountsPayablePaymentVirtualCard>
}

/**
 * Summary cards for the Payments page, computed over the same filter set as
 * PartnerAccountsPayablePaymentList. Amounts are decimal strings to preserve
 * money precision; counts are over distinct bills, totalAttemptCount over payments.
 */
export type AccountsPayablePaymentAggregates = {
  __typename: 'AccountsPayablePaymentAggregates'
  byStatus: Array<AccountsPayablePaymentStatusAggregate>
  totalAmount: Scalars['String']['output']
  totalAttemptCount: Scalars['Int']['output']
}

export type AccountsPayablePaymentBill = {
  __typename: 'AccountsPayablePaymentBill'
  amount: Scalars['String']['output']
  dueDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  number: Scalars['String']['output']
  payDate: Scalars['String']['output']
  status: BillStatus
}

export type AccountsPayablePaymentFilter = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  payDateEnd?: InputMaybe<Scalars['String']['input']>
  payDateStart?: InputMaybe<Scalars['String']['input']>
  paymentType?: InputMaybe<PaymentType>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<VendorPaymentStatus>>
  vendorIDs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AccountsPayablePaymentListResponse = {
  __typename: 'AccountsPayablePaymentListResponse'
  hasMore: Scalars['Boolean']['output']
  payments: Array<AccountsPayablePayment>
  totalCount: Scalars['Int']['output']
}

export type AccountsPayablePaymentMethod = {
  __typename: 'AccountsPayablePaymentMethod'
  accountMask: Scalars['String']['output']
  bankName: Scalars['String']['output']
}

export type AccountsPayablePaymentOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AccountsPayablePaymentOrderByField>
}

export enum AccountsPayablePaymentOrderByField {
  BillAmount = 'BILL_AMOUNT',
  CardIssuedAt = 'CARD_ISSUED_AT',
  CreatedDate = 'CREATED_DATE',
  PayDate = 'PAY_DATE',
  Status = 'STATUS',
  VendorName = 'VENDOR_NAME'
}

export type AccountsPayablePaymentStatusAggregate = {
  __typename: 'AccountsPayablePaymentStatusAggregate'
  amount: Scalars['String']['output']
  billCount: Scalars['Int']['output']
  status: BillStatus
}

export type AccountsPayablePaymentVendor = {
  __typename: 'AccountsPayablePaymentVendor'
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AccountsPayablePaymentVirtualCard = {
  __typename: 'AccountsPayablePaymentVirtualCard'
  expiresAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  issuedAt: Scalars['String']['output']
  last4: Scalars['String']['output']
  network: Scalars['String']['output']
  status: VirtualCardStatus
}

export type AccountsPayableResponse = {
  __typename: 'AccountsPayableResponse'
  ID: Scalars['String']['output']
}

export type ActivationRateInvoiceVolumeByMonthData = {
  __typename: 'ActivationRateInvoiceVolumeByMonthData'
  month: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type ActivationRateInvoiceVolumeByMonthResponse = {
  __typename: 'ActivationRateInvoiceVolumeByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<ActivationRateInvoiceVolumeByMonthData>
}

export type ActivationRatesByMonthResponse = {
  __typename: 'ActivationRatesByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

/**
 * A single entry of the partner's recent-activity feed, derived from a bill or
 * payment status transition.
 */
export type ActivityItem = {
  __typename: 'ActivityItem'
  /** Bill amount as a decimal string. */
  amount: Scalars['String']['output']
  billId: Scalars['ID']['output']
  /**
   * The new bill status of the transition. Set for bill-derived kinds
   * (BILL_CREATED, BILL_STATUS_CHANGED); null otherwise.
   */
  billStatus?: Maybe<BillStatus>
  /** ID of the underlying status-history row. */
  id: Scalars['ID']['output']
  kind: ActivityKind
  /** RFC3339 timestamp of when the transition occurred. */
  occurredAt: Scalars['String']['output']
  /**
   * The new payment status of the transition. Set for payment-derived kinds
   * (PAYMENT_SCHEDULED, PAYMENT_SENT, PAYMENT_FAILED); null otherwise.
   */
  paymentStatus?: Maybe<VendorPaymentStatus>
  vendorName: Scalars['String']['output']
}

/** Classifies a recent-activity feed entry. */
export enum ActivityKind {
  BillCreated = 'BILL_CREATED',
  BillStatusChanged = 'BILL_STATUS_CHANGED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentScheduled = 'PAYMENT_SCHEDULED',
  PaymentSent = 'PAYMENT_SENT'
}

export type AddBankAccountInput = {
  accountData: AccountDataInput
  approveBehavior?: InputMaybe<OnApproveBehavior>
  companySpecification: CompanySpecificationInput
  customName?: InputMaybe<Scalars['String']['input']>
  mandateData?: InputMaybe<MandateConsentInput>
}

export type AddCustomerBankAccountInput = {
  accountData: AccountDataInput
  companySpecification: CompanySpecificationInput
  customName?: InputMaybe<Scalars['String']['input']>
  mandateData?: InputMaybe<MandateConsentInput>
}

export type Address = AddressInterface & {
  __typename: 'Address'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryISO?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  countryISO?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type AddressInterface = {
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export enum AdyenBusinessSetup {
  Organization = 'ORGANIZATION',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

export enum AdyenCompanyType {
  AssociationIncorporated = 'ASSOCIATION_INCORPORATED',
  GovernmentalOrganization = 'GOVERNMENTAL_ORGANIZATION',
  ListedPublicCompany = 'LISTED_PUBLIC_COMPANY',
  NonProfit = 'NON_PROFIT',
  PartnershipIncorporated = 'PARTNERSHIP_INCORPORATED',
  PrivateCompany = 'PRIVATE_COMPANY'
}

export type AdyenOnboardingStatus = {
  __typename: 'AdyenOnboardingStatus'
  pciFormsSigned: Scalars['Boolean']['output']
  termsOfServiceAccepted: Scalars['Boolean']['output']
  tosAndPciEntitiesCreated: Scalars['Boolean']['output']
}

export enum AdyenOnboardingStatusStep {
  Concluded = 'CONCLUDED',
  None = 'NONE',
  Pending = 'PENDING'
}

export enum AdyenOwnerType {
  BankAccount = 'BANK_ACCOUNT',
  Individual = 'INDIVIDUAL',
  Partner = 'PARTNER'
}

export type AdyenPciForms = {
  __typename: 'AdyenPciForms'
  document: Scalars['String']['output']
  pciIds: Array<Scalars['String']['output']>
}

export enum AdyenRemediationActionType {
  AdyenRemediationActionTypeAddOrganizationPrincipalPlaceOfBusinessStateOrProvince = 'ADYEN_REMEDIATION_ACTION_TYPE_ADD_ORGANIZATION_PRINCIPAL_PLACE_OF_BUSINESS_STATE_OR_PROVINCE',
  AdyenRemediationActionTypeAddOrganizationRegisteredAddressCity = 'ADYEN_REMEDIATION_ACTION_TYPE_ADD_ORGANIZATION_REGISTERED_ADDRESS_CITY',
  AdyenRemediationActionTypeAddOrganizationRegisteredAddressPostalCode = 'ADYEN_REMEDIATION_ACTION_TYPE_ADD_ORGANIZATION_REGISTERED_ADDRESS_POSTAL_CODE',
  AdyenRemediationActionTypeAddOrganizationRegisteredAddressStreet = 'ADYEN_REMEDIATION_ACTION_TYPE_ADD_ORGANIZATION_REGISTERED_ADDRESS_STREET',
  AdyenRemediationActionTypeGenericMissingType = 'ADYEN_REMEDIATION_ACTION_TYPE_GENERIC_MISSING_TYPE',
  AdyenRemediationActionTypeTechnicalIssueVerificationProcess = 'ADYEN_REMEDIATION_ACTION_TYPE_Technical_ISSUE_VERIFICATION_PROCESS',
  AdyenRemediationActionTypeUpdateBankAccountDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_BANK_ACCOUNT_DETAILS',
  AdyenRemediationActionTypeUpdateIdNumberToSsn = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_ID_NUMBER_TO_SSN',
  AdyenRemediationActionTypeUpdateIndividualDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_INDIVIDUAL_DETAILS',
  AdyenRemediationActionTypeUpdateIndustry = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_INDUSTRY',
  AdyenRemediationActionTypeUpdateMissingBankAccount = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_BANK_ACCOUNT',
  AdyenRemediationActionTypeUpdateMissingIndividualBirthData = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_BIRTH_DATA',
  AdyenRemediationActionTypeUpdateMissingIndividualCity = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_CITY',
  AdyenRemediationActionTypeUpdateMissingIndividualDateOfBirth = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_DATE_OF_BIRTH',
  AdyenRemediationActionTypeUpdateMissingIndividualEmail = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_EMAIL',
  AdyenRemediationActionTypeUpdateMissingIndividualIdentificationData = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_IDENTIFICATION_DATA',
  AdyenRemediationActionTypeUpdateMissingIndividualPostalCode = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_POSTAL_CODE',
  AdyenRemediationActionTypeUpdateMissingIndividualStateOrProvince = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_STATE_OR_PROVINCE',
  AdyenRemediationActionTypeUpdateMissingIndividualStreet = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_STREET',
  AdyenRemediationActionTypeUpdateMissingOrganizationRegistrationNumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_REGISTRATION_NUMBER',
  AdyenRemediationActionTypeUpdateMissingOrganizationTaxId = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_TAX_ID',
  AdyenRemediationActionTypeUpdateMissingOrganizationTaxInfo = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_TAX_INFO',
  AdyenRemediationActionTypeUpdateMissingOrganizationType = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_TYPE',
  AdyenRemediationActionTypeUpdateMissingPhoneNumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_PHONE_NUMBER',
  AdyenRemediationActionTypeUpdateMissingSignatory = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_SIGNATORY',
  AdyenRemediationActionTypeUpdateMissingUboThroughControl = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_UBO_THROUGH_CONTROL',
  AdyenRemediationActionTypeUpdateOrganizationDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_ORGANIZATION_DETAILS',
  AdyenRemediationActionTypeUpdateOrganizationLegalName = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_ORGANIZATION_LEGAL_NAME',
  AdyenRemediationActionTypeUpdateSignatoryDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_SIGNATORY_DETAILS',
  AdyenRemediationActionTypeUploadBankStatement = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_BANK_STATEMENT',
  AdyenRemediationActionTypeUploadConstitutionalDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_CONSTITUTIONAL_DOCUMENT',
  AdyenRemediationActionTypeUploadDifferentBankStatement = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_BANK_STATEMENT',
  AdyenRemediationActionTypeUploadDifferentIdDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_ID_DOCUMENT',
  AdyenRemediationActionTypeUploadDifferentImageOfTheIdDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_IMAGE_OF_THE_ID_DOCUMENT',
  AdyenRemediationActionTypeUploadDifferentImageProofOfNationalIdnumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_IMAGE_PROOF_OF_NATIONAL_IDNUMBER',
  AdyenRemediationActionTypeUploadDifferentProofOfIndividualTaxId = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_INDIVIDUAL_TAX_ID',
  AdyenRemediationActionTypeUploadDifferentProofOfIndustry = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_INDUSTRY',
  AdyenRemediationActionTypeUploadDifferentProofOfNationalIdnumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_NATIONAL_IDNUMBER',
  AdyenRemediationActionTypeUploadDifferentProofOfOrganizationAddress = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_ORGANIZATION_ADDRESS',
  AdyenRemediationActionTypeUploadDifferentProofOfOrganizationTaxInfo = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_ORGANIZATION_TAX_INFO',
  AdyenRemediationActionTypeUploadDifferentProofOfResidency = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_RESIDENCY',
  AdyenRemediationActionTypeUploadDifferentProofOfSignatory = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_SIGNATORY',
  AdyenRemediationActionTypeUploadDifferentRegistrationDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_REGISTRATION_DOCUMENT',
  AdyenRemediationActionTypeUploadIdDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_ID_DOCUMENT',
  AdyenRemediationActionTypeUploadMissingProofOfOwnership = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_MISSING_PROOF_OF_OWNERSHIP',
  AdyenRemediationActionTypeUploadOfficialBankStatement = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_OFFICIAL_BANK_STATEMENT',
  AdyenRemediationActionTypeUploadProofOfIndividualTaxId = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_INDIVIDUAL_TAX_ID',
  AdyenRemediationActionTypeUploadProofOfIndustry = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_INDUSTRY',
  AdyenRemediationActionTypeUploadProofOfNationalIdnumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_NATIONAL_IDNUMBER',
  AdyenRemediationActionTypeUploadProofOfOrganizationAddress = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_ORGANIZATION_ADDRESS',
  AdyenRemediationActionTypeUploadProofOfOrganizationTaxInfo = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_ORGANIZATION_TAX_INFO',
  AdyenRemediationActionTypeUploadProofOfOwnership = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_OWNERSHIP',
  AdyenRemediationActionTypeUploadProofOfResidency = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_RESIDENCY',
  AdyenRemediationActionTypeUploadProofOfSignatory = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_SIGNATORY',
  AdyenRemediationActionTypeUploadProofOfSigningRightsDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_SIGNING_RIGHTS_DOCUMENT',
  AdyenRemediationActionTypeUploadProofPayoutAffiliation = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_PAYOUT_AFFILIATION',
  AdyenRemediationActionTypeUploadRegistrationDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_REGISTRATION_DOCUMENT',
  AdyenRemediationActionTypeUseDifferentBankAccount = 'ADYEN_REMEDIATION_ACTION_TYPE_USE_DIFFERENT_BANK_ACCOUNT'
}

export type AdyenTermsOfServiceDocument = {
  __typename: 'AdyenTermsOfServiceDocument'
  document: Scalars['String']['output']
  tosID: Scalars['String']['output']
  tosType: Scalars['String']['output']
}

export enum AdyenUploadDocumentType {
  AdyenUploadDocumentTypeBankStatement = 'ADYEN_UPLOAD_DOCUMENT_TYPE_BANK_STATEMENT',
  AdyenUploadDocumentTypeDriversLicense = 'ADYEN_UPLOAD_DOCUMENT_TYPE_DRIVERS_LICENSE',
  AdyenUploadDocumentTypeIdentityCard = 'ADYEN_UPLOAD_DOCUMENT_TYPE_IDENTITY_CARD',
  AdyenUploadDocumentTypePassport = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PASSPORT',
  AdyenUploadDocumentTypeProofOfAddress = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_ADDRESS',
  AdyenUploadDocumentTypeProofOfFundingOrWealthSource = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_FUNDING_OR_WEALTH_SOURCE',
  AdyenUploadDocumentTypeProofOfIndividualTaxId = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_INDIVIDUAL_TAX_ID',
  AdyenUploadDocumentTypeProofOfIndustry = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_INDUSTRY',
  AdyenUploadDocumentTypeProofOfNationalIdNumber = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_NATIONAL_ID_NUMBER',
  AdyenUploadDocumentTypeProofOfOrganizationTaxInfo = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_ORGANIZATION_TAX_INFO',
  AdyenUploadDocumentTypeProofOfOwnership = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_OWNERSHIP',
  AdyenUploadDocumentTypeProofOfRelationship = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_RELATIONSHIP',
  AdyenUploadDocumentTypeProofOfResidency = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_RESIDENCY',
  AdyenUploadDocumentTypeProofOfSignatory = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_SIGNATORY',
  AdyenUploadDocumentTypeRegistrationDocument = 'ADYEN_UPLOAD_DOCUMENT_TYPE_REGISTRATION_DOCUMENT',
  AdyenUploadDocumentTypeVatDocument = 'ADYEN_UPLOAD_DOCUMENT_TYPE_VAT_DOCUMENT'
}

export type AgentHoursSummary = {
  __typename: 'AgentHoursSummary'
  agentId: Scalars['ID']['output']
  availableHours: Scalars['Float']['output']
  difference: Scalars['Float']['output']
  totalHours: Scalars['Float']['output']
}

export type AgentMonthlyHours = {
  __typename: 'AgentMonthlyHours'
  agentId: Scalars['ID']['output']
  month: Scalars['String']['output']
  totalHours: Scalars['Float']['output']
}

export type AgentTicketCountItem = {
  __typename: 'AgentTicketCountItem'
  agentId: Scalars['ID']['output']
  agentName: Scalars['String']['output']
  cost: Scalars['Float']['output']
  hoursWorked: Scalars['Float']['output']
  ticketCount: Scalars['Int']['output']
}

export type AgentTicketCountsInput = {
  clientId: Scalars['ID']['input']
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type AgentUtilizationResult = {
  __typename: 'AgentUtilizationResult'
  overloadedAgents: Array<AgentHoursSummary>
  underusedAgents: Array<AgentHoursSummary>
}

export type AgreementTypeConnection = {
  __typename: 'AgreementTypeConnection'
  edges?: Maybe<Array<Maybe<AgreementTypeEdge>>>
  pageInfo: PageInfo
}

export type AgreementTypeEdge = {
  __typename: 'AgreementTypeEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ConnectwiseAgreementType>
}

export type AgreementTypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type AgreementTypeInput = {
  autotaskIDs?: InputMaybe<Array<Scalars['String']['input']>>
  connectwiseIDs?: InputMaybe<Array<Scalars['String']['input']>>
  haloPSAIDs?: InputMaybe<Array<Scalars['String']['input']>>
  quickbooksIDs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AgreementTypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AgreementTypeOrderByField>
}

export enum AgreementTypeOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type AnalyticsClientInfo = {
  __typename: 'AnalyticsClientInfo'
  companyName: Scalars['String']['output']
  id: Scalars['ID']['output']
}

/**
 * Drives the partner-facing "Last sync from <source>" chip on Analytics
 * widgets (ANA-266). Returned alongside each metric's value so the chip
 * reflects the freshness of *that specific* number.
 */
export type AnalyticsLastSync = {
  __typename: 'AnalyticsLastSync'
  source: Scalars['String']['output']
  syncedAt?: Maybe<Scalars['Time']['output']>
}

/**
 * Per-metric metadata envelope (ANA-266). Future metadata fields are
 * added here so we don't proliferate top-level metric fields.
 */
export type AnalyticsMetricMetadata = {
  __typename: 'AnalyticsMetricMetadata'
  lastSync?: Maybe<AnalyticsLastSync>
}

/**
 * Per-source sync rollup backing the "Data sources" popover shown on every
 * Analytics page. `sources` is ordered freshest-first and is empty when the
 * partner has no sync state yet (frontend hides the button).
 */
export type AnalyticsSyncStateResponse = {
  __typename: 'AnalyticsSyncStateResponse'
  sources: Array<AnalyticsSyncStateSource>
}

/**
 * One integration source's last successful sync, for the data-sources
 * popover (ANA-266). `syncedAt` is null only in the impossible-in-practice
 * case of a row with no stamp; the frontend treats null as "unknown".
 */
export type AnalyticsSyncStateSource = {
  __typename: 'AnalyticsSyncStateSource'
  name: Scalars['String']['output']
  syncedAt?: Maybe<Scalars['Time']['output']>
}

export type ApiKey = {
  __typename: 'ApiKey'
  clientID: Scalars['ID']['output']
  createdAt: Scalars['String']['output']
  createdBy?: Maybe<PartnerUser>
  id: Scalars['ID']['output']
  keyName: Scalars['String']['output']
  lastDigits: Scalars['String']['output']
  revokedAt?: Maybe<Scalars['String']['output']>
  revokedBy?: Maybe<PartnerUser>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  status: ApiKeyStatus
}

export type ApiKeyConnection = {
  __typename: 'ApiKeyConnection'
  edges?: Maybe<Array<Maybe<ApiKeyEdge>>>
  pageInfo: PageInfo
}

export type ApiKeyEdge = {
  __typename: 'ApiKeyEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ApiKey>
}

export type ApiKeyFilter = {
  status?: InputMaybe<ApiKeyStatus>
}

export type ApiKeyOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ApiKeyOrderByField>
}

export enum ApiKeyOrderByField {
  CreatedAt = 'CREATED_AT'
}

export enum ApiKeyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ArInvoice = {
  __typename: 'ArInvoice'
  amount: Scalars['Float']['output']
  autopaidAt?: Maybe<Scalars['String']['output']>
  bnplID?: Maybe<Scalars['ID']['output']>
  bnplPartnerConfirmed?: Maybe<Scalars['Boolean']['output']>
  bnplStatus?: Maybe<BnplStatus>
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customerID: Scalars['ID']['output']
  customerName: Scalars['String']['output']
  dueDate?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceNumber: Scalars['String']['output']
  isExternal: Scalars['Boolean']['output']
  isRecurring: Scalars['Boolean']['output']
  lastRemindedAt?: Maybe<Scalars['String']['output']>
  nextRecurringDate?: Maybe<Scalars['String']['output']>
  outstandingAmount: Scalars['Float']['output']
  partnerID: Scalars['ID']['output']
  recurringFrequency?: Maybe<Frequency>
  status: InvoiceStatusEnum
}

export type ArInvoiceFilter = {
  amountMax?: InputMaybe<Scalars['Float']['input']>
  amountMin?: InputMaybe<Scalars['Float']['input']>
  createdDateEnd?: InputMaybe<Scalars['String']['input']>
  createdDateStart?: InputMaybe<Scalars['String']['input']>
  customerIDs?: InputMaybe<Array<Scalars['String']['input']>>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  lastNotificationEnd?: InputMaybe<Scalars['String']['input']>
  lastNotificationStart?: InputMaybe<Scalars['String']['input']>
  recurringFrequency?: InputMaybe<ArRecurringInvoiceFrequency>
  recurringPaymentID?: InputMaybe<Scalars['String']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<InvoiceStatusEnum>>
}

export type ArInvoiceOrder = {
  direction: ArOrderDirection
  field: ArInvoiceOrderField
}

export enum ArInvoiceOrderField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  CustomerName = 'CUSTOMER_NAME',
  DueDate = 'DUE_DATE',
  InvoiceNumber = 'INVOICE_NUMBER',
  LastStatus = 'LAST_STATUS',
  OutstandingAmount = 'OUTSTANDING_AMOUNT'
}

export type ArInvoiceSummary = {
  __typename: 'ArInvoiceSummary'
  totalAmount: Scalars['Float']['output']
  totalOutstandingAmount: Scalars['Float']['output']
}

export enum ArOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ArPagination = {
  __typename: 'ArPagination'
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export enum ArRecurringInvoiceFrequency {
  Annually = 'ANNUALLY',
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Weekly = 'WEEKLY'
}

/** AssistantConfirmationOutcomeEvent signals that a pending confirmation reached a terminal state. outcome is one of confirmed | denied | expired. */
export type AssistantConfirmationOutcomeEvent = {
  __typename: 'AssistantConfirmationOutcomeEvent'
  outcome: Scalars['String']['output']
  token: Scalars['String']['output']
  toolName: Scalars['String']['output']
}

export type AssistantConfirmationRequiredEvent = {
  __typename: 'AssistantConfirmationRequiredEvent'
  description: Scalars['String']['output']
  summary: Scalars['String']['output']
  token: Scalars['String']['output']
  toolInput: Scalars['String']['output']
  toolName: Scalars['String']['output']
}

export type AssistantConversation = {
  __typename: 'AssistantConversation'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
  userID: Scalars['ID']['output']
}

export type AssistantConversationDetail = {
  __typename: 'AssistantConversationDetail'
  conversation: AssistantConversation
  hasMoreMessages: Scalars['Boolean']['output']
  messages: Array<AssistantMessage>
}

export type AssistantConversationList = {
  __typename: 'AssistantConversationList'
  conversations: Array<AssistantConversation>
  page: Scalars['Int']['output']
  perPage: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type AssistantDoneEvent = {
  __typename: 'AssistantDoneEvent'
  messageID: Scalars['ID']['output']
}

/**
 * A typed pointer to a domain entity the user attached to this message (AR-7610).
 * `type` is a free string — validated against svc-accounts-receivable's allowlist;
 * the gateway is type-agnostic by design (ADR-017), so new entity types never
 * touch this schema.
 */
export type AssistantEntityReferenceInput = {
  id: Scalars['String']['input']
  label: Scalars['String']['input']
  source: AssistantEntityReferenceSource
  type: Scalars['String']['input']
}

/** How an Entity Reference got attached to the message: an explicit @-mention pick, or an accepted page-derived suggestion chip. Analytics-only — svc-accounts-receivable never renders it into the agent payload. */
export enum AssistantEntityReferenceSource {
  Mention = 'MENTION',
  PageSuggestion = 'PAGE_SUGGESTION'
}

export type AssistantMessage = {
  __typename: 'AssistantMessage'
  content: Scalars['String']['output']
  conversationID: Scalars['ID']['output']
  createdAt: Scalars['String']['output']
  /** Persisted tool-use / confirmation events for this message. Non-empty on assistant messages that ran the tool loop; null for user messages. Ordered by seq ascending. */
  events?: Maybe<Array<AssistantMessageEventRecord>>
  id: Scalars['ID']['output']
  isPartial: Scalars['Boolean']['output']
  role: Scalars['String']['output']
}

export type AssistantMessageEvent =
  | AssistantConfirmationOutcomeEvent
  | AssistantConfirmationRequiredEvent
  | AssistantDoneEvent
  | AssistantStatusEvent
  | AssistantTokenEvent
  | AssistantToolErrorEvent
  | AssistantToolResultEvent

/**
 * AssistantMessageEventRecord mirrors the shape of a persisted message_events row.
 * The payload is a JSON-encoded string whose schema depends on kind:
 *
 * - tool_use: {tool_use_id, tool_name, input}
 * - tool_result: {tool_name, status}  # raw result is redacted server-side
 * - tool_error: {tool_use_id, tool_name, message}
 * - confirmation_required: {token, tool_name, tool_input, summary, description}
 * - confirmation_outcome: {token, tool_name, outcome}
 */
export type AssistantMessageEventRecord = {
  __typename: 'AssistantMessageEventRecord'
  kind: Scalars['String']['output']
  payload: Scalars['String']['output']
  seq: Scalars['Int']['output']
}

export type AssistantStatusEvent = {
  __typename: 'AssistantStatusEvent'
  text: Scalars['String']['output']
}

export type AssistantTokenEvent = {
  __typename: 'AssistantTokenEvent'
  text: Scalars['String']['output']
}

/** AssistantToolErrorEvent reports that a tool invocation failed (query error, unknown tool, or access denied). The message is sanitized server-side. */
export type AssistantToolErrorEvent = {
  __typename: 'AssistantToolErrorEvent'
  message: Scalars['String']['output']
  toolName: Scalars['String']['output']
}

/** AssistantToolResultEvent reports that a tool invocation finished successfully. The full result payload is never sent over the wire — FE rehydrates chip state from this signal alone. */
export type AssistantToolResultEvent = {
  __typename: 'AssistantToolResultEvent'
  status: Scalars['String']['output']
  toolName: Scalars['String']['output']
}

/** AssistantV2Conversation mirrors the v2 conversation record. v2 conversations bind 1:1 to an Anthropic session; messages are not persisted in our DB (they live in the Anthropic event stream). */
export type AssistantV2Conversation = {
  __typename: 'AssistantV2Conversation'
  /** Anthropic session ID. Null for legacy v1 rows surfaced by the mixed list. */
  anthropicSessionID?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
  userID: Scalars['ID']['output']
  /** Either "v1" or "v2". The mixed list returns rows of both kinds tagged via this field. */
  version: Scalars['String']['output']
}

/**
 * AssistantV2ConversationHistory paginates the prior events of a v2 conversation
 * in chronological order. nextCursor is only set when hasMore is true; pass it back
 * as the after argument on the next call.
 */
export type AssistantV2ConversationHistory = {
  __typename: 'AssistantV2ConversationHistory'
  events: Array<AssistantV2HistoryEvent>
  hasMore: Scalars['Boolean']['output']
  nextCursor?: Maybe<Scalars['String']['output']>
}

export type AssistantV2ConversationList = {
  __typename: 'AssistantV2ConversationList'
  conversations: Array<AssistantV2Conversation>
  page: Scalars['Int']['output']
  perPage: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/** AssistantV2File describes a file mounted on a v2 session — either user-uploaded or written by the agent (the sandbox session container). */
export type AssistantV2File = {
  __typename: 'AssistantV2File'
  contentType: Scalars['String']['output']
  createdAt: Scalars['String']['output']
  /** Original filename for uploads; basename of the session path for agent-written files. */
  filename: Scalars['String']['output']
  /** Anthropic file ID. Stable handle used by PartnerAssistantV2FileDownloadURL. */
  id: Scalars['String']['output']
  /** Session path (e.g. /reports/q3.csv) for agent-written files. Null for user uploads. */
  path?: Maybe<Scalars['String']['output']>
  sizeBytes: Scalars['Int']['output']
}

/**
 * AssistantV2HistoryEvent is one row of the history backfill — an Anthropic session
 * event surfaced via JSON GET (not SSE). id is the Anthropic event ID exposed at the
 * envelope level so cursor pagination works without the FE parsing the data blob;
 * the same id is also embedded inside data, and the live SSE stream's per-event-ID
 * dedupe keys on it.
 *
 * eventType / data follow the same semantics as AssistantV2RawEvent (span.* events
 * are dropped by the host before this list is returned).
 *
 * processedAt is the event's server timestamp (RFC3339, nanos), surfaced at the
 * envelope level so the FE can use it as the re-attach / unread cursor: it is the
 * value passed back as PartnerReattachAssistantV2Message.since. The events API has
 * no event-id cursor (AR-7569); resuming "events after a point" is done by
 * processed_at, so the FE must persist this rather than the event id.
 */
export type AssistantV2HistoryEvent = {
  __typename: 'AssistantV2HistoryEvent'
  data: Scalars['String']['output']
  eventType: Scalars['String']['output']
  id: Scalars['ID']['output']
  processedAt: Scalars['String']['output']
}

/** AssistantV2MessageEvent reuses the v1 confirmation events (identical payload semantics) and wraps the rest of the Anthropic-shaped stream in AssistantV2RawEvent. */
export type AssistantV2MessageEvent =
  | AssistantConfirmationOutcomeEvent
  | AssistantConfirmationRequiredEvent
  | AssistantV2RawEvent

/**
 * AssistantV2RawEvent is a one-to-one passthrough of an Anthropic session event.
 * data is the raw event JSON exactly as Anthropic emitted it; the FE parses based on eventType.
 *
 * Common eventType values:
 * - session.status_running / session.status_idle — top-level session lifecycle. status_idle carries a stop_reason ({type: end_turn} or {type: requires_action, event_ids: [...]}).
 * - session.thread_status_running / session.thread_status_idle — per-thread lifecycle; carry agent_name and session_thread_id, and the same stop_reason shape as the session-level events.
 * - user.message — the user turn echoed back on the stream (content is an array of {type, text} blocks).
 * - user.custom_tool_result — result of a custom tool invocation; carries custom_tool_use_id, is_error, and content blocks (text payload is tool-specific JSON).
 * - agent.thinking — agent reasoning marker (no payload beyond id/type).
 * - agent.custom_tool_use — agent invoked a custom tool; carries name and input.
 * - agent.message — final assistant message for the turn (content is an array of {type, text} blocks; may embed <!--suggested_followups-->...<!--/suggested_followups--> markup).
 *
 * The host strips span.* events server-side.
 */
export type AssistantV2RawEvent = {
  __typename: 'AssistantV2RawEvent'
  data: Scalars['String']['output']
  eventType: Scalars['String']['output']
}

/**
 * AssistantV2TurnStatus reports whether a turn is currently running on a v2
 * conversation. It is backed by AR's heartbeat-stamped turn lock — NOT Anthropic's
 * GetSession.status, which reads idle even while a session is parked in
 * requires_action (AR-7569 / ADR-016). The frontend probes this once on cold load
 * to decide whether to open a read-only re-attach subscription.
 *
 * status is "running" iff a turn lock exists with a heartbeat inside the stale
 * grace window; a missing lock or a stale-heartbeat Orphaned Turn both read
 * "idle". acquiredAt / heartbeatAt are only set when running.
 */
export type AssistantV2TurnStatus = {
  __typename: 'AssistantV2TurnStatus'
  acquiredAt?: Maybe<Scalars['String']['output']>
  heartbeatAt?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
}

export type AutomatedPaymentVolumePercentByMonthResponse = {
  __typename: 'AutomatedPaymentVolumePercentByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<AutomatedPaymentVolumePercentMonth>
}

export type AutomatedPaymentVolumePercentMonth = {
  __typename: 'AutomatedPaymentVolumePercentMonth'
  month: Scalars['String']['output']
  percent: Scalars['Float']['output']
}

export type AutomatedPaymentVolumePercentageResponse = {
  __typename: 'AutomatedPaymentVolumePercentageResponse'
  value: Scalars['Float']['output']
}

export type AutomatedPaymentsByMonthResponse = {
  __typename: 'AutomatedPaymentsByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type AutomatedPaymentsResponse = {
  __typename: 'AutomatedPaymentsResponse'
  value: Scalars['Float']['output']
}

export type AutomatedTransactionCountResponse = {
  __typename: 'AutomatedTransactionCountResponse'
  count: Scalars['Int']['output']
}

export type AutopayCustomMethod = {
  __typename: 'AutopayCustomMethod'
  card?: Maybe<Card>
  customerID: Scalars['ID']['output']
  fallbackCharge?: Maybe<Scalars['Boolean']['output']>
  institution?: Maybe<Institution>
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['output']
}

export type AutopayCustomMethodInput = {
  customerID: Scalars['ID']['input']
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['input']
}

export type AutopayExcludedCustomer = {
  __typename: 'AutopayExcludedCustomer'
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customer: Customer
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
}

/** A connection to a list of items. */
export type AutopayExcludedCustomerConnection = {
  __typename: 'AutopayExcludedCustomerConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutopayExcludedCustomerEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AutopayExcludedCustomerEdge = {
  __typename: 'AutopayExcludedCustomerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AutopayExcludedCustomer>
}

export type AutopayExcludedCustomerFilter = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerName?: InputMaybe<Scalars['String']['input']>
}

export type AutopayExcludedCustomerOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutopayExcludedCustomerOrderByField>
}

export enum AutopayExcludedCustomerOrderByField {
  CreatedAt = 'CREATED_AT'
}

export type AutopayExcludedCustomerTotals = {
  __typename: 'AutopayExcludedCustomerTotals'
  count: Scalars['Int']['output']
}

export type AutopayExcludedInvoice = {
  __typename: 'AutopayExcludedInvoice'
  excludedBy: ExcludedFromAutopayBy
  invoiceID: Scalars['ID']['output']
}

export type AutopayExcludedInvoiceCreateInput = {
  customerID: Scalars['ID']['input']
  invoiceID: Scalars['ID']['input']
}

export type AutopayRule = {
  __typename: 'AutopayRule'
  amount?: Maybe<Scalars['Float']['output']>
  amountOperator?: Maybe<RuleOperator>
  autotaskContractNames?: Maybe<Array<Scalars['String']['output']>>
  autotaskContractTypes?: Maybe<Array<AutotaskContractType>>
  connectWiseContractNames?: Maybe<Array<Scalars['String']['output']>>
  connectwiseAgreementTypes?: Maybe<Array<ConnectwiseAgreementType>>
  connectwiseBillingTerms?: Maybe<Array<ConnectwiseBillingTerms>>
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customMethods?: Maybe<Array<Maybe<AutopayCustomMethod>>>
  customers?: Maybe<Array<Maybe<Customer>>>
  daysBeforeDue?: Maybe<Scalars['Int']['output']>
  daysPastCreation?: Maybe<Scalars['Int']['output']>
  daysPastDue?: Maybe<Scalars['Int']['output']>
  haloPSAContractNames?: Maybe<Array<Scalars['String']['output']>>
  haloPSAContractSubtypes?: Maybe<Array<HaloPsaContractSubtype>>
  halopsaRecurringInvoices?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  lastDayOfMonth?: Maybe<Scalars['Boolean']['output']>
  partnerID: Scalars['ID']['output']
  quickbooksRecurringTransactions?: Maybe<Array<QuickbooksRecurringTransaction>>
  rutterNetsuitePaymentTerms?: Maybe<Array<RutterPaymentTerms>>
  rutterQbdPaymentTerms?: Maybe<Array<RutterPaymentTerms>>
  specificDay?: Maybe<Scalars['Int']['output']>
  tagIDs?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  version: Scalars['Int']['output']
}

/** A connection to a list of items. */
export type AutopayRuleConnection = {
  __typename: 'AutopayRuleConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutopayRuleEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AutopayRuleEdge = {
  __typename: 'AutopayRuleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AutopayRule>
}

export type AutopayRuleFilter = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerName?: InputMaybe<Scalars['String']['input']>
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type AutopayRuleOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutopayRuleOrderByField>
}

export enum AutopayRuleOrderByField {
  DaysPastDue = 'DAYS_PAST_DUE'
}

export type AutopayRuleTotals = {
  __typename: 'AutopayRuleTotals'
  count: Scalars['Int']['output']
}

export type AutotaskConnection = {
  __typename: 'AutotaskConnection'
  filters: AutotaskConnectionFilters
}

export type AutotaskConnectionCompanyFilters = {
  __typename: 'AutotaskConnectionCompanyFilters'
  classifications?: Maybe<Array<Scalars['String']['output']>>
  territories?: Maybe<Array<Scalars['String']['output']>>
  types?: Maybe<Array<Scalars['String']['output']>>
  udf?: Maybe<AutotaskUserDefinedField>
}

export type AutotaskConnectionContactFilters = {
  __typename: 'AutotaskConnectionContactFilters'
  udf?: Maybe<AutotaskUserDefinedField>
}

export type AutotaskConnectionFilters = {
  __typename: 'AutotaskConnectionFilters'
  companyFilters: AutotaskConnectionCompanyFilters
  contactFilters: AutotaskConnectionContactFilters
  invoiceFilters: AutotaskConnectionInvoiceFilters
}

export type AutotaskConnectionInvoiceFilters = {
  __typename: 'AutotaskConnectionInvoiceFilters'
  invoiceCreatedSince?: Maybe<Scalars['String']['output']>
}

export type AutotaskContract = {
  __typename: 'AutotaskContract'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type AutotaskContractConnection = {
  __typename: 'AutotaskContractConnection'
  contracts?: Maybe<Array<Scalars['String']['output']>>
}

export type AutotaskContractEdge = {
  __typename: 'AutotaskContractEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<AutotaskContract>
}

export type AutotaskContractFilter = {
  customerNames?: InputMaybe<Array<Scalars['String']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
}

export type AutotaskContractOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutotaskContractOrderByField>
}

export enum AutotaskContractOrderByField {
  ContractName = 'CONTRACT_NAME'
}

export type AutotaskContractType = {
  __typename: 'AutotaskContractType'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type AutotaskField = {
  __typename: 'AutotaskField'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type AutotaskFieldInput = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type AutotaskFilter = {
  __typename: 'AutotaskFilter'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type AutotaskFilterInput = {
  id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type AutotaskIntegration = IntegrationInterface & {
  __typename: 'AutotaskIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export enum AutotaskInvoiceNumberField {
  AutotaskId = 'AutotaskID',
  InvoiceNumber = 'InvoiceNumber'
}

export type AutotaskQueryFilters = {
  __typename: 'AutotaskQueryFilters'
  companyClassifications: Array<AutotaskFilter>
  companyTerritoryIDs: Array<AutotaskFilter>
  companyTypes: Array<AutotaskFilter>
  companyUserDefinedFields: Array<Maybe<AutotaskUserDefinedField>>
  contactUserDefinedFields: Array<Maybe<AutotaskUserDefinedField>>
}

export type AutotaskUserDefinedField = {
  __typename: 'AutotaskUserDefinedField'
  inputs?: Maybe<Array<Scalars['String']['output']>>
  isPickList?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  picklistValues: Array<AutotaskField>
  type?: Maybe<Scalars['String']['output']>
}

export type AutotaskUserDefinedFieldInput = {
  dataType: Scalars['String']['input']
  inputs?: InputMaybe<Array<Scalars['String']['input']>>
  isPickList: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  picklistValues?: InputMaybe<Array<InputMaybe<AutotaskFieldInput>>>
}

export type AvailableIntegrationsReply = {
  __typename: 'AvailableIntegrationsReply'
  platforms?: Maybe<Array<PlatformName>>
}

export type AverageDaysOverdueResponse = {
  __typename: 'AverageDaysOverdueResponse'
  value: Scalars['Float']['output']
}

export type AverageInvoiceAmountResponse = {
  __typename: 'AverageInvoiceAmountResponse'
  value: Scalars['Float']['output']
}

export type AverageOverdueAmountResponse = {
  __typename: 'AverageOverdueAmountResponse'
  value: Scalars['Float']['output']
}

export type AveragePaymentSizeResponse = {
  __typename: 'AveragePaymentSizeResponse'
  value: Scalars['Float']['output']
}

export type AverageTimeToPayAutopayResponse = {
  __typename: 'AverageTimeToPayAutopayResponse'
  value: Scalars['Float']['output']
}

export type AverageTimeToPayByMonthResponse = {
  __typename: 'AverageTimeToPayByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type AverageTimeToPayExternalResponse = {
  __typename: 'AverageTimeToPayExternalResponse'
  value: Scalars['Float']['output']
}

export type AverageTimeToPayExternalVsInternalByMonthData = {
  __typename: 'AverageTimeToPayExternalVsInternalByMonthData'
  average: Scalars['Float']['output']
  isInternal: Scalars['Boolean']['output']
  month: Scalars['String']['output']
}

export type AverageTimeToPayExternalVsInternalByMonthResponse = {
  __typename: 'AverageTimeToPayExternalVsInternalByMonthResponse'
  data: Array<AverageTimeToPayExternalVsInternalByMonthData>
  externalAvg: Scalars['Float']['output']
  internalAvg: Scalars['Float']['output']
}

export type AverageTimeToPayResponse = {
  __typename: 'AverageTimeToPayResponse'
  value: Scalars['Float']['output']
}

export type BnplOffer = {
  __typename: 'BNPLOffer'
  amount: Scalars['Float']['output']
  approved: Scalars['Boolean']['output']
  approvedBy?: Maybe<SuperAdminUser>
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  fees: Scalars['Float']['output']
  id: Scalars['ID']['output']
  invoiceID: Scalars['ID']['output']
  lending?: Maybe<Lending>
  netAmount: Scalars['Float']['output']
  partner?: Maybe<Partner>
  partnerConfirmed: Scalars['Boolean']['output']
  rate: Scalars['Float']['output']
  remainingBalance: Scalars['Float']['output']
  status: BnplStatus
  terms: Scalars['Int']['output']
}

export enum BnplStatus {
  Creating = 'CREATING',
  Failed = 'FAILED',
  Inprocess = 'INPROCESS',
  Inreview = 'INREVIEW',
  Rejected = 'REJECTED'
}

export type BankAccount = {
  __typename: 'BankAccount'
  accountData?: Maybe<AccountData>
  accountNumber?: Maybe<Scalars['String']['output']>
  bankAccountVerification?: Maybe<Array<Maybe<BankAccountVerification>>>
  companyName?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<CountryCode>
  customName?: Maybe<Scalars['String']['output']>
  disconnectedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  institution?: Maybe<Institution>
  mask?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  receiverName?: Maybe<Scalars['String']['output']>
  routingNumber?: Maybe<Scalars['String']['output']>
  subtype?: Maybe<Scalars['String']['output']>
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type BankAccountCustomNameUpdateInput = {
  accountCustomName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export enum BankAccountDocumentType {
  BankStatement = 'BANK_STATEMENT'
}

export type BankAccountVerification = {
  __typename: 'BankAccountVerification'
  bankAccountId: Scalars['String']['output']
  id: Scalars['String']['output']
  remediationActions?: Maybe<Array<Maybe<RemediationAction>>>
  transactionNetwork: TransactionNetwork
  verificationStatus: BankAccountVerificationStatus
  verificationType: BankAccountVerificationType
  version: Scalars['Int']['output']
}

export enum BankAccountVerificationStatus {
  BavsFailed = 'BAVS_FAILED',
  BavsInReview = 'BAVS_IN_REVIEW',
  BavsOnHold = 'BAVS_ON_HOLD',
  BavsVerified = 'BAVS_VERIFIED',
  BavsWaitingDocuments = 'BAVS_WAITING_DOCUMENTS'
}

export enum BankAccountVerificationType {
  BavtPayment = 'BAVT_PAYMENT',
  BavtPayout = 'BAVT_PAYOUT'
}

/** Response for batch vendor activation/deactivation, with one result per vendor. */
export type BatchVendorActivationResponse = {
  __typename: 'BatchVendorActivationResponse'
  results: Array<BatchVendorResult>
}

export type BatchVendorResult = {
  __typename: 'BatchVendorResult'
  /** Number of bills affected by the activation status change for this vendor. */
  affectedBillCount: Scalars['Int']['output']
  errorReason?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  vendorId: Scalars['ID']['output']
}

export type Bill = {
  __typename: 'Bill'
  ID: Scalars['String']['output']
  amount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  dueDate: Scalars['String']['output']
  issueDate: Scalars['String']['output']
  /**
   * Reason the most recent funding attempt failed (e.g. "authorization expired: ...").
   * Null when the latest attempt did not fail. Surfaced so a bill that bounced
   * back to needs_approval after a funding failure can explain why on the row.
   */
  lastFundingFailureReason?: Maybe<Scalars['String']['output']>
  lastStatus?: Maybe<BillLastStatus>
  /** Line items for this bill */
  lineItems?: Maybe<Array<BillLineItem>>
  number: Scalars['String']['output']
  partnerID: Scalars['String']['output']
  payDate: Scalars['String']['output']
  /** QBO linking information for this bill. */
  qboLinking: QboLinking
  /** Source of the bill — how it entered the system. */
  source?: Maybe<BillSource>
  status?: Maybe<BillStatus>
  vendor?: Maybe<Vendor>
  vendorID: Scalars['String']['output']
  vendorPayment?: Maybe<Array<Maybe<VendorPayment>>>
  /** Virtual card issued for this bill, when the bill was paid via virtual card. */
  virtualCard?: Maybe<VirtualCardDetails>
}

export type BillAggregates = {
  __typename: 'BillAggregates'
  byAgingBucket: Array<BillAgingBucketAggregate>
  byStatus: Array<BillStatusAggregate>
  totalAmount: Scalars['String']['output']
  totalCount: Scalars['Int']['output']
}

export type BillAgingBucketAggregate = {
  __typename: 'BillAgingBucketAggregate'
  amount: Scalars['String']['output']
  /** One of: "0-30", "31-60", "61-90", "90+" (days past due). */
  bucket: Scalars['String']['output']
  count: Scalars['Int']['output']
}

/** A connection to a list of bills. */
export type BillConnection = {
  __typename: 'BillConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BillEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Bill document download information with presigned S3 URL. */
export type BillDocumentDownload = {
  __typename: 'BillDocumentDownload'
  downloadUrl: Scalars['String']['output']
  filename: Scalars['String']['output']
  mimeType: Scalars['String']['output']
}

/** An edge in a connection. */
export type BillEdge = {
  __typename: 'BillEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Bill>
}

export type BillFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  billNumber?: InputMaybe<Scalars['String']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
  issueDateEnd?: InputMaybe<Scalars['String']['input']>
  issueDateStart?: InputMaybe<Scalars['String']['input']>
  /**
   * Free-text search across bill number and vendor name (case-insensitive
   * substring, OR'd). Use this for the bills-list search input on the
   * partner portal — it surfaces matches regardless of which column the
   * user is typing against. Prefer `billNumber` for exact-field matches.
   */
  searchTerm?: InputMaybe<Scalars['String']['input']>
  /** Filter bills by source (how they entered the system). */
  sources?: InputMaybe<Array<BillSource>>
  status?: InputMaybe<Array<InputMaybe<BillStatus>>>
  vendorIDs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BillLastStatus = {
  __typename: 'BillLastStatus'
  ID: Scalars['String']['output']
  createdAt: Scalars['String']['output']
  executedBy?: Maybe<PartnerUser>
  reason?: Maybe<Scalars['String']['output']>
  status: BillStatus
  updatedAt?: Maybe<Scalars['String']['output']>
}

/**
 * Line item on a bill representing an individual charge.
 * Decimal values (quantity, unitPrice, total) are represented as strings
 * to preserve precision for financial calculations.
 */
export type BillLineItem = {
  __typename: 'BillLineItem'
  description?: Maybe<Scalars['String']['output']>
  expenseAccountId?: Maybe<Scalars['String']['output']>
  expenseCategoryLabel?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  quantity: Scalars['String']['output']
  sequence: Scalars['Int']['output']
  tax?: Maybe<Scalars['String']['output']>
  total: Scalars['String']['output']
  type: BillLineItemType
  unitPrice: Scalars['String']['output']
  unitType: Scalars['String']['output']
}

/**
 * Input for creating a line item on a bill.
 * Decimal values (quantity, unitPrice) must be valid decimal strings.
 */
export type BillLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>
  expenseAccountId?: InputMaybe<Scalars['String']['input']>
  expenseCategoryLabel?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  quantity: Scalars['String']['input']
  tax?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<BillLineItemType>
  unitPrice: Scalars['String']['input']
  unitType: Scalars['String']['input']
}

/**
 * Discriminates between product/service line items and account-based line items.
 * ACCOUNT is the default for new rows — 99% of partners use account-based lines.
 */
export enum BillLineItemType {
  Account = 'ACCOUNT',
  Item = 'ITEM'
}

/**
 * Input for updating line items on a bill.
 * When replace is true, existing line items are replaced with the provided items.
 * When replace is false or not provided, no changes are made to line items.
 */
export type BillLineItemsUpdateInput = {
  items: Array<BillLineItemInput>
  replace: Scalars['Boolean']['input']
}

export type BillListResponse = {
  __typename: 'BillListResponse'
  bills: Array<Bill>
  hasMore: Scalars['Boolean']['output']
  totalCount: Scalars['Int']['output']
}

export type BillOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<BillOrderByField>
}

export enum BillOrderByField {
  Amount = 'AMOUNT',
  CreatedDate = 'CREATED_DATE',
  DueDate = 'DUE_DATE',
  IssueDate = 'ISSUE_DATE',
  Number = 'NUMBER'
}

/** Source of a bill — how it entered the system. */
export enum BillSource {
  Manual = 'MANUAL',
  Ocr = 'OCR',
  Quickbooks = 'QUICKBOOKS'
}

export enum BillStatus {
  BillDeleted = 'BILL_DELETED',
  BillDraft = 'BILL_DRAFT',
  BillFailed = 'BILL_FAILED',
  BillNeedApproval = 'BILL_NEED_APPROVAL',
  BillPaid = 'BILL_PAID',
  BillPaidExternally = 'BILL_PAID_EXTERNALLY',
  BillProcessing = 'BILL_PROCESSING',
  BillScheduled = 'BILL_SCHEDULED'
}

export type BillStatusAggregate = {
  __typename: 'BillStatusAggregate'
  amount: Scalars['String']['output']
  count: Scalars['Int']['output']
  status: BillStatus
}

export type BillStatusCount = {
  __typename: 'BillStatusCount'
  count: Scalars['Int']['output']
  status: BillStatus
}

export enum BillingCycleUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Unspecified = 'UNSPECIFIED',
  Year = 'YEAR'
}

export type BillingTermsInput = {
  connectwiseIDs?: InputMaybe<Array<Scalars['String']['input']>>
  rutterNetsuiteIDs?: InputMaybe<Array<Scalars['String']['input']>>
  rutterQbdIDs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BnplFilter = {
  approved?: InputMaybe<Scalars['Boolean']['input']>
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  partnerID?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<Array<BnplStatus>>
}

export type BreakdownFilter = {
  CompanyID?: InputMaybe<Scalars['ID']['input']>
  CompanyType?: InputMaybe<CompanyType>
  ID?: InputMaybe<Scalars['ID']['input']>
  PaymentMethodID?: InputMaybe<Scalars['ID']['input']>
  PayoutID?: InputMaybe<Scalars['ID']['input']>
  ProductID?: InputMaybe<Scalars['ID']['input']>
  ProductType?: InputMaybe<BreakdownProductType>
  TransactionDateFrom?: InputMaybe<Scalars['Time']['input']>
  TransactionDateTo?: InputMaybe<Scalars['Time']['input']>
  TransactionID?: InputMaybe<Scalars['ID']['input']>
}

export type BreakdownListItem = {
  __typename: 'BreakdownListItem'
  companyType: CompanyType
  createdAt: Scalars['Time']['output']
  customer?: Maybe<Customer>
  fee: Scalars['Float']['output']
  grossAmount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  partner?: Maybe<Partner>
  paymentMethod?: Maybe<PaymentMethodEntity>
  payout: Payout
  product?: Maybe<Product>
  transaction?: Maybe<Transaction>
  transactionDate?: Maybe<Scalars['Time']['output']>
  transactionType: BreakdownProductType
}

export type BreakdownListItemConnection = {
  __typename: 'BreakdownListItemConnection'
  edges?: Maybe<Array<Maybe<BreakdownListItemEdge>>>
  pageInfo: PageInfo
}

export type BreakdownListItemEdge = {
  __typename: 'BreakdownListItemEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<BreakdownListItem>
}

export enum BreakdownProductType {
  Chargeback = 'CHARGEBACK',
  OneTimePayment = 'ONE_TIME_PAYMENT',
  Payment = 'PAYMENT',
  Referral = 'REFERRAL',
  ReferralBonus = 'REFERRAL_BONUS',
  Refund = 'REFUND'
}

export type BucketAmountData = {
  __typename: 'BucketAmountData'
  bucket: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type BucketCountData = {
  __typename: 'BucketCountData'
  bucket: Scalars['String']['output']
  value: Scalars['Int']['output']
}

export type BulkCancelBillScheduleInput = {
  billIds: Array<Scalars['ID']['input']>
}

export type BulkCancelBillScheduleResponse = {
  __typename: 'BulkCancelBillScheduleResponse'
  results: Array<BulkCancelBillScheduleResult>
}

export type BulkCancelBillScheduleResult = {
  __typename: 'BulkCancelBillScheduleResult'
  billId: Scalars['ID']['output']
  errorReason?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type BulkCancelVendorPaymentItem = {
  billId: Scalars['ID']['input']
  paymentId: Scalars['ID']['input']
}

export type BulkCancelVendorPaymentResult = {
  __typename: 'BulkCancelVendorPaymentResult'
  billId: Scalars['ID']['output']
  errorReason?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type BulkCancelVendorPaymentsInput = {
  items: Array<BulkCancelVendorPaymentItem>
}

export type BulkCancelVendorPaymentsResponse = {
  __typename: 'BulkCancelVendorPaymentsResponse'
  results: Array<BulkCancelVendorPaymentResult>
}

export enum BulkChargeRequestStatusEnum {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type BulkSubmitBillResult = {
  __typename: 'BulkSubmitBillResult'
  billId: Scalars['ID']['output']
  errorReason?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type BulkSubmitBillsForApprovalResponse = {
  __typename: 'BulkSubmitBillsForApprovalResponse'
  results: Array<BulkSubmitBillResult>
}

export type BulkToggleArchiveCustomersInput = {
  archive: Scalars['Boolean']['input']
  filters: CustomerFilter
}

export type CaAccountData = {
  __typename: 'CAAccountData'
  accountNumber: Scalars['String']['output']
  institutionCode: Scalars['String']['output']
  institutionName: Scalars['String']['output']
  receiverName: Scalars['String']['output']
  subtype: Scalars['String']['output']
  transitNumber: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type CaAccountDataInput = {
  accountNumber: Scalars['String']['input']
  institutionCode: Scalars['String']['input']
  institutionName: Scalars['String']['input']
  receiverName: Scalars['String']['input']
  subtype: ManualAccountSubtypes
  transitNumber: Scalars['String']['input']
  type: ManualAccountTypes
}

export type CaAccountUpdateInput = {
  accountNumber: Scalars['String']['input']
  institutionCode: Scalars['String']['input']
  transitNumber: Scalars['String']['input']
}

export type CwBillingTermsFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type CwBillingTermsOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CwBillingTermsOrderByField>
}

export enum CwBillingTermsOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type CalculatePaymentFeeInput = {
  amount: Scalars['Float']['input']
  currency: Currency
  customerID: Scalars['String']['input']
  paymentMethodID: Scalars['String']['input']
  paymentMethodType: MethodEnum
}

export type CancelBillScheduleResponse = {
  __typename: 'CancelBillScheduleResponse'
  billId: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['ID']['input']
}

export type CancelVendorPaymentInput = {
  billId: Scalars['ID']['input']
  paymentId: Scalars['ID']['input']
}

export type CancelVendorPaymentResponse = {
  __typename: 'CancelVendorPaymentResponse'
  paymentId: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type Card = {
  __typename: 'Card'
  billingAddress?: Maybe<Address>
  cardNetWork: CardNetwork
  customName?: Maybe<Scalars['String']['output']>
  expirationDate: Scalars['String']['output']
  fundingSource: FundingSource
  hasPostalCode: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isExpired: Scalars['Boolean']['output']
  last4: Scalars['String']['output']
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
}

export type CardCreationInput = {
  billingAddress?: InputMaybe<AddressInput>
  cardProviderToken: Scalars['String']['input']
  customName?: InputMaybe<Scalars['String']['input']>
  provider: CardProvider
}

export type CardCustomNameUpdateInput = {
  cardCustomName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type CardDeletionInput = {
  id: Scalars['ID']['input']
}

export type CardFeeAmount = {
  __typename: 'CardFeeAmount'
  feeAmount: Scalars['Float']['output']
  fundingSource?: Maybe<FundingSource>
  percentage: Scalars['Float']['output']
}

export enum CardNetwork {
  AmericanExpress = 'AMERICAN_EXPRESS',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Other = 'OTHER',
  Visa = 'VISA'
}

export enum CardProvider {
  Checkout = 'CHECKOUT',
  Evervault = 'EVERVAULT',
  Modernbanc = 'MODERNBANC'
}

/**
 * Single-use token returned by PartnerCreateCardRevealToken. Short-lived
 * (60s TTL) and consumed by the Evervault Relay via the gateway HTTP
 * origin at GET /v1/virtual-card/reveal/{token} — intentionally not
 * exposed as a GraphQL mutation, to keep the one-and-only reveal path
 * gated by the Relay's shared-secret header.
 */
export type CardRevealToken = {
  __typename: 'CardRevealToken'
  token: Scalars['String']['output']
}

export type CardSerializationInput = {
  cardHolderNameSecretID: Scalars['String']['input']
  expirationDateSecretID: Scalars['String']['input']
  panSecretID: Scalars['String']['input']
}

export type CardUpdateInput = {
  billingAddress?: InputMaybe<AddressInput>
  cardCustomName?: InputMaybe<Scalars['String']['input']>
  expirationDate?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type CashFlowDistributionData = {
  __typename: 'CashFlowDistributionData'
  date: Scalars['String']['output']
  isInternal: Scalars['Boolean']['output']
  value: Scalars['Float']['output']
}

export type CashFlowDistributionLastThirtyDaysReponse = {
  __typename: 'CashFlowDistributionLastThirtyDaysReponse'
  data: Array<CashFlowDistributionData>
}

export type CashFlowDistributionResponse = {
  __typename: 'CashFlowDistributionResponse'
  data: Array<CashFlowDistributionData>
}

export type CategorySpend = {
  __typename: 'CategorySpend'
  amount: Scalars['String']['output']
  category: Scalars['String']['output']
  /** Fraction of total spend (0..1) for this category. */
  pct: Scalars['Float']['output']
}

/**
 * Re-points a funded, not-yet-disbursed bill's vendor receiving method
 * ("change receiving method"). The partner is never re-charged: the captured
 * funding is reused and only the vendor-facing rail (ACH ↔ virtual card)
 * changes. Eligible only while the bill is BILL_PROCESSING and the payout has
 * not yet been submitted.
 */
export type ChangeBillReceivingMethodInput = {
  billId: Scalars['ID']['input']
  /** The receiving method the vendor payout should switch TO. */
  targetMethod: VendorPaymentMethod
}

/**
 * Result of a change-receiving-method attempt. Mirrors CreateFundingAttemptResult:
 * eligibility/precondition failures are reported in-band (success=false plus
 * errorCode/errorMessage) rather than as GraphQL errors, so the partner UI can
 * render an "ineligible/locked" state.
 */
export type ChangeBillReceivingMethodResult = {
  __typename: 'ChangeBillReceivingMethodResult'
  billId: Scalars['ID']['output']
  /** Bill status after the switch. A successful switch leaves the bill BILL_PROCESSING. Absent on failure. */
  billStatus?: Maybe<BillStatus>
  /** gRPC status code when success=false (e.g. "FailedPrecondition"). Absent on success. */
  errorCode?: Maybe<Scalars['String']['output']>
  /** Human-readable failure message when success=false. Absent on success. */
  errorMessage?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ClientRanking = {
  __typename: 'ClientRanking'
  clientId: Scalars['ID']['output']
  clientName: Scalars['String']['output']
  margin: Scalars['Float']['output']
}

export type ClientTicketCountItem = {
  __typename: 'ClientTicketCountItem'
  clientId: Scalars['ID']['output']
  clientName: Scalars['String']['output']
  cost: Scalars['Float']['output']
  hoursWorked: Scalars['Float']['output']
  ticketCount: Scalars['Int']['output']
}

export type ClientTicketCountsInput = {
  agentId: Scalars['ID']['input']
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type ClientTrendBaseInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>
  endDate: Scalars['String']['input']
  filters?: InputMaybe<ClientTrendsFiltersInput>
  startDate: Scalars['String']['input']
}

export type ClientTrendLine = {
  __typename: 'ClientTrendLine'
  labels: Array<Scalars['String']['output']>
  laborCog: Array<Scalars['Float']['output']>
  margin: Array<Scalars['Float']['output']>
  mrr: Array<Scalars['Float']['output']>
  profit: Array<Scalars['Float']['output']>
  serviceCog: Array<Scalars['Float']['output']>
}

/**
 * ClientTrendsAggregationMode tells the UI which aggregation the response represents
 * so labels ("Avg MRR" vs "MRR") can adapt deterministically.
 */
export enum ClientTrendsAggregationMode {
  Month = 'MONTH',
  Range = 'RANGE'
}

export type ClientTrendsBreakdownItem = {
  __typename: 'ClientTrendsBreakdownItem'
  laborCogs: Scalars['Float']['output']
  margin: Scalars['Float']['output']
  month: Scalars['String']['output']
  mrr: Scalars['Float']['output']
  percentOfTotalMrr: Scalars['Float']['output']
  profit: Scalars['Float']['output']
  serviceCogs: Scalars['Float']['output']
}

export type ClientTrendsBreakdownResult = {
  __typename: 'ClientTrendsBreakdownResult'
  breakdown: Array<ClientTrendsBreakdownItem>
}

export type ClientTrendsClientItem = {
  __typename: 'ClientTrendsClientItem'
  /**
   * Average monthly MRR across the selected range.
   * Equals `mrr` in single-month mode.
   */
  avgMrr: Scalars['Float']['output']
  /**
   * Average monthly profit across the selected range.
   * Equals `profit` in single-month mode.
   */
  avgProfit: Scalars['Float']['output']
  clientId: Scalars['ID']['output']
  clientName: Scalars['String']['output']
  laborCogs: Scalars['Float']['output']
  laborCostImpact: LaborCostImpact
  margin: Scalars['Float']['output']
  mrr: Scalars['Float']['output']
  mrrChange: Scalars['Float']['output']
  /**
   * MRR delta between the last and first month *within* the selected range.
   * Equals 0 in single-month mode (no spread to compare).
   */
  mrrChangeFirstToLast: Scalars['Float']['output']
  /**
   * Percent companion of `mrrChangeFirstToLast` — `(lastMrr - firstMrr) / firstMrr * 100`.
   * Pair this with `mrrChangeFirstToLast` so the UI's value + percent badge come from
   * the same calculation in range mode (the MoM pair `mrrChange` / `mrrChangePercent`
   * stays available for callers that want the recent-momentum view alongside).
   * Returns 0 when `firstMrr` is 0 (the percent is mathematically undefined — gate on
   * `mrrChangeFirstToLast` before rendering the badge for new-client situations).
   * Equals 0 in single-month mode (mirrors `mrrChangeFirstToLast`).
   */
  mrrChangeFirstToLastPercent: Scalars['Float']['output']
  mrrChangePercent: Scalars['Float']['output']
  mrrChangeType: MrrChangeType
  percentOfTotalMrr: Scalars['Float']['output']
  profit: Scalars['Float']['output']
  serviceCogs: Scalars['Float']['output']
  /**
   * Sum of monthly MRR across the selected range.
   * Equals `mrr` in single-month mode.
   */
  totalMrr: Scalars['Float']['output']
  /**
   * Sum of monthly profit across the selected range.
   * Equals `profit` in single-month mode.
   */
  totalProfit: Scalars['Float']['output']
}

export type ClientTrendsClients = {
  __typename: 'ClientTrendsClients'
  aggregationMode: ClientTrendsAggregationMode
  items: Array<ClientTrendsClientItem>
  monthCount: Scalars['Int']['output']
  selectedMonth: Scalars['String']['output']
  total: Scalars['Int']['output']
}

export enum ClientTrendsFilterType {
  AgreementType = 'AGREEMENT_TYPE',
  ClientName = 'CLIENT_NAME'
}

export type ClientTrendsFilterValues = {
  __typename: 'ClientTrendsFilterValues'
  exclude: Array<Scalars['String']['output']>
  include: Array<Scalars['String']['output']>
}

export type ClientTrendsFilterValuesInput = {
  exclude?: InputMaybe<Array<Scalars['String']['input']>>
  include?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ClientTrendsFilterValuesResult = {
  __typename: 'ClientTrendsFilterValuesResult'
  total: Scalars['Int']['output']
  values: Array<Scalars['String']['output']>
}

export type ClientTrendsFilters = {
  __typename: 'ClientTrendsFilters'
  agreementType?: Maybe<ClientTrendsFilterValues>
  clientName?: Maybe<ClientTrendsFilterValues>
  laborCostImpact?: Maybe<Array<LaborCostImpact>>
  marginRange?: Maybe<ClientTrendsRange>
  mrrChangeRange?: Maybe<ClientTrendsRange>
  mrrChangeType?: Maybe<Array<MrrChangeType>>
  mrrRange?: Maybe<ClientTrendsRange>
}

export type ClientTrendsFiltersInput = {
  agreementType?: InputMaybe<ClientTrendsFilterValuesInput>
  clientName?: InputMaybe<ClientTrendsFilterValuesInput>
  /**
   * Post-aggregation filters on the client list. Empty / null = not applied.
   * Each range is compared against the SQL CTE column that matches the
   * metric actually shown in the UI:
   *   • mrr: avg monthly MRR (cur_mrr / monthCount) — scaled on the backend
   *   • margin: profit margin in % (already a percentage column)
   *   • mrrChange: Month mode → cur - prev; Range mode → last - first
   */
  laborCostImpact?: InputMaybe<Array<LaborCostImpact>>
  marginMax?: InputMaybe<Scalars['Float']['input']>
  marginMin?: InputMaybe<Scalars['Float']['input']>
  mrrChangeMax?: InputMaybe<Scalars['Float']['input']>
  mrrChangeMin?: InputMaybe<Scalars['Float']['input']>
  mrrChangeType?: InputMaybe<Array<MrrChangeType>>
  mrrMax?: InputMaybe<Scalars['Float']['input']>
  mrrMin?: InputMaybe<Scalars['Float']['input']>
}

export type ClientTrendsPreset = {
  __typename: 'ClientTrendsPreset'
  createdAt: Scalars['String']['output']
  filters: ClientTrendsFilters
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partnerId: Scalars['ID']['output']
  updatedAt: Scalars['String']['output']
  userId?: Maybe<Scalars['ID']['output']>
}

export type ClientTrendsRange = {
  __typename: 'ClientTrendsRange'
  max?: Maybe<Scalars['Float']['output']>
  min?: Maybe<Scalars['Float']['output']>
}

export type ClientTrendsRankings = {
  __typename: 'ClientTrendsRankings'
  leastProfitable: Array<ClientRanking>
  mostProfitable: Array<ClientRanking>
}

export enum ClientTrendsSortBy {
  CurrentMrr = 'CURRENT_MRR',
  LaborCostImpact = 'LABOR_COST_IMPACT',
  MrrChange = 'MRR_CHANGE',
  ProfitMargin = 'PROFIT_MARGIN'
}

export type ClientTrendsSummary = {
  __typename: 'ClientTrendsSummary'
  rollingMrrChange: RollingMrrChange
}

export type CollectMandateConsentInput = {
  bankAccountID: Scalars['ID']['input']
  mandateConsent: MandateConsentInput
}

export type Collection = {
  __typename: 'Collection'
  collectionFeePaymentAmount: Scalars['Float']['output']
  collectionInstruction: Scalars['String']['output']
  collectionOutstandingAmount: Scalars['Float']['output']
  collectionPayment?: Maybe<Payment>
  createdAt: Scalars['String']['output']
  customerInfo: CollectionCustomerInfo
  customerType: CollectionCustomerType
  id: Scalars['ID']['output']
  interest: Scalars['Float']['output']
  invoice: Invoice
  lastContactDate: Scalars['String']['output']
  notes: Array<CollectionNote>
  partner: Partner
  status: Array<CollectionStatus>
  updatedAt: Scalars['String']['output']
  upfrontFeePayment?: Maybe<Payment>
}

export type CollectionConnection = {
  __typename: 'CollectionConnection'
  edges?: Maybe<Array<Maybe<CollectionEdge>>>
  pageInfo: PageInfo
}

export type CollectionCreateInput = {
  collectionInstruction: Scalars['String']['input']
  customerInfo: CollectionCreationCustomerInfoInput
  customerType?: InputMaybe<CollectionCustomerType>
  interest?: InputMaybe<Scalars['Float']['input']>
  invoiceID: Scalars['ID']['input']
  lastContactDate: Scalars['String']['input']
}

export type CollectionCreationCustomerInfoInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  state: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type CollectionCustomerInfo = AddressInterface & {
  __typename: 'CollectionCustomerInfo'
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  customer: Customer
  email: Scalars['String']['output']
  name: Scalars['String']['output']
  phone: Scalars['String']['output']
  postalCode: Scalars['String']['output']
  state: Scalars['String']['output']
  streetAddress: Scalars['String']['output']
  subPremise?: Maybe<Scalars['String']['output']>
}

export enum CollectionCustomerType {
  B2B = 'B2B',
  B2C = 'B2C',
  B2G = 'B2G',
  NotInformed = 'NOT_INFORMED'
}

export type CollectionEdge = {
  __typename: 'CollectionEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Collection>
}

export type CollectionFeeRates = {
  __typename: 'CollectionFeeRates'
  collectionFeeAmount: Scalars['Float']['output']
  upfrontFeeAmount: Scalars['Float']['output']
}

export type CollectionFilter = {
  creationDateEnd?: InputMaybe<Scalars['String']['input']>
  creationDateStart?: InputMaybe<Scalars['String']['input']>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  status?: InputMaybe<Array<InputMaybe<CollectionStatusEnum>>>
}

export type CollectionNote = {
  __typename: 'CollectionNote'
  createdAt: Scalars['String']['output']
  note: Scalars['String']['output']
}

export type CollectionOrder = {
  direction?: OrderDirection
  field?: CollectionOrderField
}

export enum CollectionOrderField {
  CreatedAt = 'CREATED_AT',
  CustomerName = 'CUSTOMER_NAME',
  InvoiceAmount = 'INVOICE_AMOUNT',
  InvoiceDueDate = 'INVOICE_DUE_DATE'
}

export type CollectionStatus = {
  __typename: 'CollectionStatus'
  createdAt: Scalars['String']['output']
  status: CollectionStatusEnum
}

export enum CollectionStatusEnum {
  Canceled = 'CANCELED',
  Collected = 'COLLECTED',
  InProgress = 'IN_PROGRESS',
  Requesting = 'REQUESTING',
  Uncollectable = 'UNCOLLECTABLE',
  WaitingUpfrontFee = 'WAITING_UPFRONT_FEE'
}

export enum CollectionStatusInputEnum {
  Canceled = 'CANCELED',
  Collected = 'COLLECTED',
  InProgress = 'IN_PROGRESS',
  Uncollectable = 'UNCOLLECTABLE'
}

export type CollectionTotals = {
  __typename: 'CollectionTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  netAmount: Scalars['Float']['output']
}

export type CompactedPaymentPreference = {
  __typename: 'CompactedPaymentPreference'
  ID: Scalars['String']['output']
  accountMask: Scalars['String']['output']
  institutionName: Scalars['String']['output']
  vendorID: Scalars['String']['output']
}

export type Company = {
  __typename: 'Company'
  id: Scalars['ID']['output']
}

export type CompanyDocument = {
  __typename: 'CompanyDocument'
  createdAt: Scalars['String']['output']
  filename?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  individualID?: Maybe<Scalars['ID']['output']>
  partnerID: Scalars['ID']['output']
  type: PartnerDocumentType
  url: Scalars['String']['output']
}

export type CompanyIndividual = {
  __typename: 'CompanyIndividual'
  city: Scalars['String']['output']
  controllingPerson: Scalars['Boolean']['output']
  country: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  dateOfBirth: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  hasSSN: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  individualDocuments?: Maybe<Array<Maybe<CompanyDocument>>>
  jobTitle: Scalars['String']['output']
  lastName: Scalars['String']['output']
  owner: Scalars['Boolean']['output']
  partnerID: Scalars['ID']['output']
  phone: Scalars['String']['output']
  postalCode: Scalars['String']['output']
  signatory: Scalars['Boolean']['output']
  state: Scalars['String']['output']
  stateCode: Scalars['String']['output']
  streetAddress: Scalars['String']['output']
  subPremise: Scalars['String']['output']
}

export type CompanyIndividualUploadLinkResponse = {
  __typename: 'CompanyIndividualUploadLinkResponse'
  expirationDate: Scalars['String']['output']
  id: Scalars['String']['output']
  individualID: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type CompanyPayoutTimingConfigs = {
  __typename: 'CompanyPayoutTimingConfigs'
  activeConfig?: Maybe<PayoutTimingCompanyConfig>
  upcomingConfig?: Maybe<PayoutTimingCompanyConfig>
}

export type CompanySpecificationInput = {
  companyID: Scalars['UUID']['input']
  partnerID: Scalars['UUID']['input']
}

export enum CompanyType {
  Alternative = 'ALTERNATIVE',
  Customer = 'CUSTOMER',
  Partner = 'PARTNER'
}

export type CompanyUnion = Customer | Partner

export type ConnectWiseAgreementConnection = {
  __typename: 'ConnectWiseAgreementConnection'
  agreements?: Maybe<Array<Scalars['String']['output']>>
}

export type ConnectWiseAgreementEdge = {
  __typename: 'ConnectWiseAgreementEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ConnectwiseAgreement>
}

export type ConnectWiseAgreementFilter = {
  customerExternalIds?: InputMaybe<Array<Scalars['String']['input']>>
  customerNames?: InputMaybe<Array<Scalars['String']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ConnectWiseAgreementOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ConnectWiseAgreementOrderByField>
}

export enum ConnectWiseAgreementOrderByField {
  AgreementName = 'AGREEMENT_NAME'
}

export type ConnectWiseBillingTermsConnection = {
  __typename: 'ConnectWiseBillingTermsConnection'
  edges?: Maybe<Array<Maybe<ConnectWiseBillingTermsEdge>>>
  pageInfo: PageInfo
}

export type ConnectWiseBillingTermsEdge = {
  __typename: 'ConnectWiseBillingTermsEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ConnectwiseBillingTerms>
}

export type ConnectWiseConnection = {
  __typename: 'ConnectWiseConnection'
  partnerID: Scalars['String']['output']
  queryFilters: ConnectWiseQueryFilters
}

export type ConnectWiseFilterValue = {
  __typename: 'ConnectWiseFilterValue'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type ConnectWiseFilterValueInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type ConnectWiseFilters = {
  __typename: 'ConnectWiseFilters'
  createdSince?: Maybe<Scalars['String']['output']>
  locations?: Maybe<Array<ConnectWiseFilterValue>>
  status?: Maybe<Array<ConnectWiseFilterValue>>
  territories?: Maybe<Array<ConnectWiseFilterValue>>
  types?: Maybe<Array<ConnectWiseFilterValue>>
}

export type ConnectWiseFiltersInput = {
  createdSince?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<Array<ConnectWiseFilterValueInput>>
  status?: InputMaybe<Array<ConnectWiseFilterValueInput>>
  territories?: InputMaybe<Array<ConnectWiseFilterValueInput>>
  types?: InputMaybe<Array<ConnectWiseFilterValueInput>>
}

export type ConnectWiseGlSegment = {
  __typename: 'ConnectWiseGlSegment'
  label: Scalars['String']['output']
  position: Scalars['Int']['output']
}

export type ConnectWiseQueryFilters = {
  __typename: 'ConnectWiseQueryFilters'
  customerFilters: ConnectWiseFilters
  invoiceFilters: ConnectWiseFilters
}

export type ConnectWiseQueryFiltersInput = {
  customerFilters?: InputMaybe<ConnectWiseFiltersInput>
  invoiceFilters?: InputMaybe<ConnectWiseFiltersInput>
}

export type ConnectWiseTaxCode = {
  __typename: 'ConnectWiseTaxCode'
  default: Scalars['Boolean']['output']
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  identifier: Scalars['String']['output']
}

export type ConnectionCreateInput = {
  currency: Currency
  integrationType: IntegrationType
  publicToken: Scalars['String']['input']
}

export enum ConnectionStatus {
  AwaitingSetup = 'AWAITING_SETUP',
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ConnectionUpdateInput = {
  integrationType: IntegrationType
  platform: RutterPlatform
}

export type ConnectwiseAgreement = {
  __typename: 'ConnectwiseAgreement'
  externalID?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type ConnectwiseAgreementType = {
  __typename: 'ConnectwiseAgreementType'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type ConnectwiseBillingTerms = {
  __typename: 'ConnectwiseBillingTerms'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type ConnectwiseIntegration = IntegrationInterface & {
  __typename: 'ConnectwiseIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type ContractNamesInput = {
  autotaskNames?: InputMaybe<Array<Scalars['String']['input']>>
  connectwiseNames?: InputMaybe<Array<Scalars['String']['input']>>
  halopsaNames?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ContractSubtypeConnection = {
  __typename: 'ContractSubtypeConnection'
  edges?: Maybe<Array<Maybe<ContractSubtypeEdge>>>
  pageInfo: PageInfo
}

export type ContractSubtypeEdge = {
  __typename: 'ContractSubtypeEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<HaloPsaContractSubtype>
}

export type ContractSubtypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ContractSubtypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ContractSubtypeOrderByField>
}

export enum ContractSubtypeOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type ContractTypeConnection = {
  __typename: 'ContractTypeConnection'
  edges?: Maybe<Array<Maybe<ContractTypeEdge>>>
  pageInfo: PageInfo
}

export type ContractTypeEdge = {
  __typename: 'ContractTypeEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<AutotaskContractType>
}

export type ContractTypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ContractTypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ContractTypeOrderByField>
}

export enum ContractTypeOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type CountBillsInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
  statusIn?: InputMaybe<Array<InputMaybe<BillStatus>>>
  vendorID?: InputMaybe<Scalars['String']['input']>
}

export enum CountryCode {
  CcCa = 'CC_CA',
  CcUnspecified = 'CC_UNSPECIFIED',
  CcUs = 'CC_US'
}

export type CoverFeeConfig = {
  __typename: 'CoverFeeConfig'
  coverACHMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverCardMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverOtherMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverWireMethodFee?: Maybe<Scalars['Boolean']['output']>
}

export type CreateApiKeyInput = {
  keyName: Scalars['String']['input']
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateApiKeyResponse = {
  __typename: 'CreateApiKeyResponse'
  key: Scalars['String']['output']
}

export type CreateBill = {
  amount: Scalars['Float']['input']
  description?: InputMaybe<Scalars['String']['input']>
  /**
   * S3 path of an OCR-extracted document returned by PartnerExtractBillData.
   * When set, the bill is created as an OCR bill and the original document
   * can be downloaded from the bill detail page. The upload-then-confirm
   * flow uses this to avoid creating bill rows on upload.
   */
  documentPath?: InputMaybe<Scalars['String']['input']>
  dueDate: Scalars['String']['input']
  issueDate: Scalars['String']['input']
  /** Optional line items for this bill */
  lineItems?: InputMaybe<Array<BillLineItemInput>>
  number?: InputMaybe<Scalars['String']['input']>
  vendorID: Scalars['String']['input']
}

export type CreateClientTrendsPresetInput = {
  filters: ClientTrendsFiltersInput
  name: Scalars['String']['input']
}

export type CreateCompanyIndividualInput = {
  city: Scalars['String']['input']
  controllingPerson: Scalars['Boolean']['input']
  country: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  dateOfBirth: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
  lastName: Scalars['String']['input']
  owner: Scalars['Boolean']['input']
  partnerID: Scalars['ID']['input']
  phone: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  signatory: Scalars['Boolean']['input']
  ssn?: InputMaybe<Scalars['String']['input']>
  state: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise: Scalars['String']['input']
}

export type CreateEmailTemplateInput = {
  name: Scalars['String']['input']
  section1?: InputMaybe<Scalars['String']['input']>
  section2?: InputMaybe<Scalars['String']['input']>
  section3?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
  type: TemplateType
}

export type CreateFundingAttemptItemInput = {
  billId: Scalars['ID']['input']
  paymentMethodId: Scalars['ID']['input']
  /**
   * Optional payment speed. Defaults to STANDARD when omitted. Partners without
   * the corresponding capability receive a FailedPrecondition error in errorMessage.
   */
  paymentSpeed?: InputMaybe<PaymentSpeed>
  /**
   * When true and the funding flow ultimately issues a virtual card, triggers
   * a vendor-facing reveal email after issuance (AP-843). Ignored for ACH
   * attempts and for card flows that don't opt in. Forwarded 1:1 to the
   * svc-accounts-payable CreateFundingAttempt RPC field `sendVendorOtpEmail`.
   */
  sendVendorOtpEmail?: InputMaybe<Scalars['Boolean']['input']>
  vendorPaymentMethod?: InputMaybe<VendorPaymentMethod>
}

export type CreateFundingAttemptResult = {
  __typename: 'CreateFundingAttemptResult'
  billId: Scalars['ID']['output']
  /** Bill status after the funding attempt was created — BILL_SCHEDULED when funding is deferred, BILL_PROCESSING when the capture fires immediately. Used by the partner UI to route the user to the matching tab. Absent on failure or until the upstream svc-accounts-payable propagates the field (AP-1538). */
  billStatus?: Maybe<BillStatus>
  /** gRPC status code when success=false (e.g. "FailedPrecondition"). Absent on success. */
  errorCode?: Maybe<Scalars['String']['output']>
  /** Human-readable failure message when success=false. Absent on success. */
  errorMessage?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type CreateFundingAttemptsInput = {
  items: Array<CreateFundingAttemptItemInput>
}

export type CreateFundingAttemptsResponse = {
  __typename: 'CreateFundingAttemptsResponse'
  results: Array<CreateFundingAttemptResult>
}

export type CreateReferralInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
}

/** Input for creating a new unit type. */
export type CreateUnitTypeInput = {
  name: Scalars['String']['input']
}

export type CreateUserAndPartnerReply = {
  __typename: 'CreateUserAndPartnerReply'
  partnerId: Scalars['ID']['output']
  userId: Scalars['ID']['output']
}

export type CreateUtilizationPresetInput = {
  filters: UtilizationPresetFiltersInput
  name: Scalars['String']['input']
}

export type CreateVendor = {
  category?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  companyAddress?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  owner?: InputMaybe<Scalars['String']['input']>
  paymentPreference?: InputMaybe<UsPaymentPreferenceData>
  phone?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  taxId?: InputMaybe<Scalars['String']['input']>
}

export type CreateVendorPaymentPreferenceInput = {
  usPaymentPreferenceData?: InputMaybe<UsPaymentPreferenceData>
  vendorID: Scalars['String']['input']
}

export type CreditMemoConfig = {
  __typename: 'CreditMemoConfig'
  customerExceptionIDs: Array<Scalars['ID']['output']>
  enabled: Scalars['Boolean']['output']
  partnerID: Scalars['ID']['output']
  showCreditMemo: Scalars['Boolean']['output']
}

export type CreditMemoDetail = {
  __typename: 'CreditMemoDetail'
  createdAt: Scalars['String']['output']
  creditMemoExternalID: Scalars['String']['output']
  creditMemoExternalType: Scalars['String']['output']
  currencyCode: Scalars['String']['output']
  customer?: Maybe<Customer>
  externalMemoNumber?: Maybe<Scalars['String']['output']>
  externalNote?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  internalNote?: Maybe<Scalars['String']['output']>
  issueDate?: Maybe<Scalars['String']['output']>
  partnerID: Scalars['ID']['output']
  remainingAmount: Scalars['Float']['output']
  status: CreditMemoStatus
  totalAmount: Scalars['Float']['output']
  updatedAt: Scalars['String']['output']
}

export type CreditMemoFiltersInput = {
  amountMax?: InputMaybe<Scalars['Float']['input']>
  amountMin?: InputMaybe<Scalars['Float']['input']>
  appliedAmountMax?: InputMaybe<Scalars['Float']['input']>
  appliedAmountMin?: InputMaybe<Scalars['Float']['input']>
  issueDateEnd?: InputMaybe<Scalars['String']['input']>
  issueDateStart?: InputMaybe<Scalars['String']['input']>
  memoNumber?: InputMaybe<Scalars['String']['input']>
  remainingAmountMax?: InputMaybe<Scalars['Float']['input']>
  remainingAmountMin?: InputMaybe<Scalars['Float']['input']>
  statuses?: InputMaybe<Array<CreditMemoStatus>>
}

export type CreditMemoListResponse = {
  __typename: 'CreditMemoListResponse'
  creditMemos: Array<CreditMemoDetail>
  lastSyncedAt?: Maybe<Scalars['String']['output']>
  pagination: CreditMemoPagination
}

export enum CreditMemoOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum CreditMemoOrderField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  IssueDate = 'ISSUE_DATE',
  MemoNumber = 'MEMO_NUMBER',
  Remaining = 'REMAINING',
  Status = 'STATUS'
}

export type CreditMemoOrderInput = {
  direction: CreditMemoOrderDirection
  field: CreditMemoOrderField
}

export type CreditMemoPagination = {
  __typename: 'CreditMemoPagination'
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export enum CreditMemoStatus {
  Applied = 'APPLIED',
  Open = 'OPEN',
  PartiallyApplied = 'PARTIALLY_APPLIED',
  Void = 'VOID'
}

export enum Currency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type CustomPartnerFeeConfig = {
  __typename: 'CustomPartnerFeeConfig'
  coverFeeConfig?: Maybe<CoverFeeConfig>
  id: Scalars['ID']['output']
  partner: Partner
  paymentExecutorType: PaymentExecutorType
  paymentOriginService: PaymentAlternativeService
}

export type CustomPartnerFeeConfigUpsertInput = {
  coverFeeConfig?: InputMaybe<PartnerCoverFeeConfigInput>
  paymentExecutorType: PaymentExecutorType
  paymentOriginService: PaymentAlternativeService
}

export type CustomPartnerFeeConfigs = {
  __typename: 'CustomPartnerFeeConfigs'
  customPartnerFeeConfigs?: Maybe<Array<CustomPartnerFeeConfig>>
}

export type CustomPartnerFeeConfigsFilter = {
  paymentExecutorType?: InputMaybe<PaymentExecutorType>
  paymentOriginService?: InputMaybe<PaymentAlternativeService>
}

export type Customer = AddressInterface & {
  __typename: 'Customer'
  archivedBy?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  customerUsers?: Maybe<Array<CustomerUser>>
  defaultPaymentMethod?: Maybe<CustomerDefaultPaymentMethod>
  description?: Maybe<Scalars['String']['output']>
  ein?: Maybe<Scalars['String']['output']>
  feeConfig?: Maybe<Array<Maybe<CustomerFeeConfig>>>
  id: Scalars['ID']['output']
  industry?: Maybe<Scalars['String']['output']>
  isArchived: Scalars['Boolean']['output']
  isOnboarded: Scalars['Boolean']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  /**
   * Per-invoice outstanding detail resolved from svc-invoice's unpaid-invoice
   * list. For the total amount owed, prefer `owed` — the canonical AR-computed
   * definition; the two sources can differ.
   */
  outstandingInvoicesData?: Maybe<CustomerOutstandingInvoicesData>
  /**
   * Total currently owed by this customer, in dollars — the canonical
   * outstanding definition, summed across currencies. Sourced from the AR REST
   * customer payload on the v2 path; null on the gRPC v1 path.
   */
  owed?: Maybe<Scalars['Float']['output']>
  /**
   * Total paid by this customer in the last 30 days, in dollars, summed across
   * currencies. Sourced from the AR REST customer payload on the v2 path; null
   * on the gRPC v1 path. Sortable on the customer list via
   * PartnerListCustomersOrderField.PAID_AMOUNT.
   */
  paidLast30Days?: Maybe<Scalars['Float']['output']>
  partner?: Maybe<Partner>
  postalCode?: Maybe<Scalars['String']['output']>
  relations: Array<AccountingCustomerRelation>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
  tagIDs?: Maybe<Array<Scalars['ID']['output']>>
}

export type CustomerAutopayConfig = {
  __typename: 'CustomerAutopayConfig'
  ID: Scalars['ID']['output']
  chargeDefaultFallback: Scalars['Boolean']['output']
  customerID: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
}

/** A connection to a list of items. */
export type CustomerConnection = {
  __typename: 'CustomerConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type CustomerCreditMemoBalance = {
  __typename: 'CustomerCreditMemoBalance'
  balance: Scalars['Float']['output']
  currencyCode: Scalars['String']['output']
  enabled: Scalars['Boolean']['output']
  lastSyncedAt?: Maybe<Scalars['String']['output']>
  show: Scalars['Boolean']['output']
}

export type CustomerDefaultPaymentMethod = {
  __typename: 'CustomerDefaultPaymentMethod'
  card?: Maybe<Card>
  institution?: Maybe<Institution>
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['output']
}

/** An edge in a connection. */
export type CustomerEdge = {
  __typename: 'CustomerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Customer>
}

export type CustomerFeeConfig = {
  __typename: 'CustomerFeeConfig'
  customer: Customer
  feeType: FeeExceptionType
  id: Scalars['UUID']['output']
  partner: Partner
}

export enum CustomerFeeConfigAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type CustomerFilter = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  customerIDsNotIn?: InputMaybe<Array<Scalars['ID']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
  onboarded?: InputMaybe<Scalars['Boolean']['input']>
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>
  tagIdIn?: InputMaybe<Array<Scalars['ID']['input']>>
  tagIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CustomerIntegrationIdMapping = {
  __typename: 'CustomerIntegrationIDMapping'
  customerID: Scalars['ID']['output']
  integrationEntityID: Scalars['ID']['output']
}

export type CustomerOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CustomerOrderByField>
}

export enum CustomerOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type CustomerOutstandingInvoicesData = {
  __typename: 'CustomerOutstandingInvoicesData'
  longestDaysOverdue?: Maybe<Scalars['String']['output']>
  outstandingInvoicesCount?: Maybe<Scalars['Int']['output']>
  outstandingInvoicesTotal?: Maybe<Scalars['Float']['output']>
}

/** Payment-method gap used to filter the customer list. */
export enum CustomerPaymentMethodStatus {
  /** Customers with methods on file but no default selected. */
  NoDefault = 'NO_DEFAULT',
  /** Customers with zero enrolled payment methods. */
  NoMethodOnFile = 'NO_METHOD_ON_FILE'
}

/**
 * Per-customer roll-up backing the customer-detail assistant nudge banners.
 * Sourced from svc-accounts-receivable GET /customers/:id/summary (ADR-029).
 * Counts cover all non-archived invoices (paid included); autopayInvoiceCount is
 * the per-invoice subset currently on auto-pay.
 */
export type CustomerSummary = {
  __typename: 'CustomerSummary'
  autopayInvoiceCount: Scalars['Int']['output']
  hasPaymentMethod: Scalars['Boolean']['output']
  invoiceCount: Scalars['Int']['output']
}

export type CustomerTag = {
  __typename: 'CustomerTag'
  ID: Scalars['ID']['output']
  color?: Maybe<TagColor>
  customerIDs: Array<Scalars['ID']['output']>
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  type?: Maybe<TagType>
}

export type CustomerUser = {
  __typename: 'CustomerUser'
  approvedBy?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role: CustomerUserRole
}

/** A connection to a list of items. */
export type CustomerUserConnection = {
  __typename: 'CustomerUserConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerUserEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CustomerUserEdge = {
  __typename: 'CustomerUserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<CustomerUser>
}

export type CustomerUserFilter = {
  companyName?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  firstCreatedUserOnly?: InputMaybe<Scalars['Boolean']['input']>
  hasApprovedBy?: InputMaybe<Scalars['Boolean']['input']>
}

export type CustomerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CustomerUserOrderByField>
}

export enum CustomerUserOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum CustomerUserRole {
  Customer = 'CUSTOMER'
}

/**
 * Partner-level customer counts over non-archived customers (svc-accounts-receivable
 * ADR-029 GET /customers/summary).
 */
export type CustomersSummary = {
  __typename: 'CustomersSummary'
  customers60PlusOverdue: Scalars['Int']['output']
  customersWithNonAutopayInvoices: Scalars['Int']['output']
  customersWithoutPaymentMethod: Scalars['Int']['output']
}

export type DataPoint = {
  __typename: 'DataPoint'
  month: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type DatagateConnectionCreateInput = {
  apiToken: Scalars['String']['input']
}

export type DatagateIntegration = IntegrationInterface & {
  __typename: 'DatagateIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

/** Optional inclusive-start / exclusive-end window. Timestamps are RFC3339. */
export type DateRangeInput = {
  end: Scalars['String']['input']
  start: Scalars['String']['input']
}

export type Decimal = {
  __typename: 'Decimal'
  nanos: Scalars['Int']['output']
  units: Scalars['Int']['output']
}

export type DecimalInput = {
  nanos: Scalars['Int']['input']
  units: Scalars['Int']['input']
}

export type DeleteBillResult = {
  __typename: 'DeleteBillResult'
  billId: Scalars['ID']['output']
  errorReason?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteBillsResponse = {
  __typename: 'DeleteBillsResponse'
  results: Array<DeleteBillResult>
}

export type DeleteEmailTemplateInput = {
  id: Scalars['ID']['input']
}

/** Input for deleting a vendor document. */
export type DeleteVendorDocumentInput = {
  documentId: Scalars['ID']['input']
  vendorId: Scalars['ID']['input']
}

export type DownloadableInvoiceLink = {
  __typename: 'DownloadableInvoiceLink'
  expires_at?: Maybe<Scalars['String']['output']>
  invoiceId: Scalars['String']['output']
  status: DownloadableInvoiceStatus
  url?: Maybe<Scalars['String']['output']>
}

export enum DownloadableInvoiceStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Initialized = 'INITIALIZED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type EmailActivity = {
  __typename: 'EmailActivity'
  customer?: Maybe<Customer>
  invoice?: Maybe<Invoice>
  sentAt: Scalars['String']['output']
  status?: Maybe<EmailStatus>
  subject: Scalars['String']['output']
  user: Scalars['String']['output']
}

export type EmailActivityConnection = {
  __typename: 'EmailActivityConnection'
  edges: Array<EmailActivityEdge>
  pageInfo: PageInfo
}

export type EmailActivityEdge = {
  __typename: 'EmailActivityEdge'
  cursor: Scalars['Cursor']['output']
  node: EmailActivity
}

export type EmailActivityFilter = {
  customerID?: InputMaybe<Scalars['String']['input']>
  invoiceID?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['String']['input']>
  sentAtEnd?: InputMaybe<Scalars['String']['input']>
  sentAtStart?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<EmailStatus>
  user?: InputMaybe<Scalars['String']['input']>
}

export enum EmailStatus {
  Bounced = 'BOUNCED',
  Clicked = 'CLICKED',
  Delivered = 'DELIVERED',
  Opened = 'OPENED',
  Pending = 'PENDING'
}

export type EmailTemplate = {
  __typename: 'EmailTemplate'
  favorite?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['ID']['output']
  section1?: Maybe<Scalars['String']['output']>
  section2?: Maybe<Scalars['String']['output']>
  section3?: Maybe<Scalars['String']['output']>
  subject: Scalars['String']['output']
  type: TemplateType
}

export enum ExcludedFromAutopayBy {
  System = 'SYSTEM',
  User = 'USER'
}

export enum ExecutorEntityType {
  ExecutorEntityTypeAlternative = 'EXECUTOR_ENTITY_TYPE_ALTERNATIVE',
  ExecutorEntityTypeCustomer = 'EXECUTOR_ENTITY_TYPE_CUSTOMER',
  ExecutorEntityTypeCustomerGuest = 'EXECUTOR_ENTITY_TYPE_CUSTOMER_GUEST',
  ExecutorEntityTypePartner = 'EXECUTOR_ENTITY_TYPE_PARTNER',
  ExecutorEntityTypePartnerApi = 'EXECUTOR_ENTITY_TYPE_PARTNER_API',
  ExecutorEntityTypeSystem = 'EXECUTOR_ENTITY_TYPE_SYSTEM',
  ExecutorEntityTypeUnspecified = 'EXECUTOR_ENTITY_TYPE_UNSPECIFIED'
}

export type ExpenseAccount = {
  __typename: 'ExpenseAccount'
  accountNumber?: Maybe<Scalars['String']['output']>
  active: Scalars['Boolean']['output']
  externalId: Scalars['String']['output']
  fullyQualifiedName: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: Scalars['String']['output']
  visible: Scalars['Boolean']['output']
}

export enum ExplainErrorFeedbackType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type ExplainIntegrationErrorFeedbackInput = {
  errorMessage: Scalars['String']['input']
  explanation: Scalars['String']['input']
  feedback: ExplainErrorFeedbackType
  jobType: Scalars['String']['input']
  platformName: Scalars['String']['input']
}

export type ExplainIntegrationErrorFeedbackResponse = {
  __typename: 'ExplainIntegrationErrorFeedbackResponse'
  success: Scalars['Boolean']['output']
}

export type ExplainIntegrationErrorInput = {
  errorMessage: Scalars['String']['input']
  invoiceNumber?: InputMaybe<Scalars['String']['input']>
  jobType: Scalars['String']['input']
  platformName: Scalars['String']['input']
}

export type ExplainIntegrationErrorResponse = {
  __typename: 'ExplainIntegrationErrorResponse'
  contactSupport: Scalars['Boolean']['output']
  explanation: Scalars['String']['output']
  suggestedActions: Array<Scalars['String']['output']>
}

export type ExportClientTrendsBreakdownCsvInput = {
  clientId: Scalars['ID']['input']
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type ExportClientTrendsCsvInput = {
  clientSearch?: InputMaybe<Scalars['String']['input']>
  endDate: Scalars['String']['input']
  filters?: InputMaybe<ClientTrendsFiltersInput>
  selectedMonth?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<ClientTrendsSortBy>
  sortOrder?: InputMaybe<OrderDirection>
  startDate: Scalars['String']['input']
}

export type ExportUtilizationBreakdownCsvInput = {
  endDate: Scalars['String']['input']
  filters?: InputMaybe<ExportUtilizationCsvFiltersInput>
  startDate: Scalars['String']['input']
}

export type ExportUtilizationCsvFiltersInput = {
  agentFilter?: InputMaybe<ClientTrendsFilterValuesInput>
  agentTitleFilter?: InputMaybe<ClientTrendsFilterValuesInput>
  categoryFilter?: InputMaybe<ClientTrendsFilterValuesInput>
  clientFilter?: InputMaybe<ClientTrendsFilterValuesInput>
  ticketTypeFilter?: InputMaybe<ClientTrendsFilterValuesInput>
}

export type ExportUtilizationCsvInput = {
  endDate: Scalars['String']['input']
  filters?: InputMaybe<ExportUtilizationCsvFiltersInput>
  reportType: UtilizationCsvReportType
  startDate: Scalars['String']['input']
}

/** Input for extracting bill data from a document via OCR without creating a bill. */
export type ExtractBillDataInput = {
  /** Base64-encoded document content (PDF, PNG, or JPG). */
  content: Scalars['String']['input']
  /** MIME type: application/pdf, image/png, or image/jpeg. */
  contentType: Scalars['String']['input']
  /** Original filename with extension. */
  filename: Scalars['String']['input']
}

/** Response from extracting bill data. Does not include billId or billNumber. */
export type ExtractBillDataPayload = {
  __typename: 'ExtractBillDataPayload'
  /** S3 path to the uploaded document. */
  documentPath?: Maybe<Scalars['String']['output']>
  /** Data extracted from the document via OCR. */
  extractedData?: Maybe<ExtractedBillData>
  /** Warnings such as OCR extraction issues. */
  warnings?: Maybe<Array<Scalars['String']['output']>>
}

/** Data extracted from uploaded bill document via OCR. */
export type ExtractedBillData = {
  __typename: 'ExtractedBillData'
  description?: Maybe<Scalars['String']['output']>
  dueDate?: Maybe<Scalars['String']['output']>
  invoiceNumber?: Maybe<Scalars['String']['output']>
  issueDate?: Maybe<Scalars['String']['output']>
  lineItems?: Maybe<Array<ExtractedLineItem>>
  total?: Maybe<Scalars['String']['output']>
  vendorEmail?: Maybe<Scalars['String']['output']>
  vendorName?: Maybe<Scalars['String']['output']>
}

export type ExtractedLineItem = {
  __typename: 'ExtractedLineItem'
  amount?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  expenseAccountId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  quantity: Scalars['String']['output']
  total: Scalars['String']['output']
  unitPrice: Scalars['String']['output']
}

export enum FeeExceptionType {
  Ach = 'ACH',
  Card = 'CARD',
  Directpayment = 'DIRECTPAYMENT',
  Other = 'OTHER',
  Wire = 'WIRE'
}

export type FeeSplitResult = {
  __typename: 'FeeSplitResult'
  feePercentageForCustomer: Scalars['Float']['output']
  feePercentageForPartner: Scalars['Float']['output']
  fixedFeeAmountCustomer: Scalars['Float']['output']
  fixedFeeAmountPartner: Scalars['Float']['output']
  relativeFeeAmountCustomer: Scalars['Float']['output']
  relativeFeeAmountPartner: Scalars['Float']['output']
}

export enum FeeType {
  LatePayment = 'LATE_PAYMENT',
  Method = 'METHOD',
  Product = 'PRODUCT'
}

export enum Frequency {
  Annually = 'ANNUALLY',
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Weekly = 'WEEKLY'
}

export enum FundingSource {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Prepaid = 'PREPAID'
}

export type GeographicInfoInput = {
  latitude?: InputMaybe<Scalars['Int']['input']>
  longitude?: InputMaybe<Scalars['Int']['input']>
}

export type GetAccountingSyncBatchReply = {
  __typename: 'GetAccountingSyncBatchReply'
  batch: AccountingSyncBatch
  invoiceJobs?: Maybe<Array<AccountingSyncJob>>
}

export type GetAdyenHostedOnboardingLinkResponse = {
  __typename: 'GetAdyenHostedOnboardingLinkResponse'
  url: Scalars['String']['output']
}

export type GetAdyenRemediationActionsGrouping = {
  __typename: 'GetAdyenRemediationActionsGrouping'
  actions: Array<GetAdyenRemediationActionsItem>
  errorCode: Scalars['String']['output']
  errorMessage: Scalars['String']['output']
  ownerID: Scalars['String']['output']
  ownerType: AdyenOwnerType
}

export type GetAdyenRemediationActionsItem = {
  __typename: 'GetAdyenRemediationActionsItem'
  actionID: Scalars['String']['output']
  actionType: AdyenRemediationActionType
  unmappedRemediationActionCode?: Maybe<Scalars['String']['output']>
}

export type GetAdyenRemediationActionsReply = {
  __typename: 'GetAdyenRemediationActionsReply'
  groupings: Array<GetAdyenRemediationActionsGrouping>
}

export type GetBillAggregatesInput = {
  /** Filters bills by issueDate. Omit for all-time. */
  dateRange?: InputMaybe<DateRangeInput>
  statusIn?: InputMaybe<Array<BillStatus>>
}

export type GetCardFeeInput = {
  Amount: Scalars['Float']['input']
  CardID?: InputMaybe<Scalars['ID']['input']>
}

export type GetCardPubKey = {
  provider: CardProvider
}

export type GetClientTrendsBreakdownInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>
  endDate: Scalars['String']['input']
  filters?: InputMaybe<ClientTrendsFiltersInput>
  startDate: Scalars['String']['input']
}

export type GetClientTrendsClientsInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>
  clientSearch?: InputMaybe<Scalars['String']['input']>
  endDate: Scalars['String']['input']
  filters?: InputMaybe<ClientTrendsFiltersInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  selectedMonth?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<ClientTrendsSortBy>
  sortOrder?: InputMaybe<OrderDirection>
  startDate: Scalars['String']['input']
}

export type GetCustomerAutopayConfigInput = {
  customerID: Scalars['ID']['input']
}

export type GetCustomerAutopayConfigReply = {
  __typename: 'GetCustomerAutopayConfigReply'
  customerAutopayConfig?: Maybe<CustomerAutopayConfig>
}

export type GetCustomerCardFeeInput = {
  Amount: Scalars['Float']['input']
  CardID?: InputMaybe<Scalars['ID']['input']>
  CustomerID: Scalars['ID']['input']
}

export type GetFeeRatesInput = {
  amount: Scalars['Float']['input']
  interest?: InputMaybe<Scalars['Float']['input']>
  invoiceOverdueDate: Scalars['String']['input']
}

export type GetPartnerInvoiceBulkChargesFilter = {
  bulkChargeId?: InputMaybe<Scalars['ID']['input']>
  bulkChargeRequestStatuses?: InputMaybe<Array<BulkChargeRequestStatusEnum>>
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  paymentDateEnd?: InputMaybe<Scalars['String']['input']>
  paymentDateStart?: InputMaybe<Scalars['String']['input']>
  requesterId?: InputMaybe<Scalars['ID']['input']>
}

export type GetPartnerInvoiceBulkChargesOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PartnerInvoiceBulkChargeOrderByField>
}

export type GetPaymentMethodUsageInput = {
  /** Filters amounts by payment sentAt. Omit for all-time. */
  period?: InputMaybe<DateRangeInput>
}

export type GetRecentActivityInput = {
  /** Maximum number of activity items to return. Default 10, max 50. */
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type GetReferralDataInput = {
  period: ReferralComparisonPeriod
}

export type GetReferralDataReply = {
  __typename: 'GetReferralDataReply'
  previous: Scalars['Float']['output']
  total: Scalars['Float']['output']
}

export type GetSpendByCategoryInput = {
  /** Filters the breakdown by issueDate. Omit for all-time. */
  period?: InputMaybe<DateRangeInput>
}

/** Input for querying vendor similarity groups. */
export type GetVendorSimilarityGroupsInput = {
  /** Include previously dismissed groups. */
  includeDismissed?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by specific vendor IDs. If empty, returns all groups. */
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type GetVendorSpendInput = {
  /** Maximum number of vendors to return (top N by total spend desc). */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Filters bills by issueDate. Omit for all-time. */
  period?: InputMaybe<DateRangeInput>
}

export type GetVendorTotalsInput = {
  statuses?: InputMaybe<Array<BillStatus>>
  vendorIds: Array<Scalars['String']['input']>
}

export enum Granularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type HaloPsaConnectionQueryFilters = {
  __typename: 'HaloPSAConnectionQueryFilters'
  customerFilters?: Maybe<HaloPsaCustomerFilters>
  invoiceFilters?: Maybe<HaloPsaInvoiceFilters>
}

export type HaloPsaConnectionQueryFiltersInput = {
  customerFilters?: InputMaybe<HaloPsaCustomerFiltersInput>
  invoiceFilters?: InputMaybe<HaloPsaInvoiceFiltersInput>
}

export type HaloPsaContract = {
  __typename: 'HaloPSAContract'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type HaloPsaContractConnection = {
  __typename: 'HaloPSAContractConnection'
  edges?: Maybe<Array<HaloPsaContractEdge>>
  pageInfo: PageInfo
}

export type HaloPsaContractEdge = {
  __typename: 'HaloPSAContractEdge'
  cursor: Scalars['Cursor']['output']
  node: HaloPsaContract
}

export type HaloPsaContractFilter = {
  customerNames?: InputMaybe<Array<Scalars['String']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
}

export type HaloPsaContractSubtype = {
  __typename: 'HaloPSAContractSubtype'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type HaloPsaCustomerFilters = {
  __typename: 'HaloPSACustomerFilters'
  topLevels?: Maybe<Array<HaloPsaFilterValue>>
}

export type HaloPsaCustomerFiltersInput = {
  topLevels?: InputMaybe<Array<HaloPsaFilterValueInput>>
}

export type HaloPsaFilterValue = {
  __typename: 'HaloPSAFilterValue'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type HaloPsaFilterValueInput = {
  id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type HaloPsaIntegration = IntegrationInterface & {
  __typename: 'HaloPSAIntegration'
  applicationDomain: Scalars['String']['output']
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  queryFilters?: Maybe<HaloPsaConnectionQueryFilters>
  status: ConnectionStatus
}

export type HaloPsaInvoiceFilters = {
  __typename: 'HaloPSAInvoiceFilters'
  createdSince?: Maybe<Scalars['String']['output']>
}

export type HaloPsaInvoiceFiltersInput = {
  createdSince?: InputMaybe<Scalars['String']['input']>
}

export type HaloPsaTopLevel = {
  __typename: 'HaloPSATopLevel'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

/** One aging tile: outstanding amount (cents) plus the invoice count in the bucket. */
export type HomeAgingBucket = {
  __typename: 'HomeAgingBucket'
  amountCents: Scalars['Int']['output']
  count: Scalars['Int']['output']
}

export type HomeAutopayCoverage = {
  __typename: 'HomeAutopayCoverage'
  /** Fraction enrolled in autopay, 0..1. */
  coveragePct: Scalars['Float']['output']
  enrolledCount: Scalars['Int']['output']
  notEnrolledCount: Scalars['Int']['output']
  totalCustomers: Scalars['Int']['output']
}

export type HomeCashFlow = {
  __typename: 'HomeCashFlow'
  currencies: Array<HomeCashFlowCurrency>
  direction: HomeCashFlowDirection
}

export type HomeCashFlowCurrency = {
  __typename: 'HomeCashFlowCurrency'
  currency: Scalars['String']['output']
  deltaAbs: Scalars['Int']['output']
  deltaPct?: Maybe<Scalars['Float']['output']>
  /** Up to `limit` customers per currency (default 4, max 20), sorted by amount desc. */
  topSources: Array<HomeCashFlowTopSource>
  total: Scalars['Int']['output']
}

export enum HomeCashFlowDirection {
  Expected = 'EXPECTED',
  Received = 'RECEIVED'
}

/**
 * Classifies a cash-flow source row: a real CUSTOMER, or a synthetic channel/
 * product bucket for customer-less payments (POS terminal, e-commerce, one-time
 * payment link, bank transfer, other). Lets clients label/group/decide visibility
 * without matching the display name.
 */
export enum HomeCashFlowSourceType {
  Customer = 'CUSTOMER',
  Ecom = 'ECOM',
  Other = 'OTHER',
  Otp = 'OTP',
  Pos = 'POS',
  Transfer = 'TRANSFER'
}

export type HomeCashFlowTopSource = {
  __typename: 'HomeCashFlowTopSource'
  amountCents: Scalars['Int']['output']
  customerId: Scalars['ID']['output']
  customerName: Scalars['String']['output']
  invoiceCount: Scalars['Int']['output']
  /** Derived from invoices_legacy.autopaid_at (a proxy, not an enrollment record). */
  paymentMode: HomePaymentMode
  /** Kind of source; both E-commerce rows share ECOM and differ by paymentMode. */
  sourceType: HomeCashFlowSourceType
}

export type HomeCustomerNeedingAttention = {
  __typename: 'HomeCustomerNeedingAttention'
  autopay: Scalars['Boolean']['output']
  balanceCents: Scalars['Int']['output']
  currency: Scalars['String']['output']
  customerId: Scalars['ID']['output']
  customerName: Scalars['String']['output']
  invoicesOutstanding: Scalars['Int']['output']
  /** Null when no reminder has been sent. */
  lastReminderDaysAgo?: Maybe<Scalars['Int']['output']>
  maxDaysOverdue: Scalars['Int']['output']
  overdueCount: Scalars['Int']['output']
}

export type HomeCustomersNeedingAttention = {
  __typename: 'HomeCustomersNeedingAttention'
  items: Array<HomeCustomerNeedingAttention>
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  /** Total matching customers across all pages — use for 'page X of N'. */
  total: Scalars['Int']['output']
}

export type HomeDelta = {
  __typename: 'HomeDelta'
  deltaAbs: Scalars['Int']['output']
  /** Omitted (null) when prior == 0 to avoid divide-by-zero. */
  deltaPct?: Maybe<Scalars['Float']['output']>
  direction: HomeDeltaDirection
  isImprovement: Scalars['Boolean']['output']
  /** Prior-window value (same unit). For MRR this is an approximation (misses mid-window schedule changes). */
  prior: Scalars['Int']['output']
  /** Current-window value in the metric's native unit (cents for money, days for DSO). */
  value: Scalars['Int']['output']
}

export enum HomeDeltaDirection {
  Down = 'DOWN',
  Flat = 'FLAT',
  Up = 'UP'
}

export type HomeInvoicePipeline = {
  __typename: 'HomeInvoicePipeline'
  currencies: Array<HomeInvoicePipelineCurrency>
}

export type HomeInvoicePipelineCurrency = {
  __typename: 'HomeInvoicePipelineCurrency'
  currency: Scalars['String']['output']
  open: HomePipelineBucket
  overdue: HomePipelineBucket
  /** Invoices that transitioned to paid in the last 30 days, dated by the paid-status-change event (not invoice updated_at). */
  paid30d: HomePipelineBucket
}

/** Per-status invoice counts for a customer. total is the sum of the five statuses. */
export type HomeInvoiceStatusCounts = {
  __typename: 'HomeInvoiceStatusCounts'
  archived: Scalars['Int']['output']
  overdue: Scalars['Int']['output']
  paid: Scalars['Int']['output']
  received: Scalars['Int']['output']
  /** Sum of the five statuses — the customer's total invoice count. */
  total: Scalars['Int']['output']
  upcoming: Scalars['Int']['output']
}

/** A point-in-time KPI value with no trend (cents for money, days for DSO). */
export type HomeMetric = {
  __typename: 'HomeMetric'
  value: Scalars['Int']['output']
}

export type HomeOutstandingAr = {
  __typename: 'HomeOutstandingAR'
  currencies: Array<HomeOutstandingArCurrency>
}

export type HomeOutstandingArAging = {
  __typename: 'HomeOutstandingARAging'
  bucket0To30: HomeAgingBucket
  bucket31To60: HomeAgingBucket
  bucket61To90: HomeAgingBucket
  bucket90Plus: HomeAgingBucket
}

export type HomeOutstandingArCurrency = {
  __typename: 'HomeOutstandingARCurrency'
  aging: HomeOutstandingArAging
  currency: Scalars['String']['output']
  total: Scalars['Int']['output']
}

export type HomePaymentMethodIssues = {
  __typename: 'HomePaymentMethodIssues'
  noDefaultSet: Scalars['Int']['output']
  noMethodOnFile: Scalars['Int']['output']
}

export enum HomePaymentMode {
  Autopay = 'AUTOPAY',
  Manual = 'MANUAL'
}

export type HomePerformance = {
  __typename: 'HomePerformance'
  currencies: Array<HomePerformanceCurrency>
}

export type HomePerformanceCurrency = {
  __typename: 'HomePerformanceCurrency'
  /** Total collected in the window (cents). Carries a full trend vs the prior window. */
  collected: HomeDelta
  currency: Scalars['String']['output']
  /** Days Sales Outstanding (DAYS). Value only — no trend until AR snapshots exist. */
  dso: HomeMetric
  /** Monthly recurring revenue from recurring schedules only (cents). Value only — no trend until schedule snapshots exist. */
  mrr: HomeMetric
  /** Autopay-only MRR contribution (cents) for customers autopaying invoices with no active recurring schedule, averaged over the selected window (so it varies by range, unlike mrr). Sum mrr + mrrAutopay for the headline. No trend. */
  mrrAutopay: HomeMetric
}

export type HomePipelineBucket = {
  __typename: 'HomePipelineBucket'
  amountCents: Scalars['Int']['output']
  count: Scalars['Int']['output']
}

export enum HomeRange {
  Custom = 'CUSTOM',
  Last_7D = 'LAST_7D',
  Last_30D = 'LAST_30D',
  Last_60D = 'LAST_60D',
  Last_90D = 'LAST_90D'
}

export type HomeTopCustomerOwed = {
  __typename: 'HomeTopCustomerOwed'
  /** Derived from invoices_legacy.autopaid_at (proxy, not enrollment). */
  autopay: Scalars['Boolean']['output']
  balanceCents: Scalars['Int']['output']
  customerId: Scalars['ID']['output']
  customerName: Scalars['String']['output']
  /** @deprecated Outstanding-only count (backs balanceCents). Use invoiceCounts for the per-status breakdown / total. */
  invoiceCount: Scalars['Int']['output']
  /** Per-status invoice counts across all of the customer's invoices. */
  invoiceCounts: HomeInvoiceStatusCounts
  /** Null when the customer has no overdue invoices. */
  maxDaysOverdue?: Maybe<Scalars['Int']['output']>
  overdueCount: Scalars['Int']['output']
}

export type HomeTopCustomerPaid = {
  __typename: 'HomeTopCustomerPaid'
  customerId: Scalars['ID']['output']
  customerName: Scalars['String']['output']
  /** Sum paid in the last 30 days (cents), across both the AR and transfer payment rails. */
  paidCents: Scalars['Int']['output']
  paymentCount: Scalars['Int']['output']
}

export type HomeTopCustomersOwed = {
  __typename: 'HomeTopCustomersOwed'
  currencies: Array<HomeTopCustomersOwedCurrency>
}

export type HomeTopCustomersOwedCurrency = {
  __typename: 'HomeTopCustomersOwedCurrency'
  currency: Scalars['String']['output']
  customers: Array<HomeTopCustomerOwed>
}

export type HomeTopCustomersPaid = {
  __typename: 'HomeTopCustomersPaid'
  currencies: Array<HomeTopCustomersPaidCurrency>
}

export type HomeTopCustomersPaidCurrency = {
  __typename: 'HomeTopCustomersPaidCurrency'
  currency: Scalars['String']['output']
  customers: Array<HomeTopCustomerPaid>
}

/**
 * Read-only view of the Postmark inbound email that an OCR bill was created
 * from. Includes the email metadata, body, and every attachment that was on
 * the message — the attachment whose `isUsedForBill` is true is the PDF that
 * was OCR'd into the bill.
 */
export type InboundEmail = {
  __typename: 'InboundEmail'
  ID: Scalars['String']['output']
  attachments: Array<InboundEmailAttachment>
  /** RFC3339 timestamp when the email was sent. */
  date: Scalars['String']['output']
  from: Scalars['String']['output']
  fromName: Scalars['String']['output']
  /** HTML body as delivered by Postmark. Must be sanitized before render. */
  htmlBody: Scalars['String']['output']
  messageID: Scalars['String']['output']
  subject: Scalars['String']['output']
  /** Plain-text body as delivered by Postmark. */
  textBody: Scalars['String']['output']
  to: Scalars['String']['output']
}

export type InboundEmailAttachment = {
  __typename: 'InboundEmailAttachment'
  ID: Scalars['String']['output']
  contentType: Scalars['String']['output']
  filename: Scalars['String']['output']
  /**
   * True for the attachment that was OCR'd into the parent Bill. There is
   * always exactly one such attachment for any OCR bill that originated
   * from an inbound email; the others were sent on the same message but
   * were not used to create the bill.
   */
  isUsedForBill: Scalars['Boolean']['output']
  /**
   * Storage path of the attachment in S3, when uploaded. Resolving this to a
   * presigned download URL is out of scope for this type — use BillDocument
   * for the bill's source PDF.
   */
  s3Path?: Maybe<Scalars['String']['output']>
  size: Scalars['Int']['output']
}

export type Installment = {
  __typename: 'Installment'
  amount: Scalars['Float']['output']
  dueDate: Scalars['String']['output']
  fees: Array<Maybe<InstallmentFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  payments: Array<Maybe<Payment>>
  status: InstallmentStatus
}

export type InstallmentFee = {
  __typename: 'InstallmentFee'
  amount: Scalars['Float']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export enum InstallmentStatus {
  Canceled = 'CANCELED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type InstantPayment = {
  __typename: 'InstantPayment'
  id: Scalars['ID']['output']
}

export type Institution = {
  __typename: 'Institution'
  accounts?: Maybe<Array<Maybe<Account>>>
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  logo?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  plaidConnection?: Maybe<PlaidInstitutionConnectionStatus>
  url?: Maybe<Scalars['String']['output']>
}

export type IntegrationDisconnectInput = {
  partnerID: Scalars['ID']['input']
  platform: PlatformName
}

export type IntegrationInterface = {
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
}

export type IntegrationIssue = {
  __typename: 'IntegrationIssue'
  createdAt: Scalars['String']['output']
  detectedAt: Scalars['String']['output']
  entityExternalId: Scalars['String']['output']
  entityName: Scalars['String']['output']
  entityType: IntegrationIssueEntityType
  id: Scalars['ID']['output']
  reason: IntegrationIssueReason
  reasonDescription: Scalars['String']['output']
  sourceIntegrationPlatform: Scalars['String']['output']
  sourceIntegrationType: IntegrationType
  targetIntegrationPlatform?: Maybe<Scalars['String']['output']>
  targetIntegrationType?: Maybe<IntegrationType>
}

export type IntegrationIssueConnection = {
  __typename: 'IntegrationIssueConnection'
  edges?: Maybe<Array<IntegrationIssueEdge>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']['output']
}

export type IntegrationIssueCounts = {
  __typename: 'IntegrationIssueCounts'
  customerCount: Scalars['Int']['output']
  invoiceCount: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
}

export type IntegrationIssueEdge = {
  __typename: 'IntegrationIssueEdge'
  cursor: Scalars['Cursor']['output']
  node: IntegrationIssue
}

export enum IntegrationIssueEntityType {
  Customer = 'CUSTOMER',
  Invoice = 'INVOICE'
}

export type IntegrationIssueFilter = {
  entityType?: InputMaybe<IntegrationIssueEntityType>
  platformName: PlatformName
  reason?: InputMaybe<IntegrationIssueReason>
  search?: InputMaybe<Scalars['String']['input']>
}

export enum IntegrationIssueReason {
  DataIntegrityError = 'DATA_INTEGRITY_ERROR',
  DuplicateCustomerName = 'DUPLICATE_CUSTOMER_NAME',
  DuplicateInvoiceNumber = 'DUPLICATE_INVOICE_NUMBER',
  ImportFailed = 'IMPORT_FAILED',
  NoCounterpartIntegration = 'NO_COUNTERPART_INTEGRATION',
  NoMatchFound = 'NO_MATCH_FOUND'
}

export type IntegrationJob = {
  __typename: 'IntegrationJob'
  createdAt: Scalars['String']['output']
  deposit?: Maybe<IntegrationJobDeposit>
  errorMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceRelation?: Maybe<InvoiceRelation>
  request?: Maybe<Scalars['String']['output']>
  requestID?: Maybe<Scalars['String']['output']>
  response?: Maybe<Scalars['String']['output']>
  status: IntegrationJobStatus
  type: IntegrationJobType
  updatedAt: Scalars['String']['output']
}

export type IntegrationJobConnection = {
  __typename: 'IntegrationJobConnection'
  edges?: Maybe<Array<IntegrationJobEdge>>
  pageInfo: PageInfo
}

export type IntegrationJobDeposit = {
  __typename: 'IntegrationJobDeposit'
  txnID?: Maybe<Scalars['String']['output']>
}

export type IntegrationJobEdge = {
  __typename: 'IntegrationJobEdge'
  cursor: Scalars['Cursor']['output']
  node: IntegrationJob
}

export type IntegrationJobFailureCount = {
  __typename: 'IntegrationJobFailureCount'
  jobCount: Scalars['Int']['output']
  jobQueueCount: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
}

export type IntegrationJobFilter = {
  invoiceNumberSearch?: InputMaybe<Scalars['String']['input']>
  platformName: PlatformName
  rangeCreatedAt?: InputMaybe<RangeDateFilter>
  rangeUpdatedAt?: InputMaybe<RangeDateFilter>
  statuses?: InputMaybe<Array<IntegrationJobStatus>>
  types?: InputMaybe<Array<IntegrationJobType>>
}

export type IntegrationJobOrder = {
  direction: OrderDirection
  field: IntegrationJobOrderField
}

export enum IntegrationJobOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type IntegrationJobQueue = {
  __typename: 'IntegrationJobQueue'
  createdAt: Scalars['String']['output']
  deposit?: Maybe<IntegrationJobDeposit>
  errorMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceRelation?: Maybe<InvoiceRelation>
  request?: Maybe<Scalars['String']['output']>
  requestID?: Maybe<Scalars['String']['output']>
  response?: Maybe<Scalars['String']['output']>
  status: IntegrationJobQueueStatus
  type: IntegrationJobQueueType
  updatedAt: Scalars['String']['output']
}

export type IntegrationJobQueueConnection = {
  __typename: 'IntegrationJobQueueConnection'
  edges?: Maybe<Array<IntegrationJobQueueEdge>>
  pageInfo: PageInfo
}

export type IntegrationJobQueueEdge = {
  __typename: 'IntegrationJobQueueEdge'
  cursor: Scalars['Cursor']['output']
  node: IntegrationJobQueue
}

export type IntegrationJobQueueFilter = {
  invoiceNumberSearch?: InputMaybe<Scalars['String']['input']>
  platformName: PlatformName
  rangeCreatedAt?: InputMaybe<RangeDateFilter>
  rangeUpdatedAt?: InputMaybe<RangeDateFilter>
  statuses?: InputMaybe<Array<IntegrationJobQueueStatus>>
  types?: InputMaybe<Array<IntegrationJobQueueType>>
}

export type IntegrationJobQueueOrder = {
  direction: OrderDirection
  field: IntegrationJobQueueOrderField
}

export enum IntegrationJobQueueOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum IntegrationJobQueueStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum IntegrationJobQueueType {
  AccountCreate = 'ACCOUNT_CREATE',
  BankDeposit = 'BANK_DEPOSIT',
  BankDepositDelete = 'BANK_DEPOSIT_DELETE',
  BatchedBankDeposit = 'BATCHED_BANK_DEPOSIT',
  InvoicePayment = 'INVOICE_PAYMENT',
  InvoicePaymentDelete = 'INVOICE_PAYMENT_DELETE',
  InvoicePaymentUpdate = 'INVOICE_PAYMENT_UPDATE'
}

export enum IntegrationJobStatus {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Prequeued = 'PREQUEUED',
  Success = 'SUCCESS'
}

export enum IntegrationJobType {
  AccountCreate = 'ACCOUNT_CREATE',
  BankDeposit = 'BANK_DEPOSIT',
  InvoicePayment = 'INVOICE_PAYMENT',
  InvoicePaymentDelete = 'INVOICE_PAYMENT_DELETE',
  InvoicePaymentUpdate = 'INVOICE_PAYMENT_UPDATE'
}

export type IntegrationPermissionCapability = {
  __typename: 'IntegrationPermissionCapability'
  capability: Scalars['String']['output']
  detail?: Maybe<Scalars['String']['output']>
  probedAt: Scalars['String']['output']
  status: IntegrationPermissionStatus
}

export enum IntegrationPermissionStatus {
  Denied = 'DENIED',
  Granted = 'GRANTED',
  Partial = 'PARTIAL',
  Unknown = 'UNKNOWN'
}

export type IntegrationPermissions = {
  __typename: 'IntegrationPermissions'
  capabilities: Array<IntegrationPermissionCapability>
  connectionID: Scalars['ID']['output']
  integration: Scalars['String']['output']
}

export type IntegrationSyncInput = {
  platform: PlatformName
  syncType: SyncType
}

export type IntegrationSyncReply = {
  __typename: 'IntegrationSyncReply'
  message: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export enum IntegrationType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type Invoice = {
  __typename: 'Invoice'
  amount: Scalars['Float']['output']
  autopaidAt?: Maybe<Scalars['String']['output']>
  collection?: Maybe<Collection>
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customer?: Maybe<Customer>
  dueDate?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  externalInvoiceNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceNumber: Scalars['String']['output']
  lastRemindedAt?: Maybe<Scalars['String']['output']>
  lineItems?: Maybe<Array<Maybe<LineItem>>>
  offer?: Maybe<BnplOffer>
  outstandingAmount: Scalars['Float']['output']
  partner?: Maybe<Partner>
  payments?: Maybe<Array<Maybe<InvoicePayment>>>
  platformName: Scalars['String']['output']
  productName?: Maybe<Scalars['String']['output']>
  purchaseOrder?: Maybe<Scalars['String']['output']>
  recurringpayment: Scalars['Boolean']['output']
  recurringpaymentID?: Maybe<Scalars['String']['output']>
  sourceCreatedAt: Scalars['String']['output']
  status: InvoiceStatusEnum
  statuses: Array<Maybe<InvoiceStatus>>
  totalDiscountAmount: Scalars['Float']['output']
  totalTaxAmount: Scalars['Float']['output']
  transferPayments?: Maybe<Array<Maybe<Payment>>>
}

export type InvoiceAmountByStatusMonthResponse = {
  __typename: 'InvoiceAmountByStatusMonthResponse'
  average: Scalars['Float']['output']
  data: Array<InvoiceAmountMonth>
}

export type InvoiceAmountMonth = {
  __typename: 'InvoiceAmountMonth'
  data: Array<InvoiceAmountMonthStatus>
  month: Scalars['String']['output']
}

export type InvoiceAmountMonthStatus = {
  __typename: 'InvoiceAmountMonthStatus'
  status: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type InvoiceBnplConnection = {
  __typename: 'InvoiceBnplConnection'
  edges?: Maybe<Array<Maybe<InvoiceBnplEdge>>>
  pageInfo: PageInfo
}

export type InvoiceBnplEdge = {
  __typename: 'InvoiceBnplEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Invoice>
}

/** A connection to a list of items. */
export type InvoiceConnection = {
  __typename: 'InvoiceConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type InvoiceCountByStatusMonthResponse = {
  __typename: 'InvoiceCountByStatusMonthResponse'
  average: Scalars['Float']['output']
  data: Array<InvoiceCountMonth>
}

export type InvoiceCountMonth = {
  __typename: 'InvoiceCountMonth'
  data: Array<InvoiceCountMonthStatus>
  month: Scalars['String']['output']
}

export type InvoiceCountMonthStatus = {
  __typename: 'InvoiceCountMonthStatus'
  count: Scalars['Int']['output']
  status: Scalars['String']['output']
}

export type InvoiceCountResponse = {
  __typename: 'InvoiceCountResponse'
  value: Scalars['Int']['output']
}

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename: 'InvoiceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>
}

export type InvoiceFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  createdDateEnd?: InputMaybe<Scalars['String']['input']>
  createdDateStart?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['String']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  emailUnsent?: InputMaybe<Scalars['Boolean']['input']>
  invoiceNumber?: InputMaybe<Scalars['String']['input']>
  recurring?: InputMaybe<Scalars['Boolean']['input']>
  recurringpaymentID?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<InputMaybe<InvoiceStatusEnum>>>
}

export type InvoiceInput = {
  amount: Scalars['Float']['input']
  customerId: Scalars['String']['input']
  dueDate?: InputMaybe<Scalars['String']['input']>
  productName?: InputMaybe<Scalars['String']['input']>
}

export type InvoiceList = {
  __typename: 'InvoiceList'
  invoices?: Maybe<Array<ArInvoice>>
  pagination: ArPagination
  summary: ArInvoiceSummary
}

export enum InvoiceNumberField {
  ExternalId = 'EXTERNAL_ID',
  ExternalInvoiceNumber = 'EXTERNAL_INVOICE_NUMBER'
}

export enum InvoiceNumberFields {
  HaloPsaId = 'HaloPsaID',
  ThirdPartyInvoiceNumber = 'ThirdPartyInvoiceNumber'
}

export type InvoiceOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<InvoiceOrderByField>
}

export enum InvoiceOrderByField {
  Amount = 'AMOUNT',
  CreatedDate = 'CREATED_DATE',
  DueDate = 'DUE_DATE',
  ProductName = 'PRODUCT_NAME'
}

export enum InvoicePdfStatus {
  Expired = 'EXPIRED',
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type InvoicePayment = {
  __typename: 'InvoicePayment'
  Amount: Scalars['Float']['output']
  NetAmount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  payoutCreationForecastDate?: Maybe<Scalars['String']['output']>
  status: PaymentStatusEnum
}

export enum InvoicePayoutMethodEnum {
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export type InvoicePdfLink = {
  __typename: 'InvoicePdfLink'
  expiresAt: Scalars['String']['output']
  status: InvoicePdfStatus
  url: Scalars['String']['output']
}

export type InvoicePreferences = {
  __typename: 'InvoicePreferences'
  invoiceNumberField: InvoiceNumberField
}

export type InvoiceRelation = {
  __typename: 'InvoiceRelation'
  amount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  customer: InvoiceRelationCustomer
  dueDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  invoiceID?: Maybe<Scalars['String']['output']>
  invoiceNumber: Scalars['String']['output']
}

export type InvoiceRelationCustomer = {
  __typename: 'InvoiceRelationCustomer'
  id?: Maybe<Scalars['ID']['output']>
  name: Scalars['String']['output']
}

export type InvoiceReminder = {
  __typename: 'InvoiceReminder'
  bcc?: Maybe<Array<Scalars['String']['output']>>
  cc?: Maybe<Array<Scalars['String']['output']>>
  createdAt?: Maybe<Scalars['String']['output']>
  customers?: Maybe<Array<Maybe<Customer>>>
  daysOffset: Scalars['Int']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  runsHourly?: Maybe<Scalars['Boolean']['output']>
  sentHour?: Maybe<Scalars['Int']['output']>
  tags?: Maybe<Array<Maybe<CustomerTag>>>
  template?: Maybe<EmailTemplate>
  timezone?: Maybe<Timezone>
  type: InvoiceReminderType
}

export type InvoiceReminderExcludedCustomer = {
  __typename: 'InvoiceReminderExcludedCustomer'
  createdAt: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
}

export enum InvoiceReminderPreview {
  After = 'AFTER',
  Before = 'BEFORE',
  On = 'ON',
  OnCreation = 'ON_CREATION'
}

export type InvoiceReminderPreviewInput = {
  reminderID?: InputMaybe<Scalars['String']['input']>
  reminderPreview: InvoiceReminderPreview
}

export enum InvoiceReminderType {
  CreationDate = 'CREATION_DATE',
  DueDate = 'DUE_DATE'
}

export type InvoiceStatus = {
  __typename: 'InvoiceStatus'
  createdAt: Scalars['Time']['output']
  status: InvoiceStatusEnum
}

export enum InvoiceStatusEnum {
  Archived = 'ARCHIVED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Received = 'RECEIVED',
  Upcoming = 'UPCOMING'
}

export type InvoiceSummary = {
  __typename: 'InvoiceSummary'
  bcc?: Maybe<Array<Scalars['String']['output']>>
  cc?: Maybe<Array<Scalars['String']['output']>>
  createdAt?: Maybe<Scalars['String']['output']>
  customDay?: Maybe<Scalars['Int']['output']>
  customers?: Maybe<Array<Maybe<Customer>>>
  enabled: Scalars['Boolean']['output']
  frequency: InvoiceSummaryFrequency
  id: Scalars['ID']['output']
  lastSentAt?: Maybe<Scalars['String']['output']>
  sentHour: Scalars['Int']['output']
  startAt?: Maybe<Scalars['String']['output']>
  tags?: Maybe<Array<Maybe<CustomerTag>>>
  template?: Maybe<EmailTemplate>
  timezone?: Maybe<Timezone>
}

export type InvoiceSummaryExcludedCustomer = {
  __typename: 'InvoiceSummaryExcludedCustomer'
  createdAt: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
}

export enum InvoiceSummaryFrequency {
  MonthlyCustomDay = 'MONTHLY_CUSTOM_DAY',
  MonthlyFirstDay = 'MONTHLY_FIRST_DAY',
  MonthlyLastDay = 'MONTHLY_LAST_DAY',
  Weekly = 'WEEKLY'
}

export type InvoiceSummaryPreviewInput = {
  summaryID?: InputMaybe<Scalars['String']['input']>
}

export type InvoiceTotals = {
  __typename: 'InvoiceTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  outstandingAmount: Scalars['Float']['output']
}

export type InvoiceVolumeResponse = {
  __typename: 'InvoiceVolumeResponse'
  value: Scalars['Float']['output']
}

/**
 * Partner-level invoice aging counts (svc-accounts-receivable ADR-029
 * GET /invoices/summary). count0To30..count90Plus are EXCLUSIVE aging bands over
 * outstanding invoices aged by now()-due_date (count0To30 includes not-yet-due and
 * null-due-date invoices); dueBeforeEndOfMonth counts outstanding, not-yet-overdue
 * invoices due through the end of the current UTC month.
 */
export type InvoicesSummary = {
  __typename: 'InvoicesSummary'
  count0To30: Scalars['Int']['output']
  count31To60: Scalars['Int']['output']
  count61To90: Scalars['Int']['output']
  count90Plus: Scalars['Int']['output']
  dueBeforeEndOfMonth: Scalars['Int']['output']
}

export type JobQueueRetry = {
  jobQueueID: Scalars['ID']['input']
  platformName: PlatformName
}

export type JobRetry = {
  jobID: Scalars['ID']['input']
  platformName: PlatformName
}

export enum LaborCostImpact {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE'
}

export type LastRefreshTriggeredReply = {
  __typename: 'LastRefreshTriggeredReply'
  triggeredAt?: Maybe<Scalars['String']['output']>
}

export type LedgerMovementResult = {
  __typename: 'LedgerMovementResult'
  ledgerBalance: Scalars['Float']['output']
  movements: Array<MovementEntry>
}

export enum LedgerMovementType {
  AlternativeManualChange = 'ALTERNATIVE_MANUAL_CHANGE',
  AlternativePayment = 'ALTERNATIVE_PAYMENT',
  ExternalChange = 'EXTERNAL_CHANGE',
  ExternalCredit = 'EXTERNAL_CREDIT',
  ExternalPayment = 'EXTERNAL_PAYMENT'
}

export type Lending = {
  __typename: 'Lending'
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
  installments?: Maybe<Array<Maybe<Installment>>>
  netAmount: Scalars['Float']['output']
  partner: Partner
  payerEntity: CompanyType
  product: Product
}

export enum LendingPaymentMethodEnum {
  Ach = 'ACH',
  Card = 'CARD',
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH'
}

export type LendingPaymentMethodInput = {
  method: LendingPaymentMethodEnum
  methodReferenceID: Scalars['String']['input']
}

export type LineItem = {
  __typename: 'LineItem'
  category?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  extendedAmountPerItem?: Maybe<Scalars['Float']['output']>
  quantity?: Maybe<Scalars['Float']['output']>
  unitPrice?: Maybe<Scalars['Float']['output']>
}

export type ListAccountingSyncBatchesFilter = {
  PlatformName?: InputMaybe<PlatformName>
}

export type ListAccountingSyncBatchesReply = {
  __typename: 'ListAccountingSyncBatchesReply'
  edges?: Maybe<Array<Maybe<AccountingSyncBatchEdge>>>
  pageInfo: PageInfo
}

export type ListAccountingSyncJobsReply = {
  __typename: 'ListAccountingSyncJobsReply'
  jobs?: Maybe<Array<AccountingSyncJob>>
}

export type ListCardsFilterInput = {
  fundingSources?: InputMaybe<Array<InputMaybe<FundingSource>>>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type Mandate = {
  __typename: 'Mandate'
  consentAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  version: Scalars['String']['output']
}

export type MandateConsentInput = {
  geographicInfo: GeographicInfoInput
  mandateVersion: Scalars['String']['input']
  systemInfo: SystemInfoInput
}

export enum ManualAccountSubtypes {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export enum ManualAccountTypes {
  Depository = 'DEPOSITORY'
}

export type ManualBankingAccountInformationInput = {
  accountNumber: Scalars['String']['input']
  customName?: InputMaybe<Scalars['String']['input']>
  institutionName: Scalars['String']['input']
  onApproveBehavior?: InputMaybe<OnApproveBehavior>
  receiverName: Scalars['String']['input']
  routingNumber: Scalars['String']['input']
  subType: ManualAccountSubtypes
  type: ManualAccountTypes
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>
}

/** A single merge group specifying which vendors to merge and which survives. */
export type MergeGroupInput = {
  survivorId: Scalars['ID']['input']
  vendorIds: Array<Scalars['ID']['input']>
}

/** Result for a single merge group. */
export type MergeGroupResult = {
  __typename: 'MergeGroupResult'
  accepted: Scalars['Boolean']['output']
  errorReason?: Maybe<Scalars['String']['output']>
  survivorId: Scalars['ID']['output']
}

/** Input for merging vendors. Contains one or more merge groups. */
export type MergeVendorsInput = {
  groups: Array<MergeGroupInput>
}

/** Response from a vendor merge operation. */
export type MergeVendorsPayload = {
  __typename: 'MergeVendorsPayload'
  results: Array<MergeGroupResult>
}

export enum MethodEnum {
  Card = 'CARD',
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export enum MethodNetwork {
  Ach = 'ACH',
  AmericanExpress = 'AMERICAN_EXPRESS',
  CardOther = 'CARD_OTHER',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export type MonthlyRevenue = {
  __typename: 'MonthlyRevenue'
  amount: Scalars['Float']['output']
  month: Scalars['Int']['output']
  year: Scalars['Int']['output']
}

export type MovementEntry = {
  __typename: 'MovementEntry'
  balance: Scalars['Float']['output']
  movementType: LedgerMovementType
  movements: Array<Scalars['Float']['output']>
}

export enum MrrChangeType {
  Added = 'ADDED',
  Contraction = 'CONTRACTION',
  Expansion = 'EXPANSION',
  Lost = 'LOST',
  NoChange = 'NO_CHANGE'
}

export type Mutation = {
  __typename: 'Mutation'
  ActivatePartnerPaymentsPortal?: Maybe<Partner>
  BNPLOfferConfirmByToken?: Maybe<Scalars['String']['output']>
  CreateCompanyIndividual: CompanyIndividual
  DeleteCompanyIndividual: Scalars['String']['output']
  OAuth2Exchange: TokenExchange
  OAuth2Refresh: TokenExchange
  PartnerAccountingPreferencesUpdate?: Maybe<AccountingPreferences>
  PartnerAccountingSyncBatchCreate?: Maybe<AccountingSyncBatchCreateReply>
  PartnerAccountingSyncConfigCreate: SyncConfig
  PartnerAccountingSyncConfigUpdate: SyncConfig
  PartnerAddBankAccount: BankAccount
  PartnerAddCustomerBankAccount: BankAccount
  PartnerAddCustomerManualBankingConnection?: Maybe<Scalars['String']['output']>
  PartnerAddManualBankingConnection?: Maybe<Scalars['String']['output']>
  PartnerAddManualBankingConnectionV2?: Maybe<Account>
  PartnerApprovePendingCustomerUser?: Maybe<CustomerUser>
  PartnerArchiveAccount: Scalars['String']['output']
  PartnerArchiveCustomer?: Maybe<Customer>
  PartnerArchiveCustomerAccount: Scalars['String']['output']
  PartnerAutopayExcludedCustomerCreate?: Maybe<AutopayExcludedCustomer>
  PartnerAutopayExcludedCustomerDelete?: Maybe<Scalars['String']['output']>
  PartnerAutopayExcludedCustomerUpdate?: Maybe<
    Array<Maybe<AutopayExcludedCustomer>>
  >
  PartnerAutopayExcludedInvoiceBatchCreate?: Maybe<Scalars['String']['output']>
  PartnerAutopayExcludedInvoiceCreate?: Maybe<Scalars['String']['output']>
  PartnerAutopayExcludedInvoiceDelete?: Maybe<Scalars['String']['output']>
  PartnerAutotaskConnectionCreate?: Maybe<AutotaskQueryFilters>
  PartnerAutotaskConnectionUpdate?: Maybe<Scalars['String']['output']>
  PartnerBNPLOfferConfirm?: Maybe<Scalars['String']['output']>
  /**
   * Deactivate multiple vendors in a single request.
   * Requires ACCOUNTS_PAYABLE_CREATE_VENDOR permission.
   *
   * Returns per-vendor results indicating success or failure for each vendor.
   */
  PartnerBatchDeactivateVendors: BatchVendorActivationResponse
  /**
   * Reactivate multiple previously deactivated vendors in a single request.
   * Requires ACCOUNTS_PAYABLE_CREATE_VENDOR permission.
   *
   * Returns per-vendor results indicating success or failure for each vendor.
   */
  PartnerBatchReactivateVendors: BatchVendorActivationResponse
  PartnerBatchTagCustomers: Scalars['String']['output']
  PartnerBulkCancelBillSchedule: BulkCancelBillScheduleResponse
  PartnerBulkCancelVendorPayments: BulkCancelVendorPaymentsResponse
  PartnerBulkInvoiceRemind?: Maybe<Scalars['String']['output']>
  /**
   * Submits multiple bills for approval in a single request.
   * Requires ACCOUNTS_PAYABLE_SUBMIT_BILL_FOR_APPROVAL permission.
   *
   * Returns per-bill results indicating success or failure for each bill.
   */
  PartnerBulkSubmitBillsForApproval: BulkSubmitBillsForApprovalResponse
  PartnerBulkToggleArchiveCustomers: Scalars['String']['output']
  PartnerCancelBillSchedule: CancelBillScheduleResponse
  PartnerCancelCollection?: Maybe<Scalars['String']['output']>
  PartnerCancelScheduledPayment?: Maybe<Scalars['String']['output']>
  PartnerCancelSubscription?: Maybe<PartnerSubscription>
  PartnerCancelVendorPayment: CancelVendorPaymentResponse
  /**
   * Change the bank account that svc-accounts-payable debits to fund vendor
   * payments. Changes take effect immediately for all pending debits,
   * including bills already approved but not yet debited.
   *
   * Requires ACCOUNTS_PAYABLE_UPDATE_CONFIG permission.
   *
   * Returns the updated Accounts Payable configuration on success.
   */
  PartnerChangeAccountsPayableFundingAccount: AccountsPayableConfig
  /**
   * Change the vendor receiving method (ACH ↔ virtual card) for a funded,
   * not-yet-disbursed bill without re-charging the partner. The bill stays
   * BILL_PROCESSING. Eligibility/precondition failures are returned in-band on
   * the payload (success=false plus errorCode/errorMessage), not as GraphQL
   * errors. Delegates to svc-accounts-payable SwitchVendorPaymentMethod (AP-1582).
   */
  PartnerChangeBillReceivingMethod: ChangeBillReceivingMethodResult
  PartnerChangeBulkCustomerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeCustomPartnerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeCustomerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeCustomerPaymentConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeDefaultPayoutBankingAccount?: Maybe<Scalars['String']['output']>
  PartnerChangePartnerAutopayConfig?: Maybe<Scalars['String']['output']>
  PartnerChangePartnerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangePaymentConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeReferralPayoutBankingAccount?: Maybe<Scalars['String']['output']>
  PartnerCollectMandateConsent: Scalars['Boolean']['output']
  PartnerConfirmAssistantAction: Scalars['Boolean']['output']
  PartnerConfirmAssistantV2Action: Scalars['Boolean']['output']
  PartnerConnectWiseConnectionCreate?: Maybe<ConnectWiseQueryFilters>
  PartnerConnectWiseConnectionUpdate?: Maybe<Scalars['String']['output']>
  PartnerCreateApiKey?: Maybe<CreateApiKeyResponse>
  PartnerCreateAssistantConversation: AssistantConversation
  PartnerCreateAssistantV2Conversation: AssistantV2Conversation
  PartnerCreateAutopayRule?: Maybe<AutopayRule>
  /**
   * Creates a new bill for the authenticated partner.
   * Requires ACCOUNTS_PAYABLE_CREATE_BILL permission.
   *
   * Returns the ID of the newly created bill on success.
   * Validates all input fields including date formats, amount, and vendor existence.
   */
  PartnerCreateBill?: Maybe<AccountsPayableResponse>
  PartnerCreateCard?: Maybe<Scalars['String']['output']>
  /**
   * Mint a short-lived single-use token authorizing reveal of the bill's
   * virtual card details via the Evervault Relay. Partner must own the
   * bill and the card must be in a revealable state.
   */
  PartnerCreateCardRevealToken: CardRevealToken
  PartnerCreateClientTrendsPreset: ClientTrendsPreset
  PartnerCreateCollection?: Maybe<Scalars['String']['output']>
  PartnerCreateCompanyIndividualUploadLink?: Maybe<CompanyIndividualUploadLinkResponse>
  PartnerCreateCustomer?: Maybe<Customer>
  PartnerCreateCustomerCard?: Maybe<Scalars['String']['output']>
  PartnerCreateCustomerTag: Scalars['String']['output']
  PartnerCreateCustomerUser?: Maybe<CustomerUser>
  PartnerCreateEmailTemplate: EmailTemplate
  PartnerCreateFundingAttempts: CreateFundingAttemptsResponse
  PartnerCreateInvoiceReminder?: Maybe<InvoiceReminder>
  PartnerCreateInvoiceReminderExcludedCustomer?: Maybe<InvoiceReminderExcludedCustomer>
  PartnerCreateInvoiceSummary?: Maybe<InvoiceSummary>
  PartnerCreateInvoiceSummaryExcludedCustomer?: Maybe<InvoiceSummaryExcludedCustomer>
  PartnerCreateReferral: Scalars['String']['output']
  /** Create a new unit type for the authenticated partner. */
  PartnerCreateUnitType: UnitTypeResponse
  PartnerCreateUtilizationPreset: UtilizationPreset
  PartnerCreateVendor?: Maybe<AccountsPayableResponse>
  /**
   * Create a vendor data request. The `email` argument is the address the
   * request will be sent to; if omitted, falls back to the vendor's stored email.
   */
  PartnerCreateVendorDataRequest?: Maybe<AccountsPayableResponse>
  PartnerCreateVendorPaymentPreference?: Maybe<AccountsPayableResponse>
  PartnerDatagateConnectionCreate?: Maybe<Scalars['String']['output']>
  /**
   * Deactivate a vendor and move all its non-terminal bills back to draft status.
   * Requires ACCOUNTS_PAYABLE_CREATE_VENDOR permission.
   */
  PartnerDeactivateVendor: VendorActivationResponse
  PartnerDeleteAssistantConversation: Scalars['Boolean']['output']
  PartnerDeleteAssistantV2Conversation: Scalars['Boolean']['output']
  PartnerDeleteAutopayRule?: Maybe<Scalars['String']['output']>
  PartnerDeleteBills: DeleteBillsResponse
  PartnerDeleteCard?: Maybe<Scalars['String']['output']>
  PartnerDeleteClientTrendsPreset: Scalars['Boolean']['output']
  /**
   * Delete a single company document by ID.
   * Used during onboarding to remove incorrectly uploaded documents.
   */
  PartnerDeleteCompanyDocument: Scalars['Boolean']['output']
  /**
   * Delete all documents for a specific individual.
   * Used during onboarding to clear and re-upload all documents for an individual.
   */
  PartnerDeleteCompanyDocumentsByIndividualId: Scalars['Boolean']['output']
  PartnerDeleteCustomerCard?: Maybe<Scalars['String']['output']>
  PartnerDeleteCustomerTag: Scalars['String']['output']
  PartnerDeleteCustomerUser?: Maybe<Scalars['String']['output']>
  PartnerDeleteEmailTemplate: Scalars['String']['output']
  PartnerDeleteInvoiceReminder?: Maybe<Scalars['String']['output']>
  PartnerDeleteInvoiceReminderExcludedCustomer?: Maybe<
    Scalars['String']['output']
  >
  PartnerDeleteInvoiceSummary?: Maybe<Scalars['String']['output']>
  PartnerDeleteInvoiceSummaryExcludedCustomer?: Maybe<
    Scalars['String']['output']
  >
  /** Delete a routine the caller owns. Returns true on success. */
  PartnerDeleteRoutine: Scalars['Boolean']['output']
  PartnerDeleteScheduledOneOffEmail?: Maybe<Scalars['Boolean']['output']>
  /** Delete a unit type (soft delete). */
  PartnerDeleteUnitType: Scalars['Boolean']['output']
  PartnerDeleteUser?: Maybe<Scalars['String']['output']>
  PartnerDeleteUtilizationPreset: Scalars['Boolean']['output']
  /**
   * Dismiss a vendor similarity group so it no longer appears in deduplication suggestions.
   * Requires ACCOUNTS_PAYABLE_CREATE_VENDOR permission.
   */
  PartnerDismissVendorSimilarityGroup: Scalars['Boolean']['output']
  PartnerExportClientTrendsBreakdownCSV: Scalars['Boolean']['output']
  PartnerExportClientTrendsCSV: Scalars['Boolean']['output']
  PartnerExportUtilizationBreakdownCSV: Scalars['Boolean']['output']
  PartnerExportUtilizationCSV: Scalars['Boolean']['output']
  /**
   * Upload a bill document (PDF, PNG, JPG) and extract bill data via OCR.
   * Does NOT create a bill - returns only the extracted data for form pre-fill.
   */
  PartnerExtractBillData: ExtractBillDataPayload
  PartnerFinishOnboarding?: Maybe<Partner>
  PartnerHaloPSAConnectionCreate?: Maybe<PartnerHaloPsaConnectionCreateReply>
  PartnerHaloPSAConnectionQueryFiltersUpdate: PartnerHaloPsaConnectionQueryFiltersUpdateReply
  PartnerIntegrationDisconnect?: Maybe<Scalars['String']['output']>
  PartnerIntegrationSync?: Maybe<IntegrationSyncReply>
  PartnerInviteUser?: Maybe<PartnerUser>
  PartnerInvoiceArchive?: Maybe<Invoice>
  PartnerInvoiceBulkChargeOnDate?: Maybe<Scalars['String']['output']>
  PartnerInvoiceBulkChargeOnDueDate?: Maybe<Scalars['String']['output']>
  PartnerInvoiceCreate?: Maybe<Invoice>
  PartnerInvoicePaidUpdate?: Maybe<Invoice>
  PartnerInvoicePaidUpdateBypass?: Maybe<Invoice>
  PartnerInvoiceRemind?: Maybe<Scalars['String']['output']>
  PartnerInvoiceUnarchive?: Maybe<Invoice>
  PartnerJobQueueRetry: Scalars['Boolean']['output']
  PartnerJobRetry: Scalars['Boolean']['output']
  PartnerLinkPendingCustomerUser?: Maybe<PendingCustomerUser>
  PartnerMarkBillPaidExternally?: Maybe<AccountsPayableResponse>
  /**
   * Merge multiple vendors into a survivor vendor per group.
   * Accepts one or more merge groups, each specifying the vendor IDs to merge
   * and the survivor vendor ID that will remain active.
   */
  PartnerMergeVendors: MergeVendorsPayload
  /** @deprecated Deprecated: ModernBanc serialized token generation is no longer supported. Remove frontend callers. */
  PartnerModernBancGenerateSerializedToken?: Maybe<Scalars['String']['output']>
  PartnerPayInvoice?: Maybe<Scalars['String']['output']>
  PartnerPayOverdueInstallment?: Maybe<Scalars['String']['output']>
  PartnerPayoutTimingUpsertCompanyConfig?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksAccountUpdate?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksConnectionCreate?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksConnectionQueryFiltersUpdate?: Maybe<
    Scalars['String']['output']
  >
  PartnerQuickbooksConnectionUpdate?: Maybe<Scalars['String']['output']>
  /**
   * Reactivate a previously deactivated vendor and restore its draft bills.
   * Requires ACCOUNTS_PAYABLE_CREATE_VENDOR permission.
   */
  PartnerReactivateVendor: VendorActivationResponse
  PartnerRecurringPaymentCreate?: Maybe<RecurringPayment>
  PartnerRecurringPaymentDeactivate?: Maybe<Scalars['String']['output']>
  PartnerRecurringPaymentUpdate?: Maybe<Scalars['String']['output']>
  PartnerRefreshUnsyncedInvoices?: Maybe<Scalars['String']['output']>
  /**
   * Rejects a bill with an optional reason.
   * Requires ACCOUNTS_PAYABLE_REJECT_BILL permission.
   *
   * Returns the ID of the rejected bill on success.
   * Validates that the bill ID is a valid UUID, the bill exists, and belongs to the authenticated partner.
   * The reason parameter is optional and can be used to provide additional context for the rejection.
   */
  PartnerRejectBill?: Maybe<AccountsPayableResponse>
  PartnerRejectPendingCustomerUser?: Maybe<PendingCustomerUser>
  /** Renames a v2 conversation. The custom title overrides the auto-generated one and is never re-derived; empty/blank titles are rejected. Returns the updated conversation. */
  PartnerRenameAssistantV2Conversation: AssistantV2Conversation
  PartnerReschedulePayment?: Maybe<Scalars['String']['output']>
  PartnerResendVendorDataRequest?: Maybe<AccountsPayableResponse>
  PartnerResyncCustomerCreditMemoBalance: CustomerCreditMemoBalance
  PartnerRetryIntegrationIssue: Scalars['Boolean']['output']
  /** Retry a failed QBO payment sync. */
  PartnerRetryPaymentQboSync: QboPaymentSyncStatus
  /**
   * Reveal the virtual card issued for a bill. Returns Evervault ciphertext
   * tokens that the partner browser passes to Evervault Inputs iframes to
   * render the card — the gateway never sees plaintext PAN, CVV, or expiry.
   */
  PartnerRevealVirtualCard: RevealedVirtualCard
  PartnerRevertBillToDraft?: Maybe<AccountsPayableResponse>
  PartnerRevokeApiKey: Scalars['String']['output']
  /**
   * Enqueue an on-demand ("run now") execution of a routine the caller owns and
   * return the freshly-queued run. The run executes unattended; poll
   * PartnerGetRoutineRun / PartnerListRoutineRuns for its progress. Errors if a run
   * is already in progress or the routine is disabled.
   */
  PartnerRunRoutineNow: RoutineRun
  PartnerRutterAccountUnset?: Maybe<Scalars['String']['output']>
  PartnerRutterAccountUpsert?: Maybe<Scalars['String']['output']>
  PartnerRutterAccountUpsertMany?: Maybe<Scalars['String']['output']>
  PartnerRutterConnectionCreate?: Maybe<RutterConnection>
  PartnerRutterConnectionCreateDepositsUpdate?: Maybe<
    Scalars['String']['output']
  >
  PartnerRutterConnectionFiltersUpdate?: Maybe<Scalars['String']['output']>
  PartnerRutterConnectionUpdate?: Maybe<RutterConnection>
  PartnerSecondaryIntegrationDelete?: Maybe<Scalars['String']['output']>
  PartnerSendInvoiceReminderPreview?: Maybe<Scalars['String']['output']>
  PartnerSendInvoiceSummaryPreview?: Maybe<Scalars['String']['output']>
  PartnerSendOneOffEmail?: Maybe<Scalars['String']['output']>
  PartnerSendReferral: Scalars['String']['output']
  PartnerSendReport: Scalars['String']['output']
  PartnerSendScheduledOneOffEmailNow?: Maybe<Scalars['String']['output']>
  /**
   * Enable or disable an accounting provider integration for the authenticated partner.
   * Pass a provider value (e.g. QUICKBOOKS) to enable, or pass null to disable.
   * Requires ACCOUNTS_PAYABLE_UPDATE_CONFIG permission.
   *
   * Returns the updated Accounts Payable configuration on success.
   */
  PartnerSetAccountingIntegration: AccountsPayableConfig
  PartnerStartAccountsPayableOnboarding: StartAccountsPayableOnboardingReply
  /**
   * Submits a bill for approval, transitioning it from BILL_DRAFT to BILL_NEED_APPROVAL status.
   * Requires ACCOUNTS_PAYABLE_SUBMIT_BILL_FOR_APPROVAL permission.
   *
   * Returns the ID of the submitted bill on success.
   * Validates that the bill ID is a valid UUID, the bill exists, and belongs to the authenticated partner.
   * @deprecated Use PartnerBulkSubmitBillsForApproval instead
   */
  PartnerSubmitBillForApproval?: Maybe<AccountsPayableResponse>
  PartnerSuperopsConnectionCreate?: Maybe<Scalars['String']['output']>
  PartnerTagCustomer: Scalars['String']['output']
  PartnerToggleEmailTemplateFavorite: Scalars['String']['output']
  PartnerTogglePaymentsPortalCustomInvoices?: Maybe<Partner>
  PartnerToggleReminderEnabled?: Maybe<Scalars['String']['output']>
  PartnerToggleRequiresMFA?: Maybe<Partner>
  PartnerToggleSummaryEnabled?: Maybe<Scalars['String']['output']>
  PartnerUnarchiveCustomer?: Maybe<Customer>
  PartnerUnlinkPendingCustomerUser?: Maybe<PendingCustomerUser>
  PartnerUntagCustomer: Scalars['String']['output']
  /**
   * Update the Accounts Payable notification policy for the authenticated partner.
   * Requires ACCOUNTS_PAYABLE_UPDATE_CONFIG permission.
   *
   * Returns the updated notification policy settings on success.
   * Validates that all flags are provided and updates the partner's notification preferences.
   */
  PartnerUpdateAccountsPayableNotificationPolicy: AccountsPayableNotificationPolicy
  PartnerUpdateAddress?: Maybe<Partner>
  PartnerUpdateApiKey: Scalars['String']['output']
  PartnerUpdateAutopayRule?: Maybe<AutopayRule>
  PartnerUpdateBankAccount: Scalars['Boolean']['output']
  PartnerUpdateBankAccountCustomName?: Maybe<Scalars['String']['output']>
  PartnerUpdateBankAccountV2: Scalars['Boolean']['output']
  /**
   * Updates an existing bill for the authenticated partner.
   * Requires ACCOUNTS_PAYABLE_CREATE_BILL permission.
   *
   * Returns the ID of the updated bill on success.
   * Validates all input fields and ensures the bill exists and belongs to the partner.
   * Note: The vendor cannot be changed when updating a bill.
   */
  PartnerUpdateBill?: Maybe<AccountsPayableResponse>
  PartnerUpdateBillPayDate?: Maybe<AccountsPayableResponse>
  PartnerUpdateCard?: Maybe<Scalars['String']['output']>
  PartnerUpdateCardCustomName?: Maybe<Scalars['String']['output']>
  PartnerUpdateClientTrendsPreset: ClientTrendsPreset
  PartnerUpdateCreditMemoConfig: CreditMemoConfig
  PartnerUpdateCreditMemoConfigExceptions: CreditMemoConfig
  PartnerUpdateCustomer?: Maybe<Customer>
  PartnerUpdateCustomerTag: Scalars['String']['output']
  PartnerUpdateCustomerUser?: Maybe<CustomerUser>
  PartnerUpdateDetails?: Maybe<Partner>
  PartnerUpdateEmailTemplate: Scalars['String']['output']
  PartnerUpdateExpenseAccountVisibility: Array<ExpenseAccount>
  PartnerUpdateInvoicePdfSettings?: Maybe<Partner>
  PartnerUpdateInvoiceReminderExcludedCustomer?: Maybe<
    Array<Maybe<InvoiceReminderExcludedCustomer>>
  >
  PartnerUpdateInvoiceSummaryExcludedCustomer?: Maybe<
    Array<Maybe<InvoiceSummaryExcludedCustomer>>
  >
  PartnerUpdateMyUser?: Maybe<PartnerUser>
  PartnerUpdateName?: Maybe<Partner>
  PartnerUpdateNotificationsEnabled: NotificationsEnabled
  PartnerUpdatePaymentsPortalCustomization?: Maybe<Partner>
  PartnerUpdatePaymentsPortalMethods?: Maybe<Partner>
  PartnerUpdateReferral: Scalars['String']['output']
  PartnerUpdateReminder?: Maybe<Scalars['String']['output']>
  /** Update a routine the caller owns (partial). Powers the enabled toggle and the inline instruction edit. */
  PartnerUpdateRoutine: Routine
  PartnerUpdateScheduledOneOffEmail?: Maybe<ScheduledOneOffEmail>
  PartnerUpdateSummary?: Maybe<Scalars['String']['output']>
  PartnerUpdateTimezone?: Maybe<Partner>
  PartnerUpdateUser?: Maybe<PartnerUser>
  PartnerUpdateUtilizationPreset: UtilizationPreset
  PartnerUpdateVendor?: Maybe<AccountsPayableResponse>
  PartnerUpdateVendorPaymentPreference?: Maybe<UpdateVendorPaymentPreferenceResponse>
  /** Multipart upload onto a v2 conversation. The server enforces a 25 MB per-file cap and a content-type allowlist; rejections surface as GraphQL errors. */
  PartnerUploadAssistantV2File: AssistantV2File
  PartnerUploadBankAccountDocument: Scalars['Boolean']['output']
  /**
   * Upload a bill document (PDF, PNG, JPG) and extract bill data via OCR.
   * Creates a new bill with the extracted information.
   */
  PartnerUploadBillDocument: UploadBillDocumentPayload
  PartnerUploadDocumentByUploadLinkId: Scalars['String']['output']
  PartnerUpsertInvoicePreferences?: Maybe<Scalars['String']['output']>
  PartnerUpsertPassThroughFees?: Maybe<Scalars['String']['output']>
  /**
   * PUBLIC (unauthenticated) mutation. Mints and emails a 6-digit OTP bound
   * to the vendor session. Delegates 1:1 to the svc-accounts-payable
   * RequestVendorCardOTP RPC (AP-844); AP enforces the per-card ceiling +
   * backoff. All failure modes are mapped to an opaque gateway error.
   */
  RequestVendorCardOTP: RequestVendorCardOtpResponse
  /**
   * PUBLIC (unauthenticated) mutation. Returns Evervault ciphertext tokens
   * for the sensitive card fields plus plaintext metadata. Delegates 1:1 to
   * the svc-accounts-payable RevealVendorCardData RPC (AP-844). All failure
   * modes (invalid token, invalid OTP, expired session) are mapped to an
   * opaque gateway error so the cause is not leaked to the client.
   */
  RevealVendorCardData: RevealedVendorCard
  SetCustomerAutopayConfig?: Maybe<Scalars['Boolean']['output']>
  SolveAdyenRemediationActions: Scalars['String']['output']
  SolveRemediationActionsByIDs: Scalars['String']['output']
  StagingEnablePartnerPaymentsPortal?: Maybe<Partner>
  StagingStartAdyenOnboarding?: Maybe<StartAdyenOnboardingReply>
  SubmitVendorData: SubmitVendorDataResponse
  UpdateCompanyIndividual: Scalars['String']['output']
  UpdatePartnerReferralLink: Scalars['String']['output']
  UploadAdyenDocument: UploadAdyenDocumentResponse
  UploadPartnerDocument: Scalars['String']['output']
  UpsertSupportPreferences?: Maybe<SupportPreferences>
  cancelRefund: Scalars['Boolean']['output']
  createRefund: Scalars['Boolean']['output']
  explainIntegrationError: ExplainIntegrationErrorResponse
  explainIntegrationErrorFeedback: ExplainIntegrationErrorFeedbackResponse
  /**
   * Delete a vendor document (soft-delete).
   * Requires ACCOUNTS_PAYABLE_DELETE_VENDOR_DOCUMENT permission.
   */
  partnerDeleteVendorDocument: Scalars['Boolean']['output']
  /**
   * Upload a document for a vendor.
   * Document content must be base64-encoded.
   * Requires ACCOUNTS_PAYABLE_UPLOAD_VENDOR_DOCUMENT permission.
   */
  partnerUploadVendorDocument: PartnerUploadVendorDocumentPayload
  refreshIntegrationPermissions?: Maybe<RefreshIntegrationPermissionsReply>
}

export type MutationBnplOfferConfirmByTokenArgs = {
  confirmationToken: Scalars['String']['input']
}

export type MutationCreateCompanyIndividualArgs = {
  input: CreateCompanyIndividualInput
}

export type MutationDeleteCompanyIndividualArgs = {
  id: Scalars['ID']['input']
}

export type MutationOAuth2ExchangeArgs = {
  code: Scalars['String']['input']
  redirectUri?: InputMaybe<Scalars['String']['input']>
  state: Scalars['String']['input']
}

export type MutationOAuth2RefreshArgs = {
  refreshToken: Scalars['String']['input']
}

export type MutationPartnerAccountingPreferencesUpdateArgs = {
  input?: InputMaybe<AccountingPreferencesUpdateInput>
}

export type MutationPartnerAccountingSyncBatchCreateArgs = {
  input?: InputMaybe<AccountingSyncBatchCreateInput>
}

export type MutationPartnerAccountingSyncConfigCreateArgs = {
  input: SyncConfigCreateInput
}

export type MutationPartnerAccountingSyncConfigUpdateArgs = {
  input: SyncConfigUpdateInput
}

export type MutationPartnerAddBankAccountArgs = {
  input: AddBankAccountInput
}

export type MutationPartnerAddCustomerBankAccountArgs = {
  input: AddCustomerBankAccountInput
}

export type MutationPartnerAddCustomerManualBankingConnectionArgs = {
  accountInformation: ManualBankingAccountInformationInput
  customerID: Scalars['String']['input']
}

export type MutationPartnerAddManualBankingConnectionArgs = {
  accountInformation: ManualBankingAccountInformationInput
}

export type MutationPartnerAddManualBankingConnectionV2Args = {
  accountInformation: ManualBankingAccountInformationInput
}

export type MutationPartnerApprovePendingCustomerUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerArchiveAccountArgs = {
  accountID: Scalars['ID']['input']
}

export type MutationPartnerArchiveCustomerArgs = {
  input: PartnerArchiveCustomerInput
}

export type MutationPartnerArchiveCustomerAccountArgs = {
  accountID: Scalars['ID']['input']
  customerID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedCustomerCreateArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedCustomerDeleteArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedCustomerUpdateArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerAutopayExcludedInvoiceBatchCreateArgs = {
  excludeInvoices: Array<AutopayExcludedInvoiceCreateInput>
}

export type MutationPartnerAutopayExcludedInvoiceCreateArgs = {
  customerID: Scalars['ID']['input']
  invoiceID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedInvoiceDeleteArgs = {
  invoiceID: Scalars['ID']['input']
}

export type MutationPartnerAutotaskConnectionCreateArgs = {
  input?: InputMaybe<PartnerAutotaskConnectionCreateInput>
}

export type MutationPartnerAutotaskConnectionUpdateArgs = {
  input?: InputMaybe<PartnerAutotaskConnectionUpdateInput>
}

export type MutationPartnerBnplOfferConfirmArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerBatchDeactivateVendorsArgs = {
  vendorIDs: Array<Scalars['ID']['input']>
}

export type MutationPartnerBatchReactivateVendorsArgs = {
  vendorIDs: Array<Scalars['ID']['input']>
}

export type MutationPartnerBatchTagCustomersArgs = {
  customerIDs: Array<Scalars['ID']['input']>
  tagID: Scalars['ID']['input']
}

export type MutationPartnerBulkCancelBillScheduleArgs = {
  input: BulkCancelBillScheduleInput
}

export type MutationPartnerBulkCancelVendorPaymentsArgs = {
  input: BulkCancelVendorPaymentsInput
}

export type MutationPartnerBulkInvoiceRemindArgs = {
  invoiceIDs: Array<Scalars['String']['input']>
  templateID?: InputMaybe<Scalars['ID']['input']>
}

export type MutationPartnerBulkSubmitBillsForApprovalArgs = {
  billIDs: Array<Scalars['ID']['input']>
}

export type MutationPartnerBulkToggleArchiveCustomersArgs = {
  input: BulkToggleArchiveCustomersInput
}

export type MutationPartnerCancelBillScheduleArgs = {
  billID: Scalars['String']['input']
}

export type MutationPartnerCancelCollectionArgs = {
  collectionID: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type MutationPartnerCancelScheduledPaymentArgs = {
  paymentID: Scalars['UUID']['input']
}

export type MutationPartnerCancelSubscriptionArgs = {
  input: CancelSubscriptionInput
}

export type MutationPartnerCancelVendorPaymentArgs = {
  input: CancelVendorPaymentInput
}

export type MutationPartnerChangeAccountsPayableFundingAccountArgs = {
  input: PartnerAccountsPayableFundingAccountUpdateInput
}

export type MutationPartnerChangeBillReceivingMethodArgs = {
  input: ChangeBillReceivingMethodInput
}

export type MutationPartnerChangeBulkCustomerFeeConfigArgs = {
  customerFeeConfig: PartnerChangeBulkCustomerFeeConfigInput
}

export type MutationPartnerChangeCustomPartnerFeeConfigArgs = {
  customPartnerFeeConfig: CustomPartnerFeeConfigUpsertInput
}

export type MutationPartnerChangeCustomerFeeConfigArgs = {
  customerFeeConfig: PartnerChangeCustomerFeeConfigInput
}

export type MutationPartnerChangeCustomerPaymentConfigArgs = {
  customerID: Scalars['ID']['input']
  paymentConfig: PaymentCompanyConfigUpdateInput
}

export type MutationPartnerChangeDefaultPayoutBankingAccountArgs = {
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}

export type MutationPartnerChangePartnerAutopayConfigArgs = {
  partnerAutopayConfig: PartnerAutopayConfigUpdateInput
}

export type MutationPartnerChangePartnerFeeConfigArgs = {
  partnerFeeConfig: PartnerFeeConfigUpdateInput
}

export type MutationPartnerChangePaymentConfigArgs = {
  paymentConfig: PaymentCompanyConfigUpdateInput
}

export type MutationPartnerChangeReferralPayoutBankingAccountArgs = {
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}

export type MutationPartnerCollectMandateConsentArgs = {
  mandateConsentInput: CollectMandateConsentInput
}

export type MutationPartnerConfirmAssistantActionArgs = {
  confirmed: Scalars['Boolean']['input']
  token: Scalars['String']['input']
}

export type MutationPartnerConfirmAssistantV2ActionArgs = {
  confirmed: Scalars['Boolean']['input']
  token: Scalars['String']['input']
}

export type MutationPartnerConnectWiseConnectionCreateArgs = {
  input?: InputMaybe<PartnerConnectWiseConnectionCreateInput>
}

export type MutationPartnerConnectWiseConnectionUpdateArgs = {
  input?: InputMaybe<ConnectWiseQueryFiltersInput>
}

export type MutationPartnerCreateApiKeyArgs = {
  input: CreateApiKeyInput
}

export type MutationPartnerCreateAssistantConversationArgs = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerCreateAssistantV2ConversationArgs = {
  title?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerCreateAutopayRuleArgs = {
  input: PartnerCreateAutopayRuleInput
}

export type MutationPartnerCreateBillArgs = {
  billInput?: InputMaybe<CreateBill>
}

export type MutationPartnerCreateCardArgs = {
  input: CardCreationInput
}

export type MutationPartnerCreateCardRevealTokenArgs = {
  billID: Scalars['ID']['input']
}

export type MutationPartnerCreateClientTrendsPresetArgs = {
  input: CreateClientTrendsPresetInput
}

export type MutationPartnerCreateCollectionArgs = {
  createInput: CollectionCreateInput
}

export type MutationPartnerCreateCompanyIndividualUploadLinkArgs = {
  individualID: Scalars['ID']['input']
}

export type MutationPartnerCreateCustomerArgs = {
  input?: InputMaybe<PartnerCreateCustomerInput>
}

export type MutationPartnerCreateCustomerCardArgs = {
  customerID: Scalars['ID']['input']
  input: CardCreationInput
}

export type MutationPartnerCreateCustomerTagArgs = {
  input: PartnerCreateCustomerTagInput
}

export type MutationPartnerCreateCustomerUserArgs = {
  input?: InputMaybe<PartnerCreateCustomerUserInput>
}

export type MutationPartnerCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput
}

export type MutationPartnerCreateFundingAttemptsArgs = {
  input: CreateFundingAttemptsInput
}

export type MutationPartnerCreateInvoiceReminderArgs = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  daysOffset: Scalars['Int']['input']
  runsHourly?: InputMaybe<Scalars['Boolean']['input']>
  sentHour?: InputMaybe<Scalars['Int']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  templateID?: InputMaybe<Scalars['ID']['input']>
  timezone?: InputMaybe<Timezone>
  type: InvoiceReminderType
}

export type MutationPartnerCreateInvoiceReminderExcludedCustomerArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerCreateInvoiceSummaryArgs = {
  input?: InputMaybe<PartnerCreateInvoiceSummaryInput>
}

export type MutationPartnerCreateInvoiceSummaryExcludedCustomerArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerCreateReferralArgs = {
  input: CreateReferralInput
}

export type MutationPartnerCreateUnitTypeArgs = {
  input: CreateUnitTypeInput
}

export type MutationPartnerCreateUtilizationPresetArgs = {
  input: CreateUtilizationPresetInput
}

export type MutationPartnerCreateVendorArgs = {
  vendorInput?: InputMaybe<CreateVendor>
}

export type MutationPartnerCreateVendorDataRequestArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  vendorID: Scalars['String']['input']
}

export type MutationPartnerCreateVendorPaymentPreferenceArgs = {
  input?: InputMaybe<CreateVendorPaymentPreferenceInput>
}

export type MutationPartnerDatagateConnectionCreateArgs = {
  input?: InputMaybe<DatagateConnectionCreateInput>
}

export type MutationPartnerDeactivateVendorArgs = {
  vendorID: Scalars['ID']['input']
}

export type MutationPartnerDeleteAssistantConversationArgs = {
  conversationID: Scalars['ID']['input']
}

export type MutationPartnerDeleteAssistantV2ConversationArgs = {
  conversationID: Scalars['ID']['input']
}

export type MutationPartnerDeleteAutopayRuleArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteBillsArgs = {
  billIds: Array<Scalars['ID']['input']>
}

export type MutationPartnerDeleteCardArgs = {
  input: CardDeletionInput
}

export type MutationPartnerDeleteClientTrendsPresetArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteCompanyDocumentArgs = {
  documentId: Scalars['ID']['input']
}

export type MutationPartnerDeleteCompanyDocumentsByIndividualIdArgs = {
  individualId: Scalars['ID']['input']
}

export type MutationPartnerDeleteCustomerCardArgs = {
  customerID: Scalars['ID']['input']
  input: CardDeletionInput
}

export type MutationPartnerDeleteCustomerTagArgs = {
  ID: Scalars['ID']['input']
}

export type MutationPartnerDeleteCustomerUserArgs = {
  id: Scalars['String']['input']
}

export type MutationPartnerDeleteEmailTemplateArgs = {
  input: DeleteEmailTemplateInput
}

export type MutationPartnerDeleteInvoiceReminderArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteInvoiceReminderExcludedCustomerArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteInvoiceSummaryArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteInvoiceSummaryExcludedCustomerArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteRoutineArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteScheduledOneOffEmailArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteUnitTypeArgs = {
  unitTypeId: Scalars['ID']['input']
}

export type MutationPartnerDeleteUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteUtilizationPresetArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDismissVendorSimilarityGroupArgs = {
  groupId: Scalars['ID']['input']
}

export type MutationPartnerExportClientTrendsBreakdownCsvArgs = {
  input: ExportClientTrendsBreakdownCsvInput
}

export type MutationPartnerExportClientTrendsCsvArgs = {
  input: ExportClientTrendsCsvInput
}

export type MutationPartnerExportUtilizationBreakdownCsvArgs = {
  input: ExportUtilizationBreakdownCsvInput
}

export type MutationPartnerExportUtilizationCsvArgs = {
  input: ExportUtilizationCsvInput
}

export type MutationPartnerExtractBillDataArgs = {
  input: ExtractBillDataInput
}

export type MutationPartnerHaloPsaConnectionCreateArgs = {
  input?: InputMaybe<PartnerHaloPsaConnectionCreateInput>
}

export type MutationPartnerHaloPsaConnectionQueryFiltersUpdateArgs = {
  input: HaloPsaConnectionQueryFiltersInput
}

export type MutationPartnerIntegrationDisconnectArgs = {
  input?: InputMaybe<IntegrationDisconnectInput>
}

export type MutationPartnerIntegrationSyncArgs = {
  input?: InputMaybe<IntegrationSyncInput>
}

export type MutationPartnerInviteUserArgs = {
  input?: InputMaybe<PartnerInviteUserInput>
}

export type MutationPartnerInvoiceArchiveArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerInvoiceBulkChargeOnDateArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>
  paymentDate?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerInvoiceBulkChargeOnDueDateArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerInvoiceCreateArgs = {
  input?: InputMaybe<InvoiceInput>
}

export type MutationPartnerInvoicePaidUpdateArgs = {
  input?: InputMaybe<PartnerInvoicePaidUpdateInput>
}

export type MutationPartnerInvoicePaidUpdateBypassArgs = {
  input: PartnerInvoicePaidUpdateBypassInput
}

export type MutationPartnerInvoiceRemindArgs = {
  invoiceID: Scalars['String']['input']
}

export type MutationPartnerInvoiceUnarchiveArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerJobQueueRetryArgs = {
  input: JobQueueRetry
}

export type MutationPartnerJobRetryArgs = {
  input: JobRetry
}

export type MutationPartnerLinkPendingCustomerUserArgs = {
  customerId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationPartnerMarkBillPaidExternallyArgs = {
  billID: Scalars['String']['input']
}

export type MutationPartnerMergeVendorsArgs = {
  input: MergeVendorsInput
}

export type MutationPartnerModernBancGenerateSerializedTokenArgs = {
  input: CardSerializationInput
}

export type MutationPartnerPayInvoiceArgs = {
  amount: Scalars['Float']['input']
  customerID: Scalars['String']['input']
  idempotencyKey?: InputMaybe<Scalars['String']['input']>
  invoiceID: Scalars['String']['input']
  paymentDate?: InputMaybe<Scalars['String']['input']>
  paymentMethod: PayInvoicePaymentMethodInput
}

export type MutationPartnerPayOverdueInstallmentArgs = {
  installmentID: Scalars['String']['input']
  newPaymentMethod?: InputMaybe<LendingPaymentMethodInput>
  retryLastPaymentMethod: Scalars['Boolean']['input']
}

export type MutationPartnerPayoutTimingUpsertCompanyConfigArgs = {
  planId: Scalars['ID']['input']
}

export type MutationPartnerQuickbooksAccountUpdateArgs = {
  input?: InputMaybe<QuickbooksAccountUpdateInput>
}

export type MutationPartnerQuickbooksConnectionCreateArgs = {
  code: Scalars['String']['input']
  currency: Currency
  integrationType: IntegrationType
  realmId: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationPartnerQuickbooksConnectionQueryFiltersUpdateArgs = {
  input: QuickbooksConnectionQueryFiltersInput
}

export type MutationPartnerQuickbooksConnectionUpdateArgs = {
  autoSyncVendors?: InputMaybe<Scalars['Boolean']['input']>
  createDeposits?: InputMaybe<Scalars['Boolean']['input']>
  pushBillPaymentStatus?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPartnerReactivateVendorArgs = {
  vendorID: Scalars['ID']['input']
}

export type MutationPartnerRecurringPaymentCreateArgs = {
  input: RecurringPaymentCreateInput
}

export type MutationPartnerRecurringPaymentDeactivateArgs = {
  input: RecurringPaymentDeactivateInput
}

export type MutationPartnerRecurringPaymentUpdateArgs = {
  input: RecurringPaymentUpdateInput
}

export type MutationPartnerRefreshUnsyncedInvoicesArgs = {
  platformName: PlatformName
}

export type MutationPartnerRejectBillArgs = {
  billID: Scalars['String']['input']
  reason?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerRejectPendingCustomerUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerRenameAssistantV2ConversationArgs = {
  conversationID: Scalars['ID']['input']
  title: Scalars['String']['input']
}

export type MutationPartnerReschedulePaymentArgs = {
  newDueDate: Scalars['Time']['input']
  paymentID: Scalars['UUID']['input']
}

export type MutationPartnerResendVendorDataRequestArgs = {
  id: Scalars['String']['input']
}

export type MutationPartnerResyncCustomerCreditMemoBalanceArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerRetryIntegrationIssueArgs = {
  input: RetryIntegrationIssueInput
}

export type MutationPartnerRetryPaymentQboSyncArgs = {
  vendorPaymentId: Scalars['ID']['input']
}

export type MutationPartnerRevealVirtualCardArgs = {
  billID: Scalars['ID']['input']
}

export type MutationPartnerRevertBillToDraftArgs = {
  billID: Scalars['String']['input']
}

export type MutationPartnerRevokeApiKeyArgs = {
  keyID: Scalars['String']['input']
}

export type MutationPartnerRunRoutineNowArgs = {
  routineID: Scalars['ID']['input']
}

export type MutationPartnerRutterAccountUnsetArgs = {
  input?: InputMaybe<RutterAccountUnsetInput>
}

export type MutationPartnerRutterAccountUpsertArgs = {
  input?: InputMaybe<RutterAccountUpsertInput>
}

export type MutationPartnerRutterAccountUpsertManyArgs = {
  input?: InputMaybe<RutterAccountUpsertManyInput>
}

export type MutationPartnerRutterConnectionCreateArgs = {
  input?: InputMaybe<ConnectionCreateInput>
}

export type MutationPartnerRutterConnectionCreateDepositsUpdateArgs = {
  input?: InputMaybe<RutterConnectionCreateDepositsUpdateInput>
}

export type MutationPartnerRutterConnectionFiltersUpdateArgs = {
  input?: InputMaybe<RutterConnectionFiltersUpdateInput>
}

export type MutationPartnerRutterConnectionUpdateArgs = {
  input?: InputMaybe<ConnectionUpdateInput>
}

export type MutationPartnerSecondaryIntegrationDeleteArgs = {
  input: SecondaryIntegrationDeleteInput
}

export type MutationPartnerSendInvoiceReminderPreviewArgs = {
  input?: InputMaybe<InvoiceReminderPreviewInput>
}

export type MutationPartnerSendInvoiceSummaryPreviewArgs = {
  input?: InputMaybe<InvoiceSummaryPreviewInput>
}

export type MutationPartnerSendOneOffEmailArgs = {
  input: SendOneOffEmailInput
}

export type MutationPartnerSendReferralArgs = {
  input: SendPartnerReferralInput
}

export type MutationPartnerSendReportArgs = {
  amountMax?: InputMaybe<Scalars['Float']['input']>
  amountMin?: InputMaybe<Scalars['Float']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  format?: InputMaybe<ReportFormat>
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>
  lastNotificationEnd?: InputMaybe<Scalars['String']['input']>
  lastNotificationStart?: InputMaybe<Scalars['String']['input']>
  recurringFrequency?: InputMaybe<ArRecurringInvoiceFrequency>
  recurringPaymentID?: InputMaybe<Scalars['ID']['input']>
  reportType: ReportType
  searchTerm?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<InvoiceStatusEnum>>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerSendScheduledOneOffEmailNowArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerSetAccountingIntegrationArgs = {
  provider?: InputMaybe<AccountingProvider>
}

export type MutationPartnerSubmitBillForApprovalArgs = {
  billID: Scalars['String']['input']
}

export type MutationPartnerSuperopsConnectionCreateArgs = {
  input?: InputMaybe<SuperopsConnectionCreateInput>
}

export type MutationPartnerTagCustomerArgs = {
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}

export type MutationPartnerToggleEmailTemplateFavoriteArgs = {
  templateID: Scalars['ID']['input']
}

export type MutationPartnerTogglePaymentsPortalCustomInvoicesArgs = {
  paymentsPortalCustomInvoices: Scalars['Boolean']['input']
}

export type MutationPartnerToggleReminderEnabledArgs = {
  enabled: Scalars['Boolean']['input']
  reminderID: Scalars['ID']['input']
}

export type MutationPartnerToggleRequiresMfaArgs = {
  requiresMFA: Scalars['Boolean']['input']
}

export type MutationPartnerToggleSummaryEnabledArgs = {
  enabled: Scalars['Boolean']['input']
  summaryID: Scalars['ID']['input']
}

export type MutationPartnerUnarchiveCustomerArgs = {
  input: PartnerUnarchiveCustomerInput
}

export type MutationPartnerUnlinkPendingCustomerUserArgs = {
  customerId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationPartnerUntagCustomerArgs = {
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}

export type MutationPartnerUpdateAccountsPayableNotificationPolicyArgs = {
  input: UpdateAccountsPayableNotificationPolicyInput
}

export type MutationPartnerUpdateAddressArgs = {
  input?: InputMaybe<PartnerUpdateAddressInput>
}

export type MutationPartnerUpdateApiKeyArgs = {
  input: UpdateApiKeyInput
}

export type MutationPartnerUpdateAutopayRuleArgs = {
  input: PartnerUpdateAutopayRuleInput
}

export type MutationPartnerUpdateBankAccountArgs = {
  input: UpdateBankAccountInput
}

export type MutationPartnerUpdateBankAccountCustomNameArgs = {
  input: BankAccountCustomNameUpdateInput
}

export type MutationPartnerUpdateBankAccountV2Args = {
  input: UpdateBankAccountV2Input
}

export type MutationPartnerUpdateBillArgs = {
  billInput?: InputMaybe<UpdateBill>
}

export type MutationPartnerUpdateBillPayDateArgs = {
  input: UpdateBillPayDateInput
}

export type MutationPartnerUpdateCardArgs = {
  input: CardUpdateInput
}

export type MutationPartnerUpdateCardCustomNameArgs = {
  input: CardCustomNameUpdateInput
}

export type MutationPartnerUpdateClientTrendsPresetArgs = {
  input: UpdateClientTrendsPresetInput
}

export type MutationPartnerUpdateCreditMemoConfigArgs = {
  input: UpdateCreditMemoConfigInput
}

export type MutationPartnerUpdateCreditMemoConfigExceptionsArgs = {
  input: UpdateCreditMemoConfigExceptionsInput
}

export type MutationPartnerUpdateCustomerArgs = {
  input?: InputMaybe<PartnerUpdateCustomerInput>
}

export type MutationPartnerUpdateCustomerTagArgs = {
  input: PartnerUpdateCustomerTagInput
}

export type MutationPartnerUpdateCustomerUserArgs = {
  input?: InputMaybe<PartnerUpdateCustomerUserInput>
}

export type MutationPartnerUpdateDetailsArgs = {
  input?: InputMaybe<PartnerUpdateDetailsInput>
}

export type MutationPartnerUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput
}

export type MutationPartnerUpdateExpenseAccountVisibilityArgs = {
  accountIds: Array<Scalars['ID']['input']>
  visible: Scalars['Boolean']['input']
}

export type MutationPartnerUpdateInvoicePdfSettingsArgs = {
  input: PartnerUpdateInvoicePdfSettingsInput
}

export type MutationPartnerUpdateInvoiceReminderExcludedCustomerArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerUpdateInvoiceSummaryExcludedCustomerArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerUpdateMyUserArgs = {
  input?: InputMaybe<PartnerUpdateMyUserInput>
}

export type MutationPartnerUpdateNameArgs = {
  input: UpdatePartnerNameInput
}

export type MutationPartnerUpdateNotificationsEnabledArgs = {
  notificationsEnabled: Scalars['Boolean']['input']
}

export type MutationPartnerUpdatePaymentsPortalCustomizationArgs = {
  input?: InputMaybe<PartnerPaymentsPortalCustomizationInput>
}

export type MutationPartnerUpdatePaymentsPortalMethodsArgs = {
  methods: Array<PartnerPaymentsPortalMethod>
}

export type MutationPartnerUpdateReferralArgs = {
  input: UpdateReferralInput
}

export type MutationPartnerUpdateReminderArgs = {
  input?: InputMaybe<UpdateInvoiceReminderInput>
}

export type MutationPartnerUpdateRoutineArgs = {
  input: PartnerUpdateRoutineInput
}

export type MutationPartnerUpdateScheduledOneOffEmailArgs = {
  input: UpdateScheduledOneOffEmailInput
}

export type MutationPartnerUpdateSummaryArgs = {
  input?: InputMaybe<UpdateInvoiceSummaryInput>
}

export type MutationPartnerUpdateTimezoneArgs = {
  input?: InputMaybe<PartnerUpdateTimezoneInput>
}

export type MutationPartnerUpdateUserArgs = {
  input?: InputMaybe<PartnerUpdateUserInput>
}

export type MutationPartnerUpdateUtilizationPresetArgs = {
  input: UpdateUtilizationPresetInput
}

export type MutationPartnerUpdateVendorArgs = {
  vendorInput?: InputMaybe<UpdateVendor>
}

export type MutationPartnerUpdateVendorPaymentPreferenceArgs = {
  input?: InputMaybe<UpdateVendorPaymentPreferenceInput>
}

export type MutationPartnerUploadAssistantV2FileArgs = {
  conversationID: Scalars['ID']['input']
  file: Scalars['Upload']['input']
}

export type MutationPartnerUploadBankAccountDocumentArgs = {
  input: UploadBankAccountDocumentInput
}

export type MutationPartnerUploadBillDocumentArgs = {
  input: UploadBillDocumentInput
}

export type MutationPartnerUploadDocumentByUploadLinkIdArgs = {
  input: UploadPartnerDocumentByUploadLinkInput
}

export type MutationPartnerUpsertInvoicePreferencesArgs = {
  input?: InputMaybe<UpsertInvoicePreferencesInput>
}

export type MutationPartnerUpsertPassThroughFeesArgs = {
  input: PartnerUpsertPassThroughFeesInput
}

export type MutationRequestVendorCardOtpArgs = {
  token: Scalars['String']['input']
  vendorEmail: Scalars['String']['input']
}

export type MutationRevealVendorCardDataArgs = {
  otpCode: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type MutationSetCustomerAutopayConfigArgs = {
  input: UpsertCustomerAutopayConfigInput
}

export type MutationSolveRemediationActionsByIDsArgs = {
  actionIDs: Array<Scalars['String']['input']>
}

export type MutationStagingEnablePartnerPaymentsPortalArgs = {
  url: Scalars['String']['input']
}

export type MutationSubmitVendorDataArgs = {
  input: SubmitVendorDataInput
}

export type MutationUpdateCompanyIndividualArgs = {
  input: UpdateCompanyIndividualInput
}

export type MutationUpdatePartnerReferralLinkArgs = {
  input: UpdateReferralLinkInput
}

export type MutationUploadAdyenDocumentArgs = {
  document: UploadAdyenDocumentInput
}

export type MutationUploadPartnerDocumentArgs = {
  input: UploadPartnerDocumentInput
}

export type MutationUpsertSupportPreferencesArgs = {
  input: UpsertSupportPreferencesInput
}

export type MutationCancelRefundArgs = {
  refundID: Scalars['ID']['input']
}

export type MutationCreateRefundArgs = {
  input: RefundCreateInput
}

export type MutationExplainIntegrationErrorArgs = {
  input: ExplainIntegrationErrorInput
}

export type MutationExplainIntegrationErrorFeedbackArgs = {
  input: ExplainIntegrationErrorFeedbackInput
}

export type MutationPartnerDeleteVendorDocumentArgs = {
  input: DeleteVendorDocumentInput
}

export type MutationPartnerUploadVendorDocumentArgs = {
  input: PartnerUploadVendorDocumentInput
}

export type MutationRefreshIntegrationPermissionsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>
  integration: Scalars['String']['input']
}

export type NotificationsEnabled = {
  __typename: 'NotificationsEnabled'
  id: Scalars['ID']['output']
  notificationsEnabled: Scalars['Boolean']['output']
}

export type NumberOfOverdueInvoicesThirtyDaysResponse = {
  __typename: 'NumberOfOverdueInvoicesThirtyDaysResponse'
  value: Scalars['Int']['output']
}

export type NumberOfPaymentsResponse = {
  __typename: 'NumberOfPaymentsResponse'
  value: Scalars['Int']['output']
}

export type Offer = {
  __typename: 'Offer'
  accepted: Scalars['Boolean']['output']
  acceptedAmount?: Maybe<Scalars['Float']['output']>
  acceptedRate?: Maybe<Scalars['Float']['output']>
  acceptedTerm?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  lending?: Maybe<Lending>
  maxAmount: Scalars['Float']['output']
  maxRate: Scalars['Float']['output']
  maxTerm: Scalars['Int']['output']
  minAmount: Scalars['Float']['output']
  minRate: Scalars['Float']['output']
  minTerm: Scalars['Int']['output']
  status: OfferStatus
}

export enum OfferPayoutMethodEnum {
  Manual = 'MANUAL'
}

export enum OfferStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Review = 'REVIEW'
}

export enum OnApproveBehavior {
  OnApproveBehaviorSetAsDefaultAutomatic = 'ON_APPROVE_BEHAVIOR_SET_AS_DEFAULT_AUTOMATIC',
  OnApproveBehaviorUnspecified = 'ON_APPROVE_BEHAVIOR_UNSPECIFIED'
}

export type OneTimePayment = {
  __typename: 'OneTimePayment'
  baseAmount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  currency: Scalars['String']['output']
  expiresAt?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  partner?: Maybe<Partner>
  redirectUrl?: Maybe<Scalars['String']['output']>
  referenceId?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
}

export type OpenPayout = {
  __typename: 'OpenPayout'
  amount: Decimal
  id: Scalars['ID']['output']
  netAmount: Decimal
  numberOfPayments: Scalars['Int']['output']
  payoutWindowDate: Scalars['Time']['output']
  productID?: Maybe<Scalars['String']['output']>
  transactionNetwork: Scalars['String']['output']
}

export type OpenPayoutBalanceTotals = {
  __typename: 'OpenPayoutBalanceTotals'
  available: Decimal
  pending: Decimal
  total: Decimal
}

export type OpenPayoutBreakdownItem = {
  __typename: 'OpenPayoutBreakdownItem'
  companyType: CompanyType
  createdAt: Scalars['Time']['output']
  customer?: Maybe<Customer>
  fee: Decimal
  grossAmount: Decimal
  id: Scalars['ID']['output']
  partner?: Maybe<Partner>
  paymentMethod?: Maybe<PaymentMethodEntity>
  product?: Maybe<Product>
  transaction?: Maybe<Transaction>
  transactionDate?: Maybe<Scalars['Time']['output']>
  transactionType: BreakdownProductType
}

export type OpenPayoutBreakdownItemConnection = {
  __typename: 'OpenPayoutBreakdownItemConnection'
  edges?: Maybe<Array<Maybe<OpenPayoutBreakdownItemEdge>>>
  pageInfo: PageInfo
}

export type OpenPayoutBreakdownItemEdge = {
  __typename: 'OpenPayoutBreakdownItemEdge'
  cursor: Scalars['String']['output']
  node: OpenPayoutBreakdownItem
}

export type OpenPayoutBreakdownTotals = {
  __typename: 'OpenPayoutBreakdownTotals'
  acceleratedPayoutCapFee: Decimal
  feesGreaterThanZeroCount: Scalars['Int']['output']
  productType: BreakdownProductType
  productTypeCount: Scalars['Int']['output']
  sumAcceleratedPayoutFees: Decimal
  sumFees: Decimal
  sumGrossAmount: Decimal
}

export type OpenPayoutConnection = {
  __typename: 'OpenPayoutConnection'
  edges?: Maybe<Array<Maybe<OpenPayoutEdge>>>
  pageInfo: PageInfo
}

export type OpenPayoutDetails = {
  __typename: 'OpenPayoutDetails'
  amount: Decimal
  breakdownTotals: Array<Maybe<OpenPayoutBreakdownTotals>>
  fees: Array<Maybe<OpenPayoutFee>>
  id: Scalars['ID']['output']
  netAmount: Decimal
  payoutWindowDate: Scalars['Time']['output']
}

export type OpenPayoutEdge = {
  __typename: 'OpenPayoutEdge'
  cursor: Scalars['String']['output']
  node: OpenPayout
}

export type OpenPayoutFee = {
  __typename: 'OpenPayoutFee'
  amount: Decimal
  description: Scalars['String']['output']
  forwarded: Scalars['Boolean']['output']
  label: Scalars['String']['output']
}

export type OpenPayoutFilters = {
  amountFrom?: InputMaybe<DecimalInput>
  amountTo?: InputMaybe<DecimalInput>
  customerID?: InputMaybe<Scalars['ID']['input']>
  dateFrom?: InputMaybe<Scalars['Time']['input']>
  dateTo?: InputMaybe<Scalars['Time']['input']>
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

export type OverdueInvoiceCountResponse = {
  __typename: 'OverdueInvoiceCountResponse'
  value: Scalars['Int']['output']
}

export type OverdueInvoicePercentageResponse = {
  __typename: 'OverdueInvoicePercentageResponse'
  value: Scalars['Float']['output']
}

export type OverdueInvoiceVolumeResponse = {
  __typename: 'OverdueInvoiceVolumeResponse'
  value: Scalars['Float']['output']
}

export type OverdueInvoicesVolumeThirtyDaysResponse = {
  __typename: 'OverdueInvoicesVolumeThirtyDaysResponse'
  value: Scalars['Float']['output']
}

export type OverdueRateAtMaturityResponse = {
  __typename: 'OverdueRateAtMaturityResponse'
  /** Number of invoices in the period that reached the maturity horizon (the cohort denominator). 0 means the period has not matured yet — callers should render no-data rather than treating value as a real 0%. */
  maturedCount: Scalars['Int']['output']
  /** Share (0-100) of the matured invoice cohort that was still unpaid at the maturity horizon. */
  value: Scalars['Float']['output']
}

export type OverviewEfficiencyResult = {
  __typename: 'OverviewEfficiencyResult'
  laborEfficiencyRatio: OverviewKpi
  ticketLoad: OverviewKpi
  utilization: OverviewKpi
}

export type OverviewKpi = {
  __typename: 'OverviewKPI'
  benchmark?: Maybe<Scalars['Float']['output']>
  benchmarkDeltaPp?: Maybe<Scalars['Float']['output']>
  change: Scalars['Float']['output']
  value: Scalars['Float']['output']
}

export type OverviewMrrResult = {
  __typename: 'OverviewMRRResult'
  currentMrr: Scalars['Float']['output']
  gainedMrr: Scalars['Float']['output']
  lostMrr: Scalars['Float']['output']
  netMrrChange: Scalars['Float']['output']
  trend: Array<OverviewMrrTrendMonth>
}

export type OverviewMrrTrendMonth = {
  __typename: 'OverviewMRRTrendMonth'
  benchmark?: Maybe<Scalars['Float']['output']>
  gainedMrr: Scalars['Float']['output']
  lostMrr: Scalars['Float']['output']
  month: Scalars['String']['output']
  mrr: Scalars['Float']['output']
  netChange: Scalars['Float']['output']
}

export type OverviewProfitabilityMonth = {
  __typename: 'OverviewProfitabilityMonth'
  benchmark?: Maybe<Scalars['Float']['output']>
  month: Scalars['String']['output']
  profit: Scalars['Float']['output']
  revenue: Scalars['Float']['output']
}

export type OverviewProfitabilityResult = {
  __typename: 'OverviewProfitabilityResult'
  months: Array<OverviewProfitabilityMonth>
  totalProfit: Scalars['Float']['output']
  totalRevenue: Scalars['Float']['output']
}

export type OverviewSummaryResult = {
  __typename: 'OverviewSummaryResult'
  grossRevenue: OverviewKpi
  netProfit: OverviewKpi
}

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>
}

export type Pagination = {
  limit?: Scalars['Int']['input']
  page?: Scalars['Int']['input']
}

export type Partner = AddressInterface & {
  __typename: 'Partner'
  adyenBusinessSetup?: Maybe<AdyenBusinessSetup>
  adyenCompanyType?: Maybe<AdyenCompanyType>
  adyenIndustryCode?: Maybe<Scalars['String']['output']>
  adyenOnboardingStatus: AdyenOnboardingStatusStep
  allowAdminOpenInvoices?: Maybe<Scalars['Boolean']['output']>
  attachInvoicePDFEnabled?: Maybe<Scalars['Boolean']['output']>
  blockGoingLive: Scalars['Boolean']['output']
  city?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  currency: Currency
  description?: Maybe<Scalars['String']['output']>
  detailedSubscription?: Maybe<PartnerDetailedSubscription>
  ein?: Maybe<Scalars['String']['output']>
  hasBankStatementUploaded: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  incorporationNumber?: Maybe<Scalars['String']['output']>
  industry?: Maybe<Scalars['String']['output']>
  insightsEnabled: Scalars['Boolean']['output']
  isDeactivated: Scalars['Boolean']['output']
  isOnboarded: Scalars['Boolean']['output']
  isValidToOnboarding: Scalars['Boolean']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  paymentsPortalCustomInvoices?: Maybe<Scalars['Boolean']['output']>
  paymentsPortalCustomUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalCustomization: PartnerPaymentsPortalCustomization
  paymentsPortalDefaultUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalEnabled: Scalars['Boolean']['output']
  paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  paymentsPortalUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalUseCustomUrl?: Maybe<Scalars['Boolean']['output']>
  pdfFallbackEnabled?: Maybe<Scalars['Boolean']['output']>
  phone?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  requiresMFA: Scalars['Boolean']['output']
  state?: Maybe<Scalars['String']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
  timezone?: Maybe<Timezone>
  timezoneSetAt?: Maybe<Scalars['String']['output']>
  tosAndPciAccepted: Scalars['Boolean']['output']
  useUserLocalTimezone?: Maybe<Scalars['Boolean']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export type PartnerAccountsPayableFundingAccountUpdateInput = {
  accountID: Scalars['ID']['input']
}

export type PartnerArchiveCustomerInput = {
  id: Scalars['ID']['input']
}

export type PartnerAutopayConfig = {
  __typename: 'PartnerAutopayConfig'
  allowCustomerEdit?: Maybe<Scalars['Boolean']['output']>
  customerPaymentFailureLimit?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  partner: Partner
}

export type PartnerAutopayConfigUpdateInput = {
  allowCustomerEdit?: InputMaybe<Scalars['Boolean']['input']>
  customerPaymentFailureLimit?: InputMaybe<Scalars['Int']['input']>
}

export type PartnerAutotaskConnectionCreateInput = {
  currency: Currency
  email: Scalars['String']['input']
  integrationType: IntegrationType
  invoiceNumberField: AutotaskInvoiceNumberField
  secret: Scalars['String']['input']
  username: Scalars['String']['input']
}

export type PartnerAutotaskConnectionUpdateInput = {
  companyClassifications?: InputMaybe<Array<InputMaybe<AutotaskFilterInput>>>
  companyTerritoryIDs?: InputMaybe<Array<InputMaybe<AutotaskFilterInput>>>
  companyTypes?: InputMaybe<Array<InputMaybe<AutotaskFilterInput>>>
  companyUserDefinedFields?: InputMaybe<
    Array<InputMaybe<AutotaskUserDefinedFieldInput>>
  >
  contactUserDefinedFields?: InputMaybe<
    Array<InputMaybe<AutotaskUserDefinedFieldInput>>
  >
  invoiceCreatedSince?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCardFeeDetail = {
  __typename: 'PartnerCardFeeDetail'
  cardNetwork: CardNetwork
  percentage: Scalars['Float']['output']
}

export type PartnerChangeBulkCustomerFeeConfigInput = {
  customerIDs: Array<Scalars['UUID']['input']>
  feeType: FeeExceptionType
}

export type PartnerChangeCustomerFeeConfigInput = {
  action: CustomerFeeConfigAction
  customerID?: InputMaybe<Scalars['UUID']['input']>
  feeType?: InputMaybe<FeeExceptionType>
  id?: InputMaybe<Scalars['UUID']['input']>
}

export type PartnerCompanyConfigUpdateInput = {
  invoicePayoutMethod?: InputMaybe<InvoicePayoutMethodEnum>
  offerPayoutMethod?: InputMaybe<OfferPayoutMethodEnum>
  referralPayoutMethod?: InputMaybe<ReferralPayoutMethodEnum>
}

export type PartnerConnectWiseConnectionCreateInput = {
  CompanyID: Scalars['String']['input']
  Currency: Currency
  IntegrationType: IntegrationType
  PrivateKey: Scalars['String']['input']
  PublicKey: Scalars['String']['input']
  SiteURL?: InputMaybe<Scalars['String']['input']>
}

export type PartnerConnection = {
  __typename: 'PartnerConnection'
  edges?: Maybe<Array<Maybe<PartnerEdge>>>
  pageInfo: PageInfo
}

export type PartnerCoverFeeConfigInput = {
  coverACHMethodFee?: InputMaybe<Scalars['Boolean']['input']>
  coverCardMethodFee?: InputMaybe<Scalars['Boolean']['input']>
  coverOtherMethodFee?: InputMaybe<Scalars['Boolean']['input']>
  coverWireMethodFee?: InputMaybe<Scalars['Boolean']['input']>
}

export type PartnerCreateAutopayRuleInput = {
  agreementTypeIDs?: InputMaybe<AgreementTypeInput>
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  billingTermsIDs?: InputMaybe<BillingTermsInput>
  contractNames?: InputMaybe<ContractNamesInput>
  customMethods?: InputMaybe<Array<InputMaybe<AutopayCustomMethodInput>>>
  customerIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  daysBeforeDue?: InputMaybe<Scalars['Int']['input']>
  daysPastCreation?: InputMaybe<Scalars['Int']['input']>
  daysPastDue?: InputMaybe<Scalars['Int']['input']>
  lastDayOfMonth?: InputMaybe<Scalars['Boolean']['input']>
  recurringInvoices?: InputMaybe<RecurringInvoicesInput>
  specificDay?: InputMaybe<Scalars['Int']['input']>
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type PartnerCreateCustomerInput = {
  city?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  industry?: InputMaybe<Scalars['String']['input']>
  legalName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCreateCustomerTagInput = {
  color?: InputMaybe<TagColor>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type PartnerCreateCustomerUserInput = {
  customerId: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCreateInvoiceSummaryInput = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  customDay?: InputMaybe<Scalars['Int']['input']>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  frequency: InvoiceSummaryFrequency
  sentHour?: InputMaybe<Scalars['Int']['input']>
  startAt?: InputMaybe<Scalars['String']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  templateID?: InputMaybe<Scalars['ID']['input']>
  timezone?: InputMaybe<Timezone>
}

export type PartnerCustomerTotals = {
  __typename: 'PartnerCustomerTotals'
  count: Scalars['Int']['output']
}

export type PartnerDefaultPayoutBankingAccountUpdateInput = {
  accountID: Scalars['ID']['input']
}

export type PartnerDetailedSubscription = {
  __typename: 'PartnerDetailedSubscription'
  monthlyRevenue?: Maybe<Array<MonthlyRevenue>>
  quarterlyRevenue?: Maybe<Array<QuarterlyRevenue>>
  subscriptions?: Maybe<Array<Maybe<PartnerSubscription>>>
}

export enum PartnerDocumentType {
  BankStatement = 'BANK_STATEMENT',
  Id = 'ID',
  OwnerIdBack = 'OWNER_ID_BACK',
  OwnerIdFront = 'OWNER_ID_FRONT',
  OwnerSelfie = 'OWNER_SELFIE',
  Registration = 'REGISTRATION'
}

export type PartnerEdge = {
  __typename: 'PartnerEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Partner>
}

export type PartnerFeeConfig = {
  __typename: 'PartnerFeeConfig'
  coverDirectPaymentFees: Scalars['Boolean']['output']
  coverFeeConfig?: Maybe<CoverFeeConfig>
  id: Scalars['ID']['output']
  partner: Partner
}

export type PartnerFeeConfigUpdateInput = {
  coverDirectPaymentFees?: InputMaybe<Scalars['Boolean']['input']>
  coverFeeConfig?: InputMaybe<PartnerCoverFeeConfigInput>
}

export type PartnerFilter = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['ID']['input']>
  paymentsPortalEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type PartnerGetCoveredInvoicesForRuleInput = {
  agreementTypeIDs?: InputMaybe<AgreementTypeInput>
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  billingTermsIDs?: InputMaybe<BillingTermsInput>
  contractNames?: InputMaybe<ContractNamesInput>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  daysBeforeDue?: InputMaybe<Scalars['Int']['input']>
  daysPastCreation?: InputMaybe<Scalars['Int']['input']>
  daysPastDue?: InputMaybe<Scalars['Int']['input']>
  lastDayOfMonth?: InputMaybe<Scalars['Boolean']['input']>
  recurringInvoices?: InputMaybe<RecurringInvoicesInput>
  specificDay?: InputMaybe<Scalars['Int']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PartnerGetUserInfoReply = {
  __typename: 'PartnerGetUserInfoReply'
  id: Scalars['ID']['output']
  userType: UserType
  users?: Maybe<Array<PartnerUserInfo>>
}

export type PartnerHaloPsaConnectionCreateInput = {
  applicationDomain: Scalars['String']['input']
  clientID: Scalars['String']['input']
  clientSecret: Scalars['String']['input']
  currency: Currency
  integrationType: IntegrationType
  invoiceCreatedSince?: InputMaybe<Scalars['String']['input']>
  invoiceNumberField: InvoiceNumberFields
}

export type PartnerHaloPsaConnectionCreateReply = {
  __typename: 'PartnerHaloPSAConnectionCreateReply'
  errorMessage?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type PartnerHaloPsaConnectionQueryFiltersUpdateReply = {
  __typename: 'PartnerHaloPSAConnectionQueryFiltersUpdateReply'
  success: Scalars['Boolean']['output']
}

export type PartnerInviteUserInput = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  role: PartnerUserRole
}

export type PartnerInvoiceBulkCharge = {
  __typename: 'PartnerInvoiceBulkCharge'
  bulkChargeRequestStatus?: Maybe<BulkChargeRequestStatusEnum>
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  invoiceCount: Scalars['Int']['output']
  partner: Partner
  paymentDate?: Maybe<Scalars['String']['output']>
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>
  requester?: Maybe<PartnerUser>
}

/** A connection to a list of items. */
export type PartnerInvoiceBulkChargeConnection = {
  __typename: 'PartnerInvoiceBulkChargeConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerInvoiceBulkChargeEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PartnerInvoiceBulkChargeEdge = {
  __typename: 'PartnerInvoiceBulkChargeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<PartnerInvoiceBulkCharge>
}

export enum PartnerInvoiceBulkChargeOrderByField {
  CreatedDate = 'CREATED_DATE',
  PaymentDate = 'PAYMENT_DATE'
}

export type PartnerInvoicePaidUpdateBypassInput = {
  invoiceID: Scalars['String']['input']
  paid: Scalars['Boolean']['input']
}

export type PartnerInvoicePaidUpdateInput = {
  invoiceID: Scalars['String']['input']
  paid: Scalars['Boolean']['input']
}

export type PartnerListCustomerFeeExceptionsInput = {
  customerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  feeType?: InputMaybe<FeeExceptionType>
}

export type PartnerListCustomersFilter = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  /**
   * Filter to customers that currently owe money: at least one
   * upcoming/overdue/received invoice with outstanding_amount > 0 — the same set
   * behind the OUTSTANDING_AMOUNT sort. Only true filters; false or omitted
   * returns all customers (AR-7787).
   */
  hasOutstandingBalance?: InputMaybe<Scalars['Boolean']['input']>
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter to customers with a payment-method gap. AND-ed with tagIds. */
  paymentMethodStatus?: InputMaybe<CustomerPaymentMethodStatus>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PartnerListCustomersOrder = {
  direction: ArOrderDirection
  field: PartnerListCustomersOrderField
}

export enum PartnerListCustomersOrderField {
  City = 'CITY',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  OutstandingAmount = 'OUTSTANDING_AMOUNT',
  PaidAmount = 'PAID_AMOUNT',
  State = 'STATE'
}

export type PartnerListCustomersPage = {
  __typename: 'PartnerListCustomersPage'
  customers: Array<Customer>
  pagination: ArPagination
  summary: PartnerListCustomersSummary
}

export type PartnerListCustomersSummary = {
  __typename: 'PartnerListCustomersSummary'
  totalItems: Scalars['Int']['output']
}

export type PartnerLogoUploadUrl = {
  __typename: 'PartnerLogoUploadUrl'
  uploadCDNURL: Scalars['String']['output']
  uploadURL: Scalars['String']['output']
  uploadURLExpirationUTC: Scalars['String']['output']
}

export type PartnerOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PartnerOrderByField>
}

export enum PartnerOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type PartnerPaymentsPortalCustomization = {
  __typename: 'PartnerPaymentsPortalCustomization'
  color?: Maybe<Scalars['String']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
}

export type PartnerPaymentsPortalCustomizationInput = {
  color?: InputMaybe<Scalars['String']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
}

export enum PartnerPaymentsPortalMethod {
  Ach = 'ACH',
  Bnpl = 'BNPL',
  Card = 'CARD'
}

export type PartnerSubscription = {
  __typename: 'PartnerSubscription'
  amount: Scalars['Float']['output']
  billingCyclesCovered: Scalars['Int']['output']
  billingCyclesUnit: BillingCycleUnit
  createdDate: Scalars['String']['output']
  duration?: Maybe<Scalars['Int']['output']>
  firstBilledDate?: Maybe<Scalars['String']['output']>
  firstBillingDate: Scalars['String']['output']
  frequency: SubscriptionFrequency
  id: Scalars['ID']['output']
  lastStatus: SubscriptionStatus
  nextBillingDate: Scalars['String']['output']
  partner: Partner
  type: Scalars['String']['output']
}

export type PartnerUnarchiveCustomerInput = {
  id: Scalars['ID']['input']
}

export type PartnerUpdateAddressInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  state: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateAutopayRuleInput = {
  agreementTypeIDs?: InputMaybe<AgreementTypeInput>
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  billingTermsIDs?: InputMaybe<BillingTermsInput>
  contractNames?: InputMaybe<ContractNamesInput>
  customMethods?: InputMaybe<Array<InputMaybe<AutopayCustomMethodInput>>>
  customerIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  daysBeforeDue?: InputMaybe<Scalars['Int']['input']>
  daysPastCreation?: InputMaybe<Scalars['Int']['input']>
  daysPastDue?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
  lastDayOfMonth?: InputMaybe<Scalars['Boolean']['input']>
  recurringInvoices?: InputMaybe<RecurringInvoicesInput>
  specificDay?: InputMaybe<Scalars['Int']['input']>
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type PartnerUpdateCustomerInput = {
  city?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  industry?: InputMaybe<Scalars['String']['input']>
  legalName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateCustomerTagInput = {
  ID: Scalars['ID']['input']
  color?: InputMaybe<TagColor>
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateCustomerUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateDetailsInput = {
  adyenBusinessSetup?: InputMaybe<AdyenBusinessSetup>
  adyenCompanyType?: InputMaybe<AdyenCompanyType>
  adyenIndustryCode?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  incorporationNumber?: InputMaybe<Scalars['String']['input']>
  industry?: InputMaybe<Scalars['String']['input']>
  isTimezoneUpdated?: InputMaybe<Scalars['Boolean']['input']>
  legalName: Scalars['String']['input']
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Timezone>
  useUserLocalTimezone?: InputMaybe<Scalars['Boolean']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateInvoicePdfSettingsInput = {
  attachInvoicePdfEnabled?: InputMaybe<Scalars['Boolean']['input']>
  pdfFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type PartnerUpdateMyUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

/** Partial update of a routine the caller owns. Omitted fields are left unchanged. */
export type PartnerUpdateRoutineInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  instruction?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateTimezoneInput = {
  timezone: Timezone
  useUserLocalTimezone: Scalars['Boolean']['input']
}

export type PartnerUpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  role: PartnerUserRole
}

/** Input for uploading a vendor document. */
export type PartnerUploadVendorDocumentInput = {
  document: Scalars['String']['input']
  filename: Scalars['String']['input']
  vendorId: Scalars['ID']['input']
}

/** Response for upload vendor document mutation. */
export type PartnerUploadVendorDocumentPayload = {
  __typename: 'PartnerUploadVendorDocumentPayload'
  documentId: Scalars['ID']['output']
}

export type PartnerUpsertPassThroughFeesInput = {
  passThroughFees?: InputMaybe<Array<PassThroughFeeInput>>
}

export type PartnerUser = {
  __typename: 'PartnerUser'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  hasMFA?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role: PartnerUserRole
}

export type PartnerUserConnection = {
  __typename: 'PartnerUserConnection'
  edges?: Maybe<Array<Maybe<PartnerUserEdge>>>
  pageInfo: PageInfo
}

export type PartnerUserEdge = {
  __typename: 'PartnerUserEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<PartnerUser>
}

export type PartnerUserInfo = {
  __typename: 'PartnerUserInfo'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  partner?: Maybe<Partner>
  permissions: Array<PartnerUserPermissions>
  phone?: Maybe<Scalars['String']['output']>
  role: Scalars['String']['output']
}

export type PartnerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PartnerUserOrderByField>
}

export enum PartnerUserOrderByField {
  Name = 'NAME',
  Role = 'ROLE'
}

export enum PartnerUserPermissions {
  AccountingIntegrationSync = 'ACCOUNTING_INTEGRATION_SYNC',
  AccountingPreferencesRead = 'ACCOUNTING_PREFERENCES_READ',
  AccountingPreferencesUpdate = 'ACCOUNTING_PREFERENCES_UPDATE',
  AccountingSyncBatchCreate = 'ACCOUNTING_SYNC_BATCH_CREATE',
  AccountingSyncBatchRead = 'ACCOUNTING_SYNC_BATCH_READ',
  AccountingSyncConfigCreate = 'ACCOUNTING_SYNC_CONFIG_CREATE',
  AccountingSyncConfigRead = 'ACCOUNTING_SYNC_CONFIG_READ',
  AccountsPayableCreateBill = 'ACCOUNTS_PAYABLE_CREATE_BILL',
  AccountsPayableCreateFundingAttempt = 'ACCOUNTS_PAYABLE_CREATE_FUNDING_ATTEMPT',
  AccountsPayableCreateUnitType = 'ACCOUNTS_PAYABLE_CREATE_UNIT_TYPE',
  AccountsPayableCreateVendor = 'ACCOUNTS_PAYABLE_CREATE_VENDOR',
  AccountsPayableCreateVendorPaymentPreference = 'ACCOUNTS_PAYABLE_CREATE_VENDOR_PAYMENT_PREFERENCE',
  AccountsPayableDeleteUnitType = 'ACCOUNTS_PAYABLE_DELETE_UNIT_TYPE',
  AccountsPayableDeleteVendorDocument = 'ACCOUNTS_PAYABLE_DELETE_VENDOR_DOCUMENT',
  AccountsPayableRejectBill = 'ACCOUNTS_PAYABLE_REJECT_BILL',
  AccountsPayableStartOnboarding = 'ACCOUNTS_PAYABLE_START_ONBOARDING',
  AccountsPayableSubmitBillForApproval = 'ACCOUNTS_PAYABLE_SUBMIT_BILL_FOR_APPROVAL',
  AccountsPayableUpdateConfig = 'ACCOUNTS_PAYABLE_UPDATE_CONFIG',
  AccountsPayableUpdateVendorPaymentPreference = 'ACCOUNTS_PAYABLE_UPDATE_VENDOR_PAYMENT_PREFERENCE',
  AccountsPayableUploadVendorDocument = 'ACCOUNTS_PAYABLE_UPLOAD_VENDOR_DOCUMENT',
  AccountsPayableViewBill = 'ACCOUNTS_PAYABLE_VIEW_BILL',
  AccountsPayableViewConfig = 'ACCOUNTS_PAYABLE_VIEW_CONFIG',
  AccountsPayableViewUnitType = 'ACCOUNTS_PAYABLE_VIEW_UNIT_TYPE',
  AccountsPayableViewVendor = 'ACCOUNTS_PAYABLE_VIEW_VENDOR',
  AccountsPayableViewVendorDocument = 'ACCOUNTS_PAYABLE_VIEW_VENDOR_DOCUMENT',
  AccountsPayableViewVendorPaymentPreference = 'ACCOUNTS_PAYABLE_VIEW_VENDOR_PAYMENT_PREFERENCE',
  AdyenOnboardingStatusGet = 'ADYEN_ONBOARDING_STATUS_GET',
  AdyenRemediationActionsGet = 'ADYEN_REMEDIATION_ACTIONS_GET',
  AdyenRemediationActionsUpdate = 'ADYEN_REMEDIATION_ACTIONS_UPDATE',
  AdyenTermsAccept = 'ADYEN_TERMS_ACCEPT',
  AdyenTermsGet = 'ADYEN_TERMS_GET',
  AgreementTypeList = 'AGREEMENT_TYPE_LIST',
  ApiKeyCreate = 'API_KEY_CREATE',
  ApiKeyList = 'API_KEY_LIST',
  ApiKeyUpdate = 'API_KEY_UPDATE',
  AssistantRead = 'ASSISTANT_READ',
  AssistantWrite = 'ASSISTANT_WRITE',
  AutopayConfigList = 'AUTOPAY_CONFIG_LIST',
  AutopayConfigUpdate = 'AUTOPAY_CONFIG_UPDATE',
  AutopayRuleCreate = 'AUTOPAY_RULE_CREATE',
  AutopayRuleDelete = 'AUTOPAY_RULE_DELETE',
  AutopayRuleList = 'AUTOPAY_RULE_LIST',
  AutopayRuleUpdate = 'AUTOPAY_RULE_UPDATE',
  AutotaskConnectionCreate = 'AUTOTASK_CONNECTION_CREATE',
  AutotaskConnectionRead = 'AUTOTASK_CONNECTION_READ',
  AutotaskContractList = 'AUTOTASK_CONTRACT_LIST',
  AutotaskContractTypeList = 'AUTOTASK_CONTRACT_TYPE_LIST',
  BankingDelete = 'BANKING_DELETE',
  BankingGetintegration = 'BANKING_GETINTEGRATION',
  BankingNew = 'BANKING_NEW',
  BankingUpdate = 'BANKING_UPDATE',
  BillingHistoryList = 'BILLING_HISTORY_LIST',
  BnplConfirm = 'BNPL_CONFIRM',
  CardtransferList = 'CARDTRANSFER_LIST',
  CardList = 'CARD_LIST',
  CardManage = 'CARD_MANAGE',
  ClientTrendsRead = 'CLIENT_TRENDS_READ',
  ClientTrendsWrite = 'CLIENT_TRENDS_WRITE',
  CollectionCreate = 'COLLECTION_CREATE',
  CollectionList = 'COLLECTION_LIST',
  CollectionUpdate = 'COLLECTION_UPDATE',
  CompanyDocumentsDelete = 'COMPANY_DOCUMENTS_DELETE',
  CompanyDocumentsList = 'COMPANY_DOCUMENTS_LIST',
  CompanyIndividualCreate = 'COMPANY_INDIVIDUAL_CREATE',
  CompanyIndividualDelete = 'COMPANY_INDIVIDUAL_DELETE',
  CompanyIndividualList = 'COMPANY_INDIVIDUAL_LIST',
  CompanyIndividualUploadLinkCreate = 'COMPANY_INDIVIDUAL_UPLOAD_LINK_CREATE',
  CompanyOwnerCreate = 'COMPANY_OWNER_CREATE',
  CompanyOwnerDelete = 'COMPANY_OWNER_DELETE',
  CompanyOwnerList = 'COMPANY_OWNER_LIST',
  CompanyRepresentativeCreate = 'COMPANY_REPRESENTATIVE_CREATE',
  CompanyRepresentativeList = 'COMPANY_REPRESENTATIVE_LIST',
  ConnectwiseAgreementList = 'CONNECTWISE_AGREEMENT_LIST',
  ConnectwiseAgreementTypeList = 'CONNECTWISE_AGREEMENT_TYPE_LIST',
  ConnectwiseBillingTermsList = 'CONNECTWISE_BILLING_TERMS_LIST',
  ConnectwiseConnectionCreate = 'CONNECTWISE_CONNECTION_CREATE',
  ConnectwiseConnectionRead = 'CONNECTWISE_CONNECTION_READ',
  ConnectwiseGlSegmentRead = 'CONNECTWISE_GL_SEGMENT_READ',
  ConnectwiseTaxCodeRead = 'CONNECTWISE_TAX_CODE_READ',
  CreditMemoBalanceRead = 'CREDIT_MEMO_BALANCE_READ',
  CreditMemoBalanceWrite = 'CREDIT_MEMO_BALANCE_WRITE',
  CreditMemoConfigRead = 'CREDIT_MEMO_CONFIG_READ',
  CreditMemoConfigWrite = 'CREDIT_MEMO_CONFIG_WRITE',
  CustomeruserCreate = 'CUSTOMERUSER_CREATE',
  CustomeruserDelete = 'CUSTOMERUSER_DELETE',
  CustomeruserList = 'CUSTOMERUSER_LIST',
  CustomeruserUpdate = 'CUSTOMERUSER_UPDATE',
  CustomerAutopayConfigUpdate = 'CUSTOMER_AUTOPAY_CONFIG_UPDATE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerList = 'CUSTOMER_LIST',
  CustomerTagCreate = 'CUSTOMER_TAG_CREATE',
  CustomerTagDelete = 'CUSTOMER_TAG_DELETE',
  CustomerTagList = 'CUSTOMER_TAG_LIST',
  CustomerTagUpdate = 'CUSTOMER_TAG_UPDATE',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  DatagateConnectionCreate = 'DATAGATE_CONNECTION_CREATE',
  EmailActivityList = 'EMAIL_ACTIVITY_LIST',
  EmailTemplateCreate = 'EMAIL_TEMPLATE_CREATE',
  EmailTemplateDelete = 'EMAIL_TEMPLATE_DELETE',
  EmailTemplateList = 'EMAIL_TEMPLATE_LIST',
  EmailTemplateUpdate = 'EMAIL_TEMPLATE_UPDATE',
  GetInvoiceBulkCharges = 'GET_INVOICE_BULK_CHARGES',
  HalopsaConnectionCreate = 'HALOPSA_CONNECTION_CREATE',
  HalopsaConnectionQueryFiltersUpdate = 'HALOPSA_CONNECTION_QUERY_FILTERS_UPDATE',
  HalopsaContractList = 'HALOPSA_CONTRACT_LIST',
  HalopsaContractSubtypeList = 'HALOPSA_CONTRACT_SUBTYPE_LIST',
  HalopsaTopLevelList = 'HALOPSA_TOP_LEVEL_LIST',
  InsightsGet = 'INSIGHTS_GET',
  IntegrationDelete = 'INTEGRATION_DELETE',
  IntegrationDisconnect = 'INTEGRATION_DISCONNECT',
  IntegrationList = 'INTEGRATION_LIST',
  IntegrationLogRetry = 'INTEGRATION_LOG_RETRY',
  IntegrationLogView = 'INTEGRATION_LOG_VIEW',
  InvoiceArchive = 'INVOICE_ARCHIVE',
  InvoiceBulkCharge = 'INVOICE_BULK_CHARGE',
  InvoiceConfirm = 'INVOICE_CONFIRM',
  InvoiceCreate = 'INVOICE_CREATE',
  InvoiceDownload = 'INVOICE_DOWNLOAD',
  InvoiceList = 'INVOICE_LIST',
  InvoicePaidUpdate = 'INVOICE_PAID_UPDATE',
  InvoicePaidUpdateBypass = 'INVOICE_PAID_UPDATE_BYPASS',
  InvoicePay = 'INVOICE_PAY',
  InvoicePreferencesUpsert = 'INVOICE_PREFERENCES_UPSERT',
  InvoiceRemind = 'INVOICE_REMIND',
  InvoiceReminderCreate = 'INVOICE_REMINDER_CREATE',
  InvoiceReminderList = 'INVOICE_REMINDER_LIST',
  InvoiceReminderSendPreview = 'INVOICE_REMINDER_SEND_PREVIEW',
  LendingPay = 'LENDING_PAY',
  NotificationsRead = 'NOTIFICATIONS_READ',
  NotificationsUpdate = 'NOTIFICATIONS_UPDATE',
  OfferCreate = 'OFFER_CREATE',
  OfferList = 'OFFER_LIST',
  OfferUpdate = 'OFFER_UPDATE',
  OpenpayoutList = 'OPENPAYOUT_LIST',
  OverviewRead = 'OVERVIEW_READ',
  PartneruserCreate = 'PARTNERUSER_CREATE',
  PartneruserDelete = 'PARTNERUSER_DELETE',
  PartneruserList = 'PARTNERUSER_LIST',
  PartneruserUpdate = 'PARTNERUSER_UPDATE',
  PartneruserUpdateMyself = 'PARTNERUSER_UPDATE_MYSELF',
  PartnerCreate = 'PARTNER_CREATE',
  PartnerUpdate = 'PARTNER_UPDATE',
  PaymentcompanyconfigList = 'PAYMENTCOMPANYCONFIG_LIST',
  PaymentcompanyconfigUpdate = 'PAYMENTCOMPANYCONFIG_UPDATE',
  PaymentList = 'PAYMENT_LIST',
  PaymentUpdate = 'PAYMENT_UPDATE',
  PayoutcompanyconfigList = 'PAYOUTCOMPANYCONFIG_LIST',
  PayoutcompanyconfigUpdate = 'PAYOUTCOMPANYCONFIG_UPDATE',
  PayouttimingcompanyconfigList = 'PAYOUTTIMINGCOMPANYCONFIG_LIST',
  PayouttimingcompanyconfigUpsert = 'PAYOUTTIMINGCOMPANYCONFIG_UPSERT',
  PayouttimingplanList = 'PAYOUTTIMINGPLAN_LIST',
  PayoutList = 'PAYOUT_LIST',
  QuickbooksAccountList = 'QUICKBOOKS_ACCOUNT_LIST',
  QuickbooksAccountUpdate = 'QUICKBOOKS_ACCOUNT_UPDATE',
  QuickbooksConnectionCreate = 'QUICKBOOKS_CONNECTION_CREATE',
  QuickbooksConnectionRead = 'QUICKBOOKS_CONNECTION_READ',
  QuickbooksConnectionUrl = 'QUICKBOOKS_CONNECTION_URL',
  QuickbooksCustomerTypeList = 'QUICKBOOKS_CUSTOMER_TYPE_LIST',
  QuickbooksInvoiceCustomFieldsList = 'QUICKBOOKS_INVOICE_CUSTOM_FIELDS_LIST',
  QuickbooksRecurringTransactionList = 'QUICKBOOKS_RECURRING_TRANSACTION_LIST',
  QuickbooksTaxCodeRead = 'QUICKBOOKS_TAX_CODE_READ',
  RecurringpaymentCreate = 'RECURRINGPAYMENT_CREATE',
  RecurringpaymentDeactivate = 'RECURRINGPAYMENT_DEACTIVATE',
  RecurringpaymentList = 'RECURRINGPAYMENT_LIST',
  RecurringpaymentUpdate = 'RECURRINGPAYMENT_UPDATE',
  ReferralCreate = 'REFERRAL_CREATE',
  ReferralList = 'REFERRAL_LIST',
  ReferralPayoutList = 'REFERRAL_PAYOUT_LIST',
  ReferralSend = 'REFERRAL_SEND',
  ReferralUpdate = 'REFERRAL_UPDATE',
  ReportSend = 'REPORT_SEND',
  RutterAccountList = 'RUTTER_ACCOUNT_LIST',
  RutterAccountUpsert = 'RUTTER_ACCOUNT_UPSERT',
  RutterConnectionCreate = 'RUTTER_CONNECTION_CREATE',
  RutterConnectionRead = 'RUTTER_CONNECTION_READ',
  RutterPaymentTermsList = 'RUTTER_PAYMENT_TERMS_LIST',
  SubscriptionCancel = 'SUBSCRIPTION_CANCEL',
  SubscriptionList = 'SUBSCRIPTION_LIST',
  SubscriptionPaymentList = 'SUBSCRIPTION_PAYMENT_LIST',
  SuperopsConnectionCreate = 'SUPEROPS_CONNECTION_CREATE',
  SupportPreferencesGet = 'SUPPORT_PREFERENCES_GET',
  SupportPreferencesUpsert = 'SUPPORT_PREFERENCES_UPSERT',
  UtilizationRead = 'UTILIZATION_READ',
  UtilizationWrite = 'UTILIZATION_WRITE'
}

export enum PartnerUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Readonly = 'READONLY',
  Subadmin = 'SUBADMIN'
}

export type PassThroughFee = {
  __typename: 'PassThroughFee'
  customerID?: Maybe<Scalars['String']['output']>
  fixedFeeForwarded: Scalars['Boolean']['output']
  methodNetwork: MethodNetwork
  percent: Scalars['Float']['output']
}

export type PassThroughFeeInput = {
  customerID?: InputMaybe<Scalars['String']['input']>
  fixedFeeForwarded: Scalars['Boolean']['input']
  methodNetwork: MethodNetwork
  percent: Scalars['Float']['input']
}

export type PayInvoicePaymentMethodInput = {
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['input']
}

export type Payment = {
  __typename: 'Payment'
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  /** @deprecated Use currentPaymentMethodEntity instead */
  currentPaymentMethod?: Maybe<MethodEnum>
  currentPaymentMethodEntity?: Maybe<PaymentMethodEntity>
  customer?: Maybe<Customer>
  dueDate?: Maybe<Scalars['String']['output']>
  executorType: PaymentExecutorType
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  originService: PaymentAlternativeService
  partner: Partner
  payerCompanyType: CompanyType
  paymentCompletionForecastDate?: Maybe<Scalars['String']['output']>
  paymentFees: Array<Maybe<PaymentFee>>
  payoutEstimation: PaymentPayoutEstimation
  product: Product
  refunds?: Maybe<Array<Maybe<Refund>>>
  statuses: Array<Maybe<PaymentStatus>>
  transaction?: Maybe<Transaction>
}

export enum PaymentAlternativeService {
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  Autopay = 'AUTOPAY',
  BatchPayments = 'BATCH_PAYMENTS',
  Bnpl = 'BNPL',
  Collection = 'COLLECTION',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  RecurringPayment = 'RECURRING_PAYMENT',
  Subscription = 'SUBSCRIPTION'
}

export type PaymentCompanyConfig = {
  __typename: 'PaymentCompanyConfig'
  company: CompanyUnion
  id?: Maybe<Scalars['ID']['output']>
  paymentMethod?: Maybe<MethodEnum>
  paymentMethodEntity?: Maybe<PaymentMethodEntity>
}

export type PaymentCompanyConfigUpdateInput = {
  paymentMethod?: InputMaybe<TransferPaymentMethodInputEnum>
  paymentMethodID: Scalars['ID']['input']
}

/** A connection to a list of items. */
export type PaymentConnection = {
  __typename: 'PaymentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PaymentCountByTrigger = {
  __typename: 'PaymentCountByTrigger'
  count: Scalars['Int']['output']
  trigger: Scalars['String']['output']
}

export type PaymentCountByTriggerLastMonthResponse = {
  __typename: 'PaymentCountByTriggerLastMonthResponse'
  data: Array<PaymentCountByTrigger>
}

/** An edge in a connection. */
export type PaymentEdge = {
  __typename: 'PaymentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Payment>
}

export enum PaymentExecutorType {
  Alternative = 'ALTERNATIVE',
  Customer = 'CUSTOMER',
  GuestCustomer = 'GUEST_CUSTOMER',
  Partner = 'PARTNER',
  PartnerApi = 'PARTNER_API',
  System = 'SYSTEM'
}

export type PaymentFee = {
  __typename: 'PaymentFee'
  amount: Scalars['Float']['output']
  forwarded: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export type PaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  creationDateEnd?: InputMaybe<Scalars['String']['input']>
  creationDateStart?: InputMaybe<Scalars['String']['input']>
  customerId?: InputMaybe<Scalars['ID']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  excludeBNPL?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  payerEntity?: InputMaybe<CompanyType>
  paymentCompletionForecastDateFrom?: InputMaybe<Scalars['String']['input']>
  paymentCompletionForecastDateTo?: InputMaybe<Scalars['String']['input']>
  paymentMethod?: InputMaybe<MethodEnum>
  productId?: InputMaybe<Scalars['ID']['input']>
  productType?: InputMaybe<ProductType>
  productTypeIn?: InputMaybe<Array<InputMaybe<ProductType>>>
  status?: InputMaybe<Array<InputMaybe<PaymentStatusEnum>>>
}

export type PaymentMethodEntity = Account | Card

export type PaymentMethodUsage = {
  __typename: 'PaymentMethodUsage'
  amount: Scalars['String']['output']
  /** Signed fractional change, last-30d vs prior-30d. */
  delta: Scalars['Float']['output']
  /** "ach" or "virtual_card". */
  method: Scalars['String']['output']
}

export type PaymentOrder = {
  direction?: OrderDirection
  field?: PaymentOrderField
}

export enum PaymentOrderField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  NetAmount = 'NET_AMOUNT'
}

export type PaymentPage = {
  __typename: 'PaymentPage'
  data: Array<Maybe<Payment>>
  limit: Scalars['Int']['output']
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type PaymentPayoutEstimation = {
  __typename: 'PaymentPayoutEstimation'
  estimatedPayoutCreationDate?: Maybe<Scalars['String']['output']>
}

export type PaymentPreference = {
  __typename: 'PaymentPreference'
  country: PaymentPreferenceCountry
  paymentPreferenceID: Scalars['String']['output']
  /**
   * Provenance of the bank data behind this preference. Returns null for
   * legacy rows recorded before this field existed; the partner UI should
   * treat null as "Unknown".
   */
  source?: Maybe<VendorAuditSource>
  usPaymentPreferenceData?: Maybe<UsPaymentPreference>
}

export enum PaymentPreferenceCountry {
  UsPaymentPreference = 'US_PAYMENT_PREFERENCE'
}

export enum PaymentPreferenceType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type PaymentRequest = {
  __typename: 'PaymentRequest'
  id: Scalars['ID']['output']
  lastStatus: PaymentStatusEnum
  payment?: Maybe<Payment>
  paymentDate?: Maybe<Scalars['String']['output']>
  product: Product
}

/**
 * Dispatch speed for a vendor payment. STANDARD = regular ACH; SAME_DAY = same-day ACH;
 * INSTANT = RTP/FedNow. Capability and vendor-bank eligibility are enforced server-side.
 */
export enum PaymentSpeed {
  Instant = 'INSTANT',
  SameDay = 'SAME_DAY',
  Standard = 'STANDARD'
}

export type PaymentStatus = {
  __typename: 'PaymentStatus'
  createdAt: Scalars['String']['output']
  status?: Maybe<PaymentStatusEnum>
}

export enum PaymentStatusEnum {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type PaymentTotals = {
  __typename: 'PaymentTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  netAmount: Scalars['Float']['output']
}

/** Disbursement rail used for a vendor payment (ACH vs. virtual card). */
export enum PaymentType {
  Ach = 'ACH',
  VirtualCard = 'VIRTUAL_CARD'
}

export type PaymentVolumeAutomatedResponse = {
  __typename: 'PaymentVolumeAutomatedResponse'
  value: Scalars['Float']['output']
}

export type PaymentVolumeByMonthResponse = {
  __typename: 'PaymentVolumeByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type PaymentVolumeByTrigger = {
  __typename: 'PaymentVolumeByTrigger'
  trigger: Scalars['String']['output']
  volume: Scalars['Float']['output']
}

export type PaymentVolumeByTriggerLastMonthResponse = {
  __typename: 'PaymentVolumeByTriggerLastMonthResponse'
  data: Array<PaymentVolumeByTrigger>
}

export type PaymentVolumeResponse = {
  __typename: 'PaymentVolumeResponse'
  value: Scalars['Float']['output']
}

export type PaymentsCountByMethodMonthData = {
  __typename: 'PaymentsCountByMethodMonthData'
  count: Scalars['Int']['output']
  method: Scalars['String']['output']
  month: Scalars['String']['output']
}

export type PaymentsCountByMethodMonthResponse = {
  __typename: 'PaymentsCountByMethodMonthResponse'
  average: Scalars['Float']['output']
  data: Array<PaymentsCountByMethodMonthData>
}

export type PaymentsVolumeByMethodMonthData = {
  __typename: 'PaymentsVolumeByMethodMonthData'
  method: Scalars['String']['output']
  month: Scalars['String']['output']
  volume: Scalars['Float']['output']
}

export type PaymentsVolumeByMethodMonthResponse = {
  __typename: 'PaymentsVolumeByMethodMonthResponse'
  average: Scalars['Float']['output']
  data: Array<PaymentsVolumeByMethodMonthData>
}

export type Payout = {
  __typename: 'Payout'
  account?: Maybe<Account>
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  customer?: Maybe<Customer>
  fees: Array<Maybe<PayoutFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  payoutBreakdownTotals?: Maybe<Array<Maybe<PayoutBreakdownTotals>>>
  payoutCompletionForecastDate?: Maybe<Scalars['String']['output']>
  payoutType: PayoutType
  product: Product
  publicNumber: Scalars['String']['output']
  receiverCompanyType: CompanyType
  statuses: Array<Maybe<PayoutStatus>>
  totalFeeAmount: Scalars['Float']['output']
  transactions: Array<Maybe<Transaction>>
}

export type PayoutBreakdownTotals = {
  __typename: 'PayoutBreakdownTotals'
  feesGreaterThanZeroCount: Scalars['Int']['output']
  productType: BreakdownProductType
  productTypeCount: Scalars['Int']['output']
  sumFees: Scalars['Float']['output']
  sumGrossAmount: Scalars['Float']['output']
}

export type PayoutCompanyConfig = {
  __typename: 'PayoutCompanyConfig'
  company: Partner
  defaultBankingAccount?: Maybe<Account>
  id: Scalars['ID']['output']
  invoicePayoutMethod: InvoicePayoutMethodEnum
  offerPayoutMethod: OfferPayoutMethodEnum
  referralBankingAccount?: Maybe<Account>
  referralPayoutMethod: ReferralPayoutMethodEnum
}

/** A connection to a list of items. */
export type PayoutConnection = {
  __typename: 'PayoutConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayoutEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PayoutDetails = {
  __typename: 'PayoutDetails'
  account?: Maybe<Account>
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  fees: Array<Maybe<PayoutFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  payoutBreakdownTotals?: Maybe<Array<Maybe<PayoutBreakdownTotals>>>
  payoutCompletionForecastDate?: Maybe<Scalars['String']['output']>
  payoutType: PayoutType
  product: Product
  publicNumber: Scalars['String']['output']
  statuses: Array<Maybe<PayoutStatus>>
  totalFeeAmount: Scalars['Float']['output']
  transactions: Array<Maybe<Transaction>>
}

/** An edge in a connection. */
export type PayoutEdge = {
  __typename: 'PayoutEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Payout>
}

export type PayoutFee = {
  __typename: 'PayoutFee'
  amount: Scalars['Float']['output']
  forwarded: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export type PayoutFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  approved?: InputMaybe<Scalars['Boolean']['input']>
  completed?: InputMaybe<Scalars['Boolean']['input']>
  customerId?: InputMaybe<Scalars['ID']['input']>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  netAmountEnd?: InputMaybe<Scalars['Float']['input']>
  netAmountStart?: InputMaybe<Scalars['Float']['input']>
  payoutCompletionForecastDateFrom?: InputMaybe<Scalars['String']['input']>
  payoutCompletionForecastDateTo?: InputMaybe<Scalars['String']['input']>
  payoutType?: InputMaybe<PayoutType>
  productID?: InputMaybe<Scalars['ID']['input']>
  /** @deprecated Use productTypes instead */
  productType?: InputMaybe<ProductType>
  productTypes?: InputMaybe<Array<InputMaybe<ProductType>>>
  publicNumber?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<PayoutStatusEnum>>
}

export enum PayoutMethodEnum {
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export type PayoutOrder = {
  direction?: OrderDirection
  field?: PayoutOrderField
}

export enum PayoutOrderField {
  CreatedAt = 'CREATED_AT'
}

export type PayoutStatus = {
  __typename: 'PayoutStatus'
  createdAt: Scalars['String']['output']
  status?: Maybe<PayoutStatusEnum>
}

export enum PayoutStatusEnum {
  Analyzing = 'ANALYZING',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type PayoutTimingCompanyConfig = {
  __typename: 'PayoutTimingCompanyConfig'
  activatedAt?: Maybe<Scalars['String']['output']>
  aggregateID: Scalars['ID']['output']
  businessDaysToHold: Scalars['Int']['output']
  canCompanyChange: Scalars['Boolean']['output']
  company: Partner
  effectiveAt: Scalars['String']['output']
  payoutTimingFee?: Maybe<PayoutTimingFee>
  payoutTimingPlanID: Scalars['ID']['output']
}

export type PayoutTimingFee = {
  __typename: 'PayoutTimingFee'
  capFee: Scalars['Float']['output']
  fixedFee: Scalars['Float']['output']
  percentageFee: Scalars['Float']['output']
}

export type PayoutTimingPlan = {
  __typename: 'PayoutTimingPlan'
  businessDaysToHold: Scalars['Int']['output']
  id: Scalars['ID']['output']
  payoutTimingFee: PayoutTimingFee
}

export type PayoutTotals = {
  __typename: 'PayoutTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export enum PayoutType {
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  Referral = 'REFERRAL'
}

export type PendingCustomerUser = {
  __typename: 'PendingCustomerUser'
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  partnerId: Scalars['String']['output']
}

export type PendingCustomerUserConnection = {
  __typename: 'PendingCustomerUserConnection'
  edges?: Maybe<Array<Maybe<PendingCustomerUserEdge>>>
  pageInfo: PageInfo
}

export type PendingCustomerUserEdge = {
  __typename: 'PendingCustomerUserEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<PendingCustomerUser>
}

export type PendingCustomerUserFilters = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  customerId?: InputMaybe<Scalars['ID']['input']>
  email?: InputMaybe<Scalars['String']['input']>
}

export type PendingCustomerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PendingCustomerUserOrderByField>
}

export enum PendingCustomerUserOrderByField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL'
}

export type PendingCustomerUsersTotals = {
  __typename: 'PendingCustomerUsersTotals'
  count: Scalars['Int']['output']
}

export type PlaidInstitutionConnectionStatus = {
  __typename: 'PlaidInstitutionConnectionStatus'
  connectionId: Scalars['ID']['output']
  needsUpdate: Scalars['Boolean']['output']
}

export enum PlatformName {
  Autotask = 'AUTOTASK',
  Connectwise = 'CONNECTWISE',
  Datagate = 'DATAGATE',
  Halopsa = 'HALOPSA',
  Quickbooks = 'QUICKBOOKS',
  RutterDynamics365 = 'RUTTER_DYNAMICS365',
  RutterFreshbooks = 'RUTTER_FRESHBOOKS',
  RutterNetsuite = 'RUTTER_NETSUITE',
  RutterQbd = 'RUTTER_QBD',
  RutterSageIntacct = 'RUTTER_SAGE_INTACCT',
  RutterSageIntacctV2 = 'RUTTER_SAGE_INTACCT_V2',
  RutterXero = 'RUTTER_XERO',
  RutterZohoBooks = 'RUTTER_ZOHO_BOOKS',
  Superops = 'SUPEROPS'
}

export type Product =
  | InstantPayment
  | Invoice
  | Offer
  | OneTimePayment
  | Referral
  | ReferralBonus
  | Refund
  | SubscriptionPayment

export enum ProductType {
  Chargeback = 'CHARGEBACK',
  InstantPayment = 'INSTANT_PAYMENT',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  OneTimePayment = 'ONE_TIME_PAYMENT',
  Referral = 'REFERRAL',
  ReferralBonus = 'REFERRAL_BONUS',
  Refund = 'REFUND',
  Subscription = 'SUBSCRIPTION'
}

export type PublicVendorCardView = {
  __typename: 'PublicVendorCardView'
  billAmount: Scalars['String']['output']
  billCurrency: Scalars['String']['output']
  billNumber: Scalars['String']['output']
  expiresAt: Scalars['String']['output']
  last4: Scalars['String']['output']
  partnerName: Scalars['String']['output']
}

export enum PublicVendorDataRequestStatus {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED'
}

export type PublicVendorDataResponse = {
  __typename: 'PublicVendorDataResponse'
  expiresAt: Scalars['String']['output']
  partnerName: Scalars['String']['output']
  status: PublicVendorDataRequestStatus
  vendor: Vendor
}

export enum PushPaymentsTo {
  Both = 'BOTH',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** QBO linking information for a vendor. */
export type QboLinking = {
  __typename: 'QboLinking'
  /** Timestamp of last successful QBO sync (RFC 3339, null if not linked). */
  lastSyncedAt?: Maybe<Scalars['String']['output']>
  /** QBO vendor external ID (null if not linked). */
  qboVendorId?: Maybe<Scalars['String']['output']>
  /** Linking state: NOT_LINKED or LINKED. */
  state: QboLinkingState
}

export enum QboLinkingState {
  /** Vendor is linked to a QBO vendor */
  Linked = 'LINKED',
  /** Vendor is not linked to a QBO vendor */
  NotLinked = 'NOT_LINKED'
}

export enum QboPaymentSyncState {
  Failed = 'FAILED',
  NotSynced = 'NOT_SYNCED',
  Pending = 'PENDING',
  Synced = 'SYNCED'
}

/** QBO sync status for a bill payment. */
export type QboPaymentSyncStatus = {
  __typename: 'QboPaymentSyncStatus'
  /** Error message from QBO (null unless FAILED). */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** Timestamp of last sync status change (RFC 3339). */
  lastSyncedAt?: Maybe<Scalars['String']['output']>
  /** QBO bill payment external ID (null if not synced). */
  qboExternalId?: Maybe<Scalars['String']['output']>
  /** Sync state. */
  status: QboPaymentSyncState
}

export type QuarterlyRevenue = {
  __typename: 'QuarterlyRevenue'
  amount: Scalars['Float']['output']
  period: Scalars['String']['output']
}

export type Query = {
  __typename: 'Query'
  CreateUserAndPartner?: Maybe<CreateUserAndPartnerReply>
  FindAutopayRule?: Maybe<AutopayRule>
  FindInvoice?: Maybe<Invoice>
  GetAdyenDocumentTypes: Array<AdyenUploadDocumentType>
  GetAdyenHostedOnboardingLink?: Maybe<GetAdyenHostedOnboardingLinkResponse>
  GetAdyenOnboardingStatus: AdyenOnboardingStatus
  GetAdyenPciForms: AdyenPciForms
  GetAdyenRemediationActions: GetAdyenRemediationActionsReply
  GetAdyenTermsOfService: Array<AdyenTermsOfServiceDocument>
  GetCompanyIndividuals: Array<CompanyIndividual>
  GetCustomerAutopayConfig?: Maybe<GetCustomerAutopayConfigReply>
  GetPartnerDocuments: Array<CompanyDocument>
  GetSupportPreferences?: Maybe<SupportPreferences>
  GetUserInfo?: Maybe<PartnerGetUserInfoReply>
  GetUserPartners: Array<Maybe<Partner>>
  /**
   * PUBLIC (unauthenticated) query. Fetches the card context shown on the
   * vendor reveal landing page. Delegates 1:1 to the svc-accounts-payable
   * GetVendorCardView RPC (AP-844); all failure modes are mapped to an
   * opaque gateway error.
   */
  GetVendorCardView: PublicVendorCardView
  GetVendorDataRequestByToken: PublicVendorDataResponse
  OAuth2Url: Scalars['String']['output']
  PartnerAccountingSyncConfigGet?: Maybe<SyncConfig>
  /**
   * Summary aggregates backing the Payments-page cards. Proxies to the
   * svc-accounts-payable GetPaymentAggregates RPC and shares the same
   * AccountsPayablePaymentFilter as PartnerAccountsPayablePaymentList so the
   * cards reflect the table's active filters.
   */
  PartnerAccountsPayablePaymentAggregates: AccountsPayablePaymentAggregates
  /**
   * Vendor payment log backing the Virtual Card Log screen. Proxies to the
   * svc-accounts-payable ListPayments RPC. The full VendorPaymentStatus
   * spectrum is preserved so the log can distinguish READY from SUCCEEDED.
   */
  PartnerAccountsPayablePaymentList: AccountsPayablePaymentListResponse
  PartnerAgreementTypeConnection: AgreementTypeConnection
  PartnerApiKeyConnection?: Maybe<ApiKeyConnection>
  PartnerArInvoiceList: InvoiceList
  /** Returns a gateway-proxied URL that streams the file binary. Exactly one of fileID (Anthropic file ID) or path (session path) must be supplied. */
  PartnerAssistantV2FileDownloadURL: Scalars['String']['output']
  PartnerAutopayExcludedCustomerConnection?: Maybe<AutopayExcludedCustomerConnection>
  PartnerAutopayExcludedCustomerListTotals: AutopayExcludedCustomerTotals
  PartnerAutotaskContractConnection: AutotaskContractConnection
  PartnerAutotaskGetConnection: AutotaskConnection
  PartnerAutotaskGetFilters?: Maybe<AutotaskQueryFilters>
  PartnerBillList: BillListResponse
  /** @deprecated Use PartnerBillList instead */
  PartnerBillsConnection: BillConnection
  PartnerCalculatePaymentFee: FeeSplitResult
  PartnerCollectionConnection?: Maybe<CollectionConnection>
  PartnerCollectionTotals: CollectionTotals
  PartnerConnectWiseAgreementConnection: ConnectWiseAgreementConnection
  PartnerConnectWiseBillingTermsConnection?: Maybe<ConnectWiseBillingTermsConnection>
  PartnerConnectWiseGetConnection?: Maybe<ConnectWiseConnection>
  PartnerConnectWiseGetFilters?: Maybe<ConnectWiseQueryFilters>
  PartnerConnectWiseGlSegmentsGet: Array<ConnectWiseGlSegment>
  PartnerConnectWiseTaxCodeGet: Array<ConnectWiseTaxCode>
  PartnerContractSubtypeConnection: ContractSubtypeConnection
  PartnerContractTypeConnection: ContractTypeConnection
  PartnerCountBills: Scalars['Int']['output']
  PartnerCustomerAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  PartnerCustomerConnection?: Maybe<CustomerConnection>
  PartnerCustomerTagsAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  PartnerCustomerUserConnection?: Maybe<CustomerUserConnection>
  PartnerEmailActivityConnection?: Maybe<EmailActivityConnection>
  PartnerFindBillByID?: Maybe<Bill>
  /**
   * Resolves the Postmark inbound email that originated a bill — sender,
   * recipient, subject, date, text + html body, and every attachment from
   * the original message. The attachment whose `isUsedForBill` is true is
   * the PDF that was OCR'd into the bill.
   *
   * Returns null for bills created via MANUAL entry, QUICKBOOKS sync, or
   * OCR direct-upload (no inbound email linkage).
   */
  PartnerFindInboundEmailByBillID?: Maybe<InboundEmail>
  PartnerFindPaymentPreferenceByVendorID?: Maybe<PaymentPreference>
  PartnerFindReminder?: Maybe<InvoiceReminder>
  PartnerFindSummary?: Maybe<InvoiceSummary>
  PartnerFindVendorByID?: Maybe<Vendor>
  PartnerGetARAgingBucketsAmountInsight?: Maybe<ArAgingBucketsAmountResponse>
  PartnerGetARAgingBucketsCountInsight?: Maybe<ArAgingBucketsCountResponse>
  PartnerGetARAgingBucketsWithClientsInsight?: Maybe<ArAgingBucketsWithClientsResponse>
  PartnerGetAccountingPreferences?: Maybe<AccountingPreferences>
  PartnerGetAccountingSyncBatch?: Maybe<GetAccountingSyncBatchReply>
  /**
   * Get the Accounts Payable configuration for the authenticated partner.
   * Returns mailbox and onboarding status.
   */
  PartnerGetAccountsPayableConfig: AccountsPayableConfig
  PartnerGetActivationRateInvoiceVolumeByMonthInsight?: Maybe<ActivationRateInvoiceVolumeByMonthResponse>
  PartnerGetActivationRatesByMonthInsight?: Maybe<ActivationRatesByMonthResponse>
  PartnerGetAdminCardFeesConfig?: Maybe<Array<PartnerCardFeeDetail>>
  PartnerGetAgentLoads: Array<AgentUtilizationResult>
  PartnerGetAgentMonthlyHours: Array<AgentMonthlyHours>
  PartnerGetAgentTicketCounts: Array<AgentTicketCountItem>
  PartnerGetAnalyticsClientById?: Maybe<AnalyticsClientInfo>
  /**
   * Per-source last-successful-sync for the data-sources popover (ANA-266).
   * Intentionally NOT gated by a single @auth permission: the popover renders
   * on every Analytics page (Overview / Client Trends / Utilization), each of
   * which carries its own read permission (OVERVIEW_READ / CLIENT_TRENDS_READ /
   * UTILIZATION_READ). Permission arrays are AND-evaluated, so gating here would
   * break the popover for any user holding only one of them. The data is
   * non-sensitive (integration display names + sync timestamps) and the resolver
   * still requires an authenticated partner context (errors if absent).
   */
  PartnerGetAnalyticsSyncState: AnalyticsSyncStateResponse
  PartnerGetAssistantConversation: AssistantConversationDetail
  /** Returns the v2 conversation metadata. Unlike the v1 getter, this does not return messages — v2 messages are streamed from Anthropic via the subscription. */
  PartnerGetAssistantV2Conversation: AssistantV2Conversation
  /**
   * Returns the prior Anthropic session events for a v2 conversation in chronological
   * order so the frontend can backfill the thread when reopening it. v2 messages are
   * not persisted in our DB — Anthropic's event log is the source of truth — so this
   * is the only read path for conversation history.
   *
   * Pass nextCursor from the previous response back as `after` to fetch the next
   * page. Limit defaults to 200 and is clamped to 500.
   */
  PartnerGetAssistantV2ConversationHistory: AssistantV2ConversationHistory
  /**
   * Reports whether a turn is currently running on a v2 conversation, backed by
   * AR's heartbeat-stamped turn lock. The frontend probes this once on cold load
   * (after restoring the active conversation) to decide whether to open a
   * read-only re-attach subscription — there is no polling loop.
   */
  PartnerGetAssistantV2TurnStatus: AssistantV2TurnStatus
  PartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsight?: Maybe<AutomatedPaymentVolumePercentByMonthResponse>
  PartnerGetAutomatedPaymentVolumePercentByMonthInsight?: Maybe<AutomatedPaymentVolumePercentByMonthResponse>
  PartnerGetAutomatedPaymentVolumePercentageInsight?: Maybe<AutomatedPaymentVolumePercentageResponse>
  PartnerGetAutomatedPaymentsByMonthInsight?: Maybe<AutomatedPaymentsByMonthResponse>
  PartnerGetAutomatedPaymentsCustomerInsight?: Maybe<AutomatedPaymentsResponse>
  PartnerGetAutomatedPaymentsInsight?: Maybe<AutomatedPaymentsResponse>
  PartnerGetAutomatedTransactionCountInsight?: Maybe<AutomatedTransactionCountResponse>
  PartnerGetAverageDaysOverdueInsight?: Maybe<AverageDaysOverdueResponse>
  PartnerGetAverageInvoiceAmountInsight?: Maybe<AverageInvoiceAmountResponse>
  PartnerGetAverageOverdueAmountInsight?: Maybe<AverageOverdueAmountResponse>
  PartnerGetAveragePaymentSizeInsight?: Maybe<AveragePaymentSizeResponse>
  PartnerGetAverageTimeToPayAutopayInsight?: Maybe<AverageTimeToPayAutopayResponse>
  PartnerGetAverageTimeToPayByMonthCustomerInsight?: Maybe<AverageTimeToPayByMonthResponse>
  PartnerGetAverageTimeToPayByMonthInsight?: Maybe<AverageTimeToPayByMonthResponse>
  PartnerGetAverageTimeToPayCustomerInsight?: Maybe<AverageTimeToPayResponse>
  PartnerGetAverageTimeToPayExternalInsight?: Maybe<AverageTimeToPayExternalResponse>
  PartnerGetAverageTimeToPayExternalVsInternalByMonthInsight?: Maybe<AverageTimeToPayExternalVsInternalByMonthResponse>
  PartnerGetAverageTimeToPayInsight?: Maybe<AverageTimeToPayResponse>
  PartnerGetBankAccount?: Maybe<BankAccount>
  PartnerGetBillAggregates: BillAggregates
  PartnerGetCardFee?: Maybe<CardFeeAmount>
  PartnerGetCardPubKey?: Maybe<Scalars['String']['output']>
  PartnerGetCashFlowDistributionInsight?: Maybe<CashFlowDistributionResponse>
  PartnerGetCashFlowDistributionLastThirtyDaysInsight?: Maybe<CashFlowDistributionLastThirtyDaysReponse>
  PartnerGetClientKPIs: UtilizationKpiResult
  PartnerGetClientTicketCounts: Array<ClientTicketCountItem>
  PartnerGetClientTrendsBreakdown: ClientTrendsBreakdownResult
  PartnerGetClientTrendsClients: ClientTrendsClients
  PartnerGetClientTrendsFilterValues: ClientTrendsFilterValuesResult
  PartnerGetClientTrendsPreset: ClientTrendsPreset
  PartnerGetClientTrendsRankings: ClientTrendsRankings
  PartnerGetClientTrendsSummary: ClientTrendsSummary
  PartnerGetClientTrendsTrendData: ClientTrendLine
  PartnerGetCompanyIndividualByUploadLink?: Maybe<CompanyIndividual>
  PartnerGetCoveredInvoicesForRule: Array<Invoice>
  PartnerGetCreditMemoConfig: CreditMemoConfig
  PartnerGetCreditMemoDetails: CreditMemoDetail
  PartnerGetCustomPartnerFeeConfigs?: Maybe<CustomPartnerFeeConfigs>
  PartnerGetCustomer?: Maybe<Customer>
  PartnerGetCustomerCardFee?: Maybe<CardFeeAmount>
  PartnerGetCustomerCreditMemoBalance: CustomerCreditMemoBalance
  PartnerGetCustomerPaymentConfig?: Maybe<PaymentCompanyConfig>
  PartnerGetCustomerSummary?: Maybe<CustomerSummary>
  PartnerGetCustomersPaymentConfig?: Maybe<Array<Maybe<PaymentCompanyConfig>>>
  PartnerGetCustomersSummary: CustomersSummary
  PartnerGetFeeRates?: Maybe<CollectionFeeRates>
  PartnerGetInvoiceAmountByStatusMonthCustomerInsight?: Maybe<InvoiceAmountByStatusMonthResponse>
  PartnerGetInvoiceAmountByStatusMonthInsight?: Maybe<InvoiceAmountByStatusMonthResponse>
  PartnerGetInvoiceBulkCharges?: Maybe<PartnerInvoiceBulkChargeConnection>
  PartnerGetInvoiceCountByStatusMonthInsight?: Maybe<InvoiceCountByStatusMonthResponse>
  PartnerGetInvoiceCountInsight?: Maybe<InvoiceCountResponse>
  PartnerGetInvoiceLedgerMovements?: Maybe<LedgerMovementResult>
  PartnerGetInvoicePdfLink: InvoicePdfLink
  PartnerGetInvoicePreferences?: Maybe<InvoicePreferences>
  PartnerGetInvoiceVolumeCustomerInsight?: Maybe<InvoiceVolumeResponse>
  PartnerGetInvoiceVolumeInsight?: Maybe<InvoiceVolumeResponse>
  PartnerGetInvoicesSummary: InvoicesSummary
  PartnerGetLaborCostImpact: UtilizationLaborCostImpactResult
  PartnerGetLastRefreshTriggered: LastRefreshTriggeredReply
  PartnerGetNotificationsEnabled: NotificationsEnabled
  PartnerGetNumberOfOverdueInvoicesThirtyDaysInsight?: Maybe<NumberOfOverdueInvoicesThirtyDaysResponse>
  PartnerGetNumberOfPaymentsCustomerInsight?: Maybe<NumberOfPaymentsResponse>
  PartnerGetNumberOfPaymentsInsight?: Maybe<NumberOfPaymentsResponse>
  PartnerGetOpenPayoutBalanceTotals?: Maybe<OpenPayoutBalanceTotals>
  PartnerGetOpenPayoutBreakdownItemsConnection?: Maybe<OpenPayoutBreakdownItemConnection>
  PartnerGetOpenPayoutDetails?: Maybe<OpenPayoutDetails>
  PartnerGetOpenPayoutsConnection?: Maybe<OpenPayoutConnection>
  PartnerGetOverdueInvoiceCountInsight?: Maybe<OverdueInvoiceCountResponse>
  PartnerGetOverdueInvoicePercentageInsight?: Maybe<OverdueInvoicePercentageResponse>
  PartnerGetOverdueInvoiceVolumeInsight?: Maybe<OverdueInvoiceVolumeResponse>
  PartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsight?: Maybe<OverdueInvoicesVolumeThirtyDaysResponse>
  PartnerGetOverdueInvoicesVolumeThirtyDaysInsight?: Maybe<OverdueInvoicesVolumeThirtyDaysResponse>
  PartnerGetOverdueRateAtMaturityInsight?: Maybe<OverdueRateAtMaturityResponse>
  PartnerGetOverviewEfficiency: OverviewEfficiencyResult
  PartnerGetOverviewMRR: OverviewMrrResult
  PartnerGetOverviewProfitability: OverviewProfitabilityResult
  PartnerGetOverviewSummary: OverviewSummaryResult
  PartnerGetPartnerAutopayConfig?: Maybe<PartnerAutopayConfig>
  PartnerGetPartnerFeeConfig?: Maybe<PartnerFeeConfig>
  PartnerGetPassThroughFees?: Maybe<Array<PassThroughFee>>
  PartnerGetPaymentConfig?: Maybe<PaymentCompanyConfig>
  PartnerGetPaymentCountByTriggerLastMonthInsight?: Maybe<PaymentCountByTriggerLastMonthResponse>
  PartnerGetPaymentMethodUsage: Array<PaymentMethodUsage>
  PartnerGetPaymentVolumeAutomatedInsight?: Maybe<PaymentVolumeAutomatedResponse>
  PartnerGetPaymentVolumeByMonthCustomerInsight?: Maybe<PaymentVolumeByMonthResponse>
  PartnerGetPaymentVolumeByMonthInsight?: Maybe<PaymentVolumeByMonthResponse>
  PartnerGetPaymentVolumeByTriggerLastMonthInsight?: Maybe<PaymentVolumeByTriggerLastMonthResponse>
  PartnerGetPaymentVolumeCustomerInsight?: Maybe<PaymentVolumeResponse>
  PartnerGetPaymentVolumeInsight?: Maybe<PaymentVolumeResponse>
  PartnerGetPaymentsCountByMethodMonthInsight?: Maybe<PaymentsCountByMethodMonthResponse>
  PartnerGetPaymentsVolumeByMethodMonthInsight?: Maybe<PaymentsVolumeByMethodMonthResponse>
  PartnerGetPayoutConfig?: Maybe<PayoutCompanyConfig>
  PartnerGetPayoutTimingCompanyConfig?: Maybe<CompanyPayoutTimingConfigs>
  PartnerGetPayoutTimingPlans?: Maybe<Array<Maybe<PayoutTimingPlan>>>
  PartnerGetRecentActivity: Array<ActivityItem>
  PartnerGetReferralLink: Scalars['String']['output']
  PartnerGetReferralLinkInfo: ReferralLinkInfo
  PartnerGetReferralPayoutByPayoutID?: Maybe<ReferralPayout>
  /** One routine the caller owns, by id. */
  PartnerGetRoutine: Routine
  /** One run of a routine, with output text and downloadable artifact metadata. */
  PartnerGetRoutineRun: RoutineRun
  PartnerGetScheduledOneOffEmail?: Maybe<ScheduledOneOffEmail>
  PartnerGetSpendByCategory: SpendByCategory
  PartnerGetTicketList: TicketListResult
  PartnerGetUnsyncedInvoiceTotals?: Maybe<UnsyncedInvoiceTotals>
  PartnerGetUtilizationBreakdown: Array<UtilizationBreakdownItem>
  PartnerGetUtilizationFilterValues: UtilizationFilterValuesResult
  PartnerGetUtilizationKPIs: UtilizationKpiResult
  PartnerGetUtilizationOverview: UtilizationOverviewResult
  PartnerGetUtilizationPercentage: Scalars['Float']['output']
  PartnerGetUtilizationPreset: UtilizationPreset
  PartnerGetUtilizationSeries: UtilizationSeriesResult
  PartnerGetUtilizationSummary: Array<UtilizationSummaryItem>
  /**
   * Get groups of similar/duplicate vendors for deduplication review.
   * Optionally filter by specific vendor IDs and include previously dismissed groups.
   * Requires ACCOUNTS_PAYABLE_VIEW_VENDOR permission.
   */
  PartnerGetVendorSimilarityGroups: VendorSimilarityGroupsResponse
  PartnerGetVendorSpend: Array<VendorSpend>
  PartnerGetVendorTotals: Array<VendorTotals>
  PartnerGlobalAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  PartnerHaloPSAContractConnection: HaloPsaContractConnection
  PartnerHaloPSATopLevelList: Array<HaloPsaTopLevel>
  PartnerHomeAutopayCoverage: HomeAutopayCoverage
  PartnerHomeCashFlow: HomeCashFlow
  PartnerHomeCustomersNeedingAttention: HomeCustomersNeedingAttention
  PartnerHomeInvoicePipeline: HomeInvoicePipeline
  PartnerHomeOutstandingAR: HomeOutstandingAr
  PartnerHomePaymentMethodIssues: HomePaymentMethodIssues
  PartnerHomePerformance: HomePerformance
  PartnerHomeTopCustomersOwed: HomeTopCustomersOwed
  PartnerHomeTopCustomersPaid: HomeTopCustomersPaid
  PartnerIntegrationIssueConnection: IntegrationIssueConnection
  PartnerIntegrationIssueCounts: IntegrationIssueCounts
  PartnerIntegrationJobConnection: IntegrationJobConnection
  PartnerIntegrationJobFailureCount: IntegrationJobFailureCount
  PartnerIntegrationJobQueueConnection: IntegrationJobQueueConnection
  PartnerInvoiceBnplConnection?: Maybe<InvoiceBnplConnection>
  PartnerInvoiceConnection: InvoiceConnection
  PartnerInvoiceListTotals?: Maybe<InvoiceTotals>
  /**
   * List accounting items from external accounting system.
   * Supports pagination and filtering by active status.
   */
  PartnerListAccountingItems: AccountingItemList
  PartnerListAccountingSyncBatches?: Maybe<ListAccountingSyncBatchesReply>
  PartnerListAccountingSyncJobs?: Maybe<ListAccountingSyncJobsReply>
  PartnerListActiveSubscriptions: Array<PartnerSubscription>
  PartnerListAssistantConversations: AssistantConversationList
  PartnerListAssistantV2ConversationFiles: Array<AssistantV2File>
  PartnerListAssistantV2Conversations: AssistantV2ConversationList
  PartnerListAutopayExcludedInvoices: Array<AutopayExcludedInvoice>
  PartnerListAvailableIntegrations: AvailableIntegrationsReply
  PartnerListBankingIntegrations: Array<Maybe<Institution>>
  PartnerListCards?: Maybe<Array<Maybe<Card>>>
  PartnerListClientTrendsPresets: Array<ClientTrendsPreset>
  PartnerListCreditMemos: CreditMemoListResponse
  PartnerListCreditMemosByCustomerId: CreditMemoListResponse
  PartnerListCustomerBankingIntegrations: Array<Maybe<Institution>>
  PartnerListCustomerCards?: Maybe<Array<Maybe<Card>>>
  PartnerListCustomerFeeExceptions?: Maybe<Array<CustomerFeeConfig>>
  PartnerListCustomerRulesTotals?: Maybe<AutopayRuleTotals>
  PartnerListCustomerTags?: Maybe<Array<CustomerTag>>
  PartnerListCustomers: PartnerListCustomersPage
  PartnerListCustomersTotals?: Maybe<PartnerCustomerTotals>
  PartnerListEmailTemplates?: Maybe<Array<EmailTemplate>>
  PartnerListExpenseAccounts: Array<ExpenseAccount>
  PartnerListIntegrations?: Maybe<Array<Maybe<IntegrationInterface>>>
  PartnerListInvoiceReminderExcludedCustomers?: Maybe<
    Array<Maybe<InvoiceReminderExcludedCustomer>>
  >
  PartnerListInvoiceReminders?: Maybe<Array<Maybe<InvoiceReminder>>>
  PartnerListInvoiceSummaries?: Maybe<Array<Maybe<InvoiceSummary>>>
  PartnerListInvoiceSummaryExcludedCustomers?: Maybe<
    Array<Maybe<InvoiceSummaryExcludedCustomer>>
  >
  PartnerListPayments?: Maybe<PaymentPage>
  PartnerListPendingCustomerUsersTotals?: Maybe<PendingCustomerUsersTotals>
  /** One page of a routine's run history, newest first. */
  PartnerListRoutineRuns: RoutineRunList
  /** One page of the caller's own routines. Search, sort, and pagination run server-side in svc-accounts-receivable. */
  PartnerListRoutines: RoutineList
  PartnerListSubscriptionPaymentsTotals: SubscriptionPaymentsTotals
  /**
   * List unit types for the authenticated partner.
   * Supports filtering by IDs and soft-deleted items.
   */
  PartnerListUnitTypes: UnitTypeListResponse
  PartnerListUnsyncedInvoices?: Maybe<UnsyncedInvoices>
  PartnerListUtilizationPresets: Array<UtilizationPreset>
  /**
   * List audit logs for a specific vendor.
   * Supports pagination with limit and offset.
   */
  PartnerListVendorAuditLog: VendorAuditLogListResponse
  PartnerListVendorDataRequests: Array<VendorDataRequest>
  PartnerListVisibleExpenseAccounts: Array<ExpenseAccount>
  PartnerLogoUploadURL?: Maybe<PartnerLogoUploadUrl>
  /**
   * The earliest pay date a bill can be scheduled on: today plus the funding
   * lead (5 business days), skipping weekends and US federal holidays. Returned
   * as an RFC3339 timestamp at 00:00 UTC. The partner-front uses this to block
   * earlier dates in the Pay Date picker and to gate the approve-and-pay action.
   */
  PartnerNextValidPayDate: Scalars['String']['output']
  PartnerPaymentConnection?: Maybe<PaymentConnection>
  PartnerPaymentTotals?: Maybe<PaymentTotals>
  PartnerPayoutBreakdownListItemConnection?: Maybe<BreakdownListItemConnection>
  PartnerPayoutConnection?: Maybe<PayoutConnection>
  PartnerPayoutDetails?: Maybe<PayoutDetails>
  PartnerPayoutTotals?: Maybe<PayoutTotals>
  PartnerPendingCustomerUserConnection?: Maybe<PendingCustomerUserConnection>
  PartnerQuickbooksAccountList: QuickbooksAccountsListReply
  PartnerQuickbooksAccountRetrieve: QuickbooksAccountsRetrieveReply
  PartnerQuickbooksConnectionRead?: Maybe<QuickbooksConnection>
  PartnerQuickbooksConnectionURL?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksCustomerTypeList: QuickbooksCustomerTypeListReply
  PartnerQuickbooksInvoiceCustomFieldsList: Array<QuickbooksInvoiceCustomField>
  PartnerQuickbooksTaxCodeGet: Array<QuicbooksTaxCode>
  PartnerRecurringPaymentConnection: RecurringPaymentConnection
  PartnerRecurringPaymentTotals?: Maybe<RecurringPaymentTotals>
  PartnerRecurringTransactionConnection: RecurringTransactionConnection
  PartnerReferralConnection?: Maybe<ReferralConnection>
  PartnerReferralGetAvailableForPayoutData: GetReferralDataReply
  PartnerReferralGetAvgQuarterlyFeesData: GetReferralDataReply
  PartnerReferralGetQuarterlyEarningsData: GetReferralDataReply
  PartnerReferralGetTotalReferralFeesData: GetReferralDataReply
  PartnerResolveCustomerIntegrationIDs: ResolveCustomerIntegrationIDsResult
  /** Gateway-proxied URL that streams a run artifact binary. Exactly one of fileID (Anthropic file id) or path (artifact filename) must be supplied. */
  PartnerRoutineRunFileDownloadURL: Scalars['String']['output']
  PartnerRutterAccountList?: Maybe<Array<Maybe<RutterAccount>>>
  PartnerRutterAccountRead?: Maybe<RutterSelectedAccounts>
  PartnerRutterConnectionRead?: Maybe<RutterConnection>
  PartnerRutterPaymentTermsConnection?: Maybe<RutterPaymentTermsConnection>
  PartnerRutterSubsidiaryList?: Maybe<RutterSubsidiaryListResponse>
  PartnerScheduledOneOffEmailConnection: ScheduledOneOffEmailConnection
  PartnerScopeCatalog: Array<Scope>
  /**
   * Search accounting items by name or description.
   * Supports filtering by active status.
   */
  PartnerSearchAccountingItems: Array<AccountingItem>
  PartnerSubscriptionsPaymentsConnection: SubscriptionPaymentConnection
  PartnerUserConnection?: Maybe<PartnerUserConnection>
  PartnerVendorList: VendorListResponse
  /** @deprecated Use PartnerVendorList instead */
  PartnerVendorsConnection: VendorConnection
  integrationPermissions?: Maybe<IntegrationPermissions>
  /**
   * Download a bill document by bill ID.
   * Returns presigned S3 URL for temporary authenticated download access.
   * Returns null when the bill has no document available (MANUAL bills,
   * QuickBooks bills, OCR bills whose email attachment has no S3 path).
   * Requires ACCOUNTS_PAYABLE_VIEW_BILL permission.
   */
  partnerDownloadBillDocument?: Maybe<BillDocumentDownload>
  /**
   * Download a vendor document by ID.
   * Returns document metadata with a presigned S3 URL for temporary authenticated download access (5-minute expiration).
   * Requires ACCOUNTS_PAYABLE_VIEW_VENDOR_DOCUMENT permission.
   */
  partnerDownloadVendorDocument: VendorDocumentDownload
  /**
   * List all documents for a specific vendor.
   * Returns documents ordered by creation date (most recent first).
   * Requires ACCOUNTS_PAYABLE_VIEW_VENDOR_DOCUMENT permission.
   */
  partnerListVendorDocuments: Array<VendorDocument>
}

export type QueryCreateUserAndPartnerArgs = {
  referralID?: InputMaybe<Scalars['String']['input']>
}

export type QueryFindAutopayRuleArgs = {
  id: Scalars['ID']['input']
}

export type QueryFindInvoiceArgs = {
  id: Scalars['String']['input']
}

export type QueryGetAdyenDocumentTypesArgs = {
  ownerType: AdyenOwnerType
}

export type QueryGetCustomerAutopayConfigArgs = {
  input: GetCustomerAutopayConfigInput
}

export type QueryGetVendorCardViewArgs = {
  token: Scalars['String']['input']
}

export type QueryGetVendorDataRequestByTokenArgs = {
  token: Scalars['String']['input']
}

export type QueryOAuth2UrlArgs = {
  redirectUri?: InputMaybe<Scalars['String']['input']>
  referralID?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPartnerAccountingSyncConfigGetArgs = {
  input: SyncConfigGetInput
}

export type QueryPartnerAccountsPayablePaymentAggregatesArgs = {
  filters?: InputMaybe<AccountsPayablePaymentFilter>
}

export type QueryPartnerAccountsPayablePaymentListArgs = {
  filters?: InputMaybe<AccountsPayablePaymentFilter>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AccountsPayablePaymentOrderBy>
}

export type QueryPartnerAgreementTypeConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<AgreementTypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AgreementTypeOrderBy>
}

export type QueryPartnerApiKeyConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<ApiKeyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ApiKeyOrderBy>
}

export type QueryPartnerArInvoiceListArgs = {
  filters?: InputMaybe<ArInvoiceFilter>
  order?: InputMaybe<ArInvoiceOrder>
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type QueryPartnerAssistantV2FileDownloadUrlArgs = {
  conversationID: Scalars['ID']['input']
  fileID?: InputMaybe<Scalars['String']['input']>
  path?: InputMaybe<Scalars['String']['input']>
}

export type QueryPartnerAutopayExcludedCustomerConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayExcludedCustomerOrderBy>
}

export type QueryPartnerAutopayExcludedCustomerListTotalsArgs = {
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
}

export type QueryPartnerAutotaskContractConnectionArgs = {
  filter?: InputMaybe<AutotaskContractFilter>
}

export type QueryPartnerBillListArgs = {
  filters?: InputMaybe<BillFilter>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<BillOrderBy>
}

export type QueryPartnerBillsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<BillFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<BillOrderBy>
}

export type QueryPartnerCalculatePaymentFeeArgs = {
  input: CalculatePaymentFeeInput
}

export type QueryPartnerCollectionConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  collectionFilter?: InputMaybe<CollectionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CollectionOrder>
}

export type QueryPartnerCollectionTotalsArgs = {
  collectionFilter?: InputMaybe<CollectionFilter>
}

export type QueryPartnerConnectWiseAgreementConnectionArgs = {
  filter?: InputMaybe<ConnectWiseAgreementFilter>
}

export type QueryPartnerConnectWiseBillingTermsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CwBillingTermsFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CwBillingTermsOrderBy>
}

export type QueryPartnerContractSubtypeConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<ContractSubtypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractSubtypeOrderBy>
}

export type QueryPartnerContractTypeConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<ContractTypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractTypeOrderBy>
}

export type QueryPartnerCountBillsArgs = {
  input: CountBillsInput
}

export type QueryPartnerCustomerAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryPartnerCustomerConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<CustomerFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CustomerOrderBy>
}

export type QueryPartnerCustomerTagsAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryPartnerCustomerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<CustomerUserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CustomerUserOrderBy>
}

export type QueryPartnerEmailActivityConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<EmailActivityFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerFindBillByIdArgs = {
  billID: Scalars['String']['input']
}

export type QueryPartnerFindInboundEmailByBillIdArgs = {
  billID: Scalars['String']['input']
}

export type QueryPartnerFindPaymentPreferenceByVendorIdArgs = {
  vendorID: Scalars['String']['input']
}

export type QueryPartnerFindReminderArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerFindSummaryArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerFindVendorByIdArgs = {
  vendorID: Scalars['String']['input']
}

export type QueryPartnerGetArAgingBucketsAmountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetArAgingBucketsCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetArAgingBucketsWithClientsInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAccountingSyncBatchArgs = {
  batchID: Scalars['ID']['input']
}

export type QueryPartnerGetActivationRateInvoiceVolumeByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetActivationRatesByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAgentLoadsArgs = {
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetAgentMonthlyHoursArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetAgentTicketCountsArgs = {
  input: AgentTicketCountsInput
}

export type QueryPartnerGetAnalyticsClientByIdArgs = {
  clientId: Scalars['ID']['input']
}

export type QueryPartnerGetAssistantConversationArgs = {
  conversationID: Scalars['ID']['input']
  messageLimit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerGetAssistantV2ConversationArgs = {
  conversationID: Scalars['ID']['input']
}

export type QueryPartnerGetAssistantV2ConversationHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  conversationID: Scalars['ID']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerGetAssistantV2TurnStatusArgs = {
  conversationID: Scalars['ID']['input']
}

export type QueryPartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsightArgs =
  {
    customerID: Scalars['String']['input']
    dateFrom: Scalars['String']['input']
    dateTo: Scalars['String']['input']
  }

export type QueryPartnerGetAutomatedPaymentVolumePercentByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentVolumePercentageInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentsByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentsCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentsInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedTransactionCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageDaysOverdueInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageInvoiceAmountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageOverdueAmountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAveragePaymentSizeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayAutopayInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayByMonthCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayExternalInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayExternalVsInternalByMonthInsightArgs =
  {
    dateFrom: Scalars['String']['input']
    dateTo: Scalars['String']['input']
  }

export type QueryPartnerGetAverageTimeToPayInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetBankAccountArgs = {
  bankAccountID: Scalars['ID']['input']
}

export type QueryPartnerGetBillAggregatesArgs = {
  input: GetBillAggregatesInput
}

export type QueryPartnerGetCardFeeArgs = {
  input: GetCardFeeInput
}

export type QueryPartnerGetCardPubKeyArgs = {
  input: GetCardPubKey
}

export type QueryPartnerGetCashFlowDistributionInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  granularity?: InputMaybe<Granularity>
}

export type QueryPartnerGetClientKpIsArgs = {
  clientId: Scalars['ID']['input']
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetClientTicketCountsArgs = {
  input: ClientTicketCountsInput
}

export type QueryPartnerGetClientTrendsBreakdownArgs = {
  input: GetClientTrendsBreakdownInput
}

export type QueryPartnerGetClientTrendsClientsArgs = {
  input: GetClientTrendsClientsInput
}

export type QueryPartnerGetClientTrendsFilterValuesArgs = {
  endDate: Scalars['String']['input']
  filterType: ClientTrendsFilterType
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetClientTrendsPresetArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetClientTrendsRankingsArgs = {
  input: ClientTrendBaseInput
}

export type QueryPartnerGetClientTrendsSummaryArgs = {
  input: ClientTrendBaseInput
}

export type QueryPartnerGetClientTrendsTrendDataArgs = {
  input: ClientTrendBaseInput
}

export type QueryPartnerGetCompanyIndividualByUploadLinkArgs = {
  uploadLinkId: Scalars['ID']['input']
}

export type QueryPartnerGetCoveredInvoicesForRuleArgs = {
  input: PartnerGetCoveredInvoicesForRuleInput
}

export type QueryPartnerGetCreditMemoDetailsArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetCustomPartnerFeeConfigsArgs = {
  customPartnerFeeConfigsFilter?: InputMaybe<CustomPartnerFeeConfigsFilter>
}

export type QueryPartnerGetCustomerArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetCustomerCardFeeArgs = {
  input: GetCustomerCardFeeInput
}

export type QueryPartnerGetCustomerCreditMemoBalanceArgs = {
  customerID: Scalars['ID']['input']
}

export type QueryPartnerGetCustomerPaymentConfigArgs = {
  customerID: Scalars['ID']['input']
}

export type QueryPartnerGetCustomerSummaryArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetCustomersPaymentConfigArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryPartnerGetFeeRatesArgs = {
  input: GetFeeRatesInput
}

export type QueryPartnerGetInvoiceAmountByStatusMonthCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceAmountByStatusMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceBulkChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  getPartnerInvoiceBulkChargesFilter?: InputMaybe<GetPartnerInvoiceBulkChargesFilter>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<GetPartnerInvoiceBulkChargesOrderBy>
}

export type QueryPartnerGetInvoiceCountByStatusMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceLedgerMovementsArgs = {
  invoiceID: Scalars['String']['input']
}

export type QueryPartnerGetInvoicePdfLinkArgs = {
  invoiceID: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceVolumeCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceVolumeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetLaborCostImpactArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetLastRefreshTriggeredArgs = {
  platformName: PlatformName
}

export type QueryPartnerGetNumberOfOverdueInvoicesThirtyDaysInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetNumberOfPaymentsCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetNumberOfPaymentsInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOpenPayoutBreakdownItemsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  openPayoutID: Scalars['ID']['input']
}

export type QueryPartnerGetOpenPayoutDetailsArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetOpenPayoutsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<OpenPayoutFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerGetOverdueInvoiceCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoicePercentageInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoiceVolumeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsightArgs =
  {
    customerID: Scalars['String']['input']
    dateFrom: Scalars['String']['input']
    dateTo: Scalars['String']['input']
  }

export type QueryPartnerGetOverdueInvoicesVolumeThirtyDaysInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueRateAtMaturityInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverviewEfficiencyArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetOverviewMrrArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetOverviewProfitabilityArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetOverviewSummaryArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetPassThroughFeesArgs = {
  methodNetworks?: InputMaybe<Array<MethodNetwork>>
}

export type QueryPartnerGetPaymentMethodUsageArgs = {
  input: GetPaymentMethodUsageInput
}

export type QueryPartnerGetPaymentVolumeAutomatedInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeByMonthCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentsCountByMethodMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentsVolumeByMethodMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetRecentActivityArgs = {
  input: GetRecentActivityInput
}

export type QueryPartnerGetReferralPayoutByPayoutIdArgs = {
  payoutID: Scalars['ID']['input']
}

export type QueryPartnerGetRoutineArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetRoutineRunArgs = {
  routineID: Scalars['ID']['input']
  runID: Scalars['ID']['input']
}

export type QueryPartnerGetScheduledOneOffEmailArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetSpendByCategoryArgs = {
  input: GetSpendByCategoryInput
}

export type QueryPartnerGetTicketListArgs = {
  input: TicketListInput
}

export type QueryPartnerGetUnsyncedInvoiceTotalsArgs = {
  filters?: InputMaybe<UnsyncedInvoicesFilter>
}

export type QueryPartnerGetUtilizationBreakdownArgs = {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetUtilizationFilterValuesArgs = {
  endDate: Scalars['String']['input']
  filterType: UtilizationFilterType
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetUtilizationKpIsArgs = {
  agentId: Scalars['ID']['input']
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetUtilizationOverviewArgs = {
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  grouping: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<UtilizationOverviewSortBy>
  sortOrder?: InputMaybe<OrderDirection>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetUtilizationPercentageArgs = {
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetUtilizationPresetArgs = {
  id: Scalars['ID']['input']
}

export type QueryPartnerGetUtilizationSeriesArgs = {
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  granularity?: InputMaybe<UtilizationGranularity>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetUtilizationSummaryArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>
  clientId?: InputMaybe<Scalars['ID']['input']>
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  startDate: Scalars['String']['input']
}

export type QueryPartnerGetVendorSimilarityGroupsArgs = {
  input: GetVendorSimilarityGroupsInput
}

export type QueryPartnerGetVendorSpendArgs = {
  input: GetVendorSpendInput
}

export type QueryPartnerGetVendorTotalsArgs = {
  input: GetVendorTotalsInput
}

export type QueryPartnerGlobalAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryPartnerHaloPsaContractConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter: HaloPsaContractFilter
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerHomeCashFlowArgs = {
  direction: HomeCashFlowDirection
  end?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  range?: InputMaybe<HomeRange>
  start?: InputMaybe<Scalars['String']['input']>
}

export type QueryPartnerHomeCustomersNeedingAttentionArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerHomePerformanceArgs = {
  end?: InputMaybe<Scalars['String']['input']>
  range?: InputMaybe<HomeRange>
  start?: InputMaybe<Scalars['String']['input']>
}

export type QueryPartnerHomeTopCustomersOwedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerHomeTopCustomersPaidArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerIntegrationIssueConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  filters: IntegrationIssueFilter
  first?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerIntegrationIssueCountsArgs = {
  platformName: PlatformName
}

export type QueryPartnerIntegrationJobConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters: IntegrationJobFilter
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<IntegrationJobOrder>
}

export type QueryPartnerIntegrationJobFailureCountArgs = {
  platformName: PlatformName
  sinceDays?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerIntegrationJobQueueConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters: IntegrationJobQueueFilter
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<IntegrationJobQueueOrder>
}

export type QueryPartnerInvoiceBnplConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<BnplFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerInvoiceConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<InvoiceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<InvoiceOrderBy>
}

export type QueryPartnerInvoiceListTotalsArgs = {
  filters?: InputMaybe<InvoiceFilter>
}

export type QueryPartnerListAccountingItemsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platformName: PlatformName
}

export type QueryPartnerListAccountingSyncBatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<ListAccountingSyncBatchesFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerListAccountingSyncJobsArgs = {
  batchID: Scalars['ID']['input']
  parentID: Scalars['ID']['input']
}

export type QueryPartnerListAssistantConversationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerListAssistantV2ConversationFilesArgs = {
  conversationID: Scalars['ID']['input']
}

export type QueryPartnerListAssistantV2ConversationsArgs = {
  includeV1?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerListAutopayExcludedInvoicesArgs = {
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryPartnerListCardsArgs = {
  filter?: InputMaybe<ListCardsFilterInput>
}

export type QueryPartnerListCreditMemosArgs = {
  filters?: InputMaybe<CreditMemoFiltersInput>
  order?: InputMaybe<CreditMemoOrderInput>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerListCreditMemosByCustomerIdArgs = {
  customerID: Scalars['ID']['input']
  filters?: InputMaybe<CreditMemoFiltersInput>
  order?: InputMaybe<CreditMemoOrderInput>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerListCustomerBankingIntegrationsArgs = {
  customerID: Scalars['String']['input']
}

export type QueryPartnerListCustomerCardsArgs = {
  customerID: Scalars['ID']['input']
  filter?: InputMaybe<ListCardsFilterInput>
}

export type QueryPartnerListCustomerFeeExceptionsArgs = {
  input?: InputMaybe<PartnerListCustomerFeeExceptionsInput>
}

export type QueryPartnerListCustomerRulesTotalsArgs = {
  customerID?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPartnerListCustomerTagsArgs = {
  filter?: InputMaybe<TagFilter>
}

export type QueryPartnerListCustomersArgs = {
  filters?: InputMaybe<PartnerListCustomersFilter>
  order?: InputMaybe<PartnerListCustomersOrder>
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type QueryPartnerListCustomersTotalsArgs = {
  filter?: InputMaybe<CustomerFilter>
}

export type QueryPartnerListEmailTemplatesArgs = {
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>
  templateID?: InputMaybe<Scalars['ID']['input']>
  templateType: TemplateType
}

export type QueryPartnerListPaymentsArgs = {
  orderBy?: InputMaybe<PaymentOrder>
  pagination: Pagination
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryPartnerListRoutineRunsArgs = {
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  routineID: Scalars['ID']['input']
}

export type QueryPartnerListRoutinesArgs = {
  filters?: InputMaybe<RoutineFilter>
  order?: InputMaybe<RoutineOrder>
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type QueryPartnerListUnitTypesArgs = {
  filters?: InputMaybe<UnitTypeFilter>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<UnitTypeOrderBy>
}

export type QueryPartnerListUnsyncedInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<UnsyncedInvoicesFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<UnsyncedInvoicesOrderBy>
}

export type QueryPartnerListVendorAuditLogArgs = {
  actions?: InputMaybe<Array<VendorAuditAction>>
  entityType: VendorAuditEntityType
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  vendorID: Scalars['String']['input']
}

export type QueryPartnerListVendorDataRequestsArgs = {
  vendorID: Scalars['String']['input']
}

export type QueryPartnerPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PaymentOrder>
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryPartnerPaymentTotalsArgs = {
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryPartnerPayoutBreakdownListItemConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  breakdownFilter?: InputMaybe<BreakdownFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerPayoutConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PayoutOrder>
  payoutFilter?: InputMaybe<PayoutFilter>
}

export type QueryPartnerPayoutDetailsArgs = {
  payoutID: Scalars['ID']['input']
}

export type QueryPartnerPayoutTotalsArgs = {
  payoutFilter?: InputMaybe<PayoutFilter>
}

export type QueryPartnerPendingCustomerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<PendingCustomerUserFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PendingCustomerUserOrderBy>
}

export type QueryPartnerQuickbooksConnectionUrlArgs = {
  redirectURI: Scalars['String']['input']
}

export type QueryPartnerRecurringPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<RecurringPaymentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RecurringPaymentOrderBy>
}

export type QueryPartnerRecurringPaymentTotalsArgs = {
  filters?: InputMaybe<RecurringPaymentFilter>
}

export type QueryPartnerRecurringTransactionConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<RecurringTransactionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RecurringTransactionOrderBy>
}

export type QueryPartnerReferralConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<ReferralFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ReferralOrderBy>
}

export type QueryPartnerReferralGetAvailableForPayoutDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerReferralGetAvgQuarterlyFeesDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerReferralGetQuarterlyEarningsDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerReferralGetTotalReferralFeesDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerResolveCustomerIntegrationIDsArgs = {
  input: ResolveCustomerIntegrationIDsInput
}

export type QueryPartnerRoutineRunFileDownloadUrlArgs = {
  fileID?: InputMaybe<Scalars['String']['input']>
  path?: InputMaybe<Scalars['String']['input']>
  routineID: Scalars['ID']['input']
  runID: Scalars['ID']['input']
}

export type QueryPartnerRutterAccountListArgs = {
  input?: InputMaybe<RutterAccountListInput>
}

export type QueryPartnerRutterAccountReadArgs = {
  platform?: InputMaybe<RutterPlatform>
}

export type QueryPartnerRutterConnectionReadArgs = {
  platform?: InputMaybe<RutterPlatform>
}

export type QueryPartnerRutterPaymentTermsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<RutterPaymentTermsFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RutterPaymentTermsOrderBy>
}

export type QueryPartnerRutterSubsidiaryListArgs = {
  platform?: InputMaybe<RutterPlatform>
}

export type QueryPartnerScheduledOneOffEmailConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerSearchAccountingItemsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  platformName: PlatformName
  query: Scalars['String']['input']
}

export type QueryPartnerSubscriptionsPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<SubscriptionPaymentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<SubscriptionPaymentOrderBy>
}

export type QueryPartnerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PartnerUserOrderBy>
}

export type QueryPartnerVendorListArgs = {
  filters?: InputMaybe<VendorFilter>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<VendorOrderBy>
}

export type QueryPartnerVendorsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<VendorFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<VendorOrderBy>
}

export type QueryIntegrationPermissionsArgs = {
  integration: Scalars['String']['input']
}

export type QueryPartnerDownloadBillDocumentArgs = {
  billId: Scalars['ID']['input']
}

export type QueryPartnerDownloadVendorDocumentArgs = {
  documentId: Scalars['ID']['input']
}

export type QueryPartnerListVendorDocumentsArgs = {
  vendorId: Scalars['ID']['input']
}

export type QuicbooksTaxCode = {
  __typename: 'QuicbooksTaxCode'
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  taxGroup: Scalars['Boolean']['output']
  taxable: Scalars['Boolean']['output']
}

export type QuickbooksAccount = {
  __typename: 'QuickbooksAccount'
  fullyQualifiedName: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type QuickbooksAccountInput = {
  fullyQualifiedName: Scalars['String']['input']
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type QuickbooksAccountUpdateInput = {
  forDeposits?: InputMaybe<QuickbooksAccountInput>
  forFees?: InputMaybe<QuickbooksAccountInput>
}

export type QuickbooksAccountsListReply = {
  __typename: 'QuickbooksAccountsListReply'
  forDeposits?: Maybe<Array<QuickbooksAccount>>
  forFees?: Maybe<Array<QuickbooksAccount>>
}

export type QuickbooksAccountsRetrieveReply = {
  __typename: 'QuickbooksAccountsRetrieveReply'
  forDeposits?: Maybe<QuickbooksAccount>
  forFees?: Maybe<QuickbooksAccount>
}

export type QuickbooksConnection = {
  __typename: 'QuickbooksConnection'
  autoSyncVendors: Scalars['Boolean']['output']
  createDeposits: Scalars['Boolean']['output']
  pushBillPaymentStatus: Scalars['Boolean']['output']
  queryFilters: QuickbooksQueryFilters
}

export type QuickbooksConnectionQueryFiltersInput = {
  customerTypes?: InputMaybe<Array<QuickbooksCustomerTypeInput>>
}

export type QuickbooksCustomerType = {
  __typename: 'QuickbooksCustomerType'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type QuickbooksCustomerTypeInput = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type QuickbooksCustomerTypeListReply = {
  __typename: 'QuickbooksCustomerTypeListReply'
  customerTypes?: Maybe<Array<Maybe<QuickbooksCustomerType>>>
}

export type QuickbooksFilterValue = {
  __typename: 'QuickbooksFilterValue'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type QuickbooksIntegration = IntegrationInterface & {
  __typename: 'QuickbooksIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type QuickbooksInvoiceCustomField = {
  __typename: 'QuickbooksInvoiceCustomField'
  definitionId: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type QuickbooksQueryFilters = {
  __typename: 'QuickbooksQueryFilters'
  customerTypes?: Maybe<Array<QuickbooksFilterValue>>
}

export type QuickbooksRecurringTransaction = {
  __typename: 'QuickbooksRecurringTransaction'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type RangeDateFilter = {
  end: Scalars['String']['input']
  start: Scalars['String']['input']
}

export type RecurringInvoicesInput = {
  halopsa?: InputMaybe<Scalars['Boolean']['input']>
}

export type RecurringPayment = {
  __typename: 'RecurringPayment'
  amount: Scalars['Float']['output']
  autoCharge: Scalars['Boolean']['output']
  createdAt: Scalars['String']['output']
  customer: Customer
  dateFirstCharge: Scalars['String']['output']
  dateLastCharge?: Maybe<Scalars['String']['output']>
  frequency: Frequency
  id: Scalars['ID']['output']
  productName?: Maybe<Scalars['String']['output']>
  status: RecurringPaymentStatus
  updatedAt: Scalars['String']['output']
}

/** A connection to a list of items. */
export type RecurringPaymentConnection = {
  __typename: 'RecurringPaymentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RecurringPaymentEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RecurringPaymentCreateInput = {
  amount: Scalars['Float']['input']
  autoCharge?: InputMaybe<Scalars['Boolean']['input']>
  customerID: Scalars['String']['input']
  dateFirstCharge: Scalars['String']['input']
  dateLastCharge?: InputMaybe<Scalars['String']['input']>
  frequency: Frequency
  productName?: InputMaybe<Scalars['String']['input']>
}

export type RecurringPaymentDeactivateInput = {
  id: Scalars['ID']['input']
}

/** An edge in a connection. */
export type RecurringPaymentEdge = {
  __typename: 'RecurringPaymentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<RecurringPayment>
}

export type RecurringPaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  dateFirstChargedEnd?: InputMaybe<Scalars['String']['input']>
  dateFirstChargedStart?: InputMaybe<Scalars['String']['input']>
  dateLastChargedEnd?: InputMaybe<Scalars['String']['input']>
  dateLastChargedStart?: InputMaybe<Scalars['String']['input']>
  frequency?: InputMaybe<Frequency>
  status?: InputMaybe<Array<RecurringPaymentStatus>>
}

export type RecurringPaymentOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<RecurringPaymentOrderByField>
}

export enum RecurringPaymentOrderByField {
  Amount = 'AMOUNT',
  DateFirstCharged = 'DATE_FIRST_CHARGED',
  DateLastCharged = 'DATE_LAST_CHARGED'
}

export enum RecurringPaymentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Overdue = 'OVERDUE'
}

export type RecurringPaymentTotals = {
  __typename: 'RecurringPaymentTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export type RecurringPaymentUpdateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  autoCharge?: InputMaybe<Scalars['Boolean']['input']>
  dateLastCharge?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  productName?: InputMaybe<Scalars['String']['input']>
}

export type RecurringTransactionConnection = {
  __typename: 'RecurringTransactionConnection'
  edges?: Maybe<Array<Maybe<RecurringTransactionEdge>>>
  pageInfo: PageInfo
}

export type RecurringTransactionEdge = {
  __typename: 'RecurringTransactionEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<QuickbooksRecurringTransaction>
}

export type RecurringTransactionFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type RecurringTransactionOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<RecurringTransactionOrderByField>
}

export enum RecurringTransactionOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type Referral = {
  __typename: 'Referral'
  avgQuarterlyFees?: Maybe<Scalars['Float']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  customerID?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  recipients?: Maybe<Array<Maybe<ReferralRecipient>>>
  referralDate?: Maybe<Scalars['String']['output']>
  referralFees?: Maybe<Scalars['Float']['output']>
  referredPartner?: Maybe<Partner>
  status: ReferralStatus
}

export type ReferralBonus = {
  __typename: 'ReferralBonus'
  amount: Scalars['Float']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  referralPayoutID: Scalars['ID']['output']
}

export enum ReferralComparisonPeriod {
  ReferralPeriodAllTime = 'REFERRAL_PERIOD_ALL_TIME',
  ReferralPeriodLastQuarter = 'REFERRAL_PERIOD_LAST_QUARTER',
  ReferralPeriodLastSixMonths = 'REFERRAL_PERIOD_LAST_SIX_MONTHS',
  ReferralPeriodLastYear = 'REFERRAL_PERIOD_LAST_YEAR'
}

export type ReferralConnection = {
  __typename: 'ReferralConnection'
  edges?: Maybe<Array<Maybe<ReferralEdge>>>
  pageInfo: PageInfo
}

export type ReferralEdge = {
  __typename: 'ReferralEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Referral>
}

export type ReferralFilter = {
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['ID']['input']>
  referralIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  statusIn?: InputMaybe<Array<InputMaybe<ReferralStatus>>>
  statusNotIn?: InputMaybe<Array<InputMaybe<ReferralStatus>>>
}

export type ReferralInput = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  recipients?: InputMaybe<Array<InputMaybe<ReferralRecipientInput>>>
  referralID?: InputMaybe<Scalars['ID']['input']>
  userID?: InputMaybe<Scalars['ID']['input']>
}

export type ReferralLinkInfo = {
  __typename: 'ReferralLinkInfo'
  sendLinkToOutgoingEmails: Scalars['Boolean']['output']
  url: Scalars['String']['output']
}

export type ReferralOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ReferralOrderByField>
}

export enum ReferralOrderByField {
  CompanyName = 'COMPANY_NAME'
}

export type ReferralPayout = {
  __typename: 'ReferralPayout'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  payoutDate?: Maybe<Scalars['String']['output']>
  payoutID?: Maybe<Scalars['ID']['output']>
  period: Scalars['String']['output']
  referralCount: Scalars['Int']['output']
  referredPartnersRevenue?: Maybe<Array<Maybe<ReferredPartnerRevenue>>>
  status: ReferralPayoutStatus
}

export enum ReferralPayoutMethodEnum {
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export enum ReferralPayoutStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  Paid = 'PAID',
  PendingApproval = 'PENDING_APPROVAL',
  Unspecified = 'UNSPECIFIED'
}

export type ReferralRecipient = {
  __typename: 'ReferralRecipient'
  email: Scalars['String']['output']
  userID?: Maybe<Scalars['ID']['output']>
}

export type ReferralRecipientInput = {
  email: Scalars['String']['input']
  userID?: InputMaybe<Scalars['ID']['input']>
}

export enum ReferralStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Converted = 'CONVERTED',
  Demo = 'DEMO',
  NotSent = 'NOT_SENT',
  Referred = 'REFERRED'
}

export type ReferredPartnerRevenue = {
  __typename: 'ReferredPartnerRevenue'
  lastQuarterRevenue?: Maybe<Scalars['Float']['output']>
  referredPartnerID?: Maybe<Scalars['ID']['output']>
}

export type RefreshIntegrationPermissionsReply = {
  __typename: 'RefreshIntegrationPermissionsReply'
  capabilities: Array<IntegrationPermissionCapability>
  connectionID: Scalars['ID']['output']
  status: IntegrationPermissionStatus
}

export type Refund = {
  __typename: 'Refund'
  amount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastStatus: RefundStatusEnum
  originalPayer: Company
  originalReceiver: Company
  paymentID: Scalars['String']['output']
  paymentReferenceId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Array<RefundStatus>>
}

export type RefundCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  idempotencyKey: Scalars['String']['input']
  paymentID: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type RefundStatus = {
  __typename: 'RefundStatus'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  status: RefundStatusEnum
}

export enum RefundStatusEnum {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS'
}

export type RemediationAction = {
  __typename: 'RemediationAction'
  externalCode?: Maybe<Scalars['String']['output']>
  internalCode?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
}

export enum ReportFormat {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

export enum ReportType {
  CreditMemo = 'CREDIT_MEMO',
  Customer = 'CUSTOMER',
  Invoice = 'INVOICE',
  Payment = 'PAYMENT',
  Payout = 'PAYOUT'
}

export type RequestVendorCardOtpResponse = {
  __typename: 'RequestVendorCardOTPResponse'
  success: Scalars['Boolean']['output']
}

export type ResolveCustomerIntegrationIDsInput = {
  customerIDs: Array<Scalars['ID']['input']>
  platformName: PlatformName
}

export type ResolveCustomerIntegrationIDsResult = {
  __typename: 'ResolveCustomerIntegrationIDsResult'
  mappings: Array<CustomerIntegrationIdMapping>
  unresolvedCustomerIDs: Array<Scalars['ID']['output']>
}

export type RetryIntegrationIssueInput = {
  entityType: IntegrationIssueEntityType
  issueId: Scalars['ID']['input']
}

export type RevealedVendorCard = {
  __typename: 'RevealedVendorCard'
  billingAddress: Scalars['String']['output']
  last4: Scalars['String']['output']
  network: Scalars['String']['output']
  revealToken: Scalars['String']['output']
}

/**
 * Sensitive virtual card payload. PAN, CVV and expiry are returned as
 * Evervault ciphertext tokens — the gateway never sees plaintext. The partner
 * browser hands these tokens to Evervault Inputs iframes for on-device
 * rendering.
 *
 * Plaintext fields: cardReference, last4, network, cardholderName.
 * Evervault ciphertext tokens: panToken, cvvToken, expiryMonthToken, expiryYearToken.
 */
export type RevealedVirtualCard = {
  __typename: 'RevealedVirtualCard'
  cardReference: Scalars['String']['output']
  cardholderName: Scalars['String']['output']
  cvvToken: Scalars['String']['output']
  expiryMonthToken: Scalars['String']['output']
  expiryYearToken: Scalars['String']['output']
  last4: Scalars['String']['output']
  network: Scalars['String']['output']
  panToken: Scalars['String']['output']
}

export type RollingMrrChange = {
  __typename: 'RollingMrrChange'
  change: Scalars['Float']['output']
  comparison?: Maybe<Scalars['Float']['output']>
  metadata?: Maybe<AnalyticsMetricMetadata>
  period: Scalars['String']['output']
  value: Scalars['Float']['output']
}

/** A saved recurring instruction the assistant runs unattended on a schedule. */
export type Routine = {
  __typename: 'Routine'
  createdAt: Scalars['String']['output']
  /** 2–28. Set only for MONTHLY_CUSTOM_DAY routines. */
  customDay?: Maybe<Scalars['Int']['output']>
  /** 0–6 (Sunday=0). Set only for WEEKLY routines. */
  dayOfWeek?: Maybe<Scalars['Int']['output']>
  emailEnabled: Scalars['Boolean']['output']
  enabled: Scalars['Boolean']['output']
  frequency: RoutineFrequency
  id: Scalars['ID']['output']
  instruction: Scalars['String']['output']
  name: Scalars['String']['output']
  /** Next scheduled run (RFC3339). */
  nextRunAt: Scalars['String']['output']
  /** Recipient addresses the result is emailed to when emailEnabled; empty otherwise. */
  recipients: Array<Scalars['String']['output']>
  /** Hour of day (0–23, interpreted in `timezone`) the routine runs. */
  sentHour: Scalars['Int']['output']
  /** IANA timezone the schedule is anchored to. */
  timezone: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
}

export type RoutineFilter = {
  /** Case-insensitive substring match on routine name OR instruction. */
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

/** Recurrence cadence of a routine. Mirrors svc-accounts-receivable's Frequency. */
export enum RoutineFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  MonthlyCustomDay = 'MONTHLY_CUSTOM_DAY',
  Weekly = 'WEEKLY'
}

export type RoutineList = {
  __typename: 'RoutineList'
  pagination: ArPagination
  routines: Array<Routine>
}

export type RoutineOrder = {
  direction: ArOrderDirection
  field: RoutineOrderField
}

/** Sortable columns for the routines list. DELIVERY sorts by whether email delivery is enabled. */
export enum RoutineOrderField {
  CreatedAt = 'CREATED_AT',
  Delivery = 'DELIVERY',
  Frequency = 'FREQUENCY',
  Instruction = 'INSTRUCTION',
  Name = 'NAME',
  NextRunAt = 'NEXT_RUN_AT'
}

/**
 * Full detail of one routine run, including its output text and downloadable
 * artifacts. Statuses are the raw svc-accounts-receivable values:
 *   status: queued | running | retry_wait | succeeded | failed
 */
export type RoutineRun = {
  __typename: 'RoutineRun'
  artifacts: Array<RoutineRunArtifact>
  /** Number of run attempts made so far (1-based once running; 0 while queued). */
  attempts: Scalars['Int']['output']
  createdAt: Scalars['String']['output']
  emailStatus: Scalars['String']['output']
  error?: Maybe<Scalars['String']['output']>
  finishedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** Maximum attempts before the run is marked failed. */
  maxAttempts: Scalars['Int']['output']
  /** Model output text — the body that was emailed when the run produced no file artifact. */
  outputText: Scalars['String']['output']
  /** What triggered the run — the raw svc-accounts-receivable value: scheduled | on_demand. */
  source: Scalars['String']['output']
  startedAt: Scalars['String']['output']
  status: Scalars['String']['output']
}

/** One downloadable artifact a routine run produced. Backed by svc-accounts-receivable's captured agent-output files. */
export type RoutineRunArtifact = {
  __typename: 'RoutineRunArtifact'
  contentType: Scalars['String']['output']
  /** Anthropic file id. Pass as `fileID` to PartnerRoutineRunFileDownloadURL. */
  fileID: Scalars['String']['output']
  /** Original filename. Also accepted as the `path` argument to the download URL. */
  filename: Scalars['String']['output']
  sizeBytes: Scalars['Int']['output']
}

export type RoutineRunList = {
  __typename: 'RoutineRunList'
  pagination: ArPagination
  runs: Array<RoutineRunListItem>
}

/**
 * A run-history row. Statuses are the raw svc-accounts-receivable values — the
 * client maps them to a single user-facing badge:
 *   status:      queued | running | retry_wait | succeeded | failed
 *   emailStatus: "" (no email) | pending | sent | failed
 * Output text is omitted here (the run detail carries it); conversation id is never
 * exposed (sealing, ADR-020).
 */
export type RoutineRunListItem = {
  __typename: 'RoutineRunListItem'
  /** Number of downloadable artifacts the run produced — gates the row download affordance. */
  artifactCount: Scalars['Int']['output']
  createdAt: Scalars['String']['output']
  emailStatus: Scalars['String']['output']
  error?: Maybe<Scalars['String']['output']>
  /** RFC3339; null while the run is still in flight. */
  finishedAt?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** RFC3339. */
  startedAt: Scalars['String']['output']
  status: Scalars['String']['output']
}

export enum RuleOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type RutterAccount = {
  __typename: 'RutterAccount'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nominalCode: Scalars['String']['output']
  type: Scalars['String']['output']
}

export enum RutterAccountFor {
  Deposits = 'DEPOSITS',
  Fees = 'FEES',
  Funds = 'FUNDS',
  Payments = 'PAYMENTS',
  Refunds = 'REFUNDS'
}

export type RutterAccountListInput = {
  accountsFor?: InputMaybe<Array<RutterAccountFor>>
  platform: RutterPlatform
}

export type RutterAccountUnsetInput = {
  accountFor: RutterAccountFor
  platform: RutterPlatform
}

export type RutterAccountUpsert = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type RutterAccountUpsertInput = {
  accountFor: RutterAccountFor
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  platform?: InputMaybe<RutterPlatform>
  type: Scalars['String']['input']
}

export type RutterAccountUpsertManyInput = {
  accountForDeposits?: InputMaybe<RutterAccountUpsert>
  accountForFees?: InputMaybe<RutterAccountUpsert>
  accountForPayments?: InputMaybe<RutterAccountUpsert>
  accountForRefunds?: InputMaybe<RutterAccountUpsert>
  platform: RutterPlatform
}

export type RutterConnection = {
  __typename: 'RutterConnection'
  createDeposits: Scalars['Boolean']['output']
  platform: Scalars['String']['output']
  rutterConnectionID: Scalars['String']['output']
  status: ConnectionStatus
}

export type RutterConnectionCreateDepositsUpdateInput = {
  createDeposits: Scalars['Boolean']['input']
  platform: RutterPlatform
}

export type RutterConnectionFilters = {
  Subsidiaries?: InputMaybe<Array<RutterSubsidiaryInput>>
}

export type RutterConnectionFiltersUpdateInput = {
  filters: RutterConnectionFilters
  platform: RutterPlatform
}

export type RutterIntegration = IntegrationInterface & {
  __typename: 'RutterIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type RutterPaymentTerms = {
  __typename: 'RutterPaymentTerms'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type RutterPaymentTermsConnection = {
  __typename: 'RutterPaymentTermsConnection'
  edges?: Maybe<Array<Maybe<RutterPaymentTermsEdge>>>
  pageInfo: PageInfo
}

export type RutterPaymentTermsEdge = {
  __typename: 'RutterPaymentTermsEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<RutterPaymentTerms>
}

export type RutterPaymentTermsFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type RutterPaymentTermsOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<RutterPaymentTermsOrderByField>
}

export enum RutterPaymentTermsOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export enum RutterPlatform {
  Dynamics_365 = 'DYNAMICS_365',
  Freshbooks = 'FRESHBOOKS',
  Netsuite = 'NETSUITE',
  QuickbooksDesktop = 'QUICKBOOKS_DESKTOP',
  SageIntacct = 'SAGE_INTACCT',
  SageIntacctV2 = 'SAGE_INTACCT_V2',
  Xero = 'XERO',
  ZohoBooks = 'ZOHO_BOOKS'
}

export type RutterSelectedAccounts = {
  __typename: 'RutterSelectedAccounts'
  AccountForDeposits?: Maybe<RutterAccount>
  AccountForFees?: Maybe<RutterAccount>
  AccountForFunds?: Maybe<RutterAccount>
  AccountForPayments?: Maybe<RutterAccount>
  AccountForRefunds?: Maybe<RutterAccount>
}

export type RutterSubsidiary = {
  __typename: 'RutterSubsidiary'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type RutterSubsidiaryInput = {
  id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type RutterSubsidiaryListResponse = {
  __typename: 'RutterSubsidiaryListResponse'
  subsidiaries?: Maybe<Array<RutterSubsidiary>>
}

export type ScheduledOneOffEmail = {
  __typename: 'ScheduledOneOffEmail'
  bcc?: Maybe<Array<Scalars['String']['output']>>
  cc?: Maybe<Array<Scalars['String']['output']>>
  createdAt: Scalars['String']['output']
  customers?: Maybe<Array<Customer>>
  id: Scalars['ID']['output']
  sendAt: Scalars['String']['output']
  tags?: Maybe<Array<CustomerTag>>
  template: EmailTemplate
  timezone: Timezone
  updatedAt: Scalars['String']['output']
}

export type ScheduledOneOffEmailConnection = {
  __typename: 'ScheduledOneOffEmailConnection'
  edges: Array<ScheduledOneOffEmailEdge>
  pageInfo: PageInfo
}

export type ScheduledOneOffEmailEdge = {
  __typename: 'ScheduledOneOffEmailEdge'
  cursor: Scalars['Cursor']['output']
  node: ScheduledOneOffEmail
}

export type Scope = {
  __typename: 'Scope'
  description: Scalars['String']['output']
  group: Scalars['String']['output']
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type SecondaryIntegrationDeleteInput = {
  platform: PlatformName
}

export type SendOneOffEmailInput = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  sendAt?: InputMaybe<Scalars['String']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  templateID: Scalars['ID']['input']
  timezone?: InputMaybe<Timezone>
}

export type SendPartnerReferralInput = {
  inputs?: InputMaybe<Array<ReferralInput>>
  templateID?: InputMaybe<Scalars['ID']['input']>
}

export type SpendByCategory = {
  __typename: 'SpendByCategory'
  byCategory: Array<CategorySpend>
  /** Signed fractional change of total spend, last-30d vs prior-30d. */
  delta: Scalars['Float']['output']
  totalSpend: Scalars['String']['output']
}

export type StartAccountsPayableOnboardingReply = {
  __typename: 'StartAccountsPayableOnboardingReply'
  validations: Array<Scalars['String']['output']>
}

export type StartAdyenOnboardingReply = {
  __typename: 'StartAdyenOnboardingReply'
  validations: Array<Scalars['String']['output']>
}

export type SubmitVendorDataInput = {
  acceptsCreditCard?: InputMaybe<Scalars['Boolean']['input']>
  bankAccountNumber: Scalars['String']['input']
  bankAccountType: Scalars['String']['input']
  bankName?: InputMaybe<Scalars['String']['input']>
  bankRoutingNumber: Scalars['String']['input']
  category?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  companyAddress?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  taxId?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
}

export type SubmitVendorDataResponse = {
  __typename: 'SubmitVendorDataResponse'
  success: Scalars['Boolean']['output']
}

export type Subscription = {
  __typename: 'Subscription'
  /**
   * Read-only re-attach to an in-progress turn (AR-7569). Resumes WATCHING a turn
   * that is still generating after the original subscription was lost (e.g. a page
   * refresh): AR backfills every event with processed_at after `since` (the gap the
   * client missed), then tails the live stream for the rest of the turn. It does
   * NOT post a user message and never starts or drives a turn — the detached Turn
   * Runner on AR remains the sole driver, so two readers can't double-execute a
   * tool. Confirmation cards never surface here (they are host-overlay events,
   * absent from Anthropic's stream — ADR-015), so only AssistantV2RawEvent arms of
   * the union are emitted. Pass the last-rendered event's processedAt as `since`
   * so the backfill→live-tail boundary doesn't double-render (the events API has
   * no event-id cursor — AR-7569).
   */
  PartnerReattachAssistantV2Message: AssistantV2MessageEvent
  PartnerSendAssistantMessage: AssistantMessageEvent
  /** Anthropic-shaped SSE passthrough. Emits AssistantV2RawEvent for every forwarded session event plus host-overlay AssistantConfirmationRequiredEvent / AssistantConfirmationOutcomeEvent when an action tool gates on partner confirmation. entityReferences (optional, ≤10) are forwarded to svc-accounts-receivable, which validates them and renders the agent-facing envelope. invokeAgents (optional) is a list of agent-key strings forwarded to svc-AR, which validates them against its agent registry. */
  PartnerSendAssistantV2Message: AssistantV2MessageEvent
}

export type SubscriptionPartnerReattachAssistantV2MessageArgs = {
  conversationID: Scalars['ID']['input']
  since?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionPartnerSendAssistantMessageArgs = {
  content: Scalars['String']['input']
  conversationID: Scalars['ID']['input']
}

export type SubscriptionPartnerSendAssistantV2MessageArgs = {
  content: Scalars['String']['input']
  conversationID: Scalars['ID']['input']
  entityReferences?: InputMaybe<Array<AssistantEntityReferenceInput>>
  invokeAgents?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum SubscriptionFrequency {
  Annual = 'ANNUAL',
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  OneShot = 'ONE_SHOT'
}

export type SubscriptionPayment = {
  __typename: 'SubscriptionPayment'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  payment?: Maybe<Payment>
  paymentDate: Scalars['String']['output']
  status: SubscriptionPaymentStatus
  subscription: PartnerSubscription
}

export type SubscriptionPaymentConnection = {
  __typename: 'SubscriptionPaymentConnection'
  edges?: Maybe<Array<Maybe<SubscriptionPaymentEdge>>>
  pageInfo: PageInfo
}

export type SubscriptionPaymentEdge = {
  __typename: 'SubscriptionPaymentEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<SubscriptionPayment>
}

export type SubscriptionPaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  paymentDateEnd?: InputMaybe<Scalars['String']['input']>
  paymentDateStart?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<SubscriptionPaymentStatus>>
  subscriptionID?: InputMaybe<Scalars['ID']['input']>
}

export type SubscriptionPaymentOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<SubscriptionPaymentOrderByField>
}

export enum SubscriptionPaymentOrderByField {
  Amount = 'AMOUNT',
  PaymentDate = 'PAYMENT_DATE',
  Status = 'STATUS'
}

export enum SubscriptionPaymentStatus {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED'
}

export type SubscriptionPaymentsTotals = {
  __typename: 'SubscriptionPaymentsTotals'
  count: Scalars['Int']['output']
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SuperAdminUser = {
  __typename: 'SuperAdminUser'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  role: SuperAdminUserRole
}

export enum SuperAdminUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type SuperOpsIntegration = IntegrationInterface & {
  __typename: 'SuperOpsIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type SuperopsConnectionCreateInput = {
  apiToken: Scalars['String']['input']
  integrationType: IntegrationType
  subdomain: Scalars['String']['input']
}

export type SupportPreferences = {
  __typename: 'SupportPreferences'
  email: Scalars['String']['output']
  firstLine: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['ID']['output']
  phone?: Maybe<Scalars['String']['output']>
  secondLine?: Maybe<Scalars['String']['output']>
}

export type SyncConfig = {
  __typename: 'SyncConfig'
  lastAutomaticSync?: Maybe<Scalars['String']['output']>
  mappings?: Maybe<Array<SyncConfigMapping>>
  options: Array<SyncConfigOption>
  partnerID: Scalars['ID']['output']
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export type SyncConfigCreateInput = {
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export type SyncConfigGetInput = {
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export type SyncConfigMapping = {
  __typename: 'SyncConfigMapping'
  mappingType: SyncConfigMappingType
  sourceID: Scalars['ID']['output']
  sourceName: Scalars['String']['output']
  targetID: Scalars['ID']['output']
  targetName: Scalars['String']['output']
}

export type SyncConfigMappingInput = {
  mappingType: SyncConfigMappingType
  sourceID: Scalars['ID']['input']
  sourceName: Scalars['String']['input']
  targetID: Scalars['ID']['input']
  targetName: Scalars['String']['input']
}

export enum SyncConfigMappingType {
  MappingTypeUnspecified = 'MAPPING_TYPE_UNSPECIFIED',
  TaxCode = 'TAX_CODE'
}

export type SyncConfigOption = {
  __typename: 'SyncConfigOption'
  customValue?: Maybe<Scalars['String']['output']>
  enumValue?: Maybe<SyncConfigOptionValue>
  optionKey: SyncConfigOptionKey
  optionType: SyncConfigOptionType
}

export type SyncConfigOptionInput = {
  customValue?: InputMaybe<Scalars['String']['input']>
  enumValue?: InputMaybe<SyncConfigOptionValue>
  optionKey: SyncConfigOptionKey
  optionType: SyncConfigOptionType
}

export enum SyncConfigOptionKey {
  CwGlClassSegment = 'CW_GL_CLASS_SEGMENT',
  CwGlNonProductSegment = 'CW_GL_NON_PRODUCT_SEGMENT',
  CwGlSubclassSegment = 'CW_GL_SUBCLASS_SEGMENT',
  LineItemMappingKey = 'LINE_ITEM_MAPPING_KEY',
  OptionKeyUnspecified = 'OPTION_KEY_UNSPECIFIED',
  QboCustomFieldPoNumber = 'QBO_CUSTOM_FIELD_PO_NUMBER',
  SyncExternalPaymentsMode = 'SYNC_EXTERNAL_PAYMENTS_MODE',
  SyncFrequencyDailyTime = 'SYNC_FREQUENCY_DAILY_TIME',
  SyncFrequencyHoursInterval = 'SYNC_FREQUENCY_HOURS_INTERVAL',
  SyncFrequencyMode = 'SYNC_FREQUENCY_MODE',
  SyncFrequencyType = 'SYNC_FREQUENCY_TYPE',
  SyncServiceItemMode = 'SYNC_SERVICE_ITEM_MODE',
  UseLineItemSalesTax = 'USE_LINE_ITEM_SALES_TAX'
}

export enum SyncConfigOptionType {
  OptionTypeBoolean = 'OPTION_TYPE_BOOLEAN',
  OptionTypeFloat = 'OPTION_TYPE_FLOAT',
  OptionTypeInteger = 'OPTION_TYPE_INTEGER',
  OptionTypeString = 'OPTION_TYPE_STRING',
  OptionTypeUnspecified = 'OPTION_TYPE_UNSPECIFIED'
}

export enum SyncConfigOptionValue {
  False = 'FALSE',
  LineItemMappingProductDescription = 'LINE_ITEM_MAPPING_PRODUCT_DESCRIPTION',
  LineItemMappingProductId = 'LINE_ITEM_MAPPING_PRODUCT_ID',
  OptionValueUnspecified = 'OPTION_VALUE_UNSPECIFIED',
  SyncExternalPaymentsModeAllInvoices = 'SYNC_EXTERNAL_PAYMENTS_MODE_ALL_INVOICES',
  SyncExternalPaymentsModeDisabled = 'SYNC_EXTERNAL_PAYMENTS_MODE_DISABLED',
  SyncExternalPaymentsModeSyncedOnly = 'SYNC_EXTERNAL_PAYMENTS_MODE_SYNCED_ONLY',
  SyncFrequencyModeDaily = 'SYNC_FREQUENCY_MODE_DAILY',
  SyncFrequencyModeEveryXHours = 'SYNC_FREQUENCY_MODE_EVERY_X_HOURS',
  SyncFrequencyTypeAutomatic = 'SYNC_FREQUENCY_TYPE_AUTOMATIC',
  SyncFrequencyTypeManual = 'SYNC_FREQUENCY_TYPE_MANUAL',
  SyncServiceItemGeneralLedger = 'SYNC_SERVICE_ITEM_GENERAL_LEDGER',
  SyncServiceItemTimeEntry = 'SYNC_SERVICE_ITEM_TIME_ENTRY',
  True = 'TRUE'
}

export type SyncConfigUpdateInput = {
  mappings?: InputMaybe<Array<SyncConfigMappingInput>>
  options: Array<SyncConfigOptionInput>
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export enum SyncType {
  FetchCreditMemos = 'FETCH_CREDIT_MEMOS',
  FetchNew = 'FETCH_NEW',
  FetchUnpaid = 'FETCH_UNPAID'
}

export type SystemInfoInput = {
  browserName: Scalars['String']['input']
  browserVersion: Scalars['String']['input']
  deviceType: Scalars['String']['input']
  ipAddress: Scalars['String']['input']
  operatingSystem: Scalars['String']['input']
  osVersion: Scalars['String']['input']
  userAgent: Scalars['String']['input']
}

export enum TagColor {
  AquaBlue = 'AQUA_BLUE',
  DarkGrey = 'DARK_GREY',
  Green = 'GREEN',
  Grey = 'GREY',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type TagFilter = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export enum TagType {
  AutopayEnabled = 'AUTOPAY_ENABLED',
  Custom = 'CUSTOM',
  NoPaymentMethod = 'NO_PAYMENT_METHOD'
}

export enum TemplateType {
  OneOff = 'ONE_OFF',
  Referral = 'REFERRAL',
  Reminder = 'REMINDER',
  Summary = 'SUMMARY'
}

export type TicketListInput = {
  agentId: Scalars['ID']['input']
  categories?: InputMaybe<Array<Scalars['String']['input']>>
  clientId: Scalars['ID']['input']
  endDate: Scalars['String']['input']
  hasTicket?: InputMaybe<Scalars['Boolean']['input']>
  pagination?: InputMaybe<TicketListPaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<TicketListSortBy>
  sortDir?: InputMaybe<OrderDirection>
  startDate: Scalars['String']['input']
}

export type TicketListItem = {
  __typename: 'TicketListItem'
  category?: Maybe<Scalars['String']['output']>
  cost: Scalars['Float']['output']
  date: Scalars['String']['output']
  displayId: Scalars['String']['output']
  hoursWorked: Scalars['Float']['output']
  ticketId: Scalars['ID']['output']
  ticketUrl: Scalars['String']['output']
}

export type TicketListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type TicketListResult = {
  __typename: 'TicketListResult'
  categories: Array<Scalars['String']['output']>
  items: Array<TicketListItem>
  total: Scalars['Int']['output']
  totalCost: Scalars['Float']['output']
  totalHoursWorked: Scalars['Float']['output']
}

export enum TicketListSortBy {
  Category = 'CATEGORY',
  Cost = 'COST',
  Date = 'DATE',
  Hours = 'HOURS',
  TicketId = 'TICKET_ID'
}

export enum Timezone {
  AmericaAdak = 'AMERICA_ADAK',
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  AmericaBoise = 'AMERICA_BOISE',
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaCreston = 'AMERICA_CRESTON',
  AmericaDawson = 'AMERICA_DAWSON',
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaDetroit = 'AMERICA_DETROIT',
  AmericaEdmonton = 'AMERICA_EDMONTON',
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  AmericaHalifax = 'AMERICA_HALIFAX',
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  AmericaInuvik = 'AMERICA_INUVIK',
  AmericaIqaluit = 'AMERICA_IQALUIT',
  AmericaJuneau = 'AMERICA_JUNEAU',
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaMenominee = 'AMERICA_MENOMINEE',
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  AmericaMoncton = 'AMERICA_MONCTON',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AmericaNipigon = 'AMERICA_NIPIGON',
  AmericaNome = 'AMERICA_NOME',
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  AmericaPhoenix = 'AMERICA_PHOENIX',
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  AmericaRegina = 'AMERICA_REGINA',
  AmericaResolute = 'AMERICA_RESOLUTE',
  AmericaSitka = 'AMERICA_SITKA',
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  AmericaToronto = 'AMERICA_TORONTO',
  AmericaVancouver = 'AMERICA_VANCOUVER',
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  AmericaYakutat = 'AMERICA_YAKUTAT',
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  PacificHonolulu = 'PACIFIC_HONOLULU',
  Utc = 'UTC'
}

export type TokenExchange = {
  __typename: 'TokenExchange'
  access_token: Scalars['String']['output']
  expiry: Scalars['String']['output']
  id_token: Scalars['String']['output']
  refresh_token: Scalars['String']['output']
}

export type Transaction = {
  __typename: 'Transaction'
  amount: Scalars['Float']['output']
  companyType: CompanyType
  customer: Customer
  description: Scalars['String']['output']
  direction: TransactionDirection
  failureReason?: Maybe<Scalars['String']['output']>
  failureReasonCode?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  status: TransactionStatus
  transactionMethod: TransactionMethod
}

export enum TransactionDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum TransactionMethod {
  Ach = 'ACH',
  Card = 'CARD',
  Manual = 'MANUAL',
  Rtp = 'RTP',
  SameDayAch = 'SAME_DAY_ACH',
  Wire = 'WIRE'
}

export enum TransactionNetwork {
  TnAdyen = 'TN_ADYEN',
  TnSvb = 'TN_SVB',
  TnUnspecified = 'TN_UNSPECIFIED'
}

export enum TransactionStatus {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Charged = 'CHARGED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

export enum TransferPaymentMethodInputEnum {
  Card = 'CARD',
  StandardAch = 'STANDARD_ACH'
}

export type UsAccountData = {
  __typename: 'USAccountData'
  accountNumber: Scalars['String']['output']
  institutionName: Scalars['String']['output']
  receiverName: Scalars['String']['output']
  routingNumber: Scalars['String']['output']
  subtype: Scalars['String']['output']
  type: Scalars['String']['output']
  wireRoutingNumber?: Maybe<Scalars['String']['output']>
}

export type UsAccountDataInput = {
  accountNumber: Scalars['String']['input']
  institutionName: Scalars['String']['input']
  receiverName: Scalars['String']['input']
  routingNumber: Scalars['String']['input']
  subtype: ManualAccountSubtypes
  type: ManualAccountTypes
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>
}

export type UsAccountUpdateInput = {
  accountNumber: Scalars['String']['input']
  routingNumber: Scalars['String']['input']
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>
}

export type UsPaymentPreference = {
  __typename: 'USPaymentPreference'
  accountNumber: Scalars['String']['output']
  institutionName: Scalars['String']['output']
  routingNumber: Scalars['String']['output']
  type: PaymentPreferenceType
}

export type UsPaymentPreferenceData = {
  accountNumber: Scalars['String']['input']
  institutionName: Scalars['String']['input']
  routingNumber: Scalars['String']['input']
  type: PaymentPreferenceType
}

/** A unit type for line items (e.g., 'hour', 'license', 'device'). */
export type UnitType = {
  __typename: 'UnitType'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
}

/** Filter options for listing unit types. */
export type UnitTypeFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
}

/** Paginated list of unit types. */
export type UnitTypeListResponse = {
  __typename: 'UnitTypeListResponse'
  hasMore: Scalars['Boolean']['output']
  totalCount: Scalars['Int']['output']
  unitTypes: Array<UnitType>
}

/** Input for ordering unit type results. */
export type UnitTypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<UnitTypeOrderByField>
}

/** Ordering options for unit types. */
export enum UnitTypeOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Response for unit type mutations. */
export type UnitTypeResponse = {
  __typename: 'UnitTypeResponse'
  id: Scalars['ID']['output']
}

export type UnsyncedInvoiceEdge = {
  __typename: 'UnsyncedInvoiceEdge'
  cursor: Scalars['Cursor']['output']
  node: InvoiceRelation
}

export type UnsyncedInvoiceTotals = {
  __typename: 'UnsyncedInvoiceTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export type UnsyncedInvoices = {
  __typename: 'UnsyncedInvoices'
  edges?: Maybe<Array<Maybe<UnsyncedInvoiceEdge>>>
  pageInfo: PageInfo
}

export type UnsyncedInvoicesFilter = {
  createdDateEnd?: InputMaybe<Scalars['String']['input']>
  createdDateStart?: InputMaybe<Scalars['String']['input']>
  platformName: PlatformName
}

export type UnsyncedInvoicesOrderBy = {
  direction: OrderDirection
  field: UnsyncedInvoicesOrderByField
}

export enum UnsyncedInvoicesOrderByField {
  CreatedDate = 'CREATED_DATE'
}

/** Input for updating notification policy settings. */
export type UpdateAccountsPayableNotificationPolicyInput = {
  billCreatedEnabled: Scalars['Boolean']['input']
  billOverdueEnabled: Scalars['Boolean']['input']
  emailIngestionFailedEnabled: Scalars['Boolean']['input']
  paymentFailedEnabled: Scalars['Boolean']['input']
}

export type UpdateApiKeyInput = {
  keyID: Scalars['String']['input']
  keyName: Scalars['String']['input']
}

export type UpdateBankAccountInput = {
  accountID: Scalars['ID']['input']
  accountInformation: ManualBankingAccountInformationInput
}

export type UpdateBankAccountV2Input = {
  accountHolderName: Scalars['String']['input']
  accountID: Scalars['ID']['input']
  accountSubtype: ManualAccountSubtypes
  caAccountUpdate?: InputMaybe<CaAccountUpdateInput>
  customName?: InputMaybe<Scalars['String']['input']>
  institutionName: Scalars['String']['input']
  usAccountUpdate?: InputMaybe<UsAccountUpdateInput>
}

export type UpdateBill = {
  amount: Scalars['Float']['input']
  billID: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  dueDate: Scalars['String']['input']
  issueDate: Scalars['String']['input']
  /** Optional line items update. If not provided, line items remain unchanged. */
  lineItems?: InputMaybe<BillLineItemsUpdateInput>
  status: BillStatus
  vendorID: Scalars['String']['input']
}

export type UpdateBillPayDateInput = {
  billID: Scalars['ID']['input']
  payDate: Scalars['String']['input']
}

export type UpdateClientTrendsPresetInput = {
  filters: ClientTrendsFiltersInput
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type UpdateCompanyIndividualInput = {
  city: Scalars['String']['input']
  controllingPerson: Scalars['Boolean']['input']
  country: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  dateOfBirth: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  id: Scalars['ID']['input']
  jobTitle: Scalars['String']['input']
  lastName: Scalars['String']['input']
  owner: Scalars['Boolean']['input']
  partnerID: Scalars['ID']['input']
  phone: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  signatory: Scalars['Boolean']['input']
  ssn?: InputMaybe<Scalars['String']['input']>
  state: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise: Scalars['String']['input']
}

export type UpdateCreditMemoConfigExceptionsInput = {
  customerIDs: Array<Scalars['ID']['input']>
}

export type UpdateCreditMemoConfigInput = {
  showCreditMemo: Scalars['Boolean']['input']
}

export type UpdateEmailTemplateInput = {
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  section1?: InputMaybe<Scalars['String']['input']>
  section2?: InputMaybe<Scalars['String']['input']>
  section3?: InputMaybe<Scalars['String']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
}

export type UpdateInvoiceReminderInput = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  id: Scalars['ID']['input']
  runsHourly?: InputMaybe<Scalars['Boolean']['input']>
  sentHour?: InputMaybe<Scalars['Int']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  templateID?: InputMaybe<Scalars['ID']['input']>
  timezone?: InputMaybe<Timezone>
}

export type UpdateInvoiceSummaryInput = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  id: Scalars['ID']['input']
  sentHour?: InputMaybe<Scalars['Int']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  templateID?: InputMaybe<Scalars['ID']['input']>
  timezone?: InputMaybe<Timezone>
}

export type UpdatePartnerNameInput = {
  name: Scalars['String']['input']
}

export type UpdateReferralInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  recipients?: InputMaybe<Array<InputMaybe<ReferralRecipientInput>>>
}

export type UpdateReferralLinkInput = {
  partnerID: Scalars['ID']['input']
  sendLinkToOutgoingEmails: Scalars['Boolean']['input']
}

export type UpdateScheduledOneOffEmailInput = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  id: Scalars['ID']['input']
  sendAt?: InputMaybe<Scalars['String']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  templateID?: InputMaybe<Scalars['ID']['input']>
  timezone?: InputMaybe<Timezone>
}

export type UpdateUtilizationPresetInput = {
  filters: UtilizationPresetFiltersInput
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type UpdateVendor = {
  category?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  companyAddress?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  owner?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  taxId?: InputMaybe<Scalars['String']['input']>
  vendorID: Scalars['ID']['input']
}

export type UpdateVendorPaymentPreferenceInput = {
  paymentPreferenceID: Scalars['String']['input']
  usPaymentPreferenceData?: InputMaybe<UsPaymentPreferenceData>
}

export type UpdateVendorPaymentPreferenceResponse = {
  __typename: 'UpdateVendorPaymentPreferenceResponse'
  paymentMethodID: Scalars['String']['output']
  paymentPreferenceID: Scalars['String']['output']
}

export type UploadAdyenDocumentInput = {
  content: Scalars['String']['input']
  documentType: AdyenUploadDocumentType
  filename?: InputMaybe<Scalars['String']['input']>
  ownerID: Scalars['String']['input']
  ownerType: AdyenOwnerType
}

export type UploadAdyenDocumentResponse = {
  __typename: 'UploadAdyenDocumentResponse'
  details?: Maybe<Scalars['String']['output']>
  failed: Scalars['Boolean']['output']
}

export type UploadBankAccountDocumentInput = {
  bankAccountID: Scalars['ID']['input']
  content: Scalars['String']['input']
  filename: Scalars['String']['input']
  type: BankAccountDocumentType
}

/** Input for uploading a bill document with OCR processing. */
export type UploadBillDocumentInput = {
  /** Base64-encoded document content (PDF, PNG, or JPG). */
  content: Scalars['String']['input']
  /** MIME type: application/pdf, image/png, or image/jpeg. */
  contentType: Scalars['String']['input']
  /** Original filename with extension. */
  filename: Scalars['String']['input']
}

/** Response from uploading a bill document. */
export type UploadBillDocumentPayload = {
  __typename: 'UploadBillDocumentPayload'
  /** UUID of the created bill. */
  billId: Scalars['ID']['output']
  /** Generated bill number. */
  billNumber: Scalars['String']['output']
  /** S3 path to the uploaded document. */
  documentPath?: Maybe<Scalars['String']['output']>
  /** Data extracted from the document via OCR. */
  extractedData?: Maybe<ExtractedBillData>
  /** Warnings such as duplicate detection. */
  warnings?: Maybe<Array<Scalars['String']['output']>>
}

export type UploadPartnerDocumentByUploadLinkInput = {
  content: Scalars['String']['input']
  filename: Scalars['String']['input']
  type: PartnerDocumentType
  uploadLinkId: Scalars['String']['input']
}

export type UploadPartnerDocumentInput = {
  content: Scalars['String']['input']
  filename?: InputMaybe<Scalars['String']['input']>
  individualID?: InputMaybe<Scalars['String']['input']>
  type: PartnerDocumentType
}

export type UpsertCustomerAutopayConfigInput = {
  chargeDefaultFallback: Scalars['Boolean']['input']
  customerID: Scalars['ID']['input']
}

export type UpsertInvoicePreferencesInput = {
  invoiceNumberField: InvoiceNumberField
}

export type UpsertSupportPreferencesInput = {
  email: Scalars['String']['input']
  firstLine: Scalars['String']['input']
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  secondLine?: InputMaybe<Scalars['String']['input']>
}

export enum UserType {
  Customer = 'CUSTOMER',
  Partner = 'PARTNER',
  Superadmin = 'SUPERADMIN'
}

export type UtilizationBreakdownItem = {
  __typename: 'UtilizationBreakdownItem'
  agentName: Scalars['String']['output']
  clientName: Scalars['String']['output']
  dateWorked: Scalars['String']['output']
  hoursWorked: Scalars['Float']['output']
  labourCost: Scalars['Float']['output']
  ticketId?: Maybe<Scalars['ID']['output']>
  ticketType?: Maybe<Scalars['String']['output']>
}

export enum UtilizationCsvReportType {
  Agents = 'AGENTS',
  Clients = 'CLIENTS'
}

export enum UtilizationFilterType {
  AgentName = 'AGENT_NAME',
  AgentTitle = 'AGENT_TITLE',
  Category = 'CATEGORY',
  ClientName = 'CLIENT_NAME',
  TicketType = 'TICKET_TYPE'
}

export type UtilizationFilterValuesInput = {
  exclude?: InputMaybe<Array<Scalars['String']['input']>>
  include?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UtilizationFilterValuesResult = {
  __typename: 'UtilizationFilterValuesResult'
  total: Scalars['Int']['output']
  values: Array<Scalars['String']['output']>
}

export type UtilizationFiltersInput = {
  agentTitles?: InputMaybe<UtilizationFilterValuesInput>
  agents?: InputMaybe<UtilizationFilterValuesInput>
  categories?: InputMaybe<UtilizationFilterValuesInput>
  clients?: InputMaybe<UtilizationFilterValuesInput>
  ticketTypes?: InputMaybe<UtilizationFilterValuesInput>
}

/**
 * Bucket granularity for the adaptive utilization series (ANA-274). The server
 * auto-downgrades day → week → month past ~400 buckets, so the granularity
 * returned in the result may differ from the one requested.
 */
export enum UtilizationGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type UtilizationKpiMetric = {
  __typename: 'UtilizationKPIMetric'
  comparison: Scalars['Float']['output']
  value: Scalars['Float']['output']
}

export type UtilizationKpiResult = {
  __typename: 'UtilizationKPIResult'
  agentCost: UtilizationKpiMetric
  hoursAvailable: UtilizationKpiMetric
  hoursWorked: UtilizationKpiMetric
  utilizationPercent: UtilizationKpiMetric
}

export type UtilizationLaborCostImpactResult = {
  __typename: 'UtilizationLaborCostImpactResult'
  impact: LaborCostImpact
  laborCost: Scalars['Float']['output']
  mrr: Scalars['Float']['output']
  percentage: Scalars['Float']['output']
  percentageComparison?: Maybe<Scalars['Float']['output']>
}

export type UtilizationOverviewItem = {
  __typename: 'UtilizationOverviewItem'
  agentId?: Maybe<Scalars['ID']['output']>
  clientId?: Maybe<Scalars['ID']['output']>
  displayName: Scalars['String']['output']
  hoursAvailable: Scalars['Float']['output']
  hoursWorked: Scalars['Float']['output']
  labourCost: Scalars['Float']['output']
  utilizationComparison?: Maybe<Scalars['Float']['output']>
  utilizationPercent?: Maybe<Scalars['Float']['output']>
}

export type UtilizationOverviewResult = {
  __typename: 'UtilizationOverviewResult'
  items: Array<UtilizationOverviewItem>
  total: Scalars['Int']['output']
}

export enum UtilizationOverviewSortBy {
  HoursAvailable = 'HOURS_AVAILABLE',
  HoursWorked = 'HOURS_WORKED',
  LaborCost = 'LABOR_COST',
  Utilization = 'UTILIZATION'
}

export type UtilizationPreset = {
  __typename: 'UtilizationPreset'
  createdAt: Scalars['String']['output']
  filters: UtilizationPresetFilters
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partnerId: Scalars['ID']['output']
  updatedAt: Scalars['String']['output']
  userId?: Maybe<Scalars['ID']['output']>
}

export type UtilizationPresetFilterValues = {
  __typename: 'UtilizationPresetFilterValues'
  exclude?: Maybe<Array<Scalars['String']['output']>>
  include?: Maybe<Array<Scalars['String']['output']>>
}

export type UtilizationPresetFilters = {
  __typename: 'UtilizationPresetFilters'
  agentTitles?: Maybe<UtilizationPresetFilterValues>
  agents?: Maybe<UtilizationPresetFilterValues>
  agreements?: Maybe<UtilizationPresetFilterValues>
  categories?: Maybe<UtilizationPresetFilterValues>
  clients?: Maybe<UtilizationPresetFilterValues>
  dateFrom?: Maybe<Scalars['String']['output']>
  dateTo?: Maybe<Scalars['String']['output']>
  ticketType?: Maybe<UtilizationPresetFilterValues>
}

export type UtilizationPresetFiltersInput = {
  agentTitles?: InputMaybe<UtilizationFilterValuesInput>
  agents?: InputMaybe<UtilizationFilterValuesInput>
  agreements?: InputMaybe<UtilizationFilterValuesInput>
  categories?: InputMaybe<UtilizationFilterValuesInput>
  clients?: InputMaybe<UtilizationFilterValuesInput>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  ticketType?: InputMaybe<UtilizationFilterValuesInput>
}

export type UtilizationSeriesPoint = {
  __typename: 'UtilizationSeriesPoint'
  date: Scalars['String']['output']
  hoursWorked: Scalars['Float']['output']
  labourCost: Scalars['Float']['output']
}

export type UtilizationSeriesResult = {
  __typename: 'UtilizationSeriesResult'
  granularity: UtilizationGranularity
  series: Array<UtilizationSeriesPoint>
}

export type UtilizationSummaryItem = {
  __typename: 'UtilizationSummaryItem'
  date: Scalars['String']['output']
  hoursAvailable: Scalars['Float']['output']
  hoursWorked: Scalars['Float']['output']
  labourCost: Scalars['Float']['output']
}

export type Vendor = {
  __typename: 'Vendor'
  ID: Scalars['String']['output']
  absorbedBy?: Maybe<Vendor>
  absorbedById?: Maybe<Scalars['ID']['output']>
  acceptsCreditCard?: Maybe<Scalars['Boolean']['output']>
  category?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  compactedPaymentPreference?: Maybe<CompactedPaymentPreference>
  companyAddress?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  isMerged: Scalars['Boolean']['output']
  /**
   * RFC3339 timestamp recorded when this vendor was merged into the survivor.
   * Null for non-merged vendors and for legacy merges performed before this field existed.
   */
  mergedAt?: Maybe<Scalars['String']['output']>
  /**
   * The partner user that performed the merge. Resolved from mergedByUserId.
   * Null when mergedByUserId is null (legacy/system merges) or when the user
   * cannot be found (deactivated/deleted).
   */
  mergedByUser?: Maybe<PartnerUser>
  /** UUID of the user that performed the merge. Null for legacy merges and system-driven merges. */
  mergedByUserId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  origin?: Maybe<VendorOrigin>
  owner?: Maybe<Scalars['String']['output']>
  ownerEmail?: Maybe<Scalars['String']['output']>
  ownerPhone?: Maybe<Scalars['String']['output']>
  partnerID: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  /** QBO linking information for this vendor. */
  qboLinking: QboLinking
  state?: Maybe<Scalars['String']['output']>
  taxId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['String']['output']
}

/** Response for deactivating or reactivating a vendor. */
export type VendorActivationResponse = {
  __typename: 'VendorActivationResponse'
  /** Number of bills affected by the activation status change. */
  affectedBillCount: Scalars['Int']['output']
  /** UUID of the vendor. */
  vendorId: Scalars['ID']['output']
}

export enum VendorAuditAction {
  VendorAuditActionAdded = 'VENDOR_AUDIT_ACTION_ADDED',
  VendorAuditActionCreated = 'VENDOR_AUDIT_ACTION_CREATED',
  VendorAuditActionDeleted = 'VENDOR_AUDIT_ACTION_DELETED',
  VendorAuditActionUnspecified = 'VENDOR_AUDIT_ACTION_UNSPECIFIED',
  VendorAuditActionUpdated = 'VENDOR_AUDIT_ACTION_UPDATED'
}

export enum VendorAuditEntityType {
  VendorAuditEntityTypePaymentPreference = 'VENDOR_AUDIT_ENTITY_TYPE_PAYMENT_PREFERENCE',
  VendorAuditEntityTypeUnspecified = 'VENDOR_AUDIT_ENTITY_TYPE_UNSPECIFIED',
  VendorAuditEntityTypeVendor = 'VENDOR_AUDIT_ENTITY_TYPE_VENDOR'
}

export type VendorAuditLog = {
  __typename: 'VendorAuditLog'
  action: VendorAuditAction
  createdAt: Scalars['String']['output']
  entityId: Scalars['String']['output']
  entityType: VendorAuditEntityType
  executorEntity: ExecutorEntityType
  executorId?: Maybe<Scalars['String']['output']>
  /**
   * The partner user who executed the action.
   * Only populated when executorEntity is EXECUTOR_ENTITY_TYPE_PARTNER.
   */
  executorUser?: Maybe<PartnerUser>
  fieldName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isInitialCreation: Scalars['Boolean']['output']
  newValue?: Maybe<Scalars['String']['output']>
  oldValue?: Maybe<Scalars['String']['output']>
  partnerId: Scalars['String']['output']
  source?: Maybe<VendorAuditSource>
  vendorId: Scalars['String']['output']
}

export type VendorAuditLogListResponse = {
  __typename: 'VendorAuditLogListResponse'
  entries: Array<VendorAuditLog>
  /**
   * eventsCount is the total number of audit log entries for the vendor,
   * scoped by entityType but ignoring the actions filter.
   */
  eventsCount: Scalars['Int']['output']
  /**
   * fieldsAddedCount is the number of entries with action=ADDED, scoped
   * by entityType but ignoring the actions filter.
   */
  fieldsAddedCount: Scalars['Int']['output']
  /**
   * fieldsUpdatedCount is the number of entries with action=UPDATED, scoped
   * by entityType but ignoring the actions filter.
   */
  fieldsUpdatedCount: Scalars['Int']['output']
  hasMore: Scalars['Boolean']['output']
  /**
   * totalCount reflects the number of rows matching the full filter
   * (entityType + actions), used for pagination of entries.
   */
  totalCount: Scalars['Int']['output']
}

export enum VendorAuditSource {
  VendorAuditSourceIntegration = 'VENDOR_AUDIT_SOURCE_INTEGRATION',
  VendorAuditSourceManual = 'VENDOR_AUDIT_SOURCE_MANUAL',
  VendorAuditSourceOcr = 'VENDOR_AUDIT_SOURCE_OCR',
  VendorAuditSourceUnspecified = 'VENDOR_AUDIT_SOURCE_UNSPECIFIED',
  VendorAuditSourceVendorForm = 'VENDOR_AUDIT_SOURCE_VENDOR_FORM'
}

/** A connection to a list of vendors. */
export type VendorConnection = {
  __typename: 'VendorConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** Total number of vendors matching the query filters. */
  totalCount: Scalars['Int']['output']
}

export type VendorDataRequest = {
  __typename: 'VendorDataRequest'
  createdAt: Scalars['String']['output']
  expiresAt: Scalars['String']['output']
  id: Scalars['String']['output']
  partnerID: Scalars['String']['output']
  status: VendorDataRequestStatus
  submittedAt?: Maybe<Scalars['String']['output']>
  vendorID: Scalars['String']['output']
}

export enum VendorDataRequestStatus {
  Complete = 'COMPLETE',
  EmailFailed = 'EMAIL_FAILED',
  Expired = 'EXPIRED',
  Requested = 'REQUESTED'
}

/** Vendor document metadata. */
export type VendorDocument = {
  __typename: 'VendorDocument'
  createdAt: Scalars['String']['output']
  documentPath: Scalars['String']['output']
  filename: Scalars['String']['output']
  id: Scalars['ID']['output']
  vendorId: Scalars['ID']['output']
}

/** Vendor document with presigned download URL. */
export type VendorDocumentDownload = {
  __typename: 'VendorDocumentDownload'
  document: VendorDocument
  presignedUrl: Scalars['String']['output']
}

/** An edge in a connection. */
export type VendorEdge = {
  __typename: 'VendorEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Vendor>
}

export type VendorFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * When set, return only vendors that were merged into the given survivor.
   * Implicitly returns merged rows. Supported by PartnerVendorList only.
   */
  mergedIntoId?: InputMaybe<Scalars['String']['input']>
  /** Filter vendors by origin (how they were created). */
  origins?: InputMaybe<Array<VendorOrigin>>
  /** Filter vendors by name (case-insensitive substring match). Supported by PartnerVendorsConnection only. */
  vendorName?: InputMaybe<Scalars['String']['input']>
}

export type VendorListResponse = {
  __typename: 'VendorListResponse'
  hasMore: Scalars['Boolean']['output']
  totalCount: Scalars['Int']['output']
  vendors: Array<Vendor>
}

export type VendorOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<VendorOrderByField>
}

export enum VendorOrderByField {
  CreatedDate = 'CREATED_DATE',
  MergedDate = 'MERGED_DATE',
  Name = 'NAME'
}

/** Origin of a vendor record — how it was created in the system. */
export enum VendorOrigin {
  Manual = 'MANUAL',
  Ocr = 'OCR',
  Quickbooks = 'QUICKBOOKS'
}

export type VendorPayment = {
  __typename: 'VendorPayment'
  ID: Scalars['String']['output']
  attemptNumber: Scalars['Int']['output']
  estimatedArrivalDate?: Maybe<Scalars['String']['output']>
  failureReason?: Maybe<Scalars['String']['output']>
  holdUntil?: Maybe<Scalars['String']['output']>
  paymentMethodID: Scalars['String']['output']
  /**
   * The payment method details used at the time of the transaction.
   * This may differ from the vendor's current payment preference if it was changed after the payment.
   */
  paymentPreference?: Maybe<CompactedPaymentPreference>
  /** Speed at which the payment was dispatched. Null for legacy payments predating the speed selector. */
  paymentSpeed?: Maybe<PaymentSpeed>
  /** Disbursement rail for this payment. Null if the underlying value is unspecified or unknown. */
  paymentType?: Maybe<PaymentType>
  /** QBO sync status for this payment. */
  qboSyncStatus?: Maybe<QboPaymentSyncStatus>
  /** Funding-attempt statement descriptor for this attempt. Null when there is no correlated funding attempt. */
  reference?: Maybe<Scalars['String']['output']>
  sentAt?: Maybe<Scalars['String']['output']>
  status: VendorPaymentStatus
}

export enum VendorPaymentMethod {
  Ach = 'ACH',
  VirtualCard = 'VIRTUAL_CARD'
}

export enum VendorPaymentStatus {
  Failed = 'FAILED',
  Hold = 'HOLD',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Succeeded = 'SUCCEEDED',
  WaitingPayDate = 'WAITING_PAY_DATE'
}

/** A group of vendors identified as potential duplicates. */
export type VendorSimilarityGroup = {
  __typename: 'VendorSimilarityGroup'
  dismissedAt?: Maybe<Scalars['String']['output']>
  dismissedByCompanyId?: Maybe<Scalars['String']['output']>
  dismissedByType?: Maybe<Scalars['String']['output']>
  dismissedByUserId?: Maybe<Scalars['String']['output']>
  groupId: Scalars['ID']['output']
  members: Array<VendorSimilarityGroupMember>
}

/** A member within a vendor similarity group. */
export type VendorSimilarityGroupMember = {
  __typename: 'VendorSimilarityGroupMember'
  matchType: Scalars['String']['output']
  name: Scalars['String']['output']
  normalizedName: Scalars['String']['output']
  similarityScore: Scalars['Float']['output']
  vendorId: Scalars['ID']['output']
}

/** Response for GetVendorSimilarityGroups query. */
export type VendorSimilarityGroupsResponse = {
  __typename: 'VendorSimilarityGroupsResponse'
  groups: Array<VendorSimilarityGroup>
  totalCount: Scalars['Int']['output']
  totalVendorCount: Scalars['Int']['output']
}

export type VendorSpend = {
  __typename: 'VendorSpend'
  billCount: Scalars['Int']['output']
  totalSpend: Scalars['String']['output']
  vendorId: Scalars['String']['output']
  vendorName: Scalars['String']['output']
}

export type VendorTotals = {
  __typename: 'VendorTotals'
  billCounts: Array<BillStatusCount>
  paymentCount: Scalars['Int']['output']
  vendorId: Scalars['String']['output']
}

/**
 * Read-only signals for a virtual card issued to settle a bill.
 * Sensitive fields (PAN, CVV, expiration date, full cardholder name, billing address)
 * are intentionally excluded — they live behind a separate reveal endpoint.
 */
export type VirtualCardDetails = {
  __typename: 'VirtualCardDetails'
  /** Issuer-side reference identifier for the card. */
  cardReference: Scalars['String']['output']
  /** Lifecycle status of the issued card. */
  cardStatus: VirtualCardStatus
  /** Status of the funding attempt that triggered card issuance. */
  fundingAttemptStatus: VirtualCardFundingAttemptStatus
  /** Last 4 digits of the card PAN. */
  last4: Scalars['String']['output']
  /** Card network — e.g. visa, mastercard. */
  network: Scalars['String']['output']
}

export enum VirtualCardFundingAttemptStatus {
  VirtualCardFundingFailed = 'VIRTUAL_CARD_FUNDING_FAILED',
  VirtualCardFundingPending = 'VIRTUAL_CARD_FUNDING_PENDING',
  VirtualCardFundingSucceeded = 'VIRTUAL_CARD_FUNDING_SUCCEEDED'
}

export enum VirtualCardStatus {
  VirtualCardAuthorized = 'VIRTUAL_CARD_AUTHORIZED',
  VirtualCardBlocked = 'VIRTUAL_CARD_BLOCKED',
  VirtualCardCancelled = 'VIRTUAL_CARD_CANCELLED',
  VirtualCardExpired = 'VIRTUAL_CARD_EXPIRED',
  VirtualCardIssued = 'VIRTUAL_CARD_ISSUED',
  VirtualCardSettled = 'VIRTUAL_CARD_SETTLED'
}

export type PartnerGetCompanyIndividualByUploadLinkQueryVariables = Exact<{
  uploadLinkId: Scalars['ID']['input']
}>

export type PartnerGetCompanyIndividualByUploadLinkQuery = {
  __typename: 'Query'
  PartnerGetCompanyIndividualByUploadLink?: {
    __typename: 'CompanyIndividual'
    id: string
    firstName: string
    lastName: string
    owner: boolean
    individualDocuments?: Array<{
      __typename: 'CompanyDocument'
      id: string
      individualID?: string | null
      type: PartnerDocumentType
    } | null> | null
  } | null
}

export type PartnerUploadDocumentByUploadLinkIdMutationVariables = Exact<{
  input: UploadPartnerDocumentByUploadLinkInput
}>

export type PartnerUploadDocumentByUploadLinkIdMutation = {
  __typename: 'Mutation'
  PartnerUploadDocumentByUploadLinkId: string
}

export type PartnerCreateCardRevealTokenMutationVariables = Exact<{
  billID: Scalars['ID']['input']
}>

export type PartnerCreateCardRevealTokenMutation = {
  __typename: 'Mutation'
  PartnerCreateCardRevealToken: { __typename: 'CardRevealToken'; token: string }
}

export type PartnerCreateBillMutationVariables = Exact<{
  input?: InputMaybe<CreateBill>
}>

export type PartnerCreateBillMutation = {
  __typename: 'Mutation'
  PartnerCreateBill?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerCreateVendorMutationVariables = Exact<{
  input?: InputMaybe<CreateVendor>
}>

export type PartnerCreateVendorMutation = {
  __typename: 'Mutation'
  PartnerCreateVendor?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerUpdateVendorMutationVariables = Exact<{
  input?: InputMaybe<UpdateVendor>
}>

export type PartnerUpdateVendorMutation = {
  __typename: 'Mutation'
  PartnerUpdateVendor?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type BillsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<BillFilter>
  orderBy?: InputMaybe<BillOrderBy>
}>

export type BillsConnectionQuery = {
  __typename: 'Query'
  PartnerBillsConnection: {
    __typename: 'BillConnection'
    edges?: Array<{
      __typename: 'BillEdge'
      cursor: any
      node?: {
        __typename: 'Bill'
        ID: string
        partnerID: string
        vendorID: string
        number: string
        issueDate: string
        dueDate: string
        payDate: string
        amount: number
        description?: string | null
        status?: BillStatus | null
        source?: BillSource | null
        createdAt: string
        lastFundingFailureReason?: string | null
        vendor?: {
          __typename: 'Vendor'
          ID: string
          name: string
          email: string
          phone?: string | null
          isActive: boolean
          createdAt: string
          updatedAt: string
          category?: string | null
          companyAddress?: string | null
          city?: string | null
          state?: string | null
          postalCode?: string | null
          country?: string | null
          owner?: string | null
          taxId?: string | null
          origin?: VendorOrigin | null
          isMerged: boolean
          absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
          compactedPaymentPreference?: {
            __typename: 'CompactedPaymentPreference'
            ID: string
            institutionName: string
            accountMask: string
          } | null
        } | null
        lastStatus?: {
          __typename: 'BillLastStatus'
          ID: string
          status: BillStatus
          reason?: string | null
          createdAt: string
          executedBy?: {
            __typename: 'PartnerUser'
            id: string
            email: string
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
        vendorPayment?: Array<{
          __typename: 'VendorPayment'
          ID: string
          attemptNumber: number
          status: VendorPaymentStatus
          holdUntil?: string | null
          estimatedArrivalDate?: string | null
          sentAt?: string | null
          failureReason?: string | null
          paymentMethodID: string
          paymentType?: PaymentType | null
          reference?: string | null
          paymentPreference?: {
            __typename: 'CompactedPaymentPreference'
            ID: string
            institutionName: string
            accountMask: string
            vendorID: string
          } | null
          qboSyncStatus?: {
            __typename: 'QboPaymentSyncStatus'
            status: QboPaymentSyncState
            qboExternalId?: string | null
            lastSyncedAt?: string | null
            errorMessage?: string | null
          } | null
        } | null> | null
        lineItems?: Array<{
          __typename: 'BillLineItem'
          sequence: number
          name: string
          description?: string | null
          unitType: string
          quantity: string
          unitPrice: string
          total: string
          tax?: string | null
          expenseAccountId?: string | null
          expenseCategoryLabel?: string | null
        }> | null
        qboLinking: {
          __typename: 'QboLinking'
          state: QboLinkingState
          qboVendorId?: string | null
          lastSyncedAt?: string | null
        }
        virtualCard?: {
          __typename: 'VirtualCardDetails'
          fundingAttemptStatus: VirtualCardFundingAttemptStatus
          cardReference: string
          last4: string
          network: string
          cardStatus: VirtualCardStatus
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type BillListQueryVariables = Exact<{
  filters?: InputMaybe<BillFilter>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<BillOrderBy>
}>

export type BillListQuery = {
  __typename: 'Query'
  PartnerBillList: {
    __typename: 'BillListResponse'
    totalCount: number
    hasMore: boolean
    bills: Array<{
      __typename: 'Bill'
      ID: string
      partnerID: string
      vendorID: string
      number: string
      issueDate: string
      dueDate: string
      payDate: string
      amount: number
      description?: string | null
      status?: BillStatus | null
      source?: BillSource | null
      createdAt: string
      lastFundingFailureReason?: string | null
      vendor?: {
        __typename: 'Vendor'
        ID: string
        name: string
        email: string
        phone?: string | null
        isActive: boolean
        createdAt: string
        updatedAt: string
        category?: string | null
        companyAddress?: string | null
        city?: string | null
        state?: string | null
        postalCode?: string | null
        country?: string | null
        owner?: string | null
        taxId?: string | null
        origin?: VendorOrigin | null
        isMerged: boolean
        absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
        compactedPaymentPreference?: {
          __typename: 'CompactedPaymentPreference'
          ID: string
          institutionName: string
          accountMask: string
        } | null
      } | null
      lastStatus?: {
        __typename: 'BillLastStatus'
        ID: string
        status: BillStatus
        reason?: string | null
        createdAt: string
        executedBy?: {
          __typename: 'PartnerUser'
          id: string
          email: string
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      vendorPayment?: Array<{
        __typename: 'VendorPayment'
        ID: string
        attemptNumber: number
        status: VendorPaymentStatus
        holdUntil?: string | null
        estimatedArrivalDate?: string | null
        sentAt?: string | null
        failureReason?: string | null
        paymentMethodID: string
        paymentType?: PaymentType | null
        reference?: string | null
        paymentPreference?: {
          __typename: 'CompactedPaymentPreference'
          ID: string
          institutionName: string
          accountMask: string
          vendorID: string
        } | null
        qboSyncStatus?: {
          __typename: 'QboPaymentSyncStatus'
          status: QboPaymentSyncState
          qboExternalId?: string | null
          lastSyncedAt?: string | null
          errorMessage?: string | null
        } | null
      } | null> | null
      lineItems?: Array<{
        __typename: 'BillLineItem'
        sequence: number
        name: string
        description?: string | null
        unitType: string
        quantity: string
        unitPrice: string
        total: string
        tax?: string | null
        expenseAccountId?: string | null
        expenseCategoryLabel?: string | null
      }> | null
      qboLinking: {
        __typename: 'QboLinking'
        state: QboLinkingState
        qboVendorId?: string | null
        lastSyncedAt?: string | null
      }
      virtualCard?: {
        __typename: 'VirtualCardDetails'
        fundingAttemptStatus: VirtualCardFundingAttemptStatus
        cardReference: string
        last4: string
        network: string
        cardStatus: VirtualCardStatus
      } | null
    }>
  }
}

export type PartnerVendorSearchQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerVendorSearchQuery = {
  __typename: 'Query'
  PartnerVendorsConnection: {
    __typename: 'VendorConnection'
    edges?: Array<{
      __typename: 'VendorEdge'
      node?: {
        __typename: 'Vendor'
        ID: string
        name: string
        email: string
        phone?: string | null
      } | null
    } | null> | null
  }
}

export type VendorsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<VendorFilter>
  orderBy?: InputMaybe<VendorOrderBy>
}>

export type VendorsConnectionQuery = {
  __typename: 'Query'
  PartnerVendorsConnection: {
    __typename: 'VendorConnection'
    edges?: Array<{
      __typename: 'VendorEdge'
      cursor: any
      node?: {
        __typename: 'Vendor'
        ID: string
        name: string
        email: string
        phone?: string | null
        isActive: boolean
        createdAt: string
        updatedAt: string
        category?: string | null
        companyAddress?: string | null
        city?: string | null
        state?: string | null
        postalCode?: string | null
        country?: string | null
        owner?: string | null
        taxId?: string | null
        origin?: VendorOrigin | null
        isMerged: boolean
        compactedPaymentPreference?: {
          __typename: 'CompactedPaymentPreference'
          ID: string
          institutionName: string
          accountMask: string
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: any | null
      endCursor?: any | null
    }
  }
}

export type PartnerFindPaymentPreferenceByVendorIdQueryVariables = Exact<{
  vendorID: Scalars['String']['input']
}>

export type PartnerFindPaymentPreferenceByVendorIdQuery = {
  __typename: 'Query'
  PartnerFindPaymentPreferenceByVendorID?: {
    __typename: 'PaymentPreference'
    paymentPreferenceID: string
    country: PaymentPreferenceCountry
    source?: VendorAuditSource | null
    usPaymentPreferenceData?: {
      __typename: 'USPaymentPreference'
      institutionName: string
      routingNumber: string
      accountNumber: string
      type: PaymentPreferenceType
    } | null
  } | null
}

export type PartnerFindBillByIdQueryVariables = Exact<{
  billID: Scalars['String']['input']
}>

export type PartnerFindBillByIdQuery = {
  __typename: 'Query'
  PartnerFindBillByID?: {
    __typename: 'Bill'
    ID: string
    partnerID: string
    vendorID: string
    number: string
    issueDate: string
    dueDate: string
    payDate: string
    amount: number
    description?: string | null
    status?: BillStatus | null
    source?: BillSource | null
    createdAt: string
    lastFundingFailureReason?: string | null
    vendor?: {
      __typename: 'Vendor'
      ID: string
      name: string
      email: string
      phone?: string | null
      isActive: boolean
      createdAt: string
      updatedAt: string
      category?: string | null
      companyAddress?: string | null
      city?: string | null
      state?: string | null
      postalCode?: string | null
      country?: string | null
      owner?: string | null
      taxId?: string | null
      origin?: VendorOrigin | null
      isMerged: boolean
      absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
      compactedPaymentPreference?: {
        __typename: 'CompactedPaymentPreference'
        ID: string
        institutionName: string
        accountMask: string
      } | null
    } | null
    lastStatus?: {
      __typename: 'BillLastStatus'
      ID: string
      status: BillStatus
      reason?: string | null
      createdAt: string
      executedBy?: {
        __typename: 'PartnerUser'
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    vendorPayment?: Array<{
      __typename: 'VendorPayment'
      ID: string
      attemptNumber: number
      status: VendorPaymentStatus
      holdUntil?: string | null
      estimatedArrivalDate?: string | null
      sentAt?: string | null
      failureReason?: string | null
      paymentMethodID: string
      paymentType?: PaymentType | null
      reference?: string | null
      paymentPreference?: {
        __typename: 'CompactedPaymentPreference'
        ID: string
        institutionName: string
        accountMask: string
        vendorID: string
      } | null
      qboSyncStatus?: {
        __typename: 'QboPaymentSyncStatus'
        status: QboPaymentSyncState
        qboExternalId?: string | null
        lastSyncedAt?: string | null
        errorMessage?: string | null
      } | null
    } | null> | null
    lineItems?: Array<{
      __typename: 'BillLineItem'
      sequence: number
      name: string
      description?: string | null
      unitType: string
      quantity: string
      unitPrice: string
      total: string
      tax?: string | null
      expenseAccountId?: string | null
      expenseCategoryLabel?: string | null
    }> | null
    qboLinking: {
      __typename: 'QboLinking'
      state: QboLinkingState
      qboVendorId?: string | null
      lastSyncedAt?: string | null
    }
    virtualCard?: {
      __typename: 'VirtualCardDetails'
      fundingAttemptStatus: VirtualCardFundingAttemptStatus
      cardReference: string
      last4: string
      network: string
      cardStatus: VirtualCardStatus
    } | null
  } | null
}

export type PartnerGetBillVendorPaymentQueryVariables = Exact<{
  billID: Scalars['String']['input']
}>

export type PartnerGetBillVendorPaymentQuery = {
  __typename: 'Query'
  PartnerFindBillByID?: {
    __typename: 'Bill'
    ID: string
    vendorPayment?: Array<{
      __typename: 'VendorPayment'
      ID: string
      attemptNumber: number
      status: VendorPaymentStatus
      holdUntil?: string | null
      estimatedArrivalDate?: string | null
      sentAt?: string | null
      failureReason?: string | null
      paymentMethodID: string
      paymentType?: PaymentType | null
      reference?: string | null
      paymentPreference?: {
        __typename: 'CompactedPaymentPreference'
        ID: string
        institutionName: string
        accountMask: string
        vendorID: string
      } | null
      qboSyncStatus?: {
        __typename: 'QboPaymentSyncStatus'
        status: QboPaymentSyncState
        qboExternalId?: string | null
        lastSyncedAt?: string | null
        errorMessage?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerCreateVendorPaymentPreferenceMutationVariables = Exact<{
  input?: InputMaybe<CreateVendorPaymentPreferenceInput>
}>

export type PartnerCreateVendorPaymentPreferenceMutation = {
  __typename: 'Mutation'
  PartnerCreateVendorPaymentPreference?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerUpdateBillMutationVariables = Exact<{
  input?: InputMaybe<UpdateBill>
}>

export type PartnerUpdateBillMutation = {
  __typename: 'Mutation'
  PartnerUpdateBill?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerSubmitBillForApprovalMutationVariables = Exact<{
  billID: Scalars['String']['input']
}>

export type PartnerSubmitBillForApprovalMutation = {
  __typename: 'Mutation'
  PartnerSubmitBillForApproval?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerBulkSubmitBillsForApprovalMutationVariables = Exact<{
  billIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type PartnerBulkSubmitBillsForApprovalMutation = {
  __typename: 'Mutation'
  PartnerBulkSubmitBillsForApproval: {
    __typename: 'BulkSubmitBillsForApprovalResponse'
    results: Array<{
      __typename: 'BulkSubmitBillResult'
      billId: string
      success: boolean
      errorReason?: string | null
    }>
  }
}

export type PartnerRejectBillMutationVariables = Exact<{
  billID: Scalars['String']['input']
  reason?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerRejectBillMutation = {
  __typename: 'Mutation'
  PartnerRejectBill?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerMarkBillPaidExternallyMutationVariables = Exact<{
  billID: Scalars['String']['input']
}>

export type PartnerMarkBillPaidExternallyMutation = {
  __typename: 'Mutation'
  PartnerMarkBillPaidExternally?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerCountBillsQueryVariables = Exact<{
  input: CountBillsInput
}>

export type PartnerCountBillsQuery = {
  __typename: 'Query'
  PartnerCountBills: number
}

export type PartnerNextValidPayDateQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerNextValidPayDateQuery = {
  __typename: 'Query'
  PartnerNextValidPayDate: string
}

export type PartnerFindVendorByIdQueryVariables = Exact<{
  vendorID: Scalars['String']['input']
}>

export type PartnerFindVendorByIdQuery = {
  __typename: 'Query'
  PartnerFindVendorByID?: {
    __typename: 'Vendor'
    ID: string
    name: string
    email: string
    phone?: string | null
    isActive: boolean
    createdAt: string
    updatedAt: string
    category?: string | null
    companyAddress?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    owner?: string | null
    taxId?: string | null
    origin?: VendorOrigin | null
    isMerged: boolean
    qboLinking: {
      __typename: 'QboLinking'
      state: QboLinkingState
      qboVendorId?: string | null
      lastSyncedAt?: string | null
    }
    compactedPaymentPreference?: {
      __typename: 'CompactedPaymentPreference'
      ID: string
      institutionName: string
      accountMask: string
    } | null
  } | null
}

export type PartnerVendorPaymentHistoryQueryVariables = Exact<{
  vendorID: Scalars['String']['input']
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
}>

export type PartnerVendorPaymentHistoryQuery = {
  __typename: 'Query'
  PartnerBillsConnection: {
    __typename: 'BillConnection'
    edges?: Array<{
      __typename: 'BillEdge'
      cursor: any
      node?: {
        __typename: 'Bill'
        ID: string
        partnerID: string
        vendorID: string
        number: string
        issueDate: string
        dueDate: string
        payDate: string
        amount: number
        description?: string | null
        status?: BillStatus | null
        source?: BillSource | null
        createdAt: string
        lastFundingFailureReason?: string | null
        vendor?: {
          __typename: 'Vendor'
          ID: string
          name: string
          email: string
          phone?: string | null
          isActive: boolean
          createdAt: string
          updatedAt: string
          category?: string | null
          companyAddress?: string | null
          city?: string | null
          state?: string | null
          postalCode?: string | null
          country?: string | null
          owner?: string | null
          taxId?: string | null
          origin?: VendorOrigin | null
          isMerged: boolean
          absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
          compactedPaymentPreference?: {
            __typename: 'CompactedPaymentPreference'
            ID: string
            institutionName: string
            accountMask: string
          } | null
        } | null
        lastStatus?: {
          __typename: 'BillLastStatus'
          ID: string
          status: BillStatus
          reason?: string | null
          createdAt: string
          executedBy?: {
            __typename: 'PartnerUser'
            id: string
            email: string
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
        vendorPayment?: Array<{
          __typename: 'VendorPayment'
          ID: string
          attemptNumber: number
          status: VendorPaymentStatus
          holdUntil?: string | null
          estimatedArrivalDate?: string | null
          sentAt?: string | null
          failureReason?: string | null
          paymentMethodID: string
          paymentType?: PaymentType | null
          reference?: string | null
          paymentPreference?: {
            __typename: 'CompactedPaymentPreference'
            ID: string
            institutionName: string
            accountMask: string
            vendorID: string
          } | null
          qboSyncStatus?: {
            __typename: 'QboPaymentSyncStatus'
            status: QboPaymentSyncState
            qboExternalId?: string | null
            lastSyncedAt?: string | null
            errorMessage?: string | null
          } | null
        } | null> | null
        lineItems?: Array<{
          __typename: 'BillLineItem'
          sequence: number
          name: string
          description?: string | null
          unitType: string
          quantity: string
          unitPrice: string
          total: string
          tax?: string | null
          expenseAccountId?: string | null
          expenseCategoryLabel?: string | null
        }> | null
        qboLinking: {
          __typename: 'QboLinking'
          state: QboLinkingState
          qboVendorId?: string | null
          lastSyncedAt?: string | null
        }
        virtualCard?: {
          __typename: 'VirtualCardDetails'
          fundingAttemptStatus: VirtualCardFundingAttemptStatus
          cardReference: string
          last4: string
          network: string
          cardStatus: VirtualCardStatus
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerUpdateVendorPaymentPreferenceMutationVariables = Exact<{
  input?: InputMaybe<UpdateVendorPaymentPreferenceInput>
}>

export type PartnerUpdateVendorPaymentPreferenceMutation = {
  __typename: 'Mutation'
  PartnerUpdateVendorPaymentPreference?: {
    __typename: 'UpdateVendorPaymentPreferenceResponse'
    paymentPreferenceID: string
    paymentMethodID: string
  } | null
}

export type PartnerStartAccountsPayableOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type PartnerStartAccountsPayableOnboardingMutation = {
  __typename: 'Mutation'
  PartnerStartAccountsPayableOnboarding: {
    __typename: 'StartAccountsPayableOnboardingReply'
    validations: Array<string>
  }
}

export type PartnerCreateFundingAttemptsMutationVariables = Exact<{
  input: CreateFundingAttemptsInput
}>

export type PartnerCreateFundingAttemptsMutation = {
  __typename: 'Mutation'
  PartnerCreateFundingAttempts: {
    __typename: 'CreateFundingAttemptsResponse'
    results: Array<{
      __typename: 'CreateFundingAttemptResult'
      billId: string
      success: boolean
      billStatus?: BillStatus | null
    }>
  }
}

export type PartnerChangeBillReceivingMethodMutationVariables = Exact<{
  input: ChangeBillReceivingMethodInput
}>

export type PartnerChangeBillReceivingMethodMutation = {
  __typename: 'Mutation'
  PartnerChangeBillReceivingMethod: {
    __typename: 'ChangeBillReceivingMethodResult'
    billId: string
    success: boolean
    errorCode?: string | null
    errorMessage?: string | null
    billStatus?: BillStatus | null
  }
}

export type PartnerRevealVirtualCardMutationVariables = Exact<{
  billID: Scalars['ID']['input']
}>

export type PartnerRevealVirtualCardMutation = {
  __typename: 'Mutation'
  PartnerRevealVirtualCard: {
    __typename: 'RevealedVirtualCard'
    cardReference: string
    last4: string
    network: string
    cardholderName: string
    panToken: string
    cvvToken: string
    expiryMonthToken: string
    expiryYearToken: string
  }
}

export type PartnerGetAccountsPayableConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetAccountsPayableConfigQuery = {
  __typename: 'Query'
  PartnerGetAccountsPayableConfig: {
    __typename: 'AccountsPayableConfig'
    mailbox: string
    onboardingStatus: AccountsPayableOnboardingStatus
    accountingProvider?: AccountingProvider | null
  }
}

export type PartnerUpdateBillPayDateMutationVariables = Exact<{
  input: UpdateBillPayDateInput
}>

export type PartnerUpdateBillPayDateMutation = {
  __typename: 'Mutation'
  PartnerUpdateBillPayDate?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerDownloadBillDocumentQueryVariables = Exact<{
  billId: Scalars['ID']['input']
}>

export type PartnerDownloadBillDocumentQuery = {
  __typename: 'Query'
  partnerDownloadBillDocument?: {
    __typename: 'BillDocumentDownload'
    downloadUrl: string
    filename: string
    mimeType: string
  } | null
}

export type PartnerCancelVendorPaymentMutationVariables = Exact<{
  input: CancelVendorPaymentInput
}>

export type PartnerCancelVendorPaymentMutation = {
  __typename: 'Mutation'
  PartnerCancelVendorPayment: {
    __typename: 'CancelVendorPaymentResponse'
    paymentId: string
    status: string
  }
}

export type PartnerBulkCancelVendorPaymentsMutationVariables = Exact<{
  input: BulkCancelVendorPaymentsInput
}>

export type PartnerBulkCancelVendorPaymentsMutation = {
  __typename: 'Mutation'
  PartnerBulkCancelVendorPayments: {
    __typename: 'BulkCancelVendorPaymentsResponse'
    results: Array<{
      __typename: 'BulkCancelVendorPaymentResult'
      billId: string
      success: boolean
      errorReason?: string | null
    }>
  }
}

export type PartnerBulkCancelBillScheduleMutationVariables = Exact<{
  input: BulkCancelBillScheduleInput
}>

export type PartnerBulkCancelBillScheduleMutation = {
  __typename: 'Mutation'
  PartnerBulkCancelBillSchedule: {
    __typename: 'BulkCancelBillScheduleResponse'
    results: Array<{
      __typename: 'BulkCancelBillScheduleResult'
      billId: string
      success: boolean
      errorReason?: string | null
    }>
  }
}

export type PartnerGetAccountsPayableNotificationPolicyQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetAccountsPayableNotificationPolicyQuery = {
  __typename: 'Query'
  PartnerGetAccountsPayableConfig: {
    __typename: 'AccountsPayableConfig'
    notificationPolicy: {
      __typename: 'AccountsPayableNotificationPolicy'
      billCreatedEnabled: boolean
      billOverdueEnabled: boolean
      paymentFailedEnabled: boolean
      emailIngestionFailedEnabled: boolean
    }
  }
}

export type PartnerUpdateAccountsPayableNotificationPolicyMutationVariables =
  Exact<{
    input: UpdateAccountsPayableNotificationPolicyInput
  }>

export type PartnerUpdateAccountsPayableNotificationPolicyMutation = {
  __typename: 'Mutation'
  PartnerUpdateAccountsPayableNotificationPolicy: {
    __typename: 'AccountsPayableNotificationPolicy'
    billCreatedEnabled: boolean
    billOverdueEnabled: boolean
    paymentFailedEnabled: boolean
    emailIngestionFailedEnabled: boolean
  }
}

export type PartnerDeleteBillsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type PartnerDeleteBillsMutation = {
  __typename: 'Mutation'
  PartnerDeleteBills: {
    __typename: 'DeleteBillsResponse'
    results: Array<{
      __typename: 'DeleteBillResult'
      billId: string
      success: boolean
      errorReason?: string | null
    }>
  }
}

export type ApNotificationPolicyFragment = {
  __typename: 'AccountsPayableNotificationPolicy'
  billCreatedEnabled: boolean
  billOverdueEnabled: boolean
  paymentFailedEnabled: boolean
  emailIngestionFailedEnabled: boolean
}

export type PaymentPreferenceFragment = {
  __typename: 'PaymentPreference'
  paymentPreferenceID: string
  country: PaymentPreferenceCountry
  source?: VendorAuditSource | null
  usPaymentPreferenceData?: {
    __typename: 'USPaymentPreference'
    institutionName: string
    routingNumber: string
    accountNumber: string
    type: PaymentPreferenceType
  } | null
}

export type PartnerVendorSearchFragment = {
  __typename: 'Vendor'
  ID: string
  name: string
  email: string
  phone?: string | null
}

export type VendorListItemFragment = {
  __typename: 'Vendor'
  ID: string
  name: string
  email: string
  phone?: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
  category?: string | null
  companyAddress?: string | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  country?: string | null
  owner?: string | null
  taxId?: string | null
  origin?: VendorOrigin | null
  isMerged: boolean
  compactedPaymentPreference?: {
    __typename: 'CompactedPaymentPreference'
    ID: string
    institutionName: string
    accountMask: string
  } | null
}

export type VendorFragment = {
  __typename: 'Vendor'
  ID: string
  name: string
  email: string
  phone?: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
  category?: string | null
  companyAddress?: string | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  country?: string | null
  owner?: string | null
  taxId?: string | null
  origin?: VendorOrigin | null
  isMerged: boolean
  qboLinking: {
    __typename: 'QboLinking'
    state: QboLinkingState
    qboVendorId?: string | null
    lastSyncedAt?: string | null
  }
  compactedPaymentPreference?: {
    __typename: 'CompactedPaymentPreference'
    ID: string
    institutionName: string
    accountMask: string
  } | null
}

export type BillVendorFragment = {
  __typename: 'Vendor'
  ID: string
  name: string
  email: string
  phone?: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
  category?: string | null
  companyAddress?: string | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  country?: string | null
  owner?: string | null
  taxId?: string | null
  origin?: VendorOrigin | null
  isMerged: boolean
  absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
  compactedPaymentPreference?: {
    __typename: 'CompactedPaymentPreference'
    ID: string
    institutionName: string
    accountMask: string
  } | null
}

export type BillLastStatusFragment = {
  __typename: 'BillLastStatus'
  ID: string
  status: BillStatus
  reason?: string | null
  createdAt: string
  executedBy?: {
    __typename: 'PartnerUser'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type VendorPaymentFragmentFragment = {
  __typename: 'VendorPayment'
  ID: string
  attemptNumber: number
  status: VendorPaymentStatus
  holdUntil?: string | null
  estimatedArrivalDate?: string | null
  sentAt?: string | null
  failureReason?: string | null
  paymentMethodID: string
  paymentType?: PaymentType | null
  reference?: string | null
  paymentPreference?: {
    __typename: 'CompactedPaymentPreference'
    ID: string
    institutionName: string
    accountMask: string
    vendorID: string
  } | null
  qboSyncStatus?: {
    __typename: 'QboPaymentSyncStatus'
    status: QboPaymentSyncState
    qboExternalId?: string | null
    lastSyncedAt?: string | null
    errorMessage?: string | null
  } | null
}

export type BillLineItemFragment = {
  __typename: 'BillLineItem'
  sequence: number
  name: string
  description?: string | null
  unitType: string
  quantity: string
  unitPrice: string
  total: string
  tax?: string | null
  expenseAccountId?: string | null
  expenseCategoryLabel?: string | null
}

export type BillConnectionFragment = {
  __typename: 'Bill'
  ID: string
  partnerID: string
  vendorID: string
  number: string
  issueDate: string
  dueDate: string
  payDate: string
  amount: number
  description?: string | null
  status?: BillStatus | null
  source?: BillSource | null
  createdAt: string
  lastFundingFailureReason?: string | null
  vendor?: {
    __typename: 'Vendor'
    ID: string
    name: string
    email: string
    phone?: string | null
    isActive: boolean
    createdAt: string
    updatedAt: string
    category?: string | null
    companyAddress?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    owner?: string | null
    taxId?: string | null
    origin?: VendorOrigin | null
    isMerged: boolean
    absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
    compactedPaymentPreference?: {
      __typename: 'CompactedPaymentPreference'
      ID: string
      institutionName: string
      accountMask: string
    } | null
  } | null
  lastStatus?: {
    __typename: 'BillLastStatus'
    ID: string
    status: BillStatus
    reason?: string | null
    createdAt: string
    executedBy?: {
      __typename: 'PartnerUser'
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
    } | null
  } | null
  vendorPayment?: Array<{
    __typename: 'VendorPayment'
    ID: string
    attemptNumber: number
    status: VendorPaymentStatus
    holdUntil?: string | null
    estimatedArrivalDate?: string | null
    sentAt?: string | null
    failureReason?: string | null
    paymentMethodID: string
    paymentType?: PaymentType | null
    reference?: string | null
    paymentPreference?: {
      __typename: 'CompactedPaymentPreference'
      ID: string
      institutionName: string
      accountMask: string
      vendorID: string
    } | null
    qboSyncStatus?: {
      __typename: 'QboPaymentSyncStatus'
      status: QboPaymentSyncState
      qboExternalId?: string | null
      lastSyncedAt?: string | null
      errorMessage?: string | null
    } | null
  } | null> | null
  lineItems?: Array<{
    __typename: 'BillLineItem'
    sequence: number
    name: string
    description?: string | null
    unitType: string
    quantity: string
    unitPrice: string
    total: string
    tax?: string | null
    expenseAccountId?: string | null
    expenseCategoryLabel?: string | null
  }> | null
  qboLinking: {
    __typename: 'QboLinking'
    state: QboLinkingState
    qboVendorId?: string | null
    lastSyncedAt?: string | null
  }
  virtualCard?: {
    __typename: 'VirtualCardDetails'
    fundingAttemptStatus: VirtualCardFundingAttemptStatus
    cardReference: string
    last4: string
    network: string
    cardStatus: VirtualCardStatus
  } | null
}

export type BillFragment = {
  __typename: 'Bill'
  ID: string
  partnerID: string
  vendorID: string
  number: string
  issueDate: string
  dueDate: string
  payDate: string
  amount: number
  description?: string | null
  status?: BillStatus | null
  source?: BillSource | null
  createdAt: string
  lastFundingFailureReason?: string | null
  vendor?: {
    __typename: 'Vendor'
    ID: string
    name: string
    email: string
    phone?: string | null
    isActive: boolean
    createdAt: string
    updatedAt: string
    category?: string | null
    companyAddress?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    owner?: string | null
    taxId?: string | null
    origin?: VendorOrigin | null
    isMerged: boolean
    absorbedBy?: { __typename: 'Vendor'; ID: string; name: string } | null
    compactedPaymentPreference?: {
      __typename: 'CompactedPaymentPreference'
      ID: string
      institutionName: string
      accountMask: string
    } | null
  } | null
  lastStatus?: {
    __typename: 'BillLastStatus'
    ID: string
    status: BillStatus
    reason?: string | null
    createdAt: string
    executedBy?: {
      __typename: 'PartnerUser'
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
    } | null
  } | null
  vendorPayment?: Array<{
    __typename: 'VendorPayment'
    ID: string
    attemptNumber: number
    status: VendorPaymentStatus
    holdUntil?: string | null
    estimatedArrivalDate?: string | null
    sentAt?: string | null
    failureReason?: string | null
    paymentMethodID: string
    paymentType?: PaymentType | null
    reference?: string | null
    paymentPreference?: {
      __typename: 'CompactedPaymentPreference'
      ID: string
      institutionName: string
      accountMask: string
      vendorID: string
    } | null
    qboSyncStatus?: {
      __typename: 'QboPaymentSyncStatus'
      status: QboPaymentSyncState
      qboExternalId?: string | null
      lastSyncedAt?: string | null
      errorMessage?: string | null
    } | null
  } | null> | null
  lineItems?: Array<{
    __typename: 'BillLineItem'
    sequence: number
    name: string
    description?: string | null
    unitType: string
    quantity: string
    unitPrice: string
    total: string
    tax?: string | null
    expenseAccountId?: string | null
    expenseCategoryLabel?: string | null
  }> | null
  qboLinking: {
    __typename: 'QboLinking'
    state: QboLinkingState
    qboVendorId?: string | null
    lastSyncedAt?: string | null
  }
  virtualCard?: {
    __typename: 'VirtualCardDetails'
    fundingAttemptStatus: VirtualCardFundingAttemptStatus
    cardReference: string
    last4: string
    network: string
    cardStatus: VirtualCardStatus
  } | null
}

export type PartialCompanyIndividualFragment = {
  __typename: 'CompanyIndividual'
  id: string
  firstName: string
  lastName: string
  owner: boolean
  individualDocuments?: Array<{
    __typename: 'CompanyDocument'
    id: string
    individualID?: string | null
    type: PartnerDocumentType
  } | null> | null
}

export type PartnerSearchAccountingItemsQueryVariables = Exact<{
  platformName: PlatformName
  query: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>
}>

export type PartnerSearchAccountingItemsQuery = {
  __typename: 'Query'
  PartnerSearchAccountingItems: Array<{
    __typename: 'AccountingItem'
    id: string
    externalId: string
    name: string
    description?: string | null
    type: string
    active: boolean
    unitPrice: string
    purchaseCost: string
    expenseAccountId?: string | null
    incomeAccountId?: string | null
    taxable: boolean
  }>
}

export type AccountingItemFragmentFragment = {
  __typename: 'AccountingItem'
  id: string
  externalId: string
  name: string
  description?: string | null
  type: string
  active: boolean
  unitPrice: string
  purchaseCost: string
  expenseAccountId?: string | null
  incomeAccountId?: string | null
  taxable: boolean
}

export type AccountsPayableConfigFragment = {
  __typename: 'AccountsPayableConfig'
  mailbox: string
  onboardingStatus: AccountsPayableOnboardingStatus
  accountingProvider?: AccountingProvider | null
}

export type ApFundingAccountFragment = {
  __typename: 'Account'
  id: string
  customName?: string | null
  mask?: string | null
  subtype?: string | null
  companyName?: string | null
  institution?: { __typename: 'Institution'; name?: string | null } | null
}

export type PartnerGetAccountsPayableFundingAccountQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetAccountsPayableFundingAccountQuery = {
  __typename: 'Query'
  PartnerGetAccountsPayableConfig: {
    __typename: 'AccountsPayableConfig'
    fundingBankingAccount?: {
      __typename: 'Account'
      id: string
      customName?: string | null
      mask?: string | null
      subtype?: string | null
      companyName?: string | null
      institution?: { __typename: 'Institution'; name?: string | null } | null
    } | null
  }
}

export type PartnerChangeAccountsPayableFundingAccountMutationVariables =
  Exact<{
    input: PartnerAccountsPayableFundingAccountUpdateInput
  }>

export type PartnerChangeAccountsPayableFundingAccountMutation = {
  __typename: 'Mutation'
  PartnerChangeAccountsPayableFundingAccount: {
    __typename: 'AccountsPayableConfig'
    fundingBankingAccount?: {
      __typename: 'Account'
      id: string
      customName?: string | null
      mask?: string | null
      subtype?: string | null
      companyName?: string | null
      institution?: { __typename: 'Institution'; name?: string | null } | null
    } | null
  }
}

export type PartnerListVendorDataRequestsQueryVariables = Exact<{
  vendorID: Scalars['String']['input']
}>

export type PartnerListVendorDataRequestsQuery = {
  __typename: 'Query'
  PartnerListVendorDataRequests: Array<{
    __typename: 'VendorDataRequest'
    id: string
    vendorID: string
    partnerID: string
    status: VendorDataRequestStatus
    createdAt: string
    expiresAt: string
    submittedAt?: string | null
  }>
}

export type PartnerCreateVendorDataRequestMutationVariables = Exact<{
  vendorID: Scalars['String']['input']
  email?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerCreateVendorDataRequestMutation = {
  __typename: 'Mutation'
  PartnerCreateVendorDataRequest?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type PartnerResendVendorDataRequestMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type PartnerResendVendorDataRequestMutation = {
  __typename: 'Mutation'
  PartnerResendVendorDataRequest?: {
    __typename: 'AccountsPayableResponse'
    ID: string
  } | null
}

export type GetVendorDataRequestByTokenQueryVariables = Exact<{
  token: Scalars['String']['input']
}>

export type GetVendorDataRequestByTokenQuery = {
  __typename: 'Query'
  GetVendorDataRequestByToken: {
    __typename: 'PublicVendorDataResponse'
    status: PublicVendorDataRequestStatus
    partnerName: string
    expiresAt: string
    vendor: {
      __typename: 'Vendor'
      ID: string
      name: string
      email: string
      phone?: string | null
      category?: string | null
      taxId?: string | null
      companyAddress?: string | null
      city?: string | null
      state?: string | null
      postalCode?: string | null
      country?: string | null
      owner?: string | null
      ownerEmail?: string | null
      ownerPhone?: string | null
      acceptsCreditCard?: boolean | null
    }
  }
}

export type SubmitVendorDataMutationVariables = Exact<{
  input: SubmitVendorDataInput
}>

export type SubmitVendorDataMutation = {
  __typename: 'Mutation'
  SubmitVendorData: { __typename: 'SubmitVendorDataResponse'; success: boolean }
}

export type PartnerDeactivateVendorMutationVariables = Exact<{
  vendorID: Scalars['ID']['input']
}>

export type PartnerDeactivateVendorMutation = {
  __typename: 'Mutation'
  PartnerDeactivateVendor: {
    __typename: 'VendorActivationResponse'
    vendorId: string
    affectedBillCount: number
  }
}

export type PartnerReactivateVendorMutationVariables = Exact<{
  vendorID: Scalars['ID']['input']
}>

export type PartnerReactivateVendorMutation = {
  __typename: 'Mutation'
  PartnerReactivateVendor: {
    __typename: 'VendorActivationResponse'
    vendorId: string
    affectedBillCount: number
  }
}

export type PartnerBatchDeactivateVendorsMutationVariables = Exact<{
  vendorIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type PartnerBatchDeactivateVendorsMutation = {
  __typename: 'Mutation'
  PartnerBatchDeactivateVendors: {
    __typename: 'BatchVendorActivationResponse'
    results: Array<{
      __typename: 'BatchVendorResult'
      vendorId: string
      success: boolean
      errorReason?: string | null
      affectedBillCount: number
    }>
  }
}

export type PartnerBatchReactivateVendorsMutationVariables = Exact<{
  vendorIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type PartnerBatchReactivateVendorsMutation = {
  __typename: 'Mutation'
  PartnerBatchReactivateVendors: {
    __typename: 'BatchVendorActivationResponse'
    results: Array<{
      __typename: 'BatchVendorResult'
      vendorId: string
      success: boolean
      errorReason?: string | null
      affectedBillCount: number
    }>
  }
}

export type PartnerSetAccountingIntegrationMutationVariables = Exact<{
  provider?: InputMaybe<AccountingProvider>
}>

export type PartnerSetAccountingIntegrationMutation = {
  __typename: 'Mutation'
  PartnerSetAccountingIntegration: {
    __typename: 'AccountsPayableConfig'
    mailbox: string
    onboardingStatus: AccountsPayableOnboardingStatus
    accountingProvider?: AccountingProvider | null
  }
}

export type PartnerUploadBillDocumentMutationVariables = Exact<{
  input: UploadBillDocumentInput
}>

export type PartnerUploadBillDocumentMutation = {
  __typename: 'Mutation'
  PartnerUploadBillDocument: {
    __typename: 'UploadBillDocumentPayload'
    billId: string
    billNumber: string
    documentPath?: string | null
    warnings?: Array<string> | null
    extractedData?: {
      __typename: 'ExtractedBillData'
      vendorName?: string | null
      vendorEmail?: string | null
      invoiceNumber?: string | null
      total?: string | null
      issueDate?: string | null
      dueDate?: string | null
      description?: string | null
      lineItems?: Array<{
        __typename: 'ExtractedLineItem'
        name: string
        description?: string | null
        quantity: string
        unitPrice: string
        total: string
        category?: string | null
        expenseAccountId?: string | null
        amount?: string | null
      }> | null
    } | null
  }
}

export type PartnerExtractBillDataMutationVariables = Exact<{
  input: ExtractBillDataInput
}>

export type PartnerExtractBillDataMutation = {
  __typename: 'Mutation'
  PartnerExtractBillData: {
    __typename: 'ExtractBillDataPayload'
    documentPath?: string | null
    warnings?: Array<string> | null
    extractedData?: {
      __typename: 'ExtractedBillData'
      vendorName?: string | null
      vendorEmail?: string | null
      invoiceNumber?: string | null
      total?: string | null
      issueDate?: string | null
      dueDate?: string | null
      description?: string | null
      lineItems?: Array<{
        __typename: 'ExtractedLineItem'
        name: string
        description?: string | null
        quantity: string
        unitPrice: string
        total: string
        category?: string | null
        expenseAccountId?: string | null
        amount?: string | null
      }> | null
    } | null
  }
}

export type PartnerListVendorAuditLogQueryVariables = Exact<{
  vendorID: Scalars['String']['input']
  entityType: VendorAuditEntityType
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  actions?: InputMaybe<Array<VendorAuditAction> | VendorAuditAction>
}>

export type PartnerListVendorAuditLogQuery = {
  __typename: 'Query'
  PartnerListVendorAuditLog: {
    __typename: 'VendorAuditLogListResponse'
    totalCount: number
    hasMore: boolean
    eventsCount: number
    fieldsAddedCount: number
    fieldsUpdatedCount: number
    entries: Array<{
      __typename: 'VendorAuditLog'
      id: string
      vendorId: string
      partnerId: string
      entityId: string
      entityType: VendorAuditEntityType
      executorEntity: ExecutorEntityType
      executorId?: string | null
      action: VendorAuditAction
      fieldName?: string | null
      oldValue?: string | null
      newValue?: string | null
      createdAt: string
      isInitialCreation: boolean
      source?: VendorAuditSource | null
      executorUser?: {
        __typename: 'PartnerUser'
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
      } | null
    }>
  }
}

export type VendorAuditLogEntryFragment = {
  __typename: 'VendorAuditLog'
  id: string
  vendorId: string
  partnerId: string
  entityId: string
  entityType: VendorAuditEntityType
  executorEntity: ExecutorEntityType
  executorId?: string | null
  action: VendorAuditAction
  fieldName?: string | null
  oldValue?: string | null
  newValue?: string | null
  createdAt: string
  isInitialCreation: boolean
  source?: VendorAuditSource | null
  executorUser?: {
    __typename: 'PartnerUser'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type VendorSimilarityGroupFieldsFragment = {
  __typename: 'VendorSimilarityGroup'
  groupId: string
  dismissedAt?: string | null
  members: Array<{
    __typename: 'VendorSimilarityGroupMember'
    vendorId: string
    name: string
    normalizedName: string
    matchType: string
    similarityScore: number
  }>
}

export type PartnerGetVendorSimilarityGroupsQueryVariables = Exact<{
  input: GetVendorSimilarityGroupsInput
}>

export type PartnerGetVendorSimilarityGroupsQuery = {
  __typename: 'Query'
  PartnerGetVendorSimilarityGroups: {
    __typename: 'VendorSimilarityGroupsResponse'
    totalCount: number
    totalVendorCount: number
    groups: Array<{
      __typename: 'VendorSimilarityGroup'
      groupId: string
      dismissedAt?: string | null
      members: Array<{
        __typename: 'VendorSimilarityGroupMember'
        vendorId: string
        name: string
        normalizedName: string
        matchType: string
        similarityScore: number
      }>
    }>
  }
}

export type PartnerGetVendorTotalsQueryVariables = Exact<{
  input: GetVendorTotalsInput
}>

export type PartnerGetVendorTotalsQuery = {
  __typename: 'Query'
  PartnerGetVendorTotals: Array<{
    __typename: 'VendorTotals'
    vendorId: string
    paymentCount: number
    billCounts: Array<{
      __typename: 'BillStatusCount'
      status: BillStatus
      count: number
    }>
  }>
}

export type PartnerMergeVendorsMutationVariables = Exact<{
  input: MergeVendorsInput
}>

export type PartnerMergeVendorsMutation = {
  __typename: 'Mutation'
  PartnerMergeVendors: {
    __typename: 'MergeVendorsPayload'
    results: Array<{
      __typename: 'MergeGroupResult'
      survivorId: string
      accepted: boolean
      errorReason?: string | null
    }>
  }
}

export type PartnerDismissVendorSimilarityGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input']
}>

export type PartnerDismissVendorSimilarityGroupMutation = {
  __typename: 'Mutation'
  PartnerDismissVendorSimilarityGroup: boolean
}

export type MergedVendorFieldsFragment = {
  __typename: 'Vendor'
  ID: string
  name: string
  email: string
  origin?: VendorOrigin | null
  mergedAt?: string | null
  compactedPaymentPreference?: {
    __typename: 'CompactedPaymentPreference'
    ID: string
    institutionName: string
    accountMask: string
  } | null
  mergedByUser?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  } | null
}

export type PartnerListMergedVendorsQueryVariables = Exact<{
  survivorID: Scalars['String']['input']
  limit: Scalars['Int']['input']
  offset: Scalars['Int']['input']
}>

export type PartnerListMergedVendorsQuery = {
  __typename: 'Query'
  PartnerVendorList: {
    __typename: 'VendorListResponse'
    totalCount: number
    hasMore: boolean
    vendors: Array<{
      __typename: 'Vendor'
      ID: string
      name: string
      email: string
      origin?: VendorOrigin | null
      mergedAt?: string | null
      compactedPaymentPreference?: {
        __typename: 'CompactedPaymentPreference'
        ID: string
        institutionName: string
        accountMask: string
      } | null
      mergedByUser?: {
        __typename: 'PartnerUser'
        id: string
        firstName?: string | null
        lastName?: string | null
        email: string
      } | null
    }>
  }
}

export type PartnerRetryPaymentQboSyncMutationVariables = Exact<{
  vendorPaymentId: Scalars['ID']['input']
}>

export type PartnerRetryPaymentQboSyncMutation = {
  __typename: 'Mutation'
  PartnerRetryPaymentQboSync: {
    __typename: 'QboPaymentSyncStatus'
    status: QboPaymentSyncState
    qboExternalId?: string | null
    lastSyncedAt?: string | null
    errorMessage?: string | null
  }
}

export type GetVendorCardViewQueryVariables = Exact<{
  token: Scalars['String']['input']
}>

export type GetVendorCardViewQuery = {
  __typename: 'Query'
  GetVendorCardView: {
    __typename: 'PublicVendorCardView'
    partnerName: string
    billNumber: string
    billAmount: string
    billCurrency: string
    last4: string
    expiresAt: string
  }
}

export type RequestVendorCardOtpMutationVariables = Exact<{
  token: Scalars['String']['input']
  vendorEmail: Scalars['String']['input']
}>

export type RequestVendorCardOtpMutation = {
  __typename: 'Mutation'
  RequestVendorCardOTP: {
    __typename: 'RequestVendorCardOTPResponse'
    success: boolean
  }
}

export type RevealVendorCardDataMutationVariables = Exact<{
  token: Scalars['String']['input']
  otpCode: Scalars['String']['input']
}>

export type RevealVendorCardDataMutation = {
  __typename: 'Mutation'
  RevealVendorCardData: {
    __typename: 'RevealedVendorCard'
    revealToken: string
    last4: string
    network: string
    billingAddress: string
  }
}

export type InboundEmailAttachmentFragment = {
  __typename: 'InboundEmailAttachment'
  ID: string
  filename: string
  contentType: string
  size: number
  s3Path?: string | null
  isUsedForBill: boolean
}

export type InboundEmailFragment = {
  __typename: 'InboundEmail'
  ID: string
  messageID: string
  fromName: string
  from: string
  to: string
  subject: string
  date: string
  textBody: string
  htmlBody: string
  attachments: Array<{
    __typename: 'InboundEmailAttachment'
    ID: string
    filename: string
    contentType: string
    size: number
    s3Path?: string | null
    isUsedForBill: boolean
  }>
}

export type PartnerFindInboundEmailByBillIdQueryVariables = Exact<{
  billID: Scalars['String']['input']
}>

export type PartnerFindInboundEmailByBillIdQuery = {
  __typename: 'Query'
  PartnerFindInboundEmailByBillID?: {
    __typename: 'InboundEmail'
    ID: string
    messageID: string
    fromName: string
    from: string
    to: string
    subject: string
    date: string
    textBody: string
    htmlBody: string
    attachments: Array<{
      __typename: 'InboundEmailAttachment'
      ID: string
      filename: string
      contentType: string
      size: number
      s3Path?: string | null
      isUsedForBill: boolean
    }>
  } | null
}

export type PartnerGetBillAggregatesQueryVariables = Exact<{
  input: GetBillAggregatesInput
}>

export type PartnerGetBillAggregatesQuery = {
  __typename: 'Query'
  PartnerGetBillAggregates: {
    __typename: 'BillAggregates'
    totalAmount: string
    totalCount: number
    byAgingBucket: Array<{
      __typename: 'BillAgingBucketAggregate'
      bucket: string
      amount: string
      count: number
    }>
  }
}

export type PartnerGetVendorSpendQueryVariables = Exact<{
  input: GetVendorSpendInput
}>

export type PartnerGetVendorSpendQuery = {
  __typename: 'Query'
  PartnerGetVendorSpend: Array<{
    __typename: 'VendorSpend'
    vendorId: string
    vendorName: string
    billCount: number
    totalSpend: string
  }>
}

export type PartnerGetSpendByCategoryQueryVariables = Exact<{
  input: GetSpendByCategoryInput
}>

export type PartnerGetSpendByCategoryQuery = {
  __typename: 'Query'
  PartnerGetSpendByCategory: {
    __typename: 'SpendByCategory'
    totalSpend: string
    delta: number
    byCategory: Array<{
      __typename: 'CategorySpend'
      category: string
      amount: string
      pct: number
    }>
  }
}

export type PartnerGetPaymentMethodUsageQueryVariables = Exact<{
  input: GetPaymentMethodUsageInput
}>

export type PartnerGetPaymentMethodUsageQuery = {
  __typename: 'Query'
  PartnerGetPaymentMethodUsage: Array<{
    __typename: 'PaymentMethodUsage'
    method: string
    amount: string
    delta: number
  }>
}

export type PartnerGetRecentActivityQueryVariables = Exact<{
  input: GetRecentActivityInput
}>

export type PartnerGetRecentActivityQuery = {
  __typename: 'Query'
  PartnerGetRecentActivity: Array<{
    __typename: 'ActivityItem'
    id: string
    kind: ActivityKind
    billId: string
    vendorName: string
    amount: string
    billStatus?: BillStatus | null
    paymentStatus?: VendorPaymentStatus | null
    occurredAt: string
  }>
}

export type AccountsPayablePaymentAggregatesQueryVariables = Exact<{
  filters?: InputMaybe<AccountsPayablePaymentFilter>
}>

export type AccountsPayablePaymentAggregatesQuery = {
  __typename: 'Query'
  PartnerAccountsPayablePaymentAggregates: {
    __typename: 'AccountsPayablePaymentAggregates'
    totalAmount: string
    totalAttemptCount: number
    byStatus: Array<{
      __typename: 'AccountsPayablePaymentStatusAggregate'
      status: BillStatus
      amount: string
      billCount: number
    }>
  }
}

export type SolveRemediationActionsByIDsMutationVariables = Exact<{
  actionIDs: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type SolveRemediationActionsByIDsMutation = {
  __typename: 'Mutation'
  SolveRemediationActionsByIDs: string
}

export type GetAdyenDocumentTypesQueryVariables = Exact<{
  ownerType: AdyenOwnerType
}>

export type GetAdyenDocumentTypesQuery = {
  __typename: 'Query'
  GetAdyenDocumentTypes: Array<AdyenUploadDocumentType>
}

export type SolveAdyenRemediationActionsMutationVariables = Exact<{
  [key: string]: never
}>

export type SolveAdyenRemediationActionsMutation = {
  __typename: 'Mutation'
  SolveAdyenRemediationActions: string
}

export type UploadAdyenDocumentMutationVariables = Exact<{
  input: UploadAdyenDocumentInput
}>

export type UploadAdyenDocumentMutation = {
  __typename: 'Mutation'
  UploadAdyenDocument: {
    __typename: 'UploadAdyenDocumentResponse'
    failed: boolean
    details?: string | null
  }
}

export type GetAdyenRemediationActionsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenRemediationActionsQuery = {
  __typename: 'Query'
  GetAdyenRemediationActions: {
    __typename: 'GetAdyenRemediationActionsReply'
    groupings: Array<{
      __typename: 'GetAdyenRemediationActionsGrouping'
      errorCode: string
      errorMessage: string
      ownerID: string
      ownerType: AdyenOwnerType
      actions: Array<{
        __typename: 'GetAdyenRemediationActionsItem'
        actionID: string
        actionType: AdyenRemediationActionType
        unmappedRemediationActionCode?: string | null
      }>
    }>
  }
}

export type GetAdyenHostedOnboardingLinkQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenHostedOnboardingLinkQuery = {
  __typename: 'Query'
  GetAdyenHostedOnboardingLink?: {
    __typename: 'GetAdyenHostedOnboardingLinkResponse'
    url: string
  } | null
}

export type StagingStartAdyenOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type StagingStartAdyenOnboardingMutation = {
  __typename: 'Mutation'
  StagingStartAdyenOnboarding?: {
    __typename: 'StartAdyenOnboardingReply'
    validations: Array<string>
  } | null
}

export type GetAdyenPciFormsQueryVariables = Exact<{ [key: string]: never }>

export type GetAdyenPciFormsQuery = {
  __typename: 'Query'
  GetAdyenPciForms: {
    __typename: 'AdyenPciForms'
    pciIds: Array<string>
    document: string
  }
}

export type GetAdyenTermsOfServiceQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenTermsOfServiceQuery = {
  __typename: 'Query'
  GetAdyenTermsOfService: Array<{
    __typename: 'AdyenTermsOfServiceDocument'
    tosID: string
    tosType: string
    document: string
  }>
}

export type GetAdyenOnboardingStatusQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenOnboardingStatusQuery = {
  __typename: 'Query'
  GetAdyenOnboardingStatus: {
    __typename: 'AdyenOnboardingStatus'
    termsOfServiceAccepted: boolean
    pciFormsSigned: boolean
    tosAndPciEntitiesCreated: boolean
  }
}

export type GetAnalyticsSyncStateQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAnalyticsSyncStateQuery = {
  __typename: 'Query'
  PartnerGetAnalyticsSyncState: {
    __typename: 'AnalyticsSyncStateResponse'
    sources: Array<{
      __typename: 'AnalyticsSyncStateSource'
      name: string
      syncedAt?: any | null
    }>
  }
}

export type GetClientTrendsSummaryQueryVariables = Exact<{
  input: ClientTrendBaseInput
}>

export type GetClientTrendsSummaryQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsSummary: {
    __typename: 'ClientTrendsSummary'
    rollingMrrChange: {
      __typename: 'RollingMrrChange'
      value: number
      change: number
      period: string
    }
  }
}

export type GetClientTrendsRankingsQueryVariables = Exact<{
  input: ClientTrendBaseInput
}>

export type GetClientTrendsRankingsQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsRankings: {
    __typename: 'ClientTrendsRankings'
    mostProfitable: Array<{
      __typename: 'ClientRanking'
      clientId: string
      clientName: string
      margin: number
    }>
    leastProfitable: Array<{
      __typename: 'ClientRanking'
      clientId: string
      clientName: string
      margin: number
    }>
  }
}

export type GetClientTrendsTrendDataQueryVariables = Exact<{
  input: ClientTrendBaseInput
}>

export type GetClientTrendsTrendDataQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsTrendData: {
    __typename: 'ClientTrendLine'
    labels: Array<string>
    mrr: Array<number>
    serviceCog: Array<number>
    laborCog: Array<number>
    profit: Array<number>
    margin: Array<number>
  }
}

export type GetClientTrendsBreakdownQueryVariables = Exact<{
  input: GetClientTrendsBreakdownInput
}>

export type GetClientTrendsBreakdownQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsBreakdown: {
    __typename: 'ClientTrendsBreakdownResult'
    breakdown: Array<{
      __typename: 'ClientTrendsBreakdownItem'
      month: string
      percentOfTotalMrr: number
      mrr: number
      serviceCogs: number
      laborCogs: number
      profit: number
      margin: number
    }>
  }
}

export type GetAnalyticsClientByIdQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type GetAnalyticsClientByIdQuery = {
  __typename: 'Query'
  PartnerGetAnalyticsClientById?: {
    __typename: 'AnalyticsClientInfo'
    id: string
    companyName: string
  } | null
}

export type GetClientTrendsClientsQueryVariables = Exact<{
  input: GetClientTrendsClientsInput
}>

export type GetClientTrendsClientsQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsClients: {
    __typename: 'ClientTrendsClients'
    total: number
    selectedMonth: string
    aggregationMode: ClientTrendsAggregationMode
    monthCount: number
    items: Array<{
      __typename: 'ClientTrendsClientItem'
      clientId: string
      clientName: string
      mrr: number
      serviceCogs: number
      laborCogs: number
      profit: number
      margin: number
      percentOfTotalMrr: number
      mrrChange: number
      mrrChangePercent: number
      mrrChangeType: MrrChangeType
      laborCostImpact: LaborCostImpact
      avgMrr: number
      totalMrr: number
      avgProfit: number
      totalProfit: number
      mrrChangeFirstToLast: number
      mrrChangeFirstToLastPercent: number
    }>
  }
}

export type GetClientTrendsFilterValuesQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  filterType: ClientTrendsFilterType
  search?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}>

export type GetClientTrendsFilterValuesQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsFilterValues: {
    __typename: 'ClientTrendsFilterValuesResult'
    values: Array<string>
    total: number
  }
}

export type ClientTrendsPresetFieldsFragment = {
  __typename: 'ClientTrendsPreset'
  id: string
  partnerId: string
  userId?: string | null
  name: string
  createdAt: string
  updatedAt: string
  filters: {
    __typename: 'ClientTrendsFilters'
    laborCostImpact?: Array<LaborCostImpact> | null
    mrrChangeType?: Array<MrrChangeType> | null
    agreementType?: {
      __typename: 'ClientTrendsFilterValues'
      include: Array<string>
      exclude: Array<string>
    } | null
    clientName?: {
      __typename: 'ClientTrendsFilterValues'
      include: Array<string>
      exclude: Array<string>
    } | null
    mrrRange?: {
      __typename: 'ClientTrendsRange'
      min?: number | null
      max?: number | null
    } | null
    marginRange?: {
      __typename: 'ClientTrendsRange'
      min?: number | null
      max?: number | null
    } | null
    mrrChangeRange?: {
      __typename: 'ClientTrendsRange'
      min?: number | null
      max?: number | null
    } | null
  }
}

export type PartnerListClientTrendsPresetsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListClientTrendsPresetsQuery = {
  __typename: 'Query'
  PartnerListClientTrendsPresets: Array<{
    __typename: 'ClientTrendsPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'ClientTrendsFilters'
      laborCostImpact?: Array<LaborCostImpact> | null
      mrrChangeType?: Array<MrrChangeType> | null
      agreementType?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      clientName?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      mrrRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      marginRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      mrrChangeRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
    }
  }>
}

export type PartnerGetClientTrendsPresetQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetClientTrendsPresetQuery = {
  __typename: 'Query'
  PartnerGetClientTrendsPreset: {
    __typename: 'ClientTrendsPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'ClientTrendsFilters'
      laborCostImpact?: Array<LaborCostImpact> | null
      mrrChangeType?: Array<MrrChangeType> | null
      agreementType?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      clientName?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      mrrRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      marginRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      mrrChangeRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
    }
  }
}

export type PartnerCreateClientTrendsPresetMutationVariables = Exact<{
  input: CreateClientTrendsPresetInput
}>

export type PartnerCreateClientTrendsPresetMutation = {
  __typename: 'Mutation'
  PartnerCreateClientTrendsPreset: {
    __typename: 'ClientTrendsPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'ClientTrendsFilters'
      laborCostImpact?: Array<LaborCostImpact> | null
      mrrChangeType?: Array<MrrChangeType> | null
      agreementType?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      clientName?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      mrrRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      marginRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      mrrChangeRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
    }
  }
}

export type PartnerUpdateClientTrendsPresetMutationVariables = Exact<{
  input: UpdateClientTrendsPresetInput
}>

export type PartnerUpdateClientTrendsPresetMutation = {
  __typename: 'Mutation'
  PartnerUpdateClientTrendsPreset: {
    __typename: 'ClientTrendsPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'ClientTrendsFilters'
      laborCostImpact?: Array<LaborCostImpact> | null
      mrrChangeType?: Array<MrrChangeType> | null
      agreementType?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      clientName?: {
        __typename: 'ClientTrendsFilterValues'
        include: Array<string>
        exclude: Array<string>
      } | null
      mrrRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      marginRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
      mrrChangeRange?: {
        __typename: 'ClientTrendsRange'
        min?: number | null
        max?: number | null
      } | null
    }
  }
}

export type PartnerDeleteClientTrendsPresetMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteClientTrendsPresetMutation = {
  __typename: 'Mutation'
  PartnerDeleteClientTrendsPreset: boolean
}

export type ExportClientTrendsCsvMutationVariables = Exact<{
  input: ExportClientTrendsCsvInput
}>

export type ExportClientTrendsCsvMutation = {
  __typename: 'Mutation'
  PartnerExportClientTrendsCSV: boolean
}

export type ExportClientTrendsBreakdownCsvMutationVariables = Exact<{
  input: ExportClientTrendsBreakdownCsvInput
}>

export type ExportClientTrendsBreakdownCsvMutation = {
  __typename: 'Mutation'
  PartnerExportClientTrendsBreakdownCSV: boolean
}

export type PartnerGetAgentLoadsQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
}>

export type PartnerGetAgentLoadsQuery = {
  __typename: 'Query'
  PartnerGetAgentLoads: Array<{
    __typename: 'AgentUtilizationResult'
    overloadedAgents: Array<{
      __typename: 'AgentHoursSummary'
      agentId: string
      totalHours: number
      availableHours: number
      difference: number
    }>
    underusedAgents: Array<{
      __typename: 'AgentHoursSummary'
      agentId: string
      totalHours: number
      availableHours: number
      difference: number
    }>
  }>
}

export type PartnerGetUtilizationFilterValuesQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  filterType: UtilizationFilterType
  search?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}>

export type PartnerGetUtilizationFilterValuesQuery = {
  __typename: 'Query'
  PartnerGetUtilizationFilterValues: {
    __typename: 'UtilizationFilterValuesResult'
    values: Array<string>
    total: number
  }
}

export type PartnerGetUtilizationPercentageQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
}>

export type PartnerGetUtilizationPercentageQuery = {
  __typename: 'Query'
  PartnerGetUtilizationPercentage: number
}

export type PartnerGetUtilizationOverviewQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  grouping: Scalars['String']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
  sortBy?: InputMaybe<UtilizationOverviewSortBy>
  sortOrder?: InputMaybe<OrderDirection>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerGetUtilizationOverviewQuery = {
  __typename: 'Query'
  PartnerGetUtilizationOverview: {
    __typename: 'UtilizationOverviewResult'
    total: number
    items: Array<{
      __typename: 'UtilizationOverviewItem'
      agentId?: string | null
      clientId?: string | null
      displayName: string
      labourCost: number
      hoursWorked: number
      hoursAvailable: number
      utilizationPercent?: number | null
      utilizationComparison?: number | null
    }>
  }
}

export type PartnerGetUtilizationSummaryQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  agentId?: InputMaybe<Scalars['ID']['input']>
  clientId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<UtilizationFiltersInput>
}>

export type PartnerGetUtilizationSummaryQuery = {
  __typename: 'Query'
  PartnerGetUtilizationSummary: Array<{
    __typename: 'UtilizationSummaryItem'
    date: string
    labourCost: number
    hoursWorked: number
    hoursAvailable: number
  }>
}

export type PartnerGetUtilizationSeriesQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  granularity?: InputMaybe<UtilizationGranularity>
  filters?: InputMaybe<UtilizationFiltersInput>
}>

export type PartnerGetUtilizationSeriesQuery = {
  __typename: 'Query'
  PartnerGetUtilizationSeries: {
    __typename: 'UtilizationSeriesResult'
    granularity: UtilizationGranularity
    series: Array<{
      __typename: 'UtilizationSeriesPoint'
      date: string
      labourCost: number
      hoursWorked: number
    }>
  }
}

export type PartnerGetUtilizationBreakdownQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
}>

export type PartnerGetUtilizationBreakdownQuery = {
  __typename: 'Query'
  PartnerGetUtilizationBreakdown: Array<{
    __typename: 'UtilizationBreakdownItem'
    clientName: string
    agentName: string
    ticketId?: string | null
    ticketType?: string | null
    dateWorked: string
    hoursWorked: number
    labourCost: number
  }>
}

export type PartnerGetUtilizationKpIsQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  agentId: Scalars['ID']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
}>

export type PartnerGetUtilizationKpIsQuery = {
  __typename: 'Query'
  PartnerGetUtilizationKPIs: {
    __typename: 'UtilizationKPIResult'
    utilizationPercent: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
    hoursWorked: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
    hoursAvailable: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
    agentCost: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
  }
}

export type PartnerGetClientKpIsQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  clientId: Scalars['ID']['input']
  filters?: InputMaybe<UtilizationFiltersInput>
}>

export type PartnerGetClientKpIsQuery = {
  __typename: 'Query'
  PartnerGetClientKPIs: {
    __typename: 'UtilizationKPIResult'
    utilizationPercent: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
    hoursWorked: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
    hoursAvailable: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
    agentCost: {
      __typename: 'UtilizationKPIMetric'
      value: number
      comparison: number
    }
  }
}

export type PartnerListUtilizationPresetsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListUtilizationPresetsQuery = {
  __typename: 'Query'
  PartnerListUtilizationPresets: Array<{
    __typename: 'UtilizationPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'UtilizationPresetFilters'
      dateFrom?: string | null
      dateTo?: string | null
      clients?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agents?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agentTitles?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agreements?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      ticketType?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      categories?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
    }
  }>
}

export type PartnerGetUtilizationPresetQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetUtilizationPresetQuery = {
  __typename: 'Query'
  PartnerGetUtilizationPreset: {
    __typename: 'UtilizationPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'UtilizationPresetFilters'
      dateFrom?: string | null
      dateTo?: string | null
      clients?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agents?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agentTitles?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agreements?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      ticketType?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      categories?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
    }
  }
}

export type PartnerCreateUtilizationPresetMutationVariables = Exact<{
  input: CreateUtilizationPresetInput
}>

export type PartnerCreateUtilizationPresetMutation = {
  __typename: 'Mutation'
  PartnerCreateUtilizationPreset: {
    __typename: 'UtilizationPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'UtilizationPresetFilters'
      dateFrom?: string | null
      dateTo?: string | null
      clients?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agents?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agentTitles?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agreements?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      ticketType?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      categories?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
    }
  }
}

export type PartnerUpdateUtilizationPresetMutationVariables = Exact<{
  input: UpdateUtilizationPresetInput
}>

export type PartnerUpdateUtilizationPresetMutation = {
  __typename: 'Mutation'
  PartnerUpdateUtilizationPreset: {
    __typename: 'UtilizationPreset'
    id: string
    partnerId: string
    userId?: string | null
    name: string
    createdAt: string
    updatedAt: string
    filters: {
      __typename: 'UtilizationPresetFilters'
      dateFrom?: string | null
      dateTo?: string | null
      clients?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agents?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agentTitles?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      agreements?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      ticketType?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
      categories?: {
        __typename: 'UtilizationPresetFilterValues'
        include?: Array<string> | null
        exclude?: Array<string> | null
      } | null
    }
  }
}

export type PartnerDeleteUtilizationPresetMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteUtilizationPresetMutation = {
  __typename: 'Mutation'
  PartnerDeleteUtilizationPreset: boolean
}

export type ExportUtilizationCsvMutationVariables = Exact<{
  input: ExportUtilizationCsvInput
}>

export type ExportUtilizationCsvMutation = {
  __typename: 'Mutation'
  PartnerExportUtilizationCSV: boolean
}

export type ExportUtilizationBreakdownCsvMutationVariables = Exact<{
  input: ExportUtilizationBreakdownCsvInput
}>

export type ExportUtilizationBreakdownCsvMutation = {
  __typename: 'Mutation'
  PartnerExportUtilizationBreakdownCSV: boolean
}

export type GetClientTicketCountsQueryVariables = Exact<{
  input: ClientTicketCountsInput
}>

export type GetClientTicketCountsQuery = {
  __typename: 'Query'
  PartnerGetClientTicketCounts: Array<{
    __typename: 'ClientTicketCountItem'
    clientId: string
    clientName: string
    ticketCount: number
    hoursWorked: number
    cost: number
  }>
}

export type GetAgentTicketCountsQueryVariables = Exact<{
  input: AgentTicketCountsInput
}>

export type GetAgentTicketCountsQuery = {
  __typename: 'Query'
  PartnerGetAgentTicketCounts: Array<{
    __typename: 'AgentTicketCountItem'
    agentId: string
    agentName: string
    ticketCount: number
    hoursWorked: number
    cost: number
  }>
}

export type GetTicketListQueryVariables = Exact<{
  input: TicketListInput
}>

export type GetTicketListQuery = {
  __typename: 'Query'
  PartnerGetTicketList: {
    __typename: 'TicketListResult'
    total: number
    totalHoursWorked: number
    totalCost: number
    categories: Array<string>
    items: Array<{
      __typename: 'TicketListItem'
      ticketId: string
      displayId: string
      category?: string | null
      date: string
      hoursWorked: number
      cost: number
      ticketUrl: string
    }>
  }
}

export type PartnerCreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput
}>

export type PartnerCreateApiKeyMutation = {
  __typename: 'Mutation'
  PartnerCreateApiKey?: {
    __typename: 'CreateApiKeyResponse'
    key: string
  } | null
}

export type PartnerUpdateApiKeyMutationVariables = Exact<{
  input: UpdateApiKeyInput
}>

export type PartnerUpdateApiKeyMutation = {
  __typename: 'Mutation'
  PartnerUpdateApiKey: string
}

export type PartnerRevokeApiKeyMutationVariables = Exact<{
  keyID: Scalars['String']['input']
}>

export type PartnerRevokeApiKeyMutation = {
  __typename: 'Mutation'
  PartnerRevokeApiKey: string
}

export type PartnerScopeCatalogQueryVariables = Exact<{ [key: string]: never }>

export type PartnerScopeCatalogQuery = {
  __typename: 'Query'
  PartnerScopeCatalog: Array<{
    __typename: 'Scope'
    value: string
    group: string
    label: string
    description: string
  }>
}

export type PartnerApiKeyConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<ApiKeyFilter>
  orderBy?: InputMaybe<ApiKeyOrderBy>
}>

export type PartnerApiKeyConnectionQuery = {
  __typename: 'Query'
  PartnerApiKeyConnection?: {
    __typename: 'ApiKeyConnection'
    edges?: Array<{
      __typename: 'ApiKeyEdge'
      cursor: any
      node?: {
        __typename: 'ApiKey'
        id: string
        clientID: string
        lastDigits: string
        keyName: string
        createdAt: string
        status: ApiKeyStatus
        revokedAt?: string | null
        scopes?: Array<string> | null
        createdBy?: {
          __typename: 'PartnerUser'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
        revokedBy?: {
          __typename: 'PartnerUser'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type ApiKeyFragment = {
  __typename: 'ApiKey'
  id: string
  clientID: string
  lastDigits: string
  keyName: string
  createdAt: string
  status: ApiKeyStatus
  revokedAt?: string | null
  scopes?: Array<string> | null
  createdBy?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
  } | null
  revokedBy?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type HomeDeltaFieldsFragment = {
  __typename: 'HomeDelta'
  value: number
  prior: number
  deltaAbs: number
  deltaPct?: number | null
  direction: HomeDeltaDirection
  isImprovement: boolean
}

export type HomeCashFlowFieldsFragment = {
  __typename: 'HomeCashFlow'
  direction: HomeCashFlowDirection
  currencies: Array<{
    __typename: 'HomeCashFlowCurrency'
    currency: string
    total: number
    deltaAbs: number
    deltaPct?: number | null
    topSources: Array<{
      __typename: 'HomeCashFlowTopSource'
      customerId: string
      customerName: string
      invoiceCount: number
      paymentMode: HomePaymentMode
      amountCents: number
      sourceType: HomeCashFlowSourceType
    }>
  }>
}

export type HomeAttentionCustomerFieldsFragment = {
  __typename: 'HomeCustomerNeedingAttention'
  customerId: string
  customerName: string
  currency: string
  balanceCents: number
  invoicesOutstanding: number
  overdueCount: number
  maxDaysOverdue: number
  lastReminderDaysAgo?: number | null
  autopay: boolean
}

export type PartnerArHomeQueryVariables = Exact<{
  expectedStart: Scalars['String']['input']
  expectedEnd: Scalars['String']['input']
}>

export type PartnerArHomeQuery = {
  __typename: 'Query'
  PartnerHomeOutstandingAR: {
    __typename: 'HomeOutstandingAR'
    currencies: Array<{
      __typename: 'HomeOutstandingARCurrency'
      currency: string
      total: number
      aging: {
        __typename: 'HomeOutstandingARAging'
        bucket0To30: {
          __typename: 'HomeAgingBucket'
          amountCents: number
          count: number
        }
        bucket31To60: {
          __typename: 'HomeAgingBucket'
          amountCents: number
          count: number
        }
        bucket61To90: {
          __typename: 'HomeAgingBucket'
          amountCents: number
          count: number
        }
        bucket90Plus: {
          __typename: 'HomeAgingBucket'
          amountCents: number
          count: number
        }
      }
    }>
  }
  PartnerHomePerformance: {
    __typename: 'HomePerformance'
    currencies: Array<{
      __typename: 'HomePerformanceCurrency'
      currency: string
      collected: {
        __typename: 'HomeDelta'
        value: number
        prior: number
        deltaAbs: number
        deltaPct?: number | null
        direction: HomeDeltaDirection
        isImprovement: boolean
      }
      dso: { __typename: 'HomeMetric'; value: number }
      mrr: { __typename: 'HomeMetric'; value: number }
      mrrAutopay: { __typename: 'HomeMetric'; value: number }
    }>
  }
  PartnerHomeInvoicePipeline: {
    __typename: 'HomeInvoicePipeline'
    currencies: Array<{
      __typename: 'HomeInvoicePipelineCurrency'
      currency: string
      overdue: {
        __typename: 'HomePipelineBucket'
        count: number
        amountCents: number
      }
      open: {
        __typename: 'HomePipelineBucket'
        count: number
        amountCents: number
      }
      paid30d: {
        __typename: 'HomePipelineBucket'
        count: number
        amountCents: number
      }
    }>
  }
  cashFlowReceived: {
    __typename: 'HomeCashFlow'
    direction: HomeCashFlowDirection
    currencies: Array<{
      __typename: 'HomeCashFlowCurrency'
      currency: string
      total: number
      deltaAbs: number
      deltaPct?: number | null
      topSources: Array<{
        __typename: 'HomeCashFlowTopSource'
        customerId: string
        customerName: string
        invoiceCount: number
        paymentMode: HomePaymentMode
        amountCents: number
        sourceType: HomeCashFlowSourceType
      }>
    }>
  }
  cashFlowExpected: {
    __typename: 'HomeCashFlow'
    direction: HomeCashFlowDirection
    currencies: Array<{
      __typename: 'HomeCashFlowCurrency'
      currency: string
      total: number
      deltaAbs: number
      deltaPct?: number | null
      topSources: Array<{
        __typename: 'HomeCashFlowTopSource'
        customerId: string
        customerName: string
        invoiceCount: number
        paymentMode: HomePaymentMode
        amountCents: number
        sourceType: HomeCashFlowSourceType
      }>
    }>
  }
  PartnerHomeAutopayCoverage: {
    __typename: 'HomeAutopayCoverage'
    coveragePct: number
    enrolledCount: number
    notEnrolledCount: number
    totalCustomers: number
  }
  PartnerHomeTopCustomersOwed: {
    __typename: 'HomeTopCustomersOwed'
    currencies: Array<{
      __typename: 'HomeTopCustomersOwedCurrency'
      currency: string
      customers: Array<{
        __typename: 'HomeTopCustomerOwed'
        customerId: string
        customerName: string
        balanceCents: number
        invoiceCount: number
        overdueCount: number
        maxDaysOverdue?: number | null
        autopay: boolean
        invoiceCounts: {
          __typename: 'HomeInvoiceStatusCounts'
          upcoming: number
          overdue: number
          received: number
          paid: number
          archived: number
          total: number
        }
      }>
    }>
  }
  PartnerHomeTopCustomersPaid: {
    __typename: 'HomeTopCustomersPaid'
    currencies: Array<{
      __typename: 'HomeTopCustomersPaidCurrency'
      currency: string
      customers: Array<{
        __typename: 'HomeTopCustomerPaid'
        customerId: string
        customerName: string
        paidCents: number
        paymentCount: number
      }>
    }>
  }
  PartnerHomePaymentMethodIssues: {
    __typename: 'HomePaymentMethodIssues'
    noMethodOnFile: number
    noDefaultSet: number
  }
  PartnerHomeCustomersNeedingAttention: {
    __typename: 'HomeCustomersNeedingAttention'
    page: number
    pageSize: number
    total: number
    items: Array<{
      __typename: 'HomeCustomerNeedingAttention'
      customerId: string
      customerName: string
      currency: string
      balanceCents: number
      invoicesOutstanding: number
      overdueCount: number
      maxDaysOverdue: number
      lastReminderDaysAgo?: number | null
      autopay: boolean
    }>
  }
}

export type PartnerHomePerformanceCardQueryVariables = Exact<{
  range?: InputMaybe<HomeRange>
  start?: InputMaybe<Scalars['String']['input']>
  end?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerHomePerformanceCardQuery = {
  __typename: 'Query'
  PartnerHomePerformance: {
    __typename: 'HomePerformance'
    currencies: Array<{
      __typename: 'HomePerformanceCurrency'
      currency: string
      collected: {
        __typename: 'HomeDelta'
        value: number
        prior: number
        deltaAbs: number
        deltaPct?: number | null
        direction: HomeDeltaDirection
        isImprovement: boolean
      }
      dso: { __typename: 'HomeMetric'; value: number }
      mrr: { __typename: 'HomeMetric'; value: number }
      mrrAutopay: { __typename: 'HomeMetric'; value: number }
    }>
  }
}

export type PartnerHomeCashFlowCardQueryVariables = Exact<{
  range?: InputMaybe<HomeRange>
  start?: InputMaybe<Scalars['String']['input']>
  end?: InputMaybe<Scalars['String']['input']>
  expectedStart: Scalars['String']['input']
  expectedEnd: Scalars['String']['input']
}>

export type PartnerHomeCashFlowCardQuery = {
  __typename: 'Query'
  cashFlowReceived: {
    __typename: 'HomeCashFlow'
    direction: HomeCashFlowDirection
    currencies: Array<{
      __typename: 'HomeCashFlowCurrency'
      currency: string
      total: number
      deltaAbs: number
      deltaPct?: number | null
      topSources: Array<{
        __typename: 'HomeCashFlowTopSource'
        customerId: string
        customerName: string
        invoiceCount: number
        paymentMode: HomePaymentMode
        amountCents: number
        sourceType: HomeCashFlowSourceType
      }>
    }>
  }
  cashFlowExpected: {
    __typename: 'HomeCashFlow'
    direction: HomeCashFlowDirection
    currencies: Array<{
      __typename: 'HomeCashFlowCurrency'
      currency: string
      total: number
      deltaAbs: number
      deltaPct?: number | null
      topSources: Array<{
        __typename: 'HomeCashFlowTopSource'
        customerId: string
        customerName: string
        invoiceCount: number
        paymentMode: HomePaymentMode
        amountCents: number
        sourceType: HomeCashFlowSourceType
      }>
    }>
  }
}

export type PartnerHomeCustomersNeedingAttentionPageQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}>

export type PartnerHomeCustomersNeedingAttentionPageQuery = {
  __typename: 'Query'
  PartnerHomeCustomersNeedingAttention: {
    __typename: 'HomeCustomersNeedingAttention'
    page: number
    pageSize: number
    total: number
    items: Array<{
      __typename: 'HomeCustomerNeedingAttention'
      customerId: string
      customerName: string
      currency: string
      balanceCents: number
      invoicesOutstanding: number
      overdueCount: number
      maxDaysOverdue: number
      lastReminderDaysAgo?: number | null
      autopay: boolean
    }>
  }
}

export type ListAssistantConversationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}>

export type ListAssistantConversationsQuery = {
  __typename: 'Query'
  PartnerListAssistantConversations: {
    __typename: 'AssistantConversationList'
    total: number
    page: number
    perPage: number
    conversations: Array<{
      __typename: 'AssistantConversation'
      id: string
      partnerID: string
      userID: string
      title: string
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetAssistantConversationQueryVariables = Exact<{
  conversationID: Scalars['ID']['input']
  messageLimit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetAssistantConversationQuery = {
  __typename: 'Query'
  PartnerGetAssistantConversation: {
    __typename: 'AssistantConversationDetail'
    hasMoreMessages: boolean
    conversation: {
      __typename: 'AssistantConversation'
      id: string
      partnerID: string
      userID: string
      title: string
      createdAt: string
      updatedAt: string
    }
    messages: Array<{
      __typename: 'AssistantMessage'
      id: string
      conversationID: string
      role: string
      content: string
      isPartial: boolean
      createdAt: string
      events?: Array<{
        __typename: 'AssistantMessageEventRecord'
        seq: number
        kind: string
        payload: string
      }> | null
    }>
  }
}

export type CreateAssistantConversationMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>
}>

export type CreateAssistantConversationMutation = {
  __typename: 'Mutation'
  PartnerCreateAssistantConversation: {
    __typename: 'AssistantConversation'
    id: string
    partnerID: string
    userID: string
    title: string
    createdAt: string
    updatedAt: string
  }
}

export type DeleteAssistantConversationMutationVariables = Exact<{
  conversationID: Scalars['ID']['input']
}>

export type DeleteAssistantConversationMutation = {
  __typename: 'Mutation'
  PartnerDeleteAssistantConversation: boolean
}

export type ConfirmAssistantActionMutationVariables = Exact<{
  token: Scalars['String']['input']
  confirmed: Scalars['Boolean']['input']
}>

export type ConfirmAssistantActionMutation = {
  __typename: 'Mutation'
  PartnerConfirmAssistantAction: boolean
}

export type SendAssistantMessageSubscriptionVariables = Exact<{
  conversationID: Scalars['ID']['input']
  content: Scalars['String']['input']
}>

export type SendAssistantMessageSubscription = {
  __typename: 'Subscription'
  PartnerSendAssistantMessage:
    | {
        __typename: 'AssistantConfirmationOutcomeEvent'
        token: string
        toolName: string
        outcome: string
      }
    | {
        __typename: 'AssistantConfirmationRequiredEvent'
        token: string
        toolName: string
        toolInput: string
        summary: string
        description: string
      }
    | { __typename: 'AssistantDoneEvent'; messageID: string }
    | { __typename: 'AssistantStatusEvent'; text: string }
    | { __typename: 'AssistantTokenEvent'; text: string }
    | {
        __typename: 'AssistantToolErrorEvent'
        toolName: string
        message: string
      }
    | {
        __typename: 'AssistantToolResultEvent'
        toolName: string
        status: string
      }
}

export type ListAssistantV2ConversationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  includeV1?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListAssistantV2ConversationsQuery = {
  __typename: 'Query'
  PartnerListAssistantV2Conversations: {
    __typename: 'AssistantV2ConversationList'
    total: number
    page: number
    perPage: number
    conversations: Array<{
      __typename: 'AssistantV2Conversation'
      id: string
      partnerID: string
      userID: string
      title: string
      version: string
      anthropicSessionID?: string | null
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetAssistantV2ConversationQueryVariables = Exact<{
  conversationID: Scalars['ID']['input']
}>

export type GetAssistantV2ConversationQuery = {
  __typename: 'Query'
  PartnerGetAssistantV2Conversation: {
    __typename: 'AssistantV2Conversation'
    id: string
    partnerID: string
    userID: string
    title: string
    version: string
    anthropicSessionID?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type GetAssistantV2ConversationHistoryQueryVariables = Exact<{
  conversationID: Scalars['ID']['input']
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetAssistantV2ConversationHistoryQuery = {
  __typename: 'Query'
  PartnerGetAssistantV2ConversationHistory: {
    __typename: 'AssistantV2ConversationHistory'
    hasMore: boolean
    nextCursor?: string | null
    events: Array<{
      __typename: 'AssistantV2HistoryEvent'
      id: string
      eventType: string
      data: string
      processedAt: string
    }>
  }
}

export type GetAssistantV2TurnStatusQueryVariables = Exact<{
  conversationID: Scalars['ID']['input']
}>

export type GetAssistantV2TurnStatusQuery = {
  __typename: 'Query'
  PartnerGetAssistantV2TurnStatus: {
    __typename: 'AssistantV2TurnStatus'
    status: string
    acquiredAt?: string | null
    heartbeatAt?: string | null
  }
}

export type CreateAssistantV2ConversationMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>
}>

export type CreateAssistantV2ConversationMutation = {
  __typename: 'Mutation'
  PartnerCreateAssistantV2Conversation: {
    __typename: 'AssistantV2Conversation'
    id: string
    partnerID: string
    userID: string
    title: string
    version: string
    anthropicSessionID?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type DeleteAssistantV2ConversationMutationVariables = Exact<{
  conversationID: Scalars['ID']['input']
}>

export type DeleteAssistantV2ConversationMutation = {
  __typename: 'Mutation'
  PartnerDeleteAssistantV2Conversation: boolean
}

export type RenameAssistantV2ConversationMutationVariables = Exact<{
  conversationID: Scalars['ID']['input']
  title: Scalars['String']['input']
}>

export type RenameAssistantV2ConversationMutation = {
  __typename: 'Mutation'
  PartnerRenameAssistantV2Conversation: {
    __typename: 'AssistantV2Conversation'
    id: string
    title: string
    updatedAt: string
  }
}

export type ConfirmAssistantV2ActionMutationVariables = Exact<{
  token: Scalars['String']['input']
  confirmed: Scalars['Boolean']['input']
}>

export type ConfirmAssistantV2ActionMutation = {
  __typename: 'Mutation'
  PartnerConfirmAssistantV2Action: boolean
}

export type GetAssistantV2FileDownloadUrlQueryVariables = Exact<{
  conversationID: Scalars['ID']['input']
  fileID?: InputMaybe<Scalars['String']['input']>
  path?: InputMaybe<Scalars['String']['input']>
}>

export type GetAssistantV2FileDownloadUrlQuery = {
  __typename: 'Query'
  PartnerAssistantV2FileDownloadURL: string
}

export type UploadAssistantV2FileMutationVariables = Exact<{
  conversationID: Scalars['ID']['input']
  file: Scalars['Upload']['input']
}>

export type UploadAssistantV2FileMutation = {
  __typename: 'Mutation'
  PartnerUploadAssistantV2File: {
    __typename: 'AssistantV2File'
    id: string
    filename: string
    path?: string | null
    contentType: string
    sizeBytes: number
    createdAt: string
  }
}

export type AssistantPageSuggestionCustomerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>
}>

export type AssistantPageSuggestionCustomerQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: { __typename: 'Customer'; id: string; name?: string | null } | null
    } | null> | null
  } | null
}

export type AssistantPageSuggestionInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type AssistantPageSuggestionInvoiceQuery = {
  __typename: 'Query'
  FindInvoice?: {
    __typename: 'Invoice'
    id: string
    invoiceNumber: string
    amount: number
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type SendAssistantV2MessageSubscriptionVariables = Exact<{
  conversationID: Scalars['ID']['input']
  content: Scalars['String']['input']
  entityReferences?: InputMaybe<
    Array<AssistantEntityReferenceInput> | AssistantEntityReferenceInput
  >
  invokeAgents?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >
}>

export type SendAssistantV2MessageSubscription = {
  __typename: 'Subscription'
  PartnerSendAssistantV2Message:
    | {
        __typename: 'AssistantConfirmationOutcomeEvent'
        token: string
        toolName: string
        outcome: string
      }
    | {
        __typename: 'AssistantConfirmationRequiredEvent'
        token: string
        toolName: string
        toolInput: string
        summary: string
        description: string
      }
    | { __typename: 'AssistantV2RawEvent'; eventType: string; data: string }
}

export type ReattachAssistantV2MessageSubscriptionVariables = Exact<{
  conversationID: Scalars['ID']['input']
  since?: InputMaybe<Scalars['String']['input']>
}>

export type ReattachAssistantV2MessageSubscription = {
  __typename: 'Subscription'
  PartnerReattachAssistantV2Message:
    | {
        __typename: 'AssistantConfirmationOutcomeEvent'
        token: string
        toolName: string
        outcome: string
      }
    | {
        __typename: 'AssistantConfirmationRequiredEvent'
        token: string
        toolName: string
        toolInput: string
        summary: string
        description: string
      }
    | { __typename: 'AssistantV2RawEvent'; eventType: string; data: string }
}

export type OAuth2UrlQueryVariables = Exact<{
  referralID?: InputMaybe<Scalars['ID']['input']>
  redirectUri?: InputMaybe<Scalars['String']['input']>
}>

export type OAuth2UrlQuery = { __typename: 'Query'; OAuth2Url: string }

export type OAuth2ExchangeMutationVariables = Exact<{
  code: Scalars['String']['input']
  state: Scalars['String']['input']
  redirectUri?: InputMaybe<Scalars['String']['input']>
}>

export type OAuth2ExchangeMutation = {
  __typename: 'Mutation'
  OAuth2Exchange: {
    __typename: 'TokenExchange'
    access_token: string
    refresh_token: string
    expiry: string
    id_token: string
  }
}

export type OAuth2RefreshMutationVariables = Exact<{
  refreshToken: Scalars['String']['input']
}>

export type OAuth2RefreshMutation = {
  __typename: 'Mutation'
  OAuth2Refresh: {
    __typename: 'TokenExchange'
    access_token: string
    refresh_token: string
    expiry: string
    id_token: string
  }
}

export type TokenFragment = {
  __typename: 'TokenExchange'
  access_token: string
  refresh_token: string
  expiry: string
  id_token: string
}

export type PartnerListAutopayExcludedInvoicesQueryVariables = Exact<{
  invoiceIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerListAutopayExcludedInvoicesQuery = {
  __typename: 'Query'
  PartnerListAutopayExcludedInvoices: Array<{
    __typename: 'AutopayExcludedInvoice'
    invoiceID: string
    excludedBy: ExcludedFromAutopayBy
  }>
}

export type FindAutopayRuleQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FindAutopayRuleQuery = {
  __typename: 'Query'
  FindAutopayRule?: {
    __typename: 'AutopayRule'
    tagIDs?: Array<string | null> | null
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    specificDay?: number | null
    lastDayOfMonth?: boolean | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    version: number
    halopsaRecurringInvoices?: boolean | null
    connectWiseContractNames?: Array<string> | null
    autotaskContractNames?: Array<string> | null
    haloPSAContractNames?: Array<string> | null
    createdByCustomer: boolean
    createdAt: string
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      tagIDs?: Array<string> | null
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      outstandingInvoicesData?: {
        __typename: 'CustomerOutstandingInvoicesData'
        outstandingInvoicesCount?: number | null
        outstandingInvoicesTotal?: number | null
        longestDaysOverdue?: string | null
      } | null
      defaultPaymentMethod?: {
        __typename: 'CustomerDefaultPaymentMethod'
        methodID: string
        method: TransferPaymentMethodInputEnum
        institution?: {
          __typename: 'Institution'
          id: string
          externalId?: string | null
          name?: string | null
          url?: string | null
          logo?: string | null
          accounts?: Array<{
            __typename: 'Account'
            id: string
            mask?: string | null
            name?: string | null
            type?: string | null
            subtype?: string | null
            hasAchAccountNumber?: boolean | null
            hasAchRoutingNumber?: boolean | null
            hasWireRoutingNumber?: boolean | null
            transitNumber?: string | null
            customName?: string | null
            provider?: string | null
            disconnectedAt?: string | null
            systemDeactivatedAt?: string | null
            companyName?: string | null
            institution?: {
              __typename: 'Institution'
              name?: string | null
              id: string
              logo?: string | null
            } | null
            mandates?: Array<{
              __typename: 'Mandate'
              id: string
              consentAt: string
              version: string
            } | null> | null
          } | null> | null
        } | null
        card?: {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
          fundingSource: FundingSource
          customName?: string | null
          hasPostalCode: boolean
          isExpired: boolean
          billingAddress?: {
            __typename: 'Address'
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            state?: string | null
            stateCode?: string | null
            postalCode?: string | null
            country?: string | null
            countryISO?: string | null
          } | null
        } | null
      } | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    } | null> | null
    customMethods?: Array<{
      __typename: 'AutopayCustomMethod'
      customerID: string
      methodID: string
      method: TransferPaymentMethodInputEnum
    } | null> | null
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseBillingTerms?: Array<{
      __typename: 'ConnectwiseBillingTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterQbdPaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterNetsuitePaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
  } | null
}

export type PartnerAutopayExcludedInvoiceDeleteMutationVariables = Exact<{
  invoiceID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedInvoiceDeleteMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedInvoiceDelete?: string | null
}

export type PartnerAutopayExcludedInvoiceCreateMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
  invoiceID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedInvoiceCreateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedInvoiceCreate?: string | null
}

export type PartnerAutopayExcludedInvoiceBatchCreateMutationVariables = Exact<{
  invoices:
    | Array<AutopayExcludedInvoiceCreateInput>
    | AutopayExcludedInvoiceCreateInput
}>

export type PartnerAutopayExcludedInvoiceBatchCreateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedInvoiceBatchCreate?: string | null
}

export type PartnerGetCoveredInvoicesForRuleQueryVariables = Exact<{
  input: PartnerGetCoveredInvoicesForRuleInput
}>

export type PartnerGetCoveredInvoicesForRuleQuery = {
  __typename: 'Query'
  PartnerGetCoveredInvoicesForRule: Array<{
    __typename: 'Invoice'
    id: string
    invoiceNumber: string
    createdAt: string
    dueDate?: string | null
    amount: number
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
      tagIDs?: Array<string> | null
    } | null
  }>
}

export type PartnerGlobalAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type PartnerGlobalAutopayRuleConnectionQuery = {
  __typename: 'Query'
  PartnerGlobalAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        specificDay?: number | null
        lastDayOfMonth?: boolean | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        haloPSAContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables =
  Exact<{
    after?: InputMaybe<Scalars['Cursor']['input']>
    first?: InputMaybe<Scalars['Int']['input']>
    before?: InputMaybe<Scalars['Cursor']['input']>
    last?: InputMaybe<Scalars['Int']['input']>
    filters?: InputMaybe<AutopayRuleFilter>
    orderBy?: InputMaybe<AutopayRuleOrderBy>
  }>

export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        specificDay?: number | null
        lastDayOfMonth?: boolean | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        haloPSAContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
          fallbackCharge?: boolean | null
          institution?: {
            __typename: 'Institution'
            id: string
            externalId?: string | null
            name?: string | null
            url?: string | null
            logo?: string | null
            accounts?: Array<{
              __typename: 'Account'
              id: string
              mask?: string | null
              name?: string | null
              type?: string | null
              subtype?: string | null
              hasAchAccountNumber?: boolean | null
              hasAchRoutingNumber?: boolean | null
              hasWireRoutingNumber?: boolean | null
              transitNumber?: string | null
              customName?: string | null
              provider?: string | null
              disconnectedAt?: string | null
              systemDeactivatedAt?: string | null
              companyName?: string | null
              institution?: {
                __typename: 'Institution'
                name?: string | null
                id: string
                logo?: string | null
              } | null
              mandates?: Array<{
                __typename: 'Mandate'
                id: string
                consentAt: string
                version: string
              } | null> | null
            } | null> | null
          } | null
          card?: {
            __typename: 'Card'
            id: string
            last4: string
            expirationDate: string
            cardNetWork: CardNetwork
            fundingSource: FundingSource
            customName?: string | null
            hasPostalCode: boolean
            isExpired: boolean
            billingAddress?: {
              __typename: 'Address'
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              state?: string | null
              stateCode?: string | null
              postalCode?: string | null
              country?: string | null
              countryISO?: string | null
            } | null
          } | null
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type PartnerCustomerAutopayRuleConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        specificDay?: number | null
        lastDayOfMonth?: boolean | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        haloPSAContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerTagsAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type PartnerCustomerTagsAutopayRuleConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerTagsAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        tagIDs?: Array<string | null> | null
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        specificDay?: number | null
        lastDayOfMonth?: boolean | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        haloPSAContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerListCustomerRulesTotalsQueryVariables = Exact<{
  customerID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerListCustomerRulesTotalsQuery = {
  __typename: 'Query'
  PartnerListCustomerRulesTotals?: {
    __typename: 'AutopayRuleTotals'
    count: number
  } | null
}

export type PartnerAutopayExcludedCustomerConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
  orderBy?: InputMaybe<AutopayExcludedCustomerOrderBy>
}>

export type PartnerAutopayExcludedCustomerConnectionQuery = {
  __typename: 'Query'
  PartnerAutopayExcludedCustomerConnection?: {
    __typename: 'AutopayExcludedCustomerConnection'
    edges?: Array<{
      __typename: 'AutopayExcludedCustomerEdge'
      node?: {
        __typename: 'AutopayExcludedCustomer'
        id: string
        createdByCustomer: boolean
        createdAt: string
        customer: {
          __typename: 'Customer'
          id: string
          name?: string | null
          city?: string | null
          state?: string | null
          tagIDs?: Array<string> | null
        }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerAutopayExcludedCustomerListTotalsQueryVariables = Exact<{
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
}>

export type PartnerAutopayExcludedCustomerListTotalsQuery = {
  __typename: 'Query'
  PartnerAutopayExcludedCustomerListTotals: {
    __typename: 'AutopayExcludedCustomerTotals'
    count: number
  }
}

export type PartnerCreateAutopayRuleMutationVariables = Exact<{
  input: PartnerCreateAutopayRuleInput
}>

export type PartnerCreateAutopayRuleMutation = {
  __typename: 'Mutation'
  PartnerCreateAutopayRule?: {
    __typename: 'AutopayRule'
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    specificDay?: number | null
    lastDayOfMonth?: boolean | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    version: number
    halopsaRecurringInvoices?: boolean | null
    connectWiseContractNames?: Array<string> | null
    autotaskContractNames?: Array<string> | null
    haloPSAContractNames?: Array<string> | null
    createdByCustomer: boolean
    createdAt: string
    customMethods?: Array<{
      __typename: 'AutopayCustomMethod'
      customerID: string
      methodID: string
      method: TransferPaymentMethodInputEnum
    } | null> | null
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseBillingTerms?: Array<{
      __typename: 'ConnectwiseBillingTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterQbdPaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterNetsuitePaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null> | null
  } | null
}

export type PartnerUpdateAutopayRuleMutationVariables = Exact<{
  input: PartnerUpdateAutopayRuleInput
}>

export type PartnerUpdateAutopayRuleMutation = {
  __typename: 'Mutation'
  PartnerUpdateAutopayRule?: {
    __typename: 'AutopayRule'
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    specificDay?: number | null
    lastDayOfMonth?: boolean | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    version: number
    halopsaRecurringInvoices?: boolean | null
    connectWiseContractNames?: Array<string> | null
    autotaskContractNames?: Array<string> | null
    haloPSAContractNames?: Array<string> | null
    createdByCustomer: boolean
    createdAt: string
    customMethods?: Array<{
      __typename: 'AutopayCustomMethod'
      customerID: string
      methodID: string
      method: TransferPaymentMethodInputEnum
    } | null> | null
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseBillingTerms?: Array<{
      __typename: 'ConnectwiseBillingTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterQbdPaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterNetsuitePaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null> | null
  } | null
}

export type PartnerDeleteAutopayRuleMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteAutopayRuleMutation = {
  __typename: 'Mutation'
  PartnerDeleteAutopayRule?: string | null
}

export type PartnerAutopayExcludedCustomerCreateMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedCustomerCreateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedCustomerCreate?: {
    __typename: 'AutopayExcludedCustomer'
    id: string
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null
}

export type PartnerAutopayExcludedCustomerUpdateMutationVariables = Exact<{
  customerIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerAutopayExcludedCustomerUpdateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedCustomerUpdate?: Array<{
    __typename: 'AutopayExcludedCustomer'
    id: string
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null> | null
}

export type PartnerAutopayExcludedCustomerDeleteMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedCustomerDeleteMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedCustomerDelete?: string | null
}

export type AutopayExcludedListFragment = {
  __typename: 'AutopayExcludedCustomer'
  id: string
  createdByCustomer: boolean
  createdAt: string
  customer: {
    __typename: 'Customer'
    id: string
    name?: string | null
    city?: string | null
    state?: string | null
    tagIDs?: Array<string> | null
  }
}

export type AutopayRulesWithBankingAndCardFragment = {
  __typename: 'AutopayRule'
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  specificDay?: number | null
  lastDayOfMonth?: boolean | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  haloPSAContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
    fallbackCharge?: boolean | null
    institution?: {
      __typename: 'Institution'
      id: string
      externalId?: string | null
      name?: string | null
      url?: string | null
      logo?: string | null
      accounts?: Array<{
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        type?: string | null
        subtype?: string | null
        hasAchAccountNumber?: boolean | null
        hasAchRoutingNumber?: boolean | null
        hasWireRoutingNumber?: boolean | null
        transitNumber?: string | null
        customName?: string | null
        provider?: string | null
        disconnectedAt?: string | null
        systemDeactivatedAt?: string | null
        companyName?: string | null
        institution?: {
          __typename: 'Institution'
          name?: string | null
          id: string
          logo?: string | null
        } | null
        mandates?: Array<{
          __typename: 'Mandate'
          id: string
          consentAt: string
          version: string
        } | null> | null
      } | null> | null
    } | null
    card?: {
      __typename: 'Card'
      id: string
      last4: string
      expirationDate: string
      cardNetWork: CardNetwork
      fundingSource: FundingSource
      customName?: string | null
      hasPostalCode: boolean
      isExpired: boolean
      billingAddress?: {
        __typename: 'Address'
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        state?: string | null
        stateCode?: string | null
        postalCode?: string | null
        country?: string | null
        countryISO?: string | null
      } | null
    } | null
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type AutopayRulesWithCustomerTagsFragment = {
  __typename: 'AutopayRule'
  tagIDs?: Array<string | null> | null
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  specificDay?: number | null
  lastDayOfMonth?: boolean | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  haloPSAContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type AutopayRulesFragment = {
  __typename: 'AutopayRule'
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  specificDay?: number | null
  lastDayOfMonth?: boolean | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  haloPSAContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type CustomerAutopayConfigFragment = {
  __typename: 'GetCustomerAutopayConfigReply'
  customerAutopayConfig?: {
    __typename: 'CustomerAutopayConfig'
    customerID: string
    partnerID: string
    chargeDefaultFallback: boolean
  } | null
}

export type InvoiceCoveredFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
  createdAt: string
  dueDate?: string | null
  amount: number
  status: InvoiceStatusEnum
  recurringpayment: boolean
  externalId?: string | null
  externalInvoiceNumber?: string | null
  autopaidAt?: string | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    tagIDs?: Array<string> | null
  } | null
}

export type FindAutopayRuleFragment = {
  __typename: 'AutopayRule'
  tagIDs?: Array<string | null> | null
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  specificDay?: number | null
  lastDayOfMonth?: boolean | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  haloPSAContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
    tagIDs?: Array<string> | null
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    outstandingInvoicesData?: {
      __typename: 'CustomerOutstandingInvoicesData'
      outstandingInvoicesCount?: number | null
      outstandingInvoicesTotal?: number | null
      longestDaysOverdue?: string | null
    } | null
    defaultPaymentMethod?: {
      __typename: 'CustomerDefaultPaymentMethod'
      methodID: string
      method: TransferPaymentMethodInputEnum
      institution?: {
        __typename: 'Institution'
        id: string
        externalId?: string | null
        name?: string | null
        url?: string | null
        logo?: string | null
        accounts?: Array<{
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          type?: string | null
          subtype?: string | null
          hasAchAccountNumber?: boolean | null
          hasAchRoutingNumber?: boolean | null
          hasWireRoutingNumber?: boolean | null
          transitNumber?: string | null
          customName?: string | null
          provider?: string | null
          disconnectedAt?: string | null
          systemDeactivatedAt?: string | null
          companyName?: string | null
          institution?: {
            __typename: 'Institution'
            name?: string | null
            id: string
            logo?: string | null
          } | null
          mandates?: Array<{
            __typename: 'Mandate'
            id: string
            consentAt: string
            version: string
          } | null> | null
        } | null> | null
      } | null
      card?: {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
        fundingSource: FundingSource
        customName?: string | null
        hasPostalCode: boolean
        isExpired: boolean
        billingAddress?: {
          __typename: 'Address'
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          state?: string | null
          stateCode?: string | null
          postalCode?: string | null
          country?: string | null
          countryISO?: string | null
        } | null
      } | null
    } | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null> | null
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
}

export type GetCustomerAutopayConfigQueryVariables = Exact<{
  input: GetCustomerAutopayConfigInput
}>

export type GetCustomerAutopayConfigQuery = {
  __typename: 'Query'
  GetCustomerAutopayConfig?: {
    __typename: 'GetCustomerAutopayConfigReply'
    customerAutopayConfig?: {
      __typename: 'CustomerAutopayConfig'
      customerID: string
      partnerID: string
      chargeDefaultFallback: boolean
    } | null
  } | null
}

export type SetCustomerAutopayConfigMutationVariables = Exact<{
  input: UpsertCustomerAutopayConfigInput
}>

export type SetCustomerAutopayConfigMutation = {
  __typename: 'Mutation'
  SetCustomerAutopayConfig?: boolean | null
}

export type PartnerInvoiceBnplConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<BnplFilter>
}>

export type PartnerInvoiceBnplConnectionQuery = {
  __typename: 'Query'
  PartnerInvoiceBnplConnection?: {
    __typename: 'InvoiceBnplConnection'
    edges?: Array<{
      __typename: 'InvoiceBnplEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        amount: number
        createdAt: string
        dueDate?: string | null
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        customer?: {
          __typename: 'Customer'
          createdAt: string
          id: string
          name?: string | null
          legalName?: string | null
          isOnboarded: boolean
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        partner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
          legalName?: string | null
          isOnboarded: boolean
          adyenOnboardingStatus: AdyenOnboardingStatusStep
          insightsEnabled: boolean
          timezone?: Timezone | null
          useUserLocalTimezone?: boolean | null
          timezoneSetAt?: string | null
          attachInvoicePDFEnabled?: boolean | null
          pdfFallbackEnabled?: boolean | null
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          createdAt: string
          status: BnplStatus
          amount: number
          fees: number
          netAmount: number
          remainingBalance: number
          terms: number
          lending?: {
            __typename: 'Lending'
            id: string
            amount: number
            netAmount: number
            installments?: Array<{
              __typename: 'Installment'
              id: string
              amount: number
              dueDate: string
              netAmount: number
              status: InstallmentStatus
              payments: Array<{
                __typename: 'Payment'
                id: string
                amount: number
                netAmount: number
                creationDate: string
                currentPaymentMethod?: MethodEnum | null
                dueDate?: string | null
                paymentCompletionForecastDate?: string | null
                originService: PaymentAlternativeService
                executorType: PaymentExecutorType
                paymentFees: Array<{
                  __typename: 'PaymentFee'
                  forwarded: boolean
                  type: FeeType
                  amount: number
                  name: string
                } | null>
                currentPaymentMethodEntity?:
                  | {
                      __typename: 'Account'
                      id: string
                      name?: string | null
                      mask?: string | null
                      type?: string | null
                    }
                  | {
                      __typename: 'Card'
                      id: string
                      cardNetWork: CardNetwork
                      last4: string
                      fundingSource: FundingSource
                    }
                  | null
                customer?: {
                  __typename: 'Customer'
                  id: string
                  name?: string | null
                  streetAddress?: string | null
                  subPremise?: string | null
                  city?: string | null
                  postalCode?: string | null
                  state?: string | null
                  country?: string | null
                } | null
                product:
                  | { __typename: 'InstantPayment' }
                  | {
                      __typename: 'Invoice'
                      id: string
                      invoiceNumber: string
                      productName?: string | null
                      status: InvoiceStatusEnum
                      amount: number
                      dueDate?: string | null
                      outstandingAmount: number
                      platformName: string
                      totalDiscountAmount: number
                      statuses: Array<{
                        __typename: 'InvoiceStatus'
                        status: InvoiceStatusEnum
                        createdAt: any
                      } | null>
                      payments?: Array<{
                        __typename: 'InvoicePayment'
                        id: string
                        status: PaymentStatusEnum
                        payoutCreationForecastDate?: string | null
                      } | null> | null
                    }
                  | { __typename: 'Offer' }
                  | {
                      __typename: 'OneTimePayment'
                      id: string
                      referenceId?: string | null
                    }
                  | { __typename: 'Referral' }
                  | { __typename: 'ReferralBonus' }
                  | { __typename: 'Refund' }
                  | {
                      __typename: 'SubscriptionPayment'
                      id: string
                      paymentDate: string
                      amount: number
                      subscriptionStatus: SubscriptionPaymentStatus
                      subscription: {
                        __typename: 'PartnerSubscription'
                        id: string
                        type: string
                        frequency: SubscriptionFrequency
                      }
                    }
                transaction?: {
                  __typename: 'Transaction'
                  failureReason?: string | null
                  failureReasonCode?: string | null
                  status: TransactionStatus
                } | null
                statuses: Array<{
                  __typename: 'PaymentStatus'
                  status?: PaymentStatusEnum | null
                  createdAt: string
                } | null>
                refunds?: Array<{
                  __typename: 'Refund'
                  id: string
                  amount: number
                  createdAt: string
                  lastStatus: RefundStatusEnum
                  status?: Array<{
                    __typename: 'RefundStatus'
                    id: string
                    status: RefundStatusEnum
                    createdAt: string
                  }> | null
                } | null> | null
                payoutEstimation: {
                  __typename: 'PaymentPayoutEstimation'
                  estimatedPayoutCreationDate?: string | null
                }
              } | null>
            } | null> | null
          } | null
        } | null
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type BnplOfferConfirmByTokenMutationVariables = Exact<{
  confirmationToken: Scalars['String']['input']
}>

export type BnplOfferConfirmByTokenMutation = {
  __typename: 'Mutation'
  BNPLOfferConfirmByToken?: string | null
}

export type PartnerBnplOfferConfirmMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerBnplOfferConfirmMutation = {
  __typename: 'Mutation'
  PartnerBNPLOfferConfirm?: string | null
}

export type PartnerCustomerBnplFragment = {
  __typename: 'Invoice'
  amount: number
  createdAt: string
  dueDate?: string | null
  id: string
  invoiceNumber: string
  productName?: string | null
  status: InvoiceStatusEnum
  outstandingAmount: number
  platformName: string
  totalDiscountAmount: number
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  partner?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
  } | null
  offer?: {
    __typename: 'BNPLOffer'
    createdAt: string
    status: BnplStatus
    amount: number
    fees: number
    netAmount: number
    remainingBalance: number
    terms: number
    lending?: {
      __typename: 'Lending'
      id: string
      amount: number
      netAmount: number
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        dueDate: string
        netAmount: number
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: MethodEnum | null
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          originService: PaymentAlternativeService
          executorType: PaymentExecutorType
          paymentFees: Array<{
            __typename: 'PaymentFee'
            forwarded: boolean
            type: FeeType
            amount: number
            name: string
          } | null>
          currentPaymentMethodEntity?:
            | {
                __typename: 'Account'
                id: string
                name?: string | null
                mask?: string | null
                type?: string | null
              }
            | {
                __typename: 'Card'
                id: string
                cardNetWork: CardNetwork
                last4: string
                fundingSource: FundingSource
              }
            | null
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                status: InvoiceStatusEnum
                amount: number
                dueDate?: string | null
                outstandingAmount: number
                platformName: string
                totalDiscountAmount: number
                statuses: Array<{
                  __typename: 'InvoiceStatus'
                  status: InvoiceStatusEnum
                  createdAt: any
                } | null>
                payments?: Array<{
                  __typename: 'InvoicePayment'
                  id: string
                  status: PaymentStatusEnum
                  payoutCreationForecastDate?: string | null
                } | null> | null
              }
            | { __typename: 'Offer' }
            | {
                __typename: 'OneTimePayment'
                id: string
                referenceId?: string | null
              }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | {
                __typename: 'SubscriptionPayment'
                id: string
                paymentDate: string
                amount: number
                subscriptionStatus: SubscriptionPaymentStatus
                subscription: {
                  __typename: 'PartnerSubscription'
                  id: string
                  type: string
                  frequency: SubscriptionFrequency
                }
              }
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
            failureReasonCode?: string | null
            status: TransactionStatus
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
          refunds?: Array<{
            __typename: 'Refund'
            id: string
            amount: number
            createdAt: string
            lastStatus: RefundStatusEnum
            status?: Array<{
              __typename: 'RefundStatus'
              id: string
              status: RefundStatusEnum
              createdAt: string
            }> | null
          } | null> | null
          payoutEstimation: {
            __typename: 'PaymentPayoutEstimation'
            estimatedPayoutCreationDate?: string | null
          }
        } | null>
      } | null> | null
    } | null
  } | null
  statuses: Array<{
    __typename: 'InvoiceStatus'
    status: InvoiceStatusEnum
    createdAt: any
  } | null>
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
}

export type PartnerCustomerOfferFragment = {
  __typename: 'BNPLOffer'
  createdAt: string
  status: BnplStatus
  amount: number
  fees: number
  netAmount: number
  remainingBalance: number
  terms: number
  lending?: {
    __typename: 'Lending'
    id: string
    amount: number
    netAmount: number
    installments?: Array<{
      __typename: 'Installment'
      id: string
      amount: number
      dueDate: string
      netAmount: number
      status: InstallmentStatus
      payments: Array<{
        __typename: 'Payment'
        id: string
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: MethodEnum | null
        dueDate?: string | null
        paymentCompletionForecastDate?: string | null
        originService: PaymentAlternativeService
        executorType: PaymentExecutorType
        paymentFees: Array<{
          __typename: 'PaymentFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        currentPaymentMethodEntity?:
          | {
              __typename: 'Account'
              id: string
              name?: string | null
              mask?: string | null
              type?: string | null
            }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              last4: string
              fundingSource: FundingSource
            }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | {
              __typename: 'OneTimePayment'
              id: string
              referenceId?: string | null
            }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | {
              __typename: 'SubscriptionPayment'
              id: string
              paymentDate: string
              amount: number
              subscriptionStatus: SubscriptionPaymentStatus
              subscription: {
                __typename: 'PartnerSubscription'
                id: string
                type: string
                frequency: SubscriptionFrequency
              }
            }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
          failureReasonCode?: string | null
          status: TransactionStatus
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        refunds?: Array<{
          __typename: 'Refund'
          id: string
          amount: number
          createdAt: string
          lastStatus: RefundStatusEnum
          status?: Array<{
            __typename: 'RefundStatus'
            id: string
            status: RefundStatusEnum
            createdAt: string
          }> | null
        } | null> | null
        payoutEstimation: {
          __typename: 'PaymentPayoutEstimation'
          estimatedPayoutCreationDate?: string | null
        }
      } | null>
    } | null> | null
  } | null
}

export type PartnerCustomerScheduleFragment = {
  __typename: 'Lending'
  id: string
  amount: number
  netAmount: number
  installments?: Array<{
    __typename: 'Installment'
    id: string
    amount: number
    dueDate: string
    netAmount: number
    status: InstallmentStatus
    payments: Array<{
      __typename: 'Payment'
      id: string
      amount: number
      netAmount: number
      creationDate: string
      currentPaymentMethod?: MethodEnum | null
      dueDate?: string | null
      paymentCompletionForecastDate?: string | null
      originService: PaymentAlternativeService
      executorType: PaymentExecutorType
      paymentFees: Array<{
        __typename: 'PaymentFee'
        forwarded: boolean
        type: FeeType
        amount: number
        name: string
      } | null>
      currentPaymentMethodEntity?:
        | {
            __typename: 'Account'
            id: string
            name?: string | null
            mask?: string | null
            type?: string | null
          }
        | {
            __typename: 'Card'
            id: string
            cardNetWork: CardNetwork
            last4: string
            fundingSource: FundingSource
          }
        | null
      customer?: {
        __typename: 'Customer'
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
      } | null
      product:
        | { __typename: 'InstantPayment' }
        | {
            __typename: 'Invoice'
            id: string
            invoiceNumber: string
            productName?: string | null
            status: InvoiceStatusEnum
            amount: number
            dueDate?: string | null
            outstandingAmount: number
            platformName: string
            totalDiscountAmount: number
            statuses: Array<{
              __typename: 'InvoiceStatus'
              status: InvoiceStatusEnum
              createdAt: any
            } | null>
            payments?: Array<{
              __typename: 'InvoicePayment'
              id: string
              status: PaymentStatusEnum
              payoutCreationForecastDate?: string | null
            } | null> | null
          }
        | { __typename: 'Offer' }
        | {
            __typename: 'OneTimePayment'
            id: string
            referenceId?: string | null
          }
        | { __typename: 'Referral' }
        | { __typename: 'ReferralBonus' }
        | { __typename: 'Refund' }
        | {
            __typename: 'SubscriptionPayment'
            id: string
            paymentDate: string
            amount: number
            subscriptionStatus: SubscriptionPaymentStatus
            subscription: {
              __typename: 'PartnerSubscription'
              id: string
              type: string
              frequency: SubscriptionFrequency
            }
          }
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
        failureReasonCode?: string | null
        status: TransactionStatus
      } | null
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
        createdAt: string
      } | null>
      refunds?: Array<{
        __typename: 'Refund'
        id: string
        amount: number
        createdAt: string
        lastStatus: RefundStatusEnum
        status?: Array<{
          __typename: 'RefundStatus'
          id: string
          status: RefundStatusEnum
          createdAt: string
        }> | null
      } | null> | null
      payoutEstimation: {
        __typename: 'PaymentPayoutEstimation'
        estimatedPayoutCreationDate?: string | null
      }
    } | null>
  } | null> | null
}

export type PartnerCustomerInstallmentFragment = {
  __typename: 'Installment'
  id: string
  amount: number
  dueDate: string
  netAmount: number
  status: InstallmentStatus
  payments: Array<{
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    creationDate: string
    currentPaymentMethod?: MethodEnum | null
    dueDate?: string | null
    paymentCompletionForecastDate?: string | null
    originService: PaymentAlternativeService
    executorType: PaymentExecutorType
    paymentFees: Array<{
      __typename: 'PaymentFee'
      forwarded: boolean
      type: FeeType
      amount: number
      name: string
    } | null>
    currentPaymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          name?: string | null
          mask?: string | null
          type?: string | null
        }
      | {
          __typename: 'Card'
          id: string
          cardNetWork: CardNetwork
          last4: string
          fundingSource: FundingSource
        }
      | null
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    } | null
    product:
      | { __typename: 'InstantPayment' }
      | {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
          productName?: string | null
          status: InvoiceStatusEnum
          amount: number
          dueDate?: string | null
          outstandingAmount: number
          platformName: string
          totalDiscountAmount: number
          statuses: Array<{
            __typename: 'InvoiceStatus'
            status: InvoiceStatusEnum
            createdAt: any
          } | null>
          payments?: Array<{
            __typename: 'InvoicePayment'
            id: string
            status: PaymentStatusEnum
            payoutCreationForecastDate?: string | null
          } | null> | null
        }
      | { __typename: 'Offer' }
      | {
          __typename: 'OneTimePayment'
          id: string
          referenceId?: string | null
        }
      | { __typename: 'Referral' }
      | { __typename: 'ReferralBonus' }
      | { __typename: 'Refund' }
      | {
          __typename: 'SubscriptionPayment'
          id: string
          paymentDate: string
          amount: number
          subscriptionStatus: SubscriptionPaymentStatus
          subscription: {
            __typename: 'PartnerSubscription'
            id: string
            type: string
            frequency: SubscriptionFrequency
          }
        }
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
      failureReasonCode?: string | null
      status: TransactionStatus
    } | null
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
    refunds?: Array<{
      __typename: 'Refund'
      id: string
      amount: number
      createdAt: string
      lastStatus: RefundStatusEnum
      status?: Array<{
        __typename: 'RefundStatus'
        id: string
        status: RefundStatusEnum
        createdAt: string
      }> | null
    } | null> | null
    payoutEstimation: {
      __typename: 'PaymentPayoutEstimation'
      estimatedPayoutCreationDate?: string | null
    }
  } | null>
}

export type PartnerChangeReferralPayoutBankingAccountMutationVariables = Exact<{
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}>

export type PartnerChangeReferralPayoutBankingAccountMutation = {
  __typename: 'Mutation'
  PartnerChangeReferralPayoutBankingAccount?: string | null
}

export type PartnerListBankingIntegrationsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListBankingIntegrationsQuery = {
  __typename: 'Query'
  PartnerListBankingIntegrations: Array<{
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    url?: string | null
    logo?: string | null
    accounts?: Array<{
      __typename: 'Account'
      id: string
      mask?: string | null
      name?: string | null
      type?: string | null
      subtype?: string | null
      hasAchAccountNumber?: boolean | null
      hasAchRoutingNumber?: boolean | null
      hasWireRoutingNumber?: boolean | null
      transitNumber?: string | null
      customName?: string | null
      provider?: string | null
      disconnectedAt?: string | null
      systemDeactivatedAt?: string | null
      companyName?: string | null
      institution?: {
        __typename: 'Institution'
        name?: string | null
        id: string
        logo?: string | null
      } | null
      mandates?: Array<{
        __typename: 'Mandate'
        id: string
        consentAt: string
        version: string
      } | null> | null
    } | null> | null
  } | null>
}

export type PartnerListBankingIntegrationsWithVerificationQueryVariables =
  Exact<{ [key: string]: never }>

export type PartnerListBankingIntegrationsWithVerificationQuery = {
  __typename: 'Query'
  PartnerListBankingIntegrations: Array<{
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    url?: string | null
    logo?: string | null
    accounts?: Array<{
      __typename: 'Account'
      id: string
      mask?: string | null
      name?: string | null
      type?: string | null
      subtype?: string | null
      hasAchAccountNumber?: boolean | null
      hasAchRoutingNumber?: boolean | null
      hasWireRoutingNumber?: boolean | null
      transitNumber?: string | null
      customName?: string | null
      provider?: string | null
      disconnectedAt?: string | null
      systemDeactivatedAt?: string | null
      companyName?: string | null
      bankAccountVerification?: Array<{
        __typename: 'BankAccountVerification'
        id: string
        verificationStatus: BankAccountVerificationStatus
        verificationType: BankAccountVerificationType
        transactionNetwork: TransactionNetwork
        remediationActions?: Array<{
          __typename: 'RemediationAction'
          message: string
          internalCode?: string | null
        } | null> | null
      } | null> | null
      mandates?: Array<{
        __typename: 'Mandate'
        id: string
        consentAt: string
        version: string
      } | null> | null
      institution?: {
        __typename: 'Institution'
        name?: string | null
        id: string
        logo?: string | null
      } | null
    } | null> | null
  } | null>
}

export type PartnerListCustomerBankingIntegrationsQueryVariables = Exact<{
  customerID: Scalars['String']['input']
}>

export type PartnerListCustomerBankingIntegrationsQuery = {
  __typename: 'Query'
  PartnerListCustomerBankingIntegrations: Array<{
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    url?: string | null
    logo?: string | null
    accounts?: Array<{
      __typename: 'Account'
      id: string
      mask?: string | null
      name?: string | null
      type?: string | null
      subtype?: string | null
      hasAchAccountNumber?: boolean | null
      hasAchRoutingNumber?: boolean | null
      hasWireRoutingNumber?: boolean | null
      transitNumber?: string | null
      customName?: string | null
      provider?: string | null
      disconnectedAt?: string | null
      systemDeactivatedAt?: string | null
      companyName?: string | null
      institution?: {
        __typename: 'Institution'
        name?: string | null
        id: string
        logo?: string | null
      } | null
      mandates?: Array<{
        __typename: 'Mandate'
        id: string
        consentAt: string
        version: string
      } | null> | null
    } | null> | null
  } | null>
}

export type PartnerArchiveAccountMutationVariables = Exact<{
  accountID: Scalars['ID']['input']
}>

export type PartnerArchiveAccountMutation = {
  __typename: 'Mutation'
  PartnerArchiveAccount: string
}

export type PartnerAddManualBankingConnectionMutationVariables = Exact<{
  accountInformation: ManualBankingAccountInformationInput
}>

export type PartnerAddManualBankingConnectionMutation = {
  __typename: 'Mutation'
  PartnerAddManualBankingConnection?: string | null
}

export type PartnerAddManualBankingConnectionV2MutationVariables = Exact<{
  accountInformation: ManualBankingAccountInformationInput
}>

export type PartnerAddManualBankingConnectionV2Mutation = {
  __typename: 'Mutation'
  PartnerAddManualBankingConnectionV2?: {
    __typename: 'Account'
    id: string
  } | null
}

export type PartnerAddCustomerBankingConnectionMutationVariables = Exact<{
  customerID: Scalars['String']['input']
  accountInformation: ManualBankingAccountInformationInput
}>

export type PartnerAddCustomerBankingConnectionMutation = {
  __typename: 'Mutation'
  PartnerAddCustomerManualBankingConnection?: string | null
}

export type PartnerChangeDefaultPayoutBankingAccountMutationVariables = Exact<{
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}>

export type PartnerChangeDefaultPayoutBankingAccountMutation = {
  __typename: 'Mutation'
  PartnerChangeDefaultPayoutBankingAccount?: string | null
}

export type PartnerAddBankAccountMutationVariables = Exact<{
  input: AddBankAccountInput
}>

export type PartnerAddBankAccountMutation = {
  __typename: 'Mutation'
  PartnerAddBankAccount: { __typename: 'BankAccount'; id: string }
}

export type PartnerAddCustomerBankAccountMutationVariables = Exact<{
  input: AddCustomerBankAccountInput
}>

export type PartnerAddCustomerBankAccountMutation = {
  __typename: 'Mutation'
  PartnerAddCustomerBankAccount: { __typename: 'BankAccount'; id: string }
}

export type BankFragment = {
  __typename: 'Institution'
  id: string
  externalId?: string | null
  name?: string | null
  url?: string | null
  logo?: string | null
  accounts?: Array<{
    __typename: 'Account'
    id: string
    mask?: string | null
    name?: string | null
    type?: string | null
    subtype?: string | null
    hasAchAccountNumber?: boolean | null
    hasAchRoutingNumber?: boolean | null
    hasWireRoutingNumber?: boolean | null
    transitNumber?: string | null
    customName?: string | null
    provider?: string | null
    disconnectedAt?: string | null
    systemDeactivatedAt?: string | null
    companyName?: string | null
    institution?: {
      __typename: 'Institution'
      name?: string | null
      id: string
      logo?: string | null
    } | null
    mandates?: Array<{
      __typename: 'Mandate'
      id: string
      consentAt: string
      version: string
    } | null> | null
  } | null> | null
}

export type BankAccountFragment = {
  __typename: 'Account'
  id: string
  mask?: string | null
  name?: string | null
  type?: string | null
  subtype?: string | null
  hasAchAccountNumber?: boolean | null
  hasAchRoutingNumber?: boolean | null
  hasWireRoutingNumber?: boolean | null
  transitNumber?: string | null
  customName?: string | null
  provider?: string | null
  disconnectedAt?: string | null
  systemDeactivatedAt?: string | null
  companyName?: string | null
  institution?: {
    __typename: 'Institution'
    name?: string | null
    id: string
    logo?: string | null
  } | null
  mandates?: Array<{
    __typename: 'Mandate'
    id: string
    consentAt: string
    version: string
  } | null> | null
}

export type BankWithVerificationFragment = {
  __typename: 'Institution'
  id: string
  externalId?: string | null
  name?: string | null
  url?: string | null
  logo?: string | null
  accounts?: Array<{
    __typename: 'Account'
    id: string
    mask?: string | null
    name?: string | null
    type?: string | null
    subtype?: string | null
    hasAchAccountNumber?: boolean | null
    hasAchRoutingNumber?: boolean | null
    hasWireRoutingNumber?: boolean | null
    transitNumber?: string | null
    customName?: string | null
    provider?: string | null
    disconnectedAt?: string | null
    systemDeactivatedAt?: string | null
    companyName?: string | null
    bankAccountVerification?: Array<{
      __typename: 'BankAccountVerification'
      id: string
      verificationStatus: BankAccountVerificationStatus
      verificationType: BankAccountVerificationType
      transactionNetwork: TransactionNetwork
      remediationActions?: Array<{
        __typename: 'RemediationAction'
        message: string
        internalCode?: string | null
      } | null> | null
    } | null> | null
    mandates?: Array<{
      __typename: 'Mandate'
      id: string
      consentAt: string
      version: string
    } | null> | null
    institution?: {
      __typename: 'Institution'
      name?: string | null
      id: string
      logo?: string | null
    } | null
  } | null> | null
}

export type BankAccountWithVerificationFragment = {
  __typename: 'Account'
  id: string
  mask?: string | null
  name?: string | null
  type?: string | null
  subtype?: string | null
  hasAchAccountNumber?: boolean | null
  hasAchRoutingNumber?: boolean | null
  hasWireRoutingNumber?: boolean | null
  transitNumber?: string | null
  customName?: string | null
  provider?: string | null
  disconnectedAt?: string | null
  systemDeactivatedAt?: string | null
  companyName?: string | null
  bankAccountVerification?: Array<{
    __typename: 'BankAccountVerification'
    id: string
    verificationStatus: BankAccountVerificationStatus
    verificationType: BankAccountVerificationType
    transactionNetwork: TransactionNetwork
    remediationActions?: Array<{
      __typename: 'RemediationAction'
      message: string
      internalCode?: string | null
    } | null> | null
  } | null> | null
  mandates?: Array<{
    __typename: 'Mandate'
    id: string
    consentAt: string
    version: string
  } | null> | null
  institution?: {
    __typename: 'Institution'
    name?: string | null
    id: string
    logo?: string | null
  } | null
}

export type BankAccountInfoFragment = {
  __typename: 'BankAccount'
  id: string
  receiverName?: string | null
  type?: string | null
  subtype?: string | null
  accountNumber?: string | null
  routingNumber?: string | null
  customName?: string | null
  countryCode?: CountryCode | null
  institution?: { __typename: 'Institution'; name?: string | null } | null
  bankAccountVerification?: Array<{
    __typename: 'BankAccountVerification'
    id: string
    bankAccountId: string
    verificationStatus: BankAccountVerificationStatus
    verificationType: BankAccountVerificationType
    transactionNetwork: TransactionNetwork
    version: number
    remediationActions?: Array<{
      __typename: 'RemediationAction'
      message: string
      internalCode?: string | null
    } | null> | null
  } | null> | null
  accountData?:
    | {
        __typename: 'CAAccountData'
        institutionName: string
        institutionCode: string
        transitNumber: string
        accountNumber: string
        receiverName: string
        subtype: string
        type: string
      }
    | {
        __typename: 'USAccountData'
        institutionName: string
        routingNumber: string
        wireRoutingNumber?: string | null
        accountNumber: string
        receiverName: string
        subtype: string
        type: string
      }
    | null
}

export type PartnerUploadBankAccountDocumentMutationVariables = Exact<{
  input: UploadBankAccountDocumentInput
}>

export type PartnerUploadBankAccountDocumentMutation = {
  __typename: 'Mutation'
  PartnerUploadBankAccountDocument: boolean
}

export type PartnerUpdateBankAccountMutationVariables = Exact<{
  input: UpdateBankAccountInput
}>

export type PartnerUpdateBankAccountMutation = {
  __typename: 'Mutation'
  PartnerUpdateBankAccount: boolean
}

export type PartnerUpdateBankAccountV2MutationVariables = Exact<{
  input: UpdateBankAccountV2Input
}>

export type PartnerUpdateBankAccountV2Mutation = {
  __typename: 'Mutation'
  PartnerUpdateBankAccountV2: boolean
}

export type PartnerUpdateBankAccountCustomNameMutationVariables = Exact<{
  input: BankAccountCustomNameUpdateInput
}>

export type PartnerUpdateBankAccountCustomNameMutation = {
  __typename: 'Mutation'
  PartnerUpdateBankAccountCustomName?: string | null
}

export type PartnerGetBankAccountQueryVariables = Exact<{
  bankAccountID: Scalars['ID']['input']
}>

export type PartnerGetBankAccountQuery = {
  __typename: 'Query'
  PartnerGetBankAccount?: {
    __typename: 'BankAccount'
    id: string
    receiverName?: string | null
    type?: string | null
    subtype?: string | null
    accountNumber?: string | null
    routingNumber?: string | null
    customName?: string | null
    countryCode?: CountryCode | null
    institution?: { __typename: 'Institution'; name?: string | null } | null
    bankAccountVerification?: Array<{
      __typename: 'BankAccountVerification'
      id: string
      bankAccountId: string
      verificationStatus: BankAccountVerificationStatus
      verificationType: BankAccountVerificationType
      transactionNetwork: TransactionNetwork
      version: number
      remediationActions?: Array<{
        __typename: 'RemediationAction'
        message: string
        internalCode?: string | null
      } | null> | null
    } | null> | null
    accountData?:
      | {
          __typename: 'CAAccountData'
          institutionName: string
          institutionCode: string
          transitNumber: string
          accountNumber: string
          receiverName: string
          subtype: string
          type: string
        }
      | {
          __typename: 'USAccountData'
          institutionName: string
          routingNumber: string
          wireRoutingNumber?: string | null
          accountNumber: string
          receiverName: string
          subtype: string
          type: string
        }
      | null
  } | null
}

export type PartnerCollectMandateConsentMutationVariables = Exact<{
  mandateConsentInput: CollectMandateConsentInput
}>

export type PartnerCollectMandateConsentMutation = {
  __typename: 'Mutation'
  PartnerCollectMandateConsent: boolean
}

export type PartnerGetInvoiceBulkChargesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  getPartnerInvoiceBulkChargesFilter?: InputMaybe<GetPartnerInvoiceBulkChargesFilter>
  getPartnerInvoiceBulkChargesOrderBy?: InputMaybe<GetPartnerInvoiceBulkChargesOrderBy>
}>

export type PartnerGetInvoiceBulkChargesQuery = {
  __typename: 'Query'
  PartnerGetInvoiceBulkCharges?: {
    __typename: 'PartnerInvoiceBulkChargeConnection'
    edges?: Array<{
      __typename: 'PartnerInvoiceBulkChargeEdge'
      cursor: any
      node?: {
        __typename: 'PartnerInvoiceBulkCharge'
        id: string
        bulkChargeRequestStatus?: BulkChargeRequestStatusEnum | null
        invoiceCount: number
        paymentDate?: string | null
        createdAt: string
        partner: { __typename: 'Partner'; id: string; name?: string | null }
        requester?: {
          __typename: 'PartnerUser'
          id: string
          email: string
        } | null
        paymentRequests?: Array<{
          __typename: 'PaymentRequest'
          id: string
          lastStatus: PaymentStatusEnum
          paymentDate?: string | null
          payment?: {
            __typename: 'Payment'
            amount: number
            netAmount: number
            paymentCompletionForecastDate?: string | null
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              amount: number
            } | null>
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
            } | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                amount: number
                status: InvoiceStatusEnum
                customer?: {
                  __typename: 'Customer'
                  id: string
                  name?: string | null
                } | null
              }
            | { __typename: 'Offer' }
            | { __typename: 'OneTimePayment' }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | { __typename: 'SubscriptionPayment' }
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerInvoiceBulkChargeOnDateMutationVariables = Exact<{
  invoiceIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
  paymentDate?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerInvoiceBulkChargeOnDateMutation = {
  __typename: 'Mutation'
  PartnerInvoiceBulkChargeOnDate?: string | null
}

export type PartnerInvoiceBulkChargeOnDueDateMutationVariables = Exact<{
  invoiceIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerInvoiceBulkChargeOnDueDateMutation = {
  __typename: 'Mutation'
  PartnerInvoiceBulkChargeOnDueDate?: string | null
}

export type PartnerInvoiceBulkChargeFragment = {
  __typename: 'PartnerInvoiceBulkCharge'
  id: string
  bulkChargeRequestStatus?: BulkChargeRequestStatusEnum | null
  invoiceCount: number
  paymentDate?: string | null
  createdAt: string
  partner: { __typename: 'Partner'; id: string; name?: string | null }
  requester?: { __typename: 'PartnerUser'; id: string; email: string } | null
  paymentRequests?: Array<{
    __typename: 'PaymentRequest'
    id: string
    lastStatus: PaymentStatusEnum
    paymentDate?: string | null
    payment?: {
      __typename: 'Payment'
      amount: number
      netAmount: number
      paymentCompletionForecastDate?: string | null
      paymentFees: Array<{
        __typename: 'PaymentFee'
        forwarded: boolean
        amount: number
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null
    product:
      | { __typename: 'InstantPayment' }
      | {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
          productName?: string | null
          amount: number
          status: InvoiceStatusEnum
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
          } | null
        }
      | { __typename: 'Offer' }
      | { __typename: 'OneTimePayment' }
      | { __typename: 'Referral' }
      | { __typename: 'ReferralBonus' }
      | { __typename: 'Refund' }
      | { __typename: 'SubscriptionPayment' }
  } | null> | null
}

export type PaymentRequestFragment = {
  __typename: 'PaymentRequest'
  id: string
  lastStatus: PaymentStatusEnum
  paymentDate?: string | null
  payment?: {
    __typename: 'Payment'
    amount: number
    netAmount: number
    paymentCompletionForecastDate?: string | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      forwarded: boolean
      amount: number
    } | null>
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
    } | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        amount: number
        status: InvoiceStatusEnum
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'OneTimePayment' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
}

export type FindOverdueInvoiceDetailQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type FindOverdueInvoiceDetailQuery = {
  __typename: 'Query'
  FindInvoice?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    dueDate?: string | null
    invoiceNumber: string
    status: InvoiceStatusEnum
    customer?: {
      __typename: 'Customer'
      createdAt: string
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    } | null
    collection?: {
      __typename: 'Collection'
      id: string
      status: Array<{
        __typename: 'CollectionStatus'
        status: CollectionStatusEnum
        createdAt: string
      }>
    } | null
  } | null
}

export type FindOverdueInvoicesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<InvoiceFilter>
  orderBy?: InputMaybe<InvoiceOrderBy>
}>

export type FindOverdueInvoicesQuery = {
  __typename: 'Query'
  PartnerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        id: string
        amount: number
        outstandingAmount: number
        createdAt: string
        dueDate?: string | null
        invoiceNumber: string
        status: InvoiceStatusEnum
        collection?: {
          __typename: 'Collection'
          id: string
          status: Array<{
            __typename: 'CollectionStatus'
            status: CollectionStatusEnum
            createdAt: string
          }>
        } | null
        customer?: {
          __typename: 'Customer'
          createdAt: string
          id: string
          name?: string | null
          legalName?: string | null
          isOnboarded: boolean
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerCollectionConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  collectionFilter?: InputMaybe<CollectionFilter>
  orderBy?: InputMaybe<CollectionOrder>
}>

export type PartnerCollectionConnectionQuery = {
  __typename: 'Query'
  PartnerCollectionConnection?: {
    __typename: 'CollectionConnection'
    edges?: Array<{
      __typename: 'CollectionEdge'
      cursor: any
      node?: {
        __typename: 'Collection'
        id: string
        createdAt: string
        collectionOutstandingAmount: number
        collectionFeePaymentAmount: number
        interest: number
        collectionPayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          creationDate: string
        } | null
        invoice: {
          __typename: 'Invoice'
          id: string
          amount: number
          dueDate?: string | null
          invoiceNumber: string
          productName?: string | null
        }
        customerInfo: {
          __typename: 'CollectionCustomerInfo'
          customer: {
            __typename: 'Customer'
            createdAt: string
            id: string
            name?: string | null
            legalName?: string | null
            isOnboarded: boolean
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          }
        }
        upfrontFeePayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          currentPaymentMethodEntity?:
            | { __typename: 'Account'; id: string; name?: string | null }
            | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
            | null
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
            forwarded: boolean
            name: string
          } | null>
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null
        status: Array<{
          __typename: 'CollectionStatus'
          status: CollectionStatusEnum
          createdAt: string
        }>
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type FindCollectionDetailQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  collectionFilter?: InputMaybe<CollectionFilter>
  orderBy?: InputMaybe<CollectionOrder>
}>

export type FindCollectionDetailQuery = {
  __typename: 'Query'
  PartnerCollectionConnection?: {
    __typename: 'CollectionConnection'
    edges?: Array<{
      __typename: 'CollectionEdge'
      cursor: any
      node?: {
        __typename: 'Collection'
        id: string
        collectionInstruction: string
        collectionOutstandingAmount: number
        collectionFeePaymentAmount: number
        interest: number
        lastContactDate: string
        customerType: CollectionCustomerType
        createdAt: string
        updatedAt: string
        collectionPayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          paymentCompletionForecastDate?: string | null
          currentPaymentMethodEntity?:
            | { __typename: 'Account'; id: string; name?: string | null }
            | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
            | null
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
            forwarded: boolean
            name: string
          } | null>
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null
        customerInfo: {
          __typename: 'CollectionCustomerInfo'
          name: string
          phone: string
          email: string
          streetAddress: string
          subPremise?: string | null
          city: string
          state: string
          postalCode: string
          country: string
          customer: { __typename: 'Customer'; name?: string | null; id: string }
        }
        invoice: {
          __typename: 'Invoice'
          id: string
          amount: number
          dueDate?: string | null
          invoiceNumber: string
          productName?: string | null
        }
        notes: Array<{
          __typename: 'CollectionNote'
          note: string
          createdAt: string
        }>
        status: Array<{
          __typename: 'CollectionStatus'
          status: CollectionStatusEnum
          createdAt: string
        }>
        upfrontFeePayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          currentPaymentMethodEntity?:
            | { __typename: 'Account'; id: string; name?: string | null }
            | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
            | null
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
            forwarded: boolean
            name: string
          } | null>
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null
      } | null
    } | null> | null
  } | null
}

export type PartnerCollectionTotalsQueryVariables = Exact<{
  collectionFilter?: InputMaybe<CollectionFilter>
}>

export type PartnerCollectionTotalsQuery = {
  __typename: 'Query'
  PartnerCollectionTotals: {
    __typename: 'CollectionTotals'
    netAmount: number
    amount: number
    count: number
  }
}

export type PartnerGetFeeRatesQueryVariables = Exact<{
  input: GetFeeRatesInput
}>

export type PartnerGetFeeRatesQuery = {
  __typename: 'Query'
  PartnerGetFeeRates?: {
    __typename: 'CollectionFeeRates'
    upfrontFeeAmount: number
    collectionFeeAmount: number
  } | null
}

export type PartnerCreateCollectionMutationVariables = Exact<{
  createInput: CollectionCreateInput
}>

export type PartnerCreateCollectionMutation = {
  __typename: 'Mutation'
  PartnerCreateCollection?: string | null
}

export type PartnerCancelCollectionMutationVariables = Exact<{
  collectionID: Scalars['String']['input']
  reason: Scalars['String']['input']
}>

export type PartnerCancelCollectionMutation = {
  __typename: 'Mutation'
  PartnerCancelCollection?: string | null
}

export type PartnerCollectionInvoiceFragment = {
  __typename: 'Invoice'
  id: string
  amount: number
  outstandingAmount: number
  createdAt: string
  dueDate?: string | null
  invoiceNumber: string
  status: InvoiceStatusEnum
  collection?: {
    __typename: 'Collection'
    id: string
    status: Array<{
      __typename: 'CollectionStatus'
      status: CollectionStatusEnum
      createdAt: string
    }>
  } | null
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
}

export type UpfrontFeePaymentFragment = {
  __typename: 'Payment'
  id: string
  amount: number
  netAmount: number
  dueDate?: string | null
  paymentCompletionForecastDate?: string | null
  currentPaymentMethodEntity?:
    | { __typename: 'Account'; id: string; name?: string | null }
    | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
    | null
  paymentFees: Array<{
    __typename: 'PaymentFee'
    amount: number
    forwarded: boolean
    name: string
  } | null>
  statuses: Array<{
    __typename: 'PaymentStatus'
    status?: PaymentStatusEnum | null
    createdAt: string
  } | null>
}

export type PartnerCollectionListingFragment = {
  __typename: 'Collection'
  id: string
  createdAt: string
  collectionOutstandingAmount: number
  collectionFeePaymentAmount: number
  interest: number
  collectionPayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    creationDate: string
  } | null
  invoice: {
    __typename: 'Invoice'
    id: string
    amount: number
    dueDate?: string | null
    invoiceNumber: string
    productName?: string | null
  }
  customerInfo: {
    __typename: 'CollectionCustomerInfo'
    customer: {
      __typename: 'Customer'
      createdAt: string
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    }
  }
  upfrontFeePayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    dueDate?: string | null
    paymentCompletionForecastDate?: string | null
    currentPaymentMethodEntity?:
      | { __typename: 'Account'; id: string; name?: string | null }
      | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
      | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      amount: number
      forwarded: boolean
      name: string
    } | null>
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null
  status: Array<{
    __typename: 'CollectionStatus'
    status: CollectionStatusEnum
    createdAt: string
  }>
}

export type PartnerCollectionDetailFragment = {
  __typename: 'Collection'
  id: string
  collectionInstruction: string
  collectionOutstandingAmount: number
  collectionFeePaymentAmount: number
  interest: number
  lastContactDate: string
  customerType: CollectionCustomerType
  createdAt: string
  updatedAt: string
  collectionPayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    paymentCompletionForecastDate?: string | null
    currentPaymentMethodEntity?:
      | { __typename: 'Account'; id: string; name?: string | null }
      | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
      | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      amount: number
      forwarded: boolean
      name: string
    } | null>
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null
  customerInfo: {
    __typename: 'CollectionCustomerInfo'
    name: string
    phone: string
    email: string
    streetAddress: string
    subPremise?: string | null
    city: string
    state: string
    postalCode: string
    country: string
    customer: { __typename: 'Customer'; name?: string | null; id: string }
  }
  invoice: {
    __typename: 'Invoice'
    id: string
    amount: number
    dueDate?: string | null
    invoiceNumber: string
    productName?: string | null
  }
  notes: Array<{
    __typename: 'CollectionNote'
    note: string
    createdAt: string
  }>
  status: Array<{
    __typename: 'CollectionStatus'
    status: CollectionStatusEnum
    createdAt: string
  }>
  upfrontFeePayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    dueDate?: string | null
    paymentCompletionForecastDate?: string | null
    currentPaymentMethodEntity?:
      | { __typename: 'Account'; id: string; name?: string | null }
      | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
      | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      amount: number
      forwarded: boolean
      name: string
    } | null>
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null
}

export type PartnerOverdueInvoiceFragment = {
  __typename: 'Invoice'
  id: string
  amount: number
  outstandingAmount: number
  createdAt: string
  dueDate?: string | null
  invoiceNumber: string
  status: InvoiceStatusEnum
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  collection?: {
    __typename: 'Collection'
    id: string
    status: Array<{
      __typename: 'CollectionStatus'
      status: CollectionStatusEnum
      createdAt: string
    }>
  } | null
}

export type PartnerListCardsQueryVariables = Exact<{
  filter?: InputMaybe<ListCardsFilterInput>
}>

export type PartnerListCardsQuery = {
  __typename: 'Query'
  PartnerListCards?: Array<{
    __typename: 'Card'
    id: string
    last4: string
    expirationDate: string
    cardNetWork: CardNetwork
    fundingSource: FundingSource
    customName?: string | null
    hasPostalCode: boolean
    isExpired: boolean
    billingAddress?: {
      __typename: 'Address'
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      state?: string | null
      stateCode?: string | null
      postalCode?: string | null
      country?: string | null
      countryISO?: string | null
    } | null
  } | null> | null
}

export type PartnerListCustomerCardsQueryVariables = Exact<{
  filter?: InputMaybe<ListCardsFilterInput>
  customerID: Scalars['ID']['input']
}>

export type PartnerListCustomerCardsQuery = {
  __typename: 'Query'
  PartnerListCustomerCards?: Array<{
    __typename: 'Card'
    id: string
    last4: string
    expirationDate: string
    cardNetWork: CardNetwork
    fundingSource: FundingSource
    customName?: string | null
    hasPostalCode: boolean
    isExpired: boolean
    billingAddress?: {
      __typename: 'Address'
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      state?: string | null
      stateCode?: string | null
      postalCode?: string | null
      country?: string | null
      countryISO?: string | null
    } | null
  } | null> | null
}

export type PartnerGetCardFeeQueryVariables = Exact<{
  input: GetCardFeeInput
}>

export type PartnerGetCardFeeQuery = {
  __typename: 'Query'
  PartnerGetCardFee?: {
    __typename: 'CardFeeAmount'
    percentage: number
    feeAmount: number
  } | null
}

export type PartnerGetCustomerCardFeeQueryVariables = Exact<{
  input: GetCustomerCardFeeInput
}>

export type PartnerGetCustomerCardFeeQuery = {
  __typename: 'Query'
  PartnerGetCustomerCardFee?: {
    __typename: 'CardFeeAmount'
    percentage: number
    feeAmount: number
  } | null
}

export type PartnerCreateCardMutationVariables = Exact<{
  input: CardCreationInput
}>

export type PartnerCreateCardMutation = {
  __typename: 'Mutation'
  PartnerCreateCard?: string | null
}

export type PartnerCreateCustomerCardMutationVariables = Exact<{
  input: CardCreationInput
  customerID: Scalars['ID']['input']
}>

export type PartnerCreateCustomerCardMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomerCard?: string | null
}

export type PartnerDeleteCardMutationVariables = Exact<{
  input: CardDeletionInput
}>

export type PartnerDeleteCardMutation = {
  __typename: 'Mutation'
  PartnerDeleteCard?: string | null
}

export type PartnerDeleteCustomerCardMutationVariables = Exact<{
  input: CardDeletionInput
  customerID: Scalars['ID']['input']
}>

export type PartnerDeleteCustomerCardMutation = {
  __typename: 'Mutation'
  PartnerDeleteCustomerCard?: string | null
}

export type PartnerUpdateCardCustomNameMutationVariables = Exact<{
  input: CardCustomNameUpdateInput
}>

export type PartnerUpdateCardCustomNameMutation = {
  __typename: 'Mutation'
  PartnerUpdateCardCustomName?: string | null
}

export type PartnerUpdateCardMutationVariables = Exact<{
  input: CardUpdateInput
}>

export type PartnerUpdateCardMutation = {
  __typename: 'Mutation'
  PartnerUpdateCard?: string | null
}

export type CreditCardFragment = {
  __typename: 'Card'
  id: string
  last4: string
  expirationDate: string
  cardNetWork: CardNetwork
  fundingSource: FundingSource
  customName?: string | null
  hasPostalCode: boolean
  isExpired: boolean
  billingAddress?: {
    __typename: 'Address'
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    stateCode?: string | null
    postalCode?: string | null
    country?: string | null
    countryISO?: string | null
  } | null
}

export type PartnerCreditMemoConfigFragment = {
  __typename: 'CreditMemoConfig'
  partnerID: string
  showCreditMemo: boolean
  customerExceptionIDs: Array<string>
  enabled: boolean
}

export type PartnerCustomerCreditMemoBalanceFragment = {
  __typename: 'CustomerCreditMemoBalance'
  balance: number
  currencyCode: string
  show: boolean
  lastSyncedAt?: string | null
  enabled: boolean
}

export type PartnerGetCreditMemoConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetCreditMemoConfigQuery = {
  __typename: 'Query'
  PartnerGetCreditMemoConfig: {
    __typename: 'CreditMemoConfig'
    partnerID: string
    showCreditMemo: boolean
    customerExceptionIDs: Array<string>
    enabled: boolean
  }
}

export type PartnerGetCustomerCreditMemoBalanceQueryVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerGetCustomerCreditMemoBalanceQuery = {
  __typename: 'Query'
  PartnerGetCustomerCreditMemoBalance: {
    __typename: 'CustomerCreditMemoBalance'
    balance: number
    currencyCode: string
    show: boolean
    lastSyncedAt?: string | null
    enabled: boolean
  }
}

export type PartnerUpdateCreditMemoConfigMutationVariables = Exact<{
  input: UpdateCreditMemoConfigInput
}>

export type PartnerUpdateCreditMemoConfigMutation = {
  __typename: 'Mutation'
  PartnerUpdateCreditMemoConfig: {
    __typename: 'CreditMemoConfig'
    partnerID: string
    showCreditMemo: boolean
    customerExceptionIDs: Array<string>
    enabled: boolean
  }
}

export type PartnerUpdateCreditMemoConfigExceptionsMutationVariables = Exact<{
  input: UpdateCreditMemoConfigExceptionsInput
}>

export type PartnerUpdateCreditMemoConfigExceptionsMutation = {
  __typename: 'Mutation'
  PartnerUpdateCreditMemoConfigExceptions: {
    __typename: 'CreditMemoConfig'
    partnerID: string
    showCreditMemo: boolean
    customerExceptionIDs: Array<string>
    enabled: boolean
  }
}

export type PartnerResyncCustomerCreditMemoBalanceMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerResyncCustomerCreditMemoBalanceMutation = {
  __typename: 'Mutation'
  PartnerResyncCustomerCreditMemoBalance: {
    __typename: 'CustomerCreditMemoBalance'
    balance: number
    currencyCode: string
    show: boolean
    lastSyncedAt?: string | null
    enabled: boolean
  }
}

export type CreditMemoDetailFieldsFragment = {
  __typename: 'CreditMemoDetail'
  id: string
  partnerID: string
  externalMemoNumber?: string | null
  totalAmount: number
  remainingAmount: number
  status: CreditMemoStatus
  currencyCode: string
  issueDate?: string | null
  createdAt: string
  customer?: { __typename: 'Customer'; id: string; name?: string | null } | null
}

export type PartnerListCreditMemosQueryVariables = Exact<{
  filters?: InputMaybe<CreditMemoFiltersInput>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<CreditMemoOrderInput>
}>

export type PartnerListCreditMemosQuery = {
  __typename: 'Query'
  PartnerListCreditMemos: {
    __typename: 'CreditMemoListResponse'
    lastSyncedAt?: string | null
    creditMemos: Array<{
      __typename: 'CreditMemoDetail'
      id: string
      partnerID: string
      externalMemoNumber?: string | null
      totalAmount: number
      remainingAmount: number
      status: CreditMemoStatus
      currencyCode: string
      issueDate?: string | null
      createdAt: string
      customer?: {
        __typename: 'Customer'
        id: string
        name?: string | null
      } | null
    }>
    pagination: {
      __typename: 'CreditMemoPagination'
      page: number
      pageSize: number
      totalItems: number
      totalPages: number
    }
  }
}

export type PartnerListCreditMemosByCustomerIdQueryVariables = Exact<{
  customerID: Scalars['ID']['input']
  filters?: InputMaybe<CreditMemoFiltersInput>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<CreditMemoOrderInput>
}>

export type PartnerListCreditMemosByCustomerIdQuery = {
  __typename: 'Query'
  PartnerListCreditMemosByCustomerId: {
    __typename: 'CreditMemoListResponse'
    creditMemos: Array<{
      __typename: 'CreditMemoDetail'
      id: string
      partnerID: string
      externalMemoNumber?: string | null
      totalAmount: number
      remainingAmount: number
      status: CreditMemoStatus
      currencyCode: string
      issueDate?: string | null
      createdAt: string
      customer?: {
        __typename: 'Customer'
        id: string
        name?: string | null
      } | null
    }>
    pagination: {
      __typename: 'CreditMemoPagination'
      page: number
      pageSize: number
      totalItems: number
      totalPages: number
    }
  }
}

export type PartnerGetCreditMemoDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetCreditMemoDetailsQuery = {
  __typename: 'Query'
  PartnerGetCreditMemoDetails: {
    __typename: 'CreditMemoDetail'
    externalNote?: string | null
    internalNote?: string | null
    id: string
    partnerID: string
    externalMemoNumber?: string | null
    totalAmount: number
    remainingAmount: number
    status: CreditMemoStatus
    currencyCode: string
    issueDate?: string | null
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  }
}

export type PartnerBatchTagCustomersMutationVariables = Exact<{
  customerIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}>

export type PartnerBatchTagCustomersMutation = {
  __typename: 'Mutation'
  PartnerBatchTagCustomers: string
}

export type PartnerDeleteCustomerTagMutationVariables = Exact<{
  ID: Scalars['ID']['input']
}>

export type PartnerDeleteCustomerTagMutation = {
  __typename: 'Mutation'
  PartnerDeleteCustomerTag: string
}

export type PartnerUpdateCustomerTagMutationVariables = Exact<{
  input: PartnerUpdateCustomerTagInput
}>

export type PartnerUpdateCustomerTagMutation = {
  __typename: 'Mutation'
  PartnerUpdateCustomerTag: string
}

export type PartnerTagCustomerMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}>

export type PartnerTagCustomerMutation = {
  __typename: 'Mutation'
  PartnerTagCustomer: string
}

export type PartnerUntagCustomerMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}>

export type PartnerUntagCustomerMutation = {
  __typename: 'Mutation'
  PartnerUntagCustomer: string
}

export type PartnerListCustomerTagsQueryVariables = Exact<{
  filter?: InputMaybe<TagFilter>
}>

export type PartnerListCustomerTagsQuery = {
  __typename: 'Query'
  PartnerListCustomerTags?: Array<{
    __typename: 'CustomerTag'
    ID: string
    name: string
    description?: string | null
    color?: TagColor | null
    customerIDs: Array<string>
    type?: TagType | null
  }> | null
}

export type PartnerCreateCustomerTagMutationVariables = Exact<{
  input: PartnerCreateCustomerTagInput
}>

export type PartnerCreateCustomerTagMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomerTag: string
}

export type PartnerCustomerWithInvoicesDataConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerFilter>
  orderBy?: InputMaybe<CustomerOrderBy>
}>

export type PartnerCustomerWithInvoicesDataConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: {
        __typename: 'Customer'
        tagIDs?: Array<string> | null
        legalName?: string | null
        ein?: string | null
        createdAt: string
        isOnboarded: boolean
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
        outstandingInvoicesData?: {
          __typename: 'CustomerOutstandingInvoicesData'
          outstandingInvoicesCount?: number | null
          outstandingInvoicesTotal?: number | null
          longestDaysOverdue?: string | null
        } | null
        defaultPaymentMethod?: {
          __typename: 'CustomerDefaultPaymentMethod'
          methodID: string
          method: TransferPaymentMethodInputEnum
          institution?: {
            __typename: 'Institution'
            id: string
            externalId?: string | null
            name?: string | null
            url?: string | null
            logo?: string | null
            accounts?: Array<{
              __typename: 'Account'
              id: string
              mask?: string | null
              name?: string | null
              type?: string | null
              subtype?: string | null
              hasAchAccountNumber?: boolean | null
              hasAchRoutingNumber?: boolean | null
              hasWireRoutingNumber?: boolean | null
              transitNumber?: string | null
              customName?: string | null
              provider?: string | null
              disconnectedAt?: string | null
              systemDeactivatedAt?: string | null
              companyName?: string | null
              institution?: {
                __typename: 'Institution'
                name?: string | null
                id: string
                logo?: string | null
              } | null
              mandates?: Array<{
                __typename: 'Mandate'
                id: string
                consentAt: string
                version: string
              } | null> | null
            } | null> | null
          } | null
          card?: {
            __typename: 'Card'
            id: string
            last4: string
            expirationDate: string
            cardNetWork: CardNetwork
            fundingSource: FundingSource
            customName?: string | null
            hasPostalCode: boolean
            isExpired: boolean
            billingAddress?: {
              __typename: 'Address'
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              state?: string | null
              stateCode?: string | null
              postalCode?: string | null
              country?: string | null
              countryISO?: string | null
            } | null
          } | null
        } | null
        partner?: {
          __typename: 'Partner'
          id: string
          paymentsPortalUrl?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerWithCustomerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerFilter>
  orderBy?: InputMaybe<CustomerOrderBy>
}>

export type PartnerCustomerWithCustomerUserConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: {
        __typename: 'Customer'
        id: string
        name?: string | null
        customerUsers?: Array<{
          __typename: 'CustomerUser'
          id: string
          email: string
        }> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasPreviousPage: boolean
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerFilter>
  orderBy?: InputMaybe<CustomerOrderBy>
}>

export type PartnerCustomerConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: {
        __typename: 'Customer'
        legalName?: string | null
        ein?: string | null
        createdAt: string
        isOnboarded: boolean
        tagIDs?: Array<string> | null
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
        partner?: {
          __typename: 'Partner'
          id: string
          paymentsPortalUrl?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasPreviousPage: boolean
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerConnectionWithRelationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerFilter>
  orderBy?: InputMaybe<CustomerOrderBy>
}>

export type PartnerCustomerConnectionWithRelationsQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: {
        __typename: 'Customer'
        legalName?: string | null
        ein?: string | null
        createdAt: string
        isOnboarded: boolean
        tagIDs?: Array<string> | null
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
        relations: Array<{
          __typename: 'AccountingCustomerRelation'
          platformName: PlatformName
          externalID: string
        }>
        partner?: {
          __typename: 'Partner'
          id: string
          paymentsPortalUrl?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasPreviousPage: boolean
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerListCustomersTotalsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>
}>

export type PartnerListCustomersTotalsQuery = {
  __typename: 'Query'
  PartnerListCustomersTotals?: {
    __typename: 'PartnerCustomerTotals'
    count: number
  } | null
}

export type PartnerListCustomersV2QueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  filters?: InputMaybe<PartnerListCustomersFilter>
  order?: InputMaybe<PartnerListCustomersOrder>
}>

export type PartnerListCustomersV2Query = {
  __typename: 'Query'
  PartnerListCustomers: {
    __typename: 'PartnerListCustomersPage'
    customers: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      ein?: string | null
      industry?: string | null
      companyType?: string | null
      description?: string | null
      isOnboarded: boolean
      country?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      isArchived: boolean
      tagIDs?: Array<string> | null
      createdAt: string
      owed?: number | null
      paidLast30Days?: number | null
    }>
    pagination: {
      __typename: 'ArPagination'
      page: number
      pageSize: number
      totalItems: number
      totalPages: number
    }
    summary: { __typename: 'PartnerListCustomersSummary'; totalItems: number }
  }
}

export type PartnerGetCustomerV2QueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetCustomerV2Query = {
  __typename: 'Query'
  PartnerGetCustomer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    ein?: string | null
    industry?: string | null
    companyType?: string | null
    description?: string | null
    isOnboarded: boolean
    country?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    isArchived: boolean
    tagIDs?: Array<string> | null
    createdAt: string
    owed?: number | null
    paidLast30Days?: number | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type CustomerV2FieldsFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
  legalName?: string | null
  ein?: string | null
  industry?: string | null
  companyType?: string | null
  description?: string | null
  isOnboarded: boolean
  country?: string | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  isArchived: boolean
  tagIDs?: Array<string> | null
  createdAt: string
  owed?: number | null
  paidLast30Days?: number | null
}

export type PartnerGetCustomerSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetCustomerSummaryQuery = {
  __typename: 'Query'
  PartnerGetCustomerSummary?: {
    __typename: 'CustomerSummary'
    invoiceCount: number
    autopayInvoiceCount: number
    hasPaymentMethod: boolean
  } | null
}

export type PartnerGetCustomersSummaryQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetCustomersSummaryQuery = {
  __typename: 'Query'
  PartnerGetCustomersSummary: {
    __typename: 'CustomersSummary'
    customersWithNonAutopayInvoices: number
    customers60PlusOverdue: number
    customersWithoutPaymentMethod: number
  }
}

export type PartnerCustomerSearchQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  after?: InputMaybe<Scalars['Cursor']['input']>
}>

export type PartnerCustomerSearchQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: { __typename: 'Customer'; id: string; name?: string | null } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerArchiveCustomerMutationVariables = Exact<{
  input: PartnerArchiveCustomerInput
}>

export type PartnerArchiveCustomerMutation = {
  __typename: 'Mutation'
  PartnerArchiveCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type PartnerUnarchiveCustomerMutationVariables = Exact<{
  input: PartnerUnarchiveCustomerInput
}>

export type PartnerUnarchiveCustomerMutation = {
  __typename: 'Mutation'
  PartnerUnarchiveCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type PartnerCreateCustomerMutationVariables = Exact<{
  input?: InputMaybe<PartnerCreateCustomerInput>
}>

export type PartnerCreateCustomerMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type UpdateCustomerMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateCustomerInput>
}>

export type UpdateCustomerMutation = {
  __typename: 'Mutation'
  PartnerUpdateCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type PartnerCustomerAddressFragment = {
  __typename: 'Customer'
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
}

export type PartnerCustomerBasicFragment = {
  __typename: 'Customer'
  createdAt: string
  id: string
  name?: string | null
  legalName?: string | null
  isOnboarded: boolean
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
}

export type PartnerCustomerFragment = {
  __typename: 'Customer'
  ein?: string | null
  companyType?: string | null
  industry?: string | null
  description?: string | null
  isArchived: boolean
  archivedBy?: string | null
  createdAt: string
  id: string
  name?: string | null
  legalName?: string | null
  isOnboarded: boolean
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
}

export type PartnerCustomerListWithInvoicesDataFragment = {
  __typename: 'Customer'
  tagIDs?: Array<string> | null
  legalName?: string | null
  ein?: string | null
  createdAt: string
  isOnboarded: boolean
  id: string
  name?: string | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
  outstandingInvoicesData?: {
    __typename: 'CustomerOutstandingInvoicesData'
    outstandingInvoicesCount?: number | null
    outstandingInvoicesTotal?: number | null
    longestDaysOverdue?: string | null
  } | null
  defaultPaymentMethod?: {
    __typename: 'CustomerDefaultPaymentMethod'
    methodID: string
    method: TransferPaymentMethodInputEnum
    institution?: {
      __typename: 'Institution'
      id: string
      externalId?: string | null
      name?: string | null
      url?: string | null
      logo?: string | null
      accounts?: Array<{
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        type?: string | null
        subtype?: string | null
        hasAchAccountNumber?: boolean | null
        hasAchRoutingNumber?: boolean | null
        hasWireRoutingNumber?: boolean | null
        transitNumber?: string | null
        customName?: string | null
        provider?: string | null
        disconnectedAt?: string | null
        systemDeactivatedAt?: string | null
        companyName?: string | null
        institution?: {
          __typename: 'Institution'
          name?: string | null
          id: string
          logo?: string | null
        } | null
        mandates?: Array<{
          __typename: 'Mandate'
          id: string
          consentAt: string
          version: string
        } | null> | null
      } | null> | null
    } | null
    card?: {
      __typename: 'Card'
      id: string
      last4: string
      expirationDate: string
      cardNetWork: CardNetwork
      fundingSource: FundingSource
      customName?: string | null
      hasPostalCode: boolean
      isExpired: boolean
      billingAddress?: {
        __typename: 'Address'
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        state?: string | null
        stateCode?: string | null
        postalCode?: string | null
        country?: string | null
        countryISO?: string | null
      } | null
    } | null
  } | null
  partner?: {
    __typename: 'Partner'
    id: string
    paymentsPortalUrl?: string | null
  } | null
}

export type CustomerWithCustomerUserListFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
  customerUsers?: Array<{
    __typename: 'CustomerUser'
    id: string
    email: string
  }> | null
}

export type PartnerCustomerListFragment = {
  __typename: 'Customer'
  legalName?: string | null
  ein?: string | null
  createdAt: string
  isOnboarded: boolean
  tagIDs?: Array<string> | null
  id: string
  name?: string | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
  partner?: {
    __typename: 'Partner'
    id: string
    paymentsPortalUrl?: string | null
  } | null
}

export type PartnerCustomerSearchFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
}

export type PartnerBulkToggleArchiveCustomersMutationVariables = Exact<{
  input: BulkToggleArchiveCustomersInput
}>

export type PartnerBulkToggleArchiveCustomersMutation = {
  __typename: 'Mutation'
  PartnerBulkToggleArchiveCustomers: string
}

export type PartnerCustomerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerUserFilter>
  orderBy?: InputMaybe<CustomerUserOrderBy>
}>

export type PartnerCustomerUserConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerUserConnection?: {
    __typename: 'CustomerUserConnection'
    edges?: Array<{
      __typename: 'CustomerUserEdge'
      node?: {
        __typename: 'CustomerUser'
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
        approvedBy?: string | null
        createdAt: string
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerArchiveCustomerAccountMutationVariables = Exact<{
  accountID: Scalars['ID']['input']
  customerID: Scalars['ID']['input']
}>

export type PartnerArchiveCustomerAccountMutation = {
  __typename: 'Mutation'
  PartnerArchiveCustomerAccount: string
}

export type PartnerCreateCustomerUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerCreateCustomerUserInput>
}>

export type PartnerCreateCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomerUser?: {
    __typename: 'CustomerUser'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type PartnerDeleteCustomerUserMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type PartnerDeleteCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerDeleteCustomerUser?: string | null
}

export type UpdateCustomerUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateCustomerUserInput>
}>

export type UpdateCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerUpdateCustomerUser?: {
    __typename: 'CustomerUser'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    approvedBy?: string | null
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerListCustomerUsersFragment = {
  __typename: 'CustomerUser'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  approvedBy?: string | null
  createdAt: string
  customer?: { __typename: 'Customer'; id: string; name?: string | null } | null
}

export type PartnerCustomerUserCreationFragment = {
  __typename: 'CustomerUser'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export type PartnerCreateEmailTemplateMutationVariables = Exact<{
  input: CreateEmailTemplateInput
}>

export type PartnerCreateEmailTemplateMutation = {
  __typename: 'Mutation'
  PartnerCreateEmailTemplate: {
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  }
}

export type PartnerUpdateEmailTemplateMutationVariables = Exact<{
  input: UpdateEmailTemplateInput
}>

export type PartnerUpdateEmailTemplateMutation = {
  __typename: 'Mutation'
  PartnerUpdateEmailTemplate: string
}

export type PartnerDeleteEmailTemplateMutationVariables = Exact<{
  input: DeleteEmailTemplateInput
}>

export type PartnerDeleteEmailTemplateMutation = {
  __typename: 'Mutation'
  PartnerDeleteEmailTemplate: string
}

export type PartnerToggleEmailTemplateFavoriteMutationVariables = Exact<{
  templateID: Scalars['ID']['input']
}>

export type PartnerToggleEmailTemplateFavoriteMutation = {
  __typename: 'Mutation'
  PartnerToggleEmailTemplateFavorite: string
}

export type PartnerEmailActivityConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<EmailActivityFilter>
}>

export type PartnerEmailActivityConnectionQuery = {
  __typename: 'Query'
  PartnerEmailActivityConnection?: {
    __typename: 'EmailActivityConnection'
    edges: Array<{
      __typename: 'EmailActivityEdge'
      node: {
        __typename: 'EmailActivity'
        sentAt: string
        user: string
        subject: string
        status?: EmailStatus | null
        invoice?: {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
        } | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      }
    }>
    pageInfo: {
      __typename: 'PageInfo'
      endCursor?: any | null
      hasNextPage: boolean
    }
  } | null
}

export type PartnerListEmailTemplatesQueryVariables = Exact<{
  templateType: TemplateType
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>
  templateID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerListEmailTemplatesQuery = {
  __typename: 'Query'
  PartnerListEmailTemplates?: Array<{
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  }> | null
}

export type PartnerEmailActivityFragment = {
  __typename: 'EmailActivity'
  sentAt: string
  user: string
  subject: string
  status?: EmailStatus | null
  invoice?: { __typename: 'Invoice'; id: string; invoiceNumber: string } | null
  customer?: { __typename: 'Customer'; id: string; name?: string | null } | null
}

export type EmailTemplateFragment = {
  __typename: 'EmailTemplate'
  id: string
  partnerID: string
  name: string
  subject: string
  section1?: string | null
  section2?: string | null
  section3?: string | null
  type: TemplateType
  favorite?: boolean | null
}

export type PartnerGetPartnerFeeConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetPartnerFeeConfigQuery = {
  __typename: 'Query'
  PartnerGetPartnerFeeConfig?: {
    __typename: 'PartnerFeeConfig'
    coverDirectPaymentFees: boolean
    coverFeeConfig?: {
      __typename: 'CoverFeeConfig'
      coverCardMethodFee?: boolean | null
    } | null
  } | null
}

export type PartnerGetCustomPartnerFeeConfigsQueryVariables = Exact<{
  customPartnerFeeConfigsFilter?: InputMaybe<CustomPartnerFeeConfigsFilter>
}>

export type PartnerGetCustomPartnerFeeConfigsQuery = {
  __typename: 'Query'
  PartnerGetCustomPartnerFeeConfigs?: {
    __typename: 'CustomPartnerFeeConfigs'
    customPartnerFeeConfigs?: Array<{
      __typename: 'CustomPartnerFeeConfig'
      paymentOriginService: PaymentAlternativeService
      paymentExecutorType: PaymentExecutorType
      coverFeeConfig?: {
        __typename: 'CoverFeeConfig'
        coverACHMethodFee?: boolean | null
        coverCardMethodFee?: boolean | null
        coverWireMethodFee?: boolean | null
        coverOtherMethodFee?: boolean | null
      } | null
    }> | null
  } | null
}

export type PartnerListCustomerFeeExceptionsQueryVariables = Exact<{
  input?: InputMaybe<PartnerListCustomerFeeExceptionsInput>
}>

export type PartnerListCustomerFeeExceptionsQuery = {
  __typename: 'Query'
  PartnerListCustomerFeeExceptions?: Array<{
    __typename: 'CustomerFeeConfig'
    id: any
    feeType: FeeExceptionType
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  }> | null
}

export type PartnerChangeCustomPartnerFeeConfigMutationVariables = Exact<{
  customPartnerFeeConfig: CustomPartnerFeeConfigUpsertInput
}>

export type PartnerChangeCustomPartnerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeCustomPartnerFeeConfig?: string | null
}

export type PartnerChangeCustomerFeeConfigMutationVariables = Exact<{
  customerFeeConfig: PartnerChangeCustomerFeeConfigInput
}>

export type PartnerChangeCustomerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeCustomerFeeConfig?: string | null
}

export type PartnerChangePartnerFeeConfigMutationVariables = Exact<{
  partnerFeeConfig: PartnerFeeConfigUpdateInput
}>

export type PartnerChangePartnerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangePartnerFeeConfig?: string | null
}

export type PartnerChangeBulkCustomerFeeConfigMutationVariables = Exact<{
  customerFeeConfig: PartnerChangeBulkCustomerFeeConfigInput
}>

export type PartnerChangeBulkCustomerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeBulkCustomerFeeConfig?: string | null
}

export type PartnerGetPassThroughFeesQueryVariables = Exact<{
  methodNetworks?: InputMaybe<Array<MethodNetwork> | MethodNetwork>
}>

export type PartnerGetPassThroughFeesQuery = {
  __typename: 'Query'
  PartnerGetPassThroughFees?: Array<{
    __typename: 'PassThroughFee'
    customerID?: string | null
    methodNetwork: MethodNetwork
    fixedFeeForwarded: boolean
    percent: number
  }> | null
}

export type PartnerUpsertPassThroughFeesMutationVariables = Exact<{
  input: PartnerUpsertPassThroughFeesInput
}>

export type PartnerUpsertPassThroughFeesMutation = {
  __typename: 'Mutation'
  PartnerUpsertPassThroughFees?: string | null
}

export type PartnerGetAdminCardFeesConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetAdminCardFeesConfigQuery = {
  __typename: 'Query'
  PartnerGetAdminCardFeesConfig?: Array<{
    __typename: 'PartnerCardFeeDetail'
    cardNetwork: CardNetwork
    percentage: number
  }> | null
}

export type PartnerCustomerFeeConfigFragment = {
  __typename: 'CustomerFeeConfig'
  id: any
  feeType: FeeExceptionType
  customer: { __typename: 'Customer'; id: string; name?: string | null }
}

export type GetCustomerInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  customerID: Scalars['String']['input']
}>

export type GetCustomerInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceAmountByStatusMonthCustomerInsight?: {
    __typename: 'InvoiceAmountByStatusMonthResponse'
    average: number
    data: Array<{
      __typename: 'InvoiceAmountMonth'
      month: string
      data: Array<{
        __typename: 'InvoiceAmountMonthStatus'
        status: string
        value: number
      }>
    }>
  } | null
  PartnerGetAverageTimeToPayByMonthCustomerInsight?: {
    __typename: 'AverageTimeToPayByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetPaymentVolumeByMonthCustomerInsight?: {
    __typename: 'PaymentVolumeByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsight?: {
    __typename: 'AutomatedPaymentVolumePercentByMonthResponse'
    average: number
    data: Array<{
      __typename: 'AutomatedPaymentVolumePercentMonth'
      month: string
      percent: number
    }>
  } | null
}

export type GetCustomerInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  customerID: Scalars['String']['input']
}>

export type GetCustomerInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetPaymentVolumeCustomerInsight?: {
    __typename: 'PaymentVolumeResponse'
    value: number
  } | null
  PartnerGetNumberOfPaymentsCustomerInsight?: {
    __typename: 'NumberOfPaymentsResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayCustomerInsight?: {
    __typename: 'AverageTimeToPayResponse'
    value: number
  } | null
  PartnerGetAutomatedPaymentsCustomerInsight?: {
    __typename: 'AutomatedPaymentsResponse'
    value: number
  } | null
  PartnerGetInvoiceVolumeCustomerInsight?: {
    __typename: 'InvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsight?: {
    __typename: 'OverdueInvoicesVolumeThirtyDaysResponse'
    value: number
  } | null
}

export type GetInsightOverviewMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInsightOverviewMetricsQuery = {
  __typename: 'Query'
  PartnerGetPaymentVolumeInsight?: {
    __typename: 'PaymentVolumeResponse'
    value: number
  } | null
  PartnerGetNumberOfPaymentsInsight?: {
    __typename: 'NumberOfPaymentsResponse'
    value: number
  } | null
  PartnerGetAutomatedPaymentsInsight?: {
    __typename: 'AutomatedPaymentsResponse'
    value: number
  } | null
  PartnerGetNumberOfOverdueInvoicesThirtyDaysInsight?: {
    __typename: 'NumberOfOverdueInvoicesThirtyDaysResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicesVolumeThirtyDaysInsight?: {
    __typename: 'OverdueInvoicesVolumeThirtyDaysResponse'
    value: number
  } | null
  PartnerGetOverdueInvoiceVolumeInsight?: {
    __typename: 'OverdueInvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicePercentageInsight?: {
    __typename: 'OverdueInvoicePercentageResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayInsight?: {
    __typename: 'AverageTimeToPayResponse'
    value: number
  } | null
}

export type GetOverdueRateCohortQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  prevDateFrom: Scalars['String']['input']
  prevDateTo: Scalars['String']['input']
}>

export type GetOverdueRateCohortQuery = {
  __typename: 'Query'
  current?: {
    __typename: 'OverdueRateAtMaturityResponse'
    value: number
    maturedCount: number
  } | null
  previous?: {
    __typename: 'OverdueRateAtMaturityResponse'
    value: number
    maturedCount: number
  } | null
}

export type GetCollectionsTimeComparisonQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  prevDateFrom: Scalars['String']['input']
  prevDateTo: Scalars['String']['input']
}>

export type GetCollectionsTimeComparisonQuery = {
  __typename: 'Query'
  current?: { __typename: 'AverageTimeToPayResponse'; value: number } | null
  previous?: { __typename: 'AverageTimeToPayResponse'; value: number } | null
}

export type GetInsightOverviewGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInsightOverviewGraphsQuery = {
  __typename: 'Query'
  PartnerGetAverageTimeToPayByMonthInsight?: {
    __typename: 'AverageTimeToPayByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetPaymentVolumeByMonthInsight?: {
    __typename: 'PaymentVolumeByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAutomatedPaymentsByMonthInsight?: {
    __typename: 'AutomatedPaymentsByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetActivationRatesByMonthInsight?: {
    __typename: 'ActivationRatesByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
}

export type GetInvoicesInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceVolumeInsight?: {
    __typename: 'InvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetInvoiceCountInsight?: {
    __typename: 'InvoiceCountResponse'
    value: number
  } | null
  PartnerGetAverageInvoiceAmountInsight?: {
    __typename: 'AverageInvoiceAmountResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicePercentageInsight?: {
    __typename: 'OverdueInvoicePercentageResponse'
    value: number
  } | null
}

export type GetInvoicesInsightsArMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsArMetricsQuery = {
  __typename: 'Query'
  PartnerGetOverdueInvoiceVolumeInsight?: {
    __typename: 'OverdueInvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetOverdueInvoiceCountInsight?: {
    __typename: 'OverdueInvoiceCountResponse'
    value: number
  } | null
  PartnerGetAverageOverdueAmountInsight?: {
    __typename: 'AverageOverdueAmountResponse'
    value: number
  } | null
  PartnerGetAverageDaysOverdueInsight?: {
    __typename: 'AverageDaysOverdueResponse'
    value: number
  } | null
}

export type GetInvoicesInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceAmountByStatusMonthInsight?: {
    __typename: 'InvoiceAmountByStatusMonthResponse'
    average: number
    data: Array<{
      __typename: 'InvoiceAmountMonth'
      month: string
      data: Array<{
        __typename: 'InvoiceAmountMonthStatus'
        status: string
        value: number
      }>
    }>
  } | null
  PartnerGetInvoiceCountByStatusMonthInsight?: {
    __typename: 'InvoiceCountByStatusMonthResponse'
    average: number
    data: Array<{
      __typename: 'InvoiceCountMonth'
      month: string
      data: Array<{
        __typename: 'InvoiceCountMonthStatus'
        status: string
        count: number
      }>
    }>
  } | null
}

export type GetInvoicesInsightsArGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsArGraphsQuery = {
  __typename: 'Query'
  PartnerGetARAgingBucketsAmountInsight?: {
    __typename: 'ARAgingBucketsAmountResponse'
    data: Array<{
      __typename: 'BucketAmountData'
      bucket: string
      value: number
    }>
  } | null
  PartnerGetARAgingBucketsCountInsight?: {
    __typename: 'ARAgingBucketsCountResponse'
    data: Array<{
      __typename: 'BucketCountData'
      bucket: string
      value: number
    }>
  } | null
}

export type GetPaymentsInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetPaymentsInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetPaymentVolumeInsight?: {
    __typename: 'PaymentVolumeResponse'
    value: number
  } | null
  PartnerGetNumberOfPaymentsInsight?: {
    __typename: 'NumberOfPaymentsResponse'
    value: number
  } | null
  PartnerGetAveragePaymentSizeInsight?: {
    __typename: 'AveragePaymentSizeResponse'
    value: number
  } | null
}

export type GetPaymentsInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetPaymentsInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetPaymentsCountByMethodMonthInsight?: {
    __typename: 'PaymentsCountByMethodMonthResponse'
    average: number
    data: Array<{
      __typename: 'PaymentsCountByMethodMonthData'
      month: string
      method: string
      count: number
    }>
  } | null
  PartnerGetPaymentsVolumeByMethodMonthInsight?: {
    __typename: 'PaymentsVolumeByMethodMonthResponse'
    average: number
    data: Array<{
      __typename: 'PaymentsVolumeByMethodMonthData'
      month: string
      method: string
      volume: number
    }>
  } | null
  PartnerGetActivationRatesByMonthInsight?: {
    __typename: 'ActivationRatesByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetActivationRateInvoiceVolumeByMonthInsight?: {
    __typename: 'ActivationRateInvoiceVolumeByMonthResponse'
    average: number
    data: Array<{
      __typename: 'ActivationRateInvoiceVolumeByMonthData'
      month: string
      value: number
    }>
  } | null
}

export type GetCollectionsInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetCollectionsInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetAverageTimeToPayExternalInsight?: {
    __typename: 'AverageTimeToPayExternalResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayInsight?: {
    __typename: 'AverageTimeToPayResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayAutopayInsight?: {
    __typename: 'AverageTimeToPayAutopayResponse'
    value: number
  } | null
}

export type GetCollectionsInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  cashFlowGranularity?: InputMaybe<Granularity>
}>

export type GetCollectionsInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetCashFlowDistributionInsight?: {
    __typename: 'CashFlowDistributionResponse'
    data: Array<{
      __typename: 'CashFlowDistributionData'
      date: string
      value: number
      isInternal: boolean
    }>
  } | null
  PartnerGetAverageTimeToPayExternalVsInternalByMonthInsight?: {
    __typename: 'AverageTimeToPayExternalVsInternalByMonthResponse'
    internalAvg: number
    externalAvg: number
    data: Array<{
      __typename: 'AverageTimeToPayExternalVsInternalByMonthData'
      month: string
      average: number
      isInternal: boolean
    }>
  } | null
}

export type GetAutomationsInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetAutomationsInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetAutomatedPaymentsInsight?: {
    __typename: 'AutomatedPaymentsResponse'
    value: number
  } | null
  PartnerGetAutomatedPaymentVolumePercentageInsight?: {
    __typename: 'AutomatedPaymentVolumePercentageResponse'
    value: number
  } | null
  PartnerGetAutomatedTransactionCountInsight?: {
    __typename: 'AutomatedTransactionCountResponse'
    count: number
  } | null
  PartnerGetPaymentVolumeAutomatedInsight?: {
    __typename: 'PaymentVolumeAutomatedResponse'
    value: number
  } | null
}

export type GetAutomationsInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetAutomationsInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetAutomatedPaymentsByMonthInsight?: {
    __typename: 'AutomatedPaymentsByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAutomatedPaymentVolumePercentByMonthInsight?: {
    __typename: 'AutomatedPaymentVolumePercentByMonthResponse'
    average: number
    data: Array<{
      __typename: 'AutomatedPaymentVolumePercentMonth'
      month: string
      percent: number
    }>
  } | null
}

export type GetAutomationsLastMonthInsightsGraphsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAutomationsLastMonthInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetPaymentCountByTriggerLastMonthInsight?: {
    __typename: 'PaymentCountByTriggerLastMonthResponse'
    data: Array<{
      __typename: 'PaymentCountByTrigger'
      trigger: string
      count: number
    }>
  } | null
  PartnerGetPaymentVolumeByTriggerLastMonthInsight?: {
    __typename: 'PaymentVolumeByTriggerLastMonthResponse'
    data: Array<{
      __typename: 'PaymentVolumeByTrigger'
      trigger: string
      volume: number
    }>
  } | null
}

export type BucketCountDataFragment = {
  __typename: 'BucketCountData'
  bucket: string
  value: number
}

export type BucketAmountDataFragment = {
  __typename: 'BucketAmountData'
  bucket: string
  value: number
}

export type DataPointFragment = {
  __typename: 'DataPoint'
  month: string
  value: number
}

export type InvoiceCountMonthFragment = {
  __typename: 'InvoiceCountMonth'
  month: string
  data: Array<{
    __typename: 'InvoiceCountMonthStatus'
    status: string
    count: number
  }>
}

export type InvoiceAmountMonthFragment = {
  __typename: 'InvoiceAmountMonth'
  month: string
  data: Array<{
    __typename: 'InvoiceAmountMonthStatus'
    status: string
    value: number
  }>
}

export type PartnerAutotaskConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<PartnerAutotaskConnectionCreateInput>
}>

export type PartnerAutotaskConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerAutotaskConnectionCreate?: {
    __typename: 'AutotaskQueryFilters'
    companyTypes: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyClassifications: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyTerritoryIDs: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
    contactUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
  } | null
}

export type PartnerAutotaskConnectionUpdateMutationVariables = Exact<{
  input?: InputMaybe<PartnerAutotaskConnectionUpdateInput>
}>

export type PartnerAutotaskConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerAutotaskConnectionUpdate?: string | null
}

export type PartnerAutotaskGetFiltersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerAutotaskGetFiltersQuery = {
  __typename: 'Query'
  PartnerAutotaskGetFilters?: {
    __typename: 'AutotaskQueryFilters'
    companyTypes: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyClassifications: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyTerritoryIDs: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
    contactUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
  } | null
}

export type PartnerContractTypeConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractTypeOrderBy>
  filter?: InputMaybe<ContractTypeFilter>
}>

export type PartnerContractTypeConnectionQuery = {
  __typename: 'Query'
  PartnerContractTypeConnection: {
    __typename: 'ContractTypeConnection'
    edges?: Array<{
      __typename: 'ContractTypeEdge'
      node?: {
        __typename: 'AutotaskContractType'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerAutotaskContractConnectionQueryVariables = Exact<{
  filter?: InputMaybe<AutotaskContractFilter>
}>

export type PartnerAutotaskContractConnectionQuery = {
  __typename: 'Query'
  PartnerAutotaskContractConnection: {
    __typename: 'AutotaskContractConnection'
    contracts?: Array<string> | null
  }
}

export type PartnerAutotaskGetConnectionQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerAutotaskGetConnectionQuery = {
  __typename: 'Query'
  PartnerAutotaskGetConnection: {
    __typename: 'AutotaskConnection'
    filters: {
      __typename: 'AutotaskConnectionFilters'
      companyFilters: {
        __typename: 'AutotaskConnectionCompanyFilters'
        types?: Array<string> | null
        classifications?: Array<string> | null
        territories?: Array<string> | null
        udf?: {
          __typename: 'AutotaskUserDefinedField'
          name?: string | null
          type?: string | null
          isPickList?: boolean | null
          inputs?: Array<string> | null
          picklistValues: Array<{
            __typename: 'AutotaskField'
            id?: string | null
            name?: string | null
          }>
        } | null
      }
      contactFilters: {
        __typename: 'AutotaskConnectionContactFilters'
        udf?: {
          __typename: 'AutotaskUserDefinedField'
          name?: string | null
          type?: string | null
          isPickList?: boolean | null
          inputs?: Array<string> | null
          picklistValues: Array<{
            __typename: 'AutotaskField'
            id?: string | null
            name?: string | null
          }>
        } | null
      }
      invoiceFilters: {
        __typename: 'AutotaskConnectionInvoiceFilters'
        invoiceCreatedSince?: string | null
      }
    }
  }
}

export type PartnerConnectWiseConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<PartnerConnectWiseConnectionCreateInput>
}>

export type PartnerConnectWiseConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerConnectWiseConnectionCreate?: {
    __typename: 'ConnectWiseQueryFilters'
    invoiceFilters: {
      __typename: 'ConnectWiseFilters'
      createdSince?: string | null
      locations?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
    customerFilters: {
      __typename: 'ConnectWiseFilters'
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      territories?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      types?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
  } | null
}

export type PartnerConnectWiseConnectionUpdateMutationVariables = Exact<{
  input?: InputMaybe<ConnectWiseQueryFiltersInput>
}>

export type PartnerConnectWiseConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerConnectWiseConnectionUpdate?: string | null
}

export type PartnerConnectWiseGetConnectionQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerConnectWiseGetConnectionQuery = {
  __typename: 'Query'
  PartnerConnectWiseGetConnection?: {
    __typename: 'ConnectWiseConnection'
    partnerID: string
    queryFilters: {
      __typename: 'ConnectWiseQueryFilters'
      invoiceFilters: {
        __typename: 'ConnectWiseFilters'
        createdSince?: string | null
        locations?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
        status?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
      }
      customerFilters: {
        __typename: 'ConnectWiseFilters'
        status?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
        territories?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
        types?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
      }
    }
  } | null
}

export type PartnerConnectWiseGetFiltersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerConnectWiseGetFiltersQuery = {
  __typename: 'Query'
  PartnerConnectWiseGetFilters?: {
    __typename: 'ConnectWiseQueryFilters'
    invoiceFilters: {
      __typename: 'ConnectWiseFilters'
      createdSince?: string | null
      locations?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
    customerFilters: {
      __typename: 'ConnectWiseFilters'
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      territories?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      types?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
  } | null
}

export type CwQueryFiltersFragment = {
  __typename: 'ConnectWiseQueryFilters'
  invoiceFilters: {
    __typename: 'ConnectWiseFilters'
    createdSince?: string | null
    locations?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
    status?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
  }
  customerFilters: {
    __typename: 'ConnectWiseFilters'
    status?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
    territories?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
    types?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
  }
}

export type PartnerAgreementTypeConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AgreementTypeOrderBy>
  filter?: InputMaybe<AgreementTypeFilter>
}>

export type PartnerAgreementTypeConnectionQuery = {
  __typename: 'Query'
  PartnerAgreementTypeConnection: {
    __typename: 'AgreementTypeConnection'
    edges?: Array<{
      __typename: 'AgreementTypeEdge'
      node?: {
        __typename: 'ConnectwiseAgreementType'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerConnectWiseBillingTermsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CwBillingTermsOrderBy>
  filter?: InputMaybe<CwBillingTermsFilter>
}>

export type PartnerConnectWiseBillingTermsConnectionQuery = {
  __typename: 'Query'
  PartnerConnectWiseBillingTermsConnection?: {
    __typename: 'ConnectWiseBillingTermsConnection'
    edges?: Array<{
      __typename: 'ConnectWiseBillingTermsEdge'
      node?: {
        __typename: 'ConnectwiseBillingTerms'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerConnectWiseAgreementConnectionQueryVariables = Exact<{
  filter?: InputMaybe<ConnectWiseAgreementFilter>
}>

export type PartnerConnectWiseAgreementConnectionQuery = {
  __typename: 'Query'
  PartnerConnectWiseAgreementConnection: {
    __typename: 'ConnectWiseAgreementConnection'
    agreements?: Array<string> | null
  }
}

export type PartnerConnectWiseTaxCodeGetQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerConnectWiseTaxCodeGetQuery = {
  __typename: 'Query'
  PartnerConnectWiseTaxCodeGet: Array<{
    __typename: 'ConnectWiseTaxCode'
    id: string
    identifier: string
  }>
}

export type PartnerConnectWiseGlSegmentsGetQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerConnectWiseGlSegmentsGetQuery = {
  __typename: 'Query'
  PartnerConnectWiseGlSegmentsGet: Array<{
    __typename: 'ConnectWiseGlSegment'
    position: number
    label: string
  }>
}

export type PartnerDatagateConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<DatagateConnectionCreateInput>
}>

export type PartnerDatagateConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerDatagateConnectionCreate?: string | null
}

export type PartnerHaloPsaConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<PartnerHaloPsaConnectionCreateInput>
}>

export type PartnerHaloPsaConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerHaloPSAConnectionCreate?: {
    __typename: 'PartnerHaloPSAConnectionCreateReply'
    success: boolean
    errorMessage?: string | null
  } | null
}

export type HaloQueryFiltersFragment = {
  __typename: 'HaloPSAConnectionQueryFilters'
  customerFilters?: {
    __typename: 'HaloPSACustomerFilters'
    topLevels?: Array<{
      __typename: 'HaloPSAFilterValue'
      id: string
      name: string
    }> | null
  } | null
  invoiceFilters?: {
    __typename: 'HaloPSAInvoiceFilters'
    createdSince?: string | null
  } | null
}

export type PartnerHaloPsaTopLevelListQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerHaloPsaTopLevelListQuery = {
  __typename: 'Query'
  PartnerHaloPSATopLevelList: Array<{
    __typename: 'HaloPSATopLevel'
    id: string
    name: string
  }>
}

export type PartnerHaloPsaConnectionQueryFiltersUpdateMutationVariables =
  Exact<{
    input: HaloPsaConnectionQueryFiltersInput
  }>

export type PartnerHaloPsaConnectionQueryFiltersUpdateMutation = {
  __typename: 'Mutation'
  PartnerHaloPSAConnectionQueryFiltersUpdate: {
    __typename: 'PartnerHaloPSAConnectionQueryFiltersUpdateReply'
    success: boolean
  }
}

export type PartnerContractSubtypeConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractSubtypeOrderBy>
  filter?: InputMaybe<ContractSubtypeFilter>
}>

export type PartnerContractSubtypeConnectionQuery = {
  __typename: 'Query'
  PartnerContractSubtypeConnection: {
    __typename: 'ContractSubtypeConnection'
    edges?: Array<{
      __typename: 'ContractSubtypeEdge'
      node?: {
        __typename: 'HaloPSAContractSubtype'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerHaloPsaContractConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filter: HaloPsaContractFilter
}>

export type PartnerHaloPsaContractConnectionQuery = {
  __typename: 'Query'
  PartnerHaloPSAContractConnection: {
    __typename: 'HaloPSAContractConnection'
    edges?: Array<{
      __typename: 'HaloPSAContractEdge'
      node: { __typename: 'HaloPSAContract'; externalID: string; name: string }
    }> | null
  }
}

export type PartnerIntegrationIssueFragment = {
  __typename: 'IntegrationIssue'
  id: string
  entityType: IntegrationIssueEntityType
  entityName: string
  entityExternalId: string
  sourceIntegrationPlatform: string
  sourceIntegrationType: IntegrationType
  targetIntegrationPlatform?: string | null
  targetIntegrationType?: IntegrationType | null
  reason: IntegrationIssueReason
  reasonDescription: string
  detectedAt: string
  createdAt: string
}

export type PartnerIntegrationIssueConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  filters: IntegrationIssueFilter
}>

export type PartnerIntegrationIssueConnectionQuery = {
  __typename: 'Query'
  PartnerIntegrationIssueConnection: {
    __typename: 'IntegrationIssueConnection'
    totalCount: number
    edges?: Array<{
      __typename: 'IntegrationIssueEdge'
      cursor: any
      node: {
        __typename: 'IntegrationIssue'
        id: string
        entityType: IntegrationIssueEntityType
        entityName: string
        entityExternalId: string
        sourceIntegrationPlatform: string
        sourceIntegrationType: IntegrationType
        targetIntegrationPlatform?: string | null
        targetIntegrationType?: IntegrationType | null
        reason: IntegrationIssueReason
        reasonDescription: string
        detectedAt: string
        createdAt: string
      }
    }> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerIntegrationIssueCountsQueryVariables = Exact<{
  platformName: PlatformName
}>

export type PartnerIntegrationIssueCountsQuery = {
  __typename: 'Query'
  PartnerIntegrationIssueCounts: {
    __typename: 'IntegrationIssueCounts'
    invoiceCount: number
    customerCount: number
    totalCount: number
  }
}

export type PartnerRetryIntegrationIssueMutationVariables = Exact<{
  input: RetryIntegrationIssueInput
}>

export type PartnerRetryIntegrationIssueMutation = {
  __typename: 'Mutation'
  PartnerRetryIntegrationIssue: boolean
}

export type PartnerIntegrationJobFragment = {
  __typename: 'IntegrationJob'
  id: string
  createdAt: string
  updatedAt: string
  type: IntegrationJobType
  status: IntegrationJobStatus
  errorMessage?: string | null
  request?: string | null
  response?: string | null
  requestID?: string | null
  invoiceRelation?: {
    __typename: 'InvoiceRelation'
    invoiceNumber: string
    customer: {
      __typename: 'InvoiceRelationCustomer'
      id?: string | null
      name: string
    }
  } | null
  deposit?: {
    __typename: 'IntegrationJobDeposit'
    txnID?: string | null
  } | null
}

export type PartnerIntegrationJobConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters: IntegrationJobFilter
  order?: InputMaybe<IntegrationJobOrder>
}>

export type PartnerIntegrationJobConnectionQuery = {
  __typename: 'Query'
  PartnerIntegrationJobConnection: {
    __typename: 'IntegrationJobConnection'
    edges?: Array<{
      __typename: 'IntegrationJobEdge'
      cursor: any
      node: {
        __typename: 'IntegrationJob'
        id: string
        createdAt: string
        updatedAt: string
        type: IntegrationJobType
        status: IntegrationJobStatus
        errorMessage?: string | null
        request?: string | null
        response?: string | null
        requestID?: string | null
        invoiceRelation?: {
          __typename: 'InvoiceRelation'
          invoiceNumber: string
          customer: {
            __typename: 'InvoiceRelationCustomer'
            id?: string | null
            name: string
          }
        } | null
        deposit?: {
          __typename: 'IntegrationJobDeposit'
          txnID?: string | null
        } | null
      }
    }> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerJobRetryMutationVariables = Exact<{
  input: JobRetry
}>

export type PartnerJobRetryMutation = {
  __typename: 'Mutation'
  PartnerJobRetry: boolean
}

export type PartnerIntegrationJobQueueFragment = {
  __typename: 'IntegrationJobQueue'
  id: string
  createdAt: string
  updatedAt: string
  type: IntegrationJobQueueType
  status: IntegrationJobQueueStatus
  errorMessage?: string | null
  request?: string | null
  response?: string | null
  requestID?: string | null
  invoiceRelation?: {
    __typename: 'InvoiceRelation'
    invoiceNumber: string
    customer: {
      __typename: 'InvoiceRelationCustomer'
      id?: string | null
      name: string
    }
  } | null
  deposit?: {
    __typename: 'IntegrationJobDeposit'
    txnID?: string | null
  } | null
}

export type PartnerIntegrationJobQueueConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters: IntegrationJobQueueFilter
  order?: InputMaybe<IntegrationJobQueueOrder>
}>

export type PartnerIntegrationJobQueueConnectionQuery = {
  __typename: 'Query'
  PartnerIntegrationJobQueueConnection: {
    __typename: 'IntegrationJobQueueConnection'
    edges?: Array<{
      __typename: 'IntegrationJobQueueEdge'
      cursor: any
      node: {
        __typename: 'IntegrationJobQueue'
        id: string
        createdAt: string
        updatedAt: string
        type: IntegrationJobQueueType
        status: IntegrationJobQueueStatus
        errorMessage?: string | null
        request?: string | null
        response?: string | null
        requestID?: string | null
        invoiceRelation?: {
          __typename: 'InvoiceRelation'
          invoiceNumber: string
          customer: {
            __typename: 'InvoiceRelationCustomer'
            id?: string | null
            name: string
          }
        } | null
        deposit?: {
          __typename: 'IntegrationJobDeposit'
          txnID?: string | null
        } | null
      }
    }> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerJobQueueRetryMutationVariables = Exact<{
  input: JobQueueRetry
}>

export type PartnerJobQueueRetryMutation = {
  __typename: 'Mutation'
  PartnerJobQueueRetry: boolean
}

export type PartnerIntegrationJobFailureCountQueryVariables = Exact<{
  platformName: PlatformName
  sinceDays?: InputMaybe<Scalars['Int']['input']>
}>

export type PartnerIntegrationJobFailureCountQuery = {
  __typename: 'Query'
  PartnerIntegrationJobFailureCount: {
    __typename: 'IntegrationJobFailureCount'
    jobCount: number
    jobQueueCount: number
    totalCount: number
  }
}

export type ExplainIntegrationErrorMutationVariables = Exact<{
  input: ExplainIntegrationErrorInput
}>

export type ExplainIntegrationErrorMutation = {
  __typename: 'Mutation'
  explainIntegrationError: {
    __typename: 'ExplainIntegrationErrorResponse'
    explanation: string
    suggestedActions: Array<string>
    contactSupport: boolean
  }
}

export type ExplainIntegrationErrorFeedbackMutationVariables = Exact<{
  input: ExplainIntegrationErrorFeedbackInput
}>

export type ExplainIntegrationErrorFeedbackMutation = {
  __typename: 'Mutation'
  explainIntegrationErrorFeedback: {
    __typename: 'ExplainIntegrationErrorFeedbackResponse'
    success: boolean
  }
}

export type PartnerListIntegrationsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListIntegrationsQuery = {
  __typename: 'Query'
  PartnerListIntegrations?: Array<
    | {
        __typename: 'AutotaskIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'ConnectwiseIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'DatagateIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'HaloPSAIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
        queryFilters?: {
          __typename: 'HaloPSAConnectionQueryFilters'
          customerFilters?: {
            __typename: 'HaloPSACustomerFilters'
            topLevels?: Array<{
              __typename: 'HaloPSAFilterValue'
              id: string
              name: string
            }> | null
          } | null
          invoiceFilters?: {
            __typename: 'HaloPSAInvoiceFilters'
            createdSince?: string | null
          } | null
        } | null
      }
    | {
        __typename: 'QuickbooksIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'RutterIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'SuperOpsIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | null
  > | null
}

export type PartnerIntegrationDisconnectMutationVariables = Exact<{
  input?: InputMaybe<IntegrationDisconnectInput>
}>

export type PartnerIntegrationDisconnectMutation = {
  __typename: 'Mutation'
  PartnerIntegrationDisconnect?: string | null
}

type PartnerIntegration_AutotaskIntegration_Fragment = {
  __typename: 'AutotaskIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_ConnectwiseIntegration_Fragment = {
  __typename: 'ConnectwiseIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_DatagateIntegration_Fragment = {
  __typename: 'DatagateIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_HaloPsaIntegration_Fragment = {
  __typename: 'HaloPSAIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
  queryFilters?: {
    __typename: 'HaloPSAConnectionQueryFilters'
    customerFilters?: {
      __typename: 'HaloPSACustomerFilters'
      topLevels?: Array<{
        __typename: 'HaloPSAFilterValue'
        id: string
        name: string
      }> | null
    } | null
    invoiceFilters?: {
      __typename: 'HaloPSAInvoiceFilters'
      createdSince?: string | null
    } | null
  } | null
}

type PartnerIntegration_QuickbooksIntegration_Fragment = {
  __typename: 'QuickbooksIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_RutterIntegration_Fragment = {
  __typename: 'RutterIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_SuperOpsIntegration_Fragment = {
  __typename: 'SuperOpsIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

export type PartnerIntegrationFragment =
  | PartnerIntegration_AutotaskIntegration_Fragment
  | PartnerIntegration_ConnectwiseIntegration_Fragment
  | PartnerIntegration_DatagateIntegration_Fragment
  | PartnerIntegration_HaloPsaIntegration_Fragment
  | PartnerIntegration_QuickbooksIntegration_Fragment
  | PartnerIntegration_RutterIntegration_Fragment
  | PartnerIntegration_SuperOpsIntegration_Fragment

export type PartnerIntegrationSyncMutationVariables = Exact<{
  input?: InputMaybe<IntegrationSyncInput>
}>

export type PartnerIntegrationSyncMutation = {
  __typename: 'Mutation'
  PartnerIntegrationSync?: {
    __typename: 'IntegrationSyncReply'
    success: boolean
    message: string
  } | null
}

export type PartnerListUnsyncedInvoicesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<UnsyncedInvoicesOrderBy>
  filters?: InputMaybe<UnsyncedInvoicesFilter>
}>

export type PartnerListUnsyncedInvoicesQuery = {
  __typename: 'Query'
  PartnerListUnsyncedInvoices?: {
    __typename: 'UnsyncedInvoices'
    edges?: Array<{
      __typename: 'UnsyncedInvoiceEdge'
      cursor: any
      node: {
        __typename: 'InvoiceRelation'
        id: string
        invoiceNumber: string
        createdAt: string
        dueDate: string
        amount: number
        invoiceID?: string | null
        customer: {
          __typename: 'InvoiceRelationCustomer'
          id?: string | null
          name: string
        }
      }
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerUnsyncedInvoiceFragment = {
  __typename: 'InvoiceRelation'
  id: string
  invoiceNumber: string
  createdAt: string
  dueDate: string
  amount: number
  invoiceID?: string | null
  customer: {
    __typename: 'InvoiceRelationCustomer'
    id?: string | null
    name: string
  }
}

export type PartnerGetUnsyncedInvoiceTotalsQueryVariables = Exact<{
  filters?: InputMaybe<UnsyncedInvoicesFilter>
}>

export type PartnerGetUnsyncedInvoiceTotalsQuery = {
  __typename: 'Query'
  PartnerGetUnsyncedInvoiceTotals?: {
    __typename: 'UnsyncedInvoiceTotals'
    count: number
    amount: number
  } | null
}

export type PartnerAccountingSyncBatchCreateMutationVariables = Exact<{
  input?: InputMaybe<AccountingSyncBatchCreateInput>
}>

export type PartnerAccountingSyncBatchCreateMutation = {
  __typename: 'Mutation'
  PartnerAccountingSyncBatchCreate?: {
    __typename: 'AccountingSyncBatchCreateReply'
    notSyncedInvoiceNumbers?: Array<string> | null
    batch?: { __typename: 'AccountingSyncBatch'; id: string } | null
  } | null
}

export type AccountingSyncBatchFragment = {
  __typename: 'AccountingSyncBatch'
  id: string
  createdAt: string
  externalID: string
  status: AccountingSyncBatchStatus
  platform: PlatformName
  numberOfInvoices: number
}

export type PartnerGetAccountingSyncBatchQueryVariables = Exact<{
  batchID: Scalars['ID']['input']
}>

export type PartnerGetAccountingSyncBatchQuery = {
  __typename: 'Query'
  PartnerGetAccountingSyncBatch?: {
    __typename: 'GetAccountingSyncBatchReply'
    batch: {
      __typename: 'AccountingSyncBatch'
      id: string
      createdAt: string
      externalID: string
      status: AccountingSyncBatchStatus
      platform: PlatformName
      numberOfInvoices: number
    }
    invoiceJobs?: Array<{
      __typename: 'AccountingSyncJob'
      internalEntityID: string
      type: AccountingSyncJobType
      status: AccountingSyncJobStatus
      invoiceData?: {
        __typename: 'AccountingSyncJobInvoiceData'
        invoiceNumber: string
        invoiceDate: string
        dueDate: string
        amount: number
        customerName: string
      } | null
    }> | null
  } | null
}

export type PartnerListAccountingSyncBatchesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<ListAccountingSyncBatchesFilter>
}>

export type PartnerListAccountingSyncBatchesQuery = {
  __typename: 'Query'
  PartnerListAccountingSyncBatches?: {
    __typename: 'ListAccountingSyncBatchesReply'
    edges?: Array<{
      __typename: 'AccountingSyncBatchEdge'
      cursor: any
      node: {
        __typename: 'AccountingSyncBatch'
        id: string
        createdAt: string
        externalID: string
        status: AccountingSyncBatchStatus
        platform: PlatformName
        numberOfInvoices: number
      }
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerListAccountingSyncJobsQueryVariables = Exact<{
  batchID: Scalars['ID']['input']
  parentID: Scalars['ID']['input']
}>

export type PartnerListAccountingSyncJobsQuery = {
  __typename: 'Query'
  PartnerListAccountingSyncJobs?: {
    __typename: 'ListAccountingSyncJobsReply'
    jobs?: Array<{
      __typename: 'AccountingSyncJob'
      status: AccountingSyncJobStatus
      type: AccountingSyncJobType
      errorMessage?: string | null
      invoiceData?: {
        __typename: 'AccountingSyncJobInvoiceData'
        invoiceNumber: string
        invoiceDate: string
        dueDate: string
        amount: number
        customerName: string
      } | null
      customerData?: {
        __typename: 'AccountingSyncJobCustomerData'
        customerName: string
      } | null
      lineItemData?: {
        __typename: 'AccountingSyncJobLineItemData'
        lineItemName: string
      } | null
      billingTermData?: {
        __typename: 'AccountingSyncJobBillingTermData'
        billingTermName: string
      } | null
      paymentData?: {
        __typename: 'AccountingSyncJobPaymentData'
        amount: number
      } | null
    }> | null
  } | null
}

export type PartnerSecondaryIntegrationDeleteMutationVariables = Exact<{
  input: SecondaryIntegrationDeleteInput
}>

export type PartnerSecondaryIntegrationDeleteMutation = {
  __typename: 'Mutation'
  PartnerSecondaryIntegrationDelete?: string | null
}

export type PartnerRefreshUnsyncedInvoicesMutationVariables = Exact<{
  platformName: PlatformName
}>

export type PartnerRefreshUnsyncedInvoicesMutation = {
  __typename: 'Mutation'
  PartnerRefreshUnsyncedInvoices?: string | null
}

export type PartnerGetLastRefreshTriggeredQueryVariables = Exact<{
  platformName: PlatformName
}>

export type PartnerGetLastRefreshTriggeredQuery = {
  __typename: 'Query'
  PartnerGetLastRefreshTriggered: {
    __typename: 'LastRefreshTriggeredReply'
    triggeredAt?: string | null
  }
}

export type PartnerListAvailableIntegrationsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListAvailableIntegrationsQuery = {
  __typename: 'Query'
  PartnerListAvailableIntegrations: {
    __typename: 'AvailableIntegrationsReply'
    platforms?: Array<PlatformName> | null
  }
}

export type PartnerResolveCustomerIntegrationIDsQueryVariables = Exact<{
  input: ResolveCustomerIntegrationIDsInput
}>

export type PartnerResolveCustomerIntegrationIDsQuery = {
  __typename: 'Query'
  PartnerResolveCustomerIntegrationIDs: {
    __typename: 'ResolveCustomerIntegrationIDsResult'
    unresolvedCustomerIDs: Array<string>
    mappings: Array<{
      __typename: 'CustomerIntegrationIDMapping'
      customerID: string
      integrationEntityID: string
    }>
  }
}

export type PartnerGetAccountingPreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetAccountingPreferencesQuery = {
  __typename: 'Query'
  PartnerGetAccountingPreferences?: {
    __typename: 'AccountingPreferences'
    pdfFromPrimary: boolean
    pushPaymentsTo: PushPaymentsTo
    contactsFromPrimary: boolean
    archiveZeroedInvoices: boolean
    useIntegrationPDF: boolean
    syncPaymentsQboCw: boolean
    apEnabled: boolean
    paymentFailedNotificationEnabled: boolean
  } | null
}

export type PartnerAccountingPreferencesUpdateMutationVariables = Exact<{
  input?: InputMaybe<AccountingPreferencesUpdateInput>
}>

export type PartnerAccountingPreferencesUpdateMutation = {
  __typename: 'Mutation'
  PartnerAccountingPreferencesUpdate?: {
    __typename: 'AccountingPreferences'
    pdfFromPrimary: boolean
    pushPaymentsTo: PushPaymentsTo
    contactsFromPrimary: boolean
    syncPaymentsQboCw: boolean
    paymentFailedNotificationEnabled: boolean
  } | null
}

export type PartnerQuickbooksConnectionUrlQueryVariables = Exact<{
  redirectURI: Scalars['String']['input']
}>

export type PartnerQuickbooksConnectionUrlQuery = {
  __typename: 'Query'
  PartnerQuickbooksConnectionURL?: string | null
}

export type PartnerQuickbooksAccountListQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksAccountListQuery = {
  __typename: 'Query'
  PartnerQuickbooksAccountList: {
    __typename: 'QuickbooksAccountsListReply'
    forDeposits?: Array<{
      __typename: 'QuickbooksAccount'
      id: string
      type: string
      name: string
      fullyQualifiedName: string
    }> | null
    forFees?: Array<{
      __typename: 'QuickbooksAccount'
      id: string
      type: string
      name: string
      fullyQualifiedName: string
    }> | null
  }
}

export type PartnerQuickbooksAccountRetrieveQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksAccountRetrieveQuery = {
  __typename: 'Query'
  PartnerQuickbooksAccountRetrieve: {
    __typename: 'QuickbooksAccountsRetrieveReply'
    forDeposits?: {
      __typename: 'QuickbooksAccount'
      id: string
      type: string
      name: string
      fullyQualifiedName: string
    } | null
    forFees?: {
      __typename: 'QuickbooksAccount'
      id: string
      type: string
      name: string
      fullyQualifiedName: string
    } | null
  }
}

export type PartnerQuickbooksAccountUpdateMutationVariables = Exact<{
  input?: InputMaybe<QuickbooksAccountUpdateInput>
}>

export type PartnerQuickbooksAccountUpdateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksAccountUpdate?: string | null
}

export type PartnerQuickbooksConnectionCreateMutationVariables = Exact<{
  code: Scalars['String']['input']
  state: Scalars['String']['input']
  realmId: Scalars['String']['input']
  integrationType: IntegrationType
  currency: Currency
}>

export type PartnerQuickbooksConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksConnectionCreate?: string | null
}

export type QuickbooksAccountFragment = {
  __typename: 'QuickbooksAccount'
  id: string
  type: string
  name: string
  fullyQualifiedName: string
}

export type PartnerQuickbooksConnectionUpdateMutationVariables = Exact<{
  createDeposits?: InputMaybe<Scalars['Boolean']['input']>
  pushBillPaymentStatus?: InputMaybe<Scalars['Boolean']['input']>
  autoSyncVendors?: InputMaybe<Scalars['Boolean']['input']>
}>

export type PartnerQuickbooksConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksConnectionUpdate?: string | null
}

export type PartnerQuickbooksConnectionReadQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksConnectionReadQuery = {
  __typename: 'Query'
  PartnerQuickbooksConnectionRead?: {
    __typename: 'QuickbooksConnection'
    createDeposits: boolean
    pushBillPaymentStatus: boolean
    autoSyncVendors: boolean
    queryFilters: {
      __typename: 'QuickbooksQueryFilters'
      customerTypes?: Array<{
        __typename: 'QuickbooksFilterValue'
        id: string
        name: string
      }> | null
    }
  } | null
}

export type PartnerListExpenseAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListExpenseAccountsQuery = {
  __typename: 'Query'
  PartnerListExpenseAccounts: Array<{
    __typename: 'ExpenseAccount'
    id: string
    externalId: string
    name: string
    type: string
    accountNumber?: string | null
    fullyQualifiedName: string
    active: boolean
    visible: boolean
  }>
}

export type PartnerListVisibleExpenseAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListVisibleExpenseAccountsQuery = {
  __typename: 'Query'
  PartnerListVisibleExpenseAccounts: Array<{
    __typename: 'ExpenseAccount'
    id: string
    externalId: string
    name: string
    type: string
    accountNumber?: string | null
    fullyQualifiedName: string
    active: boolean
    visible: boolean
  }>
}

export type PartnerUpdateExpenseAccountVisibilityMutationVariables = Exact<{
  accountIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  visible: Scalars['Boolean']['input']
}>

export type PartnerUpdateExpenseAccountVisibilityMutation = {
  __typename: 'Mutation'
  PartnerUpdateExpenseAccountVisibility: Array<{
    __typename: 'ExpenseAccount'
    id: string
    externalId: string
    name: string
    type: string
    accountNumber?: string | null
    fullyQualifiedName: string
    active: boolean
    visible: boolean
  }>
}

export type PartnerRecurringTransactionConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RecurringTransactionOrderBy>
  filter?: InputMaybe<RecurringTransactionFilter>
}>

export type PartnerRecurringTransactionConnectionQuery = {
  __typename: 'Query'
  PartnerRecurringTransactionConnection: {
    __typename: 'RecurringTransactionConnection'
    edges?: Array<{
      __typename: 'RecurringTransactionEdge'
      node?: {
        __typename: 'QuickbooksRecurringTransaction'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerQuickbooksTaxCodeGetQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksTaxCodeGetQuery = {
  __typename: 'Query'
  PartnerQuickbooksTaxCodeGet: Array<{
    __typename: 'QuicbooksTaxCode'
    id: string
    name: string
  }>
}

export type PartnerQuickbooksCustomerTypeListQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksCustomerTypeListQuery = {
  __typename: 'Query'
  PartnerQuickbooksCustomerTypeList: {
    __typename: 'QuickbooksCustomerTypeListReply'
    customerTypes?: Array<{
      __typename: 'QuickbooksCustomerType'
      id: string
      name: string
    } | null> | null
  }
}

export type PartnerQuickbooksConnectionQueryFiltersUpdateMutationVariables =
  Exact<{
    input: QuickbooksConnectionQueryFiltersInput
  }>

export type PartnerQuickbooksConnectionQueryFiltersUpdateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksConnectionQueryFiltersUpdate?: string | null
}

export type PartnerQuickbooksInvoiceCustomFieldsListQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksInvoiceCustomFieldsListQuery = {
  __typename: 'Query'
  PartnerQuickbooksInvoiceCustomFieldsList: Array<{
    __typename: 'QuickbooksInvoiceCustomField'
    definitionId: string
    name: string
  }>
}

export type PartnerRutterConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<ConnectionCreateInput>
}>

export type PartnerRutterConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerRutterConnectionCreate?: {
    __typename: 'RutterConnection'
    platform: string
    status: ConnectionStatus
  } | null
}

export type PartnerRutterAccountListQueryVariables = Exact<{
  input?: InputMaybe<RutterAccountListInput>
}>

export type PartnerRutterAccountListQuery = {
  __typename: 'Query'
  PartnerRutterAccountList?: Array<{
    __typename: 'RutterAccount'
    id: string
    type: string
    name: string
    nominalCode: string
  } | null> | null
}

export type RutterAccountListFragment = {
  __typename: 'RutterAccount'
  id: string
  type: string
  name: string
  nominalCode: string
}

export type PartnerRutterAccountUpsertMutationVariables = Exact<{
  input?: InputMaybe<RutterAccountUpsertInput>
}>

export type PartnerRutterAccountUpsertMutation = {
  __typename: 'Mutation'
  PartnerRutterAccountUpsert?: string | null
}

export type PartnerRutterAccountReadQueryVariables = Exact<{
  platform?: InputMaybe<RutterPlatform>
}>

export type PartnerRutterAccountReadQuery = {
  __typename: 'Query'
  PartnerRutterAccountRead?: {
    __typename: 'RutterSelectedAccounts'
    AccountForDeposits?: { __typename: 'RutterAccount'; id: string } | null
    AccountForPayments?: { __typename: 'RutterAccount'; id: string } | null
    AccountForFunds?: { __typename: 'RutterAccount'; id: string } | null
    AccountForFees?: { __typename: 'RutterAccount'; id: string } | null
    AccountForRefunds?: { __typename: 'RutterAccount'; id: string } | null
  } | null
}

export type PartnerRutterConnectionReadQueryVariables = Exact<{
  platform?: InputMaybe<RutterPlatform>
}>

export type PartnerRutterConnectionReadQuery = {
  __typename: 'Query'
  PartnerRutterConnectionRead?: {
    __typename: 'RutterConnection'
    rutterConnectionID: string
    createDeposits: boolean
  } | null
}

export type PartnerRutterConnectionUpdateMutationVariables = Exact<{
  input?: InputMaybe<ConnectionUpdateInput>
}>

export type PartnerRutterConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerRutterConnectionUpdate?: {
    __typename: 'RutterConnection'
    status: ConnectionStatus
  } | null
}

export type PartnerRutterAccountUnsetMutationVariables = Exact<{
  input?: InputMaybe<RutterAccountUnsetInput>
}>

export type PartnerRutterAccountUnsetMutation = {
  __typename: 'Mutation'
  PartnerRutterAccountUnset?: string | null
}

export type PartnerRutterAccountUpsertManyMutationVariables = Exact<{
  input?: InputMaybe<RutterAccountUpsertManyInput>
}>

export type PartnerRutterAccountUpsertManyMutation = {
  __typename: 'Mutation'
  PartnerRutterAccountUpsertMany?: string | null
}

export type PartnerRutterPaymentTermsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RutterPaymentTermsOrderBy>
  filter?: InputMaybe<RutterPaymentTermsFilter>
}>

export type PartnerRutterPaymentTermsConnectionQuery = {
  __typename: 'Query'
  PartnerRutterPaymentTermsConnection?: {
    __typename: 'RutterPaymentTermsConnection'
    edges?: Array<{
      __typename: 'RutterPaymentTermsEdge'
      node?: {
        __typename: 'RutterPaymentTerms'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerRutterSubsidiaryListQueryVariables = Exact<{
  platform?: InputMaybe<RutterPlatform>
}>

export type PartnerRutterSubsidiaryListQuery = {
  __typename: 'Query'
  PartnerRutterSubsidiaryList?: {
    __typename: 'RutterSubsidiaryListResponse'
    subsidiaries?: Array<{
      __typename: 'RutterSubsidiary'
      id: string
      name: string
    }> | null
  } | null
}

export type PartnerRutterConnectionFiltersUpdateMutationVariables = Exact<{
  input?: InputMaybe<RutterConnectionFiltersUpdateInput>
}>

export type PartnerRutterConnectionFiltersUpdateMutation = {
  __typename: 'Mutation'
  PartnerRutterConnectionFiltersUpdate?: string | null
}

export type PartnerRutterConnectionCreateDepositsUpdateMutationVariables =
  Exact<{
    input?: InputMaybe<RutterConnectionCreateDepositsUpdateInput>
  }>

export type PartnerRutterConnectionCreateDepositsUpdateMutation = {
  __typename: 'Mutation'
  PartnerRutterConnectionCreateDepositsUpdate?: string | null
}

export type PartnerSuperopsConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<SuperopsConnectionCreateInput>
}>

export type PartnerSuperopsConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerSuperopsConnectionCreate?: string | null
}

export type IntegrationPermissionsQueryVariables = Exact<{
  integration: Scalars['String']['input']
}>

export type IntegrationPermissionsQuery = {
  __typename: 'Query'
  integrationPermissions?: {
    __typename: 'IntegrationPermissions'
    connectionID: string
    integration: string
    capabilities: Array<{
      __typename: 'IntegrationPermissionCapability'
      capability: string
      status: IntegrationPermissionStatus
      detail?: string | null
      probedAt: string
    }>
  } | null
}

export type RefreshIntegrationPermissionsMutationVariables = Exact<{
  integration: Scalars['String']['input']
  force?: InputMaybe<Scalars['Boolean']['input']>
}>

export type RefreshIntegrationPermissionsMutation = {
  __typename: 'Mutation'
  refreshIntegrationPermissions?: {
    __typename: 'RefreshIntegrationPermissionsReply'
    connectionID: string
    status: IntegrationPermissionStatus
    capabilities: Array<{
      __typename: 'IntegrationPermissionCapability'
      capability: string
      status: IntegrationPermissionStatus
      detail?: string | null
      probedAt: string
    }>
  } | null
}

export type PartnerGetInvoicesSummaryQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetInvoicesSummaryQuery = {
  __typename: 'Query'
  PartnerGetInvoicesSummary: {
    __typename: 'InvoicesSummary'
    count0To30: number
    count31To60: number
    count61To90: number
    count90Plus: number
    dueBeforeEndOfMonth: number
  }
}

export type PartnerGetInvoiceLedgerMovementsQueryVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type PartnerGetInvoiceLedgerMovementsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceLedgerMovements?: {
    __typename: 'LedgerMovementResult'
    ledgerBalance: number
    movements: Array<{
      __typename: 'MovementEntry'
      movementType: LedgerMovementType
      movements: Array<number>
      balance: number
    }>
  } | null
}

export type PartnerFindInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type PartnerFindInvoiceQuery = {
  __typename: 'Query'
  FindInvoice?: {
    __typename: 'Invoice'
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    recurringpayment: boolean
    recurringpaymentID?: string | null
    lastRemindedAt?: string | null
    externalId?: string | null
    externalInvoiceNumber?: string | null
    totalTaxAmount: number
    purchaseOrder?: string | null
    id: string
    invoiceNumber: string
    productName?: string | null
    status: InvoiceStatusEnum
    platformName: string
    totalDiscountAmount: number
    customer?: {
      __typename: 'Customer'
      createdAt: string
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    } | null
    partner?: {
      __typename: 'Partner'
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      adyenOnboardingStatus: AdyenOnboardingStatusStep
      insightsEnabled: boolean
      timezone?: Timezone | null
      useUserLocalTimezone?: boolean | null
      timezoneSetAt?: string | null
      attachInvoicePDFEnabled?: boolean | null
      pdfFallbackEnabled?: boolean | null
      paymentsPortalEnabled: boolean
      paymentsPortalUrl?: string | null
      paymentsPortalCustomUrl?: string | null
      paymentsPortalUseCustomUrl?: boolean | null
      paymentsPortalDefaultUrl?: string | null
      paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
      city?: string | null
      state?: string | null
      stateCode?: string | null
      country?: string | null
      countryCode?: string | null
      postalCode?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      paymentsPortalCustomization: {
        __typename: 'PartnerPaymentsPortalCustomization'
        color?: string | null
        logoUrl?: string | null
      }
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                  fundingSource: FundingSource
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | {
                  __typename: 'OneTimePayment'
                  id: string
                  referenceId?: string | null
                }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              failureReasonCode?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              id: string
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
    lineItems?: Array<{
      __typename: 'LineItem'
      code?: string | null
      category?: string | null
      description?: string | null
      quantity?: number | null
      extendedAmountPerItem?: number | null
      unitPrice?: number | null
    } | null> | null
    statuses: Array<{
      __typename: 'InvoiceStatus'
      status: InvoiceStatusEnum
      createdAt: any
    } | null>
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
  } | null
}

export type PartnerGetInvoicePdfLinkQueryVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type PartnerGetInvoicePdfLinkQuery = {
  __typename: 'Query'
  PartnerGetInvoicePdfLink: {
    __typename: 'InvoicePdfLink'
    url: string
    expiresAt: string
    status: InvoicePdfStatus
  }
}

export type PartnerInvoiceListTotalsQueryVariables = Exact<{
  filters?: InputMaybe<InvoiceFilter>
}>

export type PartnerInvoiceListTotalsQuery = {
  __typename: 'Query'
  PartnerInvoiceListTotals?: {
    __typename: 'InvoiceTotals'
    count: number
    amount: number
    outstandingAmount: number
  } | null
}

export type PartnerInvoiceSearchQueryVariables = Exact<{
  invoiceNumber?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerInvoiceSearchQuery = {
  __typename: 'Query'
  PartnerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
      } | null
    } | null> | null
  }
}

export type PartnerInvoiceConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<InvoiceFilter>
  orderBy?: InputMaybe<InvoiceOrderBy>
}>

export type PartnerInvoiceConnectionQuery = {
  __typename: 'Query'
  PartnerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        id: string
        amount: number
        outstandingAmount: number
        createdAt: string
        createdByCustomer: boolean
        dueDate?: string | null
        invoiceNumber: string
        lastRemindedAt?: string | null
        productName?: string | null
        status: InvoiceStatusEnum
        recurringpayment: boolean
        externalId?: string | null
        externalInvoiceNumber?: string | null
        autopaidAt?: string | null
        customer?: {
          __typename: 'Customer'
          name?: string | null
          id: string
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          id: string
          partnerConfirmed: boolean
          status: BnplStatus
          createdAt: string
          terms: number
          amount: number
          netAmount: number
          lending?: {
            __typename: 'Lending'
            id: string
            amount: number
            netAmount: number
            installments?: Array<{
              __typename: 'Installment'
              id: string
              amount: number
              dueDate: string
              netAmount: number
              status: InstallmentStatus
              payments: Array<{
                __typename: 'Payment'
                id: string
                amount: number
                netAmount: number
                creationDate: string
                currentPaymentMethod?: MethodEnum | null
                dueDate?: string | null
                paymentCompletionForecastDate?: string | null
                originService: PaymentAlternativeService
                executorType: PaymentExecutorType
                paymentFees: Array<{
                  __typename: 'PaymentFee'
                  forwarded: boolean
                  type: FeeType
                  amount: number
                  name: string
                } | null>
                currentPaymentMethodEntity?:
                  | {
                      __typename: 'Account'
                      id: string
                      name?: string | null
                      mask?: string | null
                      type?: string | null
                    }
                  | {
                      __typename: 'Card'
                      id: string
                      cardNetWork: CardNetwork
                      last4: string
                      fundingSource: FundingSource
                    }
                  | null
                customer?: {
                  __typename: 'Customer'
                  id: string
                  name?: string | null
                  streetAddress?: string | null
                  subPremise?: string | null
                  city?: string | null
                  postalCode?: string | null
                  state?: string | null
                  country?: string | null
                } | null
                product:
                  | { __typename: 'InstantPayment' }
                  | {
                      __typename: 'Invoice'
                      id: string
                      invoiceNumber: string
                      productName?: string | null
                      status: InvoiceStatusEnum
                      amount: number
                      dueDate?: string | null
                      outstandingAmount: number
                      platformName: string
                      totalDiscountAmount: number
                      statuses: Array<{
                        __typename: 'InvoiceStatus'
                        status: InvoiceStatusEnum
                        createdAt: any
                      } | null>
                      payments?: Array<{
                        __typename: 'InvoicePayment'
                        id: string
                        status: PaymentStatusEnum
                        payoutCreationForecastDate?: string | null
                      } | null> | null
                    }
                  | { __typename: 'Offer' }
                  | {
                      __typename: 'OneTimePayment'
                      id: string
                      referenceId?: string | null
                    }
                  | { __typename: 'Referral' }
                  | { __typename: 'ReferralBonus' }
                  | { __typename: 'Refund' }
                  | {
                      __typename: 'SubscriptionPayment'
                      id: string
                      paymentDate: string
                      amount: number
                      subscriptionStatus: SubscriptionPaymentStatus
                      subscription: {
                        __typename: 'PartnerSubscription'
                        id: string
                        type: string
                        frequency: SubscriptionFrequency
                      }
                    }
                transaction?: {
                  __typename: 'Transaction'
                  failureReason?: string | null
                  failureReasonCode?: string | null
                  status: TransactionStatus
                } | null
                statuses: Array<{
                  __typename: 'PaymentStatus'
                  status?: PaymentStatusEnum | null
                  createdAt: string
                } | null>
                refunds?: Array<{
                  __typename: 'Refund'
                  id: string
                  amount: number
                  createdAt: string
                  lastStatus: RefundStatusEnum
                  status?: Array<{
                    __typename: 'RefundStatus'
                    id: string
                    status: RefundStatusEnum
                    createdAt: string
                  }> | null
                } | null> | null
                payoutEstimation: {
                  __typename: 'PaymentPayoutEstimation'
                  estimatedPayoutCreationDate?: string | null
                }
              } | null>
            } | null> | null
          } | null
        } | null
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
        transferPayments?: Array<{
          __typename: 'Payment'
          id: string
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
          } | null>
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
          } | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerArInvoiceListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  filters?: InputMaybe<ArInvoiceFilter>
  order?: InputMaybe<ArInvoiceOrder>
}>

export type PartnerArInvoiceListQuery = {
  __typename: 'Query'
  PartnerArInvoiceList: {
    __typename: 'InvoiceList'
    invoices?: Array<{
      __typename: 'ArInvoice'
      id: string
      partnerID: string
      invoiceNumber: string
      customerID: string
      customerName: string
      createdByCustomer: boolean
      amount: number
      outstandingAmount: number
      dueDate?: string | null
      createdAt: string
      status: InvoiceStatusEnum
      lastRemindedAt?: string | null
      isRecurring: boolean
      isExternal: boolean
      recurringFrequency?: Frequency | null
      nextRecurringDate?: string | null
      autopaidAt?: string | null
      bnplStatus?: BnplStatus | null
      bnplPartnerConfirmed?: boolean | null
      bnplID?: string | null
    }> | null
    pagination: {
      __typename: 'ArPagination'
      page: number
      pageSize: number
      totalPages: number
      totalItems: number
    }
    summary: {
      __typename: 'ArInvoiceSummary'
      totalAmount: number
      totalOutstandingAmount: number
    }
  }
}

export type PartnerGetInvoicePreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetInvoicePreferencesQuery = {
  __typename: 'Query'
  PartnerGetInvoicePreferences?: {
    __typename: 'InvoicePreferences'
    invoiceNumberField: InvoiceNumberField
  } | null
}

export type PartnerInvoiceArchiveMutationVariables = Exact<{
  archiveInvoiceId: Scalars['ID']['input']
}>

export type PartnerInvoiceArchiveMutation = {
  __typename: 'Mutation'
  PartnerInvoiceArchive?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                  fundingSource: FundingSource
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | {
                  __typename: 'OneTimePayment'
                  id: string
                  referenceId?: string | null
                }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              failureReasonCode?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              id: string
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoiceUnarchiveMutationVariables = Exact<{
  archivedInvoiceId: Scalars['ID']['input']
}>

export type PartnerInvoiceUnarchiveMutation = {
  __typename: 'Mutation'
  PartnerInvoiceUnarchive?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                  fundingSource: FundingSource
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | {
                  __typename: 'OneTimePayment'
                  id: string
                  referenceId?: string | null
                }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              failureReasonCode?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              id: string
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoiceCreateMutationVariables = Exact<{
  input?: InputMaybe<InvoiceInput>
}>

export type PartnerInvoiceCreateMutation = {
  __typename: 'Mutation'
  PartnerInvoiceCreate?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                  fundingSource: FundingSource
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | {
                  __typename: 'OneTimePayment'
                  id: string
                  referenceId?: string | null
                }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              failureReasonCode?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              id: string
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoicePaidUpdateMutationVariables = Exact<{
  input?: InputMaybe<PartnerInvoicePaidUpdateInput>
}>

export type PartnerInvoicePaidUpdateMutation = {
  __typename: 'Mutation'
  PartnerInvoicePaidUpdate?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                  fundingSource: FundingSource
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | {
                  __typename: 'OneTimePayment'
                  id: string
                  referenceId?: string | null
                }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              failureReasonCode?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              id: string
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoiceRemindMutationVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type PartnerInvoiceRemindMutation = {
  __typename: 'Mutation'
  PartnerInvoiceRemind?: string | null
}

export type PartnerPayInvoiceMutationVariables = Exact<{
  invoiceID: Scalars['String']['input']
  customerID: Scalars['String']['input']
  paymentDate?: InputMaybe<Scalars['String']['input']>
  paymentMethod: PayInvoicePaymentMethodInput
  amount: Scalars['Float']['input']
  idempotencyKey?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerPayInvoiceMutation = {
  __typename: 'Mutation'
  PartnerPayInvoice?: string | null
}

export type PartnerUpsertInvoicePreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpsertInvoicePreferencesInput>
}>

export type PartnerUpsertInvoicePreferencesMutation = {
  __typename: 'Mutation'
  PartnerUpsertInvoicePreferences?: string | null
}

export type PartnerInvoiceSearchFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
  productName?: string | null
}

export type PartnerInvoiceEmailActivityFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
}

export type PartnerInvoiceBasicFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
  productName?: string | null
  status: InvoiceStatusEnum
  amount: number
  dueDate?: string | null
  outstandingAmount: number
  platformName: string
  totalDiscountAmount: number
  statuses: Array<{
    __typename: 'InvoiceStatus'
    status: InvoiceStatusEnum
    createdAt: any
  } | null>
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
}

export type PartnerInvoiceListingFragment = {
  __typename: 'Invoice'
  id: string
  amount: number
  outstandingAmount: number
  createdAt: string
  createdByCustomer: boolean
  dueDate?: string | null
  invoiceNumber: string
  lastRemindedAt?: string | null
  productName?: string | null
  status: InvoiceStatusEnum
  recurringpayment: boolean
  externalId?: string | null
  externalInvoiceNumber?: string | null
  autopaidAt?: string | null
  customer?: { __typename: 'Customer'; name?: string | null; id: string } | null
  offer?: {
    __typename: 'BNPLOffer'
    id: string
    partnerConfirmed: boolean
    status: BnplStatus
    createdAt: string
    terms: number
    amount: number
    netAmount: number
    lending?: {
      __typename: 'Lending'
      id: string
      amount: number
      netAmount: number
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        dueDate: string
        netAmount: number
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: MethodEnum | null
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          originService: PaymentAlternativeService
          executorType: PaymentExecutorType
          paymentFees: Array<{
            __typename: 'PaymentFee'
            forwarded: boolean
            type: FeeType
            amount: number
            name: string
          } | null>
          currentPaymentMethodEntity?:
            | {
                __typename: 'Account'
                id: string
                name?: string | null
                mask?: string | null
                type?: string | null
              }
            | {
                __typename: 'Card'
                id: string
                cardNetWork: CardNetwork
                last4: string
                fundingSource: FundingSource
              }
            | null
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                status: InvoiceStatusEnum
                amount: number
                dueDate?: string | null
                outstandingAmount: number
                platformName: string
                totalDiscountAmount: number
                statuses: Array<{
                  __typename: 'InvoiceStatus'
                  status: InvoiceStatusEnum
                  createdAt: any
                } | null>
                payments?: Array<{
                  __typename: 'InvoicePayment'
                  id: string
                  status: PaymentStatusEnum
                  payoutCreationForecastDate?: string | null
                } | null> | null
              }
            | { __typename: 'Offer' }
            | {
                __typename: 'OneTimePayment'
                id: string
                referenceId?: string | null
              }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | {
                __typename: 'SubscriptionPayment'
                id: string
                paymentDate: string
                amount: number
                subscriptionStatus: SubscriptionPaymentStatus
                subscription: {
                  __typename: 'PartnerSubscription'
                  id: string
                  type: string
                  frequency: SubscriptionFrequency
                }
              }
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
            failureReasonCode?: string | null
            status: TransactionStatus
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
          refunds?: Array<{
            __typename: 'Refund'
            id: string
            amount: number
            createdAt: string
            lastStatus: RefundStatusEnum
            status?: Array<{
              __typename: 'RefundStatus'
              id: string
              status: RefundStatusEnum
              createdAt: string
            }> | null
          } | null> | null
          payoutEstimation: {
            __typename: 'PaymentPayoutEstimation'
            estimatedPayoutCreationDate?: string | null
          }
        } | null>
      } | null> | null
    } | null
  } | null
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
  transferPayments?: Array<{
    __typename: 'Payment'
    id: string
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
    } | null>
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
    } | null
  } | null> | null
}

export type PartnerInvoiceFragment = {
  __typename: 'Invoice'
  amount: number
  outstandingAmount: number
  createdAt: string
  createdByCustomer: boolean
  dueDate?: string | null
  recurringpayment: boolean
  recurringpaymentID?: string | null
  lastRemindedAt?: string | null
  externalId?: string | null
  externalInvoiceNumber?: string | null
  totalTaxAmount: number
  purchaseOrder?: string | null
  id: string
  invoiceNumber: string
  productName?: string | null
  status: InvoiceStatusEnum
  platformName: string
  totalDiscountAmount: number
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  partner?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    paymentsPortalEnabled: boolean
    paymentsPortalUrl?: string | null
    paymentsPortalCustomUrl?: string | null
    paymentsPortalUseCustomUrl?: boolean | null
    paymentsPortalDefaultUrl?: string | null
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    city?: string | null
    state?: string | null
    stateCode?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
  offer?: {
    __typename: 'BNPLOffer'
    id: string
    partnerConfirmed: boolean
    status: BnplStatus
    createdAt: string
    terms: number
    amount: number
    netAmount: number
    lending?: {
      __typename: 'Lending'
      id: string
      amount: number
      netAmount: number
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        dueDate: string
        netAmount: number
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: MethodEnum | null
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          originService: PaymentAlternativeService
          executorType: PaymentExecutorType
          paymentFees: Array<{
            __typename: 'PaymentFee'
            forwarded: boolean
            type: FeeType
            amount: number
            name: string
          } | null>
          currentPaymentMethodEntity?:
            | {
                __typename: 'Account'
                id: string
                name?: string | null
                mask?: string | null
                type?: string | null
              }
            | {
                __typename: 'Card'
                id: string
                cardNetWork: CardNetwork
                last4: string
                fundingSource: FundingSource
              }
            | null
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                status: InvoiceStatusEnum
                amount: number
                dueDate?: string | null
                outstandingAmount: number
                platformName: string
                totalDiscountAmount: number
                statuses: Array<{
                  __typename: 'InvoiceStatus'
                  status: InvoiceStatusEnum
                  createdAt: any
                } | null>
                payments?: Array<{
                  __typename: 'InvoicePayment'
                  id: string
                  status: PaymentStatusEnum
                  payoutCreationForecastDate?: string | null
                } | null> | null
              }
            | { __typename: 'Offer' }
            | {
                __typename: 'OneTimePayment'
                id: string
                referenceId?: string | null
              }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | {
                __typename: 'SubscriptionPayment'
                id: string
                paymentDate: string
                amount: number
                subscriptionStatus: SubscriptionPaymentStatus
                subscription: {
                  __typename: 'PartnerSubscription'
                  id: string
                  type: string
                  frequency: SubscriptionFrequency
                }
              }
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
            failureReasonCode?: string | null
            status: TransactionStatus
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
          refunds?: Array<{
            __typename: 'Refund'
            id: string
            amount: number
            createdAt: string
            lastStatus: RefundStatusEnum
            status?: Array<{
              __typename: 'RefundStatus'
              id: string
              status: RefundStatusEnum
              createdAt: string
            }> | null
          } | null> | null
          payoutEstimation: {
            __typename: 'PaymentPayoutEstimation'
            estimatedPayoutCreationDate?: string | null
          }
        } | null>
      } | null> | null
    } | null
  } | null
  transferPayments?: Array<{
    __typename: 'Payment'
    id: string
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
    } | null>
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
    } | null
  } | null> | null
  lineItems?: Array<{
    __typename: 'LineItem'
    code?: string | null
    category?: string | null
    description?: string | null
    quantity?: number | null
    extendedAmountPerItem?: number | null
    unitPrice?: number | null
  } | null> | null
  statuses: Array<{
    __typename: 'InvoiceStatus'
    status: InvoiceStatusEnum
    createdAt: any
  } | null>
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
}

export type PartnerInvoiceOfferFragment = {
  __typename: 'BNPLOffer'
  id: string
  partnerConfirmed: boolean
  status: BnplStatus
  createdAt: string
  terms: number
  amount: number
  netAmount: number
  lending?: {
    __typename: 'Lending'
    id: string
    amount: number
    netAmount: number
    installments?: Array<{
      __typename: 'Installment'
      id: string
      amount: number
      dueDate: string
      netAmount: number
      status: InstallmentStatus
      payments: Array<{
        __typename: 'Payment'
        id: string
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: MethodEnum | null
        dueDate?: string | null
        paymentCompletionForecastDate?: string | null
        originService: PaymentAlternativeService
        executorType: PaymentExecutorType
        paymentFees: Array<{
          __typename: 'PaymentFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        currentPaymentMethodEntity?:
          | {
              __typename: 'Account'
              id: string
              name?: string | null
              mask?: string | null
              type?: string | null
            }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              last4: string
              fundingSource: FundingSource
            }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | {
              __typename: 'OneTimePayment'
              id: string
              referenceId?: string | null
            }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | {
              __typename: 'SubscriptionPayment'
              id: string
              paymentDate: string
              amount: number
              subscriptionStatus: SubscriptionPaymentStatus
              subscription: {
                __typename: 'PartnerSubscription'
                id: string
                type: string
                frequency: SubscriptionFrequency
              }
            }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
          failureReasonCode?: string | null
          status: TransactionStatus
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        refunds?: Array<{
          __typename: 'Refund'
          id: string
          amount: number
          createdAt: string
          lastStatus: RefundStatusEnum
          status?: Array<{
            __typename: 'RefundStatus'
            id: string
            status: RefundStatusEnum
            createdAt: string
          }> | null
        } | null> | null
        payoutEstimation: {
          __typename: 'PaymentPayoutEstimation'
          estimatedPayoutCreationDate?: string | null
        }
      } | null>
    } | null> | null
  } | null
}

export type PartnerUpdateReminderMutationVariables = Exact<{
  input?: InputMaybe<UpdateInvoiceReminderInput>
}>

export type PartnerUpdateReminderMutation = {
  __typename: 'Mutation'
  PartnerUpdateReminder?: string | null
}

export type PartnerListInvoiceRemindersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceRemindersQuery = {
  __typename: 'Query'
  PartnerListInvoiceReminders?: Array<{
    __typename: 'InvoiceReminder'
    id: string
    daysOffset: number
    type: InvoiceReminderType
    createdAt?: string | null
    sentHour?: number | null
    timezone?: Timezone | null
    runsHourly?: boolean | null
    enabled: boolean
    cc?: Array<string> | null
    bcc?: Array<string> | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    } | null> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    } | null> | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null> | null
}

export type PartnerFindReminderQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerFindReminderQuery = {
  __typename: 'Query'
  PartnerFindReminder?: {
    __typename: 'InvoiceReminder'
    id: string
    daysOffset: number
    type: InvoiceReminderType
    createdAt?: string | null
    sentHour?: number | null
    timezone?: Timezone | null
    runsHourly?: boolean | null
    enabled: boolean
    cc?: Array<string> | null
    bcc?: Array<string> | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    } | null> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    } | null> | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null
}

export type PartnerListInvoiceReminderExcludedCustomersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceReminderExcludedCustomersQuery = {
  __typename: 'Query'
  PartnerListInvoiceReminderExcludedCustomers?: Array<{
    __typename: 'InvoiceReminderExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerCreateInvoiceReminderMutationVariables = Exact<{
  daysOffset: Scalars['Int']['input']
  type: InvoiceReminderType
  templateID?: InputMaybe<Scalars['ID']['input']>
  sentHour?: InputMaybe<Scalars['Int']['input']>
  runsHourly?: InputMaybe<Scalars['Boolean']['input']>
  timezone?: InputMaybe<Timezone>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  customerIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
  cc?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >
  bcc?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >
}>

export type PartnerCreateInvoiceReminderMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceReminder?: {
    __typename: 'InvoiceReminder'
    id: string
    daysOffset: number
    type: InvoiceReminderType
    createdAt?: string | null
    sentHour?: number | null
    timezone?: Timezone | null
    runsHourly?: boolean | null
    enabled: boolean
    cc?: Array<string> | null
    bcc?: Array<string> | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    } | null> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    } | null> | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null
}

export type PartnerDeleteInvoiceReminderMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteInvoiceReminderMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceReminder?: string | null
}

export type PartnerCreateInvoiceReminderExcludedCustomerMutationVariables =
  Exact<{
    customerID: Scalars['ID']['input']
  }>

export type PartnerCreateInvoiceReminderExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceReminderExcludedCustomer?: {
    __typename: 'InvoiceReminderExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null
}

export type PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables =
  Exact<{
    customerIDs?: InputMaybe<
      Array<Scalars['ID']['input']> | Scalars['ID']['input']
    >
  }>

export type PartnerUpdateInvoiceReminderExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerUpdateInvoiceReminderExcludedCustomer?: Array<{
    __typename: 'InvoiceReminderExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables =
  Exact<{
    id: Scalars['ID']['input']
  }>

export type PartnerDeleteInvoiceReminderExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceReminderExcludedCustomer?: string | null
}

export type PartnerSendInvoiceReminderPreviewMutationVariables = Exact<{
  input?: InputMaybe<InvoiceReminderPreviewInput>
}>

export type PartnerSendInvoiceReminderPreviewMutation = {
  __typename: 'Mutation'
  PartnerSendInvoiceReminderPreview?: string | null
}

export type PartnerToggleReminderEnabledMutationVariables = Exact<{
  id: Scalars['ID']['input']
  enabled: Scalars['Boolean']['input']
}>

export type PartnerToggleReminderEnabledMutation = {
  __typename: 'Mutation'
  PartnerToggleReminderEnabled?: string | null
}

export type PartnerBulkInvoiceRemindMutationVariables = Exact<{
  invoiceIDs: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type PartnerBulkInvoiceRemindMutation = {
  __typename: 'Mutation'
  PartnerBulkInvoiceRemind?: string | null
}

export type PartnerInvoiceReminderFragment = {
  __typename: 'InvoiceReminder'
  id: string
  daysOffset: number
  type: InvoiceReminderType
  createdAt?: string | null
  sentHour?: number | null
  timezone?: Timezone | null
  runsHourly?: boolean | null
  enabled: boolean
  cc?: Array<string> | null
  bcc?: Array<string> | null
  tags?: Array<{
    __typename: 'CustomerTag'
    ID: string
    name: string
    description?: string | null
    color?: TagColor | null
    type?: TagType | null
  } | null> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    tagIDs?: Array<string> | null
  } | null> | null
  template?: {
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  } | null
}

export type PartnerInvoiceReminderExcludedCustomerFragment = {
  __typename: 'InvoiceReminderExcludedCustomer'
  id: string
  createdAt: string
  customer: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  }
}

export type PartnerUpdateSummaryMutationVariables = Exact<{
  input?: InputMaybe<UpdateInvoiceSummaryInput>
}>

export type PartnerUpdateSummaryMutation = {
  __typename: 'Mutation'
  PartnerUpdateSummary?: string | null
}

export type PartnerListInvoiceSummariesQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceSummariesQuery = {
  __typename: 'Query'
  PartnerListInvoiceSummaries?: Array<{
    __typename: 'InvoiceSummary'
    id: string
    frequency: InvoiceSummaryFrequency
    customDay?: number | null
    startAt?: string | null
    createdAt?: string | null
    sentHour: number
    timezone?: Timezone | null
    enabled: boolean
    cc?: Array<string> | null
    bcc?: Array<string> | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    } | null> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    } | null> | null
  } | null> | null
}

export type PartnerFindSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerFindSummaryQuery = {
  __typename: 'Query'
  PartnerFindSummary?: {
    __typename: 'InvoiceSummary'
    id: string
    frequency: InvoiceSummaryFrequency
    customDay?: number | null
    startAt?: string | null
    createdAt?: string | null
    sentHour: number
    timezone?: Timezone | null
    enabled: boolean
    cc?: Array<string> | null
    bcc?: Array<string> | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    } | null> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    } | null> | null
  } | null
}

export type PartnerListInvoiceSummaryExcludedCustomersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceSummaryExcludedCustomersQuery = {
  __typename: 'Query'
  PartnerListInvoiceSummaryExcludedCustomers?: Array<{
    __typename: 'InvoiceSummaryExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerCreateInvoiceSummaryMutationVariables = Exact<{
  input?: InputMaybe<PartnerCreateInvoiceSummaryInput>
}>

export type PartnerCreateInvoiceSummaryMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceSummary?: {
    __typename: 'InvoiceSummary'
    id: string
    frequency: InvoiceSummaryFrequency
    customDay?: number | null
    startAt?: string | null
    createdAt?: string | null
    sentHour: number
    timezone?: Timezone | null
    enabled: boolean
    cc?: Array<string> | null
    bcc?: Array<string> | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    } | null> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    } | null> | null
  } | null
}

export type PartnerDeleteInvoiceSummaryMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteInvoiceSummaryMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceSummary?: string | null
}

export type PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables =
  Exact<{
    customerID: Scalars['ID']['input']
  }>

export type PartnerCreateInvoiceSummaryExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceSummaryExcludedCustomer?: {
    __typename: 'InvoiceSummaryExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null
}

export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables =
  Exact<{
    customerIDs?: InputMaybe<
      Array<Scalars['ID']['input']> | Scalars['ID']['input']
    >
  }>

export type PartnerUpdateInvoiceSummaryExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerUpdateInvoiceSummaryExcludedCustomer?: Array<{
    __typename: 'InvoiceSummaryExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables =
  Exact<{
    id: Scalars['ID']['input']
  }>

export type PartnerDeleteInvoiceSummaryExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceSummaryExcludedCustomer?: string | null
}

export type PartnerSendInvoiceSummaryPreviewMutationVariables = Exact<{
  input: InvoiceSummaryPreviewInput
}>

export type PartnerSendInvoiceSummaryPreviewMutation = {
  __typename: 'Mutation'
  PartnerSendInvoiceSummaryPreview?: string | null
}

export type PartnerToggleSummaryEnabledMutationVariables = Exact<{
  id: Scalars['ID']['input']
  enabled: Scalars['Boolean']['input']
}>

export type PartnerToggleSummaryEnabledMutation = {
  __typename: 'Mutation'
  PartnerToggleSummaryEnabled?: string | null
}

export type PartnerInvoiceSummaryFragment = {
  __typename: 'InvoiceSummary'
  id: string
  frequency: InvoiceSummaryFrequency
  customDay?: number | null
  startAt?: string | null
  createdAt?: string | null
  sentHour: number
  timezone?: Timezone | null
  enabled: boolean
  cc?: Array<string> | null
  bcc?: Array<string> | null
  template?: {
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  } | null
  tags?: Array<{
    __typename: 'CustomerTag'
    ID: string
    name: string
    description?: string | null
    color?: TagColor | null
    type?: TagType | null
  } | null> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    tagIDs?: Array<string> | null
  } | null> | null
}

export type PartnerInvoiceSummaryExcludedCustomerFragment = {
  __typename: 'InvoiceSummaryExcludedCustomer'
  id: string
  createdAt: string
  customer: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  }
}

export type PartnerGetNotificationsEnabledQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetNotificationsEnabledQuery = {
  __typename: 'Query'
  PartnerGetNotificationsEnabled: {
    __typename: 'NotificationsEnabled'
    id: string
    notificationsEnabled: boolean
  }
}

export type PartnerUpdateNotificationsEnabledMutationVariables = Exact<{
  notificationsEnabled: Scalars['Boolean']['input']
}>

export type PartnerUpdateNotificationsEnabledMutation = {
  __typename: 'Mutation'
  PartnerUpdateNotificationsEnabled: {
    __typename: 'NotificationsEnabled'
    id: string
    notificationsEnabled: boolean
  }
}

export type PartnerSendOneOffEmailMutationVariables = Exact<{
  input: SendOneOffEmailInput
}>

export type PartnerSendOneOffEmailMutation = {
  __typename: 'Mutation'
  PartnerSendOneOffEmail?: string | null
}

export type OpenPayoutSummaryQueryVariables = Exact<{ [key: string]: never }>

export type OpenPayoutSummaryQuery = {
  __typename: 'Query'
  PartnerGetOpenPayoutBalanceTotals?: {
    __typename: 'OpenPayoutBalanceTotals'
    available: { __typename: 'Decimal'; units: number; nanos: number }
    pending: { __typename: 'Decimal'; units: number; nanos: number }
    total: { __typename: 'Decimal'; units: number; nanos: number }
  } | null
  PartnerGetPayoutTimingCompanyConfig?: {
    __typename: 'CompanyPayoutTimingConfigs'
    activeConfig?: {
      __typename: 'PayoutTimingCompanyConfig'
      businessDaysToHold: number
      payoutTimingFee?: {
        __typename: 'PayoutTimingFee'
        fixedFee: number
        percentageFee: number
        capFee: number
      } | null
    } | null
  } | null
  PartnerGetPayoutConfig?: {
    __typename: 'PayoutCompanyConfig'
    defaultBankingAccount?: {
      __typename: 'Account'
      id: string
      mask?: string | null
      institution?: { __typename: 'Institution'; name?: string | null } | null
    } | null
  } | null
}

export type OpenPayoutsConnectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>
  after?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<OpenPayoutFilters>
}>

export type OpenPayoutsConnectionQuery = {
  __typename: 'Query'
  PartnerGetOpenPayoutsConnection?: {
    __typename: 'OpenPayoutConnection'
    edges?: Array<{
      __typename: 'OpenPayoutEdge'
      cursor: string
      node: {
        __typename: 'OpenPayout'
        id: string
        payoutWindowDate: any
        numberOfPayments: number
        transactionNetwork: string
        productID?: string | null
        amount: { __typename: 'Decimal'; units: number; nanos: number }
        netAmount: { __typename: 'Decimal'; units: number; nanos: number }
      }
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type OpenPayoutDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type OpenPayoutDetailsQuery = {
  __typename: 'Query'
  PartnerGetOpenPayoutDetails?: {
    __typename: 'OpenPayoutDetails'
    id: string
    payoutWindowDate: any
    amount: { __typename: 'Decimal'; units: number; nanos: number }
    netAmount: { __typename: 'Decimal'; units: number; nanos: number }
    fees: Array<{
      __typename: 'OpenPayoutFee'
      label: string
      description: string
      forwarded: boolean
      amount: { __typename: 'Decimal'; units: number; nanos: number }
    } | null>
    breakdownTotals: Array<{
      __typename: 'OpenPayoutBreakdownTotals'
      productType: BreakdownProductType
      productTypeCount: number
      feesGreaterThanZeroCount: number
      sumFees: { __typename: 'Decimal'; units: number; nanos: number }
      sumGrossAmount: { __typename: 'Decimal'; units: number; nanos: number }
      sumAcceleratedPayoutFees: {
        __typename: 'Decimal'
        units: number
        nanos: number
      }
      acceleratedPayoutCapFee: {
        __typename: 'Decimal'
        units: number
        nanos: number
      }
    } | null>
  } | null
}

export type PartnerOpenPayoutDetailsFragment = {
  __typename: 'OpenPayoutDetails'
  id: string
  payoutWindowDate: any
  amount: { __typename: 'Decimal'; units: number; nanos: number }
  netAmount: { __typename: 'Decimal'; units: number; nanos: number }
  fees: Array<{
    __typename: 'OpenPayoutFee'
    label: string
    description: string
    forwarded: boolean
    amount: { __typename: 'Decimal'; units: number; nanos: number }
  } | null>
  breakdownTotals: Array<{
    __typename: 'OpenPayoutBreakdownTotals'
    productType: BreakdownProductType
    productTypeCount: number
    feesGreaterThanZeroCount: number
    sumFees: { __typename: 'Decimal'; units: number; nanos: number }
    sumGrossAmount: { __typename: 'Decimal'; units: number; nanos: number }
    sumAcceleratedPayoutFees: {
      __typename: 'Decimal'
      units: number
      nanos: number
    }
    acceleratedPayoutCapFee: {
      __typename: 'Decimal'
      units: number
      nanos: number
    }
  } | null>
}

export type OpenPayoutBreakdownItemsConnectionQueryVariables = Exact<{
  openPayoutID: Scalars['ID']['input']
  first?: InputMaybe<Scalars['Int']['input']>
  after?: InputMaybe<Scalars['Cursor']['input']>
}>

export type OpenPayoutBreakdownItemsConnectionQuery = {
  __typename: 'Query'
  PartnerGetOpenPayoutBreakdownItemsConnection?: {
    __typename: 'OpenPayoutBreakdownItemConnection'
    edges?: Array<{
      __typename: 'OpenPayoutBreakdownItemEdge'
      cursor: string
      node: {
        __typename: 'OpenPayoutBreakdownItem'
        id: string
        createdAt: any
        transactionDate?: any | null
        transactionType: BreakdownProductType
        companyType: CompanyType
        transaction?: { __typename: 'Transaction'; id: string } | null
        product?:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              customer?: {
                __typename: 'Customer'
                id: string
                name?: string | null
              } | null
              payments?: Array<{
                __typename: 'InvoicePayment'
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | {
              __typename: 'OneTimePayment'
              id: string
              referenceId?: string | null
            }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | {
              __typename: 'Refund'
              id: string
              paymentID: string
              paymentReferenceId?: string | null
            }
          | { __typename: 'SubscriptionPayment' }
          | null
        fee: { __typename: 'Decimal'; units: number; nanos: number }
        grossAmount: { __typename: 'Decimal'; units: number; nanos: number }
        paymentMethod?:
          | { __typename: 'Account'; id: string; name?: string | null }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              fundingSource: FundingSource
            }
          | null
        partner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
        } | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
      }
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerOpenPayoutBreakdownItemFragment = {
  __typename: 'OpenPayoutBreakdownItem'
  id: string
  createdAt: any
  transactionDate?: any | null
  transactionType: BreakdownProductType
  companyType: CompanyType
  transaction?: { __typename: 'Transaction'; id: string } | null
  product?:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
        payments?: Array<{
          __typename: 'InvoicePayment'
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'OneTimePayment'; id: string; referenceId?: string | null }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | {
        __typename: 'Refund'
        id: string
        paymentID: string
        paymentReferenceId?: string | null
      }
    | { __typename: 'SubscriptionPayment' }
    | null
  fee: { __typename: 'Decimal'; units: number; nanos: number }
  grossAmount: { __typename: 'Decimal'; units: number; nanos: number }
  paymentMethod?:
    | { __typename: 'Account'; id: string; name?: string | null }
    | {
        __typename: 'Card'
        id: string
        cardNetWork: CardNetwork
        fundingSource: FundingSource
      }
    | null
  partner?: { __typename: 'Partner'; id: string; name?: string | null } | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
}

export type GetOverviewSummaryQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
}>

export type GetOverviewSummaryQuery = {
  __typename: 'Query'
  PartnerGetOverviewSummary: {
    __typename: 'OverviewSummaryResult'
    grossRevenue: { __typename: 'OverviewKPI'; value: number; change: number }
    netProfit: {
      __typename: 'OverviewKPI'
      value: number
      change: number
      benchmark?: number | null
      benchmarkDeltaPp?: number | null
    }
  }
}

export type GetOverviewProfitabilityQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
}>

export type GetOverviewProfitabilityQuery = {
  __typename: 'Query'
  PartnerGetOverviewProfitability: {
    __typename: 'OverviewProfitabilityResult'
    totalRevenue: number
    totalProfit: number
    months: Array<{
      __typename: 'OverviewProfitabilityMonth'
      month: string
      revenue: number
      profit: number
      benchmark?: number | null
    }>
  }
}

export type GetOverviewMrrQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
}>

export type GetOverviewMrrQuery = {
  __typename: 'Query'
  PartnerGetOverviewMRR: {
    __typename: 'OverviewMRRResult'
    currentMrr: number
    gainedMrr: number
    lostMrr: number
    netMrrChange: number
    trend: Array<{
      __typename: 'OverviewMRRTrendMonth'
      month: string
      mrr: number
      gainedMrr: number
      lostMrr: number
      netChange: number
      benchmark?: number | null
    }>
  }
}

export type GetOverviewEfficiencyQueryVariables = Exact<{
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
}>

export type GetOverviewEfficiencyQuery = {
  __typename: 'Query'
  PartnerGetOverviewEfficiency: {
    __typename: 'OverviewEfficiencyResult'
    utilization: {
      __typename: 'OverviewKPI'
      value: number
      change: number
      benchmark?: number | null
    }
    ticketLoad: {
      __typename: 'OverviewKPI'
      value: number
      change: number
      benchmark?: number | null
    }
    laborEfficiencyRatio: {
      __typename: 'OverviewKPI'
      value: number
      change: number
      benchmark?: number | null
    }
  }
}

export type GetPartnerDocumentsQueryVariables = Exact<{ [key: string]: never }>

export type GetPartnerDocumentsQuery = {
  __typename: 'Query'
  GetPartnerDocuments: Array<{
    __typename: 'CompanyDocument'
    id: string
    partnerID: string
    type: PartnerDocumentType
    filename?: string | null
    createdAt: string
  }>
}

export type PartnerUpdateInvoicePdfSettingsMutationVariables = Exact<{
  input: PartnerUpdateInvoicePdfSettingsInput
}>

export type PartnerUpdateInvoicePdfSettingsMutation = {
  __typename: 'Mutation'
  PartnerUpdateInvoicePdfSettings?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    ein?: string | null
    incorporationNumber?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type PartnerUpdateInformationMutationVariables = Exact<{
  detailsInput?: InputMaybe<PartnerUpdateDetailsInput>
  addressInput?: InputMaybe<PartnerUpdateAddressInput>
}>

export type PartnerUpdateInformationMutation = {
  __typename: 'Mutation'
  PartnerUpdateAddress?: {
    __typename: 'Partner'
    id: string
    city?: string | null
    state?: string | null
    stateCode?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    streetAddress?: string | null
    subPremise?: string | null
  } | null
  PartnerUpdateDetails?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    ein?: string | null
    incorporationNumber?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type PartnerUpdateTimezoneMutationVariables = Exact<{
  input: PartnerUpdateTimezoneInput
}>

export type PartnerUpdateTimezoneMutation = {
  __typename: 'Mutation'
  PartnerUpdateTimezone?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    ein?: string | null
    incorporationNumber?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type ActivatePartnerPaymentsPortalMutationVariables = Exact<{
  [key: string]: never
}>

export type ActivatePartnerPaymentsPortalMutation = {
  __typename: 'Mutation'
  ActivatePartnerPaymentsPortal?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalUrl?: string | null
  } | null
}

export type GetCompanyIndividualsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetCompanyIndividualsQuery = {
  __typename: 'Query'
  GetCompanyIndividuals: Array<{
    __typename: 'CompanyIndividual'
    id: string
    partnerID: string
    firstName: string
    lastName: string
    email: string
    phone: string
    dateOfBirth: string
    jobTitle: string
    country: string
    countryCode: string
    streetAddress: string
    subPremise: string
    postalCode: string
    state: string
    stateCode: string
    city: string
    hasSSN: boolean
    owner: boolean
    signatory: boolean
    controllingPerson: boolean
  }>
}

export type GetCompanyIndividualsWithDocumentsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetCompanyIndividualsWithDocumentsQuery = {
  __typename: 'Query'
  GetCompanyIndividuals: Array<{
    __typename: 'CompanyIndividual'
    id: string
    partnerID: string
    firstName: string
    lastName: string
    email: string
    phone: string
    dateOfBirth: string
    jobTitle: string
    country: string
    countryCode: string
    streetAddress: string
    subPremise: string
    postalCode: string
    state: string
    stateCode: string
    city: string
    hasSSN: boolean
    owner: boolean
    signatory: boolean
    controllingPerson: boolean
    individualDocuments?: Array<{
      __typename: 'CompanyDocument'
      id: string
      partnerID: string
      type: PartnerDocumentType
      url: string
      filename?: string | null
      createdAt: string
      individualID?: string | null
    } | null> | null
  }>
}

export type CreateCompanyIndividualMutationVariables = Exact<{
  input: CreateCompanyIndividualInput
}>

export type CreateCompanyIndividualMutation = {
  __typename: 'Mutation'
  CreateCompanyIndividual: {
    __typename: 'CompanyIndividual'
    id: string
    partnerID: string
    firstName: string
    lastName: string
    email: string
    phone: string
    dateOfBirth: string
    jobTitle: string
    country: string
    countryCode: string
    streetAddress: string
    subPremise: string
    postalCode: string
    state: string
    stateCode: string
    city: string
    hasSSN: boolean
    owner: boolean
    signatory: boolean
    controllingPerson: boolean
  }
}

export type UpdateCompanyIndividualMutationVariables = Exact<{
  input: UpdateCompanyIndividualInput
}>

export type UpdateCompanyIndividualMutation = {
  __typename: 'Mutation'
  UpdateCompanyIndividual: string
}

export type DeleteCompanyIndividualMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteCompanyIndividualMutation = {
  __typename: 'Mutation'
  DeleteCompanyIndividual: string
}

export type PartnerDeleteCompanyDocumentsByIndividualIdMutationVariables =
  Exact<{
    individualId: Scalars['ID']['input']
  }>

export type PartnerDeleteCompanyDocumentsByIndividualIdMutation = {
  __typename: 'Mutation'
  PartnerDeleteCompanyDocumentsByIndividualId: boolean
}

export type PartnerCreateCompanyIndividualUploadLinkMutationVariables = Exact<{
  individualID: Scalars['ID']['input']
}>

export type PartnerCreateCompanyIndividualUploadLinkMutation = {
  __typename: 'Mutation'
  PartnerCreateCompanyIndividualUploadLink?: {
    __typename: 'CompanyIndividualUploadLinkResponse'
    id: string
    partnerID: string
    individualID: string
    expirationDate: string
  } | null
}

export type UploadPartnerDocumentMutationVariables = Exact<{
  input: UploadPartnerDocumentInput
}>

export type UploadPartnerDocumentMutation = {
  __typename: 'Mutation'
  UploadPartnerDocument: string
}

export type UpsertSupportPreferencesMutationVariables = Exact<{
  input: UpsertSupportPreferencesInput
}>

export type UpsertSupportPreferencesMutation = {
  __typename: 'Mutation'
  UpsertSupportPreferences?: {
    __typename: 'SupportPreferences'
    partnerID: string
    name: string
    email: string
    phone?: string | null
    firstLine: string
    secondLine?: string | null
  } | null
}

export type GetSupportPreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSupportPreferencesQuery = {
  __typename: 'Query'
  GetSupportPreferences?: {
    __typename: 'SupportPreferences'
    partnerID: string
    name: string
    email: string
    phone?: string | null
    firstLine: string
    secondLine?: string | null
  } | null
}

export type GetUserPartnersQueryVariables = Exact<{ [key: string]: never }>

export type GetUserPartnersQuery = {
  __typename: 'Query'
  GetUserPartners: Array<{
    __typename: 'Partner'
    id: string
    name?: string | null
  } | null>
}

export type PartnerFinishOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type PartnerFinishOnboardingMutation = {
  __typename: 'Mutation'
  PartnerFinishOnboarding?: {
    __typename: 'Partner'
    id: string
    isOnboarded: boolean
  } | null
}

export type PartnerUpdateDetailsMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateDetailsInput>
}>

export type PartnerUpdateDetailsMutation = {
  __typename: 'Mutation'
  PartnerUpdateDetails?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    ein?: string | null
    incorporationNumber?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type PartnerUpdateAddressMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateAddressInput>
}>

export type PartnerUpdateAddressMutation = {
  __typename: 'Mutation'
  PartnerUpdateAddress?: {
    __typename: 'Partner'
    id: string
    city?: string | null
    state?: string | null
    stateCode?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    streetAddress?: string | null
    subPremise?: string | null
  } | null
}

export type PartnerTogglePaymentsPortalCustomInvoicesMutationVariables = Exact<{
  paymentsPortalCustomInvoices: Scalars['Boolean']['input']
}>

export type PartnerTogglePaymentsPortalCustomInvoicesMutation = {
  __typename: 'Mutation'
  PartnerTogglePaymentsPortalCustomInvoices?: {
    __typename: 'Partner'
    paymentsPortalCustomInvoices?: boolean | null
  } | null
}

export type PartnerToggleRequiresMfaMutationVariables = Exact<{
  requiresMFA: Scalars['Boolean']['input']
}>

export type PartnerToggleRequiresMfaMutation = {
  __typename: 'Mutation'
  PartnerToggleRequiresMFA?: {
    __typename: 'Partner'
    id: string
    requiresMFA: boolean
  } | null
}

export type PartnerUpdateNameMutationVariables = Exact<{
  input: UpdatePartnerNameInput
}>

export type PartnerUpdateNameMutation = {
  __typename: 'Mutation'
  PartnerUpdateName?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    ein?: string | null
    incorporationNumber?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type CompanyDocumentFragment = {
  __typename: 'CompanyDocument'
  id: string
  partnerID: string
  type: PartnerDocumentType
  url: string
  filename?: string | null
  createdAt: string
  individualID?: string | null
}

export type CompanyIndividualFragment = {
  __typename: 'CompanyIndividual'
  id: string
  partnerID: string
  firstName: string
  lastName: string
  email: string
  phone: string
  dateOfBirth: string
  jobTitle: string
  country: string
  countryCode: string
  streetAddress: string
  subPremise: string
  postalCode: string
  state: string
  stateCode: string
  city: string
  hasSSN: boolean
  owner: boolean
  signatory: boolean
  controllingPerson: boolean
}

export type CompanyIndividualWithDocumentsFragment = {
  __typename: 'CompanyIndividual'
  id: string
  partnerID: string
  firstName: string
  lastName: string
  email: string
  phone: string
  dateOfBirth: string
  jobTitle: string
  country: string
  countryCode: string
  streetAddress: string
  subPremise: string
  postalCode: string
  state: string
  stateCode: string
  city: string
  hasSSN: boolean
  owner: boolean
  signatory: boolean
  controllingPerson: boolean
  individualDocuments?: Array<{
    __typename: 'CompanyDocument'
    id: string
    partnerID: string
    type: PartnerDocumentType
    url: string
    filename?: string | null
    createdAt: string
    individualID?: string | null
  } | null> | null
}

export type PartnerBaseFragment = {
  __typename: 'Partner'
  id: string
  name?: string | null
  legalName?: string | null
  isOnboarded: boolean
  adyenOnboardingStatus: AdyenOnboardingStatusStep
  insightsEnabled: boolean
  timezone?: Timezone | null
  useUserLocalTimezone?: boolean | null
  timezoneSetAt?: string | null
  attachInvoicePDFEnabled?: boolean | null
  pdfFallbackEnabled?: boolean | null
}

export type PartnerSidebarItemFragment = {
  __typename: 'Partner'
  id: string
  name?: string | null
}

export type PartnerDetailsFragment = {
  __typename: 'Partner'
  ein?: string | null
  incorporationNumber?: string | null
  companyType?: string | null
  industry?: string | null
  description?: string | null
}

export type PartnerConfigFragment = {
  __typename: 'Partner'
  paymentsPortalEnabled: boolean
  paymentsPortalUrl?: string | null
  paymentsPortalCustomUrl?: string | null
  paymentsPortalUseCustomUrl?: boolean | null
  paymentsPortalDefaultUrl?: string | null
  paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  paymentsPortalCustomization: {
    __typename: 'PartnerPaymentsPortalCustomization'
    color?: string | null
    logoUrl?: string | null
  }
}

export type PartnerAddressDetailsFragment = {
  __typename: 'Partner'
  city?: string | null
  state?: string | null
  stateCode?: string | null
  country?: string | null
  countryCode?: string | null
  postalCode?: string | null
  streetAddress?: string | null
  subPremise?: string | null
}

export type SupportPreferencesFragment = {
  __typename: 'SupportPreferences'
  partnerID: string
  name: string
  email: string
  phone?: string | null
  firstLine: string
  secondLine?: string | null
}

export type PartnerGetPartnerAutopayConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetPartnerAutopayConfigQuery = {
  __typename: 'Query'
  PartnerGetPartnerAutopayConfig?: {
    __typename: 'PartnerAutopayConfig'
    id: string
    allowCustomerEdit?: boolean | null
    customerPaymentFailureLimit?: number | null
  } | null
}

export type PartnerChangePartnerAutopayConfigMutationVariables = Exact<{
  partnerAutopayConfig: PartnerAutopayConfigUpdateInput
}>

export type PartnerChangePartnerAutopayConfigMutation = {
  __typename: 'Mutation'
  PartnerChangePartnerAutopayConfig?: string | null
}

export type PartnerCancelScheduledPaymentMutationVariables = Exact<{
  paymentID: Scalars['UUID']['input']
}>

export type PartnerCancelScheduledPaymentMutation = {
  __typename: 'Mutation'
  PartnerCancelScheduledPayment?: string | null
}

export type PartnerReschedulePaymentMutationVariables = Exact<{
  paymentID: Scalars['UUID']['input']
  newDueDate: Scalars['Time']['input']
}>

export type PartnerReschedulePaymentMutation = {
  __typename: 'Mutation'
  PartnerReschedulePayment?: string | null
}

export type PartnerPaymentConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  paymentFilter?: InputMaybe<PaymentFilter>
  orderBy?: InputMaybe<PaymentOrder>
}>

export type PartnerPaymentConnectionQuery = {
  __typename: 'Query'
  PartnerPaymentConnection?: {
    __typename: 'PaymentConnection'
    edges?: Array<{
      __typename: 'PaymentEdge'
      node?: {
        __typename: 'Payment'
        id: string
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: MethodEnum | null
        dueDate?: string | null
        paymentCompletionForecastDate?: string | null
        originService: PaymentAlternativeService
        executorType: PaymentExecutorType
        paymentFees: Array<{
          __typename: 'PaymentFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        currentPaymentMethodEntity?:
          | {
              __typename: 'Account'
              id: string
              name?: string | null
              mask?: string | null
              type?: string | null
            }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              last4: string
              fundingSource: FundingSource
            }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | {
              __typename: 'OneTimePayment'
              id: string
              referenceId?: string | null
            }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | {
              __typename: 'SubscriptionPayment'
              id: string
              paymentDate: string
              amount: number
              subscriptionStatus: SubscriptionPaymentStatus
              subscription: {
                __typename: 'PartnerSubscription'
                id: string
                type: string
                frequency: SubscriptionFrequency
              }
            }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
          failureReasonCode?: string | null
          status: TransactionStatus
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        refunds?: Array<{
          __typename: 'Refund'
          id: string
          amount: number
          createdAt: string
          lastStatus: RefundStatusEnum
          status?: Array<{
            __typename: 'RefundStatus'
            id: string
            status: RefundStatusEnum
            createdAt: string
          }> | null
        } | null> | null
        payoutEstimation: {
          __typename: 'PaymentPayoutEstimation'
          estimatedPayoutCreationDate?: string | null
        }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: any | null
      endCursor?: any | null
    }
  } | null
}

export type PartnerListPaymentsQueryVariables = Exact<{
  paymentFilter?: InputMaybe<PaymentFilter>
  pagination: Pagination
  orderBy?: InputMaybe<PaymentOrder>
}>

export type PartnerListPaymentsQuery = {
  __typename: 'Query'
  PartnerListPayments?: {
    __typename: 'PaymentPage'
    total: number
    limit: number
    page: number
    data: Array<{
      __typename: 'Payment'
      id: string
      amount: number
      netAmount: number
      creationDate: string
      currentPaymentMethod?: MethodEnum | null
      dueDate?: string | null
      paymentCompletionForecastDate?: string | null
      originService: PaymentAlternativeService
      executorType: PaymentExecutorType
      paymentFees: Array<{
        __typename: 'PaymentFee'
        forwarded: boolean
        type: FeeType
        amount: number
        name: string
      } | null>
      currentPaymentMethodEntity?:
        | {
            __typename: 'Account'
            id: string
            name?: string | null
            mask?: string | null
            type?: string | null
          }
        | {
            __typename: 'Card'
            id: string
            cardNetWork: CardNetwork
            last4: string
            fundingSource: FundingSource
          }
        | null
      customer?: {
        __typename: 'Customer'
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
      } | null
      product:
        | { __typename: 'InstantPayment' }
        | {
            __typename: 'Invoice'
            id: string
            invoiceNumber: string
            productName?: string | null
            status: InvoiceStatusEnum
            amount: number
            dueDate?: string | null
            outstandingAmount: number
            platformName: string
            totalDiscountAmount: number
            statuses: Array<{
              __typename: 'InvoiceStatus'
              status: InvoiceStatusEnum
              createdAt: any
            } | null>
            payments?: Array<{
              __typename: 'InvoicePayment'
              id: string
              status: PaymentStatusEnum
              payoutCreationForecastDate?: string | null
            } | null> | null
          }
        | { __typename: 'Offer' }
        | {
            __typename: 'OneTimePayment'
            id: string
            referenceId?: string | null
          }
        | { __typename: 'Referral' }
        | { __typename: 'ReferralBonus' }
        | { __typename: 'Refund' }
        | {
            __typename: 'SubscriptionPayment'
            id: string
            paymentDate: string
            amount: number
            subscriptionStatus: SubscriptionPaymentStatus
            subscription: {
              __typename: 'PartnerSubscription'
              id: string
              type: string
              frequency: SubscriptionFrequency
            }
          }
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
        failureReasonCode?: string | null
        status: TransactionStatus
      } | null
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
        createdAt: string
      } | null>
      refunds?: Array<{
        __typename: 'Refund'
        id: string
        amount: number
        createdAt: string
        lastStatus: RefundStatusEnum
        status?: Array<{
          __typename: 'RefundStatus'
          id: string
          status: RefundStatusEnum
          createdAt: string
        }> | null
      } | null> | null
      payoutEstimation: {
        __typename: 'PaymentPayoutEstimation'
        estimatedPayoutCreationDate?: string | null
      }
    } | null>
  } | null
}

export type PartnerPaymentTotalsQueryVariables = Exact<{
  paymentFilter?: InputMaybe<PaymentFilter>
}>

export type PartnerPaymentTotalsQuery = {
  __typename: 'Query'
  PartnerPaymentTotals?: {
    __typename: 'PaymentTotals'
    count: number
    amount: number
    netAmount: number
  } | null
}

export type PartnerCalculatePaymentFeeQueryVariables = Exact<{
  input: CalculatePaymentFeeInput
}>

export type PartnerCalculatePaymentFeeQuery = {
  __typename: 'Query'
  PartnerCalculatePaymentFee: {
    __typename: 'FeeSplitResult'
    relativeFeeAmountCustomer: number
    fixedFeeAmountCustomer: number
    relativeFeeAmountPartner: number
    fixedFeeAmountPartner: number
    feePercentageForCustomer: number
    feePercentageForPartner: number
  }
}

export type PartnerPaymentFragment = {
  __typename: 'Payment'
  id: string
  amount: number
  netAmount: number
  creationDate: string
  currentPaymentMethod?: MethodEnum | null
  dueDate?: string | null
  paymentCompletionForecastDate?: string | null
  originService: PaymentAlternativeService
  executorType: PaymentExecutorType
  paymentFees: Array<{
    __typename: 'PaymentFee'
    forwarded: boolean
    type: FeeType
    amount: number
    name: string
  } | null>
  currentPaymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        name?: string | null
        mask?: string | null
        type?: string | null
      }
    | {
        __typename: 'Card'
        id: string
        cardNetWork: CardNetwork
        last4: string
        fundingSource: FundingSource
      }
    | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'OneTimePayment'; id: string; referenceId?: string | null }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | {
        __typename: 'SubscriptionPayment'
        id: string
        paymentDate: string
        amount: number
        subscriptionStatus: SubscriptionPaymentStatus
        subscription: {
          __typename: 'PartnerSubscription'
          id: string
          type: string
          frequency: SubscriptionFrequency
        }
      }
  transaction?: {
    __typename: 'Transaction'
    failureReason?: string | null
    failureReasonCode?: string | null
    status: TransactionStatus
  } | null
  statuses: Array<{
    __typename: 'PaymentStatus'
    status?: PaymentStatusEnum | null
    createdAt: string
  } | null>
  refunds?: Array<{
    __typename: 'Refund'
    id: string
    amount: number
    createdAt: string
    lastStatus: RefundStatusEnum
    status?: Array<{
      __typename: 'RefundStatus'
      id: string
      status: RefundStatusEnum
      createdAt: string
    }> | null
  } | null> | null
  payoutEstimation: {
    __typename: 'PaymentPayoutEstimation'
    estimatedPayoutCreationDate?: string | null
  }
}

export type PartnerGetCustomerPaymentConfigQueryVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerGetCustomerPaymentConfigQuery = {
  __typename: 'Query'
  PartnerGetCustomerPaymentConfig?: {
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: MethodEnum | null
    company:
      | { __typename: 'Customer'; id: string; name?: string | null }
      | { __typename: 'Partner' }
    paymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          type?: string | null
          subtype?: string | null
          hasAchAccountNumber?: boolean | null
          hasAchRoutingNumber?: boolean | null
          hasWireRoutingNumber?: boolean | null
          transitNumber?: string | null
          customName?: string | null
          provider?: string | null
          disconnectedAt?: string | null
          systemDeactivatedAt?: string | null
          companyName?: string | null
          institution?: {
            __typename: 'Institution'
            name?: string | null
            id: string
            logo?: string | null
          } | null
          mandates?: Array<{
            __typename: 'Mandate'
            id: string
            consentAt: string
            version: string
          } | null> | null
        }
      | {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
          fundingSource: FundingSource
          customName?: string | null
          hasPostalCode: boolean
          isExpired: boolean
          billingAddress?: {
            __typename: 'Address'
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            state?: string | null
            stateCode?: string | null
            postalCode?: string | null
            country?: string | null
            countryISO?: string | null
          } | null
        }
      | null
  } | null
}

export type PartnerGetCustomersPaymentConfigQueryVariables = Exact<{
  customerIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerGetCustomersPaymentConfigQuery = {
  __typename: 'Query'
  PartnerGetCustomersPaymentConfig?: Array<{
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: MethodEnum | null
    company:
      | { __typename: 'Customer'; id: string; name?: string | null }
      | { __typename: 'Partner' }
  } | null> | null
}

export type PartnerGetPaymentConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetPaymentConfigQuery = {
  __typename: 'Query'
  PartnerGetPaymentConfig?: {
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: MethodEnum | null
    paymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          customName?: string | null
          institution?: {
            __typename: 'Institution'
            id: string
            logo?: string | null
          } | null
        }
      | {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
          customName?: string | null
          fundingSource: FundingSource
        }
      | null
  } | null
}

export type PartnerChangePaymentConfigMutationVariables = Exact<{
  paymentConfig: PaymentCompanyConfigUpdateInput
}>

export type PartnerChangePaymentConfigMutation = {
  __typename: 'Mutation'
  PartnerChangePaymentConfig?: string | null
}

export type PartnerChangeCustomerPaymentConfigMutationVariables = Exact<{
  paymentConfig: PaymentCompanyConfigUpdateInput
  customerID: Scalars['ID']['input']
}>

export type PartnerChangeCustomerPaymentConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeCustomerPaymentConfig?: string | null
}

export type PaymentConfigFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: MethodEnum | null
  paymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        customName?: string | null
        institution?: {
          __typename: 'Institution'
          id: string
          logo?: string | null
        } | null
      }
    | {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
        customName?: string | null
        fundingSource: FundingSource
      }
    | null
}

export type CustomerPaymentMethodFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: MethodEnum | null
  company:
    | { __typename: 'Customer'; id: string; name?: string | null }
    | { __typename: 'Partner' }
  paymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        type?: string | null
        subtype?: string | null
        hasAchAccountNumber?: boolean | null
        hasAchRoutingNumber?: boolean | null
        hasWireRoutingNumber?: boolean | null
        transitNumber?: string | null
        customName?: string | null
        provider?: string | null
        disconnectedAt?: string | null
        systemDeactivatedAt?: string | null
        companyName?: string | null
        institution?: {
          __typename: 'Institution'
          name?: string | null
          id: string
          logo?: string | null
        } | null
        mandates?: Array<{
          __typename: 'Mandate'
          id: string
          consentAt: string
          version: string
        } | null> | null
      }
    | {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
        fundingSource: FundingSource
        customName?: string | null
        hasPostalCode: boolean
        isExpired: boolean
        billingAddress?: {
          __typename: 'Address'
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          state?: string | null
          stateCode?: string | null
          postalCode?: string | null
          country?: string | null
          countryISO?: string | null
        } | null
      }
    | null
}

export type CustomersPaymentMethodFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: MethodEnum | null
  company:
    | { __typename: 'Customer'; id: string; name?: string | null }
    | { __typename: 'Partner' }
}

export type GetLogoUploadUrlQueryVariables = Exact<{ [key: string]: never }>

export type GetLogoUploadUrlQuery = {
  __typename: 'Query'
  PartnerLogoUploadURL?: {
    __typename: 'PartnerLogoUploadUrl'
    uploadURL: string
    uploadCDNURL: string
    uploadURLExpirationUTC: string
  } | null
}

export type PartnerUpdatePaymentsPortalMethodsMutationVariables = Exact<{
  methods: Array<PartnerPaymentsPortalMethod> | PartnerPaymentsPortalMethod
}>

export type PartnerUpdatePaymentsPortalMethodsMutation = {
  __typename: 'Mutation'
  PartnerUpdatePaymentsPortalMethods?: {
    __typename: 'Partner'
    id: string
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  } | null
}

export type PartnerUpdatePaymentsPortalCustomizationMutationVariables = Exact<{
  input?: InputMaybe<PartnerPaymentsPortalCustomizationInput>
}>

export type PartnerUpdatePaymentsPortalCustomizationMutation = {
  __typename: 'Mutation'
  PartnerUpdatePaymentsPortalCustomization?: {
    __typename: 'Partner'
    id: string
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type StagingEnablePartnerPaymentsPortalMutationVariables = Exact<{
  url: Scalars['String']['input']
}>

export type StagingEnablePartnerPaymentsPortalMutation = {
  __typename: 'Mutation'
  StagingEnablePartnerPaymentsPortal?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalUrl?: string | null
  } | null
}

export type PartnerPayoutConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  payoutFilter?: InputMaybe<PayoutFilter>
  orderBy?: InputMaybe<PayoutOrder>
}>

export type PartnerPayoutConnectionQuery = {
  __typename: 'Query'
  PartnerPayoutConnection?: {
    __typename: 'PayoutConnection'
    edges?: Array<{
      __typename: 'PayoutEdge'
      cursor: any
      node?: {
        __typename: 'Payout'
        id: string
        amount: number
        netAmount: number
        publicNumber: string
        creationDate: string
        payoutCompletionForecastDate?: string | null
        fees: Array<{
          __typename: 'PayoutFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | { __typename: 'OneTimePayment' }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | { __typename: 'SubscriptionPayment' }
        statuses: Array<{
          __typename: 'PayoutStatus'
          status?: PayoutStatusEnum | null
          createdAt: string
        } | null>
        transactions: Array<{
          __typename: 'Transaction'
          failureReason?: string | null
          transactionMethod: TransactionMethod
          status: TransactionStatus
        } | null>
        account?: {
          __typename: 'Account'
          name?: string | null
          mask?: string | null
          institution?: {
            __typename: 'Institution'
            name?: string | null
          } | null
        } | null
        payoutBreakdownTotals?: Array<{
          __typename: 'PayoutBreakdownTotals'
          productType: BreakdownProductType
          productTypeCount: number
          sumFees: number
          sumGrossAmount: number
          feesGreaterThanZeroCount: number
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerPayoutTotalsQueryVariables = Exact<{
  payoutFilter?: InputMaybe<PayoutFilter>
}>

export type PartnerPayoutTotalsQuery = {
  __typename: 'Query'
  PartnerPayoutTotals?: {
    __typename: 'PayoutTotals'
    count: number
    amount: number
  } | null
}

export type PartnerPayoutDetailsQueryVariables = Exact<{
  payoutID: Scalars['ID']['input']
}>

export type PartnerPayoutDetailsQuery = {
  __typename: 'Query'
  PartnerPayoutDetails?: {
    __typename: 'PayoutDetails'
    id: string
    amount: number
    netAmount: number
    publicNumber: string
    payoutType: PayoutType
    creationDate: string
    payoutCompletionForecastDate?: string | null
    statuses: Array<{
      __typename: 'PayoutStatus'
      status?: PayoutStatusEnum | null
      createdAt: string
    } | null>
    payoutBreakdownTotals?: Array<{
      __typename: 'PayoutBreakdownTotals'
      productType: BreakdownProductType
      productTypeCount: number
      sumFees: number
      sumGrossAmount: number
      feesGreaterThanZeroCount: number
    } | null> | null
    product:
      | { __typename: 'InstantPayment' }
      | {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
          productName?: string | null
          status: InvoiceStatusEnum
          amount: number
          dueDate?: string | null
          outstandingAmount: number
          platformName: string
          totalDiscountAmount: number
          statuses: Array<{
            __typename: 'InvoiceStatus'
            status: InvoiceStatusEnum
            createdAt: any
          } | null>
          payments?: Array<{
            __typename: 'InvoicePayment'
            id: string
            status: PaymentStatusEnum
            payoutCreationForecastDate?: string | null
          } | null> | null
        }
      | { __typename: 'Offer' }
      | { __typename: 'OneTimePayment' }
      | { __typename: 'Referral' }
      | { __typename: 'ReferralBonus' }
      | { __typename: 'Refund' }
      | { __typename: 'SubscriptionPayment' }
    account?: {
      __typename: 'Account'
      name?: string | null
      mask?: string | null
      institution?: { __typename: 'Institution'; name?: string | null } | null
    } | null
    transactions: Array<{
      __typename: 'Transaction'
      failureReason?: string | null
      transactionMethod: TransactionMethod
      status: TransactionStatus
    } | null>
    fees: Array<{
      __typename: 'PayoutFee'
      name: string
      amount: number
    } | null>
  } | null
}

export type PayoutBreakdownTotalsFragment = {
  __typename: 'PayoutBreakdownTotals'
  productType: BreakdownProductType
  productTypeCount: number
  sumFees: number
  sumGrossAmount: number
  feesGreaterThanZeroCount: number
}

export type PartnerPayoutDetailsFragment = {
  __typename: 'PayoutDetails'
  id: string
  amount: number
  netAmount: number
  publicNumber: string
  payoutType: PayoutType
  creationDate: string
  payoutCompletionForecastDate?: string | null
  statuses: Array<{
    __typename: 'PayoutStatus'
    status?: PayoutStatusEnum | null
    createdAt: string
  } | null>
  payoutBreakdownTotals?: Array<{
    __typename: 'PayoutBreakdownTotals'
    productType: BreakdownProductType
    productTypeCount: number
    sumFees: number
    sumGrossAmount: number
    feesGreaterThanZeroCount: number
  } | null> | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'OneTimePayment' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
  account?: {
    __typename: 'Account'
    name?: string | null
    mask?: string | null
    institution?: { __typename: 'Institution'; name?: string | null } | null
  } | null
  transactions: Array<{
    __typename: 'Transaction'
    failureReason?: string | null
    transactionMethod: TransactionMethod
    status: TransactionStatus
  } | null>
  fees: Array<{ __typename: 'PayoutFee'; name: string; amount: number } | null>
}

export type TransactionFragment = {
  __typename: 'Transaction'
  failureReason?: string | null
  transactionMethod: TransactionMethod
  status: TransactionStatus
}

export type PartnerPayoutFragment = {
  __typename: 'Payout'
  id: string
  amount: number
  netAmount: number
  publicNumber: string
  creationDate: string
  payoutCompletionForecastDate?: string | null
  fees: Array<{
    __typename: 'PayoutFee'
    forwarded: boolean
    type: FeeType
    amount: number
    name: string
  } | null>
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'OneTimePayment' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
  statuses: Array<{
    __typename: 'PayoutStatus'
    status?: PayoutStatusEnum | null
    createdAt: string
  } | null>
  transactions: Array<{
    __typename: 'Transaction'
    failureReason?: string | null
    transactionMethod: TransactionMethod
    status: TransactionStatus
  } | null>
  account?: {
    __typename: 'Account'
    name?: string | null
    mask?: string | null
    institution?: { __typename: 'Institution'; name?: string | null } | null
  } | null
  payoutBreakdownTotals?: Array<{
    __typename: 'PayoutBreakdownTotals'
    productType: BreakdownProductType
    productTypeCount: number
    sumFees: number
    sumGrossAmount: number
    feesGreaterThanZeroCount: number
  } | null> | null
}

export type PartnerBreakdownListItemConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  breakdownFilter?: InputMaybe<BreakdownFilter>
}>

export type PartnerBreakdownListItemConnectionQuery = {
  __typename: 'Query'
  PartnerPayoutBreakdownListItemConnection?: {
    __typename: 'BreakdownListItemConnection'
    edges?: Array<{
      __typename: 'BreakdownListItemEdge'
      cursor: any
      node?: {
        __typename: 'BreakdownListItem'
        id: string
        createdAt: any
        transactionDate?: any | null
        transactionType: BreakdownProductType
        fee: number
        grossAmount: number
        companyType: CompanyType
        transaction?: { __typename: 'Transaction'; id: string } | null
        product?:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              customer?: {
                __typename: 'Customer'
                id: string
                name?: string | null
              } | null
              payments?: Array<{
                __typename: 'InvoicePayment'
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | {
              __typename: 'OneTimePayment'
              id: string
              referenceId?: string | null
            }
          | {
              __typename: 'Referral'
              id: string
              referralDate?: string | null
              referredPartner?: {
                __typename: 'Partner'
                id: string
                name?: string | null
              } | null
            }
          | {
              __typename: 'ReferralBonus'
              id: string
              description: string
              referralPayoutID: string
              amount: number
            }
          | {
              __typename: 'Refund'
              id: string
              paymentID: string
              paymentReferenceId?: string | null
            }
          | { __typename: 'SubscriptionPayment' }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        partner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
        } | null
        paymentMethod?:
          | { __typename: 'Account'; id: string; name?: string | null }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              fundingSource: FundingSource
            }
          | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerBreakdownListItemFragment = {
  __typename: 'BreakdownListItem'
  id: string
  createdAt: any
  transactionDate?: any | null
  transactionType: BreakdownProductType
  fee: number
  grossAmount: number
  companyType: CompanyType
  transaction?: { __typename: 'Transaction'; id: string } | null
  product?:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
        payments?: Array<{
          __typename: 'InvoicePayment'
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'OneTimePayment'; id: string; referenceId?: string | null }
    | {
        __typename: 'Referral'
        id: string
        referralDate?: string | null
        referredPartner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
        } | null
      }
    | {
        __typename: 'ReferralBonus'
        id: string
        description: string
        referralPayoutID: string
        amount: number
      }
    | {
        __typename: 'Refund'
        id: string
        paymentID: string
        paymentReferenceId?: string | null
      }
    | { __typename: 'SubscriptionPayment' }
    | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  partner?: { __typename: 'Partner'; id: string; name?: string | null } | null
  paymentMethod?:
    | { __typename: 'Account'; id: string; name?: string | null }
    | {
        __typename: 'Card'
        id: string
        cardNetWork: CardNetwork
        fundingSource: FundingSource
      }
    | null
}

export type GetPayoutConfigQueryVariables = Exact<{ [key: string]: never }>

export type GetPayoutConfigQuery = {
  __typename: 'Query'
  PartnerGetPayoutConfig?: {
    __typename: 'PayoutCompanyConfig'
    id: string
    defaultBankingAccount?: { __typename: 'Account'; id: string } | null
  } | null
}

export type GetReferralPayoutConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type GetReferralPayoutConfigQuery = {
  __typename: 'Query'
  PartnerGetPayoutConfig?: {
    __typename: 'PayoutCompanyConfig'
    id: string
    referralBankingAccount?: { __typename: 'Account'; id: string } | null
    defaultBankingAccount?: { __typename: 'Account'; id: string } | null
  } | null
}

export type GetPayoutTimingConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type GetPayoutTimingConfigQuery = {
  __typename: 'Query'
  PartnerGetPayoutTimingCompanyConfig?: {
    __typename: 'CompanyPayoutTimingConfigs'
    activeConfig?: {
      __typename: 'PayoutTimingCompanyConfig'
      canCompanyChange: boolean
      effectiveAt: string
      activatedAt?: string | null
      payoutTimingPlanID: string
      businessDaysToHold: number
      payoutTimingFee?: {
        __typename: 'PayoutTimingFee'
        fixedFee: number
        percentageFee: number
        capFee: number
      } | null
    } | null
    upcomingConfig?: {
      __typename: 'PayoutTimingCompanyConfig'
      canCompanyChange: boolean
      effectiveAt: string
      activatedAt?: string | null
      payoutTimingPlanID: string
      businessDaysToHold: number
      payoutTimingFee?: {
        __typename: 'PayoutTimingFee'
        fixedFee: number
        percentageFee: number
        capFee: number
      } | null
    } | null
  } | null
  PartnerGetPayoutTimingPlans?: Array<{
    __typename: 'PayoutTimingPlan'
    id: string
    businessDaysToHold: number
    payoutTimingFee: {
      __typename: 'PayoutTimingFee'
      fixedFee: number
      percentageFee: number
      capFee: number
    }
  } | null> | null
}

export type UpdatePayoutTimingConfigMutationVariables = Exact<{
  planID: Scalars['ID']['input']
}>

export type UpdatePayoutTimingConfigMutation = {
  __typename: 'Mutation'
  PartnerPayoutTimingUpsertCompanyConfig?: string | null
}

export type PartnerListPendingCustomerUsersTotalsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListPendingCustomerUsersTotalsQuery = {
  __typename: 'Query'
  PartnerListPendingCustomerUsersTotals?: {
    __typename: 'PendingCustomerUsersTotals'
    count: number
  } | null
}

export type PartnerPendingCustomerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<PendingCustomerUserFilters>
  orderBy?: InputMaybe<PendingCustomerUserOrderBy>
}>

export type PartnerPendingCustomerUserConnectionQuery = {
  __typename: 'Query'
  PartnerPendingCustomerUserConnection?: {
    __typename: 'PendingCustomerUserConnection'
    edges?: Array<{
      __typename: 'PendingCustomerUserEdge'
      node?: {
        __typename: 'PendingCustomerUser'
        id: string
        email: string
        partnerId: string
        createdAt: string
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerRejectPendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerRejectPendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerRejectPendingCustomerUser?: {
    __typename: 'PendingCustomerUser'
    id: string
    email: string
    partnerId: string
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerApprovePendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerApprovePendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerApprovePendingCustomerUser?: {
    __typename: 'CustomerUser'
    id: string
  } | null
}

export type PartnerLinkPendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type PartnerLinkPendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerLinkPendingCustomerUser?: {
    __typename: 'PendingCustomerUser'
    id: string
    email: string
    partnerId: string
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerUnlinkPendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type PartnerUnlinkPendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerUnlinkPendingCustomerUser?: {
    __typename: 'PendingCustomerUser'
    id: string
    email: string
    partnerId: string
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerListPendingCustomerUserFragment = {
  __typename: 'PendingCustomerUser'
  id: string
  email: string
  partnerId: string
  createdAt: string
  customer?: { __typename: 'Customer'; id: string; name?: string | null } | null
}

export type PartnerListPendingCustomerFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
}

export type PartnerRecurringPaymentConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<RecurringPaymentFilter>
  orderBy?: InputMaybe<RecurringPaymentOrderBy>
}>

export type PartnerRecurringPaymentConnectionQuery = {
  __typename: 'Query'
  PartnerRecurringPaymentConnection: {
    __typename: 'RecurringPaymentConnection'
    edges?: Array<{
      __typename: 'RecurringPaymentEdge'
      node?: {
        __typename: 'RecurringPayment'
        id: string
        productName?: string | null
        amount: number
        frequency: Frequency
        status: RecurringPaymentStatus
        dateFirstCharge: string
        dateLastCharge?: string | null
        autoCharge: boolean
        customer: { __typename: 'Customer'; id: string; name?: string | null }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerRecurringPaymentTotalsQueryVariables = Exact<{
  filters?: InputMaybe<RecurringPaymentFilter>
}>

export type PartnerRecurringPaymentTotalsQuery = {
  __typename: 'Query'
  PartnerRecurringPaymentTotals?: {
    __typename: 'RecurringPaymentTotals'
    count: number
    amount: number
  } | null
}

export type RecurringPaymentCreateMutationVariables = Exact<{
  input: RecurringPaymentCreateInput
}>

export type RecurringPaymentCreateMutation = {
  __typename: 'Mutation'
  PartnerRecurringPaymentCreate?: {
    __typename: 'RecurringPayment'
    id: string
    productName?: string | null
    amount: number
    frequency: Frequency
    status: RecurringPaymentStatus
    dateFirstCharge: string
    dateLastCharge?: string | null
    autoCharge: boolean
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null
}

export type RecurringPaymentDeactivateMutationVariables = Exact<{
  input: RecurringPaymentDeactivateInput
}>

export type RecurringPaymentDeactivateMutation = {
  __typename: 'Mutation'
  PartnerRecurringPaymentDeactivate?: string | null
}

export type RecurringPaymentUpdateMutationVariables = Exact<{
  input: RecurringPaymentUpdateInput
}>

export type RecurringPaymentUpdateMutation = {
  __typename: 'Mutation'
  PartnerRecurringPaymentUpdate?: string | null
}

export type PartnerRecurringPaymentFragment = {
  __typename: 'RecurringPayment'
  id: string
  productName?: string | null
  amount: number
  frequency: Frequency
  status: RecurringPaymentStatus
  dateFirstCharge: string
  dateLastCharge?: string | null
  autoCharge: boolean
  customer: { __typename: 'Customer'; id: string; name?: string | null }
}

export type PartnerReferralGetQuarterlyEarningsDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetQuarterlyEarningsDataQuery = {
  __typename: 'Query'
  PartnerReferralGetQuarterlyEarningsData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerReferralGetAvailableForPayoutDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetAvailableForPayoutDataQuery = {
  __typename: 'Query'
  PartnerReferralGetAvailableForPayoutData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerReferralGetTotalReferralFeesDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetTotalReferralFeesDataQuery = {
  __typename: 'Query'
  PartnerReferralGetTotalReferralFeesData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerReferralGetAvgQuarterlyFeesDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetAvgQuarterlyFeesDataQuery = {
  __typename: 'Query'
  PartnerReferralGetAvgQuarterlyFeesData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerGetReferralLinkQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetReferralLinkQuery = {
  __typename: 'Query'
  PartnerGetReferralLink: string
}

export type PartnerGetReferralPayoutByPayoutIdQueryVariables = Exact<{
  payoutID: Scalars['ID']['input']
}>

export type PartnerGetReferralPayoutByPayoutIdQuery = {
  __typename: 'Query'
  PartnerGetReferralPayoutByPayoutID?: {
    __typename: 'ReferralPayout'
    id: string
    payoutID?: string | null
    referralCount: number
    amount: number
    period: string
    partnerID: string
    status: ReferralPayoutStatus
    payoutDate?: string | null
    referredPartnersRevenue?: Array<{
      __typename: 'ReferredPartnerRevenue'
      referredPartnerID?: string | null
      lastQuarterRevenue?: number | null
    } | null> | null
  } | null
}

export type PartnerReferralConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<ReferralFilter>
  orderBy?: InputMaybe<ReferralOrderBy>
}>

export type PartnerReferralConnectionQuery = {
  __typename: 'Query'
  PartnerReferralConnection?: {
    __typename: 'ReferralConnection'
    edges?: Array<{
      __typename: 'ReferralEdge'
      cursor: any
      node?: {
        __typename: 'Referral'
        id: string
        companyName?: string | null
        referralDate?: string | null
        referralFees?: number | null
        avgQuarterlyFees?: number | null
        status: ReferralStatus
        email?: string | null
        customerID?: string | null
        referredPartner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
          detailedSubscription?: {
            __typename: 'PartnerDetailedSubscription'
            subscriptions?: Array<{
              __typename: 'PartnerSubscription'
              type: string
              id: string
              frequency: SubscriptionFrequency
              amount: number
              billingCyclesCovered: number
              billingCyclesUnit: BillingCycleUnit
              lastStatus: SubscriptionStatus
              firstBilledDate?: string | null
            } | null> | null
            monthlyRevenue?: Array<{
              __typename: 'MonthlyRevenue'
              year: number
              month: number
              amount: number
            }> | null
          } | null
        } | null
        recipients?: Array<{
          __typename: 'ReferralRecipient'
          email: string
          userID?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCreateReferralMutationVariables = Exact<{
  input: CreateReferralInput
}>

export type PartnerCreateReferralMutation = {
  __typename: 'Mutation'
  PartnerCreateReferral: string
}

export type PartnerUpdateReferralMutationVariables = Exact<{
  input: UpdateReferralInput
}>

export type PartnerUpdateReferralMutation = {
  __typename: 'Mutation'
  PartnerUpdateReferral: string
}

export type PartnerSendReferralMutationVariables = Exact<{
  input: SendPartnerReferralInput
}>

export type PartnerSendReferralMutation = {
  __typename: 'Mutation'
  PartnerSendReferral: string
}

export type GetReferralDataReplyFragment = {
  __typename: 'GetReferralDataReply'
  total: number
  previous: number
}

export type ReferralFragment = {
  __typename: 'Referral'
  id: string
  companyName?: string | null
  referralDate?: string | null
  referralFees?: number | null
  avgQuarterlyFees?: number | null
  status: ReferralStatus
  email?: string | null
  customerID?: string | null
  referredPartner?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    detailedSubscription?: {
      __typename: 'PartnerDetailedSubscription'
      subscriptions?: Array<{
        __typename: 'PartnerSubscription'
        type: string
        id: string
        frequency: SubscriptionFrequency
        amount: number
        billingCyclesCovered: number
        billingCyclesUnit: BillingCycleUnit
        lastStatus: SubscriptionStatus
        firstBilledDate?: string | null
      } | null> | null
      monthlyRevenue?: Array<{
        __typename: 'MonthlyRevenue'
        year: number
        month: number
        amount: number
      }> | null
    } | null
  } | null
  recipients?: Array<{
    __typename: 'ReferralRecipient'
    email: string
    userID?: string | null
  } | null> | null
}

export type ReferralPayoutFragment = {
  __typename: 'ReferralPayout'
  id: string
  payoutID?: string | null
  referralCount: number
  amount: number
  period: string
  partnerID: string
  status: ReferralPayoutStatus
  payoutDate?: string | null
  referredPartnersRevenue?: Array<{
    __typename: 'ReferredPartnerRevenue'
    referredPartnerID?: string | null
    lastQuarterRevenue?: number | null
  } | null> | null
}

export type ReferralBonusFragment = {
  __typename: 'ReferralBonus'
  id: string
  description: string
  referralPayoutID: string
  amount: number
}

export type UpdatePartnerReferralLinkMutationVariables = Exact<{
  input: UpdateReferralLinkInput
}>

export type UpdatePartnerReferralLinkMutation = {
  __typename: 'Mutation'
  UpdatePartnerReferralLink: string
}

export type PartnerGetReferralLinkInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetReferralLinkInfoQuery = {
  __typename: 'Query'
  PartnerGetReferralLinkInfo: {
    __typename: 'ReferralLinkInfo'
    sendLinkToOutgoingEmails: boolean
    url: string
  }
}

export type CreateRefundMutationVariables = Exact<{
  input: RefundCreateInput
}>

export type CreateRefundMutation = {
  __typename: 'Mutation'
  createRefund: boolean
}

export type CancelRefundMutationVariables = Exact<{
  refundID: Scalars['ID']['input']
}>

export type CancelRefundMutation = {
  __typename: 'Mutation'
  cancelRefund: boolean
}

export type PartnerSendReportMutationVariables = Exact<{
  reportType: ReportType
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
  searchTerm?: InputMaybe<Scalars['String']['input']>
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  format?: InputMaybe<ReportFormat>
  invoiceIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
  statuses?: InputMaybe<Array<InvoiceStatusEnum> | InvoiceStatusEnum>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  amountMin?: InputMaybe<Scalars['Float']['input']>
  amountMax?: InputMaybe<Scalars['Float']['input']>
  lastNotificationStart?: InputMaybe<Scalars['String']['input']>
  lastNotificationEnd?: InputMaybe<Scalars['String']['input']>
  recurringPaymentID?: InputMaybe<Scalars['ID']['input']>
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>
  recurringFrequency?: InputMaybe<ArRecurringInvoiceFrequency>
}>

export type PartnerSendReportMutation = {
  __typename: 'Mutation'
  PartnerSendReport: string
}

export type PartnerListRoutinesQueryVariables = Exact<{
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  filters?: InputMaybe<RoutineFilter>
  order?: InputMaybe<RoutineOrder>
}>

export type PartnerListRoutinesQuery = {
  __typename: 'Query'
  PartnerListRoutines: {
    __typename: 'RoutineList'
    routines: Array<{
      __typename: 'Routine'
      id: string
      name: string
      instruction: string
      frequency: RoutineFrequency
      sentHour: number
      timezone: string
      dayOfWeek?: number | null
      customDay?: number | null
      emailEnabled: boolean
      enabled: boolean
      nextRunAt: string
    }>
    pagination: {
      __typename: 'ArPagination'
      page: number
      pageSize: number
      totalItems: number
      totalPages: number
    }
  }
}

export type RoutineListItemFragment = {
  __typename: 'Routine'
  id: string
  name: string
  instruction: string
  frequency: RoutineFrequency
  sentHour: number
  timezone: string
  dayOfWeek?: number | null
  customDay?: number | null
  emailEnabled: boolean
  enabled: boolean
  nextRunAt: string
}

export type RoutineDetailFragment = {
  __typename: 'Routine'
  id: string
  name: string
  instruction: string
  frequency: RoutineFrequency
  sentHour: number
  timezone: string
  dayOfWeek?: number | null
  customDay?: number | null
  emailEnabled: boolean
  recipients: Array<string>
  enabled: boolean
  nextRunAt: string
  createdAt: string
  updatedAt: string
}

export type PartnerGetRoutineQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetRoutineQuery = {
  __typename: 'Query'
  PartnerGetRoutine: {
    __typename: 'Routine'
    id: string
    name: string
    instruction: string
    frequency: RoutineFrequency
    sentHour: number
    timezone: string
    dayOfWeek?: number | null
    customDay?: number | null
    emailEnabled: boolean
    recipients: Array<string>
    enabled: boolean
    nextRunAt: string
    createdAt: string
    updatedAt: string
  }
}

export type RoutineRunRowFragment = {
  __typename: 'RoutineRunListItem'
  id: string
  status: string
  emailStatus: string
  error?: string | null
  startedAt: string
  finishedAt?: string | null
  createdAt: string
  artifactCount: number
}

export type PartnerListRoutineRunsQueryVariables = Exact<{
  routineID: Scalars['ID']['input']
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}>

export type PartnerListRoutineRunsQuery = {
  __typename: 'Query'
  PartnerListRoutineRuns: {
    __typename: 'RoutineRunList'
    runs: Array<{
      __typename: 'RoutineRunListItem'
      id: string
      status: string
      emailStatus: string
      error?: string | null
      startedAt: string
      finishedAt?: string | null
      createdAt: string
      artifactCount: number
    }>
    pagination: {
      __typename: 'ArPagination'
      page: number
      pageSize: number
      totalItems: number
      totalPages: number
    }
  }
}

export type RoutineRunDetailFragment = {
  __typename: 'RoutineRun'
  id: string
  status: string
  source: string
  emailStatus: string
  outputText: string
  error?: string | null
  attempts: number
  maxAttempts: number
  startedAt: string
  finishedAt?: string | null
  createdAt: string
  artifacts: Array<{
    __typename: 'RoutineRunArtifact'
    fileID: string
    filename: string
    contentType: string
    sizeBytes: number
  }>
}

export type PartnerGetRoutineRunQueryVariables = Exact<{
  routineID: Scalars['ID']['input']
  runID: Scalars['ID']['input']
}>

export type PartnerGetRoutineRunQuery = {
  __typename: 'Query'
  PartnerGetRoutineRun: {
    __typename: 'RoutineRun'
    id: string
    status: string
    source: string
    emailStatus: string
    outputText: string
    error?: string | null
    attempts: number
    maxAttempts: number
    startedAt: string
    finishedAt?: string | null
    createdAt: string
    artifacts: Array<{
      __typename: 'RoutineRunArtifact'
      fileID: string
      filename: string
      contentType: string
      sizeBytes: number
    }>
  }
}

export type PartnerRoutineRunFileDownloadUrlQueryVariables = Exact<{
  routineID: Scalars['ID']['input']
  runID: Scalars['ID']['input']
  fileID?: InputMaybe<Scalars['String']['input']>
  path?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerRoutineRunFileDownloadUrlQuery = {
  __typename: 'Query'
  PartnerRoutineRunFileDownloadURL: string
}

export type PartnerUpdateRoutineMutationVariables = Exact<{
  input: PartnerUpdateRoutineInput
}>

export type PartnerUpdateRoutineMutation = {
  __typename: 'Mutation'
  PartnerUpdateRoutine: {
    __typename: 'Routine'
    id: string
    name: string
    instruction: string
    frequency: RoutineFrequency
    sentHour: number
    timezone: string
    dayOfWeek?: number | null
    customDay?: number | null
    emailEnabled: boolean
    recipients: Array<string>
    enabled: boolean
    nextRunAt: string
    createdAt: string
    updatedAt: string
  }
}

export type PartnerDeleteRoutineMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteRoutineMutation = {
  __typename: 'Mutation'
  PartnerDeleteRoutine: boolean
}

export type PartnerRunRoutineNowMutationVariables = Exact<{
  routineID: Scalars['ID']['input']
}>

export type PartnerRunRoutineNowMutation = {
  __typename: 'Mutation'
  PartnerRunRoutineNow: {
    __typename: 'RoutineRun'
    id: string
    status: string
    source: string
    emailStatus: string
    outputText: string
    error?: string | null
    attempts: number
    maxAttempts: number
    startedAt: string
    finishedAt?: string | null
    createdAt: string
    artifacts: Array<{
      __typename: 'RoutineRunArtifact'
      fileID: string
      filename: string
      contentType: string
      sizeBytes: number
    }>
  }
}

export type PartnerScheduledOneOffEmailConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type PartnerScheduledOneOffEmailConnectionQuery = {
  __typename: 'Query'
  PartnerScheduledOneOffEmailConnection: {
    __typename: 'ScheduledOneOffEmailConnection'
    edges: Array<{
      __typename: 'ScheduledOneOffEmailEdge'
      cursor: any
      node: {
        __typename: 'ScheduledOneOffEmail'
        id: string
        createdAt: string
        sendAt: string
        timezone: Timezone
        cc?: Array<string> | null
        bcc?: Array<string> | null
        template: {
          __typename: 'EmailTemplate'
          id: string
          name: string
          subject: string
          section1?: string | null
          type: TemplateType
        }
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
          legalName?: string | null
          tagIDs?: Array<string> | null
        }> | null
        tags?: Array<{
          __typename: 'CustomerTag'
          ID: string
          name: string
          description?: string | null
          color?: TagColor | null
          type?: TagType | null
        }> | null
      }
    }>
    pageInfo: {
      __typename: 'PageInfo'
      endCursor?: any | null
      hasNextPage: boolean
    }
  }
}

export type PartnerGetScheduledOneOffEmailQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerGetScheduledOneOffEmailQuery = {
  __typename: 'Query'
  PartnerGetScheduledOneOffEmail?: {
    __typename: 'ScheduledOneOffEmail'
    id: string
    createdAt: string
    sendAt: string
    timezone: Timezone
    cc?: Array<string> | null
    bcc?: Array<string> | null
    template: {
      __typename: 'EmailTemplate'
      id: string
      name: string
      subject: string
      section1?: string | null
      type: TemplateType
    }
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    }> | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    }> | null
  } | null
}

export type PartnerDeleteScheduledOneOffEmailMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteScheduledOneOffEmailMutation = {
  __typename: 'Mutation'
  PartnerDeleteScheduledOneOffEmail?: boolean | null
}

export type PartnerUpdateScheduledOneOffEmailMutationVariables = Exact<{
  input: UpdateScheduledOneOffEmailInput
}>

export type PartnerUpdateScheduledOneOffEmailMutation = {
  __typename: 'Mutation'
  PartnerUpdateScheduledOneOffEmail?: {
    __typename: 'ScheduledOneOffEmail'
    id: string
    createdAt: string
    sendAt: string
    timezone: Timezone
    cc?: Array<string> | null
    bcc?: Array<string> | null
    template: {
      __typename: 'EmailTemplate'
      id: string
      name: string
      subject: string
      section1?: string | null
      type: TemplateType
    }
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      tagIDs?: Array<string> | null
    }> | null
    tags?: Array<{
      __typename: 'CustomerTag'
      ID: string
      name: string
      description?: string | null
      color?: TagColor | null
      type?: TagType | null
    }> | null
  } | null
}

export type PartnerSendScheduledOneOffEmailNowMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerSendScheduledOneOffEmailNowMutation = {
  __typename: 'Mutation'
  PartnerSendScheduledOneOffEmailNow?: string | null
}

export type PartnerScheduledOneOffEmailFragment = {
  __typename: 'ScheduledOneOffEmail'
  id: string
  createdAt: string
  sendAt: string
  timezone: Timezone
  cc?: Array<string> | null
  bcc?: Array<string> | null
  template: {
    __typename: 'EmailTemplate'
    id: string
    name: string
    subject: string
    section1?: string | null
    type: TemplateType
  }
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    tagIDs?: Array<string> | null
  }> | null
  tags?: Array<{
    __typename: 'CustomerTag'
    ID: string
    name: string
    description?: string | null
    color?: TagColor | null
    type?: TagType | null
  }> | null
}

export type PartnerListActiveSubscriptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListActiveSubscriptionsQuery = {
  __typename: 'Query'
  PartnerListActiveSubscriptions: Array<{
    __typename: 'PartnerSubscription'
    id: string
    type: string
    amount: number
    frequency: SubscriptionFrequency
    nextBillingDate: string
    billingCyclesCovered: number
    billingCyclesUnit: BillingCycleUnit
  }>
}

export type PartnerSubscriptionsPaymentsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<SubscriptionPaymentFilter>
  orderBy?: InputMaybe<SubscriptionPaymentOrderBy>
}>

export type PartnerSubscriptionsPaymentsConnectionQuery = {
  __typename: 'Query'
  PartnerSubscriptionsPaymentsConnection: {
    __typename: 'SubscriptionPaymentConnection'
    edges?: Array<{
      __typename: 'SubscriptionPaymentEdge'
      node?: {
        __typename: 'SubscriptionPayment'
        id: string
        paymentDate: string
        amount: number
        status: SubscriptionPaymentStatus
        subscription: {
          __typename: 'PartnerSubscription'
          id: string
          type: string
          frequency: SubscriptionFrequency
          billingCyclesCovered: number
          billingCyclesUnit: BillingCycleUnit
        }
        payment?: {
          __typename: 'Payment'
          id: string
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
          } | null>
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerListSubscriptionPaymentsTotalsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListSubscriptionPaymentsTotalsQuery = {
  __typename: 'Query'
  PartnerListSubscriptionPaymentsTotals: {
    __typename: 'SubscriptionPaymentsTotals'
    count: number
  }
}

export type PartnerCancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput
}>

export type PartnerCancelSubscriptionMutation = {
  __typename: 'Mutation'
  PartnerCancelSubscription?: {
    __typename: 'PartnerSubscription'
    id: string
    type: string
    amount: number
    frequency: SubscriptionFrequency
    nextBillingDate: string
    billingCyclesCovered: number
    billingCyclesUnit: BillingCycleUnit
  } | null
}

export type SubscriptionPaymentFragment = {
  __typename: 'SubscriptionPayment'
  id: string
  paymentDate: string
  amount: number
  status: SubscriptionPaymentStatus
  subscription: {
    __typename: 'PartnerSubscription'
    id: string
    type: string
    frequency: SubscriptionFrequency
    billingCyclesCovered: number
    billingCyclesUnit: BillingCycleUnit
  }
  payment?: {
    __typename: 'Payment'
    id: string
    paymentFees: Array<{ __typename: 'PaymentFee'; amount: number } | null>
  } | null
}

export type PartnerSubscriptionFragment = {
  __typename: 'PartnerSubscription'
  id: string
  type: string
  amount: number
  frequency: SubscriptionFrequency
  nextBillingDate: string
  billingCyclesCovered: number
  billingCyclesUnit: BillingCycleUnit
}

export type PartnerSubscriptionPaymentBasicFragment = {
  __typename: 'SubscriptionPayment'
  id: string
  paymentDate: string
  amount: number
  subscriptionStatus: SubscriptionPaymentStatus
  subscription: {
    __typename: 'PartnerSubscription'
    id: string
    type: string
    frequency: SubscriptionFrequency
  }
}

export type PartnerAccountingSyncConfigGetQueryVariables = Exact<{
  input: SyncConfigGetInput
}>

export type PartnerAccountingSyncConfigGetQuery = {
  __typename: 'Query'
  PartnerAccountingSyncConfigGet?: {
    __typename: 'SyncConfig'
    partnerID: string
    sourcePlatformName: PlatformName
    targetPlatformName: PlatformName
    lastAutomaticSync?: string | null
    options: Array<{
      __typename: 'SyncConfigOption'
      optionKey: SyncConfigOptionKey
      optionType: SyncConfigOptionType
      enumValue?: SyncConfigOptionValue | null
      customValue?: string | null
    }>
    mappings?: Array<{
      __typename: 'SyncConfigMapping'
      sourceID: string
      sourceName: string
      targetID: string
      targetName: string
      mappingType: SyncConfigMappingType
    }> | null
  } | null
}

export type PartnerAccountingSyncConfigCreateMutationVariables = Exact<{
  input: SyncConfigCreateInput
}>

export type PartnerAccountingSyncConfigCreateMutation = {
  __typename: 'Mutation'
  PartnerAccountingSyncConfigCreate: {
    __typename: 'SyncConfig'
    lastAutomaticSync?: string | null
  }
}

export type PartnerAccountingSyncConfigUpdateMutationVariables = Exact<{
  input: SyncConfigUpdateInput
}>

export type PartnerAccountingSyncConfigUpdateMutation = {
  __typename: 'Mutation'
  PartnerAccountingSyncConfigUpdate: {
    __typename: 'SyncConfig'
    lastAutomaticSync?: string | null
  }
}

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'PartnerGetUserInfoReply'
    id: string
    userType: UserType
    users?: Array<{
      __typename: 'PartnerUserInfo'
      createdAt: string
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      phone?: string | null
      jobTitle?: string | null
      role: string
      permissions: Array<PartnerUserPermissions>
      partner?: {
        __typename: 'Partner'
        createdAt: string
        id: string
        isOnboarded: boolean
        isDeactivated: boolean
        adyenOnboardingStatus: AdyenOnboardingStatusStep
        name?: string | null
        ein?: string | null
        paymentsPortalEnabled: boolean
        insightsEnabled: boolean
        hasBankStatementUploaded: boolean
        country?: string | null
        countryCode?: string | null
        tosAndPciAccepted: boolean
        isValidToOnboarding: boolean
        adyenBusinessSetup?: AdyenBusinessSetup | null
        timezone?: Timezone | null
        useUserLocalTimezone?: boolean | null
        timezoneSetAt?: string | null
        currency: Currency
        attachInvoicePDFEnabled?: boolean | null
        pdfFallbackEnabled?: boolean | null
        blockGoingLive: boolean
        paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
        paymentsPortalUrl?: string | null
        paymentsPortalCustomInvoices?: boolean | null
        requiresMFA: boolean
        paymentsPortalCustomization: {
          __typename: 'PartnerPaymentsPortalCustomization'
          color?: string | null
          logoUrl?: string | null
        }
      } | null
    }> | null
  } | null
}

export type GetUserInfoDetailsQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoDetailsQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'PartnerGetUserInfoReply'
    id: string
    users?: Array<{
      __typename: 'PartnerUserInfo'
      createdAt: string
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      phone?: string | null
      jobTitle?: string | null
      role: string
      permissions: Array<PartnerUserPermissions>
      partner?: {
        __typename: 'Partner'
        createdAt: string
        id: string
        isOnboarded: boolean
        isDeactivated: boolean
        adyenOnboardingStatus: AdyenOnboardingStatusStep
        name?: string | null
        ein?: string | null
        paymentsPortalEnabled: boolean
        insightsEnabled: boolean
        hasBankStatementUploaded: boolean
        country?: string | null
        countryCode?: string | null
        tosAndPciAccepted: boolean
        isValidToOnboarding: boolean
        adyenBusinessSetup?: AdyenBusinessSetup | null
        timezone?: Timezone | null
        useUserLocalTimezone?: boolean | null
        timezoneSetAt?: string | null
        currency: Currency
        attachInvoicePDFEnabled?: boolean | null
        pdfFallbackEnabled?: boolean | null
        blockGoingLive: boolean
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        stateCode?: string | null
        legalName?: string | null
        companyType?: string | null
        industry?: string | null
        description?: string | null
        website?: string | null
        phone?: string | null
        adyenCompanyType?: AdyenCompanyType | null
        adyenIndustryCode?: string | null
        incorporationNumber?: string | null
        paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
        paymentsPortalUrl?: string | null
        paymentsPortalCustomInvoices?: boolean | null
        requiresMFA: boolean
        paymentsPortalCustomization: {
          __typename: 'PartnerPaymentsPortalCustomization'
          color?: string | null
          logoUrl?: string | null
        }
      } | null
    }> | null
  } | null
}

export type CreateUserAndPartnerQueryVariables = Exact<{ [key: string]: never }>

export type CreateUserAndPartnerQuery = {
  __typename: 'Query'
  CreateUserAndPartner?: {
    __typename: 'CreateUserAndPartnerReply'
    userId: string
    partnerId: string
  } | null
}

export type PartnerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PartnerUserOrderBy>
}>

export type PartnerUserConnectionQuery = {
  __typename: 'Query'
  PartnerUserConnection?: {
    __typename: 'PartnerUserConnection'
    edges?: Array<{
      __typename: 'PartnerUserEdge'
      cursor: any
      node?: {
        __typename: 'PartnerUser'
        createdAt: string
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
        role: PartnerUserRole
        hasMFA?: boolean | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerUpdateMyUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateMyUserInput>
}>

export type PartnerUpdateMyUserMutation = {
  __typename: 'Mutation'
  PartnerUpdateMyUser?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    jobTitle?: string | null
  } | null
}

export type PartnerInviteUserMutationVariables = Exact<{
  input: PartnerInviteUserInput
}>

export type PartnerInviteUserMutation = {
  __typename: 'Mutation'
  PartnerInviteUser?: {
    __typename: 'PartnerUser'
    createdAt: string
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    role: PartnerUserRole
    hasMFA?: boolean | null
  } | null
}

export type PartnerUpdateUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateUserInput>
}>

export type PartnerUpdateUserMutation = {
  __typename: 'Mutation'
  PartnerUpdateUser?: {
    __typename: 'PartnerUser'
    createdAt: string
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    role: PartnerUserRole
    hasMFA?: boolean | null
  } | null
}

export type PartnerDeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteUserMutation = {
  __typename: 'Mutation'
  PartnerDeleteUser?: string | null
}

export type PartnerUserListFragment = {
  __typename: 'PartnerUser'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  role: PartnerUserRole
  hasMFA?: boolean | null
}

export type BasicUserInfoFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
}

export type BasicPartnerUserInfoFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    currency: Currency
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    blockGoingLive: boolean
  } | null
}

export type PartnerUserConfigDetailsFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    paymentsPortalEnabled: boolean
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type PartnerUserInfoDetailsFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    legalName?: string | null
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
    website?: string | null
    phone?: string | null
    adyenCompanyType?: AdyenCompanyType | null
    adyenIndustryCode?: string | null
    adyenBusinessSetup?: AdyenBusinessSetup | null
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    incorporationNumber?: string | null
  } | null
}

export type PartnerAddressInfoFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    id: string
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    state?: string | null
    stateCode?: string | null
  } | null
}

export type UserInfoFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    currency: Currency
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    blockGoingLive: boolean
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type UserInfoDetailsFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
    timezone?: Timezone | null
    useUserLocalTimezone?: boolean | null
    timezoneSetAt?: string | null
    currency: Currency
    attachInvoicePDFEnabled?: boolean | null
    pdfFallbackEnabled?: boolean | null
    blockGoingLive: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    stateCode?: string | null
    legalName?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
    website?: string | null
    phone?: string | null
    adyenCompanyType?: AdyenCompanyType | null
    adyenIndustryCode?: string | null
    incorporationNumber?: string | null
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type PartnerBaseUserFragment = {
  __typename: 'PartnerUser'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export type PartnerListUserFragment = {
  __typename: 'PartnerUser'
  role: PartnerUserRole
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export const ApNotificationPolicyFragmentDoc = /*#__PURE__*/ gql`
  fragment APNotificationPolicy on AccountsPayableNotificationPolicy {
    billCreatedEnabled
    billOverdueEnabled
    paymentFailedEnabled
    emailIngestionFailedEnabled
  }
`
export const PaymentPreferenceFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentPreference on PaymentPreference {
    paymentPreferenceID
    usPaymentPreferenceData {
      institutionName
      routingNumber
      accountNumber
      type
    }
    country
    source
  }
`
export const PartnerVendorSearchFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerVendorSearch on Vendor {
    ID
    name
    email
    phone
  }
`
export const VendorListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorListItem on Vendor {
    ID
    name
    email
    phone
    isActive
    createdAt
    updatedAt
    category
    companyAddress
    city
    state
    postalCode
    country
    owner
    taxId
    origin
    compactedPaymentPreference {
      ID
      institutionName
      accountMask
    }
    isMerged
  }
`
export const VendorFragmentDoc = /*#__PURE__*/ gql`
  fragment Vendor on Vendor {
    ...VendorListItem
    qboLinking {
      state
      qboVendorId
      lastSyncedAt
    }
  }
  ${VendorListItemFragmentDoc}
`
export const BillVendorFragmentDoc = /*#__PURE__*/ gql`
  fragment BillVendor on Vendor {
    ...VendorListItem
    absorbedBy {
      ID
      name
    }
  }
  ${VendorListItemFragmentDoc}
`
export const BillLastStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment BillLastStatus on BillLastStatus {
    ID
    status
    reason
    createdAt
    executedBy {
      id
      email
      firstName
      lastName
    }
  }
`
export const VendorPaymentFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPaymentFragment on VendorPayment {
    ID
    attemptNumber
    status
    holdUntil
    estimatedArrivalDate
    sentAt
    failureReason
    paymentMethodID
    paymentType
    reference
    paymentPreference {
      ID
      institutionName
      accountMask
      vendorID
    }
    qboSyncStatus {
      status
      qboExternalId
      lastSyncedAt
      errorMessage
    }
  }
`
export const BillLineItemFragmentDoc = /*#__PURE__*/ gql`
  fragment BillLineItem on BillLineItem {
    sequence
    name
    description
    unitType
    quantity
    unitPrice
    total
    tax
    expenseAccountId
    expenseCategoryLabel
  }
`
export const BillConnectionFragmentDoc = /*#__PURE__*/ gql`
  fragment BillConnection on Bill {
    ID
    partnerID
    vendorID
    vendor {
      ...BillVendor
    }
    number
    issueDate
    dueDate
    payDate
    amount
    description
    status
    source
    createdAt
    lastStatus {
      ...BillLastStatus
    }
    vendorPayment {
      ...VendorPaymentFragment
    }
    lineItems {
      ...BillLineItem
    }
    qboLinking {
      state
      qboVendorId
      lastSyncedAt
    }
    virtualCard {
      fundingAttemptStatus
      cardReference
      last4
      network
      cardStatus
    }
    lastFundingFailureReason
  }
  ${BillVendorFragmentDoc}
  ${BillLastStatusFragmentDoc}
  ${VendorPaymentFragmentFragmentDoc}
  ${BillLineItemFragmentDoc}
`
export const BillFragmentDoc = /*#__PURE__*/ gql`
  fragment Bill on Bill {
    ID
    partnerID
    vendorID
    vendor {
      ...BillVendor
    }
    number
    issueDate
    dueDate
    payDate
    amount
    description
    status
    source
    createdAt
    lastStatus {
      ...BillLastStatus
    }
    vendorPayment {
      ...VendorPaymentFragment
    }
    lineItems {
      ...BillLineItem
    }
    qboLinking {
      state
      qboVendorId
      lastSyncedAt
    }
    virtualCard {
      fundingAttemptStatus
      cardReference
      last4
      network
      cardStatus
    }
    lastFundingFailureReason
  }
  ${BillVendorFragmentDoc}
  ${BillLastStatusFragmentDoc}
  ${VendorPaymentFragmentFragmentDoc}
  ${BillLineItemFragmentDoc}
`
export const PartialCompanyIndividualFragmentDoc = /*#__PURE__*/ gql`
  fragment PartialCompanyIndividual on CompanyIndividual {
    id
    firstName
    lastName
    owner
    individualDocuments {
      id
      individualID
      type
    }
  }
`
export const AccountingItemFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AccountingItemFragment on AccountingItem {
    id
    externalId
    name
    description
    type
    active
    unitPrice
    purchaseCost
    expenseAccountId
    incomeAccountId
    taxable
  }
`
export const AccountsPayableConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment AccountsPayableConfig on AccountsPayableConfig {
    mailbox
    onboardingStatus
    accountingProvider
  }
`
export const ApFundingAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment ApFundingAccount on Account {
    id
    customName
    mask
    subtype
    companyName
    institution {
      name
    }
  }
`
export const VendorAuditLogEntryFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorAuditLogEntry on VendorAuditLog {
    id
    vendorId
    partnerId
    entityId
    entityType
    executorEntity
    executorId
    executorUser {
      id
      email
      firstName
      lastName
    }
    action
    fieldName
    oldValue
    newValue
    createdAt
    isInitialCreation
    source
  }
`
export const VendorSimilarityGroupFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorSimilarityGroupFields on VendorSimilarityGroup {
    groupId
    members {
      vendorId
      name
      normalizedName
      matchType
      similarityScore
    }
    dismissedAt
  }
`
export const MergedVendorFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment MergedVendorFields on Vendor {
    ID
    name
    email
    origin
    compactedPaymentPreference {
      ID
      institutionName
      accountMask
    }
    mergedAt
    mergedByUser {
      id
      firstName
      lastName
      email
    }
  }
`
export const InboundEmailAttachmentFragmentDoc = /*#__PURE__*/ gql`
  fragment InboundEmailAttachment on InboundEmailAttachment {
    ID
    filename
    contentType
    size
    s3Path
    isUsedForBill
  }
`
export const InboundEmailFragmentDoc = /*#__PURE__*/ gql`
  fragment InboundEmail on InboundEmail {
    ID
    messageID
    fromName
    from
    to
    subject
    date
    textBody
    htmlBody
    attachments {
      ...InboundEmailAttachment
    }
  }
  ${InboundEmailAttachmentFragmentDoc}
`
export const ClientTrendsPresetFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ClientTrendsPresetFields on ClientTrendsPreset {
    id
    partnerId
    userId
    name
    createdAt
    updatedAt
    filters {
      agreementType {
        include
        exclude
      }
      clientName {
        include
        exclude
      }
      laborCostImpact
      mrrChangeType
      mrrRange {
        min
        max
      }
      marginRange {
        min
        max
      }
      mrrChangeRange {
        min
        max
      }
    }
  }
`
export const ApiKeyFragmentDoc = /*#__PURE__*/ gql`
  fragment ApiKey on ApiKey {
    id
    clientID
    lastDigits
    keyName
    createdAt
    status
    revokedAt
    createdBy {
      id
      firstName
      lastName
    }
    revokedBy {
      id
      firstName
      lastName
    }
    scopes
  }
`
export const HomeDeltaFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment HomeDeltaFields on HomeDelta {
    value
    prior
    deltaAbs
    deltaPct
    direction
    isImprovement
  }
`
export const HomeCashFlowFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment HomeCashFlowFields on HomeCashFlow {
    direction
    currencies {
      currency
      total
      deltaAbs
      deltaPct
      topSources {
        customerId
        customerName
        invoiceCount
        paymentMode
        amountCents
        sourceType
      }
    }
  }
`
export const HomeAttentionCustomerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment HomeAttentionCustomerFields on HomeCustomerNeedingAttention {
    customerId
    customerName
    currency
    balanceCents
    invoicesOutstanding
    overdueCount
    maxDaysOverdue
    lastReminderDaysAgo
    autopay
  }
`
export const TokenFragmentDoc = /*#__PURE__*/ gql`
  fragment Token on TokenExchange {
    access_token
    refresh_token
    expiry
    id_token
  }
`
export const AutopayExcludedListFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayExcludedList on AutopayExcludedCustomer {
    id
    customer {
      id
      name
      city
      state
      tagIDs
    }
    createdByCustomer
    createdAt
  }
`
export const BankAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment BankAccount on Account {
    id
    mask
    name
    type
    subtype
    hasAchAccountNumber
    hasAchRoutingNumber
    hasWireRoutingNumber
    transitNumber
    customName
    institution {
      name
      id
      logo
    }
    provider
    disconnectedAt
    systemDeactivatedAt
    companyName
    mandates {
      id
      consentAt
      version
    }
  }
`
export const BankFragmentDoc = /*#__PURE__*/ gql`
  fragment Bank on Institution {
    id
    externalId
    name
    url
    logo
    accounts {
      ...BankAccount
    }
  }
  ${BankAccountFragmentDoc}
`
export const CreditCardFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditCard on Card {
    id
    last4
    expirationDate
    cardNetWork
    fundingSource
    customName
    hasPostalCode
    isExpired
    billingAddress {
      streetAddress
      subPremise
      city
      state
      stateCode
      postalCode
      country
      countryISO
    }
  }
`
export const AutopayRulesWithBankingAndCardFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayRulesWithBankingAndCard on AutopayRule {
    id
    daysPastCreation
    daysPastDue
    daysBeforeDue
    specificDay
    lastDayOfMonth
    amountOperator
    amount
    version
    customMethods {
      customerID
      methodID
      method
      institution {
        ...Bank
      }
      card {
        ...CreditCard
      }
      fallbackCharge
    }
    autotaskContractTypes {
      externalID
      partnerID
      name
    }
    connectwiseAgreementTypes {
      externalID
      partnerID
      name
    }
    haloPSAContractSubtypes {
      externalID
      partnerID
      name
    }
    quickbooksRecurringTransactions {
      externalID
      partnerID
      name
    }
    connectwiseBillingTerms {
      externalID
      partnerID
      name
    }
    rutterQbdPaymentTerms {
      externalID
      partnerID
      name
    }
    rutterNetsuitePaymentTerms {
      externalID
      partnerID
      name
    }
    halopsaRecurringInvoices
    customers {
      id
      name
    }
    connectWiseContractNames
    autotaskContractNames
    haloPSAContractNames
    createdByCustomer
    createdAt
  }
  ${BankFragmentDoc}
  ${CreditCardFragmentDoc}
`
export const AutopayRulesFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayRules on AutopayRule {
    id
    daysPastCreation
    daysPastDue
    daysBeforeDue
    specificDay
    lastDayOfMonth
    amountOperator
    amount
    version
    customMethods {
      customerID
      methodID
      method
    }
    autotaskContractTypes {
      externalID
      partnerID
      name
    }
    connectwiseAgreementTypes {
      externalID
      partnerID
      name
    }
    haloPSAContractSubtypes {
      externalID
      partnerID
      name
    }
    quickbooksRecurringTransactions {
      externalID
      partnerID
      name
    }
    connectwiseBillingTerms {
      externalID
      partnerID
      name
    }
    rutterQbdPaymentTerms {
      externalID
      partnerID
      name
    }
    rutterNetsuitePaymentTerms {
      externalID
      partnerID
      name
    }
    halopsaRecurringInvoices
    customers {
      id
      name
    }
    connectWiseContractNames
    autotaskContractNames
    haloPSAContractNames
    createdByCustomer
    createdAt
  }
`
export const AutopayRulesWithCustomerTagsFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayRulesWithCustomerTags on AutopayRule {
    ...AutopayRules
    tagIDs
  }
  ${AutopayRulesFragmentDoc}
`
export const CustomerAutopayConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerAutopayConfig on GetCustomerAutopayConfigReply {
    customerAutopayConfig {
      customerID
      partnerID
      chargeDefaultFallback
    }
  }
`
export const InvoiceCoveredFragmentDoc = /*#__PURE__*/ gql`
  fragment InvoiceCovered on Invoice {
    id
    invoiceNumber
    createdAt
    dueDate
    amount
    status
    recurringpayment
    externalId
    externalInvoiceNumber
    autopaidAt
    customer {
      id
      name
      tagIDs
    }
  }
`
export const PartnerCustomerSearchFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerSearch on Customer {
    id
    name
  }
`
export const PartnerCustomerAddressFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerAddress on Customer {
    streetAddress
    subPremise
    city
    postalCode
    state
    country
  }
`
export const PartnerCustomerListFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerList on Customer {
    ...PartnerCustomerSearch
    legalName
    ein
    createdAt
    isOnboarded
    tagIDs
    ...PartnerCustomerAddress
    partner {
      id
      paymentsPortalUrl
    }
  }
  ${PartnerCustomerSearchFragmentDoc}
  ${PartnerCustomerAddressFragmentDoc}
`
export const PartnerCustomerListWithInvoicesDataFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerListWithInvoicesData on Customer {
    ...PartnerCustomerList
    outstandingInvoicesData {
      outstandingInvoicesCount
      outstandingInvoicesTotal
      longestDaysOverdue
    }
    defaultPaymentMethod {
      methodID
      method
      institution {
        ...Bank
      }
      card {
        ...CreditCard
      }
    }
    tagIDs
  }
  ${PartnerCustomerListFragmentDoc}
  ${BankFragmentDoc}
  ${CreditCardFragmentDoc}
`
export const FindAutopayRuleFragmentDoc = /*#__PURE__*/ gql`
  fragment FindAutopayRule on AutopayRule {
    ...AutopayRules
    customers {
      ...PartnerCustomerListWithInvoicesData
    }
    tagIDs
  }
  ${AutopayRulesFragmentDoc}
  ${PartnerCustomerListWithInvoicesDataFragmentDoc}
`
export const PartnerInvoiceBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceBasic on Invoice {
    id
    invoiceNumber
    productName
    status
    statuses {
      status
      createdAt
    }
    amount
    dueDate
    outstandingAmount
    platformName
    totalDiscountAmount
    payments {
      id
      status
      payoutCreationForecastDate
    }
  }
`
export const PartnerCustomerBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerBasic on Customer {
    createdAt
    id
    name
    legalName
    isOnboarded
    ...PartnerCustomerAddress
  }
  ${PartnerCustomerAddressFragmentDoc}
`
export const PartnerBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerBase on Partner {
    id
    name
    legalName
    isOnboarded
    adyenOnboardingStatus
    insightsEnabled
    timezone
    useUserLocalTimezone
    timezoneSetAt
    attachInvoicePDFEnabled
    pdfFallbackEnabled
  }
`
export const PartnerSubscriptionPaymentBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerSubscriptionPaymentBasic on SubscriptionPayment {
    id
    subscription {
      id
      type
      frequency
    }
    paymentDate
    subscriptionStatus: status
    amount
  }
`
export const PartnerPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerPayment on Payment {
    id
    paymentFees {
      forwarded
      type
      amount
      name
    }
    amount
    netAmount
    creationDate
    currentPaymentMethod
    currentPaymentMethodEntity {
      ... on Account {
        id
        name
        mask
        type
      }
      ... on Card {
        id
        cardNetWork
        last4
        fundingSource
      }
    }
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    dueDate
    paymentCompletionForecastDate
    product {
      ... on Invoice {
        ...PartnerInvoiceBasic
      }
      ... on SubscriptionPayment {
        ...PartnerSubscriptionPaymentBasic
      }
      ... on OneTimePayment {
        id
        referenceId
      }
    }
    transaction {
      failureReason
      failureReasonCode
      status
    }
    statuses {
      status
      createdAt
    }
    originService
    executorType
    refunds {
      id
      amount
      status {
        id
        status
        createdAt
      }
      createdAt
      lastStatus
    }
    payoutEstimation {
      estimatedPayoutCreationDate
    }
  }
  ${PartnerCustomerAddressFragmentDoc}
  ${PartnerInvoiceBasicFragmentDoc}
  ${PartnerSubscriptionPaymentBasicFragmentDoc}
`
export const PartnerCustomerInstallmentFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerInstallment on Installment {
    id
    amount
    dueDate
    netAmount
    status
    payments {
      ... on Payment {
        ...PartnerPayment
      }
    }
  }
  ${PartnerPaymentFragmentDoc}
`
export const PartnerCustomerScheduleFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerSchedule on Lending {
    id
    amount
    netAmount
    installments {
      ... on Installment {
        ...PartnerCustomerInstallment
      }
    }
  }
  ${PartnerCustomerInstallmentFragmentDoc}
`
export const PartnerCustomerOfferFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerOffer on BNPLOffer {
    createdAt
    status
    amount
    fees
    netAmount
    lending {
      ...PartnerCustomerSchedule
    }
    remainingBalance
    terms
  }
  ${PartnerCustomerScheduleFragmentDoc}
`
export const PartnerCustomerBnplFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerBNPL on Invoice {
    ...PartnerInvoiceBasic
    amount
    createdAt
    dueDate
    customer {
      ...PartnerCustomerBasic
    }
    partner {
      ...PartnerBase
    }
    offer {
      ...PartnerCustomerOffer
    }
  }
  ${PartnerInvoiceBasicFragmentDoc}
  ${PartnerCustomerBasicFragmentDoc}
  ${PartnerBaseFragmentDoc}
  ${PartnerCustomerOfferFragmentDoc}
`
export const BankAccountWithVerificationFragmentDoc = /*#__PURE__*/ gql`
  fragment BankAccountWithVerification on Account {
    ...BankAccount
    bankAccountVerification {
      id
      verificationStatus
      verificationType
      transactionNetwork
      remediationActions {
        message
        internalCode
      }
    }
    mandates {
      id
      consentAt
      version
    }
  }
  ${BankAccountFragmentDoc}
`
export const BankWithVerificationFragmentDoc = /*#__PURE__*/ gql`
  fragment BankWithVerification on Institution {
    id
    externalId
    name
    url
    logo
    accounts {
      ...BankAccountWithVerification
    }
  }
  ${BankAccountWithVerificationFragmentDoc}
`
export const BankAccountInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BankAccountInfo on BankAccount {
    id
    receiverName
    type
    subtype
    accountNumber
    routingNumber
    customName
    institution {
      name
    }
    bankAccountVerification {
      id
      bankAccountId
      verificationStatus
      verificationType
      remediationActions {
        message
        internalCode
      }
      transactionNetwork
      version
    }
    countryCode
    accountData {
      ... on USAccountData {
        institutionName
        routingNumber
        wireRoutingNumber
        accountNumber
        receiverName
        subtype
        type
      }
      ... on CAAccountData {
        institutionName
        institutionCode
        transitNumber
        accountNumber
        receiverName
        subtype
        type
      }
    }
  }
`
export const PaymentRequestFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentRequest on PaymentRequest {
    id
    lastStatus
    paymentDate
    payment {
      paymentFees {
        forwarded
        amount
      }
      amount
      netAmount
      paymentCompletionForecastDate
      transaction {
        failureReason
      }
    }
    product {
      ... on Invoice {
        id
        invoiceNumber
        productName
        amount
        customer {
          id
          name
        }
        status
        amount
      }
    }
  }
`
export const PartnerInvoiceBulkChargeFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceBulkCharge on PartnerInvoiceBulkCharge {
    id
    partner {
      id
      name
    }
    requester {
      id
      email
    }
    bulkChargeRequestStatus
    invoiceCount
    paymentDate
    createdAt
    paymentRequests {
      ...PaymentRequest
    }
  }
  ${PaymentRequestFragmentDoc}
`
export const PartnerCollectionInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCollectionInvoice on Invoice {
    id
    amount
    outstandingAmount
    collection {
      id
      status {
        status
        createdAt
      }
    }
    createdAt
    customer {
      ...PartnerCustomerBasic
    }
    dueDate
    invoiceNumber
    status
  }
  ${PartnerCustomerBasicFragmentDoc}
`
export const UpfrontFeePaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment UpfrontFeePayment on Payment {
    id
    amount
    netAmount
    dueDate
    currentPaymentMethodEntity {
      ... on Account {
        id
        name
      }
      ... on Card {
        id
        cardNetWork
      }
    }
    paymentFees {
      amount
      forwarded
      name
    }
    paymentCompletionForecastDate
    statuses {
      status
      createdAt
    }
  }
`
export const PartnerCollectionListingFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCollectionListing on Collection {
    id
    createdAt
    collectionOutstandingAmount
    collectionFeePaymentAmount
    interest
    collectionPayment {
      id
      amount
      creationDate
    }
    invoice {
      id
      amount
      dueDate
      invoiceNumber
      productName
    }
    customerInfo {
      customer {
        ...PartnerCustomerBasic
      }
    }
    upfrontFeePayment {
      ...UpfrontFeePayment
    }
    status {
      status
      createdAt
    }
  }
  ${PartnerCustomerBasicFragmentDoc}
  ${UpfrontFeePaymentFragmentDoc}
`
export const PartnerCollectionDetailFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCollectionDetail on Collection {
    id
    collectionInstruction
    collectionOutstandingAmount
    collectionFeePaymentAmount
    interest
    lastContactDate
    customerType
    collectionPayment {
      id
      amount
      netAmount
      currentPaymentMethodEntity {
        ... on Account {
          id
          name
        }
        ... on Card {
          id
          cardNetWork
        }
      }
      paymentFees {
        amount
        forwarded
        name
      }
      statuses {
        status
        createdAt
      }
      paymentCompletionForecastDate
    }
    customerInfo {
      customer {
        name
        id
      }
      name
      phone
      email
      streetAddress
      subPremise
      city
      state
      postalCode
      country
    }
    invoice {
      id
      amount
      dueDate
      invoiceNumber
      productName
    }
    notes {
      note
      createdAt
    }
    status {
      status
      createdAt
    }
    createdAt
    updatedAt
    upfrontFeePayment {
      ...UpfrontFeePayment
    }
  }
  ${UpfrontFeePaymentFragmentDoc}
`
export const PartnerOverdueInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerOverdueInvoice on Invoice {
    id
    amount
    outstandingAmount
    createdAt
    customer {
      ...PartnerCustomerBasic
    }
    dueDate
    invoiceNumber
    status
    collection {
      id
      status {
        status
        createdAt
      }
    }
  }
  ${PartnerCustomerBasicFragmentDoc}
`
export const PartnerCreditMemoConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCreditMemoConfig on CreditMemoConfig {
    partnerID
    showCreditMemo
    customerExceptionIDs
    enabled
  }
`
export const PartnerCustomerCreditMemoBalanceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerCreditMemoBalance on CustomerCreditMemoBalance {
    balance
    currencyCode
    show
    lastSyncedAt
    enabled
  }
`
export const CreditMemoDetailFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditMemoDetailFields on CreditMemoDetail {
    id
    partnerID
    customer {
      id
      name
    }
    externalMemoNumber
    totalAmount
    remainingAmount
    status
    currencyCode
    issueDate
    createdAt
  }
`
export const CustomerV2FieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerV2Fields on Customer {
    id
    name
    legalName
    ein
    industry
    companyType
    description
    isOnboarded
    country
    streetAddress
    subPremise
    city
    postalCode
    state
    isArchived
    tagIDs
    createdAt
    owed
    paidLast30Days
  }
`
export const PartnerCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomer on Customer {
    ...PartnerCustomerBasic
    ein
    companyType
    industry
    description
    isArchived
    archivedBy
  }
  ${PartnerCustomerBasicFragmentDoc}
`
export const CustomerWithCustomerUserListFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerWithCustomerUserList on Customer {
    ...PartnerCustomerSearch
    customerUsers {
      id
      email
    }
  }
  ${PartnerCustomerSearchFragmentDoc}
`
export const PartnerListCustomerUsersFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListCustomerUsers on CustomerUser {
    id
    email
    firstName
    lastName
    approvedBy
    createdAt
    customer {
      id
      name
    }
  }
`
export const PartnerCustomerUserCreationFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerUserCreation on CustomerUser {
    id
    email
    firstName
    lastName
  }
`
export const PartnerInvoiceEmailActivityFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceEmailActivity on Invoice {
    id
    invoiceNumber
  }
`
export const PartnerEmailActivityFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerEmailActivity on EmailActivity {
    sentAt
    user
    subject
    invoice {
      ...PartnerInvoiceEmailActivity
    }
    customer {
      id
      name
    }
    status
  }
  ${PartnerInvoiceEmailActivityFragmentDoc}
`
export const PartnerCustomerFeeConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerFeeConfig on CustomerFeeConfig {
    id
    customer {
      id
      name
    }
    feeType
  }
`
export const BucketCountDataFragmentDoc = /*#__PURE__*/ gql`
  fragment BucketCountData on BucketCountData {
    bucket
    value
  }
`
export const BucketAmountDataFragmentDoc = /*#__PURE__*/ gql`
  fragment BucketAmountData on BucketAmountData {
    bucket
    value
  }
`
export const DataPointFragmentDoc = /*#__PURE__*/ gql`
  fragment DataPoint on DataPoint {
    month
    value
  }
`
export const InvoiceCountMonthFragmentDoc = /*#__PURE__*/ gql`
  fragment InvoiceCountMonth on InvoiceCountMonth {
    month
    data {
      status
      count
    }
  }
`
export const InvoiceAmountMonthFragmentDoc = /*#__PURE__*/ gql`
  fragment InvoiceAmountMonth on InvoiceAmountMonth {
    month
    data {
      status
      value
    }
  }
`
export const CwQueryFiltersFragmentDoc = /*#__PURE__*/ gql`
  fragment CWQueryFilters on ConnectWiseQueryFilters {
    invoiceFilters {
      locations {
        id
        name
      }
      status {
        id
        name
      }
      createdSince
    }
    customerFilters {
      status {
        id
        name
      }
      territories {
        id
        name
      }
      types {
        id
        name
      }
    }
  }
`
export const PartnerIntegrationIssueFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerIntegrationIssue on IntegrationIssue {
    id
    entityType
    entityName
    entityExternalId
    sourceIntegrationPlatform
    sourceIntegrationType
    targetIntegrationPlatform
    targetIntegrationType
    reason
    reasonDescription
    detectedAt
    createdAt
  }
`
export const PartnerIntegrationJobFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerIntegrationJob on IntegrationJob {
    id
    createdAt
    updatedAt
    type
    status
    errorMessage
    request
    response
    requestID
    invoiceRelation {
      invoiceNumber
      customer {
        id
        name
      }
    }
    deposit {
      txnID
    }
  }
`
export const PartnerIntegrationJobQueueFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerIntegrationJobQueue on IntegrationJobQueue {
    id
    createdAt
    updatedAt
    type
    status
    errorMessage
    request
    response
    requestID
    invoiceRelation {
      invoiceNumber
      customer {
        id
        name
      }
    }
    deposit {
      txnID
    }
  }
`
export const HaloQueryFiltersFragmentDoc = /*#__PURE__*/ gql`
  fragment HaloQueryFilters on HaloPSAConnectionQueryFilters {
    customerFilters {
      topLevels {
        id
        name
      }
    }
    invoiceFilters {
      createdSince
    }
  }
`
export const PartnerIntegrationFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerIntegration on IntegrationInterface {
    __typename
    id
    partnerID
    platformName
    createdAt
    integrationType
    ... on AutotaskIntegration {
      status
    }
    ... on ConnectwiseIntegration {
      status
    }
    ... on HaloPSAIntegration {
      status
      queryFilters {
        ...HaloQueryFilters
      }
    }
    ... on QuickbooksIntegration {
      status
    }
    ... on RutterIntegration {
      status
    }
    ... on SuperOpsIntegration {
      status
    }
    ... on DatagateIntegration {
      status
    }
  }
  ${HaloQueryFiltersFragmentDoc}
`
export const PartnerUnsyncedInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUnsyncedInvoice on InvoiceRelation {
    id
    invoiceNumber
    createdAt
    dueDate
    amount
    customer {
      id
      name
    }
    invoiceID
  }
`
export const AccountingSyncBatchFragmentDoc = /*#__PURE__*/ gql`
  fragment AccountingSyncBatch on AccountingSyncBatch {
    id
    createdAt
    externalID
    status
    platform
    numberOfInvoices
  }
`
export const QuickbooksAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment QuickbooksAccount on QuickbooksAccount {
    id
    type
    name
    fullyQualifiedName
  }
`
export const RutterAccountListFragmentDoc = /*#__PURE__*/ gql`
  fragment RutterAccountList on RutterAccount {
    id
    type
    name
    nominalCode
  }
`
export const PartnerInvoiceSearchFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceSearch on Invoice {
    id
    invoiceNumber
    productName
  }
`
export const PartnerInvoiceOfferFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceOffer on BNPLOffer {
    id
    partnerConfirmed
    status
    createdAt
    terms
    amount
    netAmount
    lending {
      ...PartnerCustomerSchedule
    }
  }
  ${PartnerCustomerScheduleFragmentDoc}
`
export const PartnerInvoiceListingFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceListing on Invoice {
    id
    amount
    outstandingAmount
    createdAt
    createdByCustomer
    customer {
      name
      id
    }
    dueDate
    invoiceNumber
    lastRemindedAt
    productName
    status
    recurringpayment
    offer {
      ...PartnerInvoiceOffer
    }
    payments {
      id
      status
      payoutCreationForecastDate
    }
    transferPayments {
      id
      statuses {
        status
      }
      transaction {
        failureReason
      }
    }
    externalId
    externalInvoiceNumber
    autopaidAt
  }
  ${PartnerInvoiceOfferFragmentDoc}
`
export const PartnerConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerConfig on Partner {
    paymentsPortalEnabled
    paymentsPortalUrl
    paymentsPortalCustomUrl
    paymentsPortalUseCustomUrl
    paymentsPortalDefaultUrl
    paymentsPortalMethods
    paymentsPortalCustomization {
      color
      logoUrl
    }
  }
`
export const PartnerAddressDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerAddressDetails on Partner {
    city
    state
    stateCode
    country
    countryCode
    postalCode
    streetAddress
    subPremise
  }
`
export const PartnerInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoice on Invoice {
    ...PartnerInvoiceBasic
    amount
    outstandingAmount
    createdAt
    createdByCustomer
    customer {
      ...PartnerCustomerBasic
    }
    partner {
      ...PartnerBase
      ...PartnerConfig
      ...PartnerAddressDetails
    }
    offer {
      ...PartnerInvoiceOffer
    }
    dueDate
    recurringpayment
    recurringpaymentID
    lastRemindedAt
    transferPayments {
      id
      statuses {
        status
      }
      transaction {
        failureReason
      }
    }
    externalId
    externalInvoiceNumber
    totalTaxAmount
    purchaseOrder
    lineItems {
      code
      category
      description
      quantity
      extendedAmountPerItem
      unitPrice
    }
  }
  ${PartnerInvoiceBasicFragmentDoc}
  ${PartnerCustomerBasicFragmentDoc}
  ${PartnerBaseFragmentDoc}
  ${PartnerConfigFragmentDoc}
  ${PartnerAddressDetailsFragmentDoc}
  ${PartnerInvoiceOfferFragmentDoc}
`
export const EmailTemplateFragmentDoc = /*#__PURE__*/ gql`
  fragment EmailTemplate on EmailTemplate {
    id
    partnerID
    name
    subject
    section1
    section2
    section3
    type
    favorite
  }
`
export const PartnerInvoiceReminderFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceReminder on InvoiceReminder {
    id
    daysOffset
    type
    createdAt
    sentHour
    timezone
    runsHourly
    enabled
    cc
    bcc
    tags {
      ID
      name
      description
      color
      type
    }
    customers {
      id
      name
      legalName
      tagIDs
    }
    template {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`
export const PartnerInvoiceReminderExcludedCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceReminderExcludedCustomer on InvoiceReminderExcludedCustomer {
    id
    customer {
      ...PartnerCustomerList
    }
    createdAt
  }
  ${PartnerCustomerListFragmentDoc}
`
export const PartnerInvoiceSummaryFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceSummary on InvoiceSummary {
    id
    frequency
    customDay
    startAt
    createdAt
    template {
      ...EmailTemplate
    }
    sentHour
    timezone
    enabled
    cc
    bcc
    tags {
      ID
      name
      description
      color
      type
    }
    customers {
      id
      name
      legalName
      tagIDs
    }
  }
  ${EmailTemplateFragmentDoc}
`
export const PartnerInvoiceSummaryExcludedCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceSummaryExcludedCustomer on InvoiceSummaryExcludedCustomer {
    id
    customer {
      ...PartnerCustomerList
    }
    createdAt
  }
  ${PartnerCustomerListFragmentDoc}
`
export const PartnerOpenPayoutDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerOpenPayoutDetails on OpenPayoutDetails {
    id
    payoutWindowDate
    amount {
      units
      nanos
    }
    netAmount {
      units
      nanos
    }
    fees {
      label
      description
      amount {
        units
        nanos
      }
      forwarded
    }
    breakdownTotals {
      productType
      productTypeCount
      sumFees {
        units
        nanos
      }
      sumGrossAmount {
        units
        nanos
      }
      feesGreaterThanZeroCount
      sumAcceleratedPayoutFees {
        units
        nanos
      }
      acceleratedPayoutCapFee {
        units
        nanos
      }
    }
  }
`
export const PartnerOpenPayoutBreakdownItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerOpenPayoutBreakdownItem on OpenPayoutBreakdownItem {
    id
    createdAt
    transaction {
      id
    }
    transactionDate
    transactionType
    product {
      ... on Invoice {
        id
        invoiceNumber
        productName
        status
        statuses {
          status
          createdAt
        }
        customer {
          id
          name
        }
        amount
        dueDate
        outstandingAmount
        payments {
          payoutCreationForecastDate
        }
      }
      ... on OneTimePayment {
        id
        referenceId
      }
      ... on Refund {
        id
        paymentID
        paymentReferenceId
      }
    }
    fee {
      units
      nanos
    }
    grossAmount {
      units
      nanos
    }
    paymentMethod {
      ... on Account {
        id
        name
      }
      ... on Card {
        id
        cardNetWork
        fundingSource
      }
    }
    partner {
      id
      name
    }
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    companyType
  }
  ${PartnerCustomerAddressFragmentDoc}
`
export const CompanyDocumentFragmentDoc = /*#__PURE__*/ gql`
  fragment CompanyDocument on CompanyDocument {
    id
    partnerID
    type
    url
    filename
    createdAt
    individualID
  }
`
export const CompanyIndividualFragmentDoc = /*#__PURE__*/ gql`
  fragment CompanyIndividual on CompanyIndividual {
    id
    partnerID
    firstName
    lastName
    email
    phone
    dateOfBirth
    jobTitle
    country
    countryCode
    streetAddress
    subPremise
    postalCode
    state
    stateCode
    city
    hasSSN
    owner
    signatory
    controllingPerson
  }
`
export const CompanyIndividualWithDocumentsFragmentDoc = /*#__PURE__*/ gql`
  fragment CompanyIndividualWithDocuments on CompanyIndividual {
    id
    partnerID
    firstName
    lastName
    email
    phone
    dateOfBirth
    jobTitle
    country
    countryCode
    streetAddress
    subPremise
    postalCode
    state
    stateCode
    city
    hasSSN
    owner
    signatory
    controllingPerson
    individualDocuments {
      id
      partnerID
      type
      url
      filename
      createdAt
      individualID
    }
  }
`
export const PartnerSidebarItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerSidebarItem on Partner {
    id
    name
  }
`
export const PartnerDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerDetails on Partner {
    ein
    incorporationNumber
    companyType
    industry
    description
  }
`
export const SupportPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment SupportPreferences on SupportPreferences {
    partnerID
    name
    email
    phone
    firstLine
    secondLine
  }
`
export const PaymentConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentConfig on PaymentCompanyConfig {
    id
    paymentMethodEntity {
      __typename
      ... on Account {
        id
        mask
        name
        customName
        institution {
          id
          logo
        }
      }
      ... on Card {
        id
        last4
        expirationDate
        cardNetWork
        customName
        fundingSource
      }
    }
    paymentMethod
  }
`
export const CustomerPaymentMethodFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerPaymentMethod on PaymentCompanyConfig {
    id
    company {
      __typename
      ... on Customer {
        id
        name
      }
    }
    paymentMethodEntity {
      __typename
      ... on Account {
        ...BankAccount
      }
      ... on Card {
        ...CreditCard
      }
    }
    paymentMethod
  }
  ${BankAccountFragmentDoc}
  ${CreditCardFragmentDoc}
`
export const CustomersPaymentMethodFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomersPaymentMethod on PaymentCompanyConfig {
    id
    company {
      __typename
      ... on Customer {
        id
        name
      }
    }
    paymentMethod
  }
`
export const PayoutBreakdownTotalsFragmentDoc = /*#__PURE__*/ gql`
  fragment PayoutBreakdownTotals on PayoutBreakdownTotals {
    productType
    productTypeCount
    sumFees
    sumGrossAmount
    feesGreaterThanZeroCount
  }
`
export const TransactionFragmentDoc = /*#__PURE__*/ gql`
  fragment Transaction on Transaction {
    failureReason
    transactionMethod
    status
  }
`
export const PartnerPayoutDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerPayoutDetails on PayoutDetails {
    id
    amount
    netAmount
    publicNumber
    payoutType
    statuses {
      status
      createdAt
    }
    creationDate
    payoutCompletionForecastDate
    payoutBreakdownTotals {
      ...PayoutBreakdownTotals
    }
    product {
      ... on Invoice {
        ...PartnerInvoiceBasic
      }
    }
    account {
      name
      mask
      institution {
        name
      }
    }
    transactions {
      ...Transaction
    }
    fees {
      name
      amount
    }
  }
  ${PayoutBreakdownTotalsFragmentDoc}
  ${PartnerInvoiceBasicFragmentDoc}
  ${TransactionFragmentDoc}
`
export const PartnerPayoutFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerPayout on Payout {
    id
    amount
    netAmount
    publicNumber
    fees {
      forwarded
      type
      amount
      name
    }
    creationDate
    payoutCompletionForecastDate
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    product {
      ... on Invoice {
        ...PartnerInvoiceBasic
      }
    }
    statuses {
      status
      createdAt
    }
    transactions {
      failureReason
      transactionMethod
      status
    }
    account {
      name
      mask
      institution {
        name
      }
    }
    payoutBreakdownTotals {
      ...PayoutBreakdownTotals
    }
  }
  ${PartnerCustomerAddressFragmentDoc}
  ${PartnerInvoiceBasicFragmentDoc}
  ${PayoutBreakdownTotalsFragmentDoc}
`
export const ReferralBonusFragmentDoc = /*#__PURE__*/ gql`
  fragment ReferralBonus on ReferralBonus {
    id
    description
    referralPayoutID
    amount
  }
`
export const PartnerBreakdownListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerBreakdownListItem on BreakdownListItem {
    id
    createdAt
    transactionDate
    transactionType
    fee
    grossAmount
    companyType
    transaction {
      id
    }
    product {
      ... on Invoice {
        id
        invoiceNumber
        productName
        status
        statuses {
          status
          createdAt
        }
        customer {
          id
          name
        }
        amount
        dueDate
        outstandingAmount
        payments {
          payoutCreationForecastDate
        }
      }
      ... on OneTimePayment {
        id
        referenceId
      }
      ... on Refund {
        id
        paymentID
        paymentReferenceId
      }
      ... on Referral {
        id
        referralDate
        referredPartner {
          id
          name
        }
      }
      ... on ReferralBonus {
        ...ReferralBonus
      }
    }
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    partner {
      id
      name
    }
    paymentMethod {
      ... on Account {
        id
        name
      }
      ... on Card {
        id
        cardNetWork
        fundingSource
      }
    }
  }
  ${ReferralBonusFragmentDoc}
  ${PartnerCustomerAddressFragmentDoc}
`
export const PartnerListPendingCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListPendingCustomer on Customer {
    id
    name
  }
`
export const PartnerListPendingCustomerUserFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListPendingCustomerUser on PendingCustomerUser {
    id
    email
    partnerId
    customer {
      ...PartnerListPendingCustomer
    }
    createdAt
  }
  ${PartnerListPendingCustomerFragmentDoc}
`
export const PartnerRecurringPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerRecurringPayment on RecurringPayment {
    id
    customer {
      id
      name
    }
    productName
    amount
    frequency
    status
    dateFirstCharge
    dateLastCharge
    autoCharge
  }
`
export const GetReferralDataReplyFragmentDoc = /*#__PURE__*/ gql`
  fragment GetReferralDataReply on GetReferralDataReply {
    total
    previous
  }
`
export const ReferralFragmentDoc = /*#__PURE__*/ gql`
  fragment Referral on Referral {
    id
    companyName
    referralDate
    referralFees
    avgQuarterlyFees
    status
    email
    customerID
    referredPartner {
      id
      name
      detailedSubscription {
        subscriptions {
          type
          id
          frequency
          amount
          billingCyclesCovered
          billingCyclesUnit
          lastStatus
          firstBilledDate
        }
        monthlyRevenue {
          year
          month
          amount
        }
      }
    }
    recipients {
      email
      userID
    }
  }
`
export const ReferralPayoutFragmentDoc = /*#__PURE__*/ gql`
  fragment ReferralPayout on ReferralPayout {
    id
    payoutID
    referralCount
    amount
    period
    partnerID
    status
    payoutDate
    referredPartnersRevenue {
      referredPartnerID
      lastQuarterRevenue
    }
  }
`
export const RoutineListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment RoutineListItem on Routine {
    id
    name
    instruction
    frequency
    sentHour
    timezone
    dayOfWeek
    customDay
    emailEnabled
    enabled
    nextRunAt
    __typename
  }
`
export const RoutineDetailFragmentDoc = /*#__PURE__*/ gql`
  fragment RoutineDetail on Routine {
    id
    name
    instruction
    frequency
    sentHour
    timezone
    dayOfWeek
    customDay
    emailEnabled
    recipients
    enabled
    nextRunAt
    createdAt
    updatedAt
    __typename
  }
`
export const RoutineRunRowFragmentDoc = /*#__PURE__*/ gql`
  fragment RoutineRunRow on RoutineRunListItem {
    id
    status
    emailStatus
    error
    startedAt
    finishedAt
    createdAt
    artifactCount
    __typename
  }
`
export const RoutineRunDetailFragmentDoc = /*#__PURE__*/ gql`
  fragment RoutineRunDetail on RoutineRun {
    id
    status
    source
    emailStatus
    outputText
    error
    attempts
    maxAttempts
    startedAt
    finishedAt
    createdAt
    artifacts {
      fileID
      filename
      contentType
      sizeBytes
    }
    __typename
  }
`
export const PartnerScheduledOneOffEmailFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerScheduledOneOffEmail on ScheduledOneOffEmail {
    id
    createdAt
    sendAt
    timezone
    cc
    bcc
    template {
      id
      name
      subject
      section1
      type
    }
    customers {
      id
      name
      legalName
      tagIDs
    }
    tags {
      ID
      name
      description
      color
      type
    }
  }
`
export const SubscriptionPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionPayment on SubscriptionPayment {
    id
    subscription {
      id
      type
      frequency
      billingCyclesCovered
      billingCyclesUnit
    }
    paymentDate
    payment {
      id
      paymentFees {
        amount
      }
    }
    amount
    status
  }
`
export const PartnerSubscriptionFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerSubscription on PartnerSubscription {
    id
    type
    amount
    frequency
    nextBillingDate
    billingCyclesCovered
    billingCyclesUnit
  }
`
export const PartnerUserListFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUserList on PartnerUser {
    createdAt
    id
    email
    firstName
    lastName
    role
    hasMFA
  }
`
export const BasicUserInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicUserInfo on PartnerUserInfo {
    createdAt
    id
    email
    firstName
    lastName
    phone
    jobTitle
    role
    permissions
  }
`
export const BasicPartnerUserInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicPartnerUserInfo on PartnerUserInfo {
    partner {
      createdAt
      id
      isOnboarded
      isDeactivated
      adyenOnboardingStatus
      name
      ein
      paymentsPortalEnabled
      insightsEnabled
      hasBankStatementUploaded
      country
      countryCode
      tosAndPciAccepted
      isValidToOnboarding
      adyenBusinessSetup
      timezone
      useUserLocalTimezone
      timezoneSetAt
      currency
      attachInvoicePDFEnabled
      pdfFallbackEnabled
      blockGoingLive
    }
  }
`
export const PartnerUserConfigDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUserConfigDetails on PartnerUserInfo {
    partner {
      paymentsPortalEnabled
      paymentsPortalMethods
      paymentsPortalUrl
      paymentsPortalCustomization {
        color
        logoUrl
      }
      paymentsPortalCustomInvoices
      requiresMFA
    }
  }
`
export const UserInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment UserInfo on PartnerUserInfo {
    ...BasicUserInfo
    ...BasicPartnerUserInfo
    ...PartnerUserConfigDetails
  }
  ${BasicUserInfoFragmentDoc}
  ${BasicPartnerUserInfoFragmentDoc}
  ${PartnerUserConfigDetailsFragmentDoc}
`
export const PartnerAddressInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerAddressInfo on PartnerUserInfo {
    partner {
      id
      streetAddress
      subPremise
      city
      country
      countryCode
      postalCode
      state
      stateCode
    }
  }
`
export const PartnerUserInfoDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUserInfoDetails on PartnerUserInfo {
    partner {
      legalName
      ein
      companyType
      industry
      description
      website
      phone
      adyenCompanyType
      adyenIndustryCode
      adyenBusinessSetup
      timezone
      useUserLocalTimezone
      timezoneSetAt
      incorporationNumber
    }
  }
`
export const UserInfoDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserInfoDetails on PartnerUserInfo {
    ...BasicUserInfo
    ...BasicPartnerUserInfo
    ...PartnerAddressInfo
    ...PartnerUserInfoDetails
    ...PartnerUserConfigDetails
  }
  ${BasicUserInfoFragmentDoc}
  ${BasicPartnerUserInfoFragmentDoc}
  ${PartnerAddressInfoFragmentDoc}
  ${PartnerUserInfoDetailsFragmentDoc}
  ${PartnerUserConfigDetailsFragmentDoc}
`
export const PartnerBaseUserFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerBaseUser on PartnerUser {
    id
    email
    firstName
    lastName
  }
`
export const PartnerListUserFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListUser on PartnerUser {
    ...PartnerBaseUser
    __typename
    role
    createdAt
  }
  ${PartnerBaseUserFragmentDoc}
`
export const PartnerGetCompanyIndividualByUploadLinkDocument = /*#__PURE__*/ gql`
  query PartnerGetCompanyIndividualByUploadLink($uploadLinkId: ID!) {
    PartnerGetCompanyIndividualByUploadLink(uploadLinkId: $uploadLinkId) {
      ...PartialCompanyIndividual
    }
  }
  ${PartialCompanyIndividualFragmentDoc}
`

/**
 * __usePartnerGetCompanyIndividualByUploadLinkQuery__
 *
 * To run a query within a React component, call `usePartnerGetCompanyIndividualByUploadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCompanyIndividualByUploadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCompanyIndividualByUploadLinkQuery({
 *   variables: {
 *      uploadLinkId: // value for 'uploadLinkId'
 *   },
 * });
 */
export function usePartnerGetCompanyIndividualByUploadLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCompanyIndividualByUploadLinkQuery,
    PartnerGetCompanyIndividualByUploadLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCompanyIndividualByUploadLinkQuery,
    PartnerGetCompanyIndividualByUploadLinkQueryVariables
  >(PartnerGetCompanyIndividualByUploadLinkDocument, options)
}
export function usePartnerGetCompanyIndividualByUploadLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCompanyIndividualByUploadLinkQuery,
    PartnerGetCompanyIndividualByUploadLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCompanyIndividualByUploadLinkQuery,
    PartnerGetCompanyIndividualByUploadLinkQueryVariables
  >(PartnerGetCompanyIndividualByUploadLinkDocument, options)
}
export type PartnerGetCompanyIndividualByUploadLinkQueryHookResult = ReturnType<
  typeof usePartnerGetCompanyIndividualByUploadLinkQuery
>
export type PartnerGetCompanyIndividualByUploadLinkLazyQueryHookResult =
  ReturnType<typeof usePartnerGetCompanyIndividualByUploadLinkLazyQuery>
export type PartnerGetCompanyIndividualByUploadLinkQueryResult =
  Apollo.QueryResult<
    PartnerGetCompanyIndividualByUploadLinkQuery,
    PartnerGetCompanyIndividualByUploadLinkQueryVariables
  >
export const PartnerUploadDocumentByUploadLinkIdDocument = /*#__PURE__*/ gql`
  mutation PartnerUploadDocumentByUploadLinkId(
    $input: UploadPartnerDocumentByUploadLinkInput!
  ) {
    PartnerUploadDocumentByUploadLinkId(input: $input)
  }
`
export type PartnerUploadDocumentByUploadLinkIdMutationFn =
  Apollo.MutationFunction<
    PartnerUploadDocumentByUploadLinkIdMutation,
    PartnerUploadDocumentByUploadLinkIdMutationVariables
  >

/**
 * __usePartnerUploadDocumentByUploadLinkIdMutation__
 *
 * To run a mutation, you first call `usePartnerUploadDocumentByUploadLinkIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUploadDocumentByUploadLinkIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUploadDocumentByUploadLinkIdMutation, { data, loading, error }] = usePartnerUploadDocumentByUploadLinkIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUploadDocumentByUploadLinkIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUploadDocumentByUploadLinkIdMutation,
    PartnerUploadDocumentByUploadLinkIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUploadDocumentByUploadLinkIdMutation,
    PartnerUploadDocumentByUploadLinkIdMutationVariables
  >(PartnerUploadDocumentByUploadLinkIdDocument, options)
}
export type PartnerUploadDocumentByUploadLinkIdMutationHookResult = ReturnType<
  typeof usePartnerUploadDocumentByUploadLinkIdMutation
>
export type PartnerUploadDocumentByUploadLinkIdMutationResult =
  Apollo.MutationResult<PartnerUploadDocumentByUploadLinkIdMutation>
export type PartnerUploadDocumentByUploadLinkIdMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUploadDocumentByUploadLinkIdMutation,
    PartnerUploadDocumentByUploadLinkIdMutationVariables
  >
export const PartnerCreateCardRevealTokenDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCardRevealToken($billID: ID!) {
    PartnerCreateCardRevealToken(billID: $billID) {
      token
    }
  }
`
export type PartnerCreateCardRevealTokenMutationFn = Apollo.MutationFunction<
  PartnerCreateCardRevealTokenMutation,
  PartnerCreateCardRevealTokenMutationVariables
>

/**
 * __usePartnerCreateCardRevealTokenMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCardRevealTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCardRevealTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCardRevealTokenMutation, { data, loading, error }] = usePartnerCreateCardRevealTokenMutation({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerCreateCardRevealTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCardRevealTokenMutation,
    PartnerCreateCardRevealTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCardRevealTokenMutation,
    PartnerCreateCardRevealTokenMutationVariables
  >(PartnerCreateCardRevealTokenDocument, options)
}
export type PartnerCreateCardRevealTokenMutationHookResult = ReturnType<
  typeof usePartnerCreateCardRevealTokenMutation
>
export type PartnerCreateCardRevealTokenMutationResult =
  Apollo.MutationResult<PartnerCreateCardRevealTokenMutation>
export type PartnerCreateCardRevealTokenMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCardRevealTokenMutation,
    PartnerCreateCardRevealTokenMutationVariables
  >
export const PartnerCreateBillDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateBill($input: CreateBill) {
    PartnerCreateBill(billInput: $input) {
      ID
    }
  }
`
export type PartnerCreateBillMutationFn = Apollo.MutationFunction<
  PartnerCreateBillMutation,
  PartnerCreateBillMutationVariables
>

/**
 * __usePartnerCreateBillMutation__
 *
 * To run a mutation, you first call `usePartnerCreateBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateBillMutation, { data, loading, error }] = usePartnerCreateBillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateBillMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateBillMutation,
    PartnerCreateBillMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateBillMutation,
    PartnerCreateBillMutationVariables
  >(PartnerCreateBillDocument, options)
}
export type PartnerCreateBillMutationHookResult = ReturnType<
  typeof usePartnerCreateBillMutation
>
export type PartnerCreateBillMutationResult =
  Apollo.MutationResult<PartnerCreateBillMutation>
export type PartnerCreateBillMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateBillMutation,
  PartnerCreateBillMutationVariables
>
export const PartnerCreateVendorDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateVendor($input: CreateVendor) {
    PartnerCreateVendor(vendorInput: $input) {
      ID
    }
  }
`
export type PartnerCreateVendorMutationFn = Apollo.MutationFunction<
  PartnerCreateVendorMutation,
  PartnerCreateVendorMutationVariables
>

/**
 * __usePartnerCreateVendorMutation__
 *
 * To run a mutation, you first call `usePartnerCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateVendorMutation, { data, loading, error }] = usePartnerCreateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateVendorMutation,
    PartnerCreateVendorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateVendorMutation,
    PartnerCreateVendorMutationVariables
  >(PartnerCreateVendorDocument, options)
}
export type PartnerCreateVendorMutationHookResult = ReturnType<
  typeof usePartnerCreateVendorMutation
>
export type PartnerCreateVendorMutationResult =
  Apollo.MutationResult<PartnerCreateVendorMutation>
export type PartnerCreateVendorMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateVendorMutation,
  PartnerCreateVendorMutationVariables
>
export const PartnerUpdateVendorDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateVendor($input: UpdateVendor) {
    PartnerUpdateVendor(vendorInput: $input) {
      ID
    }
  }
`
export type PartnerUpdateVendorMutationFn = Apollo.MutationFunction<
  PartnerUpdateVendorMutation,
  PartnerUpdateVendorMutationVariables
>

/**
 * __usePartnerUpdateVendorMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateVendorMutation, { data, loading, error }] = usePartnerUpdateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateVendorMutation,
    PartnerUpdateVendorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateVendorMutation,
    PartnerUpdateVendorMutationVariables
  >(PartnerUpdateVendorDocument, options)
}
export type PartnerUpdateVendorMutationHookResult = ReturnType<
  typeof usePartnerUpdateVendorMutation
>
export type PartnerUpdateVendorMutationResult =
  Apollo.MutationResult<PartnerUpdateVendorMutation>
export type PartnerUpdateVendorMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateVendorMutation,
  PartnerUpdateVendorMutationVariables
>
export const BillsConnectionDocument = /*#__PURE__*/ gql`
  query BillsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: BillFilter
    $orderBy: BillOrderBy
  ) {
    PartnerBillsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...BillConnection
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${BillConnectionFragmentDoc}
`

/**
 * __useBillsConnectionQuery__
 *
 * To run a query within a React component, call `useBillsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBillsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BillsConnectionQuery,
    BillsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BillsConnectionQuery, BillsConnectionQueryVariables>(
    BillsConnectionDocument,
    options
  )
}
export function useBillsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BillsConnectionQuery,
    BillsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BillsConnectionQuery,
    BillsConnectionQueryVariables
  >(BillsConnectionDocument, options)
}
export type BillsConnectionQueryHookResult = ReturnType<
  typeof useBillsConnectionQuery
>
export type BillsConnectionLazyQueryHookResult = ReturnType<
  typeof useBillsConnectionLazyQuery
>
export type BillsConnectionQueryResult = Apollo.QueryResult<
  BillsConnectionQuery,
  BillsConnectionQueryVariables
>
export const BillListDocument = /*#__PURE__*/ gql`
  query BillList(
    $filters: BillFilter
    $limit: Int
    $offset: Int
    $orderBy: BillOrderBy
  ) {
    PartnerBillList(
      filters: $filters
      limit: $limit
      offset: $offset
      orderBy: $orderBy
    ) {
      bills {
        ...BillConnection
      }
      totalCount
      hasMore
    }
  }
  ${BillConnectionFragmentDoc}
`

/**
 * __useBillListQuery__
 *
 * To run a query within a React component, call `useBillListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBillListQuery(
  baseOptions?: Apollo.QueryHookOptions<BillListQuery, BillListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BillListQuery, BillListQueryVariables>(
    BillListDocument,
    options
  )
}
export function useBillListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BillListQuery,
    BillListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BillListQuery, BillListQueryVariables>(
    BillListDocument,
    options
  )
}
export type BillListQueryHookResult = ReturnType<typeof useBillListQuery>
export type BillListLazyQueryHookResult = ReturnType<
  typeof useBillListLazyQuery
>
export type BillListQueryResult = Apollo.QueryResult<
  BillListQuery,
  BillListQueryVariables
>
export const PartnerVendorSearchDocument = /*#__PURE__*/ gql`
  query PartnerVendorSearch($name: String) {
    PartnerVendorsConnection(
      first: 10
      filters: { vendorName: $name, isActive: true }
    ) {
      edges {
        node {
          ...PartnerVendorSearch
        }
      }
    }
  }
  ${PartnerVendorSearchFragmentDoc}
`

/**
 * __usePartnerVendorSearchQuery__
 *
 * To run a query within a React component, call `usePartnerVendorSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerVendorSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerVendorSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePartnerVendorSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerVendorSearchQuery,
    PartnerVendorSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerVendorSearchQuery,
    PartnerVendorSearchQueryVariables
  >(PartnerVendorSearchDocument, options)
}
export function usePartnerVendorSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerVendorSearchQuery,
    PartnerVendorSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerVendorSearchQuery,
    PartnerVendorSearchQueryVariables
  >(PartnerVendorSearchDocument, options)
}
export type PartnerVendorSearchQueryHookResult = ReturnType<
  typeof usePartnerVendorSearchQuery
>
export type PartnerVendorSearchLazyQueryHookResult = ReturnType<
  typeof usePartnerVendorSearchLazyQuery
>
export type PartnerVendorSearchQueryResult = Apollo.QueryResult<
  PartnerVendorSearchQuery,
  PartnerVendorSearchQueryVariables
>
export const VendorsConnectionDocument = /*#__PURE__*/ gql`
  query VendorsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: VendorFilter
    $orderBy: VendorOrderBy
  ) {
    PartnerVendorsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...VendorListItem
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${VendorListItemFragmentDoc}
`

/**
 * __useVendorsConnectionQuery__
 *
 * To run a query within a React component, call `useVendorsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useVendorsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VendorsConnectionQuery,
    VendorsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorsConnectionQuery,
    VendorsConnectionQueryVariables
  >(VendorsConnectionDocument, options)
}
export function useVendorsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorsConnectionQuery,
    VendorsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorsConnectionQuery,
    VendorsConnectionQueryVariables
  >(VendorsConnectionDocument, options)
}
export type VendorsConnectionQueryHookResult = ReturnType<
  typeof useVendorsConnectionQuery
>
export type VendorsConnectionLazyQueryHookResult = ReturnType<
  typeof useVendorsConnectionLazyQuery
>
export type VendorsConnectionQueryResult = Apollo.QueryResult<
  VendorsConnectionQuery,
  VendorsConnectionQueryVariables
>
export const PartnerFindPaymentPreferenceByVendorIdDocument = /*#__PURE__*/ gql`
  query PartnerFindPaymentPreferenceByVendorID($vendorID: String!) {
    PartnerFindPaymentPreferenceByVendorID(vendorID: $vendorID) {
      ...PaymentPreference
    }
  }
  ${PaymentPreferenceFragmentDoc}
`

/**
 * __usePartnerFindPaymentPreferenceByVendorIdQuery__
 *
 * To run a query within a React component, call `usePartnerFindPaymentPreferenceByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindPaymentPreferenceByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindPaymentPreferenceByVendorIdQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePartnerFindPaymentPreferenceByVendorIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindPaymentPreferenceByVendorIdQuery,
    PartnerFindPaymentPreferenceByVendorIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindPaymentPreferenceByVendorIdQuery,
    PartnerFindPaymentPreferenceByVendorIdQueryVariables
  >(PartnerFindPaymentPreferenceByVendorIdDocument, options)
}
export function usePartnerFindPaymentPreferenceByVendorIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindPaymentPreferenceByVendorIdQuery,
    PartnerFindPaymentPreferenceByVendorIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindPaymentPreferenceByVendorIdQuery,
    PartnerFindPaymentPreferenceByVendorIdQueryVariables
  >(PartnerFindPaymentPreferenceByVendorIdDocument, options)
}
export type PartnerFindPaymentPreferenceByVendorIdQueryHookResult = ReturnType<
  typeof usePartnerFindPaymentPreferenceByVendorIdQuery
>
export type PartnerFindPaymentPreferenceByVendorIdLazyQueryHookResult =
  ReturnType<typeof usePartnerFindPaymentPreferenceByVendorIdLazyQuery>
export type PartnerFindPaymentPreferenceByVendorIdQueryResult =
  Apollo.QueryResult<
    PartnerFindPaymentPreferenceByVendorIdQuery,
    PartnerFindPaymentPreferenceByVendorIdQueryVariables
  >
export const PartnerFindBillByIdDocument = /*#__PURE__*/ gql`
  query PartnerFindBillByID($billID: String!) {
    PartnerFindBillByID(billID: $billID) {
      ...Bill
    }
  }
  ${BillFragmentDoc}
`

/**
 * __usePartnerFindBillByIdQuery__
 *
 * To run a query within a React component, call `usePartnerFindBillByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindBillByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindBillByIdQuery({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerFindBillByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindBillByIdQuery,
    PartnerFindBillByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindBillByIdQuery,
    PartnerFindBillByIdQueryVariables
  >(PartnerFindBillByIdDocument, options)
}
export function usePartnerFindBillByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindBillByIdQuery,
    PartnerFindBillByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindBillByIdQuery,
    PartnerFindBillByIdQueryVariables
  >(PartnerFindBillByIdDocument, options)
}
export type PartnerFindBillByIdQueryHookResult = ReturnType<
  typeof usePartnerFindBillByIdQuery
>
export type PartnerFindBillByIdLazyQueryHookResult = ReturnType<
  typeof usePartnerFindBillByIdLazyQuery
>
export type PartnerFindBillByIdQueryResult = Apollo.QueryResult<
  PartnerFindBillByIdQuery,
  PartnerFindBillByIdQueryVariables
>
export const PartnerGetBillVendorPaymentDocument = /*#__PURE__*/ gql`
  query PartnerGetBillVendorPayment($billID: String!) {
    PartnerFindBillByID(billID: $billID) {
      ID
      vendorPayment {
        ...VendorPaymentFragment
      }
    }
  }
  ${VendorPaymentFragmentFragmentDoc}
`

/**
 * __usePartnerGetBillVendorPaymentQuery__
 *
 * To run a query within a React component, call `usePartnerGetBillVendorPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetBillVendorPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetBillVendorPaymentQuery({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerGetBillVendorPaymentQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetBillVendorPaymentQuery,
    PartnerGetBillVendorPaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetBillVendorPaymentQuery,
    PartnerGetBillVendorPaymentQueryVariables
  >(PartnerGetBillVendorPaymentDocument, options)
}
export function usePartnerGetBillVendorPaymentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetBillVendorPaymentQuery,
    PartnerGetBillVendorPaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetBillVendorPaymentQuery,
    PartnerGetBillVendorPaymentQueryVariables
  >(PartnerGetBillVendorPaymentDocument, options)
}
export type PartnerGetBillVendorPaymentQueryHookResult = ReturnType<
  typeof usePartnerGetBillVendorPaymentQuery
>
export type PartnerGetBillVendorPaymentLazyQueryHookResult = ReturnType<
  typeof usePartnerGetBillVendorPaymentLazyQuery
>
export type PartnerGetBillVendorPaymentQueryResult = Apollo.QueryResult<
  PartnerGetBillVendorPaymentQuery,
  PartnerGetBillVendorPaymentQueryVariables
>
export const PartnerCreateVendorPaymentPreferenceDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateVendorPaymentPreference(
    $input: CreateVendorPaymentPreferenceInput
  ) {
    PartnerCreateVendorPaymentPreference(input: $input) {
      ID
    }
  }
`
export type PartnerCreateVendorPaymentPreferenceMutationFn =
  Apollo.MutationFunction<
    PartnerCreateVendorPaymentPreferenceMutation,
    PartnerCreateVendorPaymentPreferenceMutationVariables
  >

/**
 * __usePartnerCreateVendorPaymentPreferenceMutation__
 *
 * To run a mutation, you first call `usePartnerCreateVendorPaymentPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateVendorPaymentPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateVendorPaymentPreferenceMutation, { data, loading, error }] = usePartnerCreateVendorPaymentPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateVendorPaymentPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateVendorPaymentPreferenceMutation,
    PartnerCreateVendorPaymentPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateVendorPaymentPreferenceMutation,
    PartnerCreateVendorPaymentPreferenceMutationVariables
  >(PartnerCreateVendorPaymentPreferenceDocument, options)
}
export type PartnerCreateVendorPaymentPreferenceMutationHookResult = ReturnType<
  typeof usePartnerCreateVendorPaymentPreferenceMutation
>
export type PartnerCreateVendorPaymentPreferenceMutationResult =
  Apollo.MutationResult<PartnerCreateVendorPaymentPreferenceMutation>
export type PartnerCreateVendorPaymentPreferenceMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateVendorPaymentPreferenceMutation,
    PartnerCreateVendorPaymentPreferenceMutationVariables
  >
export const PartnerUpdateBillDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateBill($input: UpdateBill) {
    PartnerUpdateBill(billInput: $input) {
      ID
    }
  }
`
export type PartnerUpdateBillMutationFn = Apollo.MutationFunction<
  PartnerUpdateBillMutation,
  PartnerUpdateBillMutationVariables
>

/**
 * __usePartnerUpdateBillMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateBillMutation, { data, loading, error }] = usePartnerUpdateBillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateBillMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateBillMutation,
    PartnerUpdateBillMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateBillMutation,
    PartnerUpdateBillMutationVariables
  >(PartnerUpdateBillDocument, options)
}
export type PartnerUpdateBillMutationHookResult = ReturnType<
  typeof usePartnerUpdateBillMutation
>
export type PartnerUpdateBillMutationResult =
  Apollo.MutationResult<PartnerUpdateBillMutation>
export type PartnerUpdateBillMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateBillMutation,
  PartnerUpdateBillMutationVariables
>
export const PartnerSubmitBillForApprovalDocument = /*#__PURE__*/ gql`
  mutation PartnerSubmitBillForApproval($billID: String!) {
    PartnerSubmitBillForApproval(billID: $billID) {
      ID
    }
  }
`
export type PartnerSubmitBillForApprovalMutationFn = Apollo.MutationFunction<
  PartnerSubmitBillForApprovalMutation,
  PartnerSubmitBillForApprovalMutationVariables
>

/**
 * __usePartnerSubmitBillForApprovalMutation__
 *
 * To run a mutation, you first call `usePartnerSubmitBillForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSubmitBillForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSubmitBillForApprovalMutation, { data, loading, error }] = usePartnerSubmitBillForApprovalMutation({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerSubmitBillForApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSubmitBillForApprovalMutation,
    PartnerSubmitBillForApprovalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSubmitBillForApprovalMutation,
    PartnerSubmitBillForApprovalMutationVariables
  >(PartnerSubmitBillForApprovalDocument, options)
}
export type PartnerSubmitBillForApprovalMutationHookResult = ReturnType<
  typeof usePartnerSubmitBillForApprovalMutation
>
export type PartnerSubmitBillForApprovalMutationResult =
  Apollo.MutationResult<PartnerSubmitBillForApprovalMutation>
export type PartnerSubmitBillForApprovalMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSubmitBillForApprovalMutation,
    PartnerSubmitBillForApprovalMutationVariables
  >
export const PartnerBulkSubmitBillsForApprovalDocument = /*#__PURE__*/ gql`
  mutation PartnerBulkSubmitBillsForApproval($billIDs: [ID!]!) {
    PartnerBulkSubmitBillsForApproval(billIDs: $billIDs) {
      results {
        billId
        success
        errorReason
      }
    }
  }
`
export type PartnerBulkSubmitBillsForApprovalMutationFn =
  Apollo.MutationFunction<
    PartnerBulkSubmitBillsForApprovalMutation,
    PartnerBulkSubmitBillsForApprovalMutationVariables
  >

/**
 * __usePartnerBulkSubmitBillsForApprovalMutation__
 *
 * To run a mutation, you first call `usePartnerBulkSubmitBillsForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBulkSubmitBillsForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBulkSubmitBillsForApprovalMutation, { data, loading, error }] = usePartnerBulkSubmitBillsForApprovalMutation({
 *   variables: {
 *      billIDs: // value for 'billIDs'
 *   },
 * });
 */
export function usePartnerBulkSubmitBillsForApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBulkSubmitBillsForApprovalMutation,
    PartnerBulkSubmitBillsForApprovalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBulkSubmitBillsForApprovalMutation,
    PartnerBulkSubmitBillsForApprovalMutationVariables
  >(PartnerBulkSubmitBillsForApprovalDocument, options)
}
export type PartnerBulkSubmitBillsForApprovalMutationHookResult = ReturnType<
  typeof usePartnerBulkSubmitBillsForApprovalMutation
>
export type PartnerBulkSubmitBillsForApprovalMutationResult =
  Apollo.MutationResult<PartnerBulkSubmitBillsForApprovalMutation>
export type PartnerBulkSubmitBillsForApprovalMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBulkSubmitBillsForApprovalMutation,
    PartnerBulkSubmitBillsForApprovalMutationVariables
  >
export const PartnerRejectBillDocument = /*#__PURE__*/ gql`
  mutation PartnerRejectBill($billID: String!, $reason: String) {
    PartnerRejectBill(billID: $billID, reason: $reason) {
      ID
    }
  }
`
export type PartnerRejectBillMutationFn = Apollo.MutationFunction<
  PartnerRejectBillMutation,
  PartnerRejectBillMutationVariables
>

/**
 * __usePartnerRejectBillMutation__
 *
 * To run a mutation, you first call `usePartnerRejectBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRejectBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRejectBillMutation, { data, loading, error }] = usePartnerRejectBillMutation({
 *   variables: {
 *      billID: // value for 'billID'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePartnerRejectBillMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRejectBillMutation,
    PartnerRejectBillMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRejectBillMutation,
    PartnerRejectBillMutationVariables
  >(PartnerRejectBillDocument, options)
}
export type PartnerRejectBillMutationHookResult = ReturnType<
  typeof usePartnerRejectBillMutation
>
export type PartnerRejectBillMutationResult =
  Apollo.MutationResult<PartnerRejectBillMutation>
export type PartnerRejectBillMutationOptions = Apollo.BaseMutationOptions<
  PartnerRejectBillMutation,
  PartnerRejectBillMutationVariables
>
export const PartnerMarkBillPaidExternallyDocument = /*#__PURE__*/ gql`
  mutation PartnerMarkBillPaidExternally($billID: String!) {
    PartnerMarkBillPaidExternally(billID: $billID) {
      ID
    }
  }
`
export type PartnerMarkBillPaidExternallyMutationFn = Apollo.MutationFunction<
  PartnerMarkBillPaidExternallyMutation,
  PartnerMarkBillPaidExternallyMutationVariables
>

/**
 * __usePartnerMarkBillPaidExternallyMutation__
 *
 * To run a mutation, you first call `usePartnerMarkBillPaidExternallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerMarkBillPaidExternallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerMarkBillPaidExternallyMutation, { data, loading, error }] = usePartnerMarkBillPaidExternallyMutation({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerMarkBillPaidExternallyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerMarkBillPaidExternallyMutation,
    PartnerMarkBillPaidExternallyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerMarkBillPaidExternallyMutation,
    PartnerMarkBillPaidExternallyMutationVariables
  >(PartnerMarkBillPaidExternallyDocument, options)
}
export type PartnerMarkBillPaidExternallyMutationHookResult = ReturnType<
  typeof usePartnerMarkBillPaidExternallyMutation
>
export type PartnerMarkBillPaidExternallyMutationResult =
  Apollo.MutationResult<PartnerMarkBillPaidExternallyMutation>
export type PartnerMarkBillPaidExternallyMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerMarkBillPaidExternallyMutation,
    PartnerMarkBillPaidExternallyMutationVariables
  >
export const PartnerCountBillsDocument = /*#__PURE__*/ gql`
  query PartnerCountBills($input: CountBillsInput!) {
    PartnerCountBills(input: $input)
  }
`

/**
 * __usePartnerCountBillsQuery__
 *
 * To run a query within a React component, call `usePartnerCountBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCountBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCountBillsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCountBillsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerCountBillsQuery,
    PartnerCountBillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCountBillsQuery,
    PartnerCountBillsQueryVariables
  >(PartnerCountBillsDocument, options)
}
export function usePartnerCountBillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCountBillsQuery,
    PartnerCountBillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCountBillsQuery,
    PartnerCountBillsQueryVariables
  >(PartnerCountBillsDocument, options)
}
export type PartnerCountBillsQueryHookResult = ReturnType<
  typeof usePartnerCountBillsQuery
>
export type PartnerCountBillsLazyQueryHookResult = ReturnType<
  typeof usePartnerCountBillsLazyQuery
>
export type PartnerCountBillsQueryResult = Apollo.QueryResult<
  PartnerCountBillsQuery,
  PartnerCountBillsQueryVariables
>
export const PartnerNextValidPayDateDocument = /*#__PURE__*/ gql`
  query PartnerNextValidPayDate {
    PartnerNextValidPayDate
  }
`

/**
 * __usePartnerNextValidPayDateQuery__
 *
 * To run a query within a React component, call `usePartnerNextValidPayDateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerNextValidPayDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerNextValidPayDateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerNextValidPayDateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerNextValidPayDateQuery,
    PartnerNextValidPayDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerNextValidPayDateQuery,
    PartnerNextValidPayDateQueryVariables
  >(PartnerNextValidPayDateDocument, options)
}
export function usePartnerNextValidPayDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerNextValidPayDateQuery,
    PartnerNextValidPayDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerNextValidPayDateQuery,
    PartnerNextValidPayDateQueryVariables
  >(PartnerNextValidPayDateDocument, options)
}
export type PartnerNextValidPayDateQueryHookResult = ReturnType<
  typeof usePartnerNextValidPayDateQuery
>
export type PartnerNextValidPayDateLazyQueryHookResult = ReturnType<
  typeof usePartnerNextValidPayDateLazyQuery
>
export type PartnerNextValidPayDateQueryResult = Apollo.QueryResult<
  PartnerNextValidPayDateQuery,
  PartnerNextValidPayDateQueryVariables
>
export const PartnerFindVendorByIdDocument = /*#__PURE__*/ gql`
  query PartnerFindVendorByID($vendorID: String!) {
    PartnerFindVendorByID(vendorID: $vendorID) {
      ...Vendor
    }
  }
  ${VendorFragmentDoc}
`

/**
 * __usePartnerFindVendorByIdQuery__
 *
 * To run a query within a React component, call `usePartnerFindVendorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindVendorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindVendorByIdQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePartnerFindVendorByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindVendorByIdQuery,
    PartnerFindVendorByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindVendorByIdQuery,
    PartnerFindVendorByIdQueryVariables
  >(PartnerFindVendorByIdDocument, options)
}
export function usePartnerFindVendorByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindVendorByIdQuery,
    PartnerFindVendorByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindVendorByIdQuery,
    PartnerFindVendorByIdQueryVariables
  >(PartnerFindVendorByIdDocument, options)
}
export type PartnerFindVendorByIdQueryHookResult = ReturnType<
  typeof usePartnerFindVendorByIdQuery
>
export type PartnerFindVendorByIdLazyQueryHookResult = ReturnType<
  typeof usePartnerFindVendorByIdLazyQuery
>
export type PartnerFindVendorByIdQueryResult = Apollo.QueryResult<
  PartnerFindVendorByIdQuery,
  PartnerFindVendorByIdQueryVariables
>
export const PartnerVendorPaymentHistoryDocument = /*#__PURE__*/ gql`
  query PartnerVendorPaymentHistory(
    $vendorID: String!
    $after: Cursor
    $first: Int
  ) {
    PartnerBillsConnection(
      after: $after
      first: $first
      filters: { vendorIDs: [$vendorID], status: [BILL_PAID, BILL_FAILED] }
      orderBy: { field: DUE_DATE, direction: DESC }
    ) {
      edges {
        cursor
        node {
          ...BillConnection
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${BillConnectionFragmentDoc}
`

/**
 * __usePartnerVendorPaymentHistoryQuery__
 *
 * To run a query within a React component, call `usePartnerVendorPaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerVendorPaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerVendorPaymentHistoryQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePartnerVendorPaymentHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerVendorPaymentHistoryQuery,
    PartnerVendorPaymentHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerVendorPaymentHistoryQuery,
    PartnerVendorPaymentHistoryQueryVariables
  >(PartnerVendorPaymentHistoryDocument, options)
}
export function usePartnerVendorPaymentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerVendorPaymentHistoryQuery,
    PartnerVendorPaymentHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerVendorPaymentHistoryQuery,
    PartnerVendorPaymentHistoryQueryVariables
  >(PartnerVendorPaymentHistoryDocument, options)
}
export type PartnerVendorPaymentHistoryQueryHookResult = ReturnType<
  typeof usePartnerVendorPaymentHistoryQuery
>
export type PartnerVendorPaymentHistoryLazyQueryHookResult = ReturnType<
  typeof usePartnerVendorPaymentHistoryLazyQuery
>
export type PartnerVendorPaymentHistoryQueryResult = Apollo.QueryResult<
  PartnerVendorPaymentHistoryQuery,
  PartnerVendorPaymentHistoryQueryVariables
>
export const PartnerUpdateVendorPaymentPreferenceDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateVendorPaymentPreference(
    $input: UpdateVendorPaymentPreferenceInput
  ) {
    PartnerUpdateVendorPaymentPreference(input: $input) {
      paymentPreferenceID
      paymentMethodID
    }
  }
`
export type PartnerUpdateVendorPaymentPreferenceMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateVendorPaymentPreferenceMutation,
    PartnerUpdateVendorPaymentPreferenceMutationVariables
  >

/**
 * __usePartnerUpdateVendorPaymentPreferenceMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateVendorPaymentPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateVendorPaymentPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateVendorPaymentPreferenceMutation, { data, loading, error }] = usePartnerUpdateVendorPaymentPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateVendorPaymentPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateVendorPaymentPreferenceMutation,
    PartnerUpdateVendorPaymentPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateVendorPaymentPreferenceMutation,
    PartnerUpdateVendorPaymentPreferenceMutationVariables
  >(PartnerUpdateVendorPaymentPreferenceDocument, options)
}
export type PartnerUpdateVendorPaymentPreferenceMutationHookResult = ReturnType<
  typeof usePartnerUpdateVendorPaymentPreferenceMutation
>
export type PartnerUpdateVendorPaymentPreferenceMutationResult =
  Apollo.MutationResult<PartnerUpdateVendorPaymentPreferenceMutation>
export type PartnerUpdateVendorPaymentPreferenceMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateVendorPaymentPreferenceMutation,
    PartnerUpdateVendorPaymentPreferenceMutationVariables
  >
export const PartnerStartAccountsPayableOnboardingDocument = /*#__PURE__*/ gql`
  mutation PartnerStartAccountsPayableOnboarding {
    PartnerStartAccountsPayableOnboarding {
      validations
    }
  }
`
export type PartnerStartAccountsPayableOnboardingMutationFn =
  Apollo.MutationFunction<
    PartnerStartAccountsPayableOnboardingMutation,
    PartnerStartAccountsPayableOnboardingMutationVariables
  >

/**
 * __usePartnerStartAccountsPayableOnboardingMutation__
 *
 * To run a mutation, you first call `usePartnerStartAccountsPayableOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerStartAccountsPayableOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerStartAccountsPayableOnboardingMutation, { data, loading, error }] = usePartnerStartAccountsPayableOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function usePartnerStartAccountsPayableOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerStartAccountsPayableOnboardingMutation,
    PartnerStartAccountsPayableOnboardingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerStartAccountsPayableOnboardingMutation,
    PartnerStartAccountsPayableOnboardingMutationVariables
  >(PartnerStartAccountsPayableOnboardingDocument, options)
}
export type PartnerStartAccountsPayableOnboardingMutationHookResult =
  ReturnType<typeof usePartnerStartAccountsPayableOnboardingMutation>
export type PartnerStartAccountsPayableOnboardingMutationResult =
  Apollo.MutationResult<PartnerStartAccountsPayableOnboardingMutation>
export type PartnerStartAccountsPayableOnboardingMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerStartAccountsPayableOnboardingMutation,
    PartnerStartAccountsPayableOnboardingMutationVariables
  >
export const PartnerCreateFundingAttemptsDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateFundingAttempts($input: CreateFundingAttemptsInput!) {
    PartnerCreateFundingAttempts(input: $input) {
      results {
        billId
        success
        billStatus
      }
    }
  }
`
export type PartnerCreateFundingAttemptsMutationFn = Apollo.MutationFunction<
  PartnerCreateFundingAttemptsMutation,
  PartnerCreateFundingAttemptsMutationVariables
>

/**
 * __usePartnerCreateFundingAttemptsMutation__
 *
 * To run a mutation, you first call `usePartnerCreateFundingAttemptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateFundingAttemptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateFundingAttemptsMutation, { data, loading, error }] = usePartnerCreateFundingAttemptsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateFundingAttemptsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateFundingAttemptsMutation,
    PartnerCreateFundingAttemptsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateFundingAttemptsMutation,
    PartnerCreateFundingAttemptsMutationVariables
  >(PartnerCreateFundingAttemptsDocument, options)
}
export type PartnerCreateFundingAttemptsMutationHookResult = ReturnType<
  typeof usePartnerCreateFundingAttemptsMutation
>
export type PartnerCreateFundingAttemptsMutationResult =
  Apollo.MutationResult<PartnerCreateFundingAttemptsMutation>
export type PartnerCreateFundingAttemptsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateFundingAttemptsMutation,
    PartnerCreateFundingAttemptsMutationVariables
  >
export const PartnerChangeBillReceivingMethodDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeBillReceivingMethod(
    $input: ChangeBillReceivingMethodInput!
  ) {
    PartnerChangeBillReceivingMethod(input: $input) {
      billId
      success
      errorCode
      errorMessage
      billStatus
    }
  }
`
export type PartnerChangeBillReceivingMethodMutationFn =
  Apollo.MutationFunction<
    PartnerChangeBillReceivingMethodMutation,
    PartnerChangeBillReceivingMethodMutationVariables
  >

/**
 * __usePartnerChangeBillReceivingMethodMutation__
 *
 * To run a mutation, you first call `usePartnerChangeBillReceivingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeBillReceivingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeBillReceivingMethodMutation, { data, loading, error }] = usePartnerChangeBillReceivingMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerChangeBillReceivingMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeBillReceivingMethodMutation,
    PartnerChangeBillReceivingMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeBillReceivingMethodMutation,
    PartnerChangeBillReceivingMethodMutationVariables
  >(PartnerChangeBillReceivingMethodDocument, options)
}
export type PartnerChangeBillReceivingMethodMutationHookResult = ReturnType<
  typeof usePartnerChangeBillReceivingMethodMutation
>
export type PartnerChangeBillReceivingMethodMutationResult =
  Apollo.MutationResult<PartnerChangeBillReceivingMethodMutation>
export type PartnerChangeBillReceivingMethodMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeBillReceivingMethodMutation,
    PartnerChangeBillReceivingMethodMutationVariables
  >
export const PartnerRevealVirtualCardDocument = /*#__PURE__*/ gql`
  mutation PartnerRevealVirtualCard($billID: ID!) {
    PartnerRevealVirtualCard(billID: $billID) {
      cardReference
      last4
      network
      cardholderName
      panToken
      cvvToken
      expiryMonthToken
      expiryYearToken
    }
  }
`
export type PartnerRevealVirtualCardMutationFn = Apollo.MutationFunction<
  PartnerRevealVirtualCardMutation,
  PartnerRevealVirtualCardMutationVariables
>

/**
 * __usePartnerRevealVirtualCardMutation__
 *
 * To run a mutation, you first call `usePartnerRevealVirtualCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRevealVirtualCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRevealVirtualCardMutation, { data, loading, error }] = usePartnerRevealVirtualCardMutation({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerRevealVirtualCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRevealVirtualCardMutation,
    PartnerRevealVirtualCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRevealVirtualCardMutation,
    PartnerRevealVirtualCardMutationVariables
  >(PartnerRevealVirtualCardDocument, options)
}
export type PartnerRevealVirtualCardMutationHookResult = ReturnType<
  typeof usePartnerRevealVirtualCardMutation
>
export type PartnerRevealVirtualCardMutationResult =
  Apollo.MutationResult<PartnerRevealVirtualCardMutation>
export type PartnerRevealVirtualCardMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRevealVirtualCardMutation,
    PartnerRevealVirtualCardMutationVariables
  >
export const PartnerGetAccountsPayableConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountsPayableConfig {
    PartnerGetAccountsPayableConfig {
      ...AccountsPayableConfig
    }
  }
  ${AccountsPayableConfigFragmentDoc}
`

/**
 * __usePartnerGetAccountsPayableConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountsPayableConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountsPayableConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountsPayableConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetAccountsPayableConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetAccountsPayableConfigQuery,
    PartnerGetAccountsPayableConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountsPayableConfigQuery,
    PartnerGetAccountsPayableConfigQueryVariables
  >(PartnerGetAccountsPayableConfigDocument, options)
}
export function usePartnerGetAccountsPayableConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountsPayableConfigQuery,
    PartnerGetAccountsPayableConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountsPayableConfigQuery,
    PartnerGetAccountsPayableConfigQueryVariables
  >(PartnerGetAccountsPayableConfigDocument, options)
}
export type PartnerGetAccountsPayableConfigQueryHookResult = ReturnType<
  typeof usePartnerGetAccountsPayableConfigQuery
>
export type PartnerGetAccountsPayableConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAccountsPayableConfigLazyQuery
>
export type PartnerGetAccountsPayableConfigQueryResult = Apollo.QueryResult<
  PartnerGetAccountsPayableConfigQuery,
  PartnerGetAccountsPayableConfigQueryVariables
>
export const PartnerUpdateBillPayDateDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateBillPayDate($input: UpdateBillPayDateInput!) {
    PartnerUpdateBillPayDate(input: $input) {
      ID
    }
  }
`
export type PartnerUpdateBillPayDateMutationFn = Apollo.MutationFunction<
  PartnerUpdateBillPayDateMutation,
  PartnerUpdateBillPayDateMutationVariables
>

/**
 * __usePartnerUpdateBillPayDateMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateBillPayDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateBillPayDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateBillPayDateMutation, { data, loading, error }] = usePartnerUpdateBillPayDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateBillPayDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateBillPayDateMutation,
    PartnerUpdateBillPayDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateBillPayDateMutation,
    PartnerUpdateBillPayDateMutationVariables
  >(PartnerUpdateBillPayDateDocument, options)
}
export type PartnerUpdateBillPayDateMutationHookResult = ReturnType<
  typeof usePartnerUpdateBillPayDateMutation
>
export type PartnerUpdateBillPayDateMutationResult =
  Apollo.MutationResult<PartnerUpdateBillPayDateMutation>
export type PartnerUpdateBillPayDateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateBillPayDateMutation,
    PartnerUpdateBillPayDateMutationVariables
  >
export const PartnerDownloadBillDocumentDocument = /*#__PURE__*/ gql`
  query PartnerDownloadBillDocument($billId: ID!) {
    partnerDownloadBillDocument(billId: $billId) {
      downloadUrl
      filename
      mimeType
    }
  }
`

/**
 * __usePartnerDownloadBillDocumentQuery__
 *
 * To run a query within a React component, call `usePartnerDownloadBillDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDownloadBillDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDownloadBillDocumentQuery({
 *   variables: {
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function usePartnerDownloadBillDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerDownloadBillDocumentQuery,
    PartnerDownloadBillDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerDownloadBillDocumentQuery,
    PartnerDownloadBillDocumentQueryVariables
  >(PartnerDownloadBillDocumentDocument, options)
}
export function usePartnerDownloadBillDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerDownloadBillDocumentQuery,
    PartnerDownloadBillDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerDownloadBillDocumentQuery,
    PartnerDownloadBillDocumentQueryVariables
  >(PartnerDownloadBillDocumentDocument, options)
}
export type PartnerDownloadBillDocumentQueryHookResult = ReturnType<
  typeof usePartnerDownloadBillDocumentQuery
>
export type PartnerDownloadBillDocumentLazyQueryHookResult = ReturnType<
  typeof usePartnerDownloadBillDocumentLazyQuery
>
export type PartnerDownloadBillDocumentQueryResult = Apollo.QueryResult<
  PartnerDownloadBillDocumentQuery,
  PartnerDownloadBillDocumentQueryVariables
>
export const PartnerCancelVendorPaymentDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelVendorPayment($input: CancelVendorPaymentInput!) {
    PartnerCancelVendorPayment(input: $input) {
      paymentId
      status
    }
  }
`
export type PartnerCancelVendorPaymentMutationFn = Apollo.MutationFunction<
  PartnerCancelVendorPaymentMutation,
  PartnerCancelVendorPaymentMutationVariables
>

/**
 * __usePartnerCancelVendorPaymentMutation__
 *
 * To run a mutation, you first call `usePartnerCancelVendorPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelVendorPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelVendorPaymentMutation, { data, loading, error }] = usePartnerCancelVendorPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCancelVendorPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelVendorPaymentMutation,
    PartnerCancelVendorPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelVendorPaymentMutation,
    PartnerCancelVendorPaymentMutationVariables
  >(PartnerCancelVendorPaymentDocument, options)
}
export type PartnerCancelVendorPaymentMutationHookResult = ReturnType<
  typeof usePartnerCancelVendorPaymentMutation
>
export type PartnerCancelVendorPaymentMutationResult =
  Apollo.MutationResult<PartnerCancelVendorPaymentMutation>
export type PartnerCancelVendorPaymentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCancelVendorPaymentMutation,
    PartnerCancelVendorPaymentMutationVariables
  >
export const PartnerBulkCancelVendorPaymentsDocument = /*#__PURE__*/ gql`
  mutation PartnerBulkCancelVendorPayments(
    $input: BulkCancelVendorPaymentsInput!
  ) {
    PartnerBulkCancelVendorPayments(input: $input) {
      results {
        billId
        success
        errorReason
      }
    }
  }
`
export type PartnerBulkCancelVendorPaymentsMutationFn = Apollo.MutationFunction<
  PartnerBulkCancelVendorPaymentsMutation,
  PartnerBulkCancelVendorPaymentsMutationVariables
>

/**
 * __usePartnerBulkCancelVendorPaymentsMutation__
 *
 * To run a mutation, you first call `usePartnerBulkCancelVendorPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBulkCancelVendorPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBulkCancelVendorPaymentsMutation, { data, loading, error }] = usePartnerBulkCancelVendorPaymentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerBulkCancelVendorPaymentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBulkCancelVendorPaymentsMutation,
    PartnerBulkCancelVendorPaymentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBulkCancelVendorPaymentsMutation,
    PartnerBulkCancelVendorPaymentsMutationVariables
  >(PartnerBulkCancelVendorPaymentsDocument, options)
}
export type PartnerBulkCancelVendorPaymentsMutationHookResult = ReturnType<
  typeof usePartnerBulkCancelVendorPaymentsMutation
>
export type PartnerBulkCancelVendorPaymentsMutationResult =
  Apollo.MutationResult<PartnerBulkCancelVendorPaymentsMutation>
export type PartnerBulkCancelVendorPaymentsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBulkCancelVendorPaymentsMutation,
    PartnerBulkCancelVendorPaymentsMutationVariables
  >
export const PartnerBulkCancelBillScheduleDocument = /*#__PURE__*/ gql`
  mutation PartnerBulkCancelBillSchedule($input: BulkCancelBillScheduleInput!) {
    PartnerBulkCancelBillSchedule(input: $input) {
      results {
        billId
        success
        errorReason
      }
    }
  }
`
export type PartnerBulkCancelBillScheduleMutationFn = Apollo.MutationFunction<
  PartnerBulkCancelBillScheduleMutation,
  PartnerBulkCancelBillScheduleMutationVariables
>

/**
 * __usePartnerBulkCancelBillScheduleMutation__
 *
 * To run a mutation, you first call `usePartnerBulkCancelBillScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBulkCancelBillScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBulkCancelBillScheduleMutation, { data, loading, error }] = usePartnerBulkCancelBillScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerBulkCancelBillScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBulkCancelBillScheduleMutation,
    PartnerBulkCancelBillScheduleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBulkCancelBillScheduleMutation,
    PartnerBulkCancelBillScheduleMutationVariables
  >(PartnerBulkCancelBillScheduleDocument, options)
}
export type PartnerBulkCancelBillScheduleMutationHookResult = ReturnType<
  typeof usePartnerBulkCancelBillScheduleMutation
>
export type PartnerBulkCancelBillScheduleMutationResult =
  Apollo.MutationResult<PartnerBulkCancelBillScheduleMutation>
export type PartnerBulkCancelBillScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBulkCancelBillScheduleMutation,
    PartnerBulkCancelBillScheduleMutationVariables
  >
export const PartnerGetAccountsPayableNotificationPolicyDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountsPayableNotificationPolicy {
    PartnerGetAccountsPayableConfig {
      notificationPolicy {
        ...APNotificationPolicy
      }
    }
  }
  ${ApNotificationPolicyFragmentDoc}
`

/**
 * __usePartnerGetAccountsPayableNotificationPolicyQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountsPayableNotificationPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountsPayableNotificationPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountsPayableNotificationPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetAccountsPayableNotificationPolicyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetAccountsPayableNotificationPolicyQuery,
    PartnerGetAccountsPayableNotificationPolicyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountsPayableNotificationPolicyQuery,
    PartnerGetAccountsPayableNotificationPolicyQueryVariables
  >(PartnerGetAccountsPayableNotificationPolicyDocument, options)
}
export function usePartnerGetAccountsPayableNotificationPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountsPayableNotificationPolicyQuery,
    PartnerGetAccountsPayableNotificationPolicyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountsPayableNotificationPolicyQuery,
    PartnerGetAccountsPayableNotificationPolicyQueryVariables
  >(PartnerGetAccountsPayableNotificationPolicyDocument, options)
}
export type PartnerGetAccountsPayableNotificationPolicyQueryHookResult =
  ReturnType<typeof usePartnerGetAccountsPayableNotificationPolicyQuery>
export type PartnerGetAccountsPayableNotificationPolicyLazyQueryHookResult =
  ReturnType<typeof usePartnerGetAccountsPayableNotificationPolicyLazyQuery>
export type PartnerGetAccountsPayableNotificationPolicyQueryResult =
  Apollo.QueryResult<
    PartnerGetAccountsPayableNotificationPolicyQuery,
    PartnerGetAccountsPayableNotificationPolicyQueryVariables
  >
export const PartnerUpdateAccountsPayableNotificationPolicyDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateAccountsPayableNotificationPolicy(
    $input: UpdateAccountsPayableNotificationPolicyInput!
  ) {
    PartnerUpdateAccountsPayableNotificationPolicy(input: $input) {
      ...APNotificationPolicy
    }
  }
  ${ApNotificationPolicyFragmentDoc}
`
export type PartnerUpdateAccountsPayableNotificationPolicyMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateAccountsPayableNotificationPolicyMutation,
    PartnerUpdateAccountsPayableNotificationPolicyMutationVariables
  >

/**
 * __usePartnerUpdateAccountsPayableNotificationPolicyMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateAccountsPayableNotificationPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateAccountsPayableNotificationPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateAccountsPayableNotificationPolicyMutation, { data, loading, error }] = usePartnerUpdateAccountsPayableNotificationPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateAccountsPayableNotificationPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateAccountsPayableNotificationPolicyMutation,
    PartnerUpdateAccountsPayableNotificationPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateAccountsPayableNotificationPolicyMutation,
    PartnerUpdateAccountsPayableNotificationPolicyMutationVariables
  >(PartnerUpdateAccountsPayableNotificationPolicyDocument, options)
}
export type PartnerUpdateAccountsPayableNotificationPolicyMutationHookResult =
  ReturnType<typeof usePartnerUpdateAccountsPayableNotificationPolicyMutation>
export type PartnerUpdateAccountsPayableNotificationPolicyMutationResult =
  Apollo.MutationResult<PartnerUpdateAccountsPayableNotificationPolicyMutation>
export type PartnerUpdateAccountsPayableNotificationPolicyMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateAccountsPayableNotificationPolicyMutation,
    PartnerUpdateAccountsPayableNotificationPolicyMutationVariables
  >
export const PartnerDeleteBillsDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteBills($ids: [ID!]!) {
    PartnerDeleteBills(billIds: $ids) {
      results {
        billId
        success
        errorReason
      }
    }
  }
`
export type PartnerDeleteBillsMutationFn = Apollo.MutationFunction<
  PartnerDeleteBillsMutation,
  PartnerDeleteBillsMutationVariables
>

/**
 * __usePartnerDeleteBillsMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteBillsMutation, { data, loading, error }] = usePartnerDeleteBillsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePartnerDeleteBillsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteBillsMutation,
    PartnerDeleteBillsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteBillsMutation,
    PartnerDeleteBillsMutationVariables
  >(PartnerDeleteBillsDocument, options)
}
export type PartnerDeleteBillsMutationHookResult = ReturnType<
  typeof usePartnerDeleteBillsMutation
>
export type PartnerDeleteBillsMutationResult =
  Apollo.MutationResult<PartnerDeleteBillsMutation>
export type PartnerDeleteBillsMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeleteBillsMutation,
  PartnerDeleteBillsMutationVariables
>
export const PartnerSearchAccountingItemsDocument = /*#__PURE__*/ gql`
  query PartnerSearchAccountingItems(
    $platformName: PlatformName!
    $query: String!
    $limit: Int
    $activeOnly: Boolean
  ) {
    PartnerSearchAccountingItems(
      platformName: $platformName
      query: $query
      limit: $limit
      activeOnly: $activeOnly
    ) {
      ...AccountingItemFragment
    }
  }
  ${AccountingItemFragmentFragmentDoc}
`

/**
 * __usePartnerSearchAccountingItemsQuery__
 *
 * To run a query within a React component, call `usePartnerSearchAccountingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerSearchAccountingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerSearchAccountingItemsQuery({
 *   variables: {
 *      platformName: // value for 'platformName'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function usePartnerSearchAccountingItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerSearchAccountingItemsQuery,
    PartnerSearchAccountingItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerSearchAccountingItemsQuery,
    PartnerSearchAccountingItemsQueryVariables
  >(PartnerSearchAccountingItemsDocument, options)
}
export function usePartnerSearchAccountingItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerSearchAccountingItemsQuery,
    PartnerSearchAccountingItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerSearchAccountingItemsQuery,
    PartnerSearchAccountingItemsQueryVariables
  >(PartnerSearchAccountingItemsDocument, options)
}
export type PartnerSearchAccountingItemsQueryHookResult = ReturnType<
  typeof usePartnerSearchAccountingItemsQuery
>
export type PartnerSearchAccountingItemsLazyQueryHookResult = ReturnType<
  typeof usePartnerSearchAccountingItemsLazyQuery
>
export type PartnerSearchAccountingItemsQueryResult = Apollo.QueryResult<
  PartnerSearchAccountingItemsQuery,
  PartnerSearchAccountingItemsQueryVariables
>
export const PartnerGetAccountsPayableFundingAccountDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountsPayableFundingAccount {
    PartnerGetAccountsPayableConfig {
      fundingBankingAccount {
        ...ApFundingAccount
      }
    }
  }
  ${ApFundingAccountFragmentDoc}
`

/**
 * __usePartnerGetAccountsPayableFundingAccountQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountsPayableFundingAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountsPayableFundingAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountsPayableFundingAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetAccountsPayableFundingAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetAccountsPayableFundingAccountQuery,
    PartnerGetAccountsPayableFundingAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountsPayableFundingAccountQuery,
    PartnerGetAccountsPayableFundingAccountQueryVariables
  >(PartnerGetAccountsPayableFundingAccountDocument, options)
}
export function usePartnerGetAccountsPayableFundingAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountsPayableFundingAccountQuery,
    PartnerGetAccountsPayableFundingAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountsPayableFundingAccountQuery,
    PartnerGetAccountsPayableFundingAccountQueryVariables
  >(PartnerGetAccountsPayableFundingAccountDocument, options)
}
export type PartnerGetAccountsPayableFundingAccountQueryHookResult = ReturnType<
  typeof usePartnerGetAccountsPayableFundingAccountQuery
>
export type PartnerGetAccountsPayableFundingAccountLazyQueryHookResult =
  ReturnType<typeof usePartnerGetAccountsPayableFundingAccountLazyQuery>
export type PartnerGetAccountsPayableFundingAccountQueryResult =
  Apollo.QueryResult<
    PartnerGetAccountsPayableFundingAccountQuery,
    PartnerGetAccountsPayableFundingAccountQueryVariables
  >
export const PartnerChangeAccountsPayableFundingAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeAccountsPayableFundingAccount(
    $input: PartnerAccountsPayableFundingAccountUpdateInput!
  ) {
    PartnerChangeAccountsPayableFundingAccount(input: $input) {
      fundingBankingAccount {
        ...ApFundingAccount
      }
    }
  }
  ${ApFundingAccountFragmentDoc}
`
export type PartnerChangeAccountsPayableFundingAccountMutationFn =
  Apollo.MutationFunction<
    PartnerChangeAccountsPayableFundingAccountMutation,
    PartnerChangeAccountsPayableFundingAccountMutationVariables
  >

/**
 * __usePartnerChangeAccountsPayableFundingAccountMutation__
 *
 * To run a mutation, you first call `usePartnerChangeAccountsPayableFundingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeAccountsPayableFundingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeAccountsPayableFundingAccountMutation, { data, loading, error }] = usePartnerChangeAccountsPayableFundingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerChangeAccountsPayableFundingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeAccountsPayableFundingAccountMutation,
    PartnerChangeAccountsPayableFundingAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeAccountsPayableFundingAccountMutation,
    PartnerChangeAccountsPayableFundingAccountMutationVariables
  >(PartnerChangeAccountsPayableFundingAccountDocument, options)
}
export type PartnerChangeAccountsPayableFundingAccountMutationHookResult =
  ReturnType<typeof usePartnerChangeAccountsPayableFundingAccountMutation>
export type PartnerChangeAccountsPayableFundingAccountMutationResult =
  Apollo.MutationResult<PartnerChangeAccountsPayableFundingAccountMutation>
export type PartnerChangeAccountsPayableFundingAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeAccountsPayableFundingAccountMutation,
    PartnerChangeAccountsPayableFundingAccountMutationVariables
  >
export const PartnerListVendorDataRequestsDocument = /*#__PURE__*/ gql`
  query PartnerListVendorDataRequests($vendorID: String!) {
    PartnerListVendorDataRequests(vendorID: $vendorID) {
      id
      vendorID
      partnerID
      status
      createdAt
      expiresAt
      submittedAt
    }
  }
`

/**
 * __usePartnerListVendorDataRequestsQuery__
 *
 * To run a query within a React component, call `usePartnerListVendorDataRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListVendorDataRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListVendorDataRequestsQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePartnerListVendorDataRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListVendorDataRequestsQuery,
    PartnerListVendorDataRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListVendorDataRequestsQuery,
    PartnerListVendorDataRequestsQueryVariables
  >(PartnerListVendorDataRequestsDocument, options)
}
export function usePartnerListVendorDataRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListVendorDataRequestsQuery,
    PartnerListVendorDataRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListVendorDataRequestsQuery,
    PartnerListVendorDataRequestsQueryVariables
  >(PartnerListVendorDataRequestsDocument, options)
}
export type PartnerListVendorDataRequestsQueryHookResult = ReturnType<
  typeof usePartnerListVendorDataRequestsQuery
>
export type PartnerListVendorDataRequestsLazyQueryHookResult = ReturnType<
  typeof usePartnerListVendorDataRequestsLazyQuery
>
export type PartnerListVendorDataRequestsQueryResult = Apollo.QueryResult<
  PartnerListVendorDataRequestsQuery,
  PartnerListVendorDataRequestsQueryVariables
>
export const PartnerCreateVendorDataRequestDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateVendorDataRequest($vendorID: String!, $email: String) {
    PartnerCreateVendorDataRequest(vendorID: $vendorID, email: $email) {
      ID
    }
  }
`
export type PartnerCreateVendorDataRequestMutationFn = Apollo.MutationFunction<
  PartnerCreateVendorDataRequestMutation,
  PartnerCreateVendorDataRequestMutationVariables
>

/**
 * __usePartnerCreateVendorDataRequestMutation__
 *
 * To run a mutation, you first call `usePartnerCreateVendorDataRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateVendorDataRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateVendorDataRequestMutation, { data, loading, error }] = usePartnerCreateVendorDataRequestMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePartnerCreateVendorDataRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateVendorDataRequestMutation,
    PartnerCreateVendorDataRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateVendorDataRequestMutation,
    PartnerCreateVendorDataRequestMutationVariables
  >(PartnerCreateVendorDataRequestDocument, options)
}
export type PartnerCreateVendorDataRequestMutationHookResult = ReturnType<
  typeof usePartnerCreateVendorDataRequestMutation
>
export type PartnerCreateVendorDataRequestMutationResult =
  Apollo.MutationResult<PartnerCreateVendorDataRequestMutation>
export type PartnerCreateVendorDataRequestMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateVendorDataRequestMutation,
    PartnerCreateVendorDataRequestMutationVariables
  >
export const PartnerResendVendorDataRequestDocument = /*#__PURE__*/ gql`
  mutation PartnerResendVendorDataRequest($id: String!) {
    PartnerResendVendorDataRequest(id: $id) {
      ID
    }
  }
`
export type PartnerResendVendorDataRequestMutationFn = Apollo.MutationFunction<
  PartnerResendVendorDataRequestMutation,
  PartnerResendVendorDataRequestMutationVariables
>

/**
 * __usePartnerResendVendorDataRequestMutation__
 *
 * To run a mutation, you first call `usePartnerResendVendorDataRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerResendVendorDataRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerResendVendorDataRequestMutation, { data, loading, error }] = usePartnerResendVendorDataRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerResendVendorDataRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerResendVendorDataRequestMutation,
    PartnerResendVendorDataRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerResendVendorDataRequestMutation,
    PartnerResendVendorDataRequestMutationVariables
  >(PartnerResendVendorDataRequestDocument, options)
}
export type PartnerResendVendorDataRequestMutationHookResult = ReturnType<
  typeof usePartnerResendVendorDataRequestMutation
>
export type PartnerResendVendorDataRequestMutationResult =
  Apollo.MutationResult<PartnerResendVendorDataRequestMutation>
export type PartnerResendVendorDataRequestMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerResendVendorDataRequestMutation,
    PartnerResendVendorDataRequestMutationVariables
  >
export const GetVendorDataRequestByTokenDocument = /*#__PURE__*/ gql`
  query GetVendorDataRequestByToken($token: String!) {
    GetVendorDataRequestByToken(token: $token) {
      status
      partnerName
      expiresAt
      vendor {
        ID
        name
        email
        phone
        category
        taxId
        companyAddress
        city
        state
        postalCode
        country
        owner
        ownerEmail
        ownerPhone
        acceptsCreditCard
      }
    }
  }
`

/**
 * __useGetVendorDataRequestByTokenQuery__
 *
 * To run a query within a React component, call `useGetVendorDataRequestByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorDataRequestByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorDataRequestByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetVendorDataRequestByTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVendorDataRequestByTokenQuery,
    GetVendorDataRequestByTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetVendorDataRequestByTokenQuery,
    GetVendorDataRequestByTokenQueryVariables
  >(GetVendorDataRequestByTokenDocument, options)
}
export function useGetVendorDataRequestByTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVendorDataRequestByTokenQuery,
    GetVendorDataRequestByTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetVendorDataRequestByTokenQuery,
    GetVendorDataRequestByTokenQueryVariables
  >(GetVendorDataRequestByTokenDocument, options)
}
export type GetVendorDataRequestByTokenQueryHookResult = ReturnType<
  typeof useGetVendorDataRequestByTokenQuery
>
export type GetVendorDataRequestByTokenLazyQueryHookResult = ReturnType<
  typeof useGetVendorDataRequestByTokenLazyQuery
>
export type GetVendorDataRequestByTokenQueryResult = Apollo.QueryResult<
  GetVendorDataRequestByTokenQuery,
  GetVendorDataRequestByTokenQueryVariables
>
export const SubmitVendorDataDocument = /*#__PURE__*/ gql`
  mutation SubmitVendorData($input: SubmitVendorDataInput!) {
    SubmitVendorData(input: $input) {
      success
    }
  }
`
export type SubmitVendorDataMutationFn = Apollo.MutationFunction<
  SubmitVendorDataMutation,
  SubmitVendorDataMutationVariables
>

/**
 * __useSubmitVendorDataMutation__
 *
 * To run a mutation, you first call `useSubmitVendorDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVendorDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVendorDataMutation, { data, loading, error }] = useSubmitVendorDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitVendorDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitVendorDataMutation,
    SubmitVendorDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SubmitVendorDataMutation,
    SubmitVendorDataMutationVariables
  >(SubmitVendorDataDocument, options)
}
export type SubmitVendorDataMutationHookResult = ReturnType<
  typeof useSubmitVendorDataMutation
>
export type SubmitVendorDataMutationResult =
  Apollo.MutationResult<SubmitVendorDataMutation>
export type SubmitVendorDataMutationOptions = Apollo.BaseMutationOptions<
  SubmitVendorDataMutation,
  SubmitVendorDataMutationVariables
>
export const PartnerDeactivateVendorDocument = /*#__PURE__*/ gql`
  mutation PartnerDeactivateVendor($vendorID: ID!) {
    PartnerDeactivateVendor(vendorID: $vendorID) {
      vendorId
      affectedBillCount
    }
  }
`
export type PartnerDeactivateVendorMutationFn = Apollo.MutationFunction<
  PartnerDeactivateVendorMutation,
  PartnerDeactivateVendorMutationVariables
>

/**
 * __usePartnerDeactivateVendorMutation__
 *
 * To run a mutation, you first call `usePartnerDeactivateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeactivateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeactivateVendorMutation, { data, loading, error }] = usePartnerDeactivateVendorMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePartnerDeactivateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeactivateVendorMutation,
    PartnerDeactivateVendorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeactivateVendorMutation,
    PartnerDeactivateVendorMutationVariables
  >(PartnerDeactivateVendorDocument, options)
}
export type PartnerDeactivateVendorMutationHookResult = ReturnType<
  typeof usePartnerDeactivateVendorMutation
>
export type PartnerDeactivateVendorMutationResult =
  Apollo.MutationResult<PartnerDeactivateVendorMutation>
export type PartnerDeactivateVendorMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeactivateVendorMutation,
  PartnerDeactivateVendorMutationVariables
>
export const PartnerReactivateVendorDocument = /*#__PURE__*/ gql`
  mutation PartnerReactivateVendor($vendorID: ID!) {
    PartnerReactivateVendor(vendorID: $vendorID) {
      vendorId
      affectedBillCount
    }
  }
`
export type PartnerReactivateVendorMutationFn = Apollo.MutationFunction<
  PartnerReactivateVendorMutation,
  PartnerReactivateVendorMutationVariables
>

/**
 * __usePartnerReactivateVendorMutation__
 *
 * To run a mutation, you first call `usePartnerReactivateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerReactivateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerReactivateVendorMutation, { data, loading, error }] = usePartnerReactivateVendorMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePartnerReactivateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerReactivateVendorMutation,
    PartnerReactivateVendorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerReactivateVendorMutation,
    PartnerReactivateVendorMutationVariables
  >(PartnerReactivateVendorDocument, options)
}
export type PartnerReactivateVendorMutationHookResult = ReturnType<
  typeof usePartnerReactivateVendorMutation
>
export type PartnerReactivateVendorMutationResult =
  Apollo.MutationResult<PartnerReactivateVendorMutation>
export type PartnerReactivateVendorMutationOptions = Apollo.BaseMutationOptions<
  PartnerReactivateVendorMutation,
  PartnerReactivateVendorMutationVariables
>
export const PartnerBatchDeactivateVendorsDocument = /*#__PURE__*/ gql`
  mutation PartnerBatchDeactivateVendors($vendorIDs: [ID!]!) {
    PartnerBatchDeactivateVendors(vendorIDs: $vendorIDs) {
      results {
        vendorId
        success
        errorReason
        affectedBillCount
      }
    }
  }
`
export type PartnerBatchDeactivateVendorsMutationFn = Apollo.MutationFunction<
  PartnerBatchDeactivateVendorsMutation,
  PartnerBatchDeactivateVendorsMutationVariables
>

/**
 * __usePartnerBatchDeactivateVendorsMutation__
 *
 * To run a mutation, you first call `usePartnerBatchDeactivateVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBatchDeactivateVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBatchDeactivateVendorsMutation, { data, loading, error }] = usePartnerBatchDeactivateVendorsMutation({
 *   variables: {
 *      vendorIDs: // value for 'vendorIDs'
 *   },
 * });
 */
export function usePartnerBatchDeactivateVendorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBatchDeactivateVendorsMutation,
    PartnerBatchDeactivateVendorsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBatchDeactivateVendorsMutation,
    PartnerBatchDeactivateVendorsMutationVariables
  >(PartnerBatchDeactivateVendorsDocument, options)
}
export type PartnerBatchDeactivateVendorsMutationHookResult = ReturnType<
  typeof usePartnerBatchDeactivateVendorsMutation
>
export type PartnerBatchDeactivateVendorsMutationResult =
  Apollo.MutationResult<PartnerBatchDeactivateVendorsMutation>
export type PartnerBatchDeactivateVendorsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBatchDeactivateVendorsMutation,
    PartnerBatchDeactivateVendorsMutationVariables
  >
export const PartnerBatchReactivateVendorsDocument = /*#__PURE__*/ gql`
  mutation PartnerBatchReactivateVendors($vendorIDs: [ID!]!) {
    PartnerBatchReactivateVendors(vendorIDs: $vendorIDs) {
      results {
        vendorId
        success
        errorReason
        affectedBillCount
      }
    }
  }
`
export type PartnerBatchReactivateVendorsMutationFn = Apollo.MutationFunction<
  PartnerBatchReactivateVendorsMutation,
  PartnerBatchReactivateVendorsMutationVariables
>

/**
 * __usePartnerBatchReactivateVendorsMutation__
 *
 * To run a mutation, you first call `usePartnerBatchReactivateVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBatchReactivateVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBatchReactivateVendorsMutation, { data, loading, error }] = usePartnerBatchReactivateVendorsMutation({
 *   variables: {
 *      vendorIDs: // value for 'vendorIDs'
 *   },
 * });
 */
export function usePartnerBatchReactivateVendorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBatchReactivateVendorsMutation,
    PartnerBatchReactivateVendorsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBatchReactivateVendorsMutation,
    PartnerBatchReactivateVendorsMutationVariables
  >(PartnerBatchReactivateVendorsDocument, options)
}
export type PartnerBatchReactivateVendorsMutationHookResult = ReturnType<
  typeof usePartnerBatchReactivateVendorsMutation
>
export type PartnerBatchReactivateVendorsMutationResult =
  Apollo.MutationResult<PartnerBatchReactivateVendorsMutation>
export type PartnerBatchReactivateVendorsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBatchReactivateVendorsMutation,
    PartnerBatchReactivateVendorsMutationVariables
  >
export const PartnerSetAccountingIntegrationDocument = /*#__PURE__*/ gql`
  mutation PartnerSetAccountingIntegration($provider: AccountingProvider) {
    PartnerSetAccountingIntegration(provider: $provider) {
      ...AccountsPayableConfig
    }
  }
  ${AccountsPayableConfigFragmentDoc}
`
export type PartnerSetAccountingIntegrationMutationFn = Apollo.MutationFunction<
  PartnerSetAccountingIntegrationMutation,
  PartnerSetAccountingIntegrationMutationVariables
>

/**
 * __usePartnerSetAccountingIntegrationMutation__
 *
 * To run a mutation, you first call `usePartnerSetAccountingIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSetAccountingIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSetAccountingIntegrationMutation, { data, loading, error }] = usePartnerSetAccountingIntegrationMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function usePartnerSetAccountingIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSetAccountingIntegrationMutation,
    PartnerSetAccountingIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSetAccountingIntegrationMutation,
    PartnerSetAccountingIntegrationMutationVariables
  >(PartnerSetAccountingIntegrationDocument, options)
}
export type PartnerSetAccountingIntegrationMutationHookResult = ReturnType<
  typeof usePartnerSetAccountingIntegrationMutation
>
export type PartnerSetAccountingIntegrationMutationResult =
  Apollo.MutationResult<PartnerSetAccountingIntegrationMutation>
export type PartnerSetAccountingIntegrationMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSetAccountingIntegrationMutation,
    PartnerSetAccountingIntegrationMutationVariables
  >
export const PartnerUploadBillDocumentDocument = /*#__PURE__*/ gql`
  mutation PartnerUploadBillDocument($input: UploadBillDocumentInput!) {
    PartnerUploadBillDocument(input: $input) {
      billId
      billNumber
      extractedData {
        vendorName
        vendorEmail
        invoiceNumber
        total
        issueDate
        dueDate
        description
        lineItems {
          name
          description
          quantity
          unitPrice
          total
          category
          expenseAccountId
          amount
        }
      }
      documentPath
      warnings
    }
  }
`
export type PartnerUploadBillDocumentMutationFn = Apollo.MutationFunction<
  PartnerUploadBillDocumentMutation,
  PartnerUploadBillDocumentMutationVariables
>

/**
 * __usePartnerUploadBillDocumentMutation__
 *
 * To run a mutation, you first call `usePartnerUploadBillDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUploadBillDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUploadBillDocumentMutation, { data, loading, error }] = usePartnerUploadBillDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUploadBillDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUploadBillDocumentMutation,
    PartnerUploadBillDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUploadBillDocumentMutation,
    PartnerUploadBillDocumentMutationVariables
  >(PartnerUploadBillDocumentDocument, options)
}
export type PartnerUploadBillDocumentMutationHookResult = ReturnType<
  typeof usePartnerUploadBillDocumentMutation
>
export type PartnerUploadBillDocumentMutationResult =
  Apollo.MutationResult<PartnerUploadBillDocumentMutation>
export type PartnerUploadBillDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUploadBillDocumentMutation,
    PartnerUploadBillDocumentMutationVariables
  >
export const PartnerExtractBillDataDocument = /*#__PURE__*/ gql`
  mutation PartnerExtractBillData($input: ExtractBillDataInput!) {
    PartnerExtractBillData(input: $input) {
      extractedData {
        vendorName
        vendorEmail
        invoiceNumber
        total
        issueDate
        dueDate
        description
        lineItems {
          name
          description
          quantity
          unitPrice
          total
          category
          expenseAccountId
          amount
        }
      }
      documentPath
      warnings
    }
  }
`
export type PartnerExtractBillDataMutationFn = Apollo.MutationFunction<
  PartnerExtractBillDataMutation,
  PartnerExtractBillDataMutationVariables
>

/**
 * __usePartnerExtractBillDataMutation__
 *
 * To run a mutation, you first call `usePartnerExtractBillDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerExtractBillDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerExtractBillDataMutation, { data, loading, error }] = usePartnerExtractBillDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerExtractBillDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerExtractBillDataMutation,
    PartnerExtractBillDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerExtractBillDataMutation,
    PartnerExtractBillDataMutationVariables
  >(PartnerExtractBillDataDocument, options)
}
export type PartnerExtractBillDataMutationHookResult = ReturnType<
  typeof usePartnerExtractBillDataMutation
>
export type PartnerExtractBillDataMutationResult =
  Apollo.MutationResult<PartnerExtractBillDataMutation>
export type PartnerExtractBillDataMutationOptions = Apollo.BaseMutationOptions<
  PartnerExtractBillDataMutation,
  PartnerExtractBillDataMutationVariables
>
export const PartnerListVendorAuditLogDocument = /*#__PURE__*/ gql`
  query PartnerListVendorAuditLog(
    $vendorID: String!
    $entityType: VendorAuditEntityType!
    $limit: Int
    $offset: Int
    $actions: [VendorAuditAction!]
  ) {
    PartnerListVendorAuditLog(
      vendorID: $vendorID
      entityType: $entityType
      limit: $limit
      offset: $offset
      actions: $actions
    ) {
      entries {
        ...VendorAuditLogEntry
      }
      totalCount
      hasMore
      eventsCount
      fieldsAddedCount
      fieldsUpdatedCount
    }
  }
  ${VendorAuditLogEntryFragmentDoc}
`

/**
 * __usePartnerListVendorAuditLogQuery__
 *
 * To run a query within a React component, call `usePartnerListVendorAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListVendorAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListVendorAuditLogQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      entityType: // value for 'entityType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function usePartnerListVendorAuditLogQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListVendorAuditLogQuery,
    PartnerListVendorAuditLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListVendorAuditLogQuery,
    PartnerListVendorAuditLogQueryVariables
  >(PartnerListVendorAuditLogDocument, options)
}
export function usePartnerListVendorAuditLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListVendorAuditLogQuery,
    PartnerListVendorAuditLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListVendorAuditLogQuery,
    PartnerListVendorAuditLogQueryVariables
  >(PartnerListVendorAuditLogDocument, options)
}
export type PartnerListVendorAuditLogQueryHookResult = ReturnType<
  typeof usePartnerListVendorAuditLogQuery
>
export type PartnerListVendorAuditLogLazyQueryHookResult = ReturnType<
  typeof usePartnerListVendorAuditLogLazyQuery
>
export type PartnerListVendorAuditLogQueryResult = Apollo.QueryResult<
  PartnerListVendorAuditLogQuery,
  PartnerListVendorAuditLogQueryVariables
>
export const PartnerGetVendorSimilarityGroupsDocument = /*#__PURE__*/ gql`
  query PartnerGetVendorSimilarityGroups(
    $input: GetVendorSimilarityGroupsInput!
  ) {
    PartnerGetVendorSimilarityGroups(input: $input) {
      groups {
        ...VendorSimilarityGroupFields
      }
      totalCount
      totalVendorCount
    }
  }
  ${VendorSimilarityGroupFieldsFragmentDoc}
`

/**
 * __usePartnerGetVendorSimilarityGroupsQuery__
 *
 * To run a query within a React component, call `usePartnerGetVendorSimilarityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetVendorSimilarityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetVendorSimilarityGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetVendorSimilarityGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetVendorSimilarityGroupsQuery,
    PartnerGetVendorSimilarityGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetVendorSimilarityGroupsQuery,
    PartnerGetVendorSimilarityGroupsQueryVariables
  >(PartnerGetVendorSimilarityGroupsDocument, options)
}
export function usePartnerGetVendorSimilarityGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetVendorSimilarityGroupsQuery,
    PartnerGetVendorSimilarityGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetVendorSimilarityGroupsQuery,
    PartnerGetVendorSimilarityGroupsQueryVariables
  >(PartnerGetVendorSimilarityGroupsDocument, options)
}
export type PartnerGetVendorSimilarityGroupsQueryHookResult = ReturnType<
  typeof usePartnerGetVendorSimilarityGroupsQuery
>
export type PartnerGetVendorSimilarityGroupsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetVendorSimilarityGroupsLazyQuery
>
export type PartnerGetVendorSimilarityGroupsQueryResult = Apollo.QueryResult<
  PartnerGetVendorSimilarityGroupsQuery,
  PartnerGetVendorSimilarityGroupsQueryVariables
>
export const PartnerGetVendorTotalsDocument = /*#__PURE__*/ gql`
  query PartnerGetVendorTotals($input: GetVendorTotalsInput!) {
    PartnerGetVendorTotals(input: $input) {
      vendorId
      billCounts {
        status
        count
      }
      paymentCount
    }
  }
`

/**
 * __usePartnerGetVendorTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerGetVendorTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetVendorTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetVendorTotalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetVendorTotalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetVendorTotalsQuery,
    PartnerGetVendorTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetVendorTotalsQuery,
    PartnerGetVendorTotalsQueryVariables
  >(PartnerGetVendorTotalsDocument, options)
}
export function usePartnerGetVendorTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetVendorTotalsQuery,
    PartnerGetVendorTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetVendorTotalsQuery,
    PartnerGetVendorTotalsQueryVariables
  >(PartnerGetVendorTotalsDocument, options)
}
export type PartnerGetVendorTotalsQueryHookResult = ReturnType<
  typeof usePartnerGetVendorTotalsQuery
>
export type PartnerGetVendorTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetVendorTotalsLazyQuery
>
export type PartnerGetVendorTotalsQueryResult = Apollo.QueryResult<
  PartnerGetVendorTotalsQuery,
  PartnerGetVendorTotalsQueryVariables
>
export const PartnerMergeVendorsDocument = /*#__PURE__*/ gql`
  mutation PartnerMergeVendors($input: MergeVendorsInput!) {
    PartnerMergeVendors(input: $input) {
      results {
        survivorId
        accepted
        errorReason
      }
    }
  }
`
export type PartnerMergeVendorsMutationFn = Apollo.MutationFunction<
  PartnerMergeVendorsMutation,
  PartnerMergeVendorsMutationVariables
>

/**
 * __usePartnerMergeVendorsMutation__
 *
 * To run a mutation, you first call `usePartnerMergeVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerMergeVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerMergeVendorsMutation, { data, loading, error }] = usePartnerMergeVendorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerMergeVendorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerMergeVendorsMutation,
    PartnerMergeVendorsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerMergeVendorsMutation,
    PartnerMergeVendorsMutationVariables
  >(PartnerMergeVendorsDocument, options)
}
export type PartnerMergeVendorsMutationHookResult = ReturnType<
  typeof usePartnerMergeVendorsMutation
>
export type PartnerMergeVendorsMutationResult =
  Apollo.MutationResult<PartnerMergeVendorsMutation>
export type PartnerMergeVendorsMutationOptions = Apollo.BaseMutationOptions<
  PartnerMergeVendorsMutation,
  PartnerMergeVendorsMutationVariables
>
export const PartnerDismissVendorSimilarityGroupDocument = /*#__PURE__*/ gql`
  mutation PartnerDismissVendorSimilarityGroup($groupId: ID!) {
    PartnerDismissVendorSimilarityGroup(groupId: $groupId)
  }
`
export type PartnerDismissVendorSimilarityGroupMutationFn =
  Apollo.MutationFunction<
    PartnerDismissVendorSimilarityGroupMutation,
    PartnerDismissVendorSimilarityGroupMutationVariables
  >

/**
 * __usePartnerDismissVendorSimilarityGroupMutation__
 *
 * To run a mutation, you first call `usePartnerDismissVendorSimilarityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDismissVendorSimilarityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDismissVendorSimilarityGroupMutation, { data, loading, error }] = usePartnerDismissVendorSimilarityGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function usePartnerDismissVendorSimilarityGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDismissVendorSimilarityGroupMutation,
    PartnerDismissVendorSimilarityGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDismissVendorSimilarityGroupMutation,
    PartnerDismissVendorSimilarityGroupMutationVariables
  >(PartnerDismissVendorSimilarityGroupDocument, options)
}
export type PartnerDismissVendorSimilarityGroupMutationHookResult = ReturnType<
  typeof usePartnerDismissVendorSimilarityGroupMutation
>
export type PartnerDismissVendorSimilarityGroupMutationResult =
  Apollo.MutationResult<PartnerDismissVendorSimilarityGroupMutation>
export type PartnerDismissVendorSimilarityGroupMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDismissVendorSimilarityGroupMutation,
    PartnerDismissVendorSimilarityGroupMutationVariables
  >
export const PartnerListMergedVendorsDocument = /*#__PURE__*/ gql`
  query PartnerListMergedVendors(
    $survivorID: String!
    $limit: Int!
    $offset: Int!
  ) {
    PartnerVendorList(
      filters: { mergedIntoId: $survivorID }
      limit: $limit
      offset: $offset
      orderBy: { field: MERGED_DATE, direction: DESC }
    ) {
      vendors {
        ...MergedVendorFields
      }
      totalCount
      hasMore
    }
  }
  ${MergedVendorFieldsFragmentDoc}
`

/**
 * __usePartnerListMergedVendorsQuery__
 *
 * To run a query within a React component, call `usePartnerListMergedVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListMergedVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListMergedVendorsQuery({
 *   variables: {
 *      survivorID: // value for 'survivorID'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePartnerListMergedVendorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListMergedVendorsQuery,
    PartnerListMergedVendorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListMergedVendorsQuery,
    PartnerListMergedVendorsQueryVariables
  >(PartnerListMergedVendorsDocument, options)
}
export function usePartnerListMergedVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListMergedVendorsQuery,
    PartnerListMergedVendorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListMergedVendorsQuery,
    PartnerListMergedVendorsQueryVariables
  >(PartnerListMergedVendorsDocument, options)
}
export type PartnerListMergedVendorsQueryHookResult = ReturnType<
  typeof usePartnerListMergedVendorsQuery
>
export type PartnerListMergedVendorsLazyQueryHookResult = ReturnType<
  typeof usePartnerListMergedVendorsLazyQuery
>
export type PartnerListMergedVendorsQueryResult = Apollo.QueryResult<
  PartnerListMergedVendorsQuery,
  PartnerListMergedVendorsQueryVariables
>
export const PartnerRetryPaymentQboSyncDocument = /*#__PURE__*/ gql`
  mutation PartnerRetryPaymentQboSync($vendorPaymentId: ID!) {
    PartnerRetryPaymentQboSync(vendorPaymentId: $vendorPaymentId) {
      status
      qboExternalId
      lastSyncedAt
      errorMessage
    }
  }
`
export type PartnerRetryPaymentQboSyncMutationFn = Apollo.MutationFunction<
  PartnerRetryPaymentQboSyncMutation,
  PartnerRetryPaymentQboSyncMutationVariables
>

/**
 * __usePartnerRetryPaymentQboSyncMutation__
 *
 * To run a mutation, you first call `usePartnerRetryPaymentQboSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRetryPaymentQboSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRetryPaymentQboSyncMutation, { data, loading, error }] = usePartnerRetryPaymentQboSyncMutation({
 *   variables: {
 *      vendorPaymentId: // value for 'vendorPaymentId'
 *   },
 * });
 */
export function usePartnerRetryPaymentQboSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRetryPaymentQboSyncMutation,
    PartnerRetryPaymentQboSyncMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRetryPaymentQboSyncMutation,
    PartnerRetryPaymentQboSyncMutationVariables
  >(PartnerRetryPaymentQboSyncDocument, options)
}
export type PartnerRetryPaymentQboSyncMutationHookResult = ReturnType<
  typeof usePartnerRetryPaymentQboSyncMutation
>
export type PartnerRetryPaymentQboSyncMutationResult =
  Apollo.MutationResult<PartnerRetryPaymentQboSyncMutation>
export type PartnerRetryPaymentQboSyncMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRetryPaymentQboSyncMutation,
    PartnerRetryPaymentQboSyncMutationVariables
  >
export const GetVendorCardViewDocument = /*#__PURE__*/ gql`
  query GetVendorCardView($token: String!) {
    GetVendorCardView(token: $token) {
      partnerName
      billNumber
      billAmount
      billCurrency
      last4
      expiresAt
    }
  }
`

/**
 * __useGetVendorCardViewQuery__
 *
 * To run a query within a React component, call `useGetVendorCardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorCardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorCardViewQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetVendorCardViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVendorCardViewQuery,
    GetVendorCardViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetVendorCardViewQuery,
    GetVendorCardViewQueryVariables
  >(GetVendorCardViewDocument, options)
}
export function useGetVendorCardViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVendorCardViewQuery,
    GetVendorCardViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetVendorCardViewQuery,
    GetVendorCardViewQueryVariables
  >(GetVendorCardViewDocument, options)
}
export type GetVendorCardViewQueryHookResult = ReturnType<
  typeof useGetVendorCardViewQuery
>
export type GetVendorCardViewLazyQueryHookResult = ReturnType<
  typeof useGetVendorCardViewLazyQuery
>
export type GetVendorCardViewQueryResult = Apollo.QueryResult<
  GetVendorCardViewQuery,
  GetVendorCardViewQueryVariables
>
export const RequestVendorCardOtpDocument = /*#__PURE__*/ gql`
  mutation RequestVendorCardOTP($token: String!, $vendorEmail: String!) {
    RequestVendorCardOTP(token: $token, vendorEmail: $vendorEmail) {
      success
    }
  }
`
export type RequestVendorCardOtpMutationFn = Apollo.MutationFunction<
  RequestVendorCardOtpMutation,
  RequestVendorCardOtpMutationVariables
>

/**
 * __useRequestVendorCardOtpMutation__
 *
 * To run a mutation, you first call `useRequestVendorCardOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVendorCardOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVendorCardOtpMutation, { data, loading, error }] = useRequestVendorCardOtpMutation({
 *   variables: {
 *      token: // value for 'token'
 *      vendorEmail: // value for 'vendorEmail'
 *   },
 * });
 */
export function useRequestVendorCardOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestVendorCardOtpMutation,
    RequestVendorCardOtpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestVendorCardOtpMutation,
    RequestVendorCardOtpMutationVariables
  >(RequestVendorCardOtpDocument, options)
}
export type RequestVendorCardOtpMutationHookResult = ReturnType<
  typeof useRequestVendorCardOtpMutation
>
export type RequestVendorCardOtpMutationResult =
  Apollo.MutationResult<RequestVendorCardOtpMutation>
export type RequestVendorCardOtpMutationOptions = Apollo.BaseMutationOptions<
  RequestVendorCardOtpMutation,
  RequestVendorCardOtpMutationVariables
>
export const RevealVendorCardDataDocument = /*#__PURE__*/ gql`
  mutation RevealVendorCardData($token: String!, $otpCode: String!) {
    RevealVendorCardData(token: $token, otpCode: $otpCode) {
      revealToken
      last4
      network
      billingAddress
    }
  }
`
export type RevealVendorCardDataMutationFn = Apollo.MutationFunction<
  RevealVendorCardDataMutation,
  RevealVendorCardDataMutationVariables
>

/**
 * __useRevealVendorCardDataMutation__
 *
 * To run a mutation, you first call `useRevealVendorCardDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevealVendorCardDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revealVendorCardDataMutation, { data, loading, error }] = useRevealVendorCardDataMutation({
 *   variables: {
 *      token: // value for 'token'
 *      otpCode: // value for 'otpCode'
 *   },
 * });
 */
export function useRevealVendorCardDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevealVendorCardDataMutation,
    RevealVendorCardDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RevealVendorCardDataMutation,
    RevealVendorCardDataMutationVariables
  >(RevealVendorCardDataDocument, options)
}
export type RevealVendorCardDataMutationHookResult = ReturnType<
  typeof useRevealVendorCardDataMutation
>
export type RevealVendorCardDataMutationResult =
  Apollo.MutationResult<RevealVendorCardDataMutation>
export type RevealVendorCardDataMutationOptions = Apollo.BaseMutationOptions<
  RevealVendorCardDataMutation,
  RevealVendorCardDataMutationVariables
>
export const PartnerFindInboundEmailByBillIdDocument = /*#__PURE__*/ gql`
  query PartnerFindInboundEmailByBillID($billID: String!) {
    PartnerFindInboundEmailByBillID(billID: $billID) {
      ...InboundEmail
    }
  }
  ${InboundEmailFragmentDoc}
`

/**
 * __usePartnerFindInboundEmailByBillIdQuery__
 *
 * To run a query within a React component, call `usePartnerFindInboundEmailByBillIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindInboundEmailByBillIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindInboundEmailByBillIdQuery({
 *   variables: {
 *      billID: // value for 'billID'
 *   },
 * });
 */
export function usePartnerFindInboundEmailByBillIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindInboundEmailByBillIdQuery,
    PartnerFindInboundEmailByBillIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindInboundEmailByBillIdQuery,
    PartnerFindInboundEmailByBillIdQueryVariables
  >(PartnerFindInboundEmailByBillIdDocument, options)
}
export function usePartnerFindInboundEmailByBillIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindInboundEmailByBillIdQuery,
    PartnerFindInboundEmailByBillIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindInboundEmailByBillIdQuery,
    PartnerFindInboundEmailByBillIdQueryVariables
  >(PartnerFindInboundEmailByBillIdDocument, options)
}
export type PartnerFindInboundEmailByBillIdQueryHookResult = ReturnType<
  typeof usePartnerFindInboundEmailByBillIdQuery
>
export type PartnerFindInboundEmailByBillIdLazyQueryHookResult = ReturnType<
  typeof usePartnerFindInboundEmailByBillIdLazyQuery
>
export type PartnerFindInboundEmailByBillIdQueryResult = Apollo.QueryResult<
  PartnerFindInboundEmailByBillIdQuery,
  PartnerFindInboundEmailByBillIdQueryVariables
>
export const PartnerGetBillAggregatesDocument = /*#__PURE__*/ gql`
  query PartnerGetBillAggregates($input: GetBillAggregatesInput!) {
    PartnerGetBillAggregates(input: $input) {
      totalAmount
      totalCount
      byAgingBucket {
        bucket
        amount
        count
      }
    }
  }
`

/**
 * __usePartnerGetBillAggregatesQuery__
 *
 * To run a query within a React component, call `usePartnerGetBillAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetBillAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetBillAggregatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetBillAggregatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetBillAggregatesQuery,
    PartnerGetBillAggregatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetBillAggregatesQuery,
    PartnerGetBillAggregatesQueryVariables
  >(PartnerGetBillAggregatesDocument, options)
}
export function usePartnerGetBillAggregatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetBillAggregatesQuery,
    PartnerGetBillAggregatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetBillAggregatesQuery,
    PartnerGetBillAggregatesQueryVariables
  >(PartnerGetBillAggregatesDocument, options)
}
export type PartnerGetBillAggregatesQueryHookResult = ReturnType<
  typeof usePartnerGetBillAggregatesQuery
>
export type PartnerGetBillAggregatesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetBillAggregatesLazyQuery
>
export type PartnerGetBillAggregatesQueryResult = Apollo.QueryResult<
  PartnerGetBillAggregatesQuery,
  PartnerGetBillAggregatesQueryVariables
>
export const PartnerGetVendorSpendDocument = /*#__PURE__*/ gql`
  query PartnerGetVendorSpend($input: GetVendorSpendInput!) {
    PartnerGetVendorSpend(input: $input) {
      vendorId
      vendorName
      billCount
      totalSpend
    }
  }
`

/**
 * __usePartnerGetVendorSpendQuery__
 *
 * To run a query within a React component, call `usePartnerGetVendorSpendQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetVendorSpendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetVendorSpendQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetVendorSpendQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetVendorSpendQuery,
    PartnerGetVendorSpendQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetVendorSpendQuery,
    PartnerGetVendorSpendQueryVariables
  >(PartnerGetVendorSpendDocument, options)
}
export function usePartnerGetVendorSpendLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetVendorSpendQuery,
    PartnerGetVendorSpendQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetVendorSpendQuery,
    PartnerGetVendorSpendQueryVariables
  >(PartnerGetVendorSpendDocument, options)
}
export type PartnerGetVendorSpendQueryHookResult = ReturnType<
  typeof usePartnerGetVendorSpendQuery
>
export type PartnerGetVendorSpendLazyQueryHookResult = ReturnType<
  typeof usePartnerGetVendorSpendLazyQuery
>
export type PartnerGetVendorSpendQueryResult = Apollo.QueryResult<
  PartnerGetVendorSpendQuery,
  PartnerGetVendorSpendQueryVariables
>
export const PartnerGetSpendByCategoryDocument = /*#__PURE__*/ gql`
  query PartnerGetSpendByCategory($input: GetSpendByCategoryInput!) {
    PartnerGetSpendByCategory(input: $input) {
      totalSpend
      delta
      byCategory {
        category
        amount
        pct
      }
    }
  }
`

/**
 * __usePartnerGetSpendByCategoryQuery__
 *
 * To run a query within a React component, call `usePartnerGetSpendByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetSpendByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetSpendByCategoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetSpendByCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetSpendByCategoryQuery,
    PartnerGetSpendByCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetSpendByCategoryQuery,
    PartnerGetSpendByCategoryQueryVariables
  >(PartnerGetSpendByCategoryDocument, options)
}
export function usePartnerGetSpendByCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetSpendByCategoryQuery,
    PartnerGetSpendByCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetSpendByCategoryQuery,
    PartnerGetSpendByCategoryQueryVariables
  >(PartnerGetSpendByCategoryDocument, options)
}
export type PartnerGetSpendByCategoryQueryHookResult = ReturnType<
  typeof usePartnerGetSpendByCategoryQuery
>
export type PartnerGetSpendByCategoryLazyQueryHookResult = ReturnType<
  typeof usePartnerGetSpendByCategoryLazyQuery
>
export type PartnerGetSpendByCategoryQueryResult = Apollo.QueryResult<
  PartnerGetSpendByCategoryQuery,
  PartnerGetSpendByCategoryQueryVariables
>
export const PartnerGetPaymentMethodUsageDocument = /*#__PURE__*/ gql`
  query PartnerGetPaymentMethodUsage($input: GetPaymentMethodUsageInput!) {
    PartnerGetPaymentMethodUsage(input: $input) {
      method
      amount
      delta
    }
  }
`

/**
 * __usePartnerGetPaymentMethodUsageQuery__
 *
 * To run a query within a React component, call `usePartnerGetPaymentMethodUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPaymentMethodUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPaymentMethodUsageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetPaymentMethodUsageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetPaymentMethodUsageQuery,
    PartnerGetPaymentMethodUsageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPaymentMethodUsageQuery,
    PartnerGetPaymentMethodUsageQueryVariables
  >(PartnerGetPaymentMethodUsageDocument, options)
}
export function usePartnerGetPaymentMethodUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPaymentMethodUsageQuery,
    PartnerGetPaymentMethodUsageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPaymentMethodUsageQuery,
    PartnerGetPaymentMethodUsageQueryVariables
  >(PartnerGetPaymentMethodUsageDocument, options)
}
export type PartnerGetPaymentMethodUsageQueryHookResult = ReturnType<
  typeof usePartnerGetPaymentMethodUsageQuery
>
export type PartnerGetPaymentMethodUsageLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPaymentMethodUsageLazyQuery
>
export type PartnerGetPaymentMethodUsageQueryResult = Apollo.QueryResult<
  PartnerGetPaymentMethodUsageQuery,
  PartnerGetPaymentMethodUsageQueryVariables
>
export const PartnerGetRecentActivityDocument = /*#__PURE__*/ gql`
  query PartnerGetRecentActivity($input: GetRecentActivityInput!) {
    PartnerGetRecentActivity(input: $input) {
      id
      kind
      billId
      vendorName
      amount
      billStatus
      paymentStatus
      occurredAt
    }
  }
`

/**
 * __usePartnerGetRecentActivityQuery__
 *
 * To run a query within a React component, call `usePartnerGetRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetRecentActivityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetRecentActivityQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetRecentActivityQuery,
    PartnerGetRecentActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetRecentActivityQuery,
    PartnerGetRecentActivityQueryVariables
  >(PartnerGetRecentActivityDocument, options)
}
export function usePartnerGetRecentActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetRecentActivityQuery,
    PartnerGetRecentActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetRecentActivityQuery,
    PartnerGetRecentActivityQueryVariables
  >(PartnerGetRecentActivityDocument, options)
}
export type PartnerGetRecentActivityQueryHookResult = ReturnType<
  typeof usePartnerGetRecentActivityQuery
>
export type PartnerGetRecentActivityLazyQueryHookResult = ReturnType<
  typeof usePartnerGetRecentActivityLazyQuery
>
export type PartnerGetRecentActivityQueryResult = Apollo.QueryResult<
  PartnerGetRecentActivityQuery,
  PartnerGetRecentActivityQueryVariables
>
export const AccountsPayablePaymentAggregatesDocument = /*#__PURE__*/ gql`
  query AccountsPayablePaymentAggregates(
    $filters: AccountsPayablePaymentFilter
  ) {
    PartnerAccountsPayablePaymentAggregates(filters: $filters) {
      totalAmount
      totalAttemptCount
      byStatus {
        status
        amount
        billCount
      }
    }
  }
`

/**
 * __useAccountsPayablePaymentAggregatesQuery__
 *
 * To run a query within a React component, call `useAccountsPayablePaymentAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsPayablePaymentAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsPayablePaymentAggregatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccountsPayablePaymentAggregatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountsPayablePaymentAggregatesQuery,
    AccountsPayablePaymentAggregatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AccountsPayablePaymentAggregatesQuery,
    AccountsPayablePaymentAggregatesQueryVariables
  >(AccountsPayablePaymentAggregatesDocument, options)
}
export function useAccountsPayablePaymentAggregatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountsPayablePaymentAggregatesQuery,
    AccountsPayablePaymentAggregatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AccountsPayablePaymentAggregatesQuery,
    AccountsPayablePaymentAggregatesQueryVariables
  >(AccountsPayablePaymentAggregatesDocument, options)
}
export type AccountsPayablePaymentAggregatesQueryHookResult = ReturnType<
  typeof useAccountsPayablePaymentAggregatesQuery
>
export type AccountsPayablePaymentAggregatesLazyQueryHookResult = ReturnType<
  typeof useAccountsPayablePaymentAggregatesLazyQuery
>
export type AccountsPayablePaymentAggregatesQueryResult = Apollo.QueryResult<
  AccountsPayablePaymentAggregatesQuery,
  AccountsPayablePaymentAggregatesQueryVariables
>
export const SolveRemediationActionsByIDsDocument = /*#__PURE__*/ gql`
  mutation SolveRemediationActionsByIDs($actionIDs: [String!]!) {
    SolveRemediationActionsByIDs(actionIDs: $actionIDs)
  }
`
export type SolveRemediationActionsByIDsMutationFn = Apollo.MutationFunction<
  SolveRemediationActionsByIDsMutation,
  SolveRemediationActionsByIDsMutationVariables
>

/**
 * __useSolveRemediationActionsByIDsMutation__
 *
 * To run a mutation, you first call `useSolveRemediationActionsByIDsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveRemediationActionsByIDsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveRemediationActionsByIDsMutation, { data, loading, error }] = useSolveRemediationActionsByIDsMutation({
 *   variables: {
 *      actionIDs: // value for 'actionIDs'
 *   },
 * });
 */
export function useSolveRemediationActionsByIDsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SolveRemediationActionsByIDsMutation,
    SolveRemediationActionsByIDsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SolveRemediationActionsByIDsMutation,
    SolveRemediationActionsByIDsMutationVariables
  >(SolveRemediationActionsByIDsDocument, options)
}
export type SolveRemediationActionsByIDsMutationHookResult = ReturnType<
  typeof useSolveRemediationActionsByIDsMutation
>
export type SolveRemediationActionsByIDsMutationResult =
  Apollo.MutationResult<SolveRemediationActionsByIDsMutation>
export type SolveRemediationActionsByIDsMutationOptions =
  Apollo.BaseMutationOptions<
    SolveRemediationActionsByIDsMutation,
    SolveRemediationActionsByIDsMutationVariables
  >
export const GetAdyenDocumentTypesDocument = /*#__PURE__*/ gql`
  query GetAdyenDocumentTypes($ownerType: AdyenOwnerType!) {
    GetAdyenDocumentTypes(ownerType: $ownerType)
  }
`

/**
 * __useGetAdyenDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetAdyenDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenDocumentTypesQuery({
 *   variables: {
 *      ownerType: // value for 'ownerType'
 *   },
 * });
 */
export function useGetAdyenDocumentTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >(GetAdyenDocumentTypesDocument, options)
}
export function useGetAdyenDocumentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >(GetAdyenDocumentTypesDocument, options)
}
export type GetAdyenDocumentTypesQueryHookResult = ReturnType<
  typeof useGetAdyenDocumentTypesQuery
>
export type GetAdyenDocumentTypesLazyQueryHookResult = ReturnType<
  typeof useGetAdyenDocumentTypesLazyQuery
>
export type GetAdyenDocumentTypesQueryResult = Apollo.QueryResult<
  GetAdyenDocumentTypesQuery,
  GetAdyenDocumentTypesQueryVariables
>
export const SolveAdyenRemediationActionsDocument = /*#__PURE__*/ gql`
  mutation SolveAdyenRemediationActions {
    SolveAdyenRemediationActions
  }
`
export type SolveAdyenRemediationActionsMutationFn = Apollo.MutationFunction<
  SolveAdyenRemediationActionsMutation,
  SolveAdyenRemediationActionsMutationVariables
>

/**
 * __useSolveAdyenRemediationActionsMutation__
 *
 * To run a mutation, you first call `useSolveAdyenRemediationActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveAdyenRemediationActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveAdyenRemediationActionsMutation, { data, loading, error }] = useSolveAdyenRemediationActionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSolveAdyenRemediationActionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SolveAdyenRemediationActionsMutation,
    SolveAdyenRemediationActionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SolveAdyenRemediationActionsMutation,
    SolveAdyenRemediationActionsMutationVariables
  >(SolveAdyenRemediationActionsDocument, options)
}
export type SolveAdyenRemediationActionsMutationHookResult = ReturnType<
  typeof useSolveAdyenRemediationActionsMutation
>
export type SolveAdyenRemediationActionsMutationResult =
  Apollo.MutationResult<SolveAdyenRemediationActionsMutation>
export type SolveAdyenRemediationActionsMutationOptions =
  Apollo.BaseMutationOptions<
    SolveAdyenRemediationActionsMutation,
    SolveAdyenRemediationActionsMutationVariables
  >
export const UploadAdyenDocumentDocument = /*#__PURE__*/ gql`
  mutation UploadAdyenDocument($input: UploadAdyenDocumentInput!) {
    UploadAdyenDocument(document: $input) {
      failed
      details
    }
  }
`
export type UploadAdyenDocumentMutationFn = Apollo.MutationFunction<
  UploadAdyenDocumentMutation,
  UploadAdyenDocumentMutationVariables
>

/**
 * __useUploadAdyenDocumentMutation__
 *
 * To run a mutation, you first call `useUploadAdyenDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdyenDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdyenDocumentMutation, { data, loading, error }] = useUploadAdyenDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAdyenDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAdyenDocumentMutation,
    UploadAdyenDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadAdyenDocumentMutation,
    UploadAdyenDocumentMutationVariables
  >(UploadAdyenDocumentDocument, options)
}
export type UploadAdyenDocumentMutationHookResult = ReturnType<
  typeof useUploadAdyenDocumentMutation
>
export type UploadAdyenDocumentMutationResult =
  Apollo.MutationResult<UploadAdyenDocumentMutation>
export type UploadAdyenDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadAdyenDocumentMutation,
  UploadAdyenDocumentMutationVariables
>
export const GetAdyenRemediationActionsDocument = /*#__PURE__*/ gql`
  query GetAdyenRemediationActions {
    GetAdyenRemediationActions {
      groupings {
        errorCode
        errorMessage
        ownerID
        ownerType
        actions {
          actionID
          actionType
          unmappedRemediationActionCode
        }
      }
    }
  }
`

/**
 * __useGetAdyenRemediationActionsQuery__
 *
 * To run a query within a React component, call `useGetAdyenRemediationActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenRemediationActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenRemediationActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenRemediationActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >(GetAdyenRemediationActionsDocument, options)
}
export function useGetAdyenRemediationActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >(GetAdyenRemediationActionsDocument, options)
}
export type GetAdyenRemediationActionsQueryHookResult = ReturnType<
  typeof useGetAdyenRemediationActionsQuery
>
export type GetAdyenRemediationActionsLazyQueryHookResult = ReturnType<
  typeof useGetAdyenRemediationActionsLazyQuery
>
export type GetAdyenRemediationActionsQueryResult = Apollo.QueryResult<
  GetAdyenRemediationActionsQuery,
  GetAdyenRemediationActionsQueryVariables
>
export const GetAdyenHostedOnboardingLinkDocument = /*#__PURE__*/ gql`
  query GetAdyenHostedOnboardingLink {
    GetAdyenHostedOnboardingLink {
      url
    }
  }
`

/**
 * __useGetAdyenHostedOnboardingLinkQuery__
 *
 * To run a query within a React component, call `useGetAdyenHostedOnboardingLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenHostedOnboardingLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenHostedOnboardingLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenHostedOnboardingLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >(GetAdyenHostedOnboardingLinkDocument, options)
}
export function useGetAdyenHostedOnboardingLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >(GetAdyenHostedOnboardingLinkDocument, options)
}
export type GetAdyenHostedOnboardingLinkQueryHookResult = ReturnType<
  typeof useGetAdyenHostedOnboardingLinkQuery
>
export type GetAdyenHostedOnboardingLinkLazyQueryHookResult = ReturnType<
  typeof useGetAdyenHostedOnboardingLinkLazyQuery
>
export type GetAdyenHostedOnboardingLinkQueryResult = Apollo.QueryResult<
  GetAdyenHostedOnboardingLinkQuery,
  GetAdyenHostedOnboardingLinkQueryVariables
>
export const StagingStartAdyenOnboardingDocument = /*#__PURE__*/ gql`
  mutation StagingStartAdyenOnboarding {
    StagingStartAdyenOnboarding {
      validations
    }
  }
`
export type StagingStartAdyenOnboardingMutationFn = Apollo.MutationFunction<
  StagingStartAdyenOnboardingMutation,
  StagingStartAdyenOnboardingMutationVariables
>

/**
 * __useStagingStartAdyenOnboardingMutation__
 *
 * To run a mutation, you first call `useStagingStartAdyenOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStagingStartAdyenOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stagingStartAdyenOnboardingMutation, { data, loading, error }] = useStagingStartAdyenOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useStagingStartAdyenOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StagingStartAdyenOnboardingMutation,
    StagingStartAdyenOnboardingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StagingStartAdyenOnboardingMutation,
    StagingStartAdyenOnboardingMutationVariables
  >(StagingStartAdyenOnboardingDocument, options)
}
export type StagingStartAdyenOnboardingMutationHookResult = ReturnType<
  typeof useStagingStartAdyenOnboardingMutation
>
export type StagingStartAdyenOnboardingMutationResult =
  Apollo.MutationResult<StagingStartAdyenOnboardingMutation>
export type StagingStartAdyenOnboardingMutationOptions =
  Apollo.BaseMutationOptions<
    StagingStartAdyenOnboardingMutation,
    StagingStartAdyenOnboardingMutationVariables
  >
export const GetAdyenPciFormsDocument = /*#__PURE__*/ gql`
  query GetAdyenPciForms {
    GetAdyenPciForms {
      pciIds
      document
    }
  }
`

/**
 * __useGetAdyenPciFormsQuery__
 *
 * To run a query within a React component, call `useGetAdyenPciFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenPciFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenPciFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenPciFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenPciFormsQuery,
    GetAdyenPciFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdyenPciFormsQuery, GetAdyenPciFormsQueryVariables>(
    GetAdyenPciFormsDocument,
    options
  )
}
export function useGetAdyenPciFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenPciFormsQuery,
    GetAdyenPciFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenPciFormsQuery,
    GetAdyenPciFormsQueryVariables
  >(GetAdyenPciFormsDocument, options)
}
export type GetAdyenPciFormsQueryHookResult = ReturnType<
  typeof useGetAdyenPciFormsQuery
>
export type GetAdyenPciFormsLazyQueryHookResult = ReturnType<
  typeof useGetAdyenPciFormsLazyQuery
>
export type GetAdyenPciFormsQueryResult = Apollo.QueryResult<
  GetAdyenPciFormsQuery,
  GetAdyenPciFormsQueryVariables
>
export const GetAdyenTermsOfServiceDocument = /*#__PURE__*/ gql`
  query GetAdyenTermsOfService {
    GetAdyenTermsOfService {
      tosID
      tosType
      document
    }
  }
`

/**
 * __useGetAdyenTermsOfServiceQuery__
 *
 * To run a query within a React component, call `useGetAdyenTermsOfServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenTermsOfServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenTermsOfServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenTermsOfServiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >(GetAdyenTermsOfServiceDocument, options)
}
export function useGetAdyenTermsOfServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >(GetAdyenTermsOfServiceDocument, options)
}
export type GetAdyenTermsOfServiceQueryHookResult = ReturnType<
  typeof useGetAdyenTermsOfServiceQuery
>
export type GetAdyenTermsOfServiceLazyQueryHookResult = ReturnType<
  typeof useGetAdyenTermsOfServiceLazyQuery
>
export type GetAdyenTermsOfServiceQueryResult = Apollo.QueryResult<
  GetAdyenTermsOfServiceQuery,
  GetAdyenTermsOfServiceQueryVariables
>
export const GetAdyenOnboardingStatusDocument = /*#__PURE__*/ gql`
  query GetAdyenOnboardingStatus {
    GetAdyenOnboardingStatus {
      termsOfServiceAccepted
      pciFormsSigned
      tosAndPciEntitiesCreated
    }
  }
`

/**
 * __useGetAdyenOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useGetAdyenOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenOnboardingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenOnboardingStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >(GetAdyenOnboardingStatusDocument, options)
}
export function useGetAdyenOnboardingStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >(GetAdyenOnboardingStatusDocument, options)
}
export type GetAdyenOnboardingStatusQueryHookResult = ReturnType<
  typeof useGetAdyenOnboardingStatusQuery
>
export type GetAdyenOnboardingStatusLazyQueryHookResult = ReturnType<
  typeof useGetAdyenOnboardingStatusLazyQuery
>
export type GetAdyenOnboardingStatusQueryResult = Apollo.QueryResult<
  GetAdyenOnboardingStatusQuery,
  GetAdyenOnboardingStatusQueryVariables
>
export const GetAnalyticsSyncStateDocument = /*#__PURE__*/ gql`
  query GetAnalyticsSyncState {
    PartnerGetAnalyticsSyncState {
      sources {
        name
        syncedAt
      }
    }
  }
`

/**
 * __useGetAnalyticsSyncStateQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSyncStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSyncStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSyncStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalyticsSyncStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAnalyticsSyncStateQuery,
    GetAnalyticsSyncStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAnalyticsSyncStateQuery,
    GetAnalyticsSyncStateQueryVariables
  >(GetAnalyticsSyncStateDocument, options)
}
export function useGetAnalyticsSyncStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsSyncStateQuery,
    GetAnalyticsSyncStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAnalyticsSyncStateQuery,
    GetAnalyticsSyncStateQueryVariables
  >(GetAnalyticsSyncStateDocument, options)
}
export type GetAnalyticsSyncStateQueryHookResult = ReturnType<
  typeof useGetAnalyticsSyncStateQuery
>
export type GetAnalyticsSyncStateLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsSyncStateLazyQuery
>
export type GetAnalyticsSyncStateQueryResult = Apollo.QueryResult<
  GetAnalyticsSyncStateQuery,
  GetAnalyticsSyncStateQueryVariables
>
export const GetClientTrendsSummaryDocument = /*#__PURE__*/ gql`
  query GetClientTrendsSummary($input: ClientTrendBaseInput!) {
    PartnerGetClientTrendsSummary(input: $input) {
      rollingMrrChange {
        value
        change
        period
      }
    }
  }
`

/**
 * __useGetClientTrendsSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientTrendsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrendsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrendsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTrendsSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTrendsSummaryQuery,
    GetClientTrendsSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTrendsSummaryQuery,
    GetClientTrendsSummaryQueryVariables
  >(GetClientTrendsSummaryDocument, options)
}
export function useGetClientTrendsSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTrendsSummaryQuery,
    GetClientTrendsSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTrendsSummaryQuery,
    GetClientTrendsSummaryQueryVariables
  >(GetClientTrendsSummaryDocument, options)
}
export type GetClientTrendsSummaryQueryHookResult = ReturnType<
  typeof useGetClientTrendsSummaryQuery
>
export type GetClientTrendsSummaryLazyQueryHookResult = ReturnType<
  typeof useGetClientTrendsSummaryLazyQuery
>
export type GetClientTrendsSummaryQueryResult = Apollo.QueryResult<
  GetClientTrendsSummaryQuery,
  GetClientTrendsSummaryQueryVariables
>
export const GetClientTrendsRankingsDocument = /*#__PURE__*/ gql`
  query GetClientTrendsRankings($input: ClientTrendBaseInput!) {
    PartnerGetClientTrendsRankings(input: $input) {
      mostProfitable {
        clientId
        clientName
        margin
      }
      leastProfitable {
        clientId
        clientName
        margin
      }
    }
  }
`

/**
 * __useGetClientTrendsRankingsQuery__
 *
 * To run a query within a React component, call `useGetClientTrendsRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrendsRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrendsRankingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTrendsRankingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTrendsRankingsQuery,
    GetClientTrendsRankingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTrendsRankingsQuery,
    GetClientTrendsRankingsQueryVariables
  >(GetClientTrendsRankingsDocument, options)
}
export function useGetClientTrendsRankingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTrendsRankingsQuery,
    GetClientTrendsRankingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTrendsRankingsQuery,
    GetClientTrendsRankingsQueryVariables
  >(GetClientTrendsRankingsDocument, options)
}
export type GetClientTrendsRankingsQueryHookResult = ReturnType<
  typeof useGetClientTrendsRankingsQuery
>
export type GetClientTrendsRankingsLazyQueryHookResult = ReturnType<
  typeof useGetClientTrendsRankingsLazyQuery
>
export type GetClientTrendsRankingsQueryResult = Apollo.QueryResult<
  GetClientTrendsRankingsQuery,
  GetClientTrendsRankingsQueryVariables
>
export const GetClientTrendsTrendDataDocument = /*#__PURE__*/ gql`
  query GetClientTrendsTrendData($input: ClientTrendBaseInput!) {
    PartnerGetClientTrendsTrendData(input: $input) {
      labels
      mrr
      serviceCog
      laborCog
      profit
      margin
    }
  }
`

/**
 * __useGetClientTrendsTrendDataQuery__
 *
 * To run a query within a React component, call `useGetClientTrendsTrendDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrendsTrendDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrendsTrendDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTrendsTrendDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTrendsTrendDataQuery,
    GetClientTrendsTrendDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTrendsTrendDataQuery,
    GetClientTrendsTrendDataQueryVariables
  >(GetClientTrendsTrendDataDocument, options)
}
export function useGetClientTrendsTrendDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTrendsTrendDataQuery,
    GetClientTrendsTrendDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTrendsTrendDataQuery,
    GetClientTrendsTrendDataQueryVariables
  >(GetClientTrendsTrendDataDocument, options)
}
export type GetClientTrendsTrendDataQueryHookResult = ReturnType<
  typeof useGetClientTrendsTrendDataQuery
>
export type GetClientTrendsTrendDataLazyQueryHookResult = ReturnType<
  typeof useGetClientTrendsTrendDataLazyQuery
>
export type GetClientTrendsTrendDataQueryResult = Apollo.QueryResult<
  GetClientTrendsTrendDataQuery,
  GetClientTrendsTrendDataQueryVariables
>
export const GetClientTrendsBreakdownDocument = /*#__PURE__*/ gql`
  query GetClientTrendsBreakdown($input: GetClientTrendsBreakdownInput!) {
    PartnerGetClientTrendsBreakdown(input: $input) {
      breakdown {
        month
        percentOfTotalMrr
        mrr
        serviceCogs
        laborCogs
        profit
        margin
      }
    }
  }
`

/**
 * __useGetClientTrendsBreakdownQuery__
 *
 * To run a query within a React component, call `useGetClientTrendsBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrendsBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrendsBreakdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTrendsBreakdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTrendsBreakdownQuery,
    GetClientTrendsBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTrendsBreakdownQuery,
    GetClientTrendsBreakdownQueryVariables
  >(GetClientTrendsBreakdownDocument, options)
}
export function useGetClientTrendsBreakdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTrendsBreakdownQuery,
    GetClientTrendsBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTrendsBreakdownQuery,
    GetClientTrendsBreakdownQueryVariables
  >(GetClientTrendsBreakdownDocument, options)
}
export type GetClientTrendsBreakdownQueryHookResult = ReturnType<
  typeof useGetClientTrendsBreakdownQuery
>
export type GetClientTrendsBreakdownLazyQueryHookResult = ReturnType<
  typeof useGetClientTrendsBreakdownLazyQuery
>
export type GetClientTrendsBreakdownQueryResult = Apollo.QueryResult<
  GetClientTrendsBreakdownQuery,
  GetClientTrendsBreakdownQueryVariables
>
export const GetAnalyticsClientByIdDocument = /*#__PURE__*/ gql`
  query GetAnalyticsClientById($clientId: ID!) {
    PartnerGetAnalyticsClientById(clientId: $clientId) {
      id
      companyName
    }
  }
`

/**
 * __useGetAnalyticsClientByIdQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsClientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsClientByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsClientByIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetAnalyticsClientByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsClientByIdQuery,
    GetAnalyticsClientByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAnalyticsClientByIdQuery,
    GetAnalyticsClientByIdQueryVariables
  >(GetAnalyticsClientByIdDocument, options)
}
export function useGetAnalyticsClientByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsClientByIdQuery,
    GetAnalyticsClientByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAnalyticsClientByIdQuery,
    GetAnalyticsClientByIdQueryVariables
  >(GetAnalyticsClientByIdDocument, options)
}
export type GetAnalyticsClientByIdQueryHookResult = ReturnType<
  typeof useGetAnalyticsClientByIdQuery
>
export type GetAnalyticsClientByIdLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsClientByIdLazyQuery
>
export type GetAnalyticsClientByIdQueryResult = Apollo.QueryResult<
  GetAnalyticsClientByIdQuery,
  GetAnalyticsClientByIdQueryVariables
>
export const GetClientTrendsClientsDocument = /*#__PURE__*/ gql`
  query GetClientTrendsClients($input: GetClientTrendsClientsInput!) {
    PartnerGetClientTrendsClients(input: $input) {
      items {
        clientId
        clientName
        mrr
        serviceCogs
        laborCogs
        profit
        margin
        percentOfTotalMrr
        mrrChange
        mrrChangePercent
        mrrChangeType
        laborCostImpact
        avgMrr
        totalMrr
        avgProfit
        totalProfit
        mrrChangeFirstToLast
        mrrChangeFirstToLastPercent
      }
      total
      selectedMonth
      aggregationMode
      monthCount
    }
  }
`

/**
 * __useGetClientTrendsClientsQuery__
 *
 * To run a query within a React component, call `useGetClientTrendsClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrendsClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrendsClientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTrendsClientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTrendsClientsQuery,
    GetClientTrendsClientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTrendsClientsQuery,
    GetClientTrendsClientsQueryVariables
  >(GetClientTrendsClientsDocument, options)
}
export function useGetClientTrendsClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTrendsClientsQuery,
    GetClientTrendsClientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTrendsClientsQuery,
    GetClientTrendsClientsQueryVariables
  >(GetClientTrendsClientsDocument, options)
}
export type GetClientTrendsClientsQueryHookResult = ReturnType<
  typeof useGetClientTrendsClientsQuery
>
export type GetClientTrendsClientsLazyQueryHookResult = ReturnType<
  typeof useGetClientTrendsClientsLazyQuery
>
export type GetClientTrendsClientsQueryResult = Apollo.QueryResult<
  GetClientTrendsClientsQuery,
  GetClientTrendsClientsQueryVariables
>
export const GetClientTrendsFilterValuesDocument = /*#__PURE__*/ gql`
  query GetClientTrendsFilterValues(
    $startDate: String!
    $endDate: String!
    $filterType: ClientTrendsFilterType!
    $search: String
    $limit: Int = 50
    $offset: Int = 0
  ) {
    PartnerGetClientTrendsFilterValues(
      startDate: $startDate
      endDate: $endDate
      filterType: $filterType
      search: $search
      limit: $limit
      offset: $offset
    ) {
      values
      total
    }
  }
`

/**
 * __useGetClientTrendsFilterValuesQuery__
 *
 * To run a query within a React component, call `useGetClientTrendsFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrendsFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrendsFilterValuesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filterType: // value for 'filterType'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetClientTrendsFilterValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTrendsFilterValuesQuery,
    GetClientTrendsFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTrendsFilterValuesQuery,
    GetClientTrendsFilterValuesQueryVariables
  >(GetClientTrendsFilterValuesDocument, options)
}
export function useGetClientTrendsFilterValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTrendsFilterValuesQuery,
    GetClientTrendsFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTrendsFilterValuesQuery,
    GetClientTrendsFilterValuesQueryVariables
  >(GetClientTrendsFilterValuesDocument, options)
}
export type GetClientTrendsFilterValuesQueryHookResult = ReturnType<
  typeof useGetClientTrendsFilterValuesQuery
>
export type GetClientTrendsFilterValuesLazyQueryHookResult = ReturnType<
  typeof useGetClientTrendsFilterValuesLazyQuery
>
export type GetClientTrendsFilterValuesQueryResult = Apollo.QueryResult<
  GetClientTrendsFilterValuesQuery,
  GetClientTrendsFilterValuesQueryVariables
>
export const PartnerListClientTrendsPresetsDocument = /*#__PURE__*/ gql`
  query PartnerListClientTrendsPresets {
    PartnerListClientTrendsPresets {
      ...ClientTrendsPresetFields
    }
  }
  ${ClientTrendsPresetFieldsFragmentDoc}
`

/**
 * __usePartnerListClientTrendsPresetsQuery__
 *
 * To run a query within a React component, call `usePartnerListClientTrendsPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListClientTrendsPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListClientTrendsPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListClientTrendsPresetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListClientTrendsPresetsQuery,
    PartnerListClientTrendsPresetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListClientTrendsPresetsQuery,
    PartnerListClientTrendsPresetsQueryVariables
  >(PartnerListClientTrendsPresetsDocument, options)
}
export function usePartnerListClientTrendsPresetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListClientTrendsPresetsQuery,
    PartnerListClientTrendsPresetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListClientTrendsPresetsQuery,
    PartnerListClientTrendsPresetsQueryVariables
  >(PartnerListClientTrendsPresetsDocument, options)
}
export type PartnerListClientTrendsPresetsQueryHookResult = ReturnType<
  typeof usePartnerListClientTrendsPresetsQuery
>
export type PartnerListClientTrendsPresetsLazyQueryHookResult = ReturnType<
  typeof usePartnerListClientTrendsPresetsLazyQuery
>
export type PartnerListClientTrendsPresetsQueryResult = Apollo.QueryResult<
  PartnerListClientTrendsPresetsQuery,
  PartnerListClientTrendsPresetsQueryVariables
>
export const PartnerGetClientTrendsPresetDocument = /*#__PURE__*/ gql`
  query PartnerGetClientTrendsPreset($id: ID!) {
    PartnerGetClientTrendsPreset(id: $id) {
      ...ClientTrendsPresetFields
    }
  }
  ${ClientTrendsPresetFieldsFragmentDoc}
`

/**
 * __usePartnerGetClientTrendsPresetQuery__
 *
 * To run a query within a React component, call `usePartnerGetClientTrendsPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetClientTrendsPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetClientTrendsPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetClientTrendsPresetQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetClientTrendsPresetQuery,
    PartnerGetClientTrendsPresetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetClientTrendsPresetQuery,
    PartnerGetClientTrendsPresetQueryVariables
  >(PartnerGetClientTrendsPresetDocument, options)
}
export function usePartnerGetClientTrendsPresetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetClientTrendsPresetQuery,
    PartnerGetClientTrendsPresetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetClientTrendsPresetQuery,
    PartnerGetClientTrendsPresetQueryVariables
  >(PartnerGetClientTrendsPresetDocument, options)
}
export type PartnerGetClientTrendsPresetQueryHookResult = ReturnType<
  typeof usePartnerGetClientTrendsPresetQuery
>
export type PartnerGetClientTrendsPresetLazyQueryHookResult = ReturnType<
  typeof usePartnerGetClientTrendsPresetLazyQuery
>
export type PartnerGetClientTrendsPresetQueryResult = Apollo.QueryResult<
  PartnerGetClientTrendsPresetQuery,
  PartnerGetClientTrendsPresetQueryVariables
>
export const PartnerCreateClientTrendsPresetDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateClientTrendsPreset(
    $input: CreateClientTrendsPresetInput!
  ) {
    PartnerCreateClientTrendsPreset(input: $input) {
      ...ClientTrendsPresetFields
    }
  }
  ${ClientTrendsPresetFieldsFragmentDoc}
`
export type PartnerCreateClientTrendsPresetMutationFn = Apollo.MutationFunction<
  PartnerCreateClientTrendsPresetMutation,
  PartnerCreateClientTrendsPresetMutationVariables
>

/**
 * __usePartnerCreateClientTrendsPresetMutation__
 *
 * To run a mutation, you first call `usePartnerCreateClientTrendsPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateClientTrendsPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateClientTrendsPresetMutation, { data, loading, error }] = usePartnerCreateClientTrendsPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateClientTrendsPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateClientTrendsPresetMutation,
    PartnerCreateClientTrendsPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateClientTrendsPresetMutation,
    PartnerCreateClientTrendsPresetMutationVariables
  >(PartnerCreateClientTrendsPresetDocument, options)
}
export type PartnerCreateClientTrendsPresetMutationHookResult = ReturnType<
  typeof usePartnerCreateClientTrendsPresetMutation
>
export type PartnerCreateClientTrendsPresetMutationResult =
  Apollo.MutationResult<PartnerCreateClientTrendsPresetMutation>
export type PartnerCreateClientTrendsPresetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateClientTrendsPresetMutation,
    PartnerCreateClientTrendsPresetMutationVariables
  >
export const PartnerUpdateClientTrendsPresetDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateClientTrendsPreset(
    $input: UpdateClientTrendsPresetInput!
  ) {
    PartnerUpdateClientTrendsPreset(input: $input) {
      ...ClientTrendsPresetFields
    }
  }
  ${ClientTrendsPresetFieldsFragmentDoc}
`
export type PartnerUpdateClientTrendsPresetMutationFn = Apollo.MutationFunction<
  PartnerUpdateClientTrendsPresetMutation,
  PartnerUpdateClientTrendsPresetMutationVariables
>

/**
 * __usePartnerUpdateClientTrendsPresetMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateClientTrendsPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateClientTrendsPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateClientTrendsPresetMutation, { data, loading, error }] = usePartnerUpdateClientTrendsPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateClientTrendsPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateClientTrendsPresetMutation,
    PartnerUpdateClientTrendsPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateClientTrendsPresetMutation,
    PartnerUpdateClientTrendsPresetMutationVariables
  >(PartnerUpdateClientTrendsPresetDocument, options)
}
export type PartnerUpdateClientTrendsPresetMutationHookResult = ReturnType<
  typeof usePartnerUpdateClientTrendsPresetMutation
>
export type PartnerUpdateClientTrendsPresetMutationResult =
  Apollo.MutationResult<PartnerUpdateClientTrendsPresetMutation>
export type PartnerUpdateClientTrendsPresetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateClientTrendsPresetMutation,
    PartnerUpdateClientTrendsPresetMutationVariables
  >
export const PartnerDeleteClientTrendsPresetDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteClientTrendsPreset($id: ID!) {
    PartnerDeleteClientTrendsPreset(id: $id)
  }
`
export type PartnerDeleteClientTrendsPresetMutationFn = Apollo.MutationFunction<
  PartnerDeleteClientTrendsPresetMutation,
  PartnerDeleteClientTrendsPresetMutationVariables
>

/**
 * __usePartnerDeleteClientTrendsPresetMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteClientTrendsPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteClientTrendsPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteClientTrendsPresetMutation, { data, loading, error }] = usePartnerDeleteClientTrendsPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteClientTrendsPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteClientTrendsPresetMutation,
    PartnerDeleteClientTrendsPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteClientTrendsPresetMutation,
    PartnerDeleteClientTrendsPresetMutationVariables
  >(PartnerDeleteClientTrendsPresetDocument, options)
}
export type PartnerDeleteClientTrendsPresetMutationHookResult = ReturnType<
  typeof usePartnerDeleteClientTrendsPresetMutation
>
export type PartnerDeleteClientTrendsPresetMutationResult =
  Apollo.MutationResult<PartnerDeleteClientTrendsPresetMutation>
export type PartnerDeleteClientTrendsPresetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteClientTrendsPresetMutation,
    PartnerDeleteClientTrendsPresetMutationVariables
  >
export const ExportClientTrendsCsvDocument = /*#__PURE__*/ gql`
  mutation ExportClientTrendsCSV($input: ExportClientTrendsCSVInput!) {
    PartnerExportClientTrendsCSV(input: $input)
  }
`
export type ExportClientTrendsCsvMutationFn = Apollo.MutationFunction<
  ExportClientTrendsCsvMutation,
  ExportClientTrendsCsvMutationVariables
>

/**
 * __useExportClientTrendsCsvMutation__
 *
 * To run a mutation, you first call `useExportClientTrendsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportClientTrendsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportClientTrendsCsvMutation, { data, loading, error }] = useExportClientTrendsCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportClientTrendsCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportClientTrendsCsvMutation,
    ExportClientTrendsCsvMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExportClientTrendsCsvMutation,
    ExportClientTrendsCsvMutationVariables
  >(ExportClientTrendsCsvDocument, options)
}
export type ExportClientTrendsCsvMutationHookResult = ReturnType<
  typeof useExportClientTrendsCsvMutation
>
export type ExportClientTrendsCsvMutationResult =
  Apollo.MutationResult<ExportClientTrendsCsvMutation>
export type ExportClientTrendsCsvMutationOptions = Apollo.BaseMutationOptions<
  ExportClientTrendsCsvMutation,
  ExportClientTrendsCsvMutationVariables
>
export const ExportClientTrendsBreakdownCsvDocument = /*#__PURE__*/ gql`
  mutation ExportClientTrendsBreakdownCSV(
    $input: ExportClientTrendsBreakdownCSVInput!
  ) {
    PartnerExportClientTrendsBreakdownCSV(input: $input)
  }
`
export type ExportClientTrendsBreakdownCsvMutationFn = Apollo.MutationFunction<
  ExportClientTrendsBreakdownCsvMutation,
  ExportClientTrendsBreakdownCsvMutationVariables
>

/**
 * __useExportClientTrendsBreakdownCsvMutation__
 *
 * To run a mutation, you first call `useExportClientTrendsBreakdownCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportClientTrendsBreakdownCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportClientTrendsBreakdownCsvMutation, { data, loading, error }] = useExportClientTrendsBreakdownCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportClientTrendsBreakdownCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportClientTrendsBreakdownCsvMutation,
    ExportClientTrendsBreakdownCsvMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExportClientTrendsBreakdownCsvMutation,
    ExportClientTrendsBreakdownCsvMutationVariables
  >(ExportClientTrendsBreakdownCsvDocument, options)
}
export type ExportClientTrendsBreakdownCsvMutationHookResult = ReturnType<
  typeof useExportClientTrendsBreakdownCsvMutation
>
export type ExportClientTrendsBreakdownCsvMutationResult =
  Apollo.MutationResult<ExportClientTrendsBreakdownCsvMutation>
export type ExportClientTrendsBreakdownCsvMutationOptions =
  Apollo.BaseMutationOptions<
    ExportClientTrendsBreakdownCsvMutation,
    ExportClientTrendsBreakdownCsvMutationVariables
  >
export const PartnerGetAgentLoadsDocument = /*#__PURE__*/ gql`
  query PartnerGetAgentLoads(
    $startDate: String!
    $endDate: String!
    $filters: UtilizationFiltersInput
  ) {
    PartnerGetAgentLoads(
      startDate: $startDate
      endDate: $endDate
      filters: $filters
    ) {
      overloadedAgents {
        agentId
        totalHours
        availableHours
        difference
      }
      underusedAgents {
        agentId
        totalHours
        availableHours
        difference
      }
    }
  }
`

/**
 * __usePartnerGetAgentLoadsQuery__
 *
 * To run a query within a React component, call `usePartnerGetAgentLoadsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAgentLoadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAgentLoadsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetAgentLoadsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetAgentLoadsQuery,
    PartnerGetAgentLoadsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAgentLoadsQuery,
    PartnerGetAgentLoadsQueryVariables
  >(PartnerGetAgentLoadsDocument, options)
}
export function usePartnerGetAgentLoadsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAgentLoadsQuery,
    PartnerGetAgentLoadsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAgentLoadsQuery,
    PartnerGetAgentLoadsQueryVariables
  >(PartnerGetAgentLoadsDocument, options)
}
export type PartnerGetAgentLoadsQueryHookResult = ReturnType<
  typeof usePartnerGetAgentLoadsQuery
>
export type PartnerGetAgentLoadsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAgentLoadsLazyQuery
>
export type PartnerGetAgentLoadsQueryResult = Apollo.QueryResult<
  PartnerGetAgentLoadsQuery,
  PartnerGetAgentLoadsQueryVariables
>
export const PartnerGetUtilizationFilterValuesDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationFilterValues(
    $startDate: String!
    $endDate: String!
    $filterType: UtilizationFilterType!
    $search: String
    $limit: Int
    $offset: Int
  ) {
    PartnerGetUtilizationFilterValues(
      startDate: $startDate
      endDate: $endDate
      filterType: $filterType
      search: $search
      limit: $limit
      offset: $offset
    ) {
      values
      total
    }
  }
`

/**
 * __usePartnerGetUtilizationFilterValuesQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationFilterValuesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filterType: // value for 'filterType'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePartnerGetUtilizationFilterValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationFilterValuesQuery,
    PartnerGetUtilizationFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationFilterValuesQuery,
    PartnerGetUtilizationFilterValuesQueryVariables
  >(PartnerGetUtilizationFilterValuesDocument, options)
}
export function usePartnerGetUtilizationFilterValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationFilterValuesQuery,
    PartnerGetUtilizationFilterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationFilterValuesQuery,
    PartnerGetUtilizationFilterValuesQueryVariables
  >(PartnerGetUtilizationFilterValuesDocument, options)
}
export type PartnerGetUtilizationFilterValuesQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationFilterValuesQuery
>
export type PartnerGetUtilizationFilterValuesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationFilterValuesLazyQuery
>
export type PartnerGetUtilizationFilterValuesQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationFilterValuesQuery,
  PartnerGetUtilizationFilterValuesQueryVariables
>
export const PartnerGetUtilizationPercentageDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationPercentage(
    $startDate: String!
    $endDate: String!
    $filters: UtilizationFiltersInput
  ) {
    PartnerGetUtilizationPercentage(
      startDate: $startDate
      endDate: $endDate
      filters: $filters
    )
  }
`

/**
 * __usePartnerGetUtilizationPercentageQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationPercentageQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetUtilizationPercentageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationPercentageQuery,
    PartnerGetUtilizationPercentageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationPercentageQuery,
    PartnerGetUtilizationPercentageQueryVariables
  >(PartnerGetUtilizationPercentageDocument, options)
}
export function usePartnerGetUtilizationPercentageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationPercentageQuery,
    PartnerGetUtilizationPercentageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationPercentageQuery,
    PartnerGetUtilizationPercentageQueryVariables
  >(PartnerGetUtilizationPercentageDocument, options)
}
export type PartnerGetUtilizationPercentageQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationPercentageQuery
>
export type PartnerGetUtilizationPercentageLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationPercentageLazyQuery
>
export type PartnerGetUtilizationPercentageQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationPercentageQuery,
  PartnerGetUtilizationPercentageQueryVariables
>
export const PartnerGetUtilizationOverviewDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationOverview(
    $startDate: String!
    $endDate: String!
    $grouping: String!
    $filters: UtilizationFiltersInput
    $sortBy: UtilizationOverviewSortBy
    $sortOrder: OrderDirection
    $limit: Int = 0
    $offset: Int = 0
    $search: String
  ) {
    PartnerGetUtilizationOverview(
      startDate: $startDate
      endDate: $endDate
      grouping: $grouping
      filters: $filters
      sortBy: $sortBy
      sortOrder: $sortOrder
      limit: $limit
      offset: $offset
      search: $search
    ) {
      items {
        agentId
        clientId
        displayName
        labourCost
        hoursWorked
        hoursAvailable
        utilizationPercent
        utilizationComparison
      }
      total
    }
  }
`

/**
 * __usePartnerGetUtilizationOverviewQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationOverviewQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      grouping: // value for 'grouping'
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePartnerGetUtilizationOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationOverviewQuery,
    PartnerGetUtilizationOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationOverviewQuery,
    PartnerGetUtilizationOverviewQueryVariables
  >(PartnerGetUtilizationOverviewDocument, options)
}
export function usePartnerGetUtilizationOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationOverviewQuery,
    PartnerGetUtilizationOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationOverviewQuery,
    PartnerGetUtilizationOverviewQueryVariables
  >(PartnerGetUtilizationOverviewDocument, options)
}
export type PartnerGetUtilizationOverviewQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationOverviewQuery
>
export type PartnerGetUtilizationOverviewLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationOverviewLazyQuery
>
export type PartnerGetUtilizationOverviewQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationOverviewQuery,
  PartnerGetUtilizationOverviewQueryVariables
>
export const PartnerGetUtilizationSummaryDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationSummary(
    $startDate: String!
    $endDate: String!
    $agentId: ID
    $clientId: ID
    $filters: UtilizationFiltersInput
  ) {
    PartnerGetUtilizationSummary(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      clientId: $clientId
      filters: $filters
    ) {
      date
      labourCost
      hoursWorked
      hoursAvailable
    }
  }
`

/**
 * __usePartnerGetUtilizationSummaryQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      agentId: // value for 'agentId'
 *      clientId: // value for 'clientId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetUtilizationSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationSummaryQuery,
    PartnerGetUtilizationSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationSummaryQuery,
    PartnerGetUtilizationSummaryQueryVariables
  >(PartnerGetUtilizationSummaryDocument, options)
}
export function usePartnerGetUtilizationSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationSummaryQuery,
    PartnerGetUtilizationSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationSummaryQuery,
    PartnerGetUtilizationSummaryQueryVariables
  >(PartnerGetUtilizationSummaryDocument, options)
}
export type PartnerGetUtilizationSummaryQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationSummaryQuery
>
export type PartnerGetUtilizationSummaryLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationSummaryLazyQuery
>
export type PartnerGetUtilizationSummaryQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationSummaryQuery,
  PartnerGetUtilizationSummaryQueryVariables
>
export const PartnerGetUtilizationSeriesDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationSeries(
    $startDate: String!
    $endDate: String!
    $granularity: UtilizationGranularity
    $filters: UtilizationFiltersInput
  ) {
    PartnerGetUtilizationSeries(
      startDate: $startDate
      endDate: $endDate
      granularity: $granularity
      filters: $filters
    ) {
      granularity
      series {
        date
        labourCost
        hoursWorked
      }
    }
  }
`

/**
 * __usePartnerGetUtilizationSeriesQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationSeriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      granularity: // value for 'granularity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetUtilizationSeriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationSeriesQuery,
    PartnerGetUtilizationSeriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationSeriesQuery,
    PartnerGetUtilizationSeriesQueryVariables
  >(PartnerGetUtilizationSeriesDocument, options)
}
export function usePartnerGetUtilizationSeriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationSeriesQuery,
    PartnerGetUtilizationSeriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationSeriesQuery,
    PartnerGetUtilizationSeriesQueryVariables
  >(PartnerGetUtilizationSeriesDocument, options)
}
export type PartnerGetUtilizationSeriesQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationSeriesQuery
>
export type PartnerGetUtilizationSeriesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationSeriesLazyQuery
>
export type PartnerGetUtilizationSeriesQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationSeriesQuery,
  PartnerGetUtilizationSeriesQueryVariables
>
export const PartnerGetUtilizationBreakdownDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationBreakdown($startDate: String!, $endDate: String!) {
    PartnerGetUtilizationBreakdown(startDate: $startDate, endDate: $endDate) {
      clientName
      agentName
      ticketId
      ticketType
      dateWorked
      hoursWorked
      labourCost
    }
  }
`

/**
 * __usePartnerGetUtilizationBreakdownQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationBreakdownQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePartnerGetUtilizationBreakdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationBreakdownQuery,
    PartnerGetUtilizationBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationBreakdownQuery,
    PartnerGetUtilizationBreakdownQueryVariables
  >(PartnerGetUtilizationBreakdownDocument, options)
}
export function usePartnerGetUtilizationBreakdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationBreakdownQuery,
    PartnerGetUtilizationBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationBreakdownQuery,
    PartnerGetUtilizationBreakdownQueryVariables
  >(PartnerGetUtilizationBreakdownDocument, options)
}
export type PartnerGetUtilizationBreakdownQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationBreakdownQuery
>
export type PartnerGetUtilizationBreakdownLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationBreakdownLazyQuery
>
export type PartnerGetUtilizationBreakdownQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationBreakdownQuery,
  PartnerGetUtilizationBreakdownQueryVariables
>
export const PartnerGetUtilizationKpIsDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationKPIs(
    $startDate: String!
    $endDate: String!
    $agentId: ID!
    $filters: UtilizationFiltersInput
  ) {
    PartnerGetUtilizationKPIs(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      filters: $filters
    ) {
      utilizationPercent {
        value
        comparison
      }
      hoursWorked {
        value
        comparison
      }
      hoursAvailable {
        value
        comparison
      }
      agentCost {
        value
        comparison
      }
    }
  }
`

/**
 * __usePartnerGetUtilizationKpIsQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationKpIsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationKpIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationKpIsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      agentId: // value for 'agentId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetUtilizationKpIsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationKpIsQuery,
    PartnerGetUtilizationKpIsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationKpIsQuery,
    PartnerGetUtilizationKpIsQueryVariables
  >(PartnerGetUtilizationKpIsDocument, options)
}
export function usePartnerGetUtilizationKpIsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationKpIsQuery,
    PartnerGetUtilizationKpIsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationKpIsQuery,
    PartnerGetUtilizationKpIsQueryVariables
  >(PartnerGetUtilizationKpIsDocument, options)
}
export type PartnerGetUtilizationKpIsQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationKpIsQuery
>
export type PartnerGetUtilizationKpIsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationKpIsLazyQuery
>
export type PartnerGetUtilizationKpIsQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationKpIsQuery,
  PartnerGetUtilizationKpIsQueryVariables
>
export const PartnerGetClientKpIsDocument = /*#__PURE__*/ gql`
  query PartnerGetClientKPIs(
    $startDate: String!
    $endDate: String!
    $clientId: ID!
    $filters: UtilizationFiltersInput
  ) {
    PartnerGetClientKPIs(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      filters: $filters
    ) {
      utilizationPercent {
        value
        comparison
      }
      hoursWorked {
        value
        comparison
      }
      hoursAvailable {
        value
        comparison
      }
      agentCost {
        value
        comparison
      }
    }
  }
`

/**
 * __usePartnerGetClientKpIsQuery__
 *
 * To run a query within a React component, call `usePartnerGetClientKpIsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetClientKpIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetClientKpIsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      clientId: // value for 'clientId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetClientKpIsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetClientKpIsQuery,
    PartnerGetClientKpIsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetClientKpIsQuery,
    PartnerGetClientKpIsQueryVariables
  >(PartnerGetClientKpIsDocument, options)
}
export function usePartnerGetClientKpIsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetClientKpIsQuery,
    PartnerGetClientKpIsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetClientKpIsQuery,
    PartnerGetClientKpIsQueryVariables
  >(PartnerGetClientKpIsDocument, options)
}
export type PartnerGetClientKpIsQueryHookResult = ReturnType<
  typeof usePartnerGetClientKpIsQuery
>
export type PartnerGetClientKpIsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetClientKpIsLazyQuery
>
export type PartnerGetClientKpIsQueryResult = Apollo.QueryResult<
  PartnerGetClientKpIsQuery,
  PartnerGetClientKpIsQueryVariables
>
export const PartnerListUtilizationPresetsDocument = /*#__PURE__*/ gql`
  query PartnerListUtilizationPresets {
    PartnerListUtilizationPresets {
      id
      partnerId
      userId
      name
      createdAt
      updatedAt
      filters {
        dateFrom
        dateTo
        clients {
          include
          exclude
        }
        agents {
          include
          exclude
        }
        agentTitles {
          include
          exclude
        }
        agreements {
          include
          exclude
        }
        ticketType {
          include
          exclude
        }
        categories {
          include
          exclude
        }
      }
    }
  }
`

/**
 * __usePartnerListUtilizationPresetsQuery__
 *
 * To run a query within a React component, call `usePartnerListUtilizationPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListUtilizationPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListUtilizationPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListUtilizationPresetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListUtilizationPresetsQuery,
    PartnerListUtilizationPresetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListUtilizationPresetsQuery,
    PartnerListUtilizationPresetsQueryVariables
  >(PartnerListUtilizationPresetsDocument, options)
}
export function usePartnerListUtilizationPresetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListUtilizationPresetsQuery,
    PartnerListUtilizationPresetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListUtilizationPresetsQuery,
    PartnerListUtilizationPresetsQueryVariables
  >(PartnerListUtilizationPresetsDocument, options)
}
export type PartnerListUtilizationPresetsQueryHookResult = ReturnType<
  typeof usePartnerListUtilizationPresetsQuery
>
export type PartnerListUtilizationPresetsLazyQueryHookResult = ReturnType<
  typeof usePartnerListUtilizationPresetsLazyQuery
>
export type PartnerListUtilizationPresetsQueryResult = Apollo.QueryResult<
  PartnerListUtilizationPresetsQuery,
  PartnerListUtilizationPresetsQueryVariables
>
export const PartnerGetUtilizationPresetDocument = /*#__PURE__*/ gql`
  query PartnerGetUtilizationPreset($id: ID!) {
    PartnerGetUtilizationPreset(id: $id) {
      id
      partnerId
      userId
      name
      createdAt
      updatedAt
      filters {
        dateFrom
        dateTo
        clients {
          include
          exclude
        }
        agents {
          include
          exclude
        }
        agentTitles {
          include
          exclude
        }
        agreements {
          include
          exclude
        }
        ticketType {
          include
          exclude
        }
        categories {
          include
          exclude
        }
      }
    }
  }
`

/**
 * __usePartnerGetUtilizationPresetQuery__
 *
 * To run a query within a React component, call `usePartnerGetUtilizationPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUtilizationPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUtilizationPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetUtilizationPresetQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetUtilizationPresetQuery,
    PartnerGetUtilizationPresetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUtilizationPresetQuery,
    PartnerGetUtilizationPresetQueryVariables
  >(PartnerGetUtilizationPresetDocument, options)
}
export function usePartnerGetUtilizationPresetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUtilizationPresetQuery,
    PartnerGetUtilizationPresetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUtilizationPresetQuery,
    PartnerGetUtilizationPresetQueryVariables
  >(PartnerGetUtilizationPresetDocument, options)
}
export type PartnerGetUtilizationPresetQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationPresetQuery
>
export type PartnerGetUtilizationPresetLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUtilizationPresetLazyQuery
>
export type PartnerGetUtilizationPresetQueryResult = Apollo.QueryResult<
  PartnerGetUtilizationPresetQuery,
  PartnerGetUtilizationPresetQueryVariables
>
export const PartnerCreateUtilizationPresetDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateUtilizationPreset(
    $input: CreateUtilizationPresetInput!
  ) {
    PartnerCreateUtilizationPreset(input: $input) {
      id
      partnerId
      userId
      name
      createdAt
      updatedAt
      filters {
        dateFrom
        dateTo
        clients {
          include
          exclude
        }
        agents {
          include
          exclude
        }
        agentTitles {
          include
          exclude
        }
        agreements {
          include
          exclude
        }
        ticketType {
          include
          exclude
        }
        categories {
          include
          exclude
        }
      }
    }
  }
`
export type PartnerCreateUtilizationPresetMutationFn = Apollo.MutationFunction<
  PartnerCreateUtilizationPresetMutation,
  PartnerCreateUtilizationPresetMutationVariables
>

/**
 * __usePartnerCreateUtilizationPresetMutation__
 *
 * To run a mutation, you first call `usePartnerCreateUtilizationPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateUtilizationPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateUtilizationPresetMutation, { data, loading, error }] = usePartnerCreateUtilizationPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateUtilizationPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateUtilizationPresetMutation,
    PartnerCreateUtilizationPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateUtilizationPresetMutation,
    PartnerCreateUtilizationPresetMutationVariables
  >(PartnerCreateUtilizationPresetDocument, options)
}
export type PartnerCreateUtilizationPresetMutationHookResult = ReturnType<
  typeof usePartnerCreateUtilizationPresetMutation
>
export type PartnerCreateUtilizationPresetMutationResult =
  Apollo.MutationResult<PartnerCreateUtilizationPresetMutation>
export type PartnerCreateUtilizationPresetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateUtilizationPresetMutation,
    PartnerCreateUtilizationPresetMutationVariables
  >
export const PartnerUpdateUtilizationPresetDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateUtilizationPreset(
    $input: UpdateUtilizationPresetInput!
  ) {
    PartnerUpdateUtilizationPreset(input: $input) {
      id
      partnerId
      userId
      name
      createdAt
      updatedAt
      filters {
        dateFrom
        dateTo
        clients {
          include
          exclude
        }
        agents {
          include
          exclude
        }
        agentTitles {
          include
          exclude
        }
        agreements {
          include
          exclude
        }
        ticketType {
          include
          exclude
        }
        categories {
          include
          exclude
        }
      }
    }
  }
`
export type PartnerUpdateUtilizationPresetMutationFn = Apollo.MutationFunction<
  PartnerUpdateUtilizationPresetMutation,
  PartnerUpdateUtilizationPresetMutationVariables
>

/**
 * __usePartnerUpdateUtilizationPresetMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateUtilizationPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateUtilizationPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateUtilizationPresetMutation, { data, loading, error }] = usePartnerUpdateUtilizationPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateUtilizationPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateUtilizationPresetMutation,
    PartnerUpdateUtilizationPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateUtilizationPresetMutation,
    PartnerUpdateUtilizationPresetMutationVariables
  >(PartnerUpdateUtilizationPresetDocument, options)
}
export type PartnerUpdateUtilizationPresetMutationHookResult = ReturnType<
  typeof usePartnerUpdateUtilizationPresetMutation
>
export type PartnerUpdateUtilizationPresetMutationResult =
  Apollo.MutationResult<PartnerUpdateUtilizationPresetMutation>
export type PartnerUpdateUtilizationPresetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateUtilizationPresetMutation,
    PartnerUpdateUtilizationPresetMutationVariables
  >
export const PartnerDeleteUtilizationPresetDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteUtilizationPreset($id: ID!) {
    PartnerDeleteUtilizationPreset(id: $id)
  }
`
export type PartnerDeleteUtilizationPresetMutationFn = Apollo.MutationFunction<
  PartnerDeleteUtilizationPresetMutation,
  PartnerDeleteUtilizationPresetMutationVariables
>

/**
 * __usePartnerDeleteUtilizationPresetMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteUtilizationPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteUtilizationPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteUtilizationPresetMutation, { data, loading, error }] = usePartnerDeleteUtilizationPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteUtilizationPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteUtilizationPresetMutation,
    PartnerDeleteUtilizationPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteUtilizationPresetMutation,
    PartnerDeleteUtilizationPresetMutationVariables
  >(PartnerDeleteUtilizationPresetDocument, options)
}
export type PartnerDeleteUtilizationPresetMutationHookResult = ReturnType<
  typeof usePartnerDeleteUtilizationPresetMutation
>
export type PartnerDeleteUtilizationPresetMutationResult =
  Apollo.MutationResult<PartnerDeleteUtilizationPresetMutation>
export type PartnerDeleteUtilizationPresetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteUtilizationPresetMutation,
    PartnerDeleteUtilizationPresetMutationVariables
  >
export const ExportUtilizationCsvDocument = /*#__PURE__*/ gql`
  mutation ExportUtilizationCSV($input: ExportUtilizationCSVInput!) {
    PartnerExportUtilizationCSV(input: $input)
  }
`
export type ExportUtilizationCsvMutationFn = Apollo.MutationFunction<
  ExportUtilizationCsvMutation,
  ExportUtilizationCsvMutationVariables
>

/**
 * __useExportUtilizationCsvMutation__
 *
 * To run a mutation, you first call `useExportUtilizationCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUtilizationCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUtilizationCsvMutation, { data, loading, error }] = useExportUtilizationCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportUtilizationCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportUtilizationCsvMutation,
    ExportUtilizationCsvMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExportUtilizationCsvMutation,
    ExportUtilizationCsvMutationVariables
  >(ExportUtilizationCsvDocument, options)
}
export type ExportUtilizationCsvMutationHookResult = ReturnType<
  typeof useExportUtilizationCsvMutation
>
export type ExportUtilizationCsvMutationResult =
  Apollo.MutationResult<ExportUtilizationCsvMutation>
export type ExportUtilizationCsvMutationOptions = Apollo.BaseMutationOptions<
  ExportUtilizationCsvMutation,
  ExportUtilizationCsvMutationVariables
>
export const ExportUtilizationBreakdownCsvDocument = /*#__PURE__*/ gql`
  mutation ExportUtilizationBreakdownCSV(
    $input: ExportUtilizationBreakdownCSVInput!
  ) {
    PartnerExportUtilizationBreakdownCSV(input: $input)
  }
`
export type ExportUtilizationBreakdownCsvMutationFn = Apollo.MutationFunction<
  ExportUtilizationBreakdownCsvMutation,
  ExportUtilizationBreakdownCsvMutationVariables
>

/**
 * __useExportUtilizationBreakdownCsvMutation__
 *
 * To run a mutation, you first call `useExportUtilizationBreakdownCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUtilizationBreakdownCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUtilizationBreakdownCsvMutation, { data, loading, error }] = useExportUtilizationBreakdownCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportUtilizationBreakdownCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportUtilizationBreakdownCsvMutation,
    ExportUtilizationBreakdownCsvMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExportUtilizationBreakdownCsvMutation,
    ExportUtilizationBreakdownCsvMutationVariables
  >(ExportUtilizationBreakdownCsvDocument, options)
}
export type ExportUtilizationBreakdownCsvMutationHookResult = ReturnType<
  typeof useExportUtilizationBreakdownCsvMutation
>
export type ExportUtilizationBreakdownCsvMutationResult =
  Apollo.MutationResult<ExportUtilizationBreakdownCsvMutation>
export type ExportUtilizationBreakdownCsvMutationOptions =
  Apollo.BaseMutationOptions<
    ExportUtilizationBreakdownCsvMutation,
    ExportUtilizationBreakdownCsvMutationVariables
  >
export const GetClientTicketCountsDocument = /*#__PURE__*/ gql`
  query GetClientTicketCounts($input: ClientTicketCountsInput!) {
    PartnerGetClientTicketCounts(input: $input) {
      clientId
      clientName
      ticketCount
      hoursWorked
      cost
    }
  }
`

/**
 * __useGetClientTicketCountsQuery__
 *
 * To run a query within a React component, call `useGetClientTicketCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTicketCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTicketCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientTicketCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTicketCountsQuery,
    GetClientTicketCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClientTicketCountsQuery,
    GetClientTicketCountsQueryVariables
  >(GetClientTicketCountsDocument, options)
}
export function useGetClientTicketCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTicketCountsQuery,
    GetClientTicketCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClientTicketCountsQuery,
    GetClientTicketCountsQueryVariables
  >(GetClientTicketCountsDocument, options)
}
export type GetClientTicketCountsQueryHookResult = ReturnType<
  typeof useGetClientTicketCountsQuery
>
export type GetClientTicketCountsLazyQueryHookResult = ReturnType<
  typeof useGetClientTicketCountsLazyQuery
>
export type GetClientTicketCountsQueryResult = Apollo.QueryResult<
  GetClientTicketCountsQuery,
  GetClientTicketCountsQueryVariables
>
export const GetAgentTicketCountsDocument = /*#__PURE__*/ gql`
  query GetAgentTicketCounts($input: AgentTicketCountsInput!) {
    PartnerGetAgentTicketCounts(input: $input) {
      agentId
      agentName
      ticketCount
      hoursWorked
      cost
    }
  }
`

/**
 * __useGetAgentTicketCountsQuery__
 *
 * To run a query within a React component, call `useGetAgentTicketCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentTicketCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentTicketCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAgentTicketCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAgentTicketCountsQuery,
    GetAgentTicketCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAgentTicketCountsQuery,
    GetAgentTicketCountsQueryVariables
  >(GetAgentTicketCountsDocument, options)
}
export function useGetAgentTicketCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAgentTicketCountsQuery,
    GetAgentTicketCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAgentTicketCountsQuery,
    GetAgentTicketCountsQueryVariables
  >(GetAgentTicketCountsDocument, options)
}
export type GetAgentTicketCountsQueryHookResult = ReturnType<
  typeof useGetAgentTicketCountsQuery
>
export type GetAgentTicketCountsLazyQueryHookResult = ReturnType<
  typeof useGetAgentTicketCountsLazyQuery
>
export type GetAgentTicketCountsQueryResult = Apollo.QueryResult<
  GetAgentTicketCountsQuery,
  GetAgentTicketCountsQueryVariables
>
export const GetTicketListDocument = /*#__PURE__*/ gql`
  query GetTicketList($input: TicketListInput!) {
    PartnerGetTicketList(input: $input) {
      items {
        ticketId
        displayId
        category
        date
        hoursWorked
        cost
        ticketUrl
      }
      total
      totalHoursWorked
      totalCost
      categories
    }
  }
`

/**
 * __useGetTicketListQuery__
 *
 * To run a query within a React component, call `useGetTicketListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTicketListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTicketListQuery,
    GetTicketListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTicketListQuery, GetTicketListQueryVariables>(
    GetTicketListDocument,
    options
  )
}
export function useGetTicketListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTicketListQuery,
    GetTicketListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTicketListQuery, GetTicketListQueryVariables>(
    GetTicketListDocument,
    options
  )
}
export type GetTicketListQueryHookResult = ReturnType<
  typeof useGetTicketListQuery
>
export type GetTicketListLazyQueryHookResult = ReturnType<
  typeof useGetTicketListLazyQuery
>
export type GetTicketListQueryResult = Apollo.QueryResult<
  GetTicketListQuery,
  GetTicketListQueryVariables
>
export const PartnerCreateApiKeyDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateApiKey($input: CreateApiKeyInput!) {
    PartnerCreateApiKey(input: $input) {
      key
    }
  }
`
export type PartnerCreateApiKeyMutationFn = Apollo.MutationFunction<
  PartnerCreateApiKeyMutation,
  PartnerCreateApiKeyMutationVariables
>

/**
 * __usePartnerCreateApiKeyMutation__
 *
 * To run a mutation, you first call `usePartnerCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateApiKeyMutation, { data, loading, error }] = usePartnerCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateApiKeyMutation,
    PartnerCreateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateApiKeyMutation,
    PartnerCreateApiKeyMutationVariables
  >(PartnerCreateApiKeyDocument, options)
}
export type PartnerCreateApiKeyMutationHookResult = ReturnType<
  typeof usePartnerCreateApiKeyMutation
>
export type PartnerCreateApiKeyMutationResult =
  Apollo.MutationResult<PartnerCreateApiKeyMutation>
export type PartnerCreateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateApiKeyMutation,
  PartnerCreateApiKeyMutationVariables
>
export const PartnerUpdateApiKeyDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateApiKey($input: UpdateApiKeyInput!) {
    PartnerUpdateApiKey(input: $input)
  }
`
export type PartnerUpdateApiKeyMutationFn = Apollo.MutationFunction<
  PartnerUpdateApiKeyMutation,
  PartnerUpdateApiKeyMutationVariables
>

/**
 * __usePartnerUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateApiKeyMutation, { data, loading, error }] = usePartnerUpdateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateApiKeyMutation,
    PartnerUpdateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateApiKeyMutation,
    PartnerUpdateApiKeyMutationVariables
  >(PartnerUpdateApiKeyDocument, options)
}
export type PartnerUpdateApiKeyMutationHookResult = ReturnType<
  typeof usePartnerUpdateApiKeyMutation
>
export type PartnerUpdateApiKeyMutationResult =
  Apollo.MutationResult<PartnerUpdateApiKeyMutation>
export type PartnerUpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateApiKeyMutation,
  PartnerUpdateApiKeyMutationVariables
>
export const PartnerRevokeApiKeyDocument = /*#__PURE__*/ gql`
  mutation PartnerRevokeApiKey($keyID: String!) {
    PartnerRevokeApiKey(keyID: $keyID)
  }
`
export type PartnerRevokeApiKeyMutationFn = Apollo.MutationFunction<
  PartnerRevokeApiKeyMutation,
  PartnerRevokeApiKeyMutationVariables
>

/**
 * __usePartnerRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `usePartnerRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRevokeApiKeyMutation, { data, loading, error }] = usePartnerRevokeApiKeyMutation({
 *   variables: {
 *      keyID: // value for 'keyID'
 *   },
 * });
 */
export function usePartnerRevokeApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRevokeApiKeyMutation,
    PartnerRevokeApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRevokeApiKeyMutation,
    PartnerRevokeApiKeyMutationVariables
  >(PartnerRevokeApiKeyDocument, options)
}
export type PartnerRevokeApiKeyMutationHookResult = ReturnType<
  typeof usePartnerRevokeApiKeyMutation
>
export type PartnerRevokeApiKeyMutationResult =
  Apollo.MutationResult<PartnerRevokeApiKeyMutation>
export type PartnerRevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<
  PartnerRevokeApiKeyMutation,
  PartnerRevokeApiKeyMutationVariables
>
export const PartnerScopeCatalogDocument = /*#__PURE__*/ gql`
  query PartnerScopeCatalog {
    PartnerScopeCatalog {
      value
      group
      label
      description
    }
  }
`

/**
 * __usePartnerScopeCatalogQuery__
 *
 * To run a query within a React component, call `usePartnerScopeCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerScopeCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerScopeCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerScopeCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerScopeCatalogQuery,
    PartnerScopeCatalogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerScopeCatalogQuery,
    PartnerScopeCatalogQueryVariables
  >(PartnerScopeCatalogDocument, options)
}
export function usePartnerScopeCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerScopeCatalogQuery,
    PartnerScopeCatalogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerScopeCatalogQuery,
    PartnerScopeCatalogQueryVariables
  >(PartnerScopeCatalogDocument, options)
}
export type PartnerScopeCatalogQueryHookResult = ReturnType<
  typeof usePartnerScopeCatalogQuery
>
export type PartnerScopeCatalogLazyQueryHookResult = ReturnType<
  typeof usePartnerScopeCatalogLazyQuery
>
export type PartnerScopeCatalogQueryResult = Apollo.QueryResult<
  PartnerScopeCatalogQuery,
  PartnerScopeCatalogQueryVariables
>
export const PartnerApiKeyConnectionDocument = /*#__PURE__*/ gql`
  query PartnerApiKeyConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: ApiKeyFilter
    $orderBy: ApiKeyOrderBy
  ) {
    PartnerApiKeyConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...ApiKey
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ApiKeyFragmentDoc}
`

/**
 * __usePartnerApiKeyConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerApiKeyConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerApiKeyConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerApiKeyConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerApiKeyConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >(PartnerApiKeyConnectionDocument, options)
}
export function usePartnerApiKeyConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >(PartnerApiKeyConnectionDocument, options)
}
export type PartnerApiKeyConnectionQueryHookResult = ReturnType<
  typeof usePartnerApiKeyConnectionQuery
>
export type PartnerApiKeyConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerApiKeyConnectionLazyQuery
>
export type PartnerApiKeyConnectionQueryResult = Apollo.QueryResult<
  PartnerApiKeyConnectionQuery,
  PartnerApiKeyConnectionQueryVariables
>
export const PartnerArHomeDocument = /*#__PURE__*/ gql`
  query PartnerArHome($expectedStart: String!, $expectedEnd: String!) {
    PartnerHomeOutstandingAR {
      currencies {
        currency
        total
        aging {
          bucket0To30 {
            amountCents
            count
          }
          bucket31To60 {
            amountCents
            count
          }
          bucket61To90 {
            amountCents
            count
          }
          bucket90Plus {
            amountCents
            count
          }
        }
      }
    }
    PartnerHomePerformance(range: LAST_30D) {
      currencies {
        currency
        collected {
          ...HomeDeltaFields
        }
        dso {
          value
        }
        mrr {
          value
        }
        mrrAutopay {
          value
        }
      }
    }
    PartnerHomeInvoicePipeline {
      currencies {
        currency
        overdue {
          count
          amountCents
        }
        open {
          count
          amountCents
        }
        paid30d {
          count
          amountCents
        }
      }
    }
    cashFlowReceived: PartnerHomeCashFlow(
      direction: RECEIVED
      range: LAST_30D
      limit: 6
    ) {
      ...HomeCashFlowFields
    }
    cashFlowExpected: PartnerHomeCashFlow(
      direction: EXPECTED
      range: CUSTOM
      start: $expectedStart
      end: $expectedEnd
      limit: 6
    ) {
      ...HomeCashFlowFields
    }
    PartnerHomeAutopayCoverage {
      coveragePct
      enrolledCount
      notEnrolledCount
      totalCustomers
    }
    PartnerHomeTopCustomersOwed(limit: 5) {
      currencies {
        currency
        customers {
          customerId
          customerName
          balanceCents
          invoiceCount
          overdueCount
          maxDaysOverdue
          autopay
          invoiceCounts {
            upcoming
            overdue
            received
            paid
            archived
            total
          }
        }
      }
    }
    PartnerHomeTopCustomersPaid(limit: 5) {
      currencies {
        currency
        customers {
          customerId
          customerName
          paidCents
          paymentCount
        }
      }
    }
    PartnerHomePaymentMethodIssues {
      noMethodOnFile
      noDefaultSet
    }
    PartnerHomeCustomersNeedingAttention(page: 1, pageSize: 1) {
      page
      pageSize
      total
      items {
        ...HomeAttentionCustomerFields
      }
    }
  }
  ${HomeDeltaFieldsFragmentDoc}
  ${HomeCashFlowFieldsFragmentDoc}
  ${HomeAttentionCustomerFieldsFragmentDoc}
`

/**
 * __usePartnerArHomeQuery__
 *
 * To run a query within a React component, call `usePartnerArHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerArHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerArHomeQuery({
 *   variables: {
 *      expectedStart: // value for 'expectedStart'
 *      expectedEnd: // value for 'expectedEnd'
 *   },
 * });
 */
export function usePartnerArHomeQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerArHomeQuery,
    PartnerArHomeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PartnerArHomeQuery, PartnerArHomeQueryVariables>(
    PartnerArHomeDocument,
    options
  )
}
export function usePartnerArHomeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerArHomeQuery,
    PartnerArHomeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PartnerArHomeQuery, PartnerArHomeQueryVariables>(
    PartnerArHomeDocument,
    options
  )
}
export type PartnerArHomeQueryHookResult = ReturnType<
  typeof usePartnerArHomeQuery
>
export type PartnerArHomeLazyQueryHookResult = ReturnType<
  typeof usePartnerArHomeLazyQuery
>
export type PartnerArHomeQueryResult = Apollo.QueryResult<
  PartnerArHomeQuery,
  PartnerArHomeQueryVariables
>
export const PartnerHomePerformanceCardDocument = /*#__PURE__*/ gql`
  query PartnerHomePerformanceCard(
    $range: HomeRange
    $start: String
    $end: String
  ) {
    PartnerHomePerformance(range: $range, start: $start, end: $end) {
      currencies {
        currency
        collected {
          ...HomeDeltaFields
        }
        dso {
          value
        }
        mrr {
          value
        }
        mrrAutopay {
          value
        }
      }
    }
  }
  ${HomeDeltaFieldsFragmentDoc}
`

/**
 * __usePartnerHomePerformanceCardQuery__
 *
 * To run a query within a React component, call `usePartnerHomePerformanceCardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerHomePerformanceCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerHomePerformanceCardQuery({
 *   variables: {
 *      range: // value for 'range'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function usePartnerHomePerformanceCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerHomePerformanceCardQuery,
    PartnerHomePerformanceCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerHomePerformanceCardQuery,
    PartnerHomePerformanceCardQueryVariables
  >(PartnerHomePerformanceCardDocument, options)
}
export function usePartnerHomePerformanceCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerHomePerformanceCardQuery,
    PartnerHomePerformanceCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerHomePerformanceCardQuery,
    PartnerHomePerformanceCardQueryVariables
  >(PartnerHomePerformanceCardDocument, options)
}
export type PartnerHomePerformanceCardQueryHookResult = ReturnType<
  typeof usePartnerHomePerformanceCardQuery
>
export type PartnerHomePerformanceCardLazyQueryHookResult = ReturnType<
  typeof usePartnerHomePerformanceCardLazyQuery
>
export type PartnerHomePerformanceCardQueryResult = Apollo.QueryResult<
  PartnerHomePerformanceCardQuery,
  PartnerHomePerformanceCardQueryVariables
>
export const PartnerHomeCashFlowCardDocument = /*#__PURE__*/ gql`
  query PartnerHomeCashFlowCard(
    $range: HomeRange
    $start: String
    $end: String
    $expectedStart: String!
    $expectedEnd: String!
  ) {
    cashFlowReceived: PartnerHomeCashFlow(
      direction: RECEIVED
      range: $range
      start: $start
      end: $end
      limit: 6
    ) {
      ...HomeCashFlowFields
    }
    cashFlowExpected: PartnerHomeCashFlow(
      direction: EXPECTED
      range: CUSTOM
      start: $expectedStart
      end: $expectedEnd
      limit: 6
    ) {
      ...HomeCashFlowFields
    }
  }
  ${HomeCashFlowFieldsFragmentDoc}
`

/**
 * __usePartnerHomeCashFlowCardQuery__
 *
 * To run a query within a React component, call `usePartnerHomeCashFlowCardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerHomeCashFlowCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerHomeCashFlowCardQuery({
 *   variables: {
 *      range: // value for 'range'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      expectedStart: // value for 'expectedStart'
 *      expectedEnd: // value for 'expectedEnd'
 *   },
 * });
 */
export function usePartnerHomeCashFlowCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerHomeCashFlowCardQuery,
    PartnerHomeCashFlowCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerHomeCashFlowCardQuery,
    PartnerHomeCashFlowCardQueryVariables
  >(PartnerHomeCashFlowCardDocument, options)
}
export function usePartnerHomeCashFlowCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerHomeCashFlowCardQuery,
    PartnerHomeCashFlowCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerHomeCashFlowCardQuery,
    PartnerHomeCashFlowCardQueryVariables
  >(PartnerHomeCashFlowCardDocument, options)
}
export type PartnerHomeCashFlowCardQueryHookResult = ReturnType<
  typeof usePartnerHomeCashFlowCardQuery
>
export type PartnerHomeCashFlowCardLazyQueryHookResult = ReturnType<
  typeof usePartnerHomeCashFlowCardLazyQuery
>
export type PartnerHomeCashFlowCardQueryResult = Apollo.QueryResult<
  PartnerHomeCashFlowCardQuery,
  PartnerHomeCashFlowCardQueryVariables
>
export const PartnerHomeCustomersNeedingAttentionPageDocument = /*#__PURE__*/ gql`
  query PartnerHomeCustomersNeedingAttentionPage($page: Int!, $pageSize: Int!) {
    PartnerHomeCustomersNeedingAttention(page: $page, pageSize: $pageSize) {
      page
      pageSize
      total
      items {
        ...HomeAttentionCustomerFields
      }
    }
  }
  ${HomeAttentionCustomerFieldsFragmentDoc}
`

/**
 * __usePartnerHomeCustomersNeedingAttentionPageQuery__
 *
 * To run a query within a React component, call `usePartnerHomeCustomersNeedingAttentionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerHomeCustomersNeedingAttentionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerHomeCustomersNeedingAttentionPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePartnerHomeCustomersNeedingAttentionPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerHomeCustomersNeedingAttentionPageQuery,
    PartnerHomeCustomersNeedingAttentionPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerHomeCustomersNeedingAttentionPageQuery,
    PartnerHomeCustomersNeedingAttentionPageQueryVariables
  >(PartnerHomeCustomersNeedingAttentionPageDocument, options)
}
export function usePartnerHomeCustomersNeedingAttentionPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerHomeCustomersNeedingAttentionPageQuery,
    PartnerHomeCustomersNeedingAttentionPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerHomeCustomersNeedingAttentionPageQuery,
    PartnerHomeCustomersNeedingAttentionPageQueryVariables
  >(PartnerHomeCustomersNeedingAttentionPageDocument, options)
}
export type PartnerHomeCustomersNeedingAttentionPageQueryHookResult =
  ReturnType<typeof usePartnerHomeCustomersNeedingAttentionPageQuery>
export type PartnerHomeCustomersNeedingAttentionPageLazyQueryHookResult =
  ReturnType<typeof usePartnerHomeCustomersNeedingAttentionPageLazyQuery>
export type PartnerHomeCustomersNeedingAttentionPageQueryResult =
  Apollo.QueryResult<
    PartnerHomeCustomersNeedingAttentionPageQuery,
    PartnerHomeCustomersNeedingAttentionPageQueryVariables
  >
export const ListAssistantConversationsDocument = /*#__PURE__*/ gql`
  query ListAssistantConversations($page: Int, $perPage: Int) {
    PartnerListAssistantConversations(page: $page, perPage: $perPage) {
      conversations {
        id
        partnerID
        userID
        title
        createdAt
        updatedAt
      }
      total
      page
      perPage
    }
  }
`

/**
 * __useListAssistantConversationsQuery__
 *
 * To run a query within a React component, call `useListAssistantConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssistantConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssistantConversationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useListAssistantConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListAssistantConversationsQuery,
    ListAssistantConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListAssistantConversationsQuery,
    ListAssistantConversationsQueryVariables
  >(ListAssistantConversationsDocument, options)
}
export function useListAssistantConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAssistantConversationsQuery,
    ListAssistantConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListAssistantConversationsQuery,
    ListAssistantConversationsQueryVariables
  >(ListAssistantConversationsDocument, options)
}
export type ListAssistantConversationsQueryHookResult = ReturnType<
  typeof useListAssistantConversationsQuery
>
export type ListAssistantConversationsLazyQueryHookResult = ReturnType<
  typeof useListAssistantConversationsLazyQuery
>
export type ListAssistantConversationsQueryResult = Apollo.QueryResult<
  ListAssistantConversationsQuery,
  ListAssistantConversationsQueryVariables
>
export const GetAssistantConversationDocument = /*#__PURE__*/ gql`
  query GetAssistantConversation($conversationID: ID!, $messageLimit: Int) {
    PartnerGetAssistantConversation(
      conversationID: $conversationID
      messageLimit: $messageLimit
    ) {
      conversation {
        id
        partnerID
        userID
        title
        createdAt
        updatedAt
      }
      messages {
        id
        conversationID
        role
        content
        isPartial
        createdAt
        events {
          seq
          kind
          payload
        }
      }
      hasMoreMessages
    }
  }
`

/**
 * __useGetAssistantConversationQuery__
 *
 * To run a query within a React component, call `useGetAssistantConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantConversationQuery({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      messageLimit: // value for 'messageLimit'
 *   },
 * });
 */
export function useGetAssistantConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssistantConversationQuery,
    GetAssistantConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAssistantConversationQuery,
    GetAssistantConversationQueryVariables
  >(GetAssistantConversationDocument, options)
}
export function useGetAssistantConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssistantConversationQuery,
    GetAssistantConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAssistantConversationQuery,
    GetAssistantConversationQueryVariables
  >(GetAssistantConversationDocument, options)
}
export type GetAssistantConversationQueryHookResult = ReturnType<
  typeof useGetAssistantConversationQuery
>
export type GetAssistantConversationLazyQueryHookResult = ReturnType<
  typeof useGetAssistantConversationLazyQuery
>
export type GetAssistantConversationQueryResult = Apollo.QueryResult<
  GetAssistantConversationQuery,
  GetAssistantConversationQueryVariables
>
export const CreateAssistantConversationDocument = /*#__PURE__*/ gql`
  mutation CreateAssistantConversation($title: String) {
    PartnerCreateAssistantConversation(title: $title) {
      id
      partnerID
      userID
      title
      createdAt
      updatedAt
    }
  }
`
export type CreateAssistantConversationMutationFn = Apollo.MutationFunction<
  CreateAssistantConversationMutation,
  CreateAssistantConversationMutationVariables
>

/**
 * __useCreateAssistantConversationMutation__
 *
 * To run a mutation, you first call `useCreateAssistantConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssistantConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssistantConversationMutation, { data, loading, error }] = useCreateAssistantConversationMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateAssistantConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAssistantConversationMutation,
    CreateAssistantConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateAssistantConversationMutation,
    CreateAssistantConversationMutationVariables
  >(CreateAssistantConversationDocument, options)
}
export type CreateAssistantConversationMutationHookResult = ReturnType<
  typeof useCreateAssistantConversationMutation
>
export type CreateAssistantConversationMutationResult =
  Apollo.MutationResult<CreateAssistantConversationMutation>
export type CreateAssistantConversationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAssistantConversationMutation,
    CreateAssistantConversationMutationVariables
  >
export const DeleteAssistantConversationDocument = /*#__PURE__*/ gql`
  mutation DeleteAssistantConversation($conversationID: ID!) {
    PartnerDeleteAssistantConversation(conversationID: $conversationID)
  }
`
export type DeleteAssistantConversationMutationFn = Apollo.MutationFunction<
  DeleteAssistantConversationMutation,
  DeleteAssistantConversationMutationVariables
>

/**
 * __useDeleteAssistantConversationMutation__
 *
 * To run a mutation, you first call `useDeleteAssistantConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssistantConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssistantConversationMutation, { data, loading, error }] = useDeleteAssistantConversationMutation({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *   },
 * });
 */
export function useDeleteAssistantConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAssistantConversationMutation,
    DeleteAssistantConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteAssistantConversationMutation,
    DeleteAssistantConversationMutationVariables
  >(DeleteAssistantConversationDocument, options)
}
export type DeleteAssistantConversationMutationHookResult = ReturnType<
  typeof useDeleteAssistantConversationMutation
>
export type DeleteAssistantConversationMutationResult =
  Apollo.MutationResult<DeleteAssistantConversationMutation>
export type DeleteAssistantConversationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteAssistantConversationMutation,
    DeleteAssistantConversationMutationVariables
  >
export const ConfirmAssistantActionDocument = /*#__PURE__*/ gql`
  mutation ConfirmAssistantAction($token: String!, $confirmed: Boolean!) {
    PartnerConfirmAssistantAction(token: $token, confirmed: $confirmed)
  }
`
export type ConfirmAssistantActionMutationFn = Apollo.MutationFunction<
  ConfirmAssistantActionMutation,
  ConfirmAssistantActionMutationVariables
>

/**
 * __useConfirmAssistantActionMutation__
 *
 * To run a mutation, you first call `useConfirmAssistantActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAssistantActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAssistantActionMutation, { data, loading, error }] = useConfirmAssistantActionMutation({
 *   variables: {
 *      token: // value for 'token'
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useConfirmAssistantActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmAssistantActionMutation,
    ConfirmAssistantActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ConfirmAssistantActionMutation,
    ConfirmAssistantActionMutationVariables
  >(ConfirmAssistantActionDocument, options)
}
export type ConfirmAssistantActionMutationHookResult = ReturnType<
  typeof useConfirmAssistantActionMutation
>
export type ConfirmAssistantActionMutationResult =
  Apollo.MutationResult<ConfirmAssistantActionMutation>
export type ConfirmAssistantActionMutationOptions = Apollo.BaseMutationOptions<
  ConfirmAssistantActionMutation,
  ConfirmAssistantActionMutationVariables
>
export const SendAssistantMessageDocument = /*#__PURE__*/ gql`
  subscription SendAssistantMessage($conversationID: ID!, $content: String!) {
    PartnerSendAssistantMessage(
      conversationID: $conversationID
      content: $content
    ) {
      ... on AssistantStatusEvent {
        __typename
        text
      }
      ... on AssistantTokenEvent {
        __typename
        text
      }
      ... on AssistantToolResultEvent {
        __typename
        toolName
        status
      }
      ... on AssistantToolErrorEvent {
        __typename
        toolName
        message
      }
      ... on AssistantDoneEvent {
        __typename
        messageID
      }
      ... on AssistantConfirmationRequiredEvent {
        __typename
        token
        toolName
        toolInput
        summary
        description
      }
      ... on AssistantConfirmationOutcomeEvent {
        __typename
        token
        toolName
        outcome
      }
    }
  }
`

/**
 * __useSendAssistantMessageSubscription__
 *
 * To run a query within a React component, call `useSendAssistantMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSendAssistantMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendAssistantMessageSubscription({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSendAssistantMessageSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SendAssistantMessageSubscription,
    SendAssistantMessageSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    SendAssistantMessageSubscription,
    SendAssistantMessageSubscriptionVariables
  >(SendAssistantMessageDocument, options)
}
export type SendAssistantMessageSubscriptionHookResult = ReturnType<
  typeof useSendAssistantMessageSubscription
>
export type SendAssistantMessageSubscriptionResult =
  Apollo.SubscriptionResult<SendAssistantMessageSubscription>
export const ListAssistantV2ConversationsDocument = /*#__PURE__*/ gql`
  query ListAssistantV2Conversations(
    $page: Int
    $perPage: Int
    $includeV1: Boolean
  ) {
    PartnerListAssistantV2Conversations(
      page: $page
      perPage: $perPage
      includeV1: $includeV1
    ) {
      conversations {
        id
        partnerID
        userID
        title
        version
        anthropicSessionID
        createdAt
        updatedAt
      }
      total
      page
      perPage
    }
  }
`

/**
 * __useListAssistantV2ConversationsQuery__
 *
 * To run a query within a React component, call `useListAssistantV2ConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssistantV2ConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssistantV2ConversationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      includeV1: // value for 'includeV1'
 *   },
 * });
 */
export function useListAssistantV2ConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListAssistantV2ConversationsQuery,
    ListAssistantV2ConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListAssistantV2ConversationsQuery,
    ListAssistantV2ConversationsQueryVariables
  >(ListAssistantV2ConversationsDocument, options)
}
export function useListAssistantV2ConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAssistantV2ConversationsQuery,
    ListAssistantV2ConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListAssistantV2ConversationsQuery,
    ListAssistantV2ConversationsQueryVariables
  >(ListAssistantV2ConversationsDocument, options)
}
export type ListAssistantV2ConversationsQueryHookResult = ReturnType<
  typeof useListAssistantV2ConversationsQuery
>
export type ListAssistantV2ConversationsLazyQueryHookResult = ReturnType<
  typeof useListAssistantV2ConversationsLazyQuery
>
export type ListAssistantV2ConversationsQueryResult = Apollo.QueryResult<
  ListAssistantV2ConversationsQuery,
  ListAssistantV2ConversationsQueryVariables
>
export const GetAssistantV2ConversationDocument = /*#__PURE__*/ gql`
  query GetAssistantV2Conversation($conversationID: ID!) {
    PartnerGetAssistantV2Conversation(conversationID: $conversationID) {
      id
      partnerID
      userID
      title
      version
      anthropicSessionID
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetAssistantV2ConversationQuery__
 *
 * To run a query within a React component, call `useGetAssistantV2ConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantV2ConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantV2ConversationQuery({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *   },
 * });
 */
export function useGetAssistantV2ConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssistantV2ConversationQuery,
    GetAssistantV2ConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAssistantV2ConversationQuery,
    GetAssistantV2ConversationQueryVariables
  >(GetAssistantV2ConversationDocument, options)
}
export function useGetAssistantV2ConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssistantV2ConversationQuery,
    GetAssistantV2ConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAssistantV2ConversationQuery,
    GetAssistantV2ConversationQueryVariables
  >(GetAssistantV2ConversationDocument, options)
}
export type GetAssistantV2ConversationQueryHookResult = ReturnType<
  typeof useGetAssistantV2ConversationQuery
>
export type GetAssistantV2ConversationLazyQueryHookResult = ReturnType<
  typeof useGetAssistantV2ConversationLazyQuery
>
export type GetAssistantV2ConversationQueryResult = Apollo.QueryResult<
  GetAssistantV2ConversationQuery,
  GetAssistantV2ConversationQueryVariables
>
export const GetAssistantV2ConversationHistoryDocument = /*#__PURE__*/ gql`
  query GetAssistantV2ConversationHistory(
    $conversationID: ID!
    $after: String
    $limit: Int
  ) {
    PartnerGetAssistantV2ConversationHistory(
      conversationID: $conversationID
      after: $after
      limit: $limit
    ) {
      events {
        id
        eventType
        data
        processedAt
      }
      hasMore
      nextCursor
    }
  }
`

/**
 * __useGetAssistantV2ConversationHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssistantV2ConversationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantV2ConversationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantV2ConversationHistoryQuery({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAssistantV2ConversationHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssistantV2ConversationHistoryQuery,
    GetAssistantV2ConversationHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAssistantV2ConversationHistoryQuery,
    GetAssistantV2ConversationHistoryQueryVariables
  >(GetAssistantV2ConversationHistoryDocument, options)
}
export function useGetAssistantV2ConversationHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssistantV2ConversationHistoryQuery,
    GetAssistantV2ConversationHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAssistantV2ConversationHistoryQuery,
    GetAssistantV2ConversationHistoryQueryVariables
  >(GetAssistantV2ConversationHistoryDocument, options)
}
export type GetAssistantV2ConversationHistoryQueryHookResult = ReturnType<
  typeof useGetAssistantV2ConversationHistoryQuery
>
export type GetAssistantV2ConversationHistoryLazyQueryHookResult = ReturnType<
  typeof useGetAssistantV2ConversationHistoryLazyQuery
>
export type GetAssistantV2ConversationHistoryQueryResult = Apollo.QueryResult<
  GetAssistantV2ConversationHistoryQuery,
  GetAssistantV2ConversationHistoryQueryVariables
>
export const GetAssistantV2TurnStatusDocument = /*#__PURE__*/ gql`
  query GetAssistantV2TurnStatus($conversationID: ID!) {
    PartnerGetAssistantV2TurnStatus(conversationID: $conversationID) {
      status
      acquiredAt
      heartbeatAt
    }
  }
`

/**
 * __useGetAssistantV2TurnStatusQuery__
 *
 * To run a query within a React component, call `useGetAssistantV2TurnStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantV2TurnStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantV2TurnStatusQuery({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *   },
 * });
 */
export function useGetAssistantV2TurnStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssistantV2TurnStatusQuery,
    GetAssistantV2TurnStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAssistantV2TurnStatusQuery,
    GetAssistantV2TurnStatusQueryVariables
  >(GetAssistantV2TurnStatusDocument, options)
}
export function useGetAssistantV2TurnStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssistantV2TurnStatusQuery,
    GetAssistantV2TurnStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAssistantV2TurnStatusQuery,
    GetAssistantV2TurnStatusQueryVariables
  >(GetAssistantV2TurnStatusDocument, options)
}
export type GetAssistantV2TurnStatusQueryHookResult = ReturnType<
  typeof useGetAssistantV2TurnStatusQuery
>
export type GetAssistantV2TurnStatusLazyQueryHookResult = ReturnType<
  typeof useGetAssistantV2TurnStatusLazyQuery
>
export type GetAssistantV2TurnStatusQueryResult = Apollo.QueryResult<
  GetAssistantV2TurnStatusQuery,
  GetAssistantV2TurnStatusQueryVariables
>
export const CreateAssistantV2ConversationDocument = /*#__PURE__*/ gql`
  mutation CreateAssistantV2Conversation($title: String) {
    PartnerCreateAssistantV2Conversation(title: $title) {
      id
      partnerID
      userID
      title
      version
      anthropicSessionID
      createdAt
      updatedAt
    }
  }
`
export type CreateAssistantV2ConversationMutationFn = Apollo.MutationFunction<
  CreateAssistantV2ConversationMutation,
  CreateAssistantV2ConversationMutationVariables
>

/**
 * __useCreateAssistantV2ConversationMutation__
 *
 * To run a mutation, you first call `useCreateAssistantV2ConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssistantV2ConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssistantV2ConversationMutation, { data, loading, error }] = useCreateAssistantV2ConversationMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateAssistantV2ConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAssistantV2ConversationMutation,
    CreateAssistantV2ConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateAssistantV2ConversationMutation,
    CreateAssistantV2ConversationMutationVariables
  >(CreateAssistantV2ConversationDocument, options)
}
export type CreateAssistantV2ConversationMutationHookResult = ReturnType<
  typeof useCreateAssistantV2ConversationMutation
>
export type CreateAssistantV2ConversationMutationResult =
  Apollo.MutationResult<CreateAssistantV2ConversationMutation>
export type CreateAssistantV2ConversationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAssistantV2ConversationMutation,
    CreateAssistantV2ConversationMutationVariables
  >
export const DeleteAssistantV2ConversationDocument = /*#__PURE__*/ gql`
  mutation DeleteAssistantV2Conversation($conversationID: ID!) {
    PartnerDeleteAssistantV2Conversation(conversationID: $conversationID)
  }
`
export type DeleteAssistantV2ConversationMutationFn = Apollo.MutationFunction<
  DeleteAssistantV2ConversationMutation,
  DeleteAssistantV2ConversationMutationVariables
>

/**
 * __useDeleteAssistantV2ConversationMutation__
 *
 * To run a mutation, you first call `useDeleteAssistantV2ConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssistantV2ConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssistantV2ConversationMutation, { data, loading, error }] = useDeleteAssistantV2ConversationMutation({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *   },
 * });
 */
export function useDeleteAssistantV2ConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAssistantV2ConversationMutation,
    DeleteAssistantV2ConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteAssistantV2ConversationMutation,
    DeleteAssistantV2ConversationMutationVariables
  >(DeleteAssistantV2ConversationDocument, options)
}
export type DeleteAssistantV2ConversationMutationHookResult = ReturnType<
  typeof useDeleteAssistantV2ConversationMutation
>
export type DeleteAssistantV2ConversationMutationResult =
  Apollo.MutationResult<DeleteAssistantV2ConversationMutation>
export type DeleteAssistantV2ConversationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteAssistantV2ConversationMutation,
    DeleteAssistantV2ConversationMutationVariables
  >
export const RenameAssistantV2ConversationDocument = /*#__PURE__*/ gql`
  mutation RenameAssistantV2Conversation(
    $conversationID: ID!
    $title: String!
  ) {
    PartnerRenameAssistantV2Conversation(
      conversationID: $conversationID
      title: $title
    ) {
      id
      title
      updatedAt
    }
  }
`
export type RenameAssistantV2ConversationMutationFn = Apollo.MutationFunction<
  RenameAssistantV2ConversationMutation,
  RenameAssistantV2ConversationMutationVariables
>

/**
 * __useRenameAssistantV2ConversationMutation__
 *
 * To run a mutation, you first call `useRenameAssistantV2ConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameAssistantV2ConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameAssistantV2ConversationMutation, { data, loading, error }] = useRenameAssistantV2ConversationMutation({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameAssistantV2ConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameAssistantV2ConversationMutation,
    RenameAssistantV2ConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RenameAssistantV2ConversationMutation,
    RenameAssistantV2ConversationMutationVariables
  >(RenameAssistantV2ConversationDocument, options)
}
export type RenameAssistantV2ConversationMutationHookResult = ReturnType<
  typeof useRenameAssistantV2ConversationMutation
>
export type RenameAssistantV2ConversationMutationResult =
  Apollo.MutationResult<RenameAssistantV2ConversationMutation>
export type RenameAssistantV2ConversationMutationOptions =
  Apollo.BaseMutationOptions<
    RenameAssistantV2ConversationMutation,
    RenameAssistantV2ConversationMutationVariables
  >
export const ConfirmAssistantV2ActionDocument = /*#__PURE__*/ gql`
  mutation ConfirmAssistantV2Action($token: String!, $confirmed: Boolean!) {
    PartnerConfirmAssistantV2Action(token: $token, confirmed: $confirmed)
  }
`
export type ConfirmAssistantV2ActionMutationFn = Apollo.MutationFunction<
  ConfirmAssistantV2ActionMutation,
  ConfirmAssistantV2ActionMutationVariables
>

/**
 * __useConfirmAssistantV2ActionMutation__
 *
 * To run a mutation, you first call `useConfirmAssistantV2ActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAssistantV2ActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAssistantV2ActionMutation, { data, loading, error }] = useConfirmAssistantV2ActionMutation({
 *   variables: {
 *      token: // value for 'token'
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useConfirmAssistantV2ActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmAssistantV2ActionMutation,
    ConfirmAssistantV2ActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ConfirmAssistantV2ActionMutation,
    ConfirmAssistantV2ActionMutationVariables
  >(ConfirmAssistantV2ActionDocument, options)
}
export type ConfirmAssistantV2ActionMutationHookResult = ReturnType<
  typeof useConfirmAssistantV2ActionMutation
>
export type ConfirmAssistantV2ActionMutationResult =
  Apollo.MutationResult<ConfirmAssistantV2ActionMutation>
export type ConfirmAssistantV2ActionMutationOptions =
  Apollo.BaseMutationOptions<
    ConfirmAssistantV2ActionMutation,
    ConfirmAssistantV2ActionMutationVariables
  >
export const GetAssistantV2FileDownloadUrlDocument = /*#__PURE__*/ gql`
  query GetAssistantV2FileDownloadURL(
    $conversationID: ID!
    $fileID: String
    $path: String
  ) {
    PartnerAssistantV2FileDownloadURL(
      conversationID: $conversationID
      fileID: $fileID
      path: $path
    )
  }
`

/**
 * __useGetAssistantV2FileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetAssistantV2FileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantV2FileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantV2FileDownloadUrlQuery({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      fileID: // value for 'fileID'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetAssistantV2FileDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssistantV2FileDownloadUrlQuery,
    GetAssistantV2FileDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAssistantV2FileDownloadUrlQuery,
    GetAssistantV2FileDownloadUrlQueryVariables
  >(GetAssistantV2FileDownloadUrlDocument, options)
}
export function useGetAssistantV2FileDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssistantV2FileDownloadUrlQuery,
    GetAssistantV2FileDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAssistantV2FileDownloadUrlQuery,
    GetAssistantV2FileDownloadUrlQueryVariables
  >(GetAssistantV2FileDownloadUrlDocument, options)
}
export type GetAssistantV2FileDownloadUrlQueryHookResult = ReturnType<
  typeof useGetAssistantV2FileDownloadUrlQuery
>
export type GetAssistantV2FileDownloadUrlLazyQueryHookResult = ReturnType<
  typeof useGetAssistantV2FileDownloadUrlLazyQuery
>
export type GetAssistantV2FileDownloadUrlQueryResult = Apollo.QueryResult<
  GetAssistantV2FileDownloadUrlQuery,
  GetAssistantV2FileDownloadUrlQueryVariables
>
export const UploadAssistantV2FileDocument = /*#__PURE__*/ gql`
  mutation UploadAssistantV2File($conversationID: ID!, $file: Upload!) {
    PartnerUploadAssistantV2File(conversationID: $conversationID, file: $file) {
      id
      filename
      path
      contentType
      sizeBytes
      createdAt
    }
  }
`
export type UploadAssistantV2FileMutationFn = Apollo.MutationFunction<
  UploadAssistantV2FileMutation,
  UploadAssistantV2FileMutationVariables
>

/**
 * __useUploadAssistantV2FileMutation__
 *
 * To run a mutation, you first call `useUploadAssistantV2FileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAssistantV2FileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAssistantV2FileMutation, { data, loading, error }] = useUploadAssistantV2FileMutation({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAssistantV2FileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAssistantV2FileMutation,
    UploadAssistantV2FileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadAssistantV2FileMutation,
    UploadAssistantV2FileMutationVariables
  >(UploadAssistantV2FileDocument, options)
}
export type UploadAssistantV2FileMutationHookResult = ReturnType<
  typeof useUploadAssistantV2FileMutation
>
export type UploadAssistantV2FileMutationResult =
  Apollo.MutationResult<UploadAssistantV2FileMutation>
export type UploadAssistantV2FileMutationOptions = Apollo.BaseMutationOptions<
  UploadAssistantV2FileMutation,
  UploadAssistantV2FileMutationVariables
>
export const AssistantPageSuggestionCustomerDocument = /*#__PURE__*/ gql`
  query AssistantPageSuggestionCustomer($id: ID) {
    PartnerCustomerConnection(first: 1, filters: { customerID: $id }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

/**
 * __useAssistantPageSuggestionCustomerQuery__
 *
 * To run a query within a React component, call `useAssistantPageSuggestionCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantPageSuggestionCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantPageSuggestionCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssistantPageSuggestionCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssistantPageSuggestionCustomerQuery,
    AssistantPageSuggestionCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AssistantPageSuggestionCustomerQuery,
    AssistantPageSuggestionCustomerQueryVariables
  >(AssistantPageSuggestionCustomerDocument, options)
}
export function useAssistantPageSuggestionCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssistantPageSuggestionCustomerQuery,
    AssistantPageSuggestionCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AssistantPageSuggestionCustomerQuery,
    AssistantPageSuggestionCustomerQueryVariables
  >(AssistantPageSuggestionCustomerDocument, options)
}
export type AssistantPageSuggestionCustomerQueryHookResult = ReturnType<
  typeof useAssistantPageSuggestionCustomerQuery
>
export type AssistantPageSuggestionCustomerLazyQueryHookResult = ReturnType<
  typeof useAssistantPageSuggestionCustomerLazyQuery
>
export type AssistantPageSuggestionCustomerQueryResult = Apollo.QueryResult<
  AssistantPageSuggestionCustomerQuery,
  AssistantPageSuggestionCustomerQueryVariables
>
export const AssistantPageSuggestionInvoiceDocument = /*#__PURE__*/ gql`
  query AssistantPageSuggestionInvoice($id: String!) {
    FindInvoice(id: $id) {
      id
      invoiceNumber
      amount
      customer {
        id
        name
      }
    }
  }
`

/**
 * __useAssistantPageSuggestionInvoiceQuery__
 *
 * To run a query within a React component, call `useAssistantPageSuggestionInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantPageSuggestionInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantPageSuggestionInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssistantPageSuggestionInvoiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssistantPageSuggestionInvoiceQuery,
    AssistantPageSuggestionInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AssistantPageSuggestionInvoiceQuery,
    AssistantPageSuggestionInvoiceQueryVariables
  >(AssistantPageSuggestionInvoiceDocument, options)
}
export function useAssistantPageSuggestionInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssistantPageSuggestionInvoiceQuery,
    AssistantPageSuggestionInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AssistantPageSuggestionInvoiceQuery,
    AssistantPageSuggestionInvoiceQueryVariables
  >(AssistantPageSuggestionInvoiceDocument, options)
}
export type AssistantPageSuggestionInvoiceQueryHookResult = ReturnType<
  typeof useAssistantPageSuggestionInvoiceQuery
>
export type AssistantPageSuggestionInvoiceLazyQueryHookResult = ReturnType<
  typeof useAssistantPageSuggestionInvoiceLazyQuery
>
export type AssistantPageSuggestionInvoiceQueryResult = Apollo.QueryResult<
  AssistantPageSuggestionInvoiceQuery,
  AssistantPageSuggestionInvoiceQueryVariables
>
export const SendAssistantV2MessageDocument = /*#__PURE__*/ gql`
  subscription SendAssistantV2Message(
    $conversationID: ID!
    $content: String!
    $entityReferences: [AssistantEntityReferenceInput!]
    $invokeAgents: [String!]
  ) {
    PartnerSendAssistantV2Message(
      conversationID: $conversationID
      content: $content
      entityReferences: $entityReferences
      invokeAgents: $invokeAgents
    ) {
      ... on AssistantV2RawEvent {
        __typename
        eventType
        data
      }
      ... on AssistantConfirmationRequiredEvent {
        __typename
        token
        toolName
        toolInput
        summary
        description
      }
      ... on AssistantConfirmationOutcomeEvent {
        __typename
        token
        toolName
        outcome
      }
    }
  }
`

/**
 * __useSendAssistantV2MessageSubscription__
 *
 * To run a query within a React component, call `useSendAssistantV2MessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSendAssistantV2MessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendAssistantV2MessageSubscription({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      content: // value for 'content'
 *      entityReferences: // value for 'entityReferences'
 *      invokeAgents: // value for 'invokeAgents'
 *   },
 * });
 */
export function useSendAssistantV2MessageSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SendAssistantV2MessageSubscription,
    SendAssistantV2MessageSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    SendAssistantV2MessageSubscription,
    SendAssistantV2MessageSubscriptionVariables
  >(SendAssistantV2MessageDocument, options)
}
export type SendAssistantV2MessageSubscriptionHookResult = ReturnType<
  typeof useSendAssistantV2MessageSubscription
>
export type SendAssistantV2MessageSubscriptionResult =
  Apollo.SubscriptionResult<SendAssistantV2MessageSubscription>
export const ReattachAssistantV2MessageDocument = /*#__PURE__*/ gql`
  subscription ReattachAssistantV2Message(
    $conversationID: ID!
    $since: String
  ) {
    PartnerReattachAssistantV2Message(
      conversationID: $conversationID
      since: $since
    ) {
      ... on AssistantV2RawEvent {
        __typename
        eventType
        data
      }
      ... on AssistantConfirmationRequiredEvent {
        __typename
        token
        toolName
        toolInput
        summary
        description
      }
      ... on AssistantConfirmationOutcomeEvent {
        __typename
        token
        toolName
        outcome
      }
    }
  }
`

/**
 * __useReattachAssistantV2MessageSubscription__
 *
 * To run a query within a React component, call `useReattachAssistantV2MessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReattachAssistantV2MessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReattachAssistantV2MessageSubscription({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useReattachAssistantV2MessageSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ReattachAssistantV2MessageSubscription,
    ReattachAssistantV2MessageSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    ReattachAssistantV2MessageSubscription,
    ReattachAssistantV2MessageSubscriptionVariables
  >(ReattachAssistantV2MessageDocument, options)
}
export type ReattachAssistantV2MessageSubscriptionHookResult = ReturnType<
  typeof useReattachAssistantV2MessageSubscription
>
export type ReattachAssistantV2MessageSubscriptionResult =
  Apollo.SubscriptionResult<ReattachAssistantV2MessageSubscription>
export const OAuth2UrlDocument = /*#__PURE__*/ gql`
  query OAuth2Url($referralID: ID, $redirectUri: String) {
    OAuth2Url(referralID: $referralID, redirectUri: $redirectUri)
  }
`

/**
 * __useOAuth2UrlQuery__
 *
 * To run a query within a React component, call `useOAuth2UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuth2UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuth2UrlQuery({
 *   variables: {
 *      referralID: // value for 'referralID'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useOAuth2UrlQuery(
  baseOptions?: Apollo.QueryHookOptions<OAuth2UrlQuery, OAuth2UrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OAuth2UrlQuery, OAuth2UrlQueryVariables>(
    OAuth2UrlDocument,
    options
  )
}
export function useOAuth2UrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuth2UrlQuery,
    OAuth2UrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OAuth2UrlQuery, OAuth2UrlQueryVariables>(
    OAuth2UrlDocument,
    options
  )
}
export type OAuth2UrlQueryHookResult = ReturnType<typeof useOAuth2UrlQuery>
export type OAuth2UrlLazyQueryHookResult = ReturnType<
  typeof useOAuth2UrlLazyQuery
>
export type OAuth2UrlQueryResult = Apollo.QueryResult<
  OAuth2UrlQuery,
  OAuth2UrlQueryVariables
>
export const OAuth2ExchangeDocument = /*#__PURE__*/ gql`
  mutation OAuth2Exchange(
    $code: String!
    $state: String!
    $redirectUri: String
  ) {
    OAuth2Exchange(code: $code, state: $state, redirectUri: $redirectUri) {
      ...Token
    }
  }
  ${TokenFragmentDoc}
`
export type OAuth2ExchangeMutationFn = Apollo.MutationFunction<
  OAuth2ExchangeMutation,
  OAuth2ExchangeMutationVariables
>

/**
 * __useOAuth2ExchangeMutation__
 *
 * To run a mutation, you first call `useOAuth2ExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuth2ExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuth2ExchangeMutation, { data, loading, error }] = useOAuth2ExchangeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useOAuth2ExchangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OAuth2ExchangeMutation,
    OAuth2ExchangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OAuth2ExchangeMutation,
    OAuth2ExchangeMutationVariables
  >(OAuth2ExchangeDocument, options)
}
export type OAuth2ExchangeMutationHookResult = ReturnType<
  typeof useOAuth2ExchangeMutation
>
export type OAuth2ExchangeMutationResult =
  Apollo.MutationResult<OAuth2ExchangeMutation>
export type OAuth2ExchangeMutationOptions = Apollo.BaseMutationOptions<
  OAuth2ExchangeMutation,
  OAuth2ExchangeMutationVariables
>
export const OAuth2RefreshDocument = /*#__PURE__*/ gql`
  mutation OAuth2Refresh($refreshToken: String!) {
    OAuth2Refresh(refreshToken: $refreshToken) {
      ...Token
    }
  }
  ${TokenFragmentDoc}
`
export type OAuth2RefreshMutationFn = Apollo.MutationFunction<
  OAuth2RefreshMutation,
  OAuth2RefreshMutationVariables
>

/**
 * __useOAuth2RefreshMutation__
 *
 * To run a mutation, you first call `useOAuth2RefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuth2RefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuth2RefreshMutation, { data, loading, error }] = useOAuth2RefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useOAuth2RefreshMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OAuth2RefreshMutation,
    OAuth2RefreshMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OAuth2RefreshMutation,
    OAuth2RefreshMutationVariables
  >(OAuth2RefreshDocument, options)
}
export type OAuth2RefreshMutationHookResult = ReturnType<
  typeof useOAuth2RefreshMutation
>
export type OAuth2RefreshMutationResult =
  Apollo.MutationResult<OAuth2RefreshMutation>
export type OAuth2RefreshMutationOptions = Apollo.BaseMutationOptions<
  OAuth2RefreshMutation,
  OAuth2RefreshMutationVariables
>
export const PartnerListAutopayExcludedInvoicesDocument = /*#__PURE__*/ gql`
  query PartnerListAutopayExcludedInvoices($invoiceIDs: [ID!]) {
    PartnerListAutopayExcludedInvoices(invoiceIDs: $invoiceIDs) {
      invoiceID
      excludedBy
    }
  }
`

/**
 * __usePartnerListAutopayExcludedInvoicesQuery__
 *
 * To run a query within a React component, call `usePartnerListAutopayExcludedInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAutopayExcludedInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAutopayExcludedInvoicesQuery({
 *   variables: {
 *      invoiceIDs: // value for 'invoiceIDs'
 *   },
 * });
 */
export function usePartnerListAutopayExcludedInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >(PartnerListAutopayExcludedInvoicesDocument, options)
}
export function usePartnerListAutopayExcludedInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >(PartnerListAutopayExcludedInvoicesDocument, options)
}
export type PartnerListAutopayExcludedInvoicesQueryHookResult = ReturnType<
  typeof usePartnerListAutopayExcludedInvoicesQuery
>
export type PartnerListAutopayExcludedInvoicesLazyQueryHookResult = ReturnType<
  typeof usePartnerListAutopayExcludedInvoicesLazyQuery
>
export type PartnerListAutopayExcludedInvoicesQueryResult = Apollo.QueryResult<
  PartnerListAutopayExcludedInvoicesQuery,
  PartnerListAutopayExcludedInvoicesQueryVariables
>
export const FindAutopayRuleDocument = /*#__PURE__*/ gql`
  query FindAutopayRule($id: ID!) {
    FindAutopayRule(id: $id) {
      ...FindAutopayRule
    }
  }
  ${FindAutopayRuleFragmentDoc}
`

/**
 * __useFindAutopayRuleQuery__
 *
 * To run a query within a React component, call `useFindAutopayRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAutopayRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAutopayRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindAutopayRuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindAutopayRuleQuery,
    FindAutopayRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FindAutopayRuleQuery, FindAutopayRuleQueryVariables>(
    FindAutopayRuleDocument,
    options
  )
}
export function useFindAutopayRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindAutopayRuleQuery,
    FindAutopayRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindAutopayRuleQuery,
    FindAutopayRuleQueryVariables
  >(FindAutopayRuleDocument, options)
}
export type FindAutopayRuleQueryHookResult = ReturnType<
  typeof useFindAutopayRuleQuery
>
export type FindAutopayRuleLazyQueryHookResult = ReturnType<
  typeof useFindAutopayRuleLazyQuery
>
export type FindAutopayRuleQueryResult = Apollo.QueryResult<
  FindAutopayRuleQuery,
  FindAutopayRuleQueryVariables
>
export const PartnerAutopayExcludedInvoiceDeleteDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedInvoiceDelete($invoiceID: ID!) {
    PartnerAutopayExcludedInvoiceDelete(invoiceID: $invoiceID)
  }
`
export type PartnerAutopayExcludedInvoiceDeleteMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >

/**
 * __usePartnerAutopayExcludedInvoiceDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedInvoiceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedInvoiceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedInvoiceDeleteMutation, { data, loading, error }] = usePartnerAutopayExcludedInvoiceDeleteMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedInvoiceDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >(PartnerAutopayExcludedInvoiceDeleteDocument, options)
}
export type PartnerAutopayExcludedInvoiceDeleteMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedInvoiceDeleteMutation
>
export type PartnerAutopayExcludedInvoiceDeleteMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedInvoiceDeleteMutation>
export type PartnerAutopayExcludedInvoiceDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >
export const PartnerAutopayExcludedInvoiceCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedInvoiceCreate(
    $customerID: ID!
    $invoiceID: ID!
  ) {
    PartnerAutopayExcludedInvoiceCreate(
      customerID: $customerID
      invoiceID: $invoiceID
    )
  }
`
export type PartnerAutopayExcludedInvoiceCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedInvoiceCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedInvoiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedInvoiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedInvoiceCreateMutation, { data, loading, error }] = usePartnerAutopayExcludedInvoiceCreateMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedInvoiceCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >(PartnerAutopayExcludedInvoiceCreateDocument, options)
}
export type PartnerAutopayExcludedInvoiceCreateMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedInvoiceCreateMutation
>
export type PartnerAutopayExcludedInvoiceCreateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedInvoiceCreateMutation>
export type PartnerAutopayExcludedInvoiceCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >
export const PartnerAutopayExcludedInvoiceBatchCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedInvoiceBatchCreate(
    $invoices: [AutopayExcludedInvoiceCreateInput!]!
  ) {
    PartnerAutopayExcludedInvoiceBatchCreate(excludeInvoices: $invoices)
  }
`
export type PartnerAutopayExcludedInvoiceBatchCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedInvoiceBatchCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedInvoiceBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedInvoiceBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedInvoiceBatchCreateMutation, { data, loading, error }] = usePartnerAutopayExcludedInvoiceBatchCreateMutation({
 *   variables: {
 *      invoices: // value for 'invoices'
 *   },
 * });
 */
export function usePartnerAutopayExcludedInvoiceBatchCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >(PartnerAutopayExcludedInvoiceBatchCreateDocument, options)
}
export type PartnerAutopayExcludedInvoiceBatchCreateMutationHookResult =
  ReturnType<typeof usePartnerAutopayExcludedInvoiceBatchCreateMutation>
export type PartnerAutopayExcludedInvoiceBatchCreateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedInvoiceBatchCreateMutation>
export type PartnerAutopayExcludedInvoiceBatchCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >
export const PartnerGetCoveredInvoicesForRuleDocument = /*#__PURE__*/ gql`
  query PartnerGetCoveredInvoicesForRule(
    $input: PartnerGetCoveredInvoicesForRuleInput!
  ) {
    PartnerGetCoveredInvoicesForRule(input: $input) {
      ...InvoiceCovered
    }
  }
  ${InvoiceCoveredFragmentDoc}
`

/**
 * __usePartnerGetCoveredInvoicesForRuleQuery__
 *
 * To run a query within a React component, call `usePartnerGetCoveredInvoicesForRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCoveredInvoicesForRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCoveredInvoicesForRuleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetCoveredInvoicesForRuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >(PartnerGetCoveredInvoicesForRuleDocument, options)
}
export function usePartnerGetCoveredInvoicesForRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >(PartnerGetCoveredInvoicesForRuleDocument, options)
}
export type PartnerGetCoveredInvoicesForRuleQueryHookResult = ReturnType<
  typeof usePartnerGetCoveredInvoicesForRuleQuery
>
export type PartnerGetCoveredInvoicesForRuleLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCoveredInvoicesForRuleLazyQuery
>
export type PartnerGetCoveredInvoicesForRuleQueryResult = Apollo.QueryResult<
  PartnerGetCoveredInvoicesForRuleQuery,
  PartnerGetCoveredInvoicesForRuleQueryVariables
>
export const PartnerGlobalAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query PartnerGlobalAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerGlobalAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRules
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesFragmentDoc}
`

/**
 * __usePartnerGlobalAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerGlobalAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGlobalAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGlobalAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerGlobalAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >(PartnerGlobalAutopayRuleConnectionDocument, options)
}
export function usePartnerGlobalAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >(PartnerGlobalAutopayRuleConnectionDocument, options)
}
export type PartnerGlobalAutopayRuleConnectionQueryHookResult = ReturnType<
  typeof usePartnerGlobalAutopayRuleConnectionQuery
>
export type PartnerGlobalAutopayRuleConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerGlobalAutopayRuleConnectionLazyQuery
>
export type PartnerGlobalAutopayRuleConnectionQueryResult = Apollo.QueryResult<
  PartnerGlobalAutopayRuleConnectionQuery,
  PartnerGlobalAutopayRuleConnectionQueryVariables
>
export const PartnerCustomerAutopayRuleWithBankingAndCardConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerAutopayRuleWithBankingAndCardConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayRuleFilter
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerCustomerAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRulesWithBankingAndCard
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesWithBankingAndCardFragmentDoc}
`

/**
 * __usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >(PartnerCustomerAutopayRuleWithBankingAndCardConnectionDocument, options)
}
export function usePartnerCustomerAutopayRuleWithBankingAndCardConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >(PartnerCustomerAutopayRuleWithBankingAndCardConnectionDocument, options)
}
export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryHookResult =
  ReturnType<
    typeof usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery
  >
export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionLazyQueryHookResult =
  ReturnType<
    typeof usePartnerCustomerAutopayRuleWithBankingAndCardConnectionLazyQuery
  >
export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >
export const PartnerCustomerAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayRuleFilter
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerCustomerAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRules
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesFragmentDoc}
`

/**
 * __usePartnerCustomerAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >(PartnerCustomerAutopayRuleConnectionDocument, options)
}
export function usePartnerCustomerAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >(PartnerCustomerAutopayRuleConnectionDocument, options)
}
export type PartnerCustomerAutopayRuleConnectionQueryHookResult = ReturnType<
  typeof usePartnerCustomerAutopayRuleConnectionQuery
>
export type PartnerCustomerAutopayRuleConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerAutopayRuleConnectionLazyQuery>
export type PartnerCustomerAutopayRuleConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >
export const PartnerCustomerTagsAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerTagsAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayRuleFilter
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerCustomerTagsAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRules
          tagIDs
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesFragmentDoc}
`

/**
 * __usePartnerCustomerTagsAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerTagsAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerTagsAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerTagsAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerTagsAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >(PartnerCustomerTagsAutopayRuleConnectionDocument, options)
}
export function usePartnerCustomerTagsAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >(PartnerCustomerTagsAutopayRuleConnectionDocument, options)
}
export type PartnerCustomerTagsAutopayRuleConnectionQueryHookResult =
  ReturnType<typeof usePartnerCustomerTagsAutopayRuleConnectionQuery>
export type PartnerCustomerTagsAutopayRuleConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerTagsAutopayRuleConnectionLazyQuery>
export type PartnerCustomerTagsAutopayRuleConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >
export const PartnerListCustomerRulesTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerRulesTotals($customerID: ID) {
    PartnerListCustomerRulesTotals(customerID: $customerID) {
      count
    }
  }
`

/**
 * __usePartnerListCustomerRulesTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerRulesTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerRulesTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerRulesTotalsQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerListCustomerRulesTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >(PartnerListCustomerRulesTotalsDocument, options)
}
export function usePartnerListCustomerRulesTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >(PartnerListCustomerRulesTotalsDocument, options)
}
export type PartnerListCustomerRulesTotalsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerRulesTotalsQuery
>
export type PartnerListCustomerRulesTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerRulesTotalsLazyQuery
>
export type PartnerListCustomerRulesTotalsQueryResult = Apollo.QueryResult<
  PartnerListCustomerRulesTotalsQuery,
  PartnerListCustomerRulesTotalsQueryVariables
>
export const PartnerAutopayExcludedCustomerConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAutopayExcludedCustomerConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayExcludedCustomerFilter
    $orderBy: AutopayExcludedCustomerOrderBy
  ) {
    PartnerAutopayExcludedCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayExcludedList
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayExcludedListFragmentDoc}
`

/**
 * __usePartnerAutopayExcludedCustomerConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAutopayExcludedCustomerConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutopayExcludedCustomerConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >(PartnerAutopayExcludedCustomerConnectionDocument, options)
}
export function usePartnerAutopayExcludedCustomerConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >(PartnerAutopayExcludedCustomerConnectionDocument, options)
}
export type PartnerAutopayExcludedCustomerConnectionQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerConnectionQuery>
export type PartnerAutopayExcludedCustomerConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerConnectionLazyQuery>
export type PartnerAutopayExcludedCustomerConnectionQueryResult =
  Apollo.QueryResult<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >
export const PartnerAutopayExcludedCustomerListTotalsDocument = /*#__PURE__*/ gql`
  query PartnerAutopayExcludedCustomerListTotals(
    $filters: AutopayExcludedCustomerFilter
  ) {
    PartnerAutopayExcludedCustomerListTotals(filters: $filters) {
      count
    }
  }
`

/**
 * __usePartnerAutopayExcludedCustomerListTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerAutopayExcludedCustomerListTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerListTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutopayExcludedCustomerListTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerListTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >(PartnerAutopayExcludedCustomerListTotalsDocument, options)
}
export function usePartnerAutopayExcludedCustomerListTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >(PartnerAutopayExcludedCustomerListTotalsDocument, options)
}
export type PartnerAutopayExcludedCustomerListTotalsQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerListTotalsQuery>
export type PartnerAutopayExcludedCustomerListTotalsLazyQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerListTotalsLazyQuery>
export type PartnerAutopayExcludedCustomerListTotalsQueryResult =
  Apollo.QueryResult<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >
export const PartnerCreateAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateAutopayRule($input: PartnerCreateAutopayRuleInput!) {
    PartnerCreateAutopayRule(input: $input) {
      ...AutopayRules
    }
  }
  ${AutopayRulesFragmentDoc}
`
export type PartnerCreateAutopayRuleMutationFn = Apollo.MutationFunction<
  PartnerCreateAutopayRuleMutation,
  PartnerCreateAutopayRuleMutationVariables
>

/**
 * __usePartnerCreateAutopayRuleMutation__
 *
 * To run a mutation, you first call `usePartnerCreateAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateAutopayRuleMutation, { data, loading, error }] = usePartnerCreateAutopayRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateAutopayRuleMutation,
    PartnerCreateAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateAutopayRuleMutation,
    PartnerCreateAutopayRuleMutationVariables
  >(PartnerCreateAutopayRuleDocument, options)
}
export type PartnerCreateAutopayRuleMutationHookResult = ReturnType<
  typeof usePartnerCreateAutopayRuleMutation
>
export type PartnerCreateAutopayRuleMutationResult =
  Apollo.MutationResult<PartnerCreateAutopayRuleMutation>
export type PartnerCreateAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateAutopayRuleMutation,
    PartnerCreateAutopayRuleMutationVariables
  >
export const PartnerUpdateAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateAutopayRule($input: PartnerUpdateAutopayRuleInput!) {
    PartnerUpdateAutopayRule(input: $input) {
      ...AutopayRules
    }
  }
  ${AutopayRulesFragmentDoc}
`
export type PartnerUpdateAutopayRuleMutationFn = Apollo.MutationFunction<
  PartnerUpdateAutopayRuleMutation,
  PartnerUpdateAutopayRuleMutationVariables
>

/**
 * __usePartnerUpdateAutopayRuleMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateAutopayRuleMutation, { data, loading, error }] = usePartnerUpdateAutopayRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateAutopayRuleMutation,
    PartnerUpdateAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateAutopayRuleMutation,
    PartnerUpdateAutopayRuleMutationVariables
  >(PartnerUpdateAutopayRuleDocument, options)
}
export type PartnerUpdateAutopayRuleMutationHookResult = ReturnType<
  typeof usePartnerUpdateAutopayRuleMutation
>
export type PartnerUpdateAutopayRuleMutationResult =
  Apollo.MutationResult<PartnerUpdateAutopayRuleMutation>
export type PartnerUpdateAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateAutopayRuleMutation,
    PartnerUpdateAutopayRuleMutationVariables
  >
export const PartnerDeleteAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteAutopayRule($id: ID!) {
    PartnerDeleteAutopayRule(id: $id)
  }
`
export type PartnerDeleteAutopayRuleMutationFn = Apollo.MutationFunction<
  PartnerDeleteAutopayRuleMutation,
  PartnerDeleteAutopayRuleMutationVariables
>

/**
 * __usePartnerDeleteAutopayRuleMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteAutopayRuleMutation, { data, loading, error }] = usePartnerDeleteAutopayRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteAutopayRuleMutation,
    PartnerDeleteAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteAutopayRuleMutation,
    PartnerDeleteAutopayRuleMutationVariables
  >(PartnerDeleteAutopayRuleDocument, options)
}
export type PartnerDeleteAutopayRuleMutationHookResult = ReturnType<
  typeof usePartnerDeleteAutopayRuleMutation
>
export type PartnerDeleteAutopayRuleMutationResult =
  Apollo.MutationResult<PartnerDeleteAutopayRuleMutation>
export type PartnerDeleteAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteAutopayRuleMutation,
    PartnerDeleteAutopayRuleMutationVariables
  >
export const PartnerAutopayExcludedCustomerCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedCustomerCreate($customerID: ID!) {
    PartnerAutopayExcludedCustomerCreate(customerID: $customerID) {
      id
      customer {
        id
        name
      }
    }
  }
`
export type PartnerAutopayExcludedCustomerCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedCustomerCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedCustomerCreateMutation, { data, loading, error }] = usePartnerAutopayExcludedCustomerCreateMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >(PartnerAutopayExcludedCustomerCreateDocument, options)
}
export type PartnerAutopayExcludedCustomerCreateMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedCustomerCreateMutation
>
export type PartnerAutopayExcludedCustomerCreateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedCustomerCreateMutation>
export type PartnerAutopayExcludedCustomerCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >
export const PartnerAutopayExcludedCustomerUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedCustomerUpdate($customerIDs: [ID!]) {
    PartnerAutopayExcludedCustomerUpdate(customerIDs: $customerIDs) {
      id
      customer {
        id
        name
      }
    }
  }
`
export type PartnerAutopayExcludedCustomerUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedCustomerUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedCustomerUpdateMutation, { data, loading, error }] = usePartnerAutopayExcludedCustomerUpdateMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >(PartnerAutopayExcludedCustomerUpdateDocument, options)
}
export type PartnerAutopayExcludedCustomerUpdateMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedCustomerUpdateMutation
>
export type PartnerAutopayExcludedCustomerUpdateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedCustomerUpdateMutation>
export type PartnerAutopayExcludedCustomerUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >
export const PartnerAutopayExcludedCustomerDeleteDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedCustomerDelete($customerID: ID!) {
    PartnerAutopayExcludedCustomerDelete(customerID: $customerID)
  }
`
export type PartnerAutopayExcludedCustomerDeleteMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >

/**
 * __usePartnerAutopayExcludedCustomerDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedCustomerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedCustomerDeleteMutation, { data, loading, error }] = usePartnerAutopayExcludedCustomerDeleteMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >(PartnerAutopayExcludedCustomerDeleteDocument, options)
}
export type PartnerAutopayExcludedCustomerDeleteMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedCustomerDeleteMutation
>
export type PartnerAutopayExcludedCustomerDeleteMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedCustomerDeleteMutation>
export type PartnerAutopayExcludedCustomerDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >
export const GetCustomerAutopayConfigDocument = /*#__PURE__*/ gql`
  query GetCustomerAutopayConfig($input: GetCustomerAutopayConfigInput!) {
    GetCustomerAutopayConfig(input: $input) {
      ...CustomerAutopayConfig
    }
  }
  ${CustomerAutopayConfigFragmentDoc}
`

/**
 * __useGetCustomerAutopayConfigQuery__
 *
 * To run a query within a React component, call `useGetCustomerAutopayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAutopayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAutopayConfigQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomerAutopayConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >(GetCustomerAutopayConfigDocument, options)
}
export function useGetCustomerAutopayConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >(GetCustomerAutopayConfigDocument, options)
}
export type GetCustomerAutopayConfigQueryHookResult = ReturnType<
  typeof useGetCustomerAutopayConfigQuery
>
export type GetCustomerAutopayConfigLazyQueryHookResult = ReturnType<
  typeof useGetCustomerAutopayConfigLazyQuery
>
export type GetCustomerAutopayConfigQueryResult = Apollo.QueryResult<
  GetCustomerAutopayConfigQuery,
  GetCustomerAutopayConfigQueryVariables
>
export const SetCustomerAutopayConfigDocument = /*#__PURE__*/ gql`
  mutation SetCustomerAutopayConfig($input: UpsertCustomerAutopayConfigInput!) {
    SetCustomerAutopayConfig(input: $input)
  }
`
export type SetCustomerAutopayConfigMutationFn = Apollo.MutationFunction<
  SetCustomerAutopayConfigMutation,
  SetCustomerAutopayConfigMutationVariables
>

/**
 * __useSetCustomerAutopayConfigMutation__
 *
 * To run a mutation, you first call `useSetCustomerAutopayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerAutopayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerAutopayConfigMutation, { data, loading, error }] = useSetCustomerAutopayConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomerAutopayConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCustomerAutopayConfigMutation,
    SetCustomerAutopayConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetCustomerAutopayConfigMutation,
    SetCustomerAutopayConfigMutationVariables
  >(SetCustomerAutopayConfigDocument, options)
}
export type SetCustomerAutopayConfigMutationHookResult = ReturnType<
  typeof useSetCustomerAutopayConfigMutation
>
export type SetCustomerAutopayConfigMutationResult =
  Apollo.MutationResult<SetCustomerAutopayConfigMutation>
export type SetCustomerAutopayConfigMutationOptions =
  Apollo.BaseMutationOptions<
    SetCustomerAutopayConfigMutation,
    SetCustomerAutopayConfigMutationVariables
  >
export const PartnerInvoiceBnplConnectionDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceBnplConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: BnplFilter
  ) {
    PartnerInvoiceBnplConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          ...PartnerCustomerBNPL
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerBnplFragmentDoc}
`

/**
 * __usePartnerInvoiceBnplConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceBnplConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceBnplConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceBnplConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerInvoiceBnplConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >(PartnerInvoiceBnplConnectionDocument, options)
}
export function usePartnerInvoiceBnplConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >(PartnerInvoiceBnplConnectionDocument, options)
}
export type PartnerInvoiceBnplConnectionQueryHookResult = ReturnType<
  typeof usePartnerInvoiceBnplConnectionQuery
>
export type PartnerInvoiceBnplConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceBnplConnectionLazyQuery
>
export type PartnerInvoiceBnplConnectionQueryResult = Apollo.QueryResult<
  PartnerInvoiceBnplConnectionQuery,
  PartnerInvoiceBnplConnectionQueryVariables
>
export const BnplOfferConfirmByTokenDocument = /*#__PURE__*/ gql`
  mutation BNPLOfferConfirmByToken($confirmationToken: String!) {
    BNPLOfferConfirmByToken(confirmationToken: $confirmationToken)
  }
`
export type BnplOfferConfirmByTokenMutationFn = Apollo.MutationFunction<
  BnplOfferConfirmByTokenMutation,
  BnplOfferConfirmByTokenMutationVariables
>

/**
 * __useBnplOfferConfirmByTokenMutation__
 *
 * To run a mutation, you first call `useBnplOfferConfirmByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBnplOfferConfirmByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bnplOfferConfirmByTokenMutation, { data, loading, error }] = useBnplOfferConfirmByTokenMutation({
 *   variables: {
 *      confirmationToken: // value for 'confirmationToken'
 *   },
 * });
 */
export function useBnplOfferConfirmByTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BnplOfferConfirmByTokenMutation,
    BnplOfferConfirmByTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BnplOfferConfirmByTokenMutation,
    BnplOfferConfirmByTokenMutationVariables
  >(BnplOfferConfirmByTokenDocument, options)
}
export type BnplOfferConfirmByTokenMutationHookResult = ReturnType<
  typeof useBnplOfferConfirmByTokenMutation
>
export type BnplOfferConfirmByTokenMutationResult =
  Apollo.MutationResult<BnplOfferConfirmByTokenMutation>
export type BnplOfferConfirmByTokenMutationOptions = Apollo.BaseMutationOptions<
  BnplOfferConfirmByTokenMutation,
  BnplOfferConfirmByTokenMutationVariables
>
export const PartnerBnplOfferConfirmDocument = /*#__PURE__*/ gql`
  mutation PartnerBNPLOfferConfirm($id: ID!) {
    PartnerBNPLOfferConfirm(id: $id)
  }
`
export type PartnerBnplOfferConfirmMutationFn = Apollo.MutationFunction<
  PartnerBnplOfferConfirmMutation,
  PartnerBnplOfferConfirmMutationVariables
>

/**
 * __usePartnerBnplOfferConfirmMutation__
 *
 * To run a mutation, you first call `usePartnerBnplOfferConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBnplOfferConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBnplOfferConfirmMutation, { data, loading, error }] = usePartnerBnplOfferConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerBnplOfferConfirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBnplOfferConfirmMutation,
    PartnerBnplOfferConfirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBnplOfferConfirmMutation,
    PartnerBnplOfferConfirmMutationVariables
  >(PartnerBnplOfferConfirmDocument, options)
}
export type PartnerBnplOfferConfirmMutationHookResult = ReturnType<
  typeof usePartnerBnplOfferConfirmMutation
>
export type PartnerBnplOfferConfirmMutationResult =
  Apollo.MutationResult<PartnerBnplOfferConfirmMutation>
export type PartnerBnplOfferConfirmMutationOptions = Apollo.BaseMutationOptions<
  PartnerBnplOfferConfirmMutation,
  PartnerBnplOfferConfirmMutationVariables
>
export const PartnerChangeReferralPayoutBankingAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeReferralPayoutBankingAccount(
    $input: PartnerDefaultPayoutBankingAccountUpdateInput!
  ) {
    PartnerChangeReferralPayoutBankingAccount(input: $input)
  }
`
export type PartnerChangeReferralPayoutBankingAccountMutationFn =
  Apollo.MutationFunction<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >

/**
 * __usePartnerChangeReferralPayoutBankingAccountMutation__
 *
 * To run a mutation, you first call `usePartnerChangeReferralPayoutBankingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeReferralPayoutBankingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeReferralPayoutBankingAccountMutation, { data, loading, error }] = usePartnerChangeReferralPayoutBankingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerChangeReferralPayoutBankingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >(PartnerChangeReferralPayoutBankingAccountDocument, options)
}
export type PartnerChangeReferralPayoutBankingAccountMutationHookResult =
  ReturnType<typeof usePartnerChangeReferralPayoutBankingAccountMutation>
export type PartnerChangeReferralPayoutBankingAccountMutationResult =
  Apollo.MutationResult<PartnerChangeReferralPayoutBankingAccountMutation>
export type PartnerChangeReferralPayoutBankingAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >
export const PartnerListBankingIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListBankingIntegrations {
    PartnerListBankingIntegrations {
      ...Bank
    }
  }
  ${BankFragmentDoc}
`

/**
 * __usePartnerListBankingIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListBankingIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListBankingIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListBankingIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListBankingIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >(PartnerListBankingIntegrationsDocument, options)
}
export function usePartnerListBankingIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >(PartnerListBankingIntegrationsDocument, options)
}
export type PartnerListBankingIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListBankingIntegrationsQuery
>
export type PartnerListBankingIntegrationsLazyQueryHookResult = ReturnType<
  typeof usePartnerListBankingIntegrationsLazyQuery
>
export type PartnerListBankingIntegrationsQueryResult = Apollo.QueryResult<
  PartnerListBankingIntegrationsQuery,
  PartnerListBankingIntegrationsQueryVariables
>
export const PartnerListBankingIntegrationsWithVerificationDocument = /*#__PURE__*/ gql`
  query PartnerListBankingIntegrationsWithVerification {
    PartnerListBankingIntegrations {
      ...BankWithVerification
    }
  }
  ${BankWithVerificationFragmentDoc}
`

/**
 * __usePartnerListBankingIntegrationsWithVerificationQuery__
 *
 * To run a query within a React component, call `usePartnerListBankingIntegrationsWithVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListBankingIntegrationsWithVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListBankingIntegrationsWithVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListBankingIntegrationsWithVerificationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListBankingIntegrationsWithVerificationQuery,
    PartnerListBankingIntegrationsWithVerificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListBankingIntegrationsWithVerificationQuery,
    PartnerListBankingIntegrationsWithVerificationQueryVariables
  >(PartnerListBankingIntegrationsWithVerificationDocument, options)
}
export function usePartnerListBankingIntegrationsWithVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListBankingIntegrationsWithVerificationQuery,
    PartnerListBankingIntegrationsWithVerificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListBankingIntegrationsWithVerificationQuery,
    PartnerListBankingIntegrationsWithVerificationQueryVariables
  >(PartnerListBankingIntegrationsWithVerificationDocument, options)
}
export type PartnerListBankingIntegrationsWithVerificationQueryHookResult =
  ReturnType<typeof usePartnerListBankingIntegrationsWithVerificationQuery>
export type PartnerListBankingIntegrationsWithVerificationLazyQueryHookResult =
  ReturnType<typeof usePartnerListBankingIntegrationsWithVerificationLazyQuery>
export type PartnerListBankingIntegrationsWithVerificationQueryResult =
  Apollo.QueryResult<
    PartnerListBankingIntegrationsWithVerificationQuery,
    PartnerListBankingIntegrationsWithVerificationQueryVariables
  >
export const PartnerListCustomerBankingIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerBankingIntegrations($customerID: String!) {
    PartnerListCustomerBankingIntegrations(customerID: $customerID) {
      ...Bank
    }
  }
  ${BankFragmentDoc}
`

/**
 * __usePartnerListCustomerBankingIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerBankingIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerBankingIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerBankingIntegrationsQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerListCustomerBankingIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >(PartnerListCustomerBankingIntegrationsDocument, options)
}
export function usePartnerListCustomerBankingIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >(PartnerListCustomerBankingIntegrationsDocument, options)
}
export type PartnerListCustomerBankingIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerBankingIntegrationsQuery
>
export type PartnerListCustomerBankingIntegrationsLazyQueryHookResult =
  ReturnType<typeof usePartnerListCustomerBankingIntegrationsLazyQuery>
export type PartnerListCustomerBankingIntegrationsQueryResult =
  Apollo.QueryResult<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >
export const PartnerArchiveAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerArchiveAccount($accountID: ID!) {
    PartnerArchiveAccount(accountID: $accountID)
  }
`
export type PartnerArchiveAccountMutationFn = Apollo.MutationFunction<
  PartnerArchiveAccountMutation,
  PartnerArchiveAccountMutationVariables
>

/**
 * __usePartnerArchiveAccountMutation__
 *
 * To run a mutation, you first call `usePartnerArchiveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerArchiveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerArchiveAccountMutation, { data, loading, error }] = usePartnerArchiveAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function usePartnerArchiveAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerArchiveAccountMutation,
    PartnerArchiveAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerArchiveAccountMutation,
    PartnerArchiveAccountMutationVariables
  >(PartnerArchiveAccountDocument, options)
}
export type PartnerArchiveAccountMutationHookResult = ReturnType<
  typeof usePartnerArchiveAccountMutation
>
export type PartnerArchiveAccountMutationResult =
  Apollo.MutationResult<PartnerArchiveAccountMutation>
export type PartnerArchiveAccountMutationOptions = Apollo.BaseMutationOptions<
  PartnerArchiveAccountMutation,
  PartnerArchiveAccountMutationVariables
>
export const PartnerAddManualBankingConnectionDocument = /*#__PURE__*/ gql`
  mutation PartnerAddManualBankingConnection(
    $accountInformation: ManualBankingAccountInformationInput!
  ) {
    PartnerAddManualBankingConnection(accountInformation: $accountInformation)
  }
`
export type PartnerAddManualBankingConnectionMutationFn =
  Apollo.MutationFunction<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >

/**
 * __usePartnerAddManualBankingConnectionMutation__
 *
 * To run a mutation, you first call `usePartnerAddManualBankingConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddManualBankingConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddManualBankingConnectionMutation, { data, loading, error }] = usePartnerAddManualBankingConnectionMutation({
 *   variables: {
 *      accountInformation: // value for 'accountInformation'
 *   },
 * });
 */
export function usePartnerAddManualBankingConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >(PartnerAddManualBankingConnectionDocument, options)
}
export type PartnerAddManualBankingConnectionMutationHookResult = ReturnType<
  typeof usePartnerAddManualBankingConnectionMutation
>
export type PartnerAddManualBankingConnectionMutationResult =
  Apollo.MutationResult<PartnerAddManualBankingConnectionMutation>
export type PartnerAddManualBankingConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >
export const PartnerAddManualBankingConnectionV2Document = /*#__PURE__*/ gql`
  mutation PartnerAddManualBankingConnectionV2(
    $accountInformation: ManualBankingAccountInformationInput!
  ) {
    PartnerAddManualBankingConnectionV2(
      accountInformation: $accountInformation
    ) {
      id
    }
  }
`
export type PartnerAddManualBankingConnectionV2MutationFn =
  Apollo.MutationFunction<
    PartnerAddManualBankingConnectionV2Mutation,
    PartnerAddManualBankingConnectionV2MutationVariables
  >

/**
 * __usePartnerAddManualBankingConnectionV2Mutation__
 *
 * To run a mutation, you first call `usePartnerAddManualBankingConnectionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddManualBankingConnectionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddManualBankingConnectionV2Mutation, { data, loading, error }] = usePartnerAddManualBankingConnectionV2Mutation({
 *   variables: {
 *      accountInformation: // value for 'accountInformation'
 *   },
 * });
 */
export function usePartnerAddManualBankingConnectionV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddManualBankingConnectionV2Mutation,
    PartnerAddManualBankingConnectionV2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddManualBankingConnectionV2Mutation,
    PartnerAddManualBankingConnectionV2MutationVariables
  >(PartnerAddManualBankingConnectionV2Document, options)
}
export type PartnerAddManualBankingConnectionV2MutationHookResult = ReturnType<
  typeof usePartnerAddManualBankingConnectionV2Mutation
>
export type PartnerAddManualBankingConnectionV2MutationResult =
  Apollo.MutationResult<PartnerAddManualBankingConnectionV2Mutation>
export type PartnerAddManualBankingConnectionV2MutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAddManualBankingConnectionV2Mutation,
    PartnerAddManualBankingConnectionV2MutationVariables
  >
export const PartnerAddCustomerBankingConnectionDocument = /*#__PURE__*/ gql`
  mutation PartnerAddCustomerBankingConnection(
    $customerID: String!
    $accountInformation: ManualBankingAccountInformationInput!
  ) {
    PartnerAddCustomerManualBankingConnection(
      customerID: $customerID
      accountInformation: $accountInformation
    )
  }
`
export type PartnerAddCustomerBankingConnectionMutationFn =
  Apollo.MutationFunction<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >

/**
 * __usePartnerAddCustomerBankingConnectionMutation__
 *
 * To run a mutation, you first call `usePartnerAddCustomerBankingConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddCustomerBankingConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddCustomerBankingConnectionMutation, { data, loading, error }] = usePartnerAddCustomerBankingConnectionMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      accountInformation: // value for 'accountInformation'
 *   },
 * });
 */
export function usePartnerAddCustomerBankingConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >(PartnerAddCustomerBankingConnectionDocument, options)
}
export type PartnerAddCustomerBankingConnectionMutationHookResult = ReturnType<
  typeof usePartnerAddCustomerBankingConnectionMutation
>
export type PartnerAddCustomerBankingConnectionMutationResult =
  Apollo.MutationResult<PartnerAddCustomerBankingConnectionMutation>
export type PartnerAddCustomerBankingConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >
export const PartnerChangeDefaultPayoutBankingAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeDefaultPayoutBankingAccount(
    $input: PartnerDefaultPayoutBankingAccountUpdateInput!
  ) {
    PartnerChangeDefaultPayoutBankingAccount(input: $input)
  }
`
export type PartnerChangeDefaultPayoutBankingAccountMutationFn =
  Apollo.MutationFunction<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >

/**
 * __usePartnerChangeDefaultPayoutBankingAccountMutation__
 *
 * To run a mutation, you first call `usePartnerChangeDefaultPayoutBankingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeDefaultPayoutBankingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeDefaultPayoutBankingAccountMutation, { data, loading, error }] = usePartnerChangeDefaultPayoutBankingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerChangeDefaultPayoutBankingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >(PartnerChangeDefaultPayoutBankingAccountDocument, options)
}
export type PartnerChangeDefaultPayoutBankingAccountMutationHookResult =
  ReturnType<typeof usePartnerChangeDefaultPayoutBankingAccountMutation>
export type PartnerChangeDefaultPayoutBankingAccountMutationResult =
  Apollo.MutationResult<PartnerChangeDefaultPayoutBankingAccountMutation>
export type PartnerChangeDefaultPayoutBankingAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >
export const PartnerAddBankAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerAddBankAccount($input: AddBankAccountInput!) {
    PartnerAddBankAccount(input: $input) {
      id
    }
  }
`
export type PartnerAddBankAccountMutationFn = Apollo.MutationFunction<
  PartnerAddBankAccountMutation,
  PartnerAddBankAccountMutationVariables
>

/**
 * __usePartnerAddBankAccountMutation__
 *
 * To run a mutation, you first call `usePartnerAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddBankAccountMutation, { data, loading, error }] = usePartnerAddBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAddBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddBankAccountMutation,
    PartnerAddBankAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddBankAccountMutation,
    PartnerAddBankAccountMutationVariables
  >(PartnerAddBankAccountDocument, options)
}
export type PartnerAddBankAccountMutationHookResult = ReturnType<
  typeof usePartnerAddBankAccountMutation
>
export type PartnerAddBankAccountMutationResult =
  Apollo.MutationResult<PartnerAddBankAccountMutation>
export type PartnerAddBankAccountMutationOptions = Apollo.BaseMutationOptions<
  PartnerAddBankAccountMutation,
  PartnerAddBankAccountMutationVariables
>
export const PartnerAddCustomerBankAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerAddCustomerBankAccount($input: AddCustomerBankAccountInput!) {
    PartnerAddCustomerBankAccount(input: $input) {
      id
    }
  }
`
export type PartnerAddCustomerBankAccountMutationFn = Apollo.MutationFunction<
  PartnerAddCustomerBankAccountMutation,
  PartnerAddCustomerBankAccountMutationVariables
>

/**
 * __usePartnerAddCustomerBankAccountMutation__
 *
 * To run a mutation, you first call `usePartnerAddCustomerBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddCustomerBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddCustomerBankAccountMutation, { data, loading, error }] = usePartnerAddCustomerBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAddCustomerBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddCustomerBankAccountMutation,
    PartnerAddCustomerBankAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddCustomerBankAccountMutation,
    PartnerAddCustomerBankAccountMutationVariables
  >(PartnerAddCustomerBankAccountDocument, options)
}
export type PartnerAddCustomerBankAccountMutationHookResult = ReturnType<
  typeof usePartnerAddCustomerBankAccountMutation
>
export type PartnerAddCustomerBankAccountMutationResult =
  Apollo.MutationResult<PartnerAddCustomerBankAccountMutation>
export type PartnerAddCustomerBankAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAddCustomerBankAccountMutation,
    PartnerAddCustomerBankAccountMutationVariables
  >
export const PartnerUploadBankAccountDocumentDocument = /*#__PURE__*/ gql`
  mutation PartnerUploadBankAccountDocument(
    $input: UploadBankAccountDocumentInput!
  ) {
    PartnerUploadBankAccountDocument(input: $input)
  }
`
export type PartnerUploadBankAccountDocumentMutationFn =
  Apollo.MutationFunction<
    PartnerUploadBankAccountDocumentMutation,
    PartnerUploadBankAccountDocumentMutationVariables
  >

/**
 * __usePartnerUploadBankAccountDocumentMutation__
 *
 * To run a mutation, you first call `usePartnerUploadBankAccountDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUploadBankAccountDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUploadBankAccountDocumentMutation, { data, loading, error }] = usePartnerUploadBankAccountDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUploadBankAccountDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUploadBankAccountDocumentMutation,
    PartnerUploadBankAccountDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUploadBankAccountDocumentMutation,
    PartnerUploadBankAccountDocumentMutationVariables
  >(PartnerUploadBankAccountDocumentDocument, options)
}
export type PartnerUploadBankAccountDocumentMutationHookResult = ReturnType<
  typeof usePartnerUploadBankAccountDocumentMutation
>
export type PartnerUploadBankAccountDocumentMutationResult =
  Apollo.MutationResult<PartnerUploadBankAccountDocumentMutation>
export type PartnerUploadBankAccountDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUploadBankAccountDocumentMutation,
    PartnerUploadBankAccountDocumentMutationVariables
  >
export const PartnerUpdateBankAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateBankAccount($input: UpdateBankAccountInput!) {
    PartnerUpdateBankAccount(input: $input)
  }
`
export type PartnerUpdateBankAccountMutationFn = Apollo.MutationFunction<
  PartnerUpdateBankAccountMutation,
  PartnerUpdateBankAccountMutationVariables
>

/**
 * __usePartnerUpdateBankAccountMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateBankAccountMutation, { data, loading, error }] = usePartnerUpdateBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateBankAccountMutation,
    PartnerUpdateBankAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateBankAccountMutation,
    PartnerUpdateBankAccountMutationVariables
  >(PartnerUpdateBankAccountDocument, options)
}
export type PartnerUpdateBankAccountMutationHookResult = ReturnType<
  typeof usePartnerUpdateBankAccountMutation
>
export type PartnerUpdateBankAccountMutationResult =
  Apollo.MutationResult<PartnerUpdateBankAccountMutation>
export type PartnerUpdateBankAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateBankAccountMutation,
    PartnerUpdateBankAccountMutationVariables
  >
export const PartnerUpdateBankAccountV2Document = /*#__PURE__*/ gql`
  mutation PartnerUpdateBankAccountV2($input: UpdateBankAccountV2Input!) {
    PartnerUpdateBankAccountV2(input: $input)
  }
`
export type PartnerUpdateBankAccountV2MutationFn = Apollo.MutationFunction<
  PartnerUpdateBankAccountV2Mutation,
  PartnerUpdateBankAccountV2MutationVariables
>

/**
 * __usePartnerUpdateBankAccountV2Mutation__
 *
 * To run a mutation, you first call `usePartnerUpdateBankAccountV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateBankAccountV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateBankAccountV2Mutation, { data, loading, error }] = usePartnerUpdateBankAccountV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateBankAccountV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateBankAccountV2Mutation,
    PartnerUpdateBankAccountV2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateBankAccountV2Mutation,
    PartnerUpdateBankAccountV2MutationVariables
  >(PartnerUpdateBankAccountV2Document, options)
}
export type PartnerUpdateBankAccountV2MutationHookResult = ReturnType<
  typeof usePartnerUpdateBankAccountV2Mutation
>
export type PartnerUpdateBankAccountV2MutationResult =
  Apollo.MutationResult<PartnerUpdateBankAccountV2Mutation>
export type PartnerUpdateBankAccountV2MutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateBankAccountV2Mutation,
    PartnerUpdateBankAccountV2MutationVariables
  >
export const PartnerUpdateBankAccountCustomNameDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateBankAccountCustomName(
    $input: BankAccountCustomNameUpdateInput!
  ) {
    PartnerUpdateBankAccountCustomName(input: $input)
  }
`
export type PartnerUpdateBankAccountCustomNameMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateBankAccountCustomNameMutation,
    PartnerUpdateBankAccountCustomNameMutationVariables
  >

/**
 * __usePartnerUpdateBankAccountCustomNameMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateBankAccountCustomNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateBankAccountCustomNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateBankAccountCustomNameMutation, { data, loading, error }] = usePartnerUpdateBankAccountCustomNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateBankAccountCustomNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateBankAccountCustomNameMutation,
    PartnerUpdateBankAccountCustomNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateBankAccountCustomNameMutation,
    PartnerUpdateBankAccountCustomNameMutationVariables
  >(PartnerUpdateBankAccountCustomNameDocument, options)
}
export type PartnerUpdateBankAccountCustomNameMutationHookResult = ReturnType<
  typeof usePartnerUpdateBankAccountCustomNameMutation
>
export type PartnerUpdateBankAccountCustomNameMutationResult =
  Apollo.MutationResult<PartnerUpdateBankAccountCustomNameMutation>
export type PartnerUpdateBankAccountCustomNameMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateBankAccountCustomNameMutation,
    PartnerUpdateBankAccountCustomNameMutationVariables
  >
export const PartnerGetBankAccountDocument = /*#__PURE__*/ gql`
  query PartnerGetBankAccount($bankAccountID: ID!) {
    PartnerGetBankAccount(bankAccountID: $bankAccountID) {
      ...BankAccountInfo
    }
  }
  ${BankAccountInfoFragmentDoc}
`

/**
 * __usePartnerGetBankAccountQuery__
 *
 * To run a query within a React component, call `usePartnerGetBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetBankAccountQuery({
 *   variables: {
 *      bankAccountID: // value for 'bankAccountID'
 *   },
 * });
 */
export function usePartnerGetBankAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetBankAccountQuery,
    PartnerGetBankAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetBankAccountQuery,
    PartnerGetBankAccountQueryVariables
  >(PartnerGetBankAccountDocument, options)
}
export function usePartnerGetBankAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetBankAccountQuery,
    PartnerGetBankAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetBankAccountQuery,
    PartnerGetBankAccountQueryVariables
  >(PartnerGetBankAccountDocument, options)
}
export type PartnerGetBankAccountQueryHookResult = ReturnType<
  typeof usePartnerGetBankAccountQuery
>
export type PartnerGetBankAccountLazyQueryHookResult = ReturnType<
  typeof usePartnerGetBankAccountLazyQuery
>
export type PartnerGetBankAccountQueryResult = Apollo.QueryResult<
  PartnerGetBankAccountQuery,
  PartnerGetBankAccountQueryVariables
>
export const PartnerCollectMandateConsentDocument = /*#__PURE__*/ gql`
  mutation PartnerCollectMandateConsent(
    $mandateConsentInput: CollectMandateConsentInput!
  ) {
    PartnerCollectMandateConsent(mandateConsentInput: $mandateConsentInput)
  }
`
export type PartnerCollectMandateConsentMutationFn = Apollo.MutationFunction<
  PartnerCollectMandateConsentMutation,
  PartnerCollectMandateConsentMutationVariables
>

/**
 * __usePartnerCollectMandateConsentMutation__
 *
 * To run a mutation, you first call `usePartnerCollectMandateConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCollectMandateConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCollectMandateConsentMutation, { data, loading, error }] = usePartnerCollectMandateConsentMutation({
 *   variables: {
 *      mandateConsentInput: // value for 'mandateConsentInput'
 *   },
 * });
 */
export function usePartnerCollectMandateConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCollectMandateConsentMutation,
    PartnerCollectMandateConsentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCollectMandateConsentMutation,
    PartnerCollectMandateConsentMutationVariables
  >(PartnerCollectMandateConsentDocument, options)
}
export type PartnerCollectMandateConsentMutationHookResult = ReturnType<
  typeof usePartnerCollectMandateConsentMutation
>
export type PartnerCollectMandateConsentMutationResult =
  Apollo.MutationResult<PartnerCollectMandateConsentMutation>
export type PartnerCollectMandateConsentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCollectMandateConsentMutation,
    PartnerCollectMandateConsentMutationVariables
  >
export const PartnerGetInvoiceBulkChargesDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoiceBulkCharges(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $getPartnerInvoiceBulkChargesFilter: GetPartnerInvoiceBulkChargesFilter
    $getPartnerInvoiceBulkChargesOrderBy: GetPartnerInvoiceBulkChargesOrderBy
  ) {
    PartnerGetInvoiceBulkCharges(
      after: $after
      first: $first
      before: $before
      last: $last
      getPartnerInvoiceBulkChargesFilter: $getPartnerInvoiceBulkChargesFilter
      orderBy: $getPartnerInvoiceBulkChargesOrderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerInvoiceBulkCharge
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerInvoiceBulkChargeFragmentDoc}
`

/**
 * __usePartnerGetInvoiceBulkChargesQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoiceBulkChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoiceBulkChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoiceBulkChargesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      getPartnerInvoiceBulkChargesFilter: // value for 'getPartnerInvoiceBulkChargesFilter'
 *      getPartnerInvoiceBulkChargesOrderBy: // value for 'getPartnerInvoiceBulkChargesOrderBy'
 *   },
 * });
 */
export function usePartnerGetInvoiceBulkChargesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >(PartnerGetInvoiceBulkChargesDocument, options)
}
export function usePartnerGetInvoiceBulkChargesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >(PartnerGetInvoiceBulkChargesDocument, options)
}
export type PartnerGetInvoiceBulkChargesQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceBulkChargesQuery
>
export type PartnerGetInvoiceBulkChargesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceBulkChargesLazyQuery
>
export type PartnerGetInvoiceBulkChargesQueryResult = Apollo.QueryResult<
  PartnerGetInvoiceBulkChargesQuery,
  PartnerGetInvoiceBulkChargesQueryVariables
>
export const PartnerInvoiceBulkChargeOnDateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceBulkChargeOnDate(
    $invoiceIds: [ID!]
    $paymentDate: String
  ) {
    PartnerInvoiceBulkChargeOnDate(
      invoiceIds: $invoiceIds
      paymentDate: $paymentDate
    )
  }
`
export type PartnerInvoiceBulkChargeOnDateMutationFn = Apollo.MutationFunction<
  PartnerInvoiceBulkChargeOnDateMutation,
  PartnerInvoiceBulkChargeOnDateMutationVariables
>

/**
 * __usePartnerInvoiceBulkChargeOnDateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceBulkChargeOnDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceBulkChargeOnDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceBulkChargeOnDateMutation, { data, loading, error }] = usePartnerInvoiceBulkChargeOnDateMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function usePartnerInvoiceBulkChargeOnDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceBulkChargeOnDateMutation,
    PartnerInvoiceBulkChargeOnDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceBulkChargeOnDateMutation,
    PartnerInvoiceBulkChargeOnDateMutationVariables
  >(PartnerInvoiceBulkChargeOnDateDocument, options)
}
export type PartnerInvoiceBulkChargeOnDateMutationHookResult = ReturnType<
  typeof usePartnerInvoiceBulkChargeOnDateMutation
>
export type PartnerInvoiceBulkChargeOnDateMutationResult =
  Apollo.MutationResult<PartnerInvoiceBulkChargeOnDateMutation>
export type PartnerInvoiceBulkChargeOnDateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerInvoiceBulkChargeOnDateMutation,
    PartnerInvoiceBulkChargeOnDateMutationVariables
  >
export const PartnerInvoiceBulkChargeOnDueDateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceBulkChargeOnDueDate($invoiceIds: [ID!]) {
    PartnerInvoiceBulkChargeOnDueDate(invoiceIds: $invoiceIds)
  }
`
export type PartnerInvoiceBulkChargeOnDueDateMutationFn =
  Apollo.MutationFunction<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >

/**
 * __usePartnerInvoiceBulkChargeOnDueDateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceBulkChargeOnDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceBulkChargeOnDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceBulkChargeOnDueDateMutation, { data, loading, error }] = usePartnerInvoiceBulkChargeOnDueDateMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function usePartnerInvoiceBulkChargeOnDueDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >(PartnerInvoiceBulkChargeOnDueDateDocument, options)
}
export type PartnerInvoiceBulkChargeOnDueDateMutationHookResult = ReturnType<
  typeof usePartnerInvoiceBulkChargeOnDueDateMutation
>
export type PartnerInvoiceBulkChargeOnDueDateMutationResult =
  Apollo.MutationResult<PartnerInvoiceBulkChargeOnDueDateMutation>
export type PartnerInvoiceBulkChargeOnDueDateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >
export const FindOverdueInvoiceDetailDocument = /*#__PURE__*/ gql`
  query FindOverdueInvoiceDetail($id: String!) {
    FindInvoice(id: $id) {
      ...PartnerOverdueInvoice
    }
  }
  ${PartnerOverdueInvoiceFragmentDoc}
`

/**
 * __useFindOverdueInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useFindOverdueInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverdueInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverdueInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindOverdueInvoiceDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >(FindOverdueInvoiceDetailDocument, options)
}
export function useFindOverdueInvoiceDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >(FindOverdueInvoiceDetailDocument, options)
}
export type FindOverdueInvoiceDetailQueryHookResult = ReturnType<
  typeof useFindOverdueInvoiceDetailQuery
>
export type FindOverdueInvoiceDetailLazyQueryHookResult = ReturnType<
  typeof useFindOverdueInvoiceDetailLazyQuery
>
export type FindOverdueInvoiceDetailQueryResult = Apollo.QueryResult<
  FindOverdueInvoiceDetailQuery,
  FindOverdueInvoiceDetailQueryVariables
>
export const FindOverdueInvoicesDocument = /*#__PURE__*/ gql`
  query FindOverdueInvoices(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: InvoiceFilter
    $orderBy: InvoiceOrderBy
  ) {
    PartnerInvoiceConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerCollectionInvoice
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCollectionInvoiceFragmentDoc}
`

/**
 * __useFindOverdueInvoicesQuery__
 *
 * To run a query within a React component, call `useFindOverdueInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverdueInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverdueInvoicesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindOverdueInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >(FindOverdueInvoicesDocument, options)
}
export function useFindOverdueInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >(FindOverdueInvoicesDocument, options)
}
export type FindOverdueInvoicesQueryHookResult = ReturnType<
  typeof useFindOverdueInvoicesQuery
>
export type FindOverdueInvoicesLazyQueryHookResult = ReturnType<
  typeof useFindOverdueInvoicesLazyQuery
>
export type FindOverdueInvoicesQueryResult = Apollo.QueryResult<
  FindOverdueInvoicesQuery,
  FindOverdueInvoicesQueryVariables
>
export const PartnerCollectionConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCollectionConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $collectionFilter: CollectionFilter
    $orderBy: CollectionOrder
  ) {
    PartnerCollectionConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      collectionFilter: $collectionFilter
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerCollectionListing
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCollectionListingFragmentDoc}
`

/**
 * __usePartnerCollectionConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCollectionConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCollectionConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCollectionConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      collectionFilter: // value for 'collectionFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCollectionConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >(PartnerCollectionConnectionDocument, options)
}
export function usePartnerCollectionConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >(PartnerCollectionConnectionDocument, options)
}
export type PartnerCollectionConnectionQueryHookResult = ReturnType<
  typeof usePartnerCollectionConnectionQuery
>
export type PartnerCollectionConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerCollectionConnectionLazyQuery
>
export type PartnerCollectionConnectionQueryResult = Apollo.QueryResult<
  PartnerCollectionConnectionQuery,
  PartnerCollectionConnectionQueryVariables
>
export const FindCollectionDetailDocument = /*#__PURE__*/ gql`
  query FindCollectionDetail(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $collectionFilter: CollectionFilter
    $orderBy: CollectionOrder
  ) {
    PartnerCollectionConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      collectionFilter: $collectionFilter
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerCollectionDetail
        }
      }
    }
  }
  ${PartnerCollectionDetailFragmentDoc}
`

/**
 * __useFindCollectionDetailQuery__
 *
 * To run a query within a React component, call `useFindCollectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCollectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCollectionDetailQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      collectionFilter: // value for 'collectionFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindCollectionDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >(FindCollectionDetailDocument, options)
}
export function useFindCollectionDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >(FindCollectionDetailDocument, options)
}
export type FindCollectionDetailQueryHookResult = ReturnType<
  typeof useFindCollectionDetailQuery
>
export type FindCollectionDetailLazyQueryHookResult = ReturnType<
  typeof useFindCollectionDetailLazyQuery
>
export type FindCollectionDetailQueryResult = Apollo.QueryResult<
  FindCollectionDetailQuery,
  FindCollectionDetailQueryVariables
>
export const PartnerCollectionTotalsDocument = /*#__PURE__*/ gql`
  query PartnerCollectionTotals($collectionFilter: CollectionFilter) {
    PartnerCollectionTotals(collectionFilter: $collectionFilter) {
      netAmount
      amount
      count
    }
  }
`

/**
 * __usePartnerCollectionTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerCollectionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCollectionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCollectionTotalsQuery({
 *   variables: {
 *      collectionFilter: // value for 'collectionFilter'
 *   },
 * });
 */
export function usePartnerCollectionTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >(PartnerCollectionTotalsDocument, options)
}
export function usePartnerCollectionTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >(PartnerCollectionTotalsDocument, options)
}
export type PartnerCollectionTotalsQueryHookResult = ReturnType<
  typeof usePartnerCollectionTotalsQuery
>
export type PartnerCollectionTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerCollectionTotalsLazyQuery
>
export type PartnerCollectionTotalsQueryResult = Apollo.QueryResult<
  PartnerCollectionTotalsQuery,
  PartnerCollectionTotalsQueryVariables
>
export const PartnerGetFeeRatesDocument = /*#__PURE__*/ gql`
  query PartnerGetFeeRates($input: GetFeeRatesInput!) {
    PartnerGetFeeRates(input: $input) {
      upfrontFeeAmount
      collectionFeeAmount
    }
  }
`

/**
 * __usePartnerGetFeeRatesQuery__
 *
 * To run a query within a React component, call `usePartnerGetFeeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetFeeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetFeeRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetFeeRatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >(PartnerGetFeeRatesDocument, options)
}
export function usePartnerGetFeeRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >(PartnerGetFeeRatesDocument, options)
}
export type PartnerGetFeeRatesQueryHookResult = ReturnType<
  typeof usePartnerGetFeeRatesQuery
>
export type PartnerGetFeeRatesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetFeeRatesLazyQuery
>
export type PartnerGetFeeRatesQueryResult = Apollo.QueryResult<
  PartnerGetFeeRatesQuery,
  PartnerGetFeeRatesQueryVariables
>
export const PartnerCreateCollectionDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCollection($createInput: CollectionCreateInput!) {
    PartnerCreateCollection(createInput: $createInput)
  }
`
export type PartnerCreateCollectionMutationFn = Apollo.MutationFunction<
  PartnerCreateCollectionMutation,
  PartnerCreateCollectionMutationVariables
>

/**
 * __usePartnerCreateCollectionMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCollectionMutation, { data, loading, error }] = usePartnerCreateCollectionMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function usePartnerCreateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCollectionMutation,
    PartnerCreateCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCollectionMutation,
    PartnerCreateCollectionMutationVariables
  >(PartnerCreateCollectionDocument, options)
}
export type PartnerCreateCollectionMutationHookResult = ReturnType<
  typeof usePartnerCreateCollectionMutation
>
export type PartnerCreateCollectionMutationResult =
  Apollo.MutationResult<PartnerCreateCollectionMutation>
export type PartnerCreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateCollectionMutation,
  PartnerCreateCollectionMutationVariables
>
export const PartnerCancelCollectionDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelCollection($collectionID: String!, $reason: String!) {
    PartnerCancelCollection(collectionID: $collectionID, reason: $reason)
  }
`
export type PartnerCancelCollectionMutationFn = Apollo.MutationFunction<
  PartnerCancelCollectionMutation,
  PartnerCancelCollectionMutationVariables
>

/**
 * __usePartnerCancelCollectionMutation__
 *
 * To run a mutation, you first call `usePartnerCancelCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelCollectionMutation, { data, loading, error }] = usePartnerCancelCollectionMutation({
 *   variables: {
 *      collectionID: // value for 'collectionID'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePartnerCancelCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelCollectionMutation,
    PartnerCancelCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelCollectionMutation,
    PartnerCancelCollectionMutationVariables
  >(PartnerCancelCollectionDocument, options)
}
export type PartnerCancelCollectionMutationHookResult = ReturnType<
  typeof usePartnerCancelCollectionMutation
>
export type PartnerCancelCollectionMutationResult =
  Apollo.MutationResult<PartnerCancelCollectionMutation>
export type PartnerCancelCollectionMutationOptions = Apollo.BaseMutationOptions<
  PartnerCancelCollectionMutation,
  PartnerCancelCollectionMutationVariables
>
export const PartnerListCardsDocument = /*#__PURE__*/ gql`
  query PartnerListCards($filter: ListCardsFilterInput) {
    PartnerListCards(filter: $filter) {
      ...CreditCard
    }
  }
  ${CreditCardFragmentDoc}
`

/**
 * __usePartnerListCardsQuery__
 *
 * To run a query within a React component, call `usePartnerListCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerListCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCardsQuery,
    PartnerListCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PartnerListCardsQuery, PartnerListCardsQueryVariables>(
    PartnerListCardsDocument,
    options
  )
}
export function usePartnerListCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCardsQuery,
    PartnerListCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCardsQuery,
    PartnerListCardsQueryVariables
  >(PartnerListCardsDocument, options)
}
export type PartnerListCardsQueryHookResult = ReturnType<
  typeof usePartnerListCardsQuery
>
export type PartnerListCardsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCardsLazyQuery
>
export type PartnerListCardsQueryResult = Apollo.QueryResult<
  PartnerListCardsQuery,
  PartnerListCardsQueryVariables
>
export const PartnerListCustomerCardsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerCards(
    $filter: ListCardsFilterInput
    $customerID: ID!
  ) {
    PartnerListCustomerCards(customerID: $customerID, filter: $filter) {
      ...CreditCard
    }
  }
  ${CreditCardFragmentDoc}
`

/**
 * __usePartnerListCustomerCardsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerCardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerListCustomerCardsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >(PartnerListCustomerCardsDocument, options)
}
export function usePartnerListCustomerCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >(PartnerListCustomerCardsDocument, options)
}
export type PartnerListCustomerCardsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerCardsQuery
>
export type PartnerListCustomerCardsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerCardsLazyQuery
>
export type PartnerListCustomerCardsQueryResult = Apollo.QueryResult<
  PartnerListCustomerCardsQuery,
  PartnerListCustomerCardsQueryVariables
>
export const PartnerGetCardFeeDocument = /*#__PURE__*/ gql`
  query PartnerGetCardFee($input: GetCardFeeInput!) {
    PartnerGetCardFee(input: $input) {
      percentage
      feeAmount
    }
  }
`

/**
 * __usePartnerGetCardFeeQuery__
 *
 * To run a query within a React component, call `usePartnerGetCardFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCardFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCardFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetCardFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >(PartnerGetCardFeeDocument, options)
}
export function usePartnerGetCardFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >(PartnerGetCardFeeDocument, options)
}
export type PartnerGetCardFeeQueryHookResult = ReturnType<
  typeof usePartnerGetCardFeeQuery
>
export type PartnerGetCardFeeLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCardFeeLazyQuery
>
export type PartnerGetCardFeeQueryResult = Apollo.QueryResult<
  PartnerGetCardFeeQuery,
  PartnerGetCardFeeQueryVariables
>
export const PartnerGetCustomerCardFeeDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomerCardFee($input: GetCustomerCardFeeInput!) {
    PartnerGetCustomerCardFee(input: $input) {
      percentage
      feeAmount
    }
  }
`

/**
 * __usePartnerGetCustomerCardFeeQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomerCardFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerCardFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerCardFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetCustomerCardFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >(PartnerGetCustomerCardFeeDocument, options)
}
export function usePartnerGetCustomerCardFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >(PartnerGetCustomerCardFeeDocument, options)
}
export type PartnerGetCustomerCardFeeQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerCardFeeQuery
>
export type PartnerGetCustomerCardFeeLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerCardFeeLazyQuery
>
export type PartnerGetCustomerCardFeeQueryResult = Apollo.QueryResult<
  PartnerGetCustomerCardFeeQuery,
  PartnerGetCustomerCardFeeQueryVariables
>
export const PartnerCreateCardDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCard($input: CardCreationInput!) {
    PartnerCreateCard(input: $input)
  }
`
export type PartnerCreateCardMutationFn = Apollo.MutationFunction<
  PartnerCreateCardMutation,
  PartnerCreateCardMutationVariables
>

/**
 * __usePartnerCreateCardMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCardMutation, { data, loading, error }] = usePartnerCreateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCardMutation,
    PartnerCreateCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCardMutation,
    PartnerCreateCardMutationVariables
  >(PartnerCreateCardDocument, options)
}
export type PartnerCreateCardMutationHookResult = ReturnType<
  typeof usePartnerCreateCardMutation
>
export type PartnerCreateCardMutationResult =
  Apollo.MutationResult<PartnerCreateCardMutation>
export type PartnerCreateCardMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateCardMutation,
  PartnerCreateCardMutationVariables
>
export const PartnerCreateCustomerCardDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomerCard(
    $input: CardCreationInput!
    $customerID: ID!
  ) {
    PartnerCreateCustomerCard(input: $input, customerID: $customerID)
  }
`
export type PartnerCreateCustomerCardMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerCardMutation,
  PartnerCreateCustomerCardMutationVariables
>

/**
 * __usePartnerCreateCustomerCardMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerCardMutation, { data, loading, error }] = usePartnerCreateCustomerCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerCreateCustomerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerCardMutation,
    PartnerCreateCustomerCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerCardMutation,
    PartnerCreateCustomerCardMutationVariables
  >(PartnerCreateCustomerCardDocument, options)
}
export type PartnerCreateCustomerCardMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerCardMutation
>
export type PartnerCreateCustomerCardMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerCardMutation>
export type PartnerCreateCustomerCardMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCustomerCardMutation,
    PartnerCreateCustomerCardMutationVariables
  >
export const PartnerDeleteCardDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCard($input: CardDeletionInput!) {
    PartnerDeleteCard(input: $input)
  }
`
export type PartnerDeleteCardMutationFn = Apollo.MutationFunction<
  PartnerDeleteCardMutation,
  PartnerDeleteCardMutationVariables
>

/**
 * __usePartnerDeleteCardMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCardMutation, { data, loading, error }] = usePartnerDeleteCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerDeleteCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCardMutation,
    PartnerDeleteCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCardMutation,
    PartnerDeleteCardMutationVariables
  >(PartnerDeleteCardDocument, options)
}
export type PartnerDeleteCardMutationHookResult = ReturnType<
  typeof usePartnerDeleteCardMutation
>
export type PartnerDeleteCardMutationResult =
  Apollo.MutationResult<PartnerDeleteCardMutation>
export type PartnerDeleteCardMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeleteCardMutation,
  PartnerDeleteCardMutationVariables
>
export const PartnerDeleteCustomerCardDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCustomerCard(
    $input: CardDeletionInput!
    $customerID: ID!
  ) {
    PartnerDeleteCustomerCard(input: $input, customerID: $customerID)
  }
`
export type PartnerDeleteCustomerCardMutationFn = Apollo.MutationFunction<
  PartnerDeleteCustomerCardMutation,
  PartnerDeleteCustomerCardMutationVariables
>

/**
 * __usePartnerDeleteCustomerCardMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCustomerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCustomerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCustomerCardMutation, { data, loading, error }] = usePartnerDeleteCustomerCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerDeleteCustomerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCustomerCardMutation,
    PartnerDeleteCustomerCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCustomerCardMutation,
    PartnerDeleteCustomerCardMutationVariables
  >(PartnerDeleteCustomerCardDocument, options)
}
export type PartnerDeleteCustomerCardMutationHookResult = ReturnType<
  typeof usePartnerDeleteCustomerCardMutation
>
export type PartnerDeleteCustomerCardMutationResult =
  Apollo.MutationResult<PartnerDeleteCustomerCardMutation>
export type PartnerDeleteCustomerCardMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCustomerCardMutation,
    PartnerDeleteCustomerCardMutationVariables
  >
export const PartnerUpdateCardCustomNameDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateCardCustomName($input: CardCustomNameUpdateInput!) {
    PartnerUpdateCardCustomName(input: $input)
  }
`
export type PartnerUpdateCardCustomNameMutationFn = Apollo.MutationFunction<
  PartnerUpdateCardCustomNameMutation,
  PartnerUpdateCardCustomNameMutationVariables
>

/**
 * __usePartnerUpdateCardCustomNameMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateCardCustomNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateCardCustomNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateCardCustomNameMutation, { data, loading, error }] = usePartnerUpdateCardCustomNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateCardCustomNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateCardCustomNameMutation,
    PartnerUpdateCardCustomNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateCardCustomNameMutation,
    PartnerUpdateCardCustomNameMutationVariables
  >(PartnerUpdateCardCustomNameDocument, options)
}
export type PartnerUpdateCardCustomNameMutationHookResult = ReturnType<
  typeof usePartnerUpdateCardCustomNameMutation
>
export type PartnerUpdateCardCustomNameMutationResult =
  Apollo.MutationResult<PartnerUpdateCardCustomNameMutation>
export type PartnerUpdateCardCustomNameMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateCardCustomNameMutation,
    PartnerUpdateCardCustomNameMutationVariables
  >
export const PartnerUpdateCardDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateCard($input: CardUpdateInput!) {
    PartnerUpdateCard(input: $input)
  }
`
export type PartnerUpdateCardMutationFn = Apollo.MutationFunction<
  PartnerUpdateCardMutation,
  PartnerUpdateCardMutationVariables
>

/**
 * __usePartnerUpdateCardMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateCardMutation, { data, loading, error }] = usePartnerUpdateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateCardMutation,
    PartnerUpdateCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateCardMutation,
    PartnerUpdateCardMutationVariables
  >(PartnerUpdateCardDocument, options)
}
export type PartnerUpdateCardMutationHookResult = ReturnType<
  typeof usePartnerUpdateCardMutation
>
export type PartnerUpdateCardMutationResult =
  Apollo.MutationResult<PartnerUpdateCardMutation>
export type PartnerUpdateCardMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateCardMutation,
  PartnerUpdateCardMutationVariables
>
export const PartnerGetCreditMemoConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetCreditMemoConfig {
    PartnerGetCreditMemoConfig {
      ...PartnerCreditMemoConfig
    }
  }
  ${PartnerCreditMemoConfigFragmentDoc}
`

/**
 * __usePartnerGetCreditMemoConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetCreditMemoConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCreditMemoConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCreditMemoConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetCreditMemoConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetCreditMemoConfigQuery,
    PartnerGetCreditMemoConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCreditMemoConfigQuery,
    PartnerGetCreditMemoConfigQueryVariables
  >(PartnerGetCreditMemoConfigDocument, options)
}
export function usePartnerGetCreditMemoConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCreditMemoConfigQuery,
    PartnerGetCreditMemoConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCreditMemoConfigQuery,
    PartnerGetCreditMemoConfigQueryVariables
  >(PartnerGetCreditMemoConfigDocument, options)
}
export type PartnerGetCreditMemoConfigQueryHookResult = ReturnType<
  typeof usePartnerGetCreditMemoConfigQuery
>
export type PartnerGetCreditMemoConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCreditMemoConfigLazyQuery
>
export type PartnerGetCreditMemoConfigQueryResult = Apollo.QueryResult<
  PartnerGetCreditMemoConfigQuery,
  PartnerGetCreditMemoConfigQueryVariables
>
export const PartnerGetCustomerCreditMemoBalanceDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomerCreditMemoBalance($customerID: ID!) {
    PartnerGetCustomerCreditMemoBalance(customerID: $customerID) {
      ...PartnerCustomerCreditMemoBalance
    }
  }
  ${PartnerCustomerCreditMemoBalanceFragmentDoc}
`

/**
 * __usePartnerGetCustomerCreditMemoBalanceQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomerCreditMemoBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerCreditMemoBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerCreditMemoBalanceQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerGetCustomerCreditMemoBalanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerCreditMemoBalanceQuery,
    PartnerGetCustomerCreditMemoBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerCreditMemoBalanceQuery,
    PartnerGetCustomerCreditMemoBalanceQueryVariables
  >(PartnerGetCustomerCreditMemoBalanceDocument, options)
}
export function usePartnerGetCustomerCreditMemoBalanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerCreditMemoBalanceQuery,
    PartnerGetCustomerCreditMemoBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerCreditMemoBalanceQuery,
    PartnerGetCustomerCreditMemoBalanceQueryVariables
  >(PartnerGetCustomerCreditMemoBalanceDocument, options)
}
export type PartnerGetCustomerCreditMemoBalanceQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerCreditMemoBalanceQuery
>
export type PartnerGetCustomerCreditMemoBalanceLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerCreditMemoBalanceLazyQuery
>
export type PartnerGetCustomerCreditMemoBalanceQueryResult = Apollo.QueryResult<
  PartnerGetCustomerCreditMemoBalanceQuery,
  PartnerGetCustomerCreditMemoBalanceQueryVariables
>
export const PartnerUpdateCreditMemoConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateCreditMemoConfig($input: UpdateCreditMemoConfigInput!) {
    PartnerUpdateCreditMemoConfig(input: $input) {
      ...PartnerCreditMemoConfig
    }
  }
  ${PartnerCreditMemoConfigFragmentDoc}
`
export type PartnerUpdateCreditMemoConfigMutationFn = Apollo.MutationFunction<
  PartnerUpdateCreditMemoConfigMutation,
  PartnerUpdateCreditMemoConfigMutationVariables
>

/**
 * __usePartnerUpdateCreditMemoConfigMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateCreditMemoConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateCreditMemoConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateCreditMemoConfigMutation, { data, loading, error }] = usePartnerUpdateCreditMemoConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateCreditMemoConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateCreditMemoConfigMutation,
    PartnerUpdateCreditMemoConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateCreditMemoConfigMutation,
    PartnerUpdateCreditMemoConfigMutationVariables
  >(PartnerUpdateCreditMemoConfigDocument, options)
}
export type PartnerUpdateCreditMemoConfigMutationHookResult = ReturnType<
  typeof usePartnerUpdateCreditMemoConfigMutation
>
export type PartnerUpdateCreditMemoConfigMutationResult =
  Apollo.MutationResult<PartnerUpdateCreditMemoConfigMutation>
export type PartnerUpdateCreditMemoConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateCreditMemoConfigMutation,
    PartnerUpdateCreditMemoConfigMutationVariables
  >
export const PartnerUpdateCreditMemoConfigExceptionsDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateCreditMemoConfigExceptions(
    $input: UpdateCreditMemoConfigExceptionsInput!
  ) {
    PartnerUpdateCreditMemoConfigExceptions(input: $input) {
      ...PartnerCreditMemoConfig
    }
  }
  ${PartnerCreditMemoConfigFragmentDoc}
`
export type PartnerUpdateCreditMemoConfigExceptionsMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateCreditMemoConfigExceptionsMutation,
    PartnerUpdateCreditMemoConfigExceptionsMutationVariables
  >

/**
 * __usePartnerUpdateCreditMemoConfigExceptionsMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateCreditMemoConfigExceptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateCreditMemoConfigExceptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateCreditMemoConfigExceptionsMutation, { data, loading, error }] = usePartnerUpdateCreditMemoConfigExceptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateCreditMemoConfigExceptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateCreditMemoConfigExceptionsMutation,
    PartnerUpdateCreditMemoConfigExceptionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateCreditMemoConfigExceptionsMutation,
    PartnerUpdateCreditMemoConfigExceptionsMutationVariables
  >(PartnerUpdateCreditMemoConfigExceptionsDocument, options)
}
export type PartnerUpdateCreditMemoConfigExceptionsMutationHookResult =
  ReturnType<typeof usePartnerUpdateCreditMemoConfigExceptionsMutation>
export type PartnerUpdateCreditMemoConfigExceptionsMutationResult =
  Apollo.MutationResult<PartnerUpdateCreditMemoConfigExceptionsMutation>
export type PartnerUpdateCreditMemoConfigExceptionsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateCreditMemoConfigExceptionsMutation,
    PartnerUpdateCreditMemoConfigExceptionsMutationVariables
  >
export const PartnerResyncCustomerCreditMemoBalanceDocument = /*#__PURE__*/ gql`
  mutation PartnerResyncCustomerCreditMemoBalance($customerID: ID!) {
    PartnerResyncCustomerCreditMemoBalance(customerID: $customerID) {
      ...PartnerCustomerCreditMemoBalance
    }
  }
  ${PartnerCustomerCreditMemoBalanceFragmentDoc}
`
export type PartnerResyncCustomerCreditMemoBalanceMutationFn =
  Apollo.MutationFunction<
    PartnerResyncCustomerCreditMemoBalanceMutation,
    PartnerResyncCustomerCreditMemoBalanceMutationVariables
  >

/**
 * __usePartnerResyncCustomerCreditMemoBalanceMutation__
 *
 * To run a mutation, you first call `usePartnerResyncCustomerCreditMemoBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerResyncCustomerCreditMemoBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerResyncCustomerCreditMemoBalanceMutation, { data, loading, error }] = usePartnerResyncCustomerCreditMemoBalanceMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerResyncCustomerCreditMemoBalanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerResyncCustomerCreditMemoBalanceMutation,
    PartnerResyncCustomerCreditMemoBalanceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerResyncCustomerCreditMemoBalanceMutation,
    PartnerResyncCustomerCreditMemoBalanceMutationVariables
  >(PartnerResyncCustomerCreditMemoBalanceDocument, options)
}
export type PartnerResyncCustomerCreditMemoBalanceMutationHookResult =
  ReturnType<typeof usePartnerResyncCustomerCreditMemoBalanceMutation>
export type PartnerResyncCustomerCreditMemoBalanceMutationResult =
  Apollo.MutationResult<PartnerResyncCustomerCreditMemoBalanceMutation>
export type PartnerResyncCustomerCreditMemoBalanceMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerResyncCustomerCreditMemoBalanceMutation,
    PartnerResyncCustomerCreditMemoBalanceMutationVariables
  >
export const PartnerListCreditMemosDocument = /*#__PURE__*/ gql`
  query PartnerListCreditMemos(
    $filters: CreditMemoFiltersInput
    $page: Int
    $pageSize: Int
    $order: CreditMemoOrderInput
  ) {
    PartnerListCreditMemos(
      filters: $filters
      page: $page
      pageSize: $pageSize
      order: $order
    ) {
      creditMemos {
        ...CreditMemoDetailFields
      }
      pagination {
        page
        pageSize
        totalItems
        totalPages
      }
      lastSyncedAt
    }
  }
  ${CreditMemoDetailFieldsFragmentDoc}
`

/**
 * __usePartnerListCreditMemosQuery__
 *
 * To run a query within a React component, call `usePartnerListCreditMemosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCreditMemosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCreditMemosQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerListCreditMemosQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCreditMemosQuery,
    PartnerListCreditMemosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCreditMemosQuery,
    PartnerListCreditMemosQueryVariables
  >(PartnerListCreditMemosDocument, options)
}
export function usePartnerListCreditMemosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCreditMemosQuery,
    PartnerListCreditMemosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCreditMemosQuery,
    PartnerListCreditMemosQueryVariables
  >(PartnerListCreditMemosDocument, options)
}
export type PartnerListCreditMemosQueryHookResult = ReturnType<
  typeof usePartnerListCreditMemosQuery
>
export type PartnerListCreditMemosLazyQueryHookResult = ReturnType<
  typeof usePartnerListCreditMemosLazyQuery
>
export type PartnerListCreditMemosQueryResult = Apollo.QueryResult<
  PartnerListCreditMemosQuery,
  PartnerListCreditMemosQueryVariables
>
export const PartnerListCreditMemosByCustomerIdDocument = /*#__PURE__*/ gql`
  query PartnerListCreditMemosByCustomerId(
    $customerID: ID!
    $filters: CreditMemoFiltersInput
    $page: Int
    $pageSize: Int
    $order: CreditMemoOrderInput
  ) {
    PartnerListCreditMemosByCustomerId(
      customerID: $customerID
      filters: $filters
      page: $page
      pageSize: $pageSize
      order: $order
    ) {
      creditMemos {
        ...CreditMemoDetailFields
      }
      pagination {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
  ${CreditMemoDetailFieldsFragmentDoc}
`

/**
 * __usePartnerListCreditMemosByCustomerIdQuery__
 *
 * To run a query within a React component, call `usePartnerListCreditMemosByCustomerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCreditMemosByCustomerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCreditMemosByCustomerIdQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerListCreditMemosByCustomerIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListCreditMemosByCustomerIdQuery,
    PartnerListCreditMemosByCustomerIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCreditMemosByCustomerIdQuery,
    PartnerListCreditMemosByCustomerIdQueryVariables
  >(PartnerListCreditMemosByCustomerIdDocument, options)
}
export function usePartnerListCreditMemosByCustomerIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCreditMemosByCustomerIdQuery,
    PartnerListCreditMemosByCustomerIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCreditMemosByCustomerIdQuery,
    PartnerListCreditMemosByCustomerIdQueryVariables
  >(PartnerListCreditMemosByCustomerIdDocument, options)
}
export type PartnerListCreditMemosByCustomerIdQueryHookResult = ReturnType<
  typeof usePartnerListCreditMemosByCustomerIdQuery
>
export type PartnerListCreditMemosByCustomerIdLazyQueryHookResult = ReturnType<
  typeof usePartnerListCreditMemosByCustomerIdLazyQuery
>
export type PartnerListCreditMemosByCustomerIdQueryResult = Apollo.QueryResult<
  PartnerListCreditMemosByCustomerIdQuery,
  PartnerListCreditMemosByCustomerIdQueryVariables
>
export const PartnerGetCreditMemoDetailsDocument = /*#__PURE__*/ gql`
  query PartnerGetCreditMemoDetails($id: ID!) {
    PartnerGetCreditMemoDetails(id: $id) {
      ...CreditMemoDetailFields
      externalNote
      internalNote
    }
  }
  ${CreditMemoDetailFieldsFragmentDoc}
`

/**
 * __usePartnerGetCreditMemoDetailsQuery__
 *
 * To run a query within a React component, call `usePartnerGetCreditMemoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCreditMemoDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCreditMemoDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetCreditMemoDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCreditMemoDetailsQuery,
    PartnerGetCreditMemoDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCreditMemoDetailsQuery,
    PartnerGetCreditMemoDetailsQueryVariables
  >(PartnerGetCreditMemoDetailsDocument, options)
}
export function usePartnerGetCreditMemoDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCreditMemoDetailsQuery,
    PartnerGetCreditMemoDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCreditMemoDetailsQuery,
    PartnerGetCreditMemoDetailsQueryVariables
  >(PartnerGetCreditMemoDetailsDocument, options)
}
export type PartnerGetCreditMemoDetailsQueryHookResult = ReturnType<
  typeof usePartnerGetCreditMemoDetailsQuery
>
export type PartnerGetCreditMemoDetailsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCreditMemoDetailsLazyQuery
>
export type PartnerGetCreditMemoDetailsQueryResult = Apollo.QueryResult<
  PartnerGetCreditMemoDetailsQuery,
  PartnerGetCreditMemoDetailsQueryVariables
>
export const PartnerBatchTagCustomersDocument = /*#__PURE__*/ gql`
  mutation PartnerBatchTagCustomers($customerIDs: [ID!]!, $tagID: ID!) {
    PartnerBatchTagCustomers(customerIDs: $customerIDs, tagID: $tagID)
  }
`
export type PartnerBatchTagCustomersMutationFn = Apollo.MutationFunction<
  PartnerBatchTagCustomersMutation,
  PartnerBatchTagCustomersMutationVariables
>

/**
 * __usePartnerBatchTagCustomersMutation__
 *
 * To run a mutation, you first call `usePartnerBatchTagCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBatchTagCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBatchTagCustomersMutation, { data, loading, error }] = usePartnerBatchTagCustomersMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *      tagID: // value for 'tagID'
 *   },
 * });
 */
export function usePartnerBatchTagCustomersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBatchTagCustomersMutation,
    PartnerBatchTagCustomersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBatchTagCustomersMutation,
    PartnerBatchTagCustomersMutationVariables
  >(PartnerBatchTagCustomersDocument, options)
}
export type PartnerBatchTagCustomersMutationHookResult = ReturnType<
  typeof usePartnerBatchTagCustomersMutation
>
export type PartnerBatchTagCustomersMutationResult =
  Apollo.MutationResult<PartnerBatchTagCustomersMutation>
export type PartnerBatchTagCustomersMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBatchTagCustomersMutation,
    PartnerBatchTagCustomersMutationVariables
  >
export const PartnerDeleteCustomerTagDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCustomerTag($ID: ID!) {
    PartnerDeleteCustomerTag(ID: $ID)
  }
`
export type PartnerDeleteCustomerTagMutationFn = Apollo.MutationFunction<
  PartnerDeleteCustomerTagMutation,
  PartnerDeleteCustomerTagMutationVariables
>

/**
 * __usePartnerDeleteCustomerTagMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCustomerTagMutation, { data, loading, error }] = usePartnerDeleteCustomerTagMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function usePartnerDeleteCustomerTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCustomerTagMutation,
    PartnerDeleteCustomerTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCustomerTagMutation,
    PartnerDeleteCustomerTagMutationVariables
  >(PartnerDeleteCustomerTagDocument, options)
}
export type PartnerDeleteCustomerTagMutationHookResult = ReturnType<
  typeof usePartnerDeleteCustomerTagMutation
>
export type PartnerDeleteCustomerTagMutationResult =
  Apollo.MutationResult<PartnerDeleteCustomerTagMutation>
export type PartnerDeleteCustomerTagMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCustomerTagMutation,
    PartnerDeleteCustomerTagMutationVariables
  >
export const PartnerUpdateCustomerTagDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateCustomerTag($input: PartnerUpdateCustomerTagInput!) {
    PartnerUpdateCustomerTag(input: $input)
  }
`
export type PartnerUpdateCustomerTagMutationFn = Apollo.MutationFunction<
  PartnerUpdateCustomerTagMutation,
  PartnerUpdateCustomerTagMutationVariables
>

/**
 * __usePartnerUpdateCustomerTagMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateCustomerTagMutation, { data, loading, error }] = usePartnerUpdateCustomerTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateCustomerTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateCustomerTagMutation,
    PartnerUpdateCustomerTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateCustomerTagMutation,
    PartnerUpdateCustomerTagMutationVariables
  >(PartnerUpdateCustomerTagDocument, options)
}
export type PartnerUpdateCustomerTagMutationHookResult = ReturnType<
  typeof usePartnerUpdateCustomerTagMutation
>
export type PartnerUpdateCustomerTagMutationResult =
  Apollo.MutationResult<PartnerUpdateCustomerTagMutation>
export type PartnerUpdateCustomerTagMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateCustomerTagMutation,
    PartnerUpdateCustomerTagMutationVariables
  >
export const PartnerTagCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerTagCustomer($customerID: ID!, $tagID: ID!) {
    PartnerTagCustomer(customerID: $customerID, tagID: $tagID)
  }
`
export type PartnerTagCustomerMutationFn = Apollo.MutationFunction<
  PartnerTagCustomerMutation,
  PartnerTagCustomerMutationVariables
>

/**
 * __usePartnerTagCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerTagCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerTagCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerTagCustomerMutation, { data, loading, error }] = usePartnerTagCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      tagID: // value for 'tagID'
 *   },
 * });
 */
export function usePartnerTagCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerTagCustomerMutation,
    PartnerTagCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerTagCustomerMutation,
    PartnerTagCustomerMutationVariables
  >(PartnerTagCustomerDocument, options)
}
export type PartnerTagCustomerMutationHookResult = ReturnType<
  typeof usePartnerTagCustomerMutation
>
export type PartnerTagCustomerMutationResult =
  Apollo.MutationResult<PartnerTagCustomerMutation>
export type PartnerTagCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerTagCustomerMutation,
  PartnerTagCustomerMutationVariables
>
export const PartnerUntagCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUntagCustomer($customerID: ID!, $tagID: ID!) {
    PartnerUntagCustomer(customerID: $customerID, tagID: $tagID)
  }
`
export type PartnerUntagCustomerMutationFn = Apollo.MutationFunction<
  PartnerUntagCustomerMutation,
  PartnerUntagCustomerMutationVariables
>

/**
 * __usePartnerUntagCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUntagCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUntagCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUntagCustomerMutation, { data, loading, error }] = usePartnerUntagCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      tagID: // value for 'tagID'
 *   },
 * });
 */
export function usePartnerUntagCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUntagCustomerMutation,
    PartnerUntagCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUntagCustomerMutation,
    PartnerUntagCustomerMutationVariables
  >(PartnerUntagCustomerDocument, options)
}
export type PartnerUntagCustomerMutationHookResult = ReturnType<
  typeof usePartnerUntagCustomerMutation
>
export type PartnerUntagCustomerMutationResult =
  Apollo.MutationResult<PartnerUntagCustomerMutation>
export type PartnerUntagCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerUntagCustomerMutation,
  PartnerUntagCustomerMutationVariables
>
export const PartnerListCustomerTagsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerTags($filter: TagFilter) {
    PartnerListCustomerTags(filter: $filter) {
      ID
      name
      description
      color
      customerIDs
      type
    }
  }
`

/**
 * __usePartnerListCustomerTagsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerListCustomerTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >(PartnerListCustomerTagsDocument, options)
}
export function usePartnerListCustomerTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >(PartnerListCustomerTagsDocument, options)
}
export type PartnerListCustomerTagsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerTagsQuery
>
export type PartnerListCustomerTagsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerTagsLazyQuery
>
export type PartnerListCustomerTagsQueryResult = Apollo.QueryResult<
  PartnerListCustomerTagsQuery,
  PartnerListCustomerTagsQueryVariables
>
export const PartnerCreateCustomerTagDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomerTag($input: PartnerCreateCustomerTagInput!) {
    PartnerCreateCustomerTag(input: $input)
  }
`
export type PartnerCreateCustomerTagMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerTagMutation,
  PartnerCreateCustomerTagMutationVariables
>

/**
 * __usePartnerCreateCustomerTagMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerTagMutation, { data, loading, error }] = usePartnerCreateCustomerTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCustomerTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerTagMutation,
    PartnerCreateCustomerTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerTagMutation,
    PartnerCreateCustomerTagMutationVariables
  >(PartnerCreateCustomerTagDocument, options)
}
export type PartnerCreateCustomerTagMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerTagMutation
>
export type PartnerCreateCustomerTagMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerTagMutation>
export type PartnerCreateCustomerTagMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCustomerTagMutation,
    PartnerCreateCustomerTagMutationVariables
  >
export const PartnerCustomerWithInvoicesDataConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerWithInvoicesDataConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerFilter
    $orderBy: CustomerOrderBy
  ) {
    PartnerCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerCustomerListWithInvoicesData
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerListWithInvoicesDataFragmentDoc}
`

/**
 * __usePartnerCustomerWithInvoicesDataConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerWithInvoicesDataConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerWithInvoicesDataConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerWithInvoicesDataConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerWithInvoicesDataConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >(PartnerCustomerWithInvoicesDataConnectionDocument, options)
}
export function usePartnerCustomerWithInvoicesDataConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >(PartnerCustomerWithInvoicesDataConnectionDocument, options)
}
export type PartnerCustomerWithInvoicesDataConnectionQueryHookResult =
  ReturnType<typeof usePartnerCustomerWithInvoicesDataConnectionQuery>
export type PartnerCustomerWithInvoicesDataConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerWithInvoicesDataConnectionLazyQuery>
export type PartnerCustomerWithInvoicesDataConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >
export const PartnerCustomerWithCustomerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerWithCustomerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerFilter
    $orderBy: CustomerOrderBy
  ) {
    PartnerCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...CustomerWithCustomerUserList
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
  ${CustomerWithCustomerUserListFragmentDoc}
`

/**
 * __usePartnerCustomerWithCustomerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerWithCustomerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerWithCustomerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerWithCustomerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerWithCustomerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerWithCustomerUserConnectionQuery,
    PartnerCustomerWithCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerWithCustomerUserConnectionQuery,
    PartnerCustomerWithCustomerUserConnectionQueryVariables
  >(PartnerCustomerWithCustomerUserConnectionDocument, options)
}
export function usePartnerCustomerWithCustomerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerWithCustomerUserConnectionQuery,
    PartnerCustomerWithCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerWithCustomerUserConnectionQuery,
    PartnerCustomerWithCustomerUserConnectionQueryVariables
  >(PartnerCustomerWithCustomerUserConnectionDocument, options)
}
export type PartnerCustomerWithCustomerUserConnectionQueryHookResult =
  ReturnType<typeof usePartnerCustomerWithCustomerUserConnectionQuery>
export type PartnerCustomerWithCustomerUserConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerWithCustomerUserConnectionLazyQuery>
export type PartnerCustomerWithCustomerUserConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerWithCustomerUserConnectionQuery,
    PartnerCustomerWithCustomerUserConnectionQueryVariables
  >
export const PartnerCustomerConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerFilter
    $orderBy: CustomerOrderBy
  ) {
    PartnerCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerCustomerList
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerListFragmentDoc}
`

/**
 * __usePartnerCustomerConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >(PartnerCustomerConnectionDocument, options)
}
export function usePartnerCustomerConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >(PartnerCustomerConnectionDocument, options)
}
export type PartnerCustomerConnectionQueryHookResult = ReturnType<
  typeof usePartnerCustomerConnectionQuery
>
export type PartnerCustomerConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerCustomerConnectionLazyQuery
>
export type PartnerCustomerConnectionQueryResult = Apollo.QueryResult<
  PartnerCustomerConnectionQuery,
  PartnerCustomerConnectionQueryVariables
>
export const PartnerCustomerConnectionWithRelationsDocument = /*#__PURE__*/ gql`
  query PartnerCustomerConnectionWithRelations(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerFilter
    $orderBy: CustomerOrderBy
  ) {
    PartnerCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerCustomerList
          relations {
            platformName
            externalID
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerListFragmentDoc}
`

/**
 * __usePartnerCustomerConnectionWithRelationsQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerConnectionWithRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerConnectionWithRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerConnectionWithRelationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerConnectionWithRelationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerConnectionWithRelationsQuery,
    PartnerCustomerConnectionWithRelationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerConnectionWithRelationsQuery,
    PartnerCustomerConnectionWithRelationsQueryVariables
  >(PartnerCustomerConnectionWithRelationsDocument, options)
}
export function usePartnerCustomerConnectionWithRelationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerConnectionWithRelationsQuery,
    PartnerCustomerConnectionWithRelationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerConnectionWithRelationsQuery,
    PartnerCustomerConnectionWithRelationsQueryVariables
  >(PartnerCustomerConnectionWithRelationsDocument, options)
}
export type PartnerCustomerConnectionWithRelationsQueryHookResult = ReturnType<
  typeof usePartnerCustomerConnectionWithRelationsQuery
>
export type PartnerCustomerConnectionWithRelationsLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerConnectionWithRelationsLazyQuery>
export type PartnerCustomerConnectionWithRelationsQueryResult =
  Apollo.QueryResult<
    PartnerCustomerConnectionWithRelationsQuery,
    PartnerCustomerConnectionWithRelationsQueryVariables
  >
export const PartnerListCustomersTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomersTotals($filter: CustomerFilter) {
    PartnerListCustomersTotals(filter: $filter) {
      count
    }
  }
`

/**
 * __usePartnerListCustomersTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomersTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomersTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomersTotalsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerListCustomersTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >(PartnerListCustomersTotalsDocument, options)
}
export function usePartnerListCustomersTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >(PartnerListCustomersTotalsDocument, options)
}
export type PartnerListCustomersTotalsQueryHookResult = ReturnType<
  typeof usePartnerListCustomersTotalsQuery
>
export type PartnerListCustomersTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomersTotalsLazyQuery
>
export type PartnerListCustomersTotalsQueryResult = Apollo.QueryResult<
  PartnerListCustomersTotalsQuery,
  PartnerListCustomersTotalsQueryVariables
>
export const PartnerListCustomersV2Document = /*#__PURE__*/ gql`
  query PartnerListCustomersV2(
    $page: Int!
    $pageSize: Int!
    $filters: PartnerListCustomersFilter
    $order: PartnerListCustomersOrder
  ) {
    PartnerListCustomers(
      page: $page
      pageSize: $pageSize
      filters: $filters
      order: $order
    ) {
      customers {
        ...CustomerV2Fields
      }
      pagination {
        page
        pageSize
        totalItems
        totalPages
      }
      summary {
        totalItems
      }
    }
  }
  ${CustomerV2FieldsFragmentDoc}
`

/**
 * __usePartnerListCustomersV2Query__
 *
 * To run a query within a React component, call `usePartnerListCustomersV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomersV2Query({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerListCustomersV2Query(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListCustomersV2Query,
    PartnerListCustomersV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomersV2Query,
    PartnerListCustomersV2QueryVariables
  >(PartnerListCustomersV2Document, options)
}
export function usePartnerListCustomersV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomersV2Query,
    PartnerListCustomersV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomersV2Query,
    PartnerListCustomersV2QueryVariables
  >(PartnerListCustomersV2Document, options)
}
export type PartnerListCustomersV2QueryHookResult = ReturnType<
  typeof usePartnerListCustomersV2Query
>
export type PartnerListCustomersV2LazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomersV2LazyQuery
>
export type PartnerListCustomersV2QueryResult = Apollo.QueryResult<
  PartnerListCustomersV2Query,
  PartnerListCustomersV2QueryVariables
>
export const PartnerGetCustomerV2Document = /*#__PURE__*/ gql`
  query PartnerGetCustomerV2($id: ID!) {
    PartnerGetCustomer(id: $id) {
      ...CustomerV2Fields
      partner {
        id
        paymentsPortalUrl
      }
    }
  }
  ${CustomerV2FieldsFragmentDoc}
`

/**
 * __usePartnerGetCustomerV2Query__
 *
 * To run a query within a React component, call `usePartnerGetCustomerV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetCustomerV2Query(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerV2Query,
    PartnerGetCustomerV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerV2Query,
    PartnerGetCustomerV2QueryVariables
  >(PartnerGetCustomerV2Document, options)
}
export function usePartnerGetCustomerV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerV2Query,
    PartnerGetCustomerV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerV2Query,
    PartnerGetCustomerV2QueryVariables
  >(PartnerGetCustomerV2Document, options)
}
export type PartnerGetCustomerV2QueryHookResult = ReturnType<
  typeof usePartnerGetCustomerV2Query
>
export type PartnerGetCustomerV2LazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerV2LazyQuery
>
export type PartnerGetCustomerV2QueryResult = Apollo.QueryResult<
  PartnerGetCustomerV2Query,
  PartnerGetCustomerV2QueryVariables
>
export const PartnerGetCustomerSummaryDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomerSummary($id: ID!) {
    PartnerGetCustomerSummary(id: $id) {
      invoiceCount
      autopayInvoiceCount
      hasPaymentMethod
    }
  }
`

/**
 * __usePartnerGetCustomerSummaryQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomerSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetCustomerSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerSummaryQuery,
    PartnerGetCustomerSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerSummaryQuery,
    PartnerGetCustomerSummaryQueryVariables
  >(PartnerGetCustomerSummaryDocument, options)
}
export function usePartnerGetCustomerSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerSummaryQuery,
    PartnerGetCustomerSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerSummaryQuery,
    PartnerGetCustomerSummaryQueryVariables
  >(PartnerGetCustomerSummaryDocument, options)
}
export type PartnerGetCustomerSummaryQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerSummaryQuery
>
export type PartnerGetCustomerSummaryLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerSummaryLazyQuery
>
export type PartnerGetCustomerSummaryQueryResult = Apollo.QueryResult<
  PartnerGetCustomerSummaryQuery,
  PartnerGetCustomerSummaryQueryVariables
>
export const PartnerGetCustomersSummaryDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomersSummary {
    PartnerGetCustomersSummary {
      customersWithNonAutopayInvoices
      customers60PlusOverdue
      customersWithoutPaymentMethod
    }
  }
`

/**
 * __usePartnerGetCustomersSummaryQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomersSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomersSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomersSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetCustomersSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetCustomersSummaryQuery,
    PartnerGetCustomersSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomersSummaryQuery,
    PartnerGetCustomersSummaryQueryVariables
  >(PartnerGetCustomersSummaryDocument, options)
}
export function usePartnerGetCustomersSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomersSummaryQuery,
    PartnerGetCustomersSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomersSummaryQuery,
    PartnerGetCustomersSummaryQueryVariables
  >(PartnerGetCustomersSummaryDocument, options)
}
export type PartnerGetCustomersSummaryQueryHookResult = ReturnType<
  typeof usePartnerGetCustomersSummaryQuery
>
export type PartnerGetCustomersSummaryLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomersSummaryLazyQuery
>
export type PartnerGetCustomersSummaryQueryResult = Apollo.QueryResult<
  PartnerGetCustomersSummaryQuery,
  PartnerGetCustomersSummaryQueryVariables
>
export const PartnerCustomerSearchDocument = /*#__PURE__*/ gql`
  query PartnerCustomerSearch($name: String, $first: Int = 10, $after: Cursor) {
    PartnerCustomerConnection(
      first: $first
      after: $after
      filters: { name: $name }
    ) {
      edges {
        node {
          ...PartnerCustomerSearch
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerSearchFragmentDoc}
`

/**
 * __usePartnerCustomerSearchQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePartnerCustomerSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >(PartnerCustomerSearchDocument, options)
}
export function usePartnerCustomerSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >(PartnerCustomerSearchDocument, options)
}
export type PartnerCustomerSearchQueryHookResult = ReturnType<
  typeof usePartnerCustomerSearchQuery
>
export type PartnerCustomerSearchLazyQueryHookResult = ReturnType<
  typeof usePartnerCustomerSearchLazyQuery
>
export type PartnerCustomerSearchQueryResult = Apollo.QueryResult<
  PartnerCustomerSearchQuery,
  PartnerCustomerSearchQueryVariables
>
export const PartnerArchiveCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerArchiveCustomer($input: PartnerArchiveCustomerInput!) {
    PartnerArchiveCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type PartnerArchiveCustomerMutationFn = Apollo.MutationFunction<
  PartnerArchiveCustomerMutation,
  PartnerArchiveCustomerMutationVariables
>

/**
 * __usePartnerArchiveCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerArchiveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerArchiveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerArchiveCustomerMutation, { data, loading, error }] = usePartnerArchiveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerArchiveCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerArchiveCustomerMutation,
    PartnerArchiveCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerArchiveCustomerMutation,
    PartnerArchiveCustomerMutationVariables
  >(PartnerArchiveCustomerDocument, options)
}
export type PartnerArchiveCustomerMutationHookResult = ReturnType<
  typeof usePartnerArchiveCustomerMutation
>
export type PartnerArchiveCustomerMutationResult =
  Apollo.MutationResult<PartnerArchiveCustomerMutation>
export type PartnerArchiveCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerArchiveCustomerMutation,
  PartnerArchiveCustomerMutationVariables
>
export const PartnerUnarchiveCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUnarchiveCustomer($input: PartnerUnarchiveCustomerInput!) {
    PartnerUnarchiveCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type PartnerUnarchiveCustomerMutationFn = Apollo.MutationFunction<
  PartnerUnarchiveCustomerMutation,
  PartnerUnarchiveCustomerMutationVariables
>

/**
 * __usePartnerUnarchiveCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUnarchiveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUnarchiveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUnarchiveCustomerMutation, { data, loading, error }] = usePartnerUnarchiveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUnarchiveCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUnarchiveCustomerMutation,
    PartnerUnarchiveCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUnarchiveCustomerMutation,
    PartnerUnarchiveCustomerMutationVariables
  >(PartnerUnarchiveCustomerDocument, options)
}
export type PartnerUnarchiveCustomerMutationHookResult = ReturnType<
  typeof usePartnerUnarchiveCustomerMutation
>
export type PartnerUnarchiveCustomerMutationResult =
  Apollo.MutationResult<PartnerUnarchiveCustomerMutation>
export type PartnerUnarchiveCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUnarchiveCustomerMutation,
    PartnerUnarchiveCustomerMutationVariables
  >
export const PartnerCreateCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomer($input: PartnerCreateCustomerInput) {
    PartnerCreateCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type PartnerCreateCustomerMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerMutation,
  PartnerCreateCustomerMutationVariables
>

/**
 * __usePartnerCreateCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerMutation, { data, loading, error }] = usePartnerCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerMutation,
    PartnerCreateCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerMutation,
    PartnerCreateCustomerMutationVariables
  >(PartnerCreateCustomerDocument, options)
}
export type PartnerCreateCustomerMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerMutation
>
export type PartnerCreateCustomerMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerMutation>
export type PartnerCreateCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateCustomerMutation,
  PartnerCreateCustomerMutationVariables
>
export const UpdateCustomerDocument = /*#__PURE__*/ gql`
  mutation UpdateCustomer($input: PartnerUpdateCustomerInput) {
    PartnerUpdateCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type UpdateCustomerMutationFn = Apollo.MutationFunction<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UpdateCustomerDocument, options)
}
export type UpdateCustomerMutationHookResult = ReturnType<
  typeof useUpdateCustomerMutation
>
export type UpdateCustomerMutationResult =
  Apollo.MutationResult<UpdateCustomerMutation>
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>
export const PartnerBulkToggleArchiveCustomersDocument = /*#__PURE__*/ gql`
  mutation PartnerBulkToggleArchiveCustomers(
    $input: BulkToggleArchiveCustomersInput!
  ) {
    PartnerBulkToggleArchiveCustomers(input: $input)
  }
`
export type PartnerBulkToggleArchiveCustomersMutationFn =
  Apollo.MutationFunction<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >

/**
 * __usePartnerBulkToggleArchiveCustomersMutation__
 *
 * To run a mutation, you first call `usePartnerBulkToggleArchiveCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBulkToggleArchiveCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBulkToggleArchiveCustomersMutation, { data, loading, error }] = usePartnerBulkToggleArchiveCustomersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerBulkToggleArchiveCustomersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >(PartnerBulkToggleArchiveCustomersDocument, options)
}
export type PartnerBulkToggleArchiveCustomersMutationHookResult = ReturnType<
  typeof usePartnerBulkToggleArchiveCustomersMutation
>
export type PartnerBulkToggleArchiveCustomersMutationResult =
  Apollo.MutationResult<PartnerBulkToggleArchiveCustomersMutation>
export type PartnerBulkToggleArchiveCustomersMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >
export const PartnerCustomerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerUserFilter
    $orderBy: CustomerUserOrderBy
  ) {
    PartnerCustomerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerListCustomerUsers
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerListCustomerUsersFragmentDoc}
`

/**
 * __usePartnerCustomerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >(PartnerCustomerUserConnectionDocument, options)
}
export function usePartnerCustomerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >(PartnerCustomerUserConnectionDocument, options)
}
export type PartnerCustomerUserConnectionQueryHookResult = ReturnType<
  typeof usePartnerCustomerUserConnectionQuery
>
export type PartnerCustomerUserConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerCustomerUserConnectionLazyQuery
>
export type PartnerCustomerUserConnectionQueryResult = Apollo.QueryResult<
  PartnerCustomerUserConnectionQuery,
  PartnerCustomerUserConnectionQueryVariables
>
export const PartnerArchiveCustomerAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerArchiveCustomerAccount($accountID: ID!, $customerID: ID!) {
    PartnerArchiveCustomerAccount(
      accountID: $accountID
      customerID: $customerID
    )
  }
`
export type PartnerArchiveCustomerAccountMutationFn = Apollo.MutationFunction<
  PartnerArchiveCustomerAccountMutation,
  PartnerArchiveCustomerAccountMutationVariables
>

/**
 * __usePartnerArchiveCustomerAccountMutation__
 *
 * To run a mutation, you first call `usePartnerArchiveCustomerAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerArchiveCustomerAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerArchiveCustomerAccountMutation, { data, loading, error }] = usePartnerArchiveCustomerAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerArchiveCustomerAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerArchiveCustomerAccountMutation,
    PartnerArchiveCustomerAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerArchiveCustomerAccountMutation,
    PartnerArchiveCustomerAccountMutationVariables
  >(PartnerArchiveCustomerAccountDocument, options)
}
export type PartnerArchiveCustomerAccountMutationHookResult = ReturnType<
  typeof usePartnerArchiveCustomerAccountMutation
>
export type PartnerArchiveCustomerAccountMutationResult =
  Apollo.MutationResult<PartnerArchiveCustomerAccountMutation>
export type PartnerArchiveCustomerAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerArchiveCustomerAccountMutation,
    PartnerArchiveCustomerAccountMutationVariables
  >
export const PartnerCreateCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomerUser($input: PartnerCreateCustomerUserInput) {
    PartnerCreateCustomerUser(input: $input) {
      ...PartnerCustomerUserCreation
    }
  }
  ${PartnerCustomerUserCreationFragmentDoc}
`
export type PartnerCreateCustomerUserMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerUserMutation,
  PartnerCreateCustomerUserMutationVariables
>

/**
 * __usePartnerCreateCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerUserMutation, { data, loading, error }] = usePartnerCreateCustomerUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerUserMutation,
    PartnerCreateCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerUserMutation,
    PartnerCreateCustomerUserMutationVariables
  >(PartnerCreateCustomerUserDocument, options)
}
export type PartnerCreateCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerUserMutation
>
export type PartnerCreateCustomerUserMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerUserMutation>
export type PartnerCreateCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCustomerUserMutation,
    PartnerCreateCustomerUserMutationVariables
  >
export const PartnerDeleteCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCustomerUser($id: String!) {
    PartnerDeleteCustomerUser(id: $id)
  }
`
export type PartnerDeleteCustomerUserMutationFn = Apollo.MutationFunction<
  PartnerDeleteCustomerUserMutation,
  PartnerDeleteCustomerUserMutationVariables
>

/**
 * __usePartnerDeleteCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCustomerUserMutation, { data, loading, error }] = usePartnerDeleteCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCustomerUserMutation,
    PartnerDeleteCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCustomerUserMutation,
    PartnerDeleteCustomerUserMutationVariables
  >(PartnerDeleteCustomerUserDocument, options)
}
export type PartnerDeleteCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerDeleteCustomerUserMutation
>
export type PartnerDeleteCustomerUserMutationResult =
  Apollo.MutationResult<PartnerDeleteCustomerUserMutation>
export type PartnerDeleteCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCustomerUserMutation,
    PartnerDeleteCustomerUserMutationVariables
  >
export const UpdateCustomerUserDocument = /*#__PURE__*/ gql`
  mutation UpdateCustomerUser($input: PartnerUpdateCustomerUserInput) {
    PartnerUpdateCustomerUser(input: $input) {
      ...PartnerListCustomerUsers
    }
  }
  ${PartnerListCustomerUsersFragmentDoc}
`
export type UpdateCustomerUserMutationFn = Apollo.MutationFunction<
  UpdateCustomerUserMutation,
  UpdateCustomerUserMutationVariables
>

/**
 * __useUpdateCustomerUserMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerUserMutation, { data, loading, error }] = useUpdateCustomerUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerUserMutation,
    UpdateCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCustomerUserMutation,
    UpdateCustomerUserMutationVariables
  >(UpdateCustomerUserDocument, options)
}
export type UpdateCustomerUserMutationHookResult = ReturnType<
  typeof useUpdateCustomerUserMutation
>
export type UpdateCustomerUserMutationResult =
  Apollo.MutationResult<UpdateCustomerUserMutation>
export type UpdateCustomerUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerUserMutation,
  UpdateCustomerUserMutationVariables
>
export const PartnerCreateEmailTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateEmailTemplate($input: CreateEmailTemplateInput!) {
    PartnerCreateEmailTemplate(input: $input) {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`
export type PartnerCreateEmailTemplateMutationFn = Apollo.MutationFunction<
  PartnerCreateEmailTemplateMutation,
  PartnerCreateEmailTemplateMutationVariables
>

/**
 * __usePartnerCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateEmailTemplateMutation, { data, loading, error }] = usePartnerCreateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateEmailTemplateMutation,
    PartnerCreateEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateEmailTemplateMutation,
    PartnerCreateEmailTemplateMutationVariables
  >(PartnerCreateEmailTemplateDocument, options)
}
export type PartnerCreateEmailTemplateMutationHookResult = ReturnType<
  typeof usePartnerCreateEmailTemplateMutation
>
export type PartnerCreateEmailTemplateMutationResult =
  Apollo.MutationResult<PartnerCreateEmailTemplateMutation>
export type PartnerCreateEmailTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateEmailTemplateMutation,
    PartnerCreateEmailTemplateMutationVariables
  >
export const PartnerUpdateEmailTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateEmailTemplate($input: UpdateEmailTemplateInput!) {
    PartnerUpdateEmailTemplate(input: $input)
  }
`
export type PartnerUpdateEmailTemplateMutationFn = Apollo.MutationFunction<
  PartnerUpdateEmailTemplateMutation,
  PartnerUpdateEmailTemplateMutationVariables
>

/**
 * __usePartnerUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateEmailTemplateMutation, { data, loading, error }] = usePartnerUpdateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateEmailTemplateMutation,
    PartnerUpdateEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateEmailTemplateMutation,
    PartnerUpdateEmailTemplateMutationVariables
  >(PartnerUpdateEmailTemplateDocument, options)
}
export type PartnerUpdateEmailTemplateMutationHookResult = ReturnType<
  typeof usePartnerUpdateEmailTemplateMutation
>
export type PartnerUpdateEmailTemplateMutationResult =
  Apollo.MutationResult<PartnerUpdateEmailTemplateMutation>
export type PartnerUpdateEmailTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateEmailTemplateMutation,
    PartnerUpdateEmailTemplateMutationVariables
  >
export const PartnerDeleteEmailTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteEmailTemplate($input: DeleteEmailTemplateInput!) {
    PartnerDeleteEmailTemplate(input: $input)
  }
`
export type PartnerDeleteEmailTemplateMutationFn = Apollo.MutationFunction<
  PartnerDeleteEmailTemplateMutation,
  PartnerDeleteEmailTemplateMutationVariables
>

/**
 * __usePartnerDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteEmailTemplateMutation, { data, loading, error }] = usePartnerDeleteEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerDeleteEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteEmailTemplateMutation,
    PartnerDeleteEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteEmailTemplateMutation,
    PartnerDeleteEmailTemplateMutationVariables
  >(PartnerDeleteEmailTemplateDocument, options)
}
export type PartnerDeleteEmailTemplateMutationHookResult = ReturnType<
  typeof usePartnerDeleteEmailTemplateMutation
>
export type PartnerDeleteEmailTemplateMutationResult =
  Apollo.MutationResult<PartnerDeleteEmailTemplateMutation>
export type PartnerDeleteEmailTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteEmailTemplateMutation,
    PartnerDeleteEmailTemplateMutationVariables
  >
export const PartnerToggleEmailTemplateFavoriteDocument = /*#__PURE__*/ gql`
  mutation PartnerToggleEmailTemplateFavorite($templateID: ID!) {
    PartnerToggleEmailTemplateFavorite(templateID: $templateID)
  }
`
export type PartnerToggleEmailTemplateFavoriteMutationFn =
  Apollo.MutationFunction<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >

/**
 * __usePartnerToggleEmailTemplateFavoriteMutation__
 *
 * To run a mutation, you first call `usePartnerToggleEmailTemplateFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerToggleEmailTemplateFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerToggleEmailTemplateFavoriteMutation, { data, loading, error }] = usePartnerToggleEmailTemplateFavoriteMutation({
 *   variables: {
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerToggleEmailTemplateFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >(PartnerToggleEmailTemplateFavoriteDocument, options)
}
export type PartnerToggleEmailTemplateFavoriteMutationHookResult = ReturnType<
  typeof usePartnerToggleEmailTemplateFavoriteMutation
>
export type PartnerToggleEmailTemplateFavoriteMutationResult =
  Apollo.MutationResult<PartnerToggleEmailTemplateFavoriteMutation>
export type PartnerToggleEmailTemplateFavoriteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >
export const PartnerEmailActivityConnectionDocument = /*#__PURE__*/ gql`
  query PartnerEmailActivityConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: EmailActivityFilter
  ) {
    PartnerEmailActivityConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        node {
          ...PartnerEmailActivity
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${PartnerEmailActivityFragmentDoc}
`

/**
 * __usePartnerEmailActivityConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerEmailActivityConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerEmailActivityConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerEmailActivityConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerEmailActivityConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >(PartnerEmailActivityConnectionDocument, options)
}
export function usePartnerEmailActivityConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >(PartnerEmailActivityConnectionDocument, options)
}
export type PartnerEmailActivityConnectionQueryHookResult = ReturnType<
  typeof usePartnerEmailActivityConnectionQuery
>
export type PartnerEmailActivityConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerEmailActivityConnectionLazyQuery
>
export type PartnerEmailActivityConnectionQueryResult = Apollo.QueryResult<
  PartnerEmailActivityConnectionQuery,
  PartnerEmailActivityConnectionQueryVariables
>
export const PartnerListEmailTemplatesDocument = /*#__PURE__*/ gql`
  query PartnerListEmailTemplates(
    $templateType: TemplateType!
    $favoritesOnly: Boolean
    $templateID: ID
  ) {
    PartnerListEmailTemplates(
      templateType: $templateType
      favoritesOnly: $favoritesOnly
      templateID: $templateID
    ) {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`

/**
 * __usePartnerListEmailTemplatesQuery__
 *
 * To run a query within a React component, call `usePartnerListEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListEmailTemplatesQuery({
 *   variables: {
 *      templateType: // value for 'templateType'
 *      favoritesOnly: // value for 'favoritesOnly'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerListEmailTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >(PartnerListEmailTemplatesDocument, options)
}
export function usePartnerListEmailTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >(PartnerListEmailTemplatesDocument, options)
}
export type PartnerListEmailTemplatesQueryHookResult = ReturnType<
  typeof usePartnerListEmailTemplatesQuery
>
export type PartnerListEmailTemplatesLazyQueryHookResult = ReturnType<
  typeof usePartnerListEmailTemplatesLazyQuery
>
export type PartnerListEmailTemplatesQueryResult = Apollo.QueryResult<
  PartnerListEmailTemplatesQuery,
  PartnerListEmailTemplatesQueryVariables
>
export const PartnerGetPartnerFeeConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetPartnerFeeConfig {
    PartnerGetPartnerFeeConfig {
      coverDirectPaymentFees
      coverFeeConfig {
        coverCardMethodFee
      }
    }
  }
`

/**
 * __usePartnerGetPartnerFeeConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetPartnerFeeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPartnerFeeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPartnerFeeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetPartnerFeeConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >(PartnerGetPartnerFeeConfigDocument, options)
}
export function usePartnerGetPartnerFeeConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >(PartnerGetPartnerFeeConfigDocument, options)
}
export type PartnerGetPartnerFeeConfigQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerFeeConfigQuery
>
export type PartnerGetPartnerFeeConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerFeeConfigLazyQuery
>
export type PartnerGetPartnerFeeConfigQueryResult = Apollo.QueryResult<
  PartnerGetPartnerFeeConfigQuery,
  PartnerGetPartnerFeeConfigQueryVariables
>
export const PartnerGetCustomPartnerFeeConfigsDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomPartnerFeeConfigs(
    $customPartnerFeeConfigsFilter: CustomPartnerFeeConfigsFilter
  ) {
    PartnerGetCustomPartnerFeeConfigs(
      customPartnerFeeConfigsFilter: $customPartnerFeeConfigsFilter
    ) {
      customPartnerFeeConfigs {
        paymentOriginService
        paymentExecutorType
        coverFeeConfig {
          coverACHMethodFee
          coverCardMethodFee
          coverWireMethodFee
          coverOtherMethodFee
        }
      }
    }
  }
`

/**
 * __usePartnerGetCustomPartnerFeeConfigsQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomPartnerFeeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomPartnerFeeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomPartnerFeeConfigsQuery({
 *   variables: {
 *      customPartnerFeeConfigsFilter: // value for 'customPartnerFeeConfigsFilter'
 *   },
 * });
 */
export function usePartnerGetCustomPartnerFeeConfigsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >(PartnerGetCustomPartnerFeeConfigsDocument, options)
}
export function usePartnerGetCustomPartnerFeeConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >(PartnerGetCustomPartnerFeeConfigsDocument, options)
}
export type PartnerGetCustomPartnerFeeConfigsQueryHookResult = ReturnType<
  typeof usePartnerGetCustomPartnerFeeConfigsQuery
>
export type PartnerGetCustomPartnerFeeConfigsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomPartnerFeeConfigsLazyQuery
>
export type PartnerGetCustomPartnerFeeConfigsQueryResult = Apollo.QueryResult<
  PartnerGetCustomPartnerFeeConfigsQuery,
  PartnerGetCustomPartnerFeeConfigsQueryVariables
>
export const PartnerListCustomerFeeExceptionsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerFeeExceptions(
    $input: PartnerListCustomerFeeExceptionsInput
  ) {
    PartnerListCustomerFeeExceptions(input: $input) {
      ...PartnerCustomerFeeConfig
    }
  }
  ${PartnerCustomerFeeConfigFragmentDoc}
`

/**
 * __usePartnerListCustomerFeeExceptionsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerFeeExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerFeeExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerFeeExceptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerListCustomerFeeExceptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >(PartnerListCustomerFeeExceptionsDocument, options)
}
export function usePartnerListCustomerFeeExceptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >(PartnerListCustomerFeeExceptionsDocument, options)
}
export type PartnerListCustomerFeeExceptionsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerFeeExceptionsQuery
>
export type PartnerListCustomerFeeExceptionsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerFeeExceptionsLazyQuery
>
export type PartnerListCustomerFeeExceptionsQueryResult = Apollo.QueryResult<
  PartnerListCustomerFeeExceptionsQuery,
  PartnerListCustomerFeeExceptionsQueryVariables
>
export const PartnerChangeCustomPartnerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeCustomPartnerFeeConfig(
    $customPartnerFeeConfig: CustomPartnerFeeConfigUpsertInput!
  ) {
    PartnerChangeCustomPartnerFeeConfig(
      customPartnerFeeConfig: $customPartnerFeeConfig
    )
  }
`
export type PartnerChangeCustomPartnerFeeConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >

/**
 * __usePartnerChangeCustomPartnerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeCustomPartnerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeCustomPartnerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeCustomPartnerFeeConfigMutation, { data, loading, error }] = usePartnerChangeCustomPartnerFeeConfigMutation({
 *   variables: {
 *      customPartnerFeeConfig: // value for 'customPartnerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangeCustomPartnerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >(PartnerChangeCustomPartnerFeeConfigDocument, options)
}
export type PartnerChangeCustomPartnerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeCustomPartnerFeeConfigMutation
>
export type PartnerChangeCustomPartnerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangeCustomPartnerFeeConfigMutation>
export type PartnerChangeCustomPartnerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >
export const PartnerChangeCustomerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeCustomerFeeConfig(
    $customerFeeConfig: PartnerChangeCustomerFeeConfigInput!
  ) {
    PartnerChangeCustomerFeeConfig(customerFeeConfig: $customerFeeConfig)
  }
`
export type PartnerChangeCustomerFeeConfigMutationFn = Apollo.MutationFunction<
  PartnerChangeCustomerFeeConfigMutation,
  PartnerChangeCustomerFeeConfigMutationVariables
>

/**
 * __usePartnerChangeCustomerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeCustomerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeCustomerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeCustomerFeeConfigMutation, { data, loading, error }] = usePartnerChangeCustomerFeeConfigMutation({
 *   variables: {
 *      customerFeeConfig: // value for 'customerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangeCustomerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeCustomerFeeConfigMutation,
    PartnerChangeCustomerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeCustomerFeeConfigMutation,
    PartnerChangeCustomerFeeConfigMutationVariables
  >(PartnerChangeCustomerFeeConfigDocument, options)
}
export type PartnerChangeCustomerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeCustomerFeeConfigMutation
>
export type PartnerChangeCustomerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangeCustomerFeeConfigMutation>
export type PartnerChangeCustomerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeCustomerFeeConfigMutation,
    PartnerChangeCustomerFeeConfigMutationVariables
  >
export const PartnerChangePartnerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangePartnerFeeConfig(
    $partnerFeeConfig: PartnerFeeConfigUpdateInput!
  ) {
    PartnerChangePartnerFeeConfig(partnerFeeConfig: $partnerFeeConfig)
  }
`
export type PartnerChangePartnerFeeConfigMutationFn = Apollo.MutationFunction<
  PartnerChangePartnerFeeConfigMutation,
  PartnerChangePartnerFeeConfigMutationVariables
>

/**
 * __usePartnerChangePartnerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangePartnerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangePartnerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangePartnerFeeConfigMutation, { data, loading, error }] = usePartnerChangePartnerFeeConfigMutation({
 *   variables: {
 *      partnerFeeConfig: // value for 'partnerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangePartnerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangePartnerFeeConfigMutation,
    PartnerChangePartnerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangePartnerFeeConfigMutation,
    PartnerChangePartnerFeeConfigMutationVariables
  >(PartnerChangePartnerFeeConfigDocument, options)
}
export type PartnerChangePartnerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangePartnerFeeConfigMutation
>
export type PartnerChangePartnerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangePartnerFeeConfigMutation>
export type PartnerChangePartnerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangePartnerFeeConfigMutation,
    PartnerChangePartnerFeeConfigMutationVariables
  >
export const PartnerChangeBulkCustomerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeBulkCustomerFeeConfig(
    $customerFeeConfig: PartnerChangeBulkCustomerFeeConfigInput!
  ) {
    PartnerChangeBulkCustomerFeeConfig(customerFeeConfig: $customerFeeConfig)
  }
`
export type PartnerChangeBulkCustomerFeeConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >

/**
 * __usePartnerChangeBulkCustomerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeBulkCustomerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeBulkCustomerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeBulkCustomerFeeConfigMutation, { data, loading, error }] = usePartnerChangeBulkCustomerFeeConfigMutation({
 *   variables: {
 *      customerFeeConfig: // value for 'customerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangeBulkCustomerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >(PartnerChangeBulkCustomerFeeConfigDocument, options)
}
export type PartnerChangeBulkCustomerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeBulkCustomerFeeConfigMutation
>
export type PartnerChangeBulkCustomerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangeBulkCustomerFeeConfigMutation>
export type PartnerChangeBulkCustomerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >
export const PartnerGetPassThroughFeesDocument = /*#__PURE__*/ gql`
  query PartnerGetPassThroughFees($methodNetworks: [MethodNetwork!]) {
    PartnerGetPassThroughFees(methodNetworks: $methodNetworks) {
      customerID
      methodNetwork
      fixedFeeForwarded
      percent
    }
  }
`

/**
 * __usePartnerGetPassThroughFeesQuery__
 *
 * To run a query within a React component, call `usePartnerGetPassThroughFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPassThroughFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPassThroughFeesQuery({
 *   variables: {
 *      methodNetworks: // value for 'methodNetworks'
 *   },
 * });
 */
export function usePartnerGetPassThroughFeesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPassThroughFeesQuery,
    PartnerGetPassThroughFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPassThroughFeesQuery,
    PartnerGetPassThroughFeesQueryVariables
  >(PartnerGetPassThroughFeesDocument, options)
}
export function usePartnerGetPassThroughFeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPassThroughFeesQuery,
    PartnerGetPassThroughFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPassThroughFeesQuery,
    PartnerGetPassThroughFeesQueryVariables
  >(PartnerGetPassThroughFeesDocument, options)
}
export type PartnerGetPassThroughFeesQueryHookResult = ReturnType<
  typeof usePartnerGetPassThroughFeesQuery
>
export type PartnerGetPassThroughFeesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPassThroughFeesLazyQuery
>
export type PartnerGetPassThroughFeesQueryResult = Apollo.QueryResult<
  PartnerGetPassThroughFeesQuery,
  PartnerGetPassThroughFeesQueryVariables
>
export const PartnerUpsertPassThroughFeesDocument = /*#__PURE__*/ gql`
  mutation PartnerUpsertPassThroughFees(
    $input: PartnerUpsertPassThroughFeesInput!
  ) {
    PartnerUpsertPassThroughFees(input: $input)
  }
`
export type PartnerUpsertPassThroughFeesMutationFn = Apollo.MutationFunction<
  PartnerUpsertPassThroughFeesMutation,
  PartnerUpsertPassThroughFeesMutationVariables
>

/**
 * __usePartnerUpsertPassThroughFeesMutation__
 *
 * To run a mutation, you first call `usePartnerUpsertPassThroughFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpsertPassThroughFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpsertPassThroughFeesMutation, { data, loading, error }] = usePartnerUpsertPassThroughFeesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpsertPassThroughFeesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpsertPassThroughFeesMutation,
    PartnerUpsertPassThroughFeesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpsertPassThroughFeesMutation,
    PartnerUpsertPassThroughFeesMutationVariables
  >(PartnerUpsertPassThroughFeesDocument, options)
}
export type PartnerUpsertPassThroughFeesMutationHookResult = ReturnType<
  typeof usePartnerUpsertPassThroughFeesMutation
>
export type PartnerUpsertPassThroughFeesMutationResult =
  Apollo.MutationResult<PartnerUpsertPassThroughFeesMutation>
export type PartnerUpsertPassThroughFeesMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpsertPassThroughFeesMutation,
    PartnerUpsertPassThroughFeesMutationVariables
  >
export const PartnerGetAdminCardFeesConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetAdminCardFeesConfig {
    PartnerGetAdminCardFeesConfig {
      cardNetwork
      percentage
    }
  }
`

/**
 * __usePartnerGetAdminCardFeesConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetAdminCardFeesConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAdminCardFeesConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAdminCardFeesConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetAdminCardFeesConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetAdminCardFeesConfigQuery,
    PartnerGetAdminCardFeesConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAdminCardFeesConfigQuery,
    PartnerGetAdminCardFeesConfigQueryVariables
  >(PartnerGetAdminCardFeesConfigDocument, options)
}
export function usePartnerGetAdminCardFeesConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAdminCardFeesConfigQuery,
    PartnerGetAdminCardFeesConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAdminCardFeesConfigQuery,
    PartnerGetAdminCardFeesConfigQueryVariables
  >(PartnerGetAdminCardFeesConfigDocument, options)
}
export type PartnerGetAdminCardFeesConfigQueryHookResult = ReturnType<
  typeof usePartnerGetAdminCardFeesConfigQuery
>
export type PartnerGetAdminCardFeesConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAdminCardFeesConfigLazyQuery
>
export type PartnerGetAdminCardFeesConfigQueryResult = Apollo.QueryResult<
  PartnerGetAdminCardFeesConfigQuery,
  PartnerGetAdminCardFeesConfigQueryVariables
>
export const GetCustomerInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetCustomerInsightsGraphs(
    $dateFrom: String!
    $dateTo: String!
    $customerID: String!
  ) {
    PartnerGetInvoiceAmountByStatusMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        ...InvoiceAmountMonth
      }
      average
    }
    PartnerGetAverageTimeToPayByMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetPaymentVolumeByMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        month
        percent
      }
      average
    }
  }
  ${InvoiceAmountMonthFragmentDoc}
  ${DataPointFragmentDoc}
`

/**
 * __useGetCustomerInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetCustomerInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function useGetCustomerInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >(GetCustomerInsightsGraphsDocument, options)
}
export function useGetCustomerInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >(GetCustomerInsightsGraphsDocument, options)
}
export type GetCustomerInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsGraphsQuery
>
export type GetCustomerInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsGraphsLazyQuery
>
export type GetCustomerInsightsGraphsQueryResult = Apollo.QueryResult<
  GetCustomerInsightsGraphsQuery,
  GetCustomerInsightsGraphsQueryVariables
>
export const GetCustomerInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetCustomerInsightsMetrics(
    $dateFrom: String!
    $dateTo: String!
    $customerID: String!
  ) {
    PartnerGetPaymentVolumeCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetNumberOfPaymentsCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetAverageTimeToPayCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetAutomatedPaymentsCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetInvoiceVolumeCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
  }
`

/**
 * __useGetCustomerInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetCustomerInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function useGetCustomerInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >(GetCustomerInsightsMetricsDocument, options)
}
export function useGetCustomerInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >(GetCustomerInsightsMetricsDocument, options)
}
export type GetCustomerInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsMetricsQuery
>
export type GetCustomerInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsMetricsLazyQuery
>
export type GetCustomerInsightsMetricsQueryResult = Apollo.QueryResult<
  GetCustomerInsightsMetricsQuery,
  GetCustomerInsightsMetricsQueryVariables
>
export const GetInsightOverviewMetricsDocument = /*#__PURE__*/ gql`
  query GetInsightOverviewMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetPaymentVolumeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetNumberOfPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAutomatedPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetNumberOfOverdueInvoicesThirtyDaysInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoicesVolumeThirtyDaysInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoiceVolumeInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoicePercentageInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAverageTimeToPayInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
  }
`

/**
 * __useGetInsightOverviewMetricsQuery__
 *
 * To run a query within a React component, call `useGetInsightOverviewMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightOverviewMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightOverviewMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInsightOverviewMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >(GetInsightOverviewMetricsDocument, options)
}
export function useGetInsightOverviewMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >(GetInsightOverviewMetricsDocument, options)
}
export type GetInsightOverviewMetricsQueryHookResult = ReturnType<
  typeof useGetInsightOverviewMetricsQuery
>
export type GetInsightOverviewMetricsLazyQueryHookResult = ReturnType<
  typeof useGetInsightOverviewMetricsLazyQuery
>
export type GetInsightOverviewMetricsQueryResult = Apollo.QueryResult<
  GetInsightOverviewMetricsQuery,
  GetInsightOverviewMetricsQueryVariables
>
export const GetOverdueRateCohortDocument = /*#__PURE__*/ gql`
  query GetOverdueRateCohort(
    $dateFrom: String!
    $dateTo: String!
    $prevDateFrom: String!
    $prevDateTo: String!
  ) {
    current: PartnerGetOverdueRateAtMaturityInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
      maturedCount
    }
    previous: PartnerGetOverdueRateAtMaturityInsight(
      dateFrom: $prevDateFrom
      dateTo: $prevDateTo
    ) {
      value
      maturedCount
    }
  }
`

/**
 * __useGetOverdueRateCohortQuery__
 *
 * To run a query within a React component, call `useGetOverdueRateCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverdueRateCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverdueRateCohortQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      prevDateFrom: // value for 'prevDateFrom'
 *      prevDateTo: // value for 'prevDateTo'
 *   },
 * });
 */
export function useGetOverdueRateCohortQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOverdueRateCohortQuery,
    GetOverdueRateCohortQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetOverdueRateCohortQuery,
    GetOverdueRateCohortQueryVariables
  >(GetOverdueRateCohortDocument, options)
}
export function useGetOverdueRateCohortLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOverdueRateCohortQuery,
    GetOverdueRateCohortQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetOverdueRateCohortQuery,
    GetOverdueRateCohortQueryVariables
  >(GetOverdueRateCohortDocument, options)
}
export type GetOverdueRateCohortQueryHookResult = ReturnType<
  typeof useGetOverdueRateCohortQuery
>
export type GetOverdueRateCohortLazyQueryHookResult = ReturnType<
  typeof useGetOverdueRateCohortLazyQuery
>
export type GetOverdueRateCohortQueryResult = Apollo.QueryResult<
  GetOverdueRateCohortQuery,
  GetOverdueRateCohortQueryVariables
>
export const GetCollectionsTimeComparisonDocument = /*#__PURE__*/ gql`
  query GetCollectionsTimeComparison(
    $dateFrom: String!
    $dateTo: String!
    $prevDateFrom: String!
    $prevDateTo: String!
  ) {
    current: PartnerGetAverageTimeToPayInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    previous: PartnerGetAverageTimeToPayInsight(
      dateFrom: $prevDateFrom
      dateTo: $prevDateTo
    ) {
      value
    }
  }
`

/**
 * __useGetCollectionsTimeComparisonQuery__
 *
 * To run a query within a React component, call `useGetCollectionsTimeComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsTimeComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsTimeComparisonQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      prevDateFrom: // value for 'prevDateFrom'
 *      prevDateTo: // value for 'prevDateTo'
 *   },
 * });
 */
export function useGetCollectionsTimeComparisonQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsTimeComparisonQuery,
    GetCollectionsTimeComparisonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCollectionsTimeComparisonQuery,
    GetCollectionsTimeComparisonQueryVariables
  >(GetCollectionsTimeComparisonDocument, options)
}
export function useGetCollectionsTimeComparisonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsTimeComparisonQuery,
    GetCollectionsTimeComparisonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCollectionsTimeComparisonQuery,
    GetCollectionsTimeComparisonQueryVariables
  >(GetCollectionsTimeComparisonDocument, options)
}
export type GetCollectionsTimeComparisonQueryHookResult = ReturnType<
  typeof useGetCollectionsTimeComparisonQuery
>
export type GetCollectionsTimeComparisonLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsTimeComparisonLazyQuery
>
export type GetCollectionsTimeComparisonQueryResult = Apollo.QueryResult<
  GetCollectionsTimeComparisonQuery,
  GetCollectionsTimeComparisonQueryVariables
>
export const GetInsightOverviewGraphsDocument = /*#__PURE__*/ gql`
  query GetInsightOverviewGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetAverageTimeToPayByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetPaymentVolumeByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAutomatedPaymentsByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetActivationRatesByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
  }
  ${DataPointFragmentDoc}
`

/**
 * __useGetInsightOverviewGraphsQuery__
 *
 * To run a query within a React component, call `useGetInsightOverviewGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightOverviewGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightOverviewGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInsightOverviewGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >(GetInsightOverviewGraphsDocument, options)
}
export function useGetInsightOverviewGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >(GetInsightOverviewGraphsDocument, options)
}
export type GetInsightOverviewGraphsQueryHookResult = ReturnType<
  typeof useGetInsightOverviewGraphsQuery
>
export type GetInsightOverviewGraphsLazyQueryHookResult = ReturnType<
  typeof useGetInsightOverviewGraphsLazyQuery
>
export type GetInsightOverviewGraphsQueryResult = Apollo.QueryResult<
  GetInsightOverviewGraphsQuery,
  GetInsightOverviewGraphsQueryVariables
>
export const GetInvoicesInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetInvoiceVolumeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetInvoiceCountInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageInvoiceAmountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoicePercentageInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetInvoicesInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >(GetInvoicesInsightsMetricsDocument, options)
}
export function useGetInvoicesInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >(GetInvoicesInsightsMetricsDocument, options)
}
export type GetInvoicesInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsMetricsQuery
>
export type GetInvoicesInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsMetricsLazyQuery
>
export type GetInvoicesInsightsMetricsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsMetricsQuery,
  GetInvoicesInsightsMetricsQueryVariables
>
export const GetInvoicesInsightsArMetricsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsARMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetOverdueInvoiceVolumeInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoiceCountInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageOverdueAmountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAverageDaysOverdueInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
  }
`

/**
 * __useGetInvoicesInsightsArMetricsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsArMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsArMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsArMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsArMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >(GetInvoicesInsightsArMetricsDocument, options)
}
export function useGetInvoicesInsightsArMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >(GetInvoicesInsightsArMetricsDocument, options)
}
export type GetInvoicesInsightsArMetricsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArMetricsQuery
>
export type GetInvoicesInsightsArMetricsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArMetricsLazyQuery
>
export type GetInvoicesInsightsArMetricsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsArMetricsQuery,
  GetInvoicesInsightsArMetricsQueryVariables
>
export const GetInvoicesInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetInvoiceAmountByStatusMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...InvoiceAmountMonth
      }
      average
    }
    PartnerGetInvoiceCountByStatusMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...InvoiceCountMonth
      }
      average
    }
  }
  ${InvoiceAmountMonthFragmentDoc}
  ${InvoiceCountMonthFragmentDoc}
`

/**
 * __useGetInvoicesInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >(GetInvoicesInsightsGraphsDocument, options)
}
export function useGetInvoicesInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >(GetInvoicesInsightsGraphsDocument, options)
}
export type GetInvoicesInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsGraphsQuery
>
export type GetInvoicesInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsGraphsLazyQuery
>
export type GetInvoicesInsightsGraphsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsGraphsQuery,
  GetInvoicesInsightsGraphsQueryVariables
>
export const GetInvoicesInsightsArGraphsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsARGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetARAgingBucketsAmountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...BucketAmountData
      }
    }
    PartnerGetARAgingBucketsCountInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      data {
        ...BucketCountData
      }
    }
  }
  ${BucketAmountDataFragmentDoc}
  ${BucketCountDataFragmentDoc}
`

/**
 * __useGetInvoicesInsightsArGraphsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsArGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsArGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsArGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsArGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >(GetInvoicesInsightsArGraphsDocument, options)
}
export function useGetInvoicesInsightsArGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >(GetInvoicesInsightsArGraphsDocument, options)
}
export type GetInvoicesInsightsArGraphsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArGraphsQuery
>
export type GetInvoicesInsightsArGraphsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArGraphsLazyQuery
>
export type GetInvoicesInsightsArGraphsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsArGraphsQuery,
  GetInvoicesInsightsArGraphsQueryVariables
>
export const GetPaymentsInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetPaymentsInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetPaymentVolumeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetNumberOfPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAveragePaymentSizeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
  }
`

/**
 * __useGetPaymentsInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetPaymentsInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >(GetPaymentsInsightsMetricsDocument, options)
}
export function useGetPaymentsInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >(GetPaymentsInsightsMetricsDocument, options)
}
export type GetPaymentsInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsMetricsQuery
>
export type GetPaymentsInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsMetricsLazyQuery
>
export type GetPaymentsInsightsMetricsQueryResult = Apollo.QueryResult<
  GetPaymentsInsightsMetricsQuery,
  GetPaymentsInsightsMetricsQueryVariables
>
export const GetPaymentsInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetPaymentsInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetPaymentsCountByMethodMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        method
        count
      }
      average
    }
    PartnerGetPaymentsVolumeByMethodMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        method
        volume
      }
      average
    }
    PartnerGetActivationRatesByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetActivationRateInvoiceVolumeByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        value
      }
      average
    }
  }
  ${DataPointFragmentDoc}
`

/**
 * __useGetPaymentsInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetPaymentsInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >(GetPaymentsInsightsGraphsDocument, options)
}
export function useGetPaymentsInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >(GetPaymentsInsightsGraphsDocument, options)
}
export type GetPaymentsInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsGraphsQuery
>
export type GetPaymentsInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsGraphsLazyQuery
>
export type GetPaymentsInsightsGraphsQueryResult = Apollo.QueryResult<
  GetPaymentsInsightsGraphsQuery,
  GetPaymentsInsightsGraphsQueryVariables
>
export const GetCollectionsInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetCollectionsInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetAverageTimeToPayExternalInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAverageTimeToPayInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageTimeToPayAutopayInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetCollectionsInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetCollectionsInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >(GetCollectionsInsightsMetricsDocument, options)
}
export function useGetCollectionsInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >(GetCollectionsInsightsMetricsDocument, options)
}
export type GetCollectionsInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsMetricsQuery
>
export type GetCollectionsInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsMetricsLazyQuery
>
export type GetCollectionsInsightsMetricsQueryResult = Apollo.QueryResult<
  GetCollectionsInsightsMetricsQuery,
  GetCollectionsInsightsMetricsQueryVariables
>
export const GetCollectionsInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetCollectionsInsightsGraphs(
    $dateFrom: String!
    $dateTo: String!
    $cashFlowGranularity: Granularity = MONTH
  ) {
    PartnerGetCashFlowDistributionInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      granularity: $cashFlowGranularity
    ) {
      data {
        date
        value
        isInternal
      }
    }
    PartnerGetAverageTimeToPayExternalVsInternalByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      internalAvg
      externalAvg
      data {
        month
        average
        isInternal
      }
    }
  }
`

/**
 * __useGetCollectionsInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      cashFlowGranularity: // value for 'cashFlowGranularity'
 *   },
 * });
 */
export function useGetCollectionsInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >(GetCollectionsInsightsGraphsDocument, options)
}
export function useGetCollectionsInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >(GetCollectionsInsightsGraphsDocument, options)
}
export type GetCollectionsInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsGraphsQuery
>
export type GetCollectionsInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsGraphsLazyQuery
>
export type GetCollectionsInsightsGraphsQueryResult = Apollo.QueryResult<
  GetCollectionsInsightsGraphsQuery,
  GetCollectionsInsightsGraphsQueryVariables
>
export const GetAutomationsInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetAutomationsInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetAutomatedPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAutomatedPaymentVolumePercentageInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAutomatedTransactionCountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      count
    }
    PartnerGetPaymentVolumeAutomatedInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetAutomationsInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetAutomationsInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >(GetAutomationsInsightsMetricsDocument, options)
}
export function useGetAutomationsInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >(GetAutomationsInsightsMetricsDocument, options)
}
export type GetAutomationsInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsMetricsQuery
>
export type GetAutomationsInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsMetricsLazyQuery
>
export type GetAutomationsInsightsMetricsQueryResult = Apollo.QueryResult<
  GetAutomationsInsightsMetricsQuery,
  GetAutomationsInsightsMetricsQueryVariables
>
export const GetAutomationsInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetAutomationsInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetAutomatedPaymentsByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAutomatedPaymentVolumePercentByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        percent
      }
      average
    }
  }
  ${DataPointFragmentDoc}
`

/**
 * __useGetAutomationsInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetAutomationsInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >(GetAutomationsInsightsGraphsDocument, options)
}
export function useGetAutomationsInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >(GetAutomationsInsightsGraphsDocument, options)
}
export type GetAutomationsInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsGraphsQuery
>
export type GetAutomationsInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsGraphsLazyQuery
>
export type GetAutomationsInsightsGraphsQueryResult = Apollo.QueryResult<
  GetAutomationsInsightsGraphsQuery,
  GetAutomationsInsightsGraphsQueryVariables
>
export const GetAutomationsLastMonthInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetAutomationsLastMonthInsightsGraphs {
    PartnerGetPaymentCountByTriggerLastMonthInsight {
      data {
        trigger
        count
      }
    }
    PartnerGetPaymentVolumeByTriggerLastMonthInsight {
      data {
        trigger
        volume
      }
    }
  }
`

/**
 * __useGetAutomationsLastMonthInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsLastMonthInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsLastMonthInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsLastMonthInsightsGraphsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutomationsLastMonthInsightsGraphsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >(GetAutomationsLastMonthInsightsGraphsDocument, options)
}
export function useGetAutomationsLastMonthInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >(GetAutomationsLastMonthInsightsGraphsDocument, options)
}
export type GetAutomationsLastMonthInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetAutomationsLastMonthInsightsGraphsQuery
>
export type GetAutomationsLastMonthInsightsGraphsLazyQueryHookResult =
  ReturnType<typeof useGetAutomationsLastMonthInsightsGraphsLazyQuery>
export type GetAutomationsLastMonthInsightsGraphsQueryResult =
  Apollo.QueryResult<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >
export const PartnerAutotaskConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutotaskConnectionCreate(
    $input: PartnerAutotaskConnectionCreateInput
  ) {
    PartnerAutotaskConnectionCreate(input: $input) {
      companyTypes {
        id
        name
      }
      companyClassifications {
        id
        name
      }
      companyTerritoryIDs {
        id
        name
      }
      companyUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
      contactUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
    }
  }
`
export type PartnerAutotaskConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerAutotaskConnectionCreateMutation,
  PartnerAutotaskConnectionCreateMutationVariables
>

/**
 * __usePartnerAutotaskConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutotaskConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutotaskConnectionCreateMutation, { data, loading, error }] = usePartnerAutotaskConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAutotaskConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutotaskConnectionCreateMutation,
    PartnerAutotaskConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutotaskConnectionCreateMutation,
    PartnerAutotaskConnectionCreateMutationVariables
  >(PartnerAutotaskConnectionCreateDocument, options)
}
export type PartnerAutotaskConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerAutotaskConnectionCreateMutation
>
export type PartnerAutotaskConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerAutotaskConnectionCreateMutation>
export type PartnerAutotaskConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutotaskConnectionCreateMutation,
    PartnerAutotaskConnectionCreateMutationVariables
  >
export const PartnerAutotaskConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutotaskConnectionUpdate(
    $input: PartnerAutotaskConnectionUpdateInput
  ) {
    PartnerAutotaskConnectionUpdate(input: $input)
  }
`
export type PartnerAutotaskConnectionUpdateMutationFn = Apollo.MutationFunction<
  PartnerAutotaskConnectionUpdateMutation,
  PartnerAutotaskConnectionUpdateMutationVariables
>

/**
 * __usePartnerAutotaskConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAutotaskConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutotaskConnectionUpdateMutation, { data, loading, error }] = usePartnerAutotaskConnectionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAutotaskConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutotaskConnectionUpdateMutation,
    PartnerAutotaskConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutotaskConnectionUpdateMutation,
    PartnerAutotaskConnectionUpdateMutationVariables
  >(PartnerAutotaskConnectionUpdateDocument, options)
}
export type PartnerAutotaskConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerAutotaskConnectionUpdateMutation
>
export type PartnerAutotaskConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerAutotaskConnectionUpdateMutation>
export type PartnerAutotaskConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutotaskConnectionUpdateMutation,
    PartnerAutotaskConnectionUpdateMutationVariables
  >
export const PartnerAutotaskGetFiltersDocument = /*#__PURE__*/ gql`
  query PartnerAutotaskGetFilters {
    PartnerAutotaskGetFilters {
      companyTypes {
        id
        name
      }
      companyClassifications {
        id
        name
      }
      companyTerritoryIDs {
        id
        name
      }
      companyUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
      contactUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
    }
  }
`

/**
 * __usePartnerAutotaskGetFiltersQuery__
 *
 * To run a query within a React component, call `usePartnerAutotaskGetFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskGetFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutotaskGetFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerAutotaskGetFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >(PartnerAutotaskGetFiltersDocument, options)
}
export function usePartnerAutotaskGetFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >(PartnerAutotaskGetFiltersDocument, options)
}
export type PartnerAutotaskGetFiltersQueryHookResult = ReturnType<
  typeof usePartnerAutotaskGetFiltersQuery
>
export type PartnerAutotaskGetFiltersLazyQueryHookResult = ReturnType<
  typeof usePartnerAutotaskGetFiltersLazyQuery
>
export type PartnerAutotaskGetFiltersQueryResult = Apollo.QueryResult<
  PartnerAutotaskGetFiltersQuery,
  PartnerAutotaskGetFiltersQueryVariables
>
export const PartnerContractTypeConnectionDocument = /*#__PURE__*/ gql`
  query PartnerContractTypeConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: ContractTypeOrderBy
    $filter: ContractTypeFilter
  ) {
    PartnerContractTypeConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerContractTypeConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerContractTypeConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerContractTypeConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerContractTypeConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerContractTypeConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >(PartnerContractTypeConnectionDocument, options)
}
export function usePartnerContractTypeConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >(PartnerContractTypeConnectionDocument, options)
}
export type PartnerContractTypeConnectionQueryHookResult = ReturnType<
  typeof usePartnerContractTypeConnectionQuery
>
export type PartnerContractTypeConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerContractTypeConnectionLazyQuery
>
export type PartnerContractTypeConnectionQueryResult = Apollo.QueryResult<
  PartnerContractTypeConnectionQuery,
  PartnerContractTypeConnectionQueryVariables
>
export const PartnerAutotaskContractConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAutotaskContractConnection($filter: AutotaskContractFilter) {
    PartnerAutotaskContractConnection(filter: $filter) {
      contracts
    }
  }
`

/**
 * __usePartnerAutotaskContractConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAutotaskContractConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskContractConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutotaskContractConnectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerAutotaskContractConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >(PartnerAutotaskContractConnectionDocument, options)
}
export function usePartnerAutotaskContractConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >(PartnerAutotaskContractConnectionDocument, options)
}
export type PartnerAutotaskContractConnectionQueryHookResult = ReturnType<
  typeof usePartnerAutotaskContractConnectionQuery
>
export type PartnerAutotaskContractConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerAutotaskContractConnectionLazyQuery
>
export type PartnerAutotaskContractConnectionQueryResult = Apollo.QueryResult<
  PartnerAutotaskContractConnectionQuery,
  PartnerAutotaskContractConnectionQueryVariables
>
export const PartnerAutotaskGetConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAutotaskGetConnection {
    PartnerAutotaskGetConnection {
      filters {
        companyFilters {
          types
          classifications
          territories
          udf {
            name
            type
            isPickList
            picklistValues {
              id
              name
            }
            inputs
          }
        }
        contactFilters {
          udf {
            name
            type
            isPickList
            picklistValues {
              id
              name
            }
            inputs
          }
        }
        invoiceFilters {
          invoiceCreatedSince
        }
      }
    }
  }
`

/**
 * __usePartnerAutotaskGetConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAutotaskGetConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskGetConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutotaskGetConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerAutotaskGetConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutotaskGetConnectionQuery,
    PartnerAutotaskGetConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutotaskGetConnectionQuery,
    PartnerAutotaskGetConnectionQueryVariables
  >(PartnerAutotaskGetConnectionDocument, options)
}
export function usePartnerAutotaskGetConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutotaskGetConnectionQuery,
    PartnerAutotaskGetConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutotaskGetConnectionQuery,
    PartnerAutotaskGetConnectionQueryVariables
  >(PartnerAutotaskGetConnectionDocument, options)
}
export type PartnerAutotaskGetConnectionQueryHookResult = ReturnType<
  typeof usePartnerAutotaskGetConnectionQuery
>
export type PartnerAutotaskGetConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerAutotaskGetConnectionLazyQuery
>
export type PartnerAutotaskGetConnectionQueryResult = Apollo.QueryResult<
  PartnerAutotaskGetConnectionQuery,
  PartnerAutotaskGetConnectionQueryVariables
>
export const PartnerConnectWiseConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerConnectWiseConnectionCreate(
    $input: PartnerConnectWiseConnectionCreateInput
  ) {
    PartnerConnectWiseConnectionCreate(input: $input) {
      ...CWQueryFilters
    }
  }
  ${CwQueryFiltersFragmentDoc}
`
export type PartnerConnectWiseConnectionCreateMutationFn =
  Apollo.MutationFunction<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >

/**
 * __usePartnerConnectWiseConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerConnectWiseConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerConnectWiseConnectionCreateMutation, { data, loading, error }] = usePartnerConnectWiseConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerConnectWiseConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >(PartnerConnectWiseConnectionCreateDocument, options)
}
export type PartnerConnectWiseConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerConnectWiseConnectionCreateMutation
>
export type PartnerConnectWiseConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerConnectWiseConnectionCreateMutation>
export type PartnerConnectWiseConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >
export const PartnerConnectWiseConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerConnectWiseConnectionUpdate(
    $input: ConnectWiseQueryFiltersInput
  ) {
    PartnerConnectWiseConnectionUpdate(input: $input)
  }
`
export type PartnerConnectWiseConnectionUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >

/**
 * __usePartnerConnectWiseConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerConnectWiseConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerConnectWiseConnectionUpdateMutation, { data, loading, error }] = usePartnerConnectWiseConnectionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerConnectWiseConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >(PartnerConnectWiseConnectionUpdateDocument, options)
}
export type PartnerConnectWiseConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerConnectWiseConnectionUpdateMutation
>
export type PartnerConnectWiseConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerConnectWiseConnectionUpdateMutation>
export type PartnerConnectWiseConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >
export const PartnerConnectWiseGetConnectionDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseGetConnection {
    PartnerConnectWiseGetConnection {
      partnerID
      queryFilters {
        ...CWQueryFilters
      }
    }
  }
  ${CwQueryFiltersFragmentDoc}
`

/**
 * __usePartnerConnectWiseGetConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseGetConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseGetConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseGetConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerConnectWiseGetConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >(PartnerConnectWiseGetConnectionDocument, options)
}
export function usePartnerConnectWiseGetConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >(PartnerConnectWiseGetConnectionDocument, options)
}
export type PartnerConnectWiseGetConnectionQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetConnectionQuery
>
export type PartnerConnectWiseGetConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetConnectionLazyQuery
>
export type PartnerConnectWiseGetConnectionQueryResult = Apollo.QueryResult<
  PartnerConnectWiseGetConnectionQuery,
  PartnerConnectWiseGetConnectionQueryVariables
>
export const PartnerConnectWiseGetFiltersDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseGetFilters {
    PartnerConnectWiseGetFilters {
      ...CWQueryFilters
    }
  }
  ${CwQueryFiltersFragmentDoc}
`

/**
 * __usePartnerConnectWiseGetFiltersQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseGetFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseGetFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseGetFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerConnectWiseGetFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >(PartnerConnectWiseGetFiltersDocument, options)
}
export function usePartnerConnectWiseGetFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >(PartnerConnectWiseGetFiltersDocument, options)
}
export type PartnerConnectWiseGetFiltersQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetFiltersQuery
>
export type PartnerConnectWiseGetFiltersLazyQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetFiltersLazyQuery
>
export type PartnerConnectWiseGetFiltersQueryResult = Apollo.QueryResult<
  PartnerConnectWiseGetFiltersQuery,
  PartnerConnectWiseGetFiltersQueryVariables
>
export const PartnerAgreementTypeConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAgreementTypeConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AgreementTypeOrderBy
    $filter: AgreementTypeFilter
  ) {
    PartnerAgreementTypeConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerAgreementTypeConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAgreementTypeConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAgreementTypeConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAgreementTypeConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerAgreementTypeConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >(PartnerAgreementTypeConnectionDocument, options)
}
export function usePartnerAgreementTypeConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >(PartnerAgreementTypeConnectionDocument, options)
}
export type PartnerAgreementTypeConnectionQueryHookResult = ReturnType<
  typeof usePartnerAgreementTypeConnectionQuery
>
export type PartnerAgreementTypeConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerAgreementTypeConnectionLazyQuery
>
export type PartnerAgreementTypeConnectionQueryResult = Apollo.QueryResult<
  PartnerAgreementTypeConnectionQuery,
  PartnerAgreementTypeConnectionQueryVariables
>
export const PartnerConnectWiseBillingTermsConnectionDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseBillingTermsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: CWBillingTermsOrderBy
    $filter: CWBillingTermsFilter
  ) {
    PartnerConnectWiseBillingTermsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerConnectWiseBillingTermsConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseBillingTermsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseBillingTermsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseBillingTermsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerConnectWiseBillingTermsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >(PartnerConnectWiseBillingTermsConnectionDocument, options)
}
export function usePartnerConnectWiseBillingTermsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >(PartnerConnectWiseBillingTermsConnectionDocument, options)
}
export type PartnerConnectWiseBillingTermsConnectionQueryHookResult =
  ReturnType<typeof usePartnerConnectWiseBillingTermsConnectionQuery>
export type PartnerConnectWiseBillingTermsConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerConnectWiseBillingTermsConnectionLazyQuery>
export type PartnerConnectWiseBillingTermsConnectionQueryResult =
  Apollo.QueryResult<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >
export const PartnerConnectWiseAgreementConnectionDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseAgreementConnection(
    $filter: ConnectWiseAgreementFilter
  ) {
    PartnerConnectWiseAgreementConnection(filter: $filter) {
      agreements
    }
  }
`

/**
 * __usePartnerConnectWiseAgreementConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseAgreementConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseAgreementConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseAgreementConnectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerConnectWiseAgreementConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >(PartnerConnectWiseAgreementConnectionDocument, options)
}
export function usePartnerConnectWiseAgreementConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >(PartnerConnectWiseAgreementConnectionDocument, options)
}
export type PartnerConnectWiseAgreementConnectionQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseAgreementConnectionQuery
>
export type PartnerConnectWiseAgreementConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerConnectWiseAgreementConnectionLazyQuery>
export type PartnerConnectWiseAgreementConnectionQueryResult =
  Apollo.QueryResult<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >
export const PartnerConnectWiseTaxCodeGetDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseTaxCodeGet {
    PartnerConnectWiseTaxCodeGet {
      id
      identifier
    }
  }
`

/**
 * __usePartnerConnectWiseTaxCodeGetQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseTaxCodeGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseTaxCodeGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseTaxCodeGetQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerConnectWiseTaxCodeGetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseTaxCodeGetQuery,
    PartnerConnectWiseTaxCodeGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseTaxCodeGetQuery,
    PartnerConnectWiseTaxCodeGetQueryVariables
  >(PartnerConnectWiseTaxCodeGetDocument, options)
}
export function usePartnerConnectWiseTaxCodeGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseTaxCodeGetQuery,
    PartnerConnectWiseTaxCodeGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseTaxCodeGetQuery,
    PartnerConnectWiseTaxCodeGetQueryVariables
  >(PartnerConnectWiseTaxCodeGetDocument, options)
}
export type PartnerConnectWiseTaxCodeGetQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseTaxCodeGetQuery
>
export type PartnerConnectWiseTaxCodeGetLazyQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseTaxCodeGetLazyQuery
>
export type PartnerConnectWiseTaxCodeGetQueryResult = Apollo.QueryResult<
  PartnerConnectWiseTaxCodeGetQuery,
  PartnerConnectWiseTaxCodeGetQueryVariables
>
export const PartnerConnectWiseGlSegmentsGetDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseGlSegmentsGet {
    PartnerConnectWiseGlSegmentsGet {
      position
      label
    }
  }
`

/**
 * __usePartnerConnectWiseGlSegmentsGetQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseGlSegmentsGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseGlSegmentsGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseGlSegmentsGetQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerConnectWiseGlSegmentsGetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseGlSegmentsGetQuery,
    PartnerConnectWiseGlSegmentsGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseGlSegmentsGetQuery,
    PartnerConnectWiseGlSegmentsGetQueryVariables
  >(PartnerConnectWiseGlSegmentsGetDocument, options)
}
export function usePartnerConnectWiseGlSegmentsGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseGlSegmentsGetQuery,
    PartnerConnectWiseGlSegmentsGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseGlSegmentsGetQuery,
    PartnerConnectWiseGlSegmentsGetQueryVariables
  >(PartnerConnectWiseGlSegmentsGetDocument, options)
}
export type PartnerConnectWiseGlSegmentsGetQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGlSegmentsGetQuery
>
export type PartnerConnectWiseGlSegmentsGetLazyQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGlSegmentsGetLazyQuery
>
export type PartnerConnectWiseGlSegmentsGetQueryResult = Apollo.QueryResult<
  PartnerConnectWiseGlSegmentsGetQuery,
  PartnerConnectWiseGlSegmentsGetQueryVariables
>
export const PartnerDatagateConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerDatagateConnectionCreate(
    $input: DatagateConnectionCreateInput
  ) {
    PartnerDatagateConnectionCreate(input: $input)
  }
`
export type PartnerDatagateConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerDatagateConnectionCreateMutation,
  PartnerDatagateConnectionCreateMutationVariables
>

/**
 * __usePartnerDatagateConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerDatagateConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDatagateConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDatagateConnectionCreateMutation, { data, loading, error }] = usePartnerDatagateConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerDatagateConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDatagateConnectionCreateMutation,
    PartnerDatagateConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDatagateConnectionCreateMutation,
    PartnerDatagateConnectionCreateMutationVariables
  >(PartnerDatagateConnectionCreateDocument, options)
}
export type PartnerDatagateConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerDatagateConnectionCreateMutation
>
export type PartnerDatagateConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerDatagateConnectionCreateMutation>
export type PartnerDatagateConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDatagateConnectionCreateMutation,
    PartnerDatagateConnectionCreateMutationVariables
  >
export const PartnerHaloPsaConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerHaloPSAConnectionCreate(
    $input: PartnerHaloPSAConnectionCreateInput
  ) {
    PartnerHaloPSAConnectionCreate(input: $input) {
      success
      errorMessage
    }
  }
`
export type PartnerHaloPsaConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerHaloPsaConnectionCreateMutation,
  PartnerHaloPsaConnectionCreateMutationVariables
>

/**
 * __usePartnerHaloPsaConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerHaloPsaConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerHaloPsaConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerHaloPsaConnectionCreateMutation, { data, loading, error }] = usePartnerHaloPsaConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerHaloPsaConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerHaloPsaConnectionCreateMutation,
    PartnerHaloPsaConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerHaloPsaConnectionCreateMutation,
    PartnerHaloPsaConnectionCreateMutationVariables
  >(PartnerHaloPsaConnectionCreateDocument, options)
}
export type PartnerHaloPsaConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerHaloPsaConnectionCreateMutation
>
export type PartnerHaloPsaConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerHaloPsaConnectionCreateMutation>
export type PartnerHaloPsaConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerHaloPsaConnectionCreateMutation,
    PartnerHaloPsaConnectionCreateMutationVariables
  >
export const PartnerHaloPsaTopLevelListDocument = /*#__PURE__*/ gql`
  query PartnerHaloPSATopLevelList {
    PartnerHaloPSATopLevelList {
      id
      name
    }
  }
`

/**
 * __usePartnerHaloPsaTopLevelListQuery__
 *
 * To run a query within a React component, call `usePartnerHaloPsaTopLevelListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerHaloPsaTopLevelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerHaloPsaTopLevelListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerHaloPsaTopLevelListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerHaloPsaTopLevelListQuery,
    PartnerHaloPsaTopLevelListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerHaloPsaTopLevelListQuery,
    PartnerHaloPsaTopLevelListQueryVariables
  >(PartnerHaloPsaTopLevelListDocument, options)
}
export function usePartnerHaloPsaTopLevelListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerHaloPsaTopLevelListQuery,
    PartnerHaloPsaTopLevelListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerHaloPsaTopLevelListQuery,
    PartnerHaloPsaTopLevelListQueryVariables
  >(PartnerHaloPsaTopLevelListDocument, options)
}
export type PartnerHaloPsaTopLevelListQueryHookResult = ReturnType<
  typeof usePartnerHaloPsaTopLevelListQuery
>
export type PartnerHaloPsaTopLevelListLazyQueryHookResult = ReturnType<
  typeof usePartnerHaloPsaTopLevelListLazyQuery
>
export type PartnerHaloPsaTopLevelListQueryResult = Apollo.QueryResult<
  PartnerHaloPsaTopLevelListQuery,
  PartnerHaloPsaTopLevelListQueryVariables
>
export const PartnerHaloPsaConnectionQueryFiltersUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerHaloPSAConnectionQueryFiltersUpdate(
    $input: HaloPSAConnectionQueryFiltersInput!
  ) {
    PartnerHaloPSAConnectionQueryFiltersUpdate(input: $input) {
      success
    }
  }
`
export type PartnerHaloPsaConnectionQueryFiltersUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerHaloPsaConnectionQueryFiltersUpdateMutation,
    PartnerHaloPsaConnectionQueryFiltersUpdateMutationVariables
  >

/**
 * __usePartnerHaloPsaConnectionQueryFiltersUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerHaloPsaConnectionQueryFiltersUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerHaloPsaConnectionQueryFiltersUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerHaloPsaConnectionQueryFiltersUpdateMutation, { data, loading, error }] = usePartnerHaloPsaConnectionQueryFiltersUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerHaloPsaConnectionQueryFiltersUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerHaloPsaConnectionQueryFiltersUpdateMutation,
    PartnerHaloPsaConnectionQueryFiltersUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerHaloPsaConnectionQueryFiltersUpdateMutation,
    PartnerHaloPsaConnectionQueryFiltersUpdateMutationVariables
  >(PartnerHaloPsaConnectionQueryFiltersUpdateDocument, options)
}
export type PartnerHaloPsaConnectionQueryFiltersUpdateMutationHookResult =
  ReturnType<typeof usePartnerHaloPsaConnectionQueryFiltersUpdateMutation>
export type PartnerHaloPsaConnectionQueryFiltersUpdateMutationResult =
  Apollo.MutationResult<PartnerHaloPsaConnectionQueryFiltersUpdateMutation>
export type PartnerHaloPsaConnectionQueryFiltersUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerHaloPsaConnectionQueryFiltersUpdateMutation,
    PartnerHaloPsaConnectionQueryFiltersUpdateMutationVariables
  >
export const PartnerContractSubtypeConnectionDocument = /*#__PURE__*/ gql`
  query PartnerContractSubtypeConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: ContractSubtypeOrderBy
    $filter: ContractSubtypeFilter
  ) {
    PartnerContractSubtypeConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerContractSubtypeConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerContractSubtypeConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerContractSubtypeConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerContractSubtypeConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerContractSubtypeConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >(PartnerContractSubtypeConnectionDocument, options)
}
export function usePartnerContractSubtypeConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >(PartnerContractSubtypeConnectionDocument, options)
}
export type PartnerContractSubtypeConnectionQueryHookResult = ReturnType<
  typeof usePartnerContractSubtypeConnectionQuery
>
export type PartnerContractSubtypeConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerContractSubtypeConnectionLazyQuery
>
export type PartnerContractSubtypeConnectionQueryResult = Apollo.QueryResult<
  PartnerContractSubtypeConnectionQuery,
  PartnerContractSubtypeConnectionQueryVariables
>
export const PartnerHaloPsaContractConnectionDocument = /*#__PURE__*/ gql`
  query PartnerHaloPSAContractConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filter: HaloPSAContractFilter!
  ) {
    PartnerHaloPSAContractConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
    }
  }
`

/**
 * __usePartnerHaloPsaContractConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerHaloPsaContractConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerHaloPsaContractConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerHaloPsaContractConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerHaloPsaContractConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerHaloPsaContractConnectionQuery,
    PartnerHaloPsaContractConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerHaloPsaContractConnectionQuery,
    PartnerHaloPsaContractConnectionQueryVariables
  >(PartnerHaloPsaContractConnectionDocument, options)
}
export function usePartnerHaloPsaContractConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerHaloPsaContractConnectionQuery,
    PartnerHaloPsaContractConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerHaloPsaContractConnectionQuery,
    PartnerHaloPsaContractConnectionQueryVariables
  >(PartnerHaloPsaContractConnectionDocument, options)
}
export type PartnerHaloPsaContractConnectionQueryHookResult = ReturnType<
  typeof usePartnerHaloPsaContractConnectionQuery
>
export type PartnerHaloPsaContractConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerHaloPsaContractConnectionLazyQuery
>
export type PartnerHaloPsaContractConnectionQueryResult = Apollo.QueryResult<
  PartnerHaloPsaContractConnectionQuery,
  PartnerHaloPsaContractConnectionQueryVariables
>
export const PartnerIntegrationIssueConnectionDocument = /*#__PURE__*/ gql`
  query PartnerIntegrationIssueConnection(
    $after: Cursor
    $first: Int
    $filters: IntegrationIssueFilter!
  ) {
    PartnerIntegrationIssueConnection(
      after: $after
      first: $first
      filters: $filters
    ) {
      edges {
        node {
          ...PartnerIntegrationIssue
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
  ${PartnerIntegrationIssueFragmentDoc}
`

/**
 * __usePartnerIntegrationIssueConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerIntegrationIssueConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationIssueConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerIntegrationIssueConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerIntegrationIssueConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerIntegrationIssueConnectionQuery,
    PartnerIntegrationIssueConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerIntegrationIssueConnectionQuery,
    PartnerIntegrationIssueConnectionQueryVariables
  >(PartnerIntegrationIssueConnectionDocument, options)
}
export function usePartnerIntegrationIssueConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerIntegrationIssueConnectionQuery,
    PartnerIntegrationIssueConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerIntegrationIssueConnectionQuery,
    PartnerIntegrationIssueConnectionQueryVariables
  >(PartnerIntegrationIssueConnectionDocument, options)
}
export type PartnerIntegrationIssueConnectionQueryHookResult = ReturnType<
  typeof usePartnerIntegrationIssueConnectionQuery
>
export type PartnerIntegrationIssueConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerIntegrationIssueConnectionLazyQuery
>
export type PartnerIntegrationIssueConnectionQueryResult = Apollo.QueryResult<
  PartnerIntegrationIssueConnectionQuery,
  PartnerIntegrationIssueConnectionQueryVariables
>
export const PartnerIntegrationIssueCountsDocument = /*#__PURE__*/ gql`
  query PartnerIntegrationIssueCounts($platformName: PlatformName!) {
    PartnerIntegrationIssueCounts(platformName: $platformName) {
      invoiceCount
      customerCount
      totalCount
    }
  }
`

/**
 * __usePartnerIntegrationIssueCountsQuery__
 *
 * To run a query within a React component, call `usePartnerIntegrationIssueCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationIssueCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerIntegrationIssueCountsQuery({
 *   variables: {
 *      platformName: // value for 'platformName'
 *   },
 * });
 */
export function usePartnerIntegrationIssueCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerIntegrationIssueCountsQuery,
    PartnerIntegrationIssueCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerIntegrationIssueCountsQuery,
    PartnerIntegrationIssueCountsQueryVariables
  >(PartnerIntegrationIssueCountsDocument, options)
}
export function usePartnerIntegrationIssueCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerIntegrationIssueCountsQuery,
    PartnerIntegrationIssueCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerIntegrationIssueCountsQuery,
    PartnerIntegrationIssueCountsQueryVariables
  >(PartnerIntegrationIssueCountsDocument, options)
}
export type PartnerIntegrationIssueCountsQueryHookResult = ReturnType<
  typeof usePartnerIntegrationIssueCountsQuery
>
export type PartnerIntegrationIssueCountsLazyQueryHookResult = ReturnType<
  typeof usePartnerIntegrationIssueCountsLazyQuery
>
export type PartnerIntegrationIssueCountsQueryResult = Apollo.QueryResult<
  PartnerIntegrationIssueCountsQuery,
  PartnerIntegrationIssueCountsQueryVariables
>
export const PartnerRetryIntegrationIssueDocument = /*#__PURE__*/ gql`
  mutation PartnerRetryIntegrationIssue($input: RetryIntegrationIssueInput!) {
    PartnerRetryIntegrationIssue(input: $input)
  }
`
export type PartnerRetryIntegrationIssueMutationFn = Apollo.MutationFunction<
  PartnerRetryIntegrationIssueMutation,
  PartnerRetryIntegrationIssueMutationVariables
>

/**
 * __usePartnerRetryIntegrationIssueMutation__
 *
 * To run a mutation, you first call `usePartnerRetryIntegrationIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRetryIntegrationIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRetryIntegrationIssueMutation, { data, loading, error }] = usePartnerRetryIntegrationIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRetryIntegrationIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRetryIntegrationIssueMutation,
    PartnerRetryIntegrationIssueMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRetryIntegrationIssueMutation,
    PartnerRetryIntegrationIssueMutationVariables
  >(PartnerRetryIntegrationIssueDocument, options)
}
export type PartnerRetryIntegrationIssueMutationHookResult = ReturnType<
  typeof usePartnerRetryIntegrationIssueMutation
>
export type PartnerRetryIntegrationIssueMutationResult =
  Apollo.MutationResult<PartnerRetryIntegrationIssueMutation>
export type PartnerRetryIntegrationIssueMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRetryIntegrationIssueMutation,
    PartnerRetryIntegrationIssueMutationVariables
  >
export const PartnerIntegrationJobConnectionDocument = /*#__PURE__*/ gql`
  query PartnerIntegrationJobConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: IntegrationJobFilter!
    $order: IntegrationJobOrder
  ) {
    PartnerIntegrationJobConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      order: $order
    ) {
      edges {
        node {
          ...PartnerIntegrationJob
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
  ${PartnerIntegrationJobFragmentDoc}
`

/**
 * __usePartnerIntegrationJobConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerIntegrationJobConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationJobConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerIntegrationJobConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerIntegrationJobConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerIntegrationJobConnectionQuery,
    PartnerIntegrationJobConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerIntegrationJobConnectionQuery,
    PartnerIntegrationJobConnectionQueryVariables
  >(PartnerIntegrationJobConnectionDocument, options)
}
export function usePartnerIntegrationJobConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerIntegrationJobConnectionQuery,
    PartnerIntegrationJobConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerIntegrationJobConnectionQuery,
    PartnerIntegrationJobConnectionQueryVariables
  >(PartnerIntegrationJobConnectionDocument, options)
}
export type PartnerIntegrationJobConnectionQueryHookResult = ReturnType<
  typeof usePartnerIntegrationJobConnectionQuery
>
export type PartnerIntegrationJobConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerIntegrationJobConnectionLazyQuery
>
export type PartnerIntegrationJobConnectionQueryResult = Apollo.QueryResult<
  PartnerIntegrationJobConnectionQuery,
  PartnerIntegrationJobConnectionQueryVariables
>
export const PartnerJobRetryDocument = /*#__PURE__*/ gql`
  mutation PartnerJobRetry($input: JobRetry!) {
    PartnerJobRetry(input: $input)
  }
`
export type PartnerJobRetryMutationFn = Apollo.MutationFunction<
  PartnerJobRetryMutation,
  PartnerJobRetryMutationVariables
>

/**
 * __usePartnerJobRetryMutation__
 *
 * To run a mutation, you first call `usePartnerJobRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerJobRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerJobRetryMutation, { data, loading, error }] = usePartnerJobRetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerJobRetryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerJobRetryMutation,
    PartnerJobRetryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerJobRetryMutation,
    PartnerJobRetryMutationVariables
  >(PartnerJobRetryDocument, options)
}
export type PartnerJobRetryMutationHookResult = ReturnType<
  typeof usePartnerJobRetryMutation
>
export type PartnerJobRetryMutationResult =
  Apollo.MutationResult<PartnerJobRetryMutation>
export type PartnerJobRetryMutationOptions = Apollo.BaseMutationOptions<
  PartnerJobRetryMutation,
  PartnerJobRetryMutationVariables
>
export const PartnerIntegrationJobQueueConnectionDocument = /*#__PURE__*/ gql`
  query PartnerIntegrationJobQueueConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: IntegrationJobQueueFilter!
    $order: IntegrationJobQueueOrder
  ) {
    PartnerIntegrationJobQueueConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      order: $order
    ) {
      edges {
        node {
          ...PartnerIntegrationJobQueue
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
  ${PartnerIntegrationJobQueueFragmentDoc}
`

/**
 * __usePartnerIntegrationJobQueueConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerIntegrationJobQueueConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationJobQueueConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerIntegrationJobQueueConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerIntegrationJobQueueConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerIntegrationJobQueueConnectionQuery,
    PartnerIntegrationJobQueueConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerIntegrationJobQueueConnectionQuery,
    PartnerIntegrationJobQueueConnectionQueryVariables
  >(PartnerIntegrationJobQueueConnectionDocument, options)
}
export function usePartnerIntegrationJobQueueConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerIntegrationJobQueueConnectionQuery,
    PartnerIntegrationJobQueueConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerIntegrationJobQueueConnectionQuery,
    PartnerIntegrationJobQueueConnectionQueryVariables
  >(PartnerIntegrationJobQueueConnectionDocument, options)
}
export type PartnerIntegrationJobQueueConnectionQueryHookResult = ReturnType<
  typeof usePartnerIntegrationJobQueueConnectionQuery
>
export type PartnerIntegrationJobQueueConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerIntegrationJobQueueConnectionLazyQuery>
export type PartnerIntegrationJobQueueConnectionQueryResult =
  Apollo.QueryResult<
    PartnerIntegrationJobQueueConnectionQuery,
    PartnerIntegrationJobQueueConnectionQueryVariables
  >
export const PartnerJobQueueRetryDocument = /*#__PURE__*/ gql`
  mutation PartnerJobQueueRetry($input: JobQueueRetry!) {
    PartnerJobQueueRetry(input: $input)
  }
`
export type PartnerJobQueueRetryMutationFn = Apollo.MutationFunction<
  PartnerJobQueueRetryMutation,
  PartnerJobQueueRetryMutationVariables
>

/**
 * __usePartnerJobQueueRetryMutation__
 *
 * To run a mutation, you first call `usePartnerJobQueueRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerJobQueueRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerJobQueueRetryMutation, { data, loading, error }] = usePartnerJobQueueRetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerJobQueueRetryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerJobQueueRetryMutation,
    PartnerJobQueueRetryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerJobQueueRetryMutation,
    PartnerJobQueueRetryMutationVariables
  >(PartnerJobQueueRetryDocument, options)
}
export type PartnerJobQueueRetryMutationHookResult = ReturnType<
  typeof usePartnerJobQueueRetryMutation
>
export type PartnerJobQueueRetryMutationResult =
  Apollo.MutationResult<PartnerJobQueueRetryMutation>
export type PartnerJobQueueRetryMutationOptions = Apollo.BaseMutationOptions<
  PartnerJobQueueRetryMutation,
  PartnerJobQueueRetryMutationVariables
>
export const PartnerIntegrationJobFailureCountDocument = /*#__PURE__*/ gql`
  query PartnerIntegrationJobFailureCount(
    $platformName: PlatformName!
    $sinceDays: Int
  ) {
    PartnerIntegrationJobFailureCount(
      platformName: $platformName
      sinceDays: $sinceDays
    ) {
      jobCount
      jobQueueCount
      totalCount
    }
  }
`

/**
 * __usePartnerIntegrationJobFailureCountQuery__
 *
 * To run a query within a React component, call `usePartnerIntegrationJobFailureCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationJobFailureCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerIntegrationJobFailureCountQuery({
 *   variables: {
 *      platformName: // value for 'platformName'
 *      sinceDays: // value for 'sinceDays'
 *   },
 * });
 */
export function usePartnerIntegrationJobFailureCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerIntegrationJobFailureCountQuery,
    PartnerIntegrationJobFailureCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerIntegrationJobFailureCountQuery,
    PartnerIntegrationJobFailureCountQueryVariables
  >(PartnerIntegrationJobFailureCountDocument, options)
}
export function usePartnerIntegrationJobFailureCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerIntegrationJobFailureCountQuery,
    PartnerIntegrationJobFailureCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerIntegrationJobFailureCountQuery,
    PartnerIntegrationJobFailureCountQueryVariables
  >(PartnerIntegrationJobFailureCountDocument, options)
}
export type PartnerIntegrationJobFailureCountQueryHookResult = ReturnType<
  typeof usePartnerIntegrationJobFailureCountQuery
>
export type PartnerIntegrationJobFailureCountLazyQueryHookResult = ReturnType<
  typeof usePartnerIntegrationJobFailureCountLazyQuery
>
export type PartnerIntegrationJobFailureCountQueryResult = Apollo.QueryResult<
  PartnerIntegrationJobFailureCountQuery,
  PartnerIntegrationJobFailureCountQueryVariables
>
export const ExplainIntegrationErrorDocument = /*#__PURE__*/ gql`
  mutation ExplainIntegrationError($input: ExplainIntegrationErrorInput!) {
    explainIntegrationError(input: $input) {
      explanation
      suggestedActions
      contactSupport
    }
  }
`
export type ExplainIntegrationErrorMutationFn = Apollo.MutationFunction<
  ExplainIntegrationErrorMutation,
  ExplainIntegrationErrorMutationVariables
>

/**
 * __useExplainIntegrationErrorMutation__
 *
 * To run a mutation, you first call `useExplainIntegrationErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExplainIntegrationErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [explainIntegrationErrorMutation, { data, loading, error }] = useExplainIntegrationErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExplainIntegrationErrorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExplainIntegrationErrorMutation,
    ExplainIntegrationErrorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExplainIntegrationErrorMutation,
    ExplainIntegrationErrorMutationVariables
  >(ExplainIntegrationErrorDocument, options)
}
export type ExplainIntegrationErrorMutationHookResult = ReturnType<
  typeof useExplainIntegrationErrorMutation
>
export type ExplainIntegrationErrorMutationResult =
  Apollo.MutationResult<ExplainIntegrationErrorMutation>
export type ExplainIntegrationErrorMutationOptions = Apollo.BaseMutationOptions<
  ExplainIntegrationErrorMutation,
  ExplainIntegrationErrorMutationVariables
>
export const ExplainIntegrationErrorFeedbackDocument = /*#__PURE__*/ gql`
  mutation ExplainIntegrationErrorFeedback(
    $input: ExplainIntegrationErrorFeedbackInput!
  ) {
    explainIntegrationErrorFeedback(input: $input) {
      success
    }
  }
`
export type ExplainIntegrationErrorFeedbackMutationFn = Apollo.MutationFunction<
  ExplainIntegrationErrorFeedbackMutation,
  ExplainIntegrationErrorFeedbackMutationVariables
>

/**
 * __useExplainIntegrationErrorFeedbackMutation__
 *
 * To run a mutation, you first call `useExplainIntegrationErrorFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExplainIntegrationErrorFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [explainIntegrationErrorFeedbackMutation, { data, loading, error }] = useExplainIntegrationErrorFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExplainIntegrationErrorFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExplainIntegrationErrorFeedbackMutation,
    ExplainIntegrationErrorFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExplainIntegrationErrorFeedbackMutation,
    ExplainIntegrationErrorFeedbackMutationVariables
  >(ExplainIntegrationErrorFeedbackDocument, options)
}
export type ExplainIntegrationErrorFeedbackMutationHookResult = ReturnType<
  typeof useExplainIntegrationErrorFeedbackMutation
>
export type ExplainIntegrationErrorFeedbackMutationResult =
  Apollo.MutationResult<ExplainIntegrationErrorFeedbackMutation>
export type ExplainIntegrationErrorFeedbackMutationOptions =
  Apollo.BaseMutationOptions<
    ExplainIntegrationErrorFeedbackMutation,
    ExplainIntegrationErrorFeedbackMutationVariables
  >
export const PartnerListIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListIntegrations {
    PartnerListIntegrations {
      __typename
      id
      partnerID
      platformName
      createdAt
      integrationType
      ... on AutotaskIntegration {
        status
      }
      ... on ConnectwiseIntegration {
        status
      }
      ... on HaloPSAIntegration {
        status
        queryFilters {
          ...HaloQueryFilters
        }
      }
      ... on QuickbooksIntegration {
        status
      }
      ... on RutterIntegration {
        status
      }
      ... on SuperOpsIntegration {
        status
      }
      ... on DatagateIntegration {
        status
      }
    }
  }
  ${HaloQueryFiltersFragmentDoc}
`

/**
 * __usePartnerListIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >(PartnerListIntegrationsDocument, options)
}
export function usePartnerListIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >(PartnerListIntegrationsDocument, options)
}
export type PartnerListIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListIntegrationsQuery
>
export type PartnerListIntegrationsLazyQueryHookResult = ReturnType<
  typeof usePartnerListIntegrationsLazyQuery
>
export type PartnerListIntegrationsQueryResult = Apollo.QueryResult<
  PartnerListIntegrationsQuery,
  PartnerListIntegrationsQueryVariables
>
export const PartnerIntegrationDisconnectDocument = /*#__PURE__*/ gql`
  mutation PartnerIntegrationDisconnect($input: IntegrationDisconnectInput) {
    PartnerIntegrationDisconnect(input: $input)
  }
`
export type PartnerIntegrationDisconnectMutationFn = Apollo.MutationFunction<
  PartnerIntegrationDisconnectMutation,
  PartnerIntegrationDisconnectMutationVariables
>

/**
 * __usePartnerIntegrationDisconnectMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationDisconnectMutation, { data, loading, error }] = usePartnerIntegrationDisconnectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerIntegrationDisconnectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerIntegrationDisconnectMutation,
    PartnerIntegrationDisconnectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerIntegrationDisconnectMutation,
    PartnerIntegrationDisconnectMutationVariables
  >(PartnerIntegrationDisconnectDocument, options)
}
export type PartnerIntegrationDisconnectMutationHookResult = ReturnType<
  typeof usePartnerIntegrationDisconnectMutation
>
export type PartnerIntegrationDisconnectMutationResult =
  Apollo.MutationResult<PartnerIntegrationDisconnectMutation>
export type PartnerIntegrationDisconnectMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerIntegrationDisconnectMutation,
    PartnerIntegrationDisconnectMutationVariables
  >
export const PartnerIntegrationSyncDocument = /*#__PURE__*/ gql`
  mutation PartnerIntegrationSync($input: IntegrationSyncInput) {
    PartnerIntegrationSync(input: $input) {
      success
      message
    }
  }
`
export type PartnerIntegrationSyncMutationFn = Apollo.MutationFunction<
  PartnerIntegrationSyncMutation,
  PartnerIntegrationSyncMutationVariables
>

/**
 * __usePartnerIntegrationSyncMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationSyncMutation, { data, loading, error }] = usePartnerIntegrationSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerIntegrationSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerIntegrationSyncMutation,
    PartnerIntegrationSyncMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerIntegrationSyncMutation,
    PartnerIntegrationSyncMutationVariables
  >(PartnerIntegrationSyncDocument, options)
}
export type PartnerIntegrationSyncMutationHookResult = ReturnType<
  typeof usePartnerIntegrationSyncMutation
>
export type PartnerIntegrationSyncMutationResult =
  Apollo.MutationResult<PartnerIntegrationSyncMutation>
export type PartnerIntegrationSyncMutationOptions = Apollo.BaseMutationOptions<
  PartnerIntegrationSyncMutation,
  PartnerIntegrationSyncMutationVariables
>
export const PartnerListUnsyncedInvoicesDocument = /*#__PURE__*/ gql`
  query PartnerListUnsyncedInvoices(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: UnsyncedInvoicesOrderBy
    $filters: UnsyncedInvoicesFilter
  ) {
    PartnerListUnsyncedInvoices(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          ...PartnerUnsyncedInvoice
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
  ${PartnerUnsyncedInvoiceFragmentDoc}
`

/**
 * __usePartnerListUnsyncedInvoicesQuery__
 *
 * To run a query within a React component, call `usePartnerListUnsyncedInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListUnsyncedInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListUnsyncedInvoicesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerListUnsyncedInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >(PartnerListUnsyncedInvoicesDocument, options)
}
export function usePartnerListUnsyncedInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >(PartnerListUnsyncedInvoicesDocument, options)
}
export type PartnerListUnsyncedInvoicesQueryHookResult = ReturnType<
  typeof usePartnerListUnsyncedInvoicesQuery
>
export type PartnerListUnsyncedInvoicesLazyQueryHookResult = ReturnType<
  typeof usePartnerListUnsyncedInvoicesLazyQuery
>
export type PartnerListUnsyncedInvoicesQueryResult = Apollo.QueryResult<
  PartnerListUnsyncedInvoicesQuery,
  PartnerListUnsyncedInvoicesQueryVariables
>
export const PartnerGetUnsyncedInvoiceTotalsDocument = /*#__PURE__*/ gql`
  query PartnerGetUnsyncedInvoiceTotals($filters: UnsyncedInvoicesFilter) {
    PartnerGetUnsyncedInvoiceTotals(filters: $filters) {
      count
      amount
    }
  }
`

/**
 * __usePartnerGetUnsyncedInvoiceTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerGetUnsyncedInvoiceTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUnsyncedInvoiceTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUnsyncedInvoiceTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetUnsyncedInvoiceTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >(PartnerGetUnsyncedInvoiceTotalsDocument, options)
}
export function usePartnerGetUnsyncedInvoiceTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >(PartnerGetUnsyncedInvoiceTotalsDocument, options)
}
export type PartnerGetUnsyncedInvoiceTotalsQueryHookResult = ReturnType<
  typeof usePartnerGetUnsyncedInvoiceTotalsQuery
>
export type PartnerGetUnsyncedInvoiceTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUnsyncedInvoiceTotalsLazyQuery
>
export type PartnerGetUnsyncedInvoiceTotalsQueryResult = Apollo.QueryResult<
  PartnerGetUnsyncedInvoiceTotalsQuery,
  PartnerGetUnsyncedInvoiceTotalsQueryVariables
>
export const PartnerAccountingSyncBatchCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingSyncBatchCreate(
    $input: AccountingSyncBatchCreateInput
  ) {
    PartnerAccountingSyncBatchCreate(input: $input) {
      batch {
        id
      }
      notSyncedInvoiceNumbers
    }
  }
`
export type PartnerAccountingSyncBatchCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >

/**
 * __usePartnerAccountingSyncBatchCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingSyncBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingSyncBatchCreateMutation, { data, loading, error }] = usePartnerAccountingSyncBatchCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncBatchCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >(PartnerAccountingSyncBatchCreateDocument, options)
}
export type PartnerAccountingSyncBatchCreateMutationHookResult = ReturnType<
  typeof usePartnerAccountingSyncBatchCreateMutation
>
export type PartnerAccountingSyncBatchCreateMutationResult =
  Apollo.MutationResult<PartnerAccountingSyncBatchCreateMutation>
export type PartnerAccountingSyncBatchCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >
export const PartnerGetAccountingSyncBatchDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountingSyncBatch($batchID: ID!) {
    PartnerGetAccountingSyncBatch(batchID: $batchID) {
      batch {
        ...AccountingSyncBatch
      }
      invoiceJobs {
        internalEntityID
        type
        status
        invoiceData {
          invoiceNumber
          invoiceDate
          dueDate
          amount
          customerName
        }
      }
    }
  }
  ${AccountingSyncBatchFragmentDoc}
`

/**
 * __usePartnerGetAccountingSyncBatchQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountingSyncBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountingSyncBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountingSyncBatchQuery({
 *   variables: {
 *      batchID: // value for 'batchID'
 *   },
 * });
 */
export function usePartnerGetAccountingSyncBatchQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >(PartnerGetAccountingSyncBatchDocument, options)
}
export function usePartnerGetAccountingSyncBatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >(PartnerGetAccountingSyncBatchDocument, options)
}
export type PartnerGetAccountingSyncBatchQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingSyncBatchQuery
>
export type PartnerGetAccountingSyncBatchLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingSyncBatchLazyQuery
>
export type PartnerGetAccountingSyncBatchQueryResult = Apollo.QueryResult<
  PartnerGetAccountingSyncBatchQuery,
  PartnerGetAccountingSyncBatchQueryVariables
>
export const PartnerListAccountingSyncBatchesDocument = /*#__PURE__*/ gql`
  query PartnerListAccountingSyncBatches(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: ListAccountingSyncBatchesFilter
  ) {
    PartnerListAccountingSyncBatches(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          ...AccountingSyncBatch
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
  ${AccountingSyncBatchFragmentDoc}
`

/**
 * __usePartnerListAccountingSyncBatchesQuery__
 *
 * To run a query within a React component, call `usePartnerListAccountingSyncBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAccountingSyncBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAccountingSyncBatchesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerListAccountingSyncBatchesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >(PartnerListAccountingSyncBatchesDocument, options)
}
export function usePartnerListAccountingSyncBatchesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >(PartnerListAccountingSyncBatchesDocument, options)
}
export type PartnerListAccountingSyncBatchesQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncBatchesQuery
>
export type PartnerListAccountingSyncBatchesLazyQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncBatchesLazyQuery
>
export type PartnerListAccountingSyncBatchesQueryResult = Apollo.QueryResult<
  PartnerListAccountingSyncBatchesQuery,
  PartnerListAccountingSyncBatchesQueryVariables
>
export const PartnerListAccountingSyncJobsDocument = /*#__PURE__*/ gql`
  query PartnerListAccountingSyncJobs($batchID: ID!, $parentID: ID!) {
    PartnerListAccountingSyncJobs(batchID: $batchID, parentID: $parentID) {
      jobs {
        status
        type
        errorMessage
        invoiceData {
          invoiceNumber
          invoiceDate
          dueDate
          amount
          customerName
        }
        customerData {
          customerName
        }
        lineItemData {
          lineItemName
        }
        billingTermData {
          billingTermName
        }
        paymentData {
          amount
        }
      }
    }
  }
`

/**
 * __usePartnerListAccountingSyncJobsQuery__
 *
 * To run a query within a React component, call `usePartnerListAccountingSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAccountingSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAccountingSyncJobsQuery({
 *   variables: {
 *      batchID: // value for 'batchID'
 *      parentID: // value for 'parentID'
 *   },
 * });
 */
export function usePartnerListAccountingSyncJobsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >(PartnerListAccountingSyncJobsDocument, options)
}
export function usePartnerListAccountingSyncJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >(PartnerListAccountingSyncJobsDocument, options)
}
export type PartnerListAccountingSyncJobsQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncJobsQuery
>
export type PartnerListAccountingSyncJobsLazyQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncJobsLazyQuery
>
export type PartnerListAccountingSyncJobsQueryResult = Apollo.QueryResult<
  PartnerListAccountingSyncJobsQuery,
  PartnerListAccountingSyncJobsQueryVariables
>
export const PartnerSecondaryIntegrationDeleteDocument = /*#__PURE__*/ gql`
  mutation PartnerSecondaryIntegrationDelete(
    $input: SecondaryIntegrationDeleteInput!
  ) {
    PartnerSecondaryIntegrationDelete(input: $input)
  }
`
export type PartnerSecondaryIntegrationDeleteMutationFn =
  Apollo.MutationFunction<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >

/**
 * __usePartnerSecondaryIntegrationDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerSecondaryIntegrationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSecondaryIntegrationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSecondaryIntegrationDeleteMutation, { data, loading, error }] = usePartnerSecondaryIntegrationDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSecondaryIntegrationDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >(PartnerSecondaryIntegrationDeleteDocument, options)
}
export type PartnerSecondaryIntegrationDeleteMutationHookResult = ReturnType<
  typeof usePartnerSecondaryIntegrationDeleteMutation
>
export type PartnerSecondaryIntegrationDeleteMutationResult =
  Apollo.MutationResult<PartnerSecondaryIntegrationDeleteMutation>
export type PartnerSecondaryIntegrationDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >
export const PartnerRefreshUnsyncedInvoicesDocument = /*#__PURE__*/ gql`
  mutation PartnerRefreshUnsyncedInvoices($platformName: PlatformName!) {
    PartnerRefreshUnsyncedInvoices(platformName: $platformName)
  }
`
export type PartnerRefreshUnsyncedInvoicesMutationFn = Apollo.MutationFunction<
  PartnerRefreshUnsyncedInvoicesMutation,
  PartnerRefreshUnsyncedInvoicesMutationVariables
>

/**
 * __usePartnerRefreshUnsyncedInvoicesMutation__
 *
 * To run a mutation, you first call `usePartnerRefreshUnsyncedInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRefreshUnsyncedInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRefreshUnsyncedInvoicesMutation, { data, loading, error }] = usePartnerRefreshUnsyncedInvoicesMutation({
 *   variables: {
 *      platformName: // value for 'platformName'
 *   },
 * });
 */
export function usePartnerRefreshUnsyncedInvoicesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRefreshUnsyncedInvoicesMutation,
    PartnerRefreshUnsyncedInvoicesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRefreshUnsyncedInvoicesMutation,
    PartnerRefreshUnsyncedInvoicesMutationVariables
  >(PartnerRefreshUnsyncedInvoicesDocument, options)
}
export type PartnerRefreshUnsyncedInvoicesMutationHookResult = ReturnType<
  typeof usePartnerRefreshUnsyncedInvoicesMutation
>
export type PartnerRefreshUnsyncedInvoicesMutationResult =
  Apollo.MutationResult<PartnerRefreshUnsyncedInvoicesMutation>
export type PartnerRefreshUnsyncedInvoicesMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRefreshUnsyncedInvoicesMutation,
    PartnerRefreshUnsyncedInvoicesMutationVariables
  >
export const PartnerGetLastRefreshTriggeredDocument = /*#__PURE__*/ gql`
  query PartnerGetLastRefreshTriggered($platformName: PlatformName!) {
    PartnerGetLastRefreshTriggered(platformName: $platformName) {
      triggeredAt
    }
  }
`

/**
 * __usePartnerGetLastRefreshTriggeredQuery__
 *
 * To run a query within a React component, call `usePartnerGetLastRefreshTriggeredQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetLastRefreshTriggeredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetLastRefreshTriggeredQuery({
 *   variables: {
 *      platformName: // value for 'platformName'
 *   },
 * });
 */
export function usePartnerGetLastRefreshTriggeredQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetLastRefreshTriggeredQuery,
    PartnerGetLastRefreshTriggeredQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetLastRefreshTriggeredQuery,
    PartnerGetLastRefreshTriggeredQueryVariables
  >(PartnerGetLastRefreshTriggeredDocument, options)
}
export function usePartnerGetLastRefreshTriggeredLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetLastRefreshTriggeredQuery,
    PartnerGetLastRefreshTriggeredQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetLastRefreshTriggeredQuery,
    PartnerGetLastRefreshTriggeredQueryVariables
  >(PartnerGetLastRefreshTriggeredDocument, options)
}
export type PartnerGetLastRefreshTriggeredQueryHookResult = ReturnType<
  typeof usePartnerGetLastRefreshTriggeredQuery
>
export type PartnerGetLastRefreshTriggeredLazyQueryHookResult = ReturnType<
  typeof usePartnerGetLastRefreshTriggeredLazyQuery
>
export type PartnerGetLastRefreshTriggeredQueryResult = Apollo.QueryResult<
  PartnerGetLastRefreshTriggeredQuery,
  PartnerGetLastRefreshTriggeredQueryVariables
>
export const PartnerListAvailableIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListAvailableIntegrations {
    PartnerListAvailableIntegrations {
      platforms
    }
  }
`

/**
 * __usePartnerListAvailableIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListAvailableIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAvailableIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAvailableIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListAvailableIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListAvailableIntegrationsQuery,
    PartnerListAvailableIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAvailableIntegrationsQuery,
    PartnerListAvailableIntegrationsQueryVariables
  >(PartnerListAvailableIntegrationsDocument, options)
}
export function usePartnerListAvailableIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAvailableIntegrationsQuery,
    PartnerListAvailableIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAvailableIntegrationsQuery,
    PartnerListAvailableIntegrationsQueryVariables
  >(PartnerListAvailableIntegrationsDocument, options)
}
export type PartnerListAvailableIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListAvailableIntegrationsQuery
>
export type PartnerListAvailableIntegrationsLazyQueryHookResult = ReturnType<
  typeof usePartnerListAvailableIntegrationsLazyQuery
>
export type PartnerListAvailableIntegrationsQueryResult = Apollo.QueryResult<
  PartnerListAvailableIntegrationsQuery,
  PartnerListAvailableIntegrationsQueryVariables
>
export const PartnerResolveCustomerIntegrationIDsDocument = /*#__PURE__*/ gql`
  query PartnerResolveCustomerIntegrationIDs(
    $input: ResolveCustomerIntegrationIDsInput!
  ) {
    PartnerResolveCustomerIntegrationIDs(input: $input) {
      mappings {
        customerID
        integrationEntityID
      }
      unresolvedCustomerIDs
    }
  }
`

/**
 * __usePartnerResolveCustomerIntegrationIDsQuery__
 *
 * To run a query within a React component, call `usePartnerResolveCustomerIntegrationIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerResolveCustomerIntegrationIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerResolveCustomerIntegrationIDsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerResolveCustomerIntegrationIDsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerResolveCustomerIntegrationIDsQuery,
    PartnerResolveCustomerIntegrationIDsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerResolveCustomerIntegrationIDsQuery,
    PartnerResolveCustomerIntegrationIDsQueryVariables
  >(PartnerResolveCustomerIntegrationIDsDocument, options)
}
export function usePartnerResolveCustomerIntegrationIDsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerResolveCustomerIntegrationIDsQuery,
    PartnerResolveCustomerIntegrationIDsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerResolveCustomerIntegrationIDsQuery,
    PartnerResolveCustomerIntegrationIDsQueryVariables
  >(PartnerResolveCustomerIntegrationIDsDocument, options)
}
export type PartnerResolveCustomerIntegrationIDsQueryHookResult = ReturnType<
  typeof usePartnerResolveCustomerIntegrationIDsQuery
>
export type PartnerResolveCustomerIntegrationIDsLazyQueryHookResult =
  ReturnType<typeof usePartnerResolveCustomerIntegrationIDsLazyQuery>
export type PartnerResolveCustomerIntegrationIDsQueryResult =
  Apollo.QueryResult<
    PartnerResolveCustomerIntegrationIDsQuery,
    PartnerResolveCustomerIntegrationIDsQueryVariables
  >
export const PartnerGetAccountingPreferencesDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountingPreferences {
    PartnerGetAccountingPreferences {
      pdfFromPrimary
      pushPaymentsTo
      contactsFromPrimary
      archiveZeroedInvoices
      useIntegrationPDF
      syncPaymentsQboCw
      apEnabled
      paymentFailedNotificationEnabled
    }
  }
`

/**
 * __usePartnerGetAccountingPreferencesQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountingPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountingPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountingPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetAccountingPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >(PartnerGetAccountingPreferencesDocument, options)
}
export function usePartnerGetAccountingPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >(PartnerGetAccountingPreferencesDocument, options)
}
export type PartnerGetAccountingPreferencesQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingPreferencesQuery
>
export type PartnerGetAccountingPreferencesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingPreferencesLazyQuery
>
export type PartnerGetAccountingPreferencesQueryResult = Apollo.QueryResult<
  PartnerGetAccountingPreferencesQuery,
  PartnerGetAccountingPreferencesQueryVariables
>
export const PartnerAccountingPreferencesUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingPreferencesUpdate(
    $input: AccountingPreferencesUpdateInput
  ) {
    PartnerAccountingPreferencesUpdate(input: $input) {
      pdfFromPrimary
      pushPaymentsTo
      contactsFromPrimary
      syncPaymentsQboCw
      paymentFailedNotificationEnabled
    }
  }
`
export type PartnerAccountingPreferencesUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >

/**
 * __usePartnerAccountingPreferencesUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingPreferencesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingPreferencesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingPreferencesUpdateMutation, { data, loading, error }] = usePartnerAccountingPreferencesUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingPreferencesUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >(PartnerAccountingPreferencesUpdateDocument, options)
}
export type PartnerAccountingPreferencesUpdateMutationHookResult = ReturnType<
  typeof usePartnerAccountingPreferencesUpdateMutation
>
export type PartnerAccountingPreferencesUpdateMutationResult =
  Apollo.MutationResult<PartnerAccountingPreferencesUpdateMutation>
export type PartnerAccountingPreferencesUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >
export const PartnerQuickbooksConnectionUrlDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksConnectionURL($redirectURI: String!) {
    PartnerQuickbooksConnectionURL(redirectURI: $redirectURI)
  }
`

/**
 * __usePartnerQuickbooksConnectionUrlQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksConnectionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksConnectionUrlQuery({
 *   variables: {
 *      redirectURI: // value for 'redirectURI'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >(PartnerQuickbooksConnectionUrlDocument, options)
}
export function usePartnerQuickbooksConnectionUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >(PartnerQuickbooksConnectionUrlDocument, options)
}
export type PartnerQuickbooksConnectionUrlQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionUrlQuery
>
export type PartnerQuickbooksConnectionUrlLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionUrlLazyQuery
>
export type PartnerQuickbooksConnectionUrlQueryResult = Apollo.QueryResult<
  PartnerQuickbooksConnectionUrlQuery,
  PartnerQuickbooksConnectionUrlQueryVariables
>
export const PartnerQuickbooksAccountListDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksAccountList {
    PartnerQuickbooksAccountList {
      forDeposits {
        ...QuickbooksAccount
      }
      forFees {
        ...QuickbooksAccount
      }
    }
  }
  ${QuickbooksAccountFragmentDoc}
`

/**
 * __usePartnerQuickbooksAccountListQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksAccountListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksAccountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksAccountListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksAccountListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >(PartnerQuickbooksAccountListDocument, options)
}
export function usePartnerQuickbooksAccountListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >(PartnerQuickbooksAccountListDocument, options)
}
export type PartnerQuickbooksAccountListQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountListQuery
>
export type PartnerQuickbooksAccountListLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountListLazyQuery
>
export type PartnerQuickbooksAccountListQueryResult = Apollo.QueryResult<
  PartnerQuickbooksAccountListQuery,
  PartnerQuickbooksAccountListQueryVariables
>
export const PartnerQuickbooksAccountRetrieveDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksAccountRetrieve {
    PartnerQuickbooksAccountRetrieve {
      forDeposits {
        ...QuickbooksAccount
      }
      forFees {
        ...QuickbooksAccount
      }
    }
  }
  ${QuickbooksAccountFragmentDoc}
`

/**
 * __usePartnerQuickbooksAccountRetrieveQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksAccountRetrieveQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksAccountRetrieveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksAccountRetrieveQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksAccountRetrieveQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >(PartnerQuickbooksAccountRetrieveDocument, options)
}
export function usePartnerQuickbooksAccountRetrieveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >(PartnerQuickbooksAccountRetrieveDocument, options)
}
export type PartnerQuickbooksAccountRetrieveQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountRetrieveQuery
>
export type PartnerQuickbooksAccountRetrieveLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountRetrieveLazyQuery
>
export type PartnerQuickbooksAccountRetrieveQueryResult = Apollo.QueryResult<
  PartnerQuickbooksAccountRetrieveQuery,
  PartnerQuickbooksAccountRetrieveQueryVariables
>
export const PartnerQuickbooksAccountUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksAccountUpdate(
    $input: QuickbooksAccountUpdateInput
  ) {
    PartnerQuickbooksAccountUpdate(input: $input)
  }
`
export type PartnerQuickbooksAccountUpdateMutationFn = Apollo.MutationFunction<
  PartnerQuickbooksAccountUpdateMutation,
  PartnerQuickbooksAccountUpdateMutationVariables
>

/**
 * __usePartnerQuickbooksAccountUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksAccountUpdateMutation, { data, loading, error }] = usePartnerQuickbooksAccountUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerQuickbooksAccountUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksAccountUpdateMutation,
    PartnerQuickbooksAccountUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksAccountUpdateMutation,
    PartnerQuickbooksAccountUpdateMutationVariables
  >(PartnerQuickbooksAccountUpdateDocument, options)
}
export type PartnerQuickbooksAccountUpdateMutationHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountUpdateMutation
>
export type PartnerQuickbooksAccountUpdateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksAccountUpdateMutation>
export type PartnerQuickbooksAccountUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksAccountUpdateMutation,
    PartnerQuickbooksAccountUpdateMutationVariables
  >
export const PartnerQuickbooksConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksConnectionCreate(
    $code: String!
    $state: String!
    $realmId: String!
    $integrationType: IntegrationType!
    $currency: Currency!
  ) {
    PartnerQuickbooksConnectionCreate(
      code: $code
      state: $state
      realmId: $realmId
      integrationType: $integrationType
      currency: $currency
    )
  }
`
export type PartnerQuickbooksConnectionCreateMutationFn =
  Apollo.MutationFunction<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >

/**
 * __usePartnerQuickbooksConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksConnectionCreateMutation, { data, loading, error }] = usePartnerQuickbooksConnectionCreateMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *      realmId: // value for 'realmId'
 *      integrationType: // value for 'integrationType'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >(PartnerQuickbooksConnectionCreateDocument, options)
}
export type PartnerQuickbooksConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionCreateMutation
>
export type PartnerQuickbooksConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksConnectionCreateMutation>
export type PartnerQuickbooksConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >
export const PartnerQuickbooksConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksConnectionUpdate(
    $createDeposits: Boolean
    $pushBillPaymentStatus: Boolean
    $autoSyncVendors: Boolean
  ) {
    PartnerQuickbooksConnectionUpdate(
      createDeposits: $createDeposits
      pushBillPaymentStatus: $pushBillPaymentStatus
      autoSyncVendors: $autoSyncVendors
    )
  }
`
export type PartnerQuickbooksConnectionUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >

/**
 * __usePartnerQuickbooksConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksConnectionUpdateMutation, { data, loading, error }] = usePartnerQuickbooksConnectionUpdateMutation({
 *   variables: {
 *      createDeposits: // value for 'createDeposits'
 *      pushBillPaymentStatus: // value for 'pushBillPaymentStatus'
 *      autoSyncVendors: // value for 'autoSyncVendors'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >(PartnerQuickbooksConnectionUpdateDocument, options)
}
export type PartnerQuickbooksConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionUpdateMutation
>
export type PartnerQuickbooksConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksConnectionUpdateMutation>
export type PartnerQuickbooksConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >
export const PartnerQuickbooksConnectionReadDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksConnectionRead {
    PartnerQuickbooksConnectionRead {
      createDeposits
      pushBillPaymentStatus
      autoSyncVendors
      queryFilters {
        customerTypes {
          id
          name
        }
      }
    }
  }
`

/**
 * __usePartnerQuickbooksConnectionReadQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksConnectionReadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksConnectionReadQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionReadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >(PartnerQuickbooksConnectionReadDocument, options)
}
export function usePartnerQuickbooksConnectionReadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >(PartnerQuickbooksConnectionReadDocument, options)
}
export type PartnerQuickbooksConnectionReadQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionReadQuery
>
export type PartnerQuickbooksConnectionReadLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionReadLazyQuery
>
export type PartnerQuickbooksConnectionReadQueryResult = Apollo.QueryResult<
  PartnerQuickbooksConnectionReadQuery,
  PartnerQuickbooksConnectionReadQueryVariables
>
export const PartnerListExpenseAccountsDocument = /*#__PURE__*/ gql`
  query PartnerListExpenseAccounts {
    PartnerListExpenseAccounts {
      id
      externalId
      name
      type
      accountNumber
      fullyQualifiedName
      active
      visible
    }
  }
`

/**
 * __usePartnerListExpenseAccountsQuery__
 *
 * To run a query within a React component, call `usePartnerListExpenseAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListExpenseAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListExpenseAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListExpenseAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListExpenseAccountsQuery,
    PartnerListExpenseAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListExpenseAccountsQuery,
    PartnerListExpenseAccountsQueryVariables
  >(PartnerListExpenseAccountsDocument, options)
}
export function usePartnerListExpenseAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListExpenseAccountsQuery,
    PartnerListExpenseAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListExpenseAccountsQuery,
    PartnerListExpenseAccountsQueryVariables
  >(PartnerListExpenseAccountsDocument, options)
}
export type PartnerListExpenseAccountsQueryHookResult = ReturnType<
  typeof usePartnerListExpenseAccountsQuery
>
export type PartnerListExpenseAccountsLazyQueryHookResult = ReturnType<
  typeof usePartnerListExpenseAccountsLazyQuery
>
export type PartnerListExpenseAccountsQueryResult = Apollo.QueryResult<
  PartnerListExpenseAccountsQuery,
  PartnerListExpenseAccountsQueryVariables
>
export const PartnerListVisibleExpenseAccountsDocument = /*#__PURE__*/ gql`
  query PartnerListVisibleExpenseAccounts {
    PartnerListVisibleExpenseAccounts {
      id
      externalId
      name
      type
      accountNumber
      fullyQualifiedName
      active
      visible
    }
  }
`

/**
 * __usePartnerListVisibleExpenseAccountsQuery__
 *
 * To run a query within a React component, call `usePartnerListVisibleExpenseAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListVisibleExpenseAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListVisibleExpenseAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListVisibleExpenseAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListVisibleExpenseAccountsQuery,
    PartnerListVisibleExpenseAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListVisibleExpenseAccountsQuery,
    PartnerListVisibleExpenseAccountsQueryVariables
  >(PartnerListVisibleExpenseAccountsDocument, options)
}
export function usePartnerListVisibleExpenseAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListVisibleExpenseAccountsQuery,
    PartnerListVisibleExpenseAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListVisibleExpenseAccountsQuery,
    PartnerListVisibleExpenseAccountsQueryVariables
  >(PartnerListVisibleExpenseAccountsDocument, options)
}
export type PartnerListVisibleExpenseAccountsQueryHookResult = ReturnType<
  typeof usePartnerListVisibleExpenseAccountsQuery
>
export type PartnerListVisibleExpenseAccountsLazyQueryHookResult = ReturnType<
  typeof usePartnerListVisibleExpenseAccountsLazyQuery
>
export type PartnerListVisibleExpenseAccountsQueryResult = Apollo.QueryResult<
  PartnerListVisibleExpenseAccountsQuery,
  PartnerListVisibleExpenseAccountsQueryVariables
>
export const PartnerUpdateExpenseAccountVisibilityDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateExpenseAccountVisibility(
    $accountIds: [ID!]!
    $visible: Boolean!
  ) {
    PartnerUpdateExpenseAccountVisibility(
      accountIds: $accountIds
      visible: $visible
    ) {
      id
      externalId
      name
      type
      accountNumber
      fullyQualifiedName
      active
      visible
    }
  }
`
export type PartnerUpdateExpenseAccountVisibilityMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateExpenseAccountVisibilityMutation,
    PartnerUpdateExpenseAccountVisibilityMutationVariables
  >

/**
 * __usePartnerUpdateExpenseAccountVisibilityMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateExpenseAccountVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateExpenseAccountVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateExpenseAccountVisibilityMutation, { data, loading, error }] = usePartnerUpdateExpenseAccountVisibilityMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function usePartnerUpdateExpenseAccountVisibilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateExpenseAccountVisibilityMutation,
    PartnerUpdateExpenseAccountVisibilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateExpenseAccountVisibilityMutation,
    PartnerUpdateExpenseAccountVisibilityMutationVariables
  >(PartnerUpdateExpenseAccountVisibilityDocument, options)
}
export type PartnerUpdateExpenseAccountVisibilityMutationHookResult =
  ReturnType<typeof usePartnerUpdateExpenseAccountVisibilityMutation>
export type PartnerUpdateExpenseAccountVisibilityMutationResult =
  Apollo.MutationResult<PartnerUpdateExpenseAccountVisibilityMutation>
export type PartnerUpdateExpenseAccountVisibilityMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateExpenseAccountVisibilityMutation,
    PartnerUpdateExpenseAccountVisibilityMutationVariables
  >
export const PartnerRecurringTransactionConnectionDocument = /*#__PURE__*/ gql`
  query PartnerRecurringTransactionConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: RecurringTransactionOrderBy
    $filter: RecurringTransactionFilter
  ) {
    PartnerRecurringTransactionConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerRecurringTransactionConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerRecurringTransactionConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRecurringTransactionConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRecurringTransactionConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerRecurringTransactionConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >(PartnerRecurringTransactionConnectionDocument, options)
}
export function usePartnerRecurringTransactionConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >(PartnerRecurringTransactionConnectionDocument, options)
}
export type PartnerRecurringTransactionConnectionQueryHookResult = ReturnType<
  typeof usePartnerRecurringTransactionConnectionQuery
>
export type PartnerRecurringTransactionConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerRecurringTransactionConnectionLazyQuery>
export type PartnerRecurringTransactionConnectionQueryResult =
  Apollo.QueryResult<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >
export const PartnerQuickbooksTaxCodeGetDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksTaxCodeGet {
    PartnerQuickbooksTaxCodeGet {
      id
      name
    }
  }
`

/**
 * __usePartnerQuickbooksTaxCodeGetQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksTaxCodeGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksTaxCodeGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksTaxCodeGetQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksTaxCodeGetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksTaxCodeGetQuery,
    PartnerQuickbooksTaxCodeGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksTaxCodeGetQuery,
    PartnerQuickbooksTaxCodeGetQueryVariables
  >(PartnerQuickbooksTaxCodeGetDocument, options)
}
export function usePartnerQuickbooksTaxCodeGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksTaxCodeGetQuery,
    PartnerQuickbooksTaxCodeGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksTaxCodeGetQuery,
    PartnerQuickbooksTaxCodeGetQueryVariables
  >(PartnerQuickbooksTaxCodeGetDocument, options)
}
export type PartnerQuickbooksTaxCodeGetQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksTaxCodeGetQuery
>
export type PartnerQuickbooksTaxCodeGetLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksTaxCodeGetLazyQuery
>
export type PartnerQuickbooksTaxCodeGetQueryResult = Apollo.QueryResult<
  PartnerQuickbooksTaxCodeGetQuery,
  PartnerQuickbooksTaxCodeGetQueryVariables
>
export const PartnerQuickbooksCustomerTypeListDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksCustomerTypeList {
    PartnerQuickbooksCustomerTypeList {
      customerTypes {
        id
        name
      }
    }
  }
`

/**
 * __usePartnerQuickbooksCustomerTypeListQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksCustomerTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksCustomerTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksCustomerTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksCustomerTypeListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksCustomerTypeListQuery,
    PartnerQuickbooksCustomerTypeListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksCustomerTypeListQuery,
    PartnerQuickbooksCustomerTypeListQueryVariables
  >(PartnerQuickbooksCustomerTypeListDocument, options)
}
export function usePartnerQuickbooksCustomerTypeListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksCustomerTypeListQuery,
    PartnerQuickbooksCustomerTypeListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksCustomerTypeListQuery,
    PartnerQuickbooksCustomerTypeListQueryVariables
  >(PartnerQuickbooksCustomerTypeListDocument, options)
}
export type PartnerQuickbooksCustomerTypeListQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksCustomerTypeListQuery
>
export type PartnerQuickbooksCustomerTypeListLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksCustomerTypeListLazyQuery
>
export type PartnerQuickbooksCustomerTypeListQueryResult = Apollo.QueryResult<
  PartnerQuickbooksCustomerTypeListQuery,
  PartnerQuickbooksCustomerTypeListQueryVariables
>
export const PartnerQuickbooksConnectionQueryFiltersUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksConnectionQueryFiltersUpdate(
    $input: QuickbooksConnectionQueryFiltersInput!
  ) {
    PartnerQuickbooksConnectionQueryFiltersUpdate(input: $input)
  }
`
export type PartnerQuickbooksConnectionQueryFiltersUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerQuickbooksConnectionQueryFiltersUpdateMutation,
    PartnerQuickbooksConnectionQueryFiltersUpdateMutationVariables
  >

/**
 * __usePartnerQuickbooksConnectionQueryFiltersUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksConnectionQueryFiltersUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionQueryFiltersUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksConnectionQueryFiltersUpdateMutation, { data, loading, error }] = usePartnerQuickbooksConnectionQueryFiltersUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionQueryFiltersUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksConnectionQueryFiltersUpdateMutation,
    PartnerQuickbooksConnectionQueryFiltersUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksConnectionQueryFiltersUpdateMutation,
    PartnerQuickbooksConnectionQueryFiltersUpdateMutationVariables
  >(PartnerQuickbooksConnectionQueryFiltersUpdateDocument, options)
}
export type PartnerQuickbooksConnectionQueryFiltersUpdateMutationHookResult =
  ReturnType<typeof usePartnerQuickbooksConnectionQueryFiltersUpdateMutation>
export type PartnerQuickbooksConnectionQueryFiltersUpdateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksConnectionQueryFiltersUpdateMutation>
export type PartnerQuickbooksConnectionQueryFiltersUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksConnectionQueryFiltersUpdateMutation,
    PartnerQuickbooksConnectionQueryFiltersUpdateMutationVariables
  >
export const PartnerQuickbooksInvoiceCustomFieldsListDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksInvoiceCustomFieldsList {
    PartnerQuickbooksInvoiceCustomFieldsList {
      definitionId
      name
    }
  }
`

/**
 * __usePartnerQuickbooksInvoiceCustomFieldsListQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksInvoiceCustomFieldsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksInvoiceCustomFieldsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksInvoiceCustomFieldsListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksInvoiceCustomFieldsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksInvoiceCustomFieldsListQuery,
    PartnerQuickbooksInvoiceCustomFieldsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksInvoiceCustomFieldsListQuery,
    PartnerQuickbooksInvoiceCustomFieldsListQueryVariables
  >(PartnerQuickbooksInvoiceCustomFieldsListDocument, options)
}
export function usePartnerQuickbooksInvoiceCustomFieldsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksInvoiceCustomFieldsListQuery,
    PartnerQuickbooksInvoiceCustomFieldsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksInvoiceCustomFieldsListQuery,
    PartnerQuickbooksInvoiceCustomFieldsListQueryVariables
  >(PartnerQuickbooksInvoiceCustomFieldsListDocument, options)
}
export type PartnerQuickbooksInvoiceCustomFieldsListQueryHookResult =
  ReturnType<typeof usePartnerQuickbooksInvoiceCustomFieldsListQuery>
export type PartnerQuickbooksInvoiceCustomFieldsListLazyQueryHookResult =
  ReturnType<typeof usePartnerQuickbooksInvoiceCustomFieldsListLazyQuery>
export type PartnerQuickbooksInvoiceCustomFieldsListQueryResult =
  Apollo.QueryResult<
    PartnerQuickbooksInvoiceCustomFieldsListQuery,
    PartnerQuickbooksInvoiceCustomFieldsListQueryVariables
  >
export const PartnerRutterConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterConnectionCreate($input: ConnectionCreateInput) {
    PartnerRutterConnectionCreate(input: $input) {
      platform
      status
    }
  }
`
export type PartnerRutterConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerRutterConnectionCreateMutation,
  PartnerRutterConnectionCreateMutationVariables
>

/**
 * __usePartnerRutterConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerRutterConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterConnectionCreateMutation, { data, loading, error }] = usePartnerRutterConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterConnectionCreateMutation,
    PartnerRutterConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterConnectionCreateMutation,
    PartnerRutterConnectionCreateMutationVariables
  >(PartnerRutterConnectionCreateDocument, options)
}
export type PartnerRutterConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerRutterConnectionCreateMutation
>
export type PartnerRutterConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerRutterConnectionCreateMutation>
export type PartnerRutterConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterConnectionCreateMutation,
    PartnerRutterConnectionCreateMutationVariables
  >
export const PartnerRutterAccountListDocument = /*#__PURE__*/ gql`
  query PartnerRutterAccountList($input: RutterAccountListInput) {
    PartnerRutterAccountList(input: $input) {
      ...RutterAccountList
    }
  }
  ${RutterAccountListFragmentDoc}
`

/**
 * __usePartnerRutterAccountListQuery__
 *
 * To run a query within a React component, call `usePartnerRutterAccountListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterAccountListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >(PartnerRutterAccountListDocument, options)
}
export function usePartnerRutterAccountListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >(PartnerRutterAccountListDocument, options)
}
export type PartnerRutterAccountListQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountListQuery
>
export type PartnerRutterAccountListLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountListLazyQuery
>
export type PartnerRutterAccountListQueryResult = Apollo.QueryResult<
  PartnerRutterAccountListQuery,
  PartnerRutterAccountListQueryVariables
>
export const PartnerRutterAccountUpsertDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterAccountUpsert($input: RutterAccountUpsertInput) {
    PartnerRutterAccountUpsert(input: $input)
  }
`
export type PartnerRutterAccountUpsertMutationFn = Apollo.MutationFunction<
  PartnerRutterAccountUpsertMutation,
  PartnerRutterAccountUpsertMutationVariables
>

/**
 * __usePartnerRutterAccountUpsertMutation__
 *
 * To run a mutation, you first call `usePartnerRutterAccountUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterAccountUpsertMutation, { data, loading, error }] = usePartnerRutterAccountUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountUpsertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterAccountUpsertMutation,
    PartnerRutterAccountUpsertMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterAccountUpsertMutation,
    PartnerRutterAccountUpsertMutationVariables
  >(PartnerRutterAccountUpsertDocument, options)
}
export type PartnerRutterAccountUpsertMutationHookResult = ReturnType<
  typeof usePartnerRutterAccountUpsertMutation
>
export type PartnerRutterAccountUpsertMutationResult =
  Apollo.MutationResult<PartnerRutterAccountUpsertMutation>
export type PartnerRutterAccountUpsertMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterAccountUpsertMutation,
    PartnerRutterAccountUpsertMutationVariables
  >
export const PartnerRutterAccountReadDocument = /*#__PURE__*/ gql`
  query PartnerRutterAccountRead($platform: RutterPlatform) {
    PartnerRutterAccountRead(platform: $platform) {
      AccountForDeposits {
        id
      }
      AccountForPayments {
        id
      }
      AccountForFunds {
        id
      }
      AccountForFees {
        id
      }
      AccountForRefunds {
        id
      }
    }
  }
`

/**
 * __usePartnerRutterAccountReadQuery__
 *
 * To run a query within a React component, call `usePartnerRutterAccountReadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterAccountReadQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function usePartnerRutterAccountReadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >(PartnerRutterAccountReadDocument, options)
}
export function usePartnerRutterAccountReadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >(PartnerRutterAccountReadDocument, options)
}
export type PartnerRutterAccountReadQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountReadQuery
>
export type PartnerRutterAccountReadLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountReadLazyQuery
>
export type PartnerRutterAccountReadQueryResult = Apollo.QueryResult<
  PartnerRutterAccountReadQuery,
  PartnerRutterAccountReadQueryVariables
>
export const PartnerRutterConnectionReadDocument = /*#__PURE__*/ gql`
  query PartnerRutterConnectionRead($platform: RutterPlatform) {
    PartnerRutterConnectionRead(platform: $platform) {
      rutterConnectionID
      createDeposits
    }
  }
`

/**
 * __usePartnerRutterConnectionReadQuery__
 *
 * To run a query within a React component, call `usePartnerRutterConnectionReadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterConnectionReadQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function usePartnerRutterConnectionReadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >(PartnerRutterConnectionReadDocument, options)
}
export function usePartnerRutterConnectionReadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >(PartnerRutterConnectionReadDocument, options)
}
export type PartnerRutterConnectionReadQueryHookResult = ReturnType<
  typeof usePartnerRutterConnectionReadQuery
>
export type PartnerRutterConnectionReadLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterConnectionReadLazyQuery
>
export type PartnerRutterConnectionReadQueryResult = Apollo.QueryResult<
  PartnerRutterConnectionReadQuery,
  PartnerRutterConnectionReadQueryVariables
>
export const PartnerRutterConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterConnectionUpdate($input: ConnectionUpdateInput) {
    PartnerRutterConnectionUpdate(input: $input) {
      status
    }
  }
`
export type PartnerRutterConnectionUpdateMutationFn = Apollo.MutationFunction<
  PartnerRutterConnectionUpdateMutation,
  PartnerRutterConnectionUpdateMutationVariables
>

/**
 * __usePartnerRutterConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerRutterConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterConnectionUpdateMutation, { data, loading, error }] = usePartnerRutterConnectionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterConnectionUpdateMutation,
    PartnerRutterConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterConnectionUpdateMutation,
    PartnerRutterConnectionUpdateMutationVariables
  >(PartnerRutterConnectionUpdateDocument, options)
}
export type PartnerRutterConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerRutterConnectionUpdateMutation
>
export type PartnerRutterConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerRutterConnectionUpdateMutation>
export type PartnerRutterConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterConnectionUpdateMutation,
    PartnerRutterConnectionUpdateMutationVariables
  >
export const PartnerRutterAccountUnsetDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterAccountUnset($input: RutterAccountUnsetInput) {
    PartnerRutterAccountUnset(input: $input)
  }
`
export type PartnerRutterAccountUnsetMutationFn = Apollo.MutationFunction<
  PartnerRutterAccountUnsetMutation,
  PartnerRutterAccountUnsetMutationVariables
>

/**
 * __usePartnerRutterAccountUnsetMutation__
 *
 * To run a mutation, you first call `usePartnerRutterAccountUnsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountUnsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterAccountUnsetMutation, { data, loading, error }] = usePartnerRutterAccountUnsetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountUnsetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterAccountUnsetMutation,
    PartnerRutterAccountUnsetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterAccountUnsetMutation,
    PartnerRutterAccountUnsetMutationVariables
  >(PartnerRutterAccountUnsetDocument, options)
}
export type PartnerRutterAccountUnsetMutationHookResult = ReturnType<
  typeof usePartnerRutterAccountUnsetMutation
>
export type PartnerRutterAccountUnsetMutationResult =
  Apollo.MutationResult<PartnerRutterAccountUnsetMutation>
export type PartnerRutterAccountUnsetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterAccountUnsetMutation,
    PartnerRutterAccountUnsetMutationVariables
  >
export const PartnerRutterAccountUpsertManyDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterAccountUpsertMany(
    $input: RutterAccountUpsertManyInput
  ) {
    PartnerRutterAccountUpsertMany(input: $input)
  }
`
export type PartnerRutterAccountUpsertManyMutationFn = Apollo.MutationFunction<
  PartnerRutterAccountUpsertManyMutation,
  PartnerRutterAccountUpsertManyMutationVariables
>

/**
 * __usePartnerRutterAccountUpsertManyMutation__
 *
 * To run a mutation, you first call `usePartnerRutterAccountUpsertManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountUpsertManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterAccountUpsertManyMutation, { data, loading, error }] = usePartnerRutterAccountUpsertManyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountUpsertManyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterAccountUpsertManyMutation,
    PartnerRutterAccountUpsertManyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterAccountUpsertManyMutation,
    PartnerRutterAccountUpsertManyMutationVariables
  >(PartnerRutterAccountUpsertManyDocument, options)
}
export type PartnerRutterAccountUpsertManyMutationHookResult = ReturnType<
  typeof usePartnerRutterAccountUpsertManyMutation
>
export type PartnerRutterAccountUpsertManyMutationResult =
  Apollo.MutationResult<PartnerRutterAccountUpsertManyMutation>
export type PartnerRutterAccountUpsertManyMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterAccountUpsertManyMutation,
    PartnerRutterAccountUpsertManyMutationVariables
  >
export const PartnerRutterPaymentTermsConnectionDocument = /*#__PURE__*/ gql`
  query PartnerRutterPaymentTermsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: RutterPaymentTermsOrderBy
    $filter: RutterPaymentTermsFilter
  ) {
    PartnerRutterPaymentTermsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerRutterPaymentTermsConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerRutterPaymentTermsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterPaymentTermsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterPaymentTermsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerRutterPaymentTermsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >(PartnerRutterPaymentTermsConnectionDocument, options)
}
export function usePartnerRutterPaymentTermsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >(PartnerRutterPaymentTermsConnectionDocument, options)
}
export type PartnerRutterPaymentTermsConnectionQueryHookResult = ReturnType<
  typeof usePartnerRutterPaymentTermsConnectionQuery
>
export type PartnerRutterPaymentTermsConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterPaymentTermsConnectionLazyQuery
>
export type PartnerRutterPaymentTermsConnectionQueryResult = Apollo.QueryResult<
  PartnerRutterPaymentTermsConnectionQuery,
  PartnerRutterPaymentTermsConnectionQueryVariables
>
export const PartnerRutterSubsidiaryListDocument = /*#__PURE__*/ gql`
  query PartnerRutterSubsidiaryList($platform: RutterPlatform) {
    PartnerRutterSubsidiaryList(platform: $platform) {
      subsidiaries {
        id
        name
      }
    }
  }
`

/**
 * __usePartnerRutterSubsidiaryListQuery__
 *
 * To run a query within a React component, call `usePartnerRutterSubsidiaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterSubsidiaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterSubsidiaryListQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function usePartnerRutterSubsidiaryListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterSubsidiaryListQuery,
    PartnerRutterSubsidiaryListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterSubsidiaryListQuery,
    PartnerRutterSubsidiaryListQueryVariables
  >(PartnerRutterSubsidiaryListDocument, options)
}
export function usePartnerRutterSubsidiaryListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterSubsidiaryListQuery,
    PartnerRutterSubsidiaryListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterSubsidiaryListQuery,
    PartnerRutterSubsidiaryListQueryVariables
  >(PartnerRutterSubsidiaryListDocument, options)
}
export type PartnerRutterSubsidiaryListQueryHookResult = ReturnType<
  typeof usePartnerRutterSubsidiaryListQuery
>
export type PartnerRutterSubsidiaryListLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterSubsidiaryListLazyQuery
>
export type PartnerRutterSubsidiaryListQueryResult = Apollo.QueryResult<
  PartnerRutterSubsidiaryListQuery,
  PartnerRutterSubsidiaryListQueryVariables
>
export const PartnerRutterConnectionFiltersUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterConnectionFiltersUpdate(
    $input: RutterConnectionFiltersUpdateInput
  ) {
    PartnerRutterConnectionFiltersUpdate(input: $input)
  }
`
export type PartnerRutterConnectionFiltersUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerRutterConnectionFiltersUpdateMutation,
    PartnerRutterConnectionFiltersUpdateMutationVariables
  >

/**
 * __usePartnerRutterConnectionFiltersUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerRutterConnectionFiltersUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionFiltersUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterConnectionFiltersUpdateMutation, { data, loading, error }] = usePartnerRutterConnectionFiltersUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterConnectionFiltersUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterConnectionFiltersUpdateMutation,
    PartnerRutterConnectionFiltersUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterConnectionFiltersUpdateMutation,
    PartnerRutterConnectionFiltersUpdateMutationVariables
  >(PartnerRutterConnectionFiltersUpdateDocument, options)
}
export type PartnerRutterConnectionFiltersUpdateMutationHookResult = ReturnType<
  typeof usePartnerRutterConnectionFiltersUpdateMutation
>
export type PartnerRutterConnectionFiltersUpdateMutationResult =
  Apollo.MutationResult<PartnerRutterConnectionFiltersUpdateMutation>
export type PartnerRutterConnectionFiltersUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterConnectionFiltersUpdateMutation,
    PartnerRutterConnectionFiltersUpdateMutationVariables
  >
export const PartnerRutterConnectionCreateDepositsUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterConnectionCreateDepositsUpdate(
    $input: RutterConnectionCreateDepositsUpdateInput
  ) {
    PartnerRutterConnectionCreateDepositsUpdate(input: $input)
  }
`
export type PartnerRutterConnectionCreateDepositsUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerRutterConnectionCreateDepositsUpdateMutation,
    PartnerRutterConnectionCreateDepositsUpdateMutationVariables
  >

/**
 * __usePartnerRutterConnectionCreateDepositsUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerRutterConnectionCreateDepositsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionCreateDepositsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterConnectionCreateDepositsUpdateMutation, { data, loading, error }] = usePartnerRutterConnectionCreateDepositsUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterConnectionCreateDepositsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterConnectionCreateDepositsUpdateMutation,
    PartnerRutterConnectionCreateDepositsUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterConnectionCreateDepositsUpdateMutation,
    PartnerRutterConnectionCreateDepositsUpdateMutationVariables
  >(PartnerRutterConnectionCreateDepositsUpdateDocument, options)
}
export type PartnerRutterConnectionCreateDepositsUpdateMutationHookResult =
  ReturnType<typeof usePartnerRutterConnectionCreateDepositsUpdateMutation>
export type PartnerRutterConnectionCreateDepositsUpdateMutationResult =
  Apollo.MutationResult<PartnerRutterConnectionCreateDepositsUpdateMutation>
export type PartnerRutterConnectionCreateDepositsUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterConnectionCreateDepositsUpdateMutation,
    PartnerRutterConnectionCreateDepositsUpdateMutationVariables
  >
export const PartnerSuperopsConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerSuperopsConnectionCreate(
    $input: SuperopsConnectionCreateInput
  ) {
    PartnerSuperopsConnectionCreate(input: $input)
  }
`
export type PartnerSuperopsConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerSuperopsConnectionCreateMutation,
  PartnerSuperopsConnectionCreateMutationVariables
>

/**
 * __usePartnerSuperopsConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerSuperopsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSuperopsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSuperopsConnectionCreateMutation, { data, loading, error }] = usePartnerSuperopsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSuperopsConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSuperopsConnectionCreateMutation,
    PartnerSuperopsConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSuperopsConnectionCreateMutation,
    PartnerSuperopsConnectionCreateMutationVariables
  >(PartnerSuperopsConnectionCreateDocument, options)
}
export type PartnerSuperopsConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerSuperopsConnectionCreateMutation
>
export type PartnerSuperopsConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerSuperopsConnectionCreateMutation>
export type PartnerSuperopsConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSuperopsConnectionCreateMutation,
    PartnerSuperopsConnectionCreateMutationVariables
  >
export const IntegrationPermissionsDocument = /*#__PURE__*/ gql`
  query IntegrationPermissions($integration: String!) {
    integrationPermissions(integration: $integration) {
      connectionID
      integration
      capabilities {
        capability
        status
        detail
        probedAt
      }
    }
  }
`

/**
 * __useIntegrationPermissionsQuery__
 *
 * To run a query within a React component, call `useIntegrationPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationPermissionsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useIntegrationPermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IntegrationPermissionsQuery,
    IntegrationPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IntegrationPermissionsQuery,
    IntegrationPermissionsQueryVariables
  >(IntegrationPermissionsDocument, options)
}
export function useIntegrationPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IntegrationPermissionsQuery,
    IntegrationPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IntegrationPermissionsQuery,
    IntegrationPermissionsQueryVariables
  >(IntegrationPermissionsDocument, options)
}
export type IntegrationPermissionsQueryHookResult = ReturnType<
  typeof useIntegrationPermissionsQuery
>
export type IntegrationPermissionsLazyQueryHookResult = ReturnType<
  typeof useIntegrationPermissionsLazyQuery
>
export type IntegrationPermissionsQueryResult = Apollo.QueryResult<
  IntegrationPermissionsQuery,
  IntegrationPermissionsQueryVariables
>
export const RefreshIntegrationPermissionsDocument = /*#__PURE__*/ gql`
  mutation RefreshIntegrationPermissions(
    $integration: String!
    $force: Boolean
  ) {
    refreshIntegrationPermissions(integration: $integration, force: $force) {
      connectionID
      status
      capabilities {
        capability
        status
        detail
        probedAt
      }
    }
  }
`
export type RefreshIntegrationPermissionsMutationFn = Apollo.MutationFunction<
  RefreshIntegrationPermissionsMutation,
  RefreshIntegrationPermissionsMutationVariables
>

/**
 * __useRefreshIntegrationPermissionsMutation__
 *
 * To run a mutation, you first call `useRefreshIntegrationPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshIntegrationPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshIntegrationPermissionsMutation, { data, loading, error }] = useRefreshIntegrationPermissionsMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useRefreshIntegrationPermissionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshIntegrationPermissionsMutation,
    RefreshIntegrationPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RefreshIntegrationPermissionsMutation,
    RefreshIntegrationPermissionsMutationVariables
  >(RefreshIntegrationPermissionsDocument, options)
}
export type RefreshIntegrationPermissionsMutationHookResult = ReturnType<
  typeof useRefreshIntegrationPermissionsMutation
>
export type RefreshIntegrationPermissionsMutationResult =
  Apollo.MutationResult<RefreshIntegrationPermissionsMutation>
export type RefreshIntegrationPermissionsMutationOptions =
  Apollo.BaseMutationOptions<
    RefreshIntegrationPermissionsMutation,
    RefreshIntegrationPermissionsMutationVariables
  >
export const PartnerGetInvoicesSummaryDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoicesSummary {
    PartnerGetInvoicesSummary {
      count0To30
      count31To60
      count61To90
      count90Plus
      dueBeforeEndOfMonth
    }
  }
`

/**
 * __usePartnerGetInvoicesSummaryQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoicesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoicesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoicesSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetInvoicesSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetInvoicesSummaryQuery,
    PartnerGetInvoicesSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoicesSummaryQuery,
    PartnerGetInvoicesSummaryQueryVariables
  >(PartnerGetInvoicesSummaryDocument, options)
}
export function usePartnerGetInvoicesSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoicesSummaryQuery,
    PartnerGetInvoicesSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoicesSummaryQuery,
    PartnerGetInvoicesSummaryQueryVariables
  >(PartnerGetInvoicesSummaryDocument, options)
}
export type PartnerGetInvoicesSummaryQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicesSummaryQuery
>
export type PartnerGetInvoicesSummaryLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicesSummaryLazyQuery
>
export type PartnerGetInvoicesSummaryQueryResult = Apollo.QueryResult<
  PartnerGetInvoicesSummaryQuery,
  PartnerGetInvoicesSummaryQueryVariables
>
export const PartnerGetInvoiceLedgerMovementsDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoiceLedgerMovements($invoiceID: String!) {
    PartnerGetInvoiceLedgerMovements(invoiceID: $invoiceID) {
      ledgerBalance
      movements {
        movementType
        movements
        balance
      }
    }
  }
`

/**
 * __usePartnerGetInvoiceLedgerMovementsQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoiceLedgerMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoiceLedgerMovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoiceLedgerMovementsQuery({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerGetInvoiceLedgerMovementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >(PartnerGetInvoiceLedgerMovementsDocument, options)
}
export function usePartnerGetInvoiceLedgerMovementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >(PartnerGetInvoiceLedgerMovementsDocument, options)
}
export type PartnerGetInvoiceLedgerMovementsQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceLedgerMovementsQuery
>
export type PartnerGetInvoiceLedgerMovementsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceLedgerMovementsLazyQuery
>
export type PartnerGetInvoiceLedgerMovementsQueryResult = Apollo.QueryResult<
  PartnerGetInvoiceLedgerMovementsQuery,
  PartnerGetInvoiceLedgerMovementsQueryVariables
>
export const PartnerFindInvoiceDocument = /*#__PURE__*/ gql`
  query PartnerFindInvoice($id: String!) {
    FindInvoice(id: $id) {
      ...PartnerInvoice
    }
  }
  ${PartnerInvoiceFragmentDoc}
`

/**
 * __usePartnerFindInvoiceQuery__
 *
 * To run a query within a React component, call `usePartnerFindInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerFindInvoiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >(PartnerFindInvoiceDocument, options)
}
export function usePartnerFindInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >(PartnerFindInvoiceDocument, options)
}
export type PartnerFindInvoiceQueryHookResult = ReturnType<
  typeof usePartnerFindInvoiceQuery
>
export type PartnerFindInvoiceLazyQueryHookResult = ReturnType<
  typeof usePartnerFindInvoiceLazyQuery
>
export type PartnerFindInvoiceQueryResult = Apollo.QueryResult<
  PartnerFindInvoiceQuery,
  PartnerFindInvoiceQueryVariables
>
export const PartnerGetInvoicePdfLinkDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoicePdfLink($invoiceID: String!) {
    PartnerGetInvoicePdfLink(invoiceID: $invoiceID) {
      url
      expiresAt
      status
    }
  }
`

/**
 * __usePartnerGetInvoicePdfLinkQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoicePdfLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoicePdfLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoicePdfLinkQuery({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerGetInvoicePdfLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >(PartnerGetInvoicePdfLinkDocument, options)
}
export function usePartnerGetInvoicePdfLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >(PartnerGetInvoicePdfLinkDocument, options)
}
export type PartnerGetInvoicePdfLinkQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePdfLinkQuery
>
export type PartnerGetInvoicePdfLinkLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePdfLinkLazyQuery
>
export type PartnerGetInvoicePdfLinkQueryResult = Apollo.QueryResult<
  PartnerGetInvoicePdfLinkQuery,
  PartnerGetInvoicePdfLinkQueryVariables
>
export const PartnerInvoiceListTotalsDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceListTotals($filters: InvoiceFilter) {
    PartnerInvoiceListTotals(filters: $filters) {
      count
      amount
      outstandingAmount
    }
  }
`

/**
 * __usePartnerInvoiceListTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceListTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceListTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceListTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerInvoiceListTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >(PartnerInvoiceListTotalsDocument, options)
}
export function usePartnerInvoiceListTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >(PartnerInvoiceListTotalsDocument, options)
}
export type PartnerInvoiceListTotalsQueryHookResult = ReturnType<
  typeof usePartnerInvoiceListTotalsQuery
>
export type PartnerInvoiceListTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceListTotalsLazyQuery
>
export type PartnerInvoiceListTotalsQueryResult = Apollo.QueryResult<
  PartnerInvoiceListTotalsQuery,
  PartnerInvoiceListTotalsQueryVariables
>
export const PartnerInvoiceSearchDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceSearch($invoiceNumber: String) {
    PartnerInvoiceConnection(
      first: 5
      filters: { invoiceNumber: $invoiceNumber }
    ) {
      edges {
        cursor
        node {
          ...PartnerInvoiceSearch
        }
      }
    }
  }
  ${PartnerInvoiceSearchFragmentDoc}
`

/**
 * __usePartnerInvoiceSearchQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceSearchQuery({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function usePartnerInvoiceSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >(PartnerInvoiceSearchDocument, options)
}
export function usePartnerInvoiceSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >(PartnerInvoiceSearchDocument, options)
}
export type PartnerInvoiceSearchQueryHookResult = ReturnType<
  typeof usePartnerInvoiceSearchQuery
>
export type PartnerInvoiceSearchLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceSearchLazyQuery
>
export type PartnerInvoiceSearchQueryResult = Apollo.QueryResult<
  PartnerInvoiceSearchQuery,
  PartnerInvoiceSearchQueryVariables
>
export const PartnerInvoiceConnectionDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: InvoiceFilter
    $orderBy: InvoiceOrderBy
  ) {
    PartnerInvoiceConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerInvoiceListing
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`

/**
 * __usePartnerInvoiceConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerInvoiceConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >(PartnerInvoiceConnectionDocument, options)
}
export function usePartnerInvoiceConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >(PartnerInvoiceConnectionDocument, options)
}
export type PartnerInvoiceConnectionQueryHookResult = ReturnType<
  typeof usePartnerInvoiceConnectionQuery
>
export type PartnerInvoiceConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceConnectionLazyQuery
>
export type PartnerInvoiceConnectionQueryResult = Apollo.QueryResult<
  PartnerInvoiceConnectionQuery,
  PartnerInvoiceConnectionQueryVariables
>
export const PartnerArInvoiceListDocument = /*#__PURE__*/ gql`
  query PartnerArInvoiceList(
    $page: Int!
    $pageSize: Int!
    $filters: ArInvoiceFilter
    $order: ArInvoiceOrder
  ) {
    PartnerArInvoiceList(
      page: $page
      pageSize: $pageSize
      filters: $filters
      order: $order
    ) {
      invoices {
        id
        partnerID
        invoiceNumber
        customerID
        customerName
        createdByCustomer
        amount
        outstandingAmount
        dueDate
        createdAt
        status
        lastRemindedAt
        isRecurring
        isExternal
        recurringFrequency
        nextRecurringDate
        autopaidAt
        bnplStatus
        bnplPartnerConfirmed
        bnplID
      }
      pagination {
        page
        pageSize
        totalPages
        totalItems
      }
      summary {
        totalAmount
        totalOutstandingAmount
      }
    }
  }
`

/**
 * __usePartnerArInvoiceListQuery__
 *
 * To run a query within a React component, call `usePartnerArInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerArInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerArInvoiceListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerArInvoiceListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerArInvoiceListQuery,
    PartnerArInvoiceListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerArInvoiceListQuery,
    PartnerArInvoiceListQueryVariables
  >(PartnerArInvoiceListDocument, options)
}
export function usePartnerArInvoiceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerArInvoiceListQuery,
    PartnerArInvoiceListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerArInvoiceListQuery,
    PartnerArInvoiceListQueryVariables
  >(PartnerArInvoiceListDocument, options)
}
export type PartnerArInvoiceListQueryHookResult = ReturnType<
  typeof usePartnerArInvoiceListQuery
>
export type PartnerArInvoiceListLazyQueryHookResult = ReturnType<
  typeof usePartnerArInvoiceListLazyQuery
>
export type PartnerArInvoiceListQueryResult = Apollo.QueryResult<
  PartnerArInvoiceListQuery,
  PartnerArInvoiceListQueryVariables
>
export const PartnerGetInvoicePreferencesDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoicePreferences {
    PartnerGetInvoicePreferences {
      invoiceNumberField
    }
  }
`

/**
 * __usePartnerGetInvoicePreferencesQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoicePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoicePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoicePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetInvoicePreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >(PartnerGetInvoicePreferencesDocument, options)
}
export function usePartnerGetInvoicePreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >(PartnerGetInvoicePreferencesDocument, options)
}
export type PartnerGetInvoicePreferencesQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePreferencesQuery
>
export type PartnerGetInvoicePreferencesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePreferencesLazyQuery
>
export type PartnerGetInvoicePreferencesQueryResult = Apollo.QueryResult<
  PartnerGetInvoicePreferencesQuery,
  PartnerGetInvoicePreferencesQueryVariables
>
export const PartnerInvoiceArchiveDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceArchive($archiveInvoiceId: ID!) {
    PartnerInvoiceArchive(id: $archiveInvoiceId) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoiceArchiveMutationFn = Apollo.MutationFunction<
  PartnerInvoiceArchiveMutation,
  PartnerInvoiceArchiveMutationVariables
>

/**
 * __usePartnerInvoiceArchiveMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceArchiveMutation, { data, loading, error }] = usePartnerInvoiceArchiveMutation({
 *   variables: {
 *      archiveInvoiceId: // value for 'archiveInvoiceId'
 *   },
 * });
 */
export function usePartnerInvoiceArchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceArchiveMutation,
    PartnerInvoiceArchiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceArchiveMutation,
    PartnerInvoiceArchiveMutationVariables
  >(PartnerInvoiceArchiveDocument, options)
}
export type PartnerInvoiceArchiveMutationHookResult = ReturnType<
  typeof usePartnerInvoiceArchiveMutation
>
export type PartnerInvoiceArchiveMutationResult =
  Apollo.MutationResult<PartnerInvoiceArchiveMutation>
export type PartnerInvoiceArchiveMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceArchiveMutation,
  PartnerInvoiceArchiveMutationVariables
>
export const PartnerInvoiceUnarchiveDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceUnarchive($archivedInvoiceId: ID!) {
    PartnerInvoiceUnarchive(id: $archivedInvoiceId) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoiceUnarchiveMutationFn = Apollo.MutationFunction<
  PartnerInvoiceUnarchiveMutation,
  PartnerInvoiceUnarchiveMutationVariables
>

/**
 * __usePartnerInvoiceUnarchiveMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceUnarchiveMutation, { data, loading, error }] = usePartnerInvoiceUnarchiveMutation({
 *   variables: {
 *      archivedInvoiceId: // value for 'archivedInvoiceId'
 *   },
 * });
 */
export function usePartnerInvoiceUnarchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceUnarchiveMutation,
    PartnerInvoiceUnarchiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceUnarchiveMutation,
    PartnerInvoiceUnarchiveMutationVariables
  >(PartnerInvoiceUnarchiveDocument, options)
}
export type PartnerInvoiceUnarchiveMutationHookResult = ReturnType<
  typeof usePartnerInvoiceUnarchiveMutation
>
export type PartnerInvoiceUnarchiveMutationResult =
  Apollo.MutationResult<PartnerInvoiceUnarchiveMutation>
export type PartnerInvoiceUnarchiveMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceUnarchiveMutation,
  PartnerInvoiceUnarchiveMutationVariables
>
export const PartnerInvoiceCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceCreate($input: InvoiceInput) {
    PartnerInvoiceCreate(input: $input) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoiceCreateMutationFn = Apollo.MutationFunction<
  PartnerInvoiceCreateMutation,
  PartnerInvoiceCreateMutationVariables
>

/**
 * __usePartnerInvoiceCreateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceCreateMutation, { data, loading, error }] = usePartnerInvoiceCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerInvoiceCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceCreateMutation,
    PartnerInvoiceCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceCreateMutation,
    PartnerInvoiceCreateMutationVariables
  >(PartnerInvoiceCreateDocument, options)
}
export type PartnerInvoiceCreateMutationHookResult = ReturnType<
  typeof usePartnerInvoiceCreateMutation
>
export type PartnerInvoiceCreateMutationResult =
  Apollo.MutationResult<PartnerInvoiceCreateMutation>
export type PartnerInvoiceCreateMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceCreateMutation,
  PartnerInvoiceCreateMutationVariables
>
export const PartnerInvoicePaidUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoicePaidUpdate($input: PartnerInvoicePaidUpdateInput) {
    PartnerInvoicePaidUpdate(input: $input) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoicePaidUpdateMutationFn = Apollo.MutationFunction<
  PartnerInvoicePaidUpdateMutation,
  PartnerInvoicePaidUpdateMutationVariables
>

/**
 * __usePartnerInvoicePaidUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoicePaidUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoicePaidUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoicePaidUpdateMutation, { data, loading, error }] = usePartnerInvoicePaidUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerInvoicePaidUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoicePaidUpdateMutation,
    PartnerInvoicePaidUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoicePaidUpdateMutation,
    PartnerInvoicePaidUpdateMutationVariables
  >(PartnerInvoicePaidUpdateDocument, options)
}
export type PartnerInvoicePaidUpdateMutationHookResult = ReturnType<
  typeof usePartnerInvoicePaidUpdateMutation
>
export type PartnerInvoicePaidUpdateMutationResult =
  Apollo.MutationResult<PartnerInvoicePaidUpdateMutation>
export type PartnerInvoicePaidUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerInvoicePaidUpdateMutation,
    PartnerInvoicePaidUpdateMutationVariables
  >
export const PartnerInvoiceRemindDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceRemind($invoiceID: String!) {
    PartnerInvoiceRemind(invoiceID: $invoiceID)
  }
`
export type PartnerInvoiceRemindMutationFn = Apollo.MutationFunction<
  PartnerInvoiceRemindMutation,
  PartnerInvoiceRemindMutationVariables
>

/**
 * __usePartnerInvoiceRemindMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceRemindMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceRemindMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceRemindMutation, { data, loading, error }] = usePartnerInvoiceRemindMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerInvoiceRemindMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceRemindMutation,
    PartnerInvoiceRemindMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceRemindMutation,
    PartnerInvoiceRemindMutationVariables
  >(PartnerInvoiceRemindDocument, options)
}
export type PartnerInvoiceRemindMutationHookResult = ReturnType<
  typeof usePartnerInvoiceRemindMutation
>
export type PartnerInvoiceRemindMutationResult =
  Apollo.MutationResult<PartnerInvoiceRemindMutation>
export type PartnerInvoiceRemindMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceRemindMutation,
  PartnerInvoiceRemindMutationVariables
>
export const PartnerPayInvoiceDocument = /*#__PURE__*/ gql`
  mutation PartnerPayInvoice(
    $invoiceID: String!
    $customerID: String!
    $paymentDate: String
    $paymentMethod: PayInvoicePaymentMethodInput!
    $amount: Float!
    $idempotencyKey: String
  ) {
    PartnerPayInvoice(
      invoiceID: $invoiceID
      customerID: $customerID
      paymentDate: $paymentDate
      paymentMethod: $paymentMethod
      amount: $amount
      idempotencyKey: $idempotencyKey
    )
  }
`
export type PartnerPayInvoiceMutationFn = Apollo.MutationFunction<
  PartnerPayInvoiceMutation,
  PartnerPayInvoiceMutationVariables
>

/**
 * __usePartnerPayInvoiceMutation__
 *
 * To run a mutation, you first call `usePartnerPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerPayInvoiceMutation, { data, loading, error }] = usePartnerPayInvoiceMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *      customerID: // value for 'customerID'
 *      paymentDate: // value for 'paymentDate'
 *      paymentMethod: // value for 'paymentMethod'
 *      amount: // value for 'amount'
 *      idempotencyKey: // value for 'idempotencyKey'
 *   },
 * });
 */
export function usePartnerPayInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerPayInvoiceMutation,
    PartnerPayInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerPayInvoiceMutation,
    PartnerPayInvoiceMutationVariables
  >(PartnerPayInvoiceDocument, options)
}
export type PartnerPayInvoiceMutationHookResult = ReturnType<
  typeof usePartnerPayInvoiceMutation
>
export type PartnerPayInvoiceMutationResult =
  Apollo.MutationResult<PartnerPayInvoiceMutation>
export type PartnerPayInvoiceMutationOptions = Apollo.BaseMutationOptions<
  PartnerPayInvoiceMutation,
  PartnerPayInvoiceMutationVariables
>
export const PartnerUpsertInvoicePreferencesDocument = /*#__PURE__*/ gql`
  mutation PartnerUpsertInvoicePreferences(
    $input: UpsertInvoicePreferencesInput
  ) {
    PartnerUpsertInvoicePreferences(input: $input)
  }
`
export type PartnerUpsertInvoicePreferencesMutationFn = Apollo.MutationFunction<
  PartnerUpsertInvoicePreferencesMutation,
  PartnerUpsertInvoicePreferencesMutationVariables
>

/**
 * __usePartnerUpsertInvoicePreferencesMutation__
 *
 * To run a mutation, you first call `usePartnerUpsertInvoicePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpsertInvoicePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpsertInvoicePreferencesMutation, { data, loading, error }] = usePartnerUpsertInvoicePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpsertInvoicePreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpsertInvoicePreferencesMutation,
    PartnerUpsertInvoicePreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpsertInvoicePreferencesMutation,
    PartnerUpsertInvoicePreferencesMutationVariables
  >(PartnerUpsertInvoicePreferencesDocument, options)
}
export type PartnerUpsertInvoicePreferencesMutationHookResult = ReturnType<
  typeof usePartnerUpsertInvoicePreferencesMutation
>
export type PartnerUpsertInvoicePreferencesMutationResult =
  Apollo.MutationResult<PartnerUpsertInvoicePreferencesMutation>
export type PartnerUpsertInvoicePreferencesMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpsertInvoicePreferencesMutation,
    PartnerUpsertInvoicePreferencesMutationVariables
  >
export const PartnerUpdateReminderDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateReminder($input: UpdateInvoiceReminderInput) {
    PartnerUpdateReminder(input: $input)
  }
`
export type PartnerUpdateReminderMutationFn = Apollo.MutationFunction<
  PartnerUpdateReminderMutation,
  PartnerUpdateReminderMutationVariables
>

/**
 * __usePartnerUpdateReminderMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateReminderMutation, { data, loading, error }] = usePartnerUpdateReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateReminderMutation,
    PartnerUpdateReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateReminderMutation,
    PartnerUpdateReminderMutationVariables
  >(PartnerUpdateReminderDocument, options)
}
export type PartnerUpdateReminderMutationHookResult = ReturnType<
  typeof usePartnerUpdateReminderMutation
>
export type PartnerUpdateReminderMutationResult =
  Apollo.MutationResult<PartnerUpdateReminderMutation>
export type PartnerUpdateReminderMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateReminderMutation,
  PartnerUpdateReminderMutationVariables
>
export const PartnerListInvoiceRemindersDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceReminders {
    PartnerListInvoiceReminders {
      ...PartnerInvoiceReminder
    }
  }
  ${PartnerInvoiceReminderFragmentDoc}
`

/**
 * __usePartnerListInvoiceRemindersQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceRemindersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceRemindersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >(PartnerListInvoiceRemindersDocument, options)
}
export function usePartnerListInvoiceRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >(PartnerListInvoiceRemindersDocument, options)
}
export type PartnerListInvoiceRemindersQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceRemindersQuery
>
export type PartnerListInvoiceRemindersLazyQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceRemindersLazyQuery
>
export type PartnerListInvoiceRemindersQueryResult = Apollo.QueryResult<
  PartnerListInvoiceRemindersQuery,
  PartnerListInvoiceRemindersQueryVariables
>
export const PartnerFindReminderDocument = /*#__PURE__*/ gql`
  query PartnerFindReminder($id: ID!) {
    PartnerFindReminder(id: $id) {
      ...PartnerInvoiceReminder
    }
  }
  ${PartnerInvoiceReminderFragmentDoc}
`

/**
 * __usePartnerFindReminderQuery__
 *
 * To run a query within a React component, call `usePartnerFindReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindReminderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerFindReminderQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindReminderQuery,
    PartnerFindReminderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindReminderQuery,
    PartnerFindReminderQueryVariables
  >(PartnerFindReminderDocument, options)
}
export function usePartnerFindReminderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindReminderQuery,
    PartnerFindReminderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindReminderQuery,
    PartnerFindReminderQueryVariables
  >(PartnerFindReminderDocument, options)
}
export type PartnerFindReminderQueryHookResult = ReturnType<
  typeof usePartnerFindReminderQuery
>
export type PartnerFindReminderLazyQueryHookResult = ReturnType<
  typeof usePartnerFindReminderLazyQuery
>
export type PartnerFindReminderQueryResult = Apollo.QueryResult<
  PartnerFindReminderQuery,
  PartnerFindReminderQueryVariables
>
export const PartnerListInvoiceReminderExcludedCustomersDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceReminderExcludedCustomers {
    PartnerListInvoiceReminderExcludedCustomers {
      ...PartnerInvoiceReminderExcludedCustomer
    }
  }
  ${PartnerInvoiceReminderExcludedCustomerFragmentDoc}
`

/**
 * __usePartnerListInvoiceReminderExcludedCustomersQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceReminderExcludedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceReminderExcludedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceReminderExcludedCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceReminderExcludedCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >(PartnerListInvoiceReminderExcludedCustomersDocument, options)
}
export function usePartnerListInvoiceReminderExcludedCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >(PartnerListInvoiceReminderExcludedCustomersDocument, options)
}
export type PartnerListInvoiceReminderExcludedCustomersQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceReminderExcludedCustomersQuery>
export type PartnerListInvoiceReminderExcludedCustomersLazyQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceReminderExcludedCustomersLazyQuery>
export type PartnerListInvoiceReminderExcludedCustomersQueryResult =
  Apollo.QueryResult<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >
export const PartnerCreateInvoiceReminderDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceReminder(
    $daysOffset: Int!
    $type: InvoiceReminderType!
    $templateID: ID
    $sentHour: Int
    $runsHourly: Boolean
    $timezone: Timezone
    $tagIDs: [ID!]
    $customerIDs: [ID!]
    $cc: [String!]
    $bcc: [String!]
  ) {
    PartnerCreateInvoiceReminder(
      daysOffset: $daysOffset
      type: $type
      templateID: $templateID
      sentHour: $sentHour
      runsHourly: $runsHourly
      timezone: $timezone
      tagIDs: $tagIDs
      customerIDs: $customerIDs
      cc: $cc
      bcc: $bcc
    ) {
      ...PartnerInvoiceReminder
    }
  }
  ${PartnerInvoiceReminderFragmentDoc}
`
export type PartnerCreateInvoiceReminderMutationFn = Apollo.MutationFunction<
  PartnerCreateInvoiceReminderMutation,
  PartnerCreateInvoiceReminderMutationVariables
>

/**
 * __usePartnerCreateInvoiceReminderMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceReminderMutation, { data, loading, error }] = usePartnerCreateInvoiceReminderMutation({
 *   variables: {
 *      daysOffset: // value for 'daysOffset'
 *      type: // value for 'type'
 *      templateID: // value for 'templateID'
 *      sentHour: // value for 'sentHour'
 *      runsHourly: // value for 'runsHourly'
 *      timezone: // value for 'timezone'
 *      tagIDs: // value for 'tagIDs'
 *      customerIDs: // value for 'customerIDs'
 *      cc: // value for 'cc'
 *      bcc: // value for 'bcc'
 *   },
 * });
 */
export function usePartnerCreateInvoiceReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceReminderMutation,
    PartnerCreateInvoiceReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceReminderMutation,
    PartnerCreateInvoiceReminderMutationVariables
  >(PartnerCreateInvoiceReminderDocument, options)
}
export type PartnerCreateInvoiceReminderMutationHookResult = ReturnType<
  typeof usePartnerCreateInvoiceReminderMutation
>
export type PartnerCreateInvoiceReminderMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceReminderMutation>
export type PartnerCreateInvoiceReminderMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceReminderMutation,
    PartnerCreateInvoiceReminderMutationVariables
  >
export const PartnerDeleteInvoiceReminderDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceReminder($id: ID!) {
    PartnerDeleteInvoiceReminder(id: $id)
  }
`
export type PartnerDeleteInvoiceReminderMutationFn = Apollo.MutationFunction<
  PartnerDeleteInvoiceReminderMutation,
  PartnerDeleteInvoiceReminderMutationVariables
>

/**
 * __usePartnerDeleteInvoiceReminderMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceReminderMutation, { data, loading, error }] = usePartnerDeleteInvoiceReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceReminderMutation,
    PartnerDeleteInvoiceReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceReminderMutation,
    PartnerDeleteInvoiceReminderMutationVariables
  >(PartnerDeleteInvoiceReminderDocument, options)
}
export type PartnerDeleteInvoiceReminderMutationHookResult = ReturnType<
  typeof usePartnerDeleteInvoiceReminderMutation
>
export type PartnerDeleteInvoiceReminderMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceReminderMutation>
export type PartnerDeleteInvoiceReminderMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceReminderMutation,
    PartnerDeleteInvoiceReminderMutationVariables
  >
export const PartnerCreateInvoiceReminderExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceReminderExcludedCustomer($customerID: ID!) {
    PartnerCreateInvoiceReminderExcludedCustomer(customerID: $customerID) {
      ...PartnerInvoiceReminderExcludedCustomer
    }
  }
  ${PartnerInvoiceReminderExcludedCustomerFragmentDoc}
`
export type PartnerCreateInvoiceReminderExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >

/**
 * __usePartnerCreateInvoiceReminderExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceReminderExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceReminderExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceReminderExcludedCustomerMutation, { data, loading, error }] = usePartnerCreateInvoiceReminderExcludedCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerCreateInvoiceReminderExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >(PartnerCreateInvoiceReminderExcludedCustomerDocument, options)
}
export type PartnerCreateInvoiceReminderExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerCreateInvoiceReminderExcludedCustomerMutation>
export type PartnerCreateInvoiceReminderExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceReminderExcludedCustomerMutation>
export type PartnerCreateInvoiceReminderExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >
export const PartnerUpdateInvoiceReminderExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInvoiceReminderExcludedCustomer($customerIDs: [ID!]) {
    PartnerUpdateInvoiceReminderExcludedCustomer(customerIDs: $customerIDs) {
      ...PartnerInvoiceReminderExcludedCustomer
    }
  }
  ${PartnerInvoiceReminderExcludedCustomerFragmentDoc}
`
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >

/**
 * __usePartnerUpdateInvoiceReminderExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInvoiceReminderExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInvoiceReminderExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInvoiceReminderExcludedCustomerMutation, { data, loading, error }] = usePartnerUpdateInvoiceReminderExcludedCustomerMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerUpdateInvoiceReminderExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >(PartnerUpdateInvoiceReminderExcludedCustomerDocument, options)
}
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerUpdateInvoiceReminderExcludedCustomerMutation>
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerUpdateInvoiceReminderExcludedCustomerMutation>
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >
export const PartnerDeleteInvoiceReminderExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceReminderExcludedCustomer($id: ID!) {
    PartnerDeleteInvoiceReminderExcludedCustomer(id: $id)
  }
`
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >

/**
 * __usePartnerDeleteInvoiceReminderExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceReminderExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceReminderExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceReminderExcludedCustomerMutation, { data, loading, error }] = usePartnerDeleteInvoiceReminderExcludedCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceReminderExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >(PartnerDeleteInvoiceReminderExcludedCustomerDocument, options)
}
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerDeleteInvoiceReminderExcludedCustomerMutation>
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceReminderExcludedCustomerMutation>
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >
export const PartnerSendInvoiceReminderPreviewDocument = /*#__PURE__*/ gql`
  mutation PartnerSendInvoiceReminderPreview(
    $input: InvoiceReminderPreviewInput
  ) {
    PartnerSendInvoiceReminderPreview(input: $input)
  }
`
export type PartnerSendInvoiceReminderPreviewMutationFn =
  Apollo.MutationFunction<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >

/**
 * __usePartnerSendInvoiceReminderPreviewMutation__
 *
 * To run a mutation, you first call `usePartnerSendInvoiceReminderPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendInvoiceReminderPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendInvoiceReminderPreviewMutation, { data, loading, error }] = usePartnerSendInvoiceReminderPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendInvoiceReminderPreviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >(PartnerSendInvoiceReminderPreviewDocument, options)
}
export type PartnerSendInvoiceReminderPreviewMutationHookResult = ReturnType<
  typeof usePartnerSendInvoiceReminderPreviewMutation
>
export type PartnerSendInvoiceReminderPreviewMutationResult =
  Apollo.MutationResult<PartnerSendInvoiceReminderPreviewMutation>
export type PartnerSendInvoiceReminderPreviewMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >
export const PartnerToggleReminderEnabledDocument = /*#__PURE__*/ gql`
  mutation PartnerToggleReminderEnabled($id: ID!, $enabled: Boolean!) {
    PartnerToggleReminderEnabled(reminderID: $id, enabled: $enabled)
  }
`
export type PartnerToggleReminderEnabledMutationFn = Apollo.MutationFunction<
  PartnerToggleReminderEnabledMutation,
  PartnerToggleReminderEnabledMutationVariables
>

/**
 * __usePartnerToggleReminderEnabledMutation__
 *
 * To run a mutation, you first call `usePartnerToggleReminderEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerToggleReminderEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerToggleReminderEnabledMutation, { data, loading, error }] = usePartnerToggleReminderEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function usePartnerToggleReminderEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerToggleReminderEnabledMutation,
    PartnerToggleReminderEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerToggleReminderEnabledMutation,
    PartnerToggleReminderEnabledMutationVariables
  >(PartnerToggleReminderEnabledDocument, options)
}
export type PartnerToggleReminderEnabledMutationHookResult = ReturnType<
  typeof usePartnerToggleReminderEnabledMutation
>
export type PartnerToggleReminderEnabledMutationResult =
  Apollo.MutationResult<PartnerToggleReminderEnabledMutation>
export type PartnerToggleReminderEnabledMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerToggleReminderEnabledMutation,
    PartnerToggleReminderEnabledMutationVariables
  >
export const PartnerBulkInvoiceRemindDocument = /*#__PURE__*/ gql`
  mutation PartnerBulkInvoiceRemind($invoiceIDs: [String!]!) {
    PartnerBulkInvoiceRemind(invoiceIDs: $invoiceIDs)
  }
`
export type PartnerBulkInvoiceRemindMutationFn = Apollo.MutationFunction<
  PartnerBulkInvoiceRemindMutation,
  PartnerBulkInvoiceRemindMutationVariables
>

/**
 * __usePartnerBulkInvoiceRemindMutation__
 *
 * To run a mutation, you first call `usePartnerBulkInvoiceRemindMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBulkInvoiceRemindMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBulkInvoiceRemindMutation, { data, loading, error }] = usePartnerBulkInvoiceRemindMutation({
 *   variables: {
 *      invoiceIDs: // value for 'invoiceIDs'
 *   },
 * });
 */
export function usePartnerBulkInvoiceRemindMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBulkInvoiceRemindMutation,
    PartnerBulkInvoiceRemindMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBulkInvoiceRemindMutation,
    PartnerBulkInvoiceRemindMutationVariables
  >(PartnerBulkInvoiceRemindDocument, options)
}
export type PartnerBulkInvoiceRemindMutationHookResult = ReturnType<
  typeof usePartnerBulkInvoiceRemindMutation
>
export type PartnerBulkInvoiceRemindMutationResult =
  Apollo.MutationResult<PartnerBulkInvoiceRemindMutation>
export type PartnerBulkInvoiceRemindMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBulkInvoiceRemindMutation,
    PartnerBulkInvoiceRemindMutationVariables
  >
export const PartnerUpdateSummaryDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateSummary($input: UpdateInvoiceSummaryInput) {
    PartnerUpdateSummary(input: $input)
  }
`
export type PartnerUpdateSummaryMutationFn = Apollo.MutationFunction<
  PartnerUpdateSummaryMutation,
  PartnerUpdateSummaryMutationVariables
>

/**
 * __usePartnerUpdateSummaryMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateSummaryMutation, { data, loading, error }] = usePartnerUpdateSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateSummaryMutation,
    PartnerUpdateSummaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateSummaryMutation,
    PartnerUpdateSummaryMutationVariables
  >(PartnerUpdateSummaryDocument, options)
}
export type PartnerUpdateSummaryMutationHookResult = ReturnType<
  typeof usePartnerUpdateSummaryMutation
>
export type PartnerUpdateSummaryMutationResult =
  Apollo.MutationResult<PartnerUpdateSummaryMutation>
export type PartnerUpdateSummaryMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateSummaryMutation,
  PartnerUpdateSummaryMutationVariables
>
export const PartnerListInvoiceSummariesDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceSummaries {
    PartnerListInvoiceSummaries {
      ...PartnerInvoiceSummary
    }
  }
  ${PartnerInvoiceSummaryFragmentDoc}
`

/**
 * __usePartnerListInvoiceSummariesQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceSummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceSummariesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >(PartnerListInvoiceSummariesDocument, options)
}
export function usePartnerListInvoiceSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >(PartnerListInvoiceSummariesDocument, options)
}
export type PartnerListInvoiceSummariesQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceSummariesQuery
>
export type PartnerListInvoiceSummariesLazyQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceSummariesLazyQuery
>
export type PartnerListInvoiceSummariesQueryResult = Apollo.QueryResult<
  PartnerListInvoiceSummariesQuery,
  PartnerListInvoiceSummariesQueryVariables
>
export const PartnerFindSummaryDocument = /*#__PURE__*/ gql`
  query PartnerFindSummary($id: ID!) {
    PartnerFindSummary(id: $id) {
      ...PartnerInvoiceSummary
    }
  }
  ${PartnerInvoiceSummaryFragmentDoc}
`

/**
 * __usePartnerFindSummaryQuery__
 *
 * To run a query within a React component, call `usePartnerFindSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerFindSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindSummaryQuery,
    PartnerFindSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindSummaryQuery,
    PartnerFindSummaryQueryVariables
  >(PartnerFindSummaryDocument, options)
}
export function usePartnerFindSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindSummaryQuery,
    PartnerFindSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindSummaryQuery,
    PartnerFindSummaryQueryVariables
  >(PartnerFindSummaryDocument, options)
}
export type PartnerFindSummaryQueryHookResult = ReturnType<
  typeof usePartnerFindSummaryQuery
>
export type PartnerFindSummaryLazyQueryHookResult = ReturnType<
  typeof usePartnerFindSummaryLazyQuery
>
export type PartnerFindSummaryQueryResult = Apollo.QueryResult<
  PartnerFindSummaryQuery,
  PartnerFindSummaryQueryVariables
>
export const PartnerListInvoiceSummaryExcludedCustomersDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceSummaryExcludedCustomers {
    PartnerListInvoiceSummaryExcludedCustomers {
      ...PartnerInvoiceSummaryExcludedCustomer
    }
  }
  ${PartnerInvoiceSummaryExcludedCustomerFragmentDoc}
`

/**
 * __usePartnerListInvoiceSummaryExcludedCustomersQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceSummaryExcludedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceSummaryExcludedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceSummaryExcludedCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceSummaryExcludedCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >(PartnerListInvoiceSummaryExcludedCustomersDocument, options)
}
export function usePartnerListInvoiceSummaryExcludedCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >(PartnerListInvoiceSummaryExcludedCustomersDocument, options)
}
export type PartnerListInvoiceSummaryExcludedCustomersQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceSummaryExcludedCustomersQuery>
export type PartnerListInvoiceSummaryExcludedCustomersLazyQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceSummaryExcludedCustomersLazyQuery>
export type PartnerListInvoiceSummaryExcludedCustomersQueryResult =
  Apollo.QueryResult<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >
export const PartnerCreateInvoiceSummaryDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceSummary(
    $input: PartnerCreateInvoiceSummaryInput
  ) {
    PartnerCreateInvoiceSummary(input: $input) {
      ...PartnerInvoiceSummary
    }
  }
  ${PartnerInvoiceSummaryFragmentDoc}
`
export type PartnerCreateInvoiceSummaryMutationFn = Apollo.MutationFunction<
  PartnerCreateInvoiceSummaryMutation,
  PartnerCreateInvoiceSummaryMutationVariables
>

/**
 * __usePartnerCreateInvoiceSummaryMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceSummaryMutation, { data, loading, error }] = usePartnerCreateInvoiceSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateInvoiceSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceSummaryMutation,
    PartnerCreateInvoiceSummaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceSummaryMutation,
    PartnerCreateInvoiceSummaryMutationVariables
  >(PartnerCreateInvoiceSummaryDocument, options)
}
export type PartnerCreateInvoiceSummaryMutationHookResult = ReturnType<
  typeof usePartnerCreateInvoiceSummaryMutation
>
export type PartnerCreateInvoiceSummaryMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceSummaryMutation>
export type PartnerCreateInvoiceSummaryMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceSummaryMutation,
    PartnerCreateInvoiceSummaryMutationVariables
  >
export const PartnerDeleteInvoiceSummaryDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceSummary($id: ID!) {
    PartnerDeleteInvoiceSummary(id: $id)
  }
`
export type PartnerDeleteInvoiceSummaryMutationFn = Apollo.MutationFunction<
  PartnerDeleteInvoiceSummaryMutation,
  PartnerDeleteInvoiceSummaryMutationVariables
>

/**
 * __usePartnerDeleteInvoiceSummaryMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceSummaryMutation, { data, loading, error }] = usePartnerDeleteInvoiceSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceSummaryMutation,
    PartnerDeleteInvoiceSummaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceSummaryMutation,
    PartnerDeleteInvoiceSummaryMutationVariables
  >(PartnerDeleteInvoiceSummaryDocument, options)
}
export type PartnerDeleteInvoiceSummaryMutationHookResult = ReturnType<
  typeof usePartnerDeleteInvoiceSummaryMutation
>
export type PartnerDeleteInvoiceSummaryMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceSummaryMutation>
export type PartnerDeleteInvoiceSummaryMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceSummaryMutation,
    PartnerDeleteInvoiceSummaryMutationVariables
  >
export const PartnerCreateInvoiceSummaryExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceSummaryExcludedCustomer($customerID: ID!) {
    PartnerCreateInvoiceSummaryExcludedCustomer(customerID: $customerID) {
      ...PartnerInvoiceSummaryExcludedCustomer
    }
  }
  ${PartnerInvoiceSummaryExcludedCustomerFragmentDoc}
`
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >

/**
 * __usePartnerCreateInvoiceSummaryExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceSummaryExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceSummaryExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceSummaryExcludedCustomerMutation, { data, loading, error }] = usePartnerCreateInvoiceSummaryExcludedCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerCreateInvoiceSummaryExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >(PartnerCreateInvoiceSummaryExcludedCustomerDocument, options)
}
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerCreateInvoiceSummaryExcludedCustomerMutation>
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceSummaryExcludedCustomerMutation>
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >
export const PartnerUpdateInvoiceSummaryExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInvoiceSummaryExcludedCustomer($customerIDs: [ID!]) {
    PartnerUpdateInvoiceSummaryExcludedCustomer(customerIDs: $customerIDs) {
      ...PartnerInvoiceSummaryExcludedCustomer
    }
  }
  ${PartnerInvoiceSummaryExcludedCustomerFragmentDoc}
`
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >

/**
 * __usePartnerUpdateInvoiceSummaryExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInvoiceSummaryExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInvoiceSummaryExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInvoiceSummaryExcludedCustomerMutation, { data, loading, error }] = usePartnerUpdateInvoiceSummaryExcludedCustomerMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerUpdateInvoiceSummaryExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >(PartnerUpdateInvoiceSummaryExcludedCustomerDocument, options)
}
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerUpdateInvoiceSummaryExcludedCustomerMutation>
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerUpdateInvoiceSummaryExcludedCustomerMutation>
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >
export const PartnerDeleteInvoiceSummaryExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceSummaryExcludedCustomer($id: ID!) {
    PartnerDeleteInvoiceSummaryExcludedCustomer(id: $id)
  }
`
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >

/**
 * __usePartnerDeleteInvoiceSummaryExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceSummaryExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceSummaryExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceSummaryExcludedCustomerMutation, { data, loading, error }] = usePartnerDeleteInvoiceSummaryExcludedCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceSummaryExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >(PartnerDeleteInvoiceSummaryExcludedCustomerDocument, options)
}
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerDeleteInvoiceSummaryExcludedCustomerMutation>
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceSummaryExcludedCustomerMutation>
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >
export const PartnerSendInvoiceSummaryPreviewDocument = /*#__PURE__*/ gql`
  mutation PartnerSendInvoiceSummaryPreview(
    $input: InvoiceSummaryPreviewInput!
  ) {
    PartnerSendInvoiceSummaryPreview(input: $input)
  }
`
export type PartnerSendInvoiceSummaryPreviewMutationFn =
  Apollo.MutationFunction<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >

/**
 * __usePartnerSendInvoiceSummaryPreviewMutation__
 *
 * To run a mutation, you first call `usePartnerSendInvoiceSummaryPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendInvoiceSummaryPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendInvoiceSummaryPreviewMutation, { data, loading, error }] = usePartnerSendInvoiceSummaryPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendInvoiceSummaryPreviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >(PartnerSendInvoiceSummaryPreviewDocument, options)
}
export type PartnerSendInvoiceSummaryPreviewMutationHookResult = ReturnType<
  typeof usePartnerSendInvoiceSummaryPreviewMutation
>
export type PartnerSendInvoiceSummaryPreviewMutationResult =
  Apollo.MutationResult<PartnerSendInvoiceSummaryPreviewMutation>
export type PartnerSendInvoiceSummaryPreviewMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >
export const PartnerToggleSummaryEnabledDocument = /*#__PURE__*/ gql`
  mutation PartnerToggleSummaryEnabled($id: ID!, $enabled: Boolean!) {
    PartnerToggleSummaryEnabled(summaryID: $id, enabled: $enabled)
  }
`
export type PartnerToggleSummaryEnabledMutationFn = Apollo.MutationFunction<
  PartnerToggleSummaryEnabledMutation,
  PartnerToggleSummaryEnabledMutationVariables
>

/**
 * __usePartnerToggleSummaryEnabledMutation__
 *
 * To run a mutation, you first call `usePartnerToggleSummaryEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerToggleSummaryEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerToggleSummaryEnabledMutation, { data, loading, error }] = usePartnerToggleSummaryEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function usePartnerToggleSummaryEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerToggleSummaryEnabledMutation,
    PartnerToggleSummaryEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerToggleSummaryEnabledMutation,
    PartnerToggleSummaryEnabledMutationVariables
  >(PartnerToggleSummaryEnabledDocument, options)
}
export type PartnerToggleSummaryEnabledMutationHookResult = ReturnType<
  typeof usePartnerToggleSummaryEnabledMutation
>
export type PartnerToggleSummaryEnabledMutationResult =
  Apollo.MutationResult<PartnerToggleSummaryEnabledMutation>
export type PartnerToggleSummaryEnabledMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerToggleSummaryEnabledMutation,
    PartnerToggleSummaryEnabledMutationVariables
  >
export const PartnerGetNotificationsEnabledDocument = /*#__PURE__*/ gql`
  query PartnerGetNotificationsEnabled {
    PartnerGetNotificationsEnabled {
      id
      notificationsEnabled
    }
  }
`

/**
 * __usePartnerGetNotificationsEnabledQuery__
 *
 * To run a query within a React component, call `usePartnerGetNotificationsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetNotificationsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetNotificationsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetNotificationsEnabledQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >(PartnerGetNotificationsEnabledDocument, options)
}
export function usePartnerGetNotificationsEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >(PartnerGetNotificationsEnabledDocument, options)
}
export type PartnerGetNotificationsEnabledQueryHookResult = ReturnType<
  typeof usePartnerGetNotificationsEnabledQuery
>
export type PartnerGetNotificationsEnabledLazyQueryHookResult = ReturnType<
  typeof usePartnerGetNotificationsEnabledLazyQuery
>
export type PartnerGetNotificationsEnabledQueryResult = Apollo.QueryResult<
  PartnerGetNotificationsEnabledQuery,
  PartnerGetNotificationsEnabledQueryVariables
>
export const PartnerUpdateNotificationsEnabledDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateNotificationsEnabled($notificationsEnabled: Boolean!) {
    PartnerUpdateNotificationsEnabled(
      notificationsEnabled: $notificationsEnabled
    ) {
      id
      notificationsEnabled
    }
  }
`
export type PartnerUpdateNotificationsEnabledMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >

/**
 * __usePartnerUpdateNotificationsEnabledMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateNotificationsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateNotificationsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateNotificationsEnabledMutation, { data, loading, error }] = usePartnerUpdateNotificationsEnabledMutation({
 *   variables: {
 *      notificationsEnabled: // value for 'notificationsEnabled'
 *   },
 * });
 */
export function usePartnerUpdateNotificationsEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >(PartnerUpdateNotificationsEnabledDocument, options)
}
export type PartnerUpdateNotificationsEnabledMutationHookResult = ReturnType<
  typeof usePartnerUpdateNotificationsEnabledMutation
>
export type PartnerUpdateNotificationsEnabledMutationResult =
  Apollo.MutationResult<PartnerUpdateNotificationsEnabledMutation>
export type PartnerUpdateNotificationsEnabledMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >
export const PartnerSendOneOffEmailDocument = /*#__PURE__*/ gql`
  mutation PartnerSendOneOffEmail($input: SendOneOffEmailInput!) {
    PartnerSendOneOffEmail(input: $input)
  }
`
export type PartnerSendOneOffEmailMutationFn = Apollo.MutationFunction<
  PartnerSendOneOffEmailMutation,
  PartnerSendOneOffEmailMutationVariables
>

/**
 * __usePartnerSendOneOffEmailMutation__
 *
 * To run a mutation, you first call `usePartnerSendOneOffEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendOneOffEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendOneOffEmailMutation, { data, loading, error }] = usePartnerSendOneOffEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendOneOffEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendOneOffEmailMutation,
    PartnerSendOneOffEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendOneOffEmailMutation,
    PartnerSendOneOffEmailMutationVariables
  >(PartnerSendOneOffEmailDocument, options)
}
export type PartnerSendOneOffEmailMutationHookResult = ReturnType<
  typeof usePartnerSendOneOffEmailMutation
>
export type PartnerSendOneOffEmailMutationResult =
  Apollo.MutationResult<PartnerSendOneOffEmailMutation>
export type PartnerSendOneOffEmailMutationOptions = Apollo.BaseMutationOptions<
  PartnerSendOneOffEmailMutation,
  PartnerSendOneOffEmailMutationVariables
>
export const OpenPayoutSummaryDocument = /*#__PURE__*/ gql`
  query OpenPayoutSummary {
    PartnerGetOpenPayoutBalanceTotals {
      available {
        units
        nanos
      }
      pending {
        units
        nanos
      }
      total {
        units
        nanos
      }
    }
    PartnerGetPayoutTimingCompanyConfig {
      activeConfig {
        businessDaysToHold
        payoutTimingFee {
          fixedFee
          percentageFee
          capFee
        }
      }
    }
    PartnerGetPayoutConfig {
      defaultBankingAccount {
        id
        mask
        institution {
          name
        }
      }
    }
  }
`

/**
 * __useOpenPayoutSummaryQuery__
 *
 * To run a query within a React component, call `useOpenPayoutSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenPayoutSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenPayoutSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenPayoutSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OpenPayoutSummaryQuery,
    OpenPayoutSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OpenPayoutSummaryQuery,
    OpenPayoutSummaryQueryVariables
  >(OpenPayoutSummaryDocument, options)
}
export function useOpenPayoutSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OpenPayoutSummaryQuery,
    OpenPayoutSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OpenPayoutSummaryQuery,
    OpenPayoutSummaryQueryVariables
  >(OpenPayoutSummaryDocument, options)
}
export type OpenPayoutSummaryQueryHookResult = ReturnType<
  typeof useOpenPayoutSummaryQuery
>
export type OpenPayoutSummaryLazyQueryHookResult = ReturnType<
  typeof useOpenPayoutSummaryLazyQuery
>
export type OpenPayoutSummaryQueryResult = Apollo.QueryResult<
  OpenPayoutSummaryQuery,
  OpenPayoutSummaryQueryVariables
>
export const OpenPayoutsConnectionDocument = /*#__PURE__*/ gql`
  query OpenPayoutsConnection(
    $first: Int
    $after: Cursor
    $filters: OpenPayoutFilters
  ) {
    PartnerGetOpenPayoutsConnection(
      first: $first
      after: $after
      filters: $filters
    ) {
      edges {
        node {
          id
          payoutWindowDate
          amount {
            units
            nanos
          }
          netAmount {
            units
            nanos
          }
          numberOfPayments
          transactionNetwork
          productID
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __useOpenPayoutsConnectionQuery__
 *
 * To run a query within a React component, call `useOpenPayoutsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenPayoutsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenPayoutsConnectionQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOpenPayoutsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OpenPayoutsConnectionQuery,
    OpenPayoutsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OpenPayoutsConnectionQuery,
    OpenPayoutsConnectionQueryVariables
  >(OpenPayoutsConnectionDocument, options)
}
export function useOpenPayoutsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OpenPayoutsConnectionQuery,
    OpenPayoutsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OpenPayoutsConnectionQuery,
    OpenPayoutsConnectionQueryVariables
  >(OpenPayoutsConnectionDocument, options)
}
export type OpenPayoutsConnectionQueryHookResult = ReturnType<
  typeof useOpenPayoutsConnectionQuery
>
export type OpenPayoutsConnectionLazyQueryHookResult = ReturnType<
  typeof useOpenPayoutsConnectionLazyQuery
>
export type OpenPayoutsConnectionQueryResult = Apollo.QueryResult<
  OpenPayoutsConnectionQuery,
  OpenPayoutsConnectionQueryVariables
>
export const OpenPayoutDetailsDocument = /*#__PURE__*/ gql`
  query OpenPayoutDetails($id: ID!) {
    PartnerGetOpenPayoutDetails(id: $id) {
      ...PartnerOpenPayoutDetails
    }
  }
  ${PartnerOpenPayoutDetailsFragmentDoc}
`

/**
 * __useOpenPayoutDetailsQuery__
 *
 * To run a query within a React component, call `useOpenPayoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenPayoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenPayoutDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenPayoutDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OpenPayoutDetailsQuery,
    OpenPayoutDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OpenPayoutDetailsQuery,
    OpenPayoutDetailsQueryVariables
  >(OpenPayoutDetailsDocument, options)
}
export function useOpenPayoutDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OpenPayoutDetailsQuery,
    OpenPayoutDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OpenPayoutDetailsQuery,
    OpenPayoutDetailsQueryVariables
  >(OpenPayoutDetailsDocument, options)
}
export type OpenPayoutDetailsQueryHookResult = ReturnType<
  typeof useOpenPayoutDetailsQuery
>
export type OpenPayoutDetailsLazyQueryHookResult = ReturnType<
  typeof useOpenPayoutDetailsLazyQuery
>
export type OpenPayoutDetailsQueryResult = Apollo.QueryResult<
  OpenPayoutDetailsQuery,
  OpenPayoutDetailsQueryVariables
>
export const OpenPayoutBreakdownItemsConnectionDocument = /*#__PURE__*/ gql`
  query OpenPayoutBreakdownItemsConnection(
    $openPayoutID: ID!
    $first: Int
    $after: Cursor
  ) {
    PartnerGetOpenPayoutBreakdownItemsConnection(
      openPayoutID: $openPayoutID
      first: $first
      after: $after
    ) {
      edges {
        node {
          ...PartnerOpenPayoutBreakdownItem
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerOpenPayoutBreakdownItemFragmentDoc}
`

/**
 * __useOpenPayoutBreakdownItemsConnectionQuery__
 *
 * To run a query within a React component, call `useOpenPayoutBreakdownItemsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenPayoutBreakdownItemsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenPayoutBreakdownItemsConnectionQuery({
 *   variables: {
 *      openPayoutID: // value for 'openPayoutID'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useOpenPayoutBreakdownItemsConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    OpenPayoutBreakdownItemsConnectionQuery,
    OpenPayoutBreakdownItemsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OpenPayoutBreakdownItemsConnectionQuery,
    OpenPayoutBreakdownItemsConnectionQueryVariables
  >(OpenPayoutBreakdownItemsConnectionDocument, options)
}
export function useOpenPayoutBreakdownItemsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OpenPayoutBreakdownItemsConnectionQuery,
    OpenPayoutBreakdownItemsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OpenPayoutBreakdownItemsConnectionQuery,
    OpenPayoutBreakdownItemsConnectionQueryVariables
  >(OpenPayoutBreakdownItemsConnectionDocument, options)
}
export type OpenPayoutBreakdownItemsConnectionQueryHookResult = ReturnType<
  typeof useOpenPayoutBreakdownItemsConnectionQuery
>
export type OpenPayoutBreakdownItemsConnectionLazyQueryHookResult = ReturnType<
  typeof useOpenPayoutBreakdownItemsConnectionLazyQuery
>
export type OpenPayoutBreakdownItemsConnectionQueryResult = Apollo.QueryResult<
  OpenPayoutBreakdownItemsConnectionQuery,
  OpenPayoutBreakdownItemsConnectionQueryVariables
>
export const GetOverviewSummaryDocument = /*#__PURE__*/ gql`
  query GetOverviewSummary($startDate: String!, $endDate: String!) {
    PartnerGetOverviewSummary(startDate: $startDate, endDate: $endDate) {
      grossRevenue {
        value
        change
      }
      netProfit {
        value
        change
        benchmark
        benchmarkDeltaPp
      }
    }
  }
`

/**
 * __useGetOverviewSummaryQuery__
 *
 * To run a query within a React component, call `useGetOverviewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOverviewSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOverviewSummaryQuery,
    GetOverviewSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetOverviewSummaryQuery,
    GetOverviewSummaryQueryVariables
  >(GetOverviewSummaryDocument, options)
}
export function useGetOverviewSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOverviewSummaryQuery,
    GetOverviewSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetOverviewSummaryQuery,
    GetOverviewSummaryQueryVariables
  >(GetOverviewSummaryDocument, options)
}
export type GetOverviewSummaryQueryHookResult = ReturnType<
  typeof useGetOverviewSummaryQuery
>
export type GetOverviewSummaryLazyQueryHookResult = ReturnType<
  typeof useGetOverviewSummaryLazyQuery
>
export type GetOverviewSummaryQueryResult = Apollo.QueryResult<
  GetOverviewSummaryQuery,
  GetOverviewSummaryQueryVariables
>
export const GetOverviewProfitabilityDocument = /*#__PURE__*/ gql`
  query GetOverviewProfitability($startDate: String!, $endDate: String!) {
    PartnerGetOverviewProfitability(startDate: $startDate, endDate: $endDate) {
      totalRevenue
      totalProfit
      months {
        month
        revenue
        profit
        benchmark
      }
    }
  }
`

/**
 * __useGetOverviewProfitabilityQuery__
 *
 * To run a query within a React component, call `useGetOverviewProfitabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewProfitabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewProfitabilityQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOverviewProfitabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOverviewProfitabilityQuery,
    GetOverviewProfitabilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetOverviewProfitabilityQuery,
    GetOverviewProfitabilityQueryVariables
  >(GetOverviewProfitabilityDocument, options)
}
export function useGetOverviewProfitabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOverviewProfitabilityQuery,
    GetOverviewProfitabilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetOverviewProfitabilityQuery,
    GetOverviewProfitabilityQueryVariables
  >(GetOverviewProfitabilityDocument, options)
}
export type GetOverviewProfitabilityQueryHookResult = ReturnType<
  typeof useGetOverviewProfitabilityQuery
>
export type GetOverviewProfitabilityLazyQueryHookResult = ReturnType<
  typeof useGetOverviewProfitabilityLazyQuery
>
export type GetOverviewProfitabilityQueryResult = Apollo.QueryResult<
  GetOverviewProfitabilityQuery,
  GetOverviewProfitabilityQueryVariables
>
export const GetOverviewMrrDocument = /*#__PURE__*/ gql`
  query GetOverviewMrr($startDate: String!, $endDate: String!) {
    PartnerGetOverviewMRR(startDate: $startDate, endDate: $endDate) {
      currentMrr
      gainedMrr
      lostMrr
      netMrrChange
      trend {
        month
        mrr
        gainedMrr
        lostMrr
        netChange
        benchmark
      }
    }
  }
`

/**
 * __useGetOverviewMrrQuery__
 *
 * To run a query within a React component, call `useGetOverviewMrrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewMrrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewMrrQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOverviewMrrQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOverviewMrrQuery,
    GetOverviewMrrQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOverviewMrrQuery, GetOverviewMrrQueryVariables>(
    GetOverviewMrrDocument,
    options
  )
}
export function useGetOverviewMrrLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOverviewMrrQuery,
    GetOverviewMrrQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOverviewMrrQuery, GetOverviewMrrQueryVariables>(
    GetOverviewMrrDocument,
    options
  )
}
export type GetOverviewMrrQueryHookResult = ReturnType<
  typeof useGetOverviewMrrQuery
>
export type GetOverviewMrrLazyQueryHookResult = ReturnType<
  typeof useGetOverviewMrrLazyQuery
>
export type GetOverviewMrrQueryResult = Apollo.QueryResult<
  GetOverviewMrrQuery,
  GetOverviewMrrQueryVariables
>
export const GetOverviewEfficiencyDocument = /*#__PURE__*/ gql`
  query GetOverviewEfficiency($startDate: String!, $endDate: String!) {
    PartnerGetOverviewEfficiency(startDate: $startDate, endDate: $endDate) {
      utilization {
        value
        change
        benchmark
      }
      ticketLoad {
        value
        change
        benchmark
      }
      laborEfficiencyRatio {
        value
        change
        benchmark
      }
    }
  }
`

/**
 * __useGetOverviewEfficiencyQuery__
 *
 * To run a query within a React component, call `useGetOverviewEfficiencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewEfficiencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewEfficiencyQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOverviewEfficiencyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOverviewEfficiencyQuery,
    GetOverviewEfficiencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetOverviewEfficiencyQuery,
    GetOverviewEfficiencyQueryVariables
  >(GetOverviewEfficiencyDocument, options)
}
export function useGetOverviewEfficiencyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOverviewEfficiencyQuery,
    GetOverviewEfficiencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetOverviewEfficiencyQuery,
    GetOverviewEfficiencyQueryVariables
  >(GetOverviewEfficiencyDocument, options)
}
export type GetOverviewEfficiencyQueryHookResult = ReturnType<
  typeof useGetOverviewEfficiencyQuery
>
export type GetOverviewEfficiencyLazyQueryHookResult = ReturnType<
  typeof useGetOverviewEfficiencyLazyQuery
>
export type GetOverviewEfficiencyQueryResult = Apollo.QueryResult<
  GetOverviewEfficiencyQuery,
  GetOverviewEfficiencyQueryVariables
>
export const GetPartnerDocumentsDocument = /*#__PURE__*/ gql`
  query GetPartnerDocuments {
    GetPartnerDocuments {
      id
      partnerID
      type
      filename
      createdAt
    }
  }
`

/**
 * __useGetPartnerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPartnerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >(GetPartnerDocumentsDocument, options)
}
export function useGetPartnerDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >(GetPartnerDocumentsDocument, options)
}
export type GetPartnerDocumentsQueryHookResult = ReturnType<
  typeof useGetPartnerDocumentsQuery
>
export type GetPartnerDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetPartnerDocumentsLazyQuery
>
export type GetPartnerDocumentsQueryResult = Apollo.QueryResult<
  GetPartnerDocumentsQuery,
  GetPartnerDocumentsQueryVariables
>
export const PartnerUpdateInvoicePdfSettingsDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInvoicePdfSettings(
    $input: PartnerUpdateInvoicePdfSettingsInput!
  ) {
    PartnerUpdateInvoicePdfSettings(input: $input) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateInvoicePdfSettingsMutationFn = Apollo.MutationFunction<
  PartnerUpdateInvoicePdfSettingsMutation,
  PartnerUpdateInvoicePdfSettingsMutationVariables
>

/**
 * __usePartnerUpdateInvoicePdfSettingsMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInvoicePdfSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInvoicePdfSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInvoicePdfSettingsMutation, { data, loading, error }] = usePartnerUpdateInvoicePdfSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateInvoicePdfSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInvoicePdfSettingsMutation,
    PartnerUpdateInvoicePdfSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInvoicePdfSettingsMutation,
    PartnerUpdateInvoicePdfSettingsMutationVariables
  >(PartnerUpdateInvoicePdfSettingsDocument, options)
}
export type PartnerUpdateInvoicePdfSettingsMutationHookResult = ReturnType<
  typeof usePartnerUpdateInvoicePdfSettingsMutation
>
export type PartnerUpdateInvoicePdfSettingsMutationResult =
  Apollo.MutationResult<PartnerUpdateInvoicePdfSettingsMutation>
export type PartnerUpdateInvoicePdfSettingsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInvoicePdfSettingsMutation,
    PartnerUpdateInvoicePdfSettingsMutationVariables
  >
export const PartnerUpdateInformationDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInformation(
    $detailsInput: PartnerUpdateDetailsInput
    $addressInput: PartnerUpdateAddressInput
  ) {
    PartnerUpdateAddress(input: $addressInput) {
      id
      ...PartnerAddressDetails
    }
    PartnerUpdateDetails(input: $detailsInput) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerAddressDetailsFragmentDoc}
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateInformationMutationFn = Apollo.MutationFunction<
  PartnerUpdateInformationMutation,
  PartnerUpdateInformationMutationVariables
>

/**
 * __usePartnerUpdateInformationMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInformationMutation, { data, loading, error }] = usePartnerUpdateInformationMutation({
 *   variables: {
 *      detailsInput: // value for 'detailsInput'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function usePartnerUpdateInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInformationMutation,
    PartnerUpdateInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInformationMutation,
    PartnerUpdateInformationMutationVariables
  >(PartnerUpdateInformationDocument, options)
}
export type PartnerUpdateInformationMutationHookResult = ReturnType<
  typeof usePartnerUpdateInformationMutation
>
export type PartnerUpdateInformationMutationResult =
  Apollo.MutationResult<PartnerUpdateInformationMutation>
export type PartnerUpdateInformationMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInformationMutation,
    PartnerUpdateInformationMutationVariables
  >
export const PartnerUpdateTimezoneDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateTimezone($input: PartnerUpdateTimezoneInput!) {
    PartnerUpdateTimezone(input: $input) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateTimezoneMutationFn = Apollo.MutationFunction<
  PartnerUpdateTimezoneMutation,
  PartnerUpdateTimezoneMutationVariables
>

/**
 * __usePartnerUpdateTimezoneMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateTimezoneMutation, { data, loading, error }] = usePartnerUpdateTimezoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateTimezoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateTimezoneMutation,
    PartnerUpdateTimezoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateTimezoneMutation,
    PartnerUpdateTimezoneMutationVariables
  >(PartnerUpdateTimezoneDocument, options)
}
export type PartnerUpdateTimezoneMutationHookResult = ReturnType<
  typeof usePartnerUpdateTimezoneMutation
>
export type PartnerUpdateTimezoneMutationResult =
  Apollo.MutationResult<PartnerUpdateTimezoneMutation>
export type PartnerUpdateTimezoneMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateTimezoneMutation,
  PartnerUpdateTimezoneMutationVariables
>
export const ActivatePartnerPaymentsPortalDocument = /*#__PURE__*/ gql`
  mutation ActivatePartnerPaymentsPortal {
    ActivatePartnerPaymentsPortal {
      id
      name
      paymentsPortalEnabled
      paymentsPortalUrl
    }
  }
`
export type ActivatePartnerPaymentsPortalMutationFn = Apollo.MutationFunction<
  ActivatePartnerPaymentsPortalMutation,
  ActivatePartnerPaymentsPortalMutationVariables
>

/**
 * __useActivatePartnerPaymentsPortalMutation__
 *
 * To run a mutation, you first call `useActivatePartnerPaymentsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePartnerPaymentsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePartnerPaymentsPortalMutation, { data, loading, error }] = useActivatePartnerPaymentsPortalMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivatePartnerPaymentsPortalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivatePartnerPaymentsPortalMutation,
    ActivatePartnerPaymentsPortalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ActivatePartnerPaymentsPortalMutation,
    ActivatePartnerPaymentsPortalMutationVariables
  >(ActivatePartnerPaymentsPortalDocument, options)
}
export type ActivatePartnerPaymentsPortalMutationHookResult = ReturnType<
  typeof useActivatePartnerPaymentsPortalMutation
>
export type ActivatePartnerPaymentsPortalMutationResult =
  Apollo.MutationResult<ActivatePartnerPaymentsPortalMutation>
export type ActivatePartnerPaymentsPortalMutationOptions =
  Apollo.BaseMutationOptions<
    ActivatePartnerPaymentsPortalMutation,
    ActivatePartnerPaymentsPortalMutationVariables
  >
export const GetCompanyIndividualsDocument = /*#__PURE__*/ gql`
  query GetCompanyIndividuals {
    GetCompanyIndividuals {
      ...CompanyIndividual
    }
  }
  ${CompanyIndividualFragmentDoc}
`

/**
 * __useGetCompanyIndividualsQuery__
 *
 * To run a query within a React component, call `useGetCompanyIndividualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIndividualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIndividualsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyIndividualsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >(GetCompanyIndividualsDocument, options)
}
export function useGetCompanyIndividualsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >(GetCompanyIndividualsDocument, options)
}
export type GetCompanyIndividualsQueryHookResult = ReturnType<
  typeof useGetCompanyIndividualsQuery
>
export type GetCompanyIndividualsLazyQueryHookResult = ReturnType<
  typeof useGetCompanyIndividualsLazyQuery
>
export type GetCompanyIndividualsQueryResult = Apollo.QueryResult<
  GetCompanyIndividualsQuery,
  GetCompanyIndividualsQueryVariables
>
export const GetCompanyIndividualsWithDocumentsDocument = /*#__PURE__*/ gql`
  query GetCompanyIndividualsWithDocuments {
    GetCompanyIndividuals {
      ...CompanyIndividualWithDocuments
    }
  }
  ${CompanyIndividualWithDocumentsFragmentDoc}
`

/**
 * __useGetCompanyIndividualsWithDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCompanyIndividualsWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIndividualsWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIndividualsWithDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyIndividualsWithDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyIndividualsWithDocumentsQuery,
    GetCompanyIndividualsWithDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCompanyIndividualsWithDocumentsQuery,
    GetCompanyIndividualsWithDocumentsQueryVariables
  >(GetCompanyIndividualsWithDocumentsDocument, options)
}
export function useGetCompanyIndividualsWithDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyIndividualsWithDocumentsQuery,
    GetCompanyIndividualsWithDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCompanyIndividualsWithDocumentsQuery,
    GetCompanyIndividualsWithDocumentsQueryVariables
  >(GetCompanyIndividualsWithDocumentsDocument, options)
}
export type GetCompanyIndividualsWithDocumentsQueryHookResult = ReturnType<
  typeof useGetCompanyIndividualsWithDocumentsQuery
>
export type GetCompanyIndividualsWithDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetCompanyIndividualsWithDocumentsLazyQuery
>
export type GetCompanyIndividualsWithDocumentsQueryResult = Apollo.QueryResult<
  GetCompanyIndividualsWithDocumentsQuery,
  GetCompanyIndividualsWithDocumentsQueryVariables
>
export const CreateCompanyIndividualDocument = /*#__PURE__*/ gql`
  mutation CreateCompanyIndividual($input: CreateCompanyIndividualInput!) {
    CreateCompanyIndividual(input: $input) {
      ...CompanyIndividual
    }
  }
  ${CompanyIndividualFragmentDoc}
`
export type CreateCompanyIndividualMutationFn = Apollo.MutationFunction<
  CreateCompanyIndividualMutation,
  CreateCompanyIndividualMutationVariables
>

/**
 * __useCreateCompanyIndividualMutation__
 *
 * To run a mutation, you first call `useCreateCompanyIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyIndividualMutation, { data, loading, error }] = useCreateCompanyIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyIndividualMutation,
    CreateCompanyIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCompanyIndividualMutation,
    CreateCompanyIndividualMutationVariables
  >(CreateCompanyIndividualDocument, options)
}
export type CreateCompanyIndividualMutationHookResult = ReturnType<
  typeof useCreateCompanyIndividualMutation
>
export type CreateCompanyIndividualMutationResult =
  Apollo.MutationResult<CreateCompanyIndividualMutation>
export type CreateCompanyIndividualMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyIndividualMutation,
  CreateCompanyIndividualMutationVariables
>
export const UpdateCompanyIndividualDocument = /*#__PURE__*/ gql`
  mutation UpdateCompanyIndividual($input: UpdateCompanyIndividualInput!) {
    UpdateCompanyIndividual(input: $input)
  }
`
export type UpdateCompanyIndividualMutationFn = Apollo.MutationFunction<
  UpdateCompanyIndividualMutation,
  UpdateCompanyIndividualMutationVariables
>

/**
 * __useUpdateCompanyIndividualMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyIndividualMutation, { data, loading, error }] = useUpdateCompanyIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCompanyIndividualMutation,
    UpdateCompanyIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCompanyIndividualMutation,
    UpdateCompanyIndividualMutationVariables
  >(UpdateCompanyIndividualDocument, options)
}
export type UpdateCompanyIndividualMutationHookResult = ReturnType<
  typeof useUpdateCompanyIndividualMutation
>
export type UpdateCompanyIndividualMutationResult =
  Apollo.MutationResult<UpdateCompanyIndividualMutation>
export type UpdateCompanyIndividualMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompanyIndividualMutation,
  UpdateCompanyIndividualMutationVariables
>
export const DeleteCompanyIndividualDocument = /*#__PURE__*/ gql`
  mutation DeleteCompanyIndividual($id: ID!) {
    DeleteCompanyIndividual(id: $id)
  }
`
export type DeleteCompanyIndividualMutationFn = Apollo.MutationFunction<
  DeleteCompanyIndividualMutation,
  DeleteCompanyIndividualMutationVariables
>

/**
 * __useDeleteCompanyIndividualMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyIndividualMutation, { data, loading, error }] = useDeleteCompanyIndividualMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCompanyIndividualMutation,
    DeleteCompanyIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCompanyIndividualMutation,
    DeleteCompanyIndividualMutationVariables
  >(DeleteCompanyIndividualDocument, options)
}
export type DeleteCompanyIndividualMutationHookResult = ReturnType<
  typeof useDeleteCompanyIndividualMutation
>
export type DeleteCompanyIndividualMutationResult =
  Apollo.MutationResult<DeleteCompanyIndividualMutation>
export type DeleteCompanyIndividualMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyIndividualMutation,
  DeleteCompanyIndividualMutationVariables
>
export const PartnerDeleteCompanyDocumentsByIndividualIdDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCompanyDocumentsByIndividualId($individualId: ID!) {
    PartnerDeleteCompanyDocumentsByIndividualId(individualId: $individualId)
  }
`
export type PartnerDeleteCompanyDocumentsByIndividualIdMutationFn =
  Apollo.MutationFunction<
    PartnerDeleteCompanyDocumentsByIndividualIdMutation,
    PartnerDeleteCompanyDocumentsByIndividualIdMutationVariables
  >

/**
 * __usePartnerDeleteCompanyDocumentsByIndividualIdMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCompanyDocumentsByIndividualIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCompanyDocumentsByIndividualIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCompanyDocumentsByIndividualIdMutation, { data, loading, error }] = usePartnerDeleteCompanyDocumentsByIndividualIdMutation({
 *   variables: {
 *      individualId: // value for 'individualId'
 *   },
 * });
 */
export function usePartnerDeleteCompanyDocumentsByIndividualIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCompanyDocumentsByIndividualIdMutation,
    PartnerDeleteCompanyDocumentsByIndividualIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCompanyDocumentsByIndividualIdMutation,
    PartnerDeleteCompanyDocumentsByIndividualIdMutationVariables
  >(PartnerDeleteCompanyDocumentsByIndividualIdDocument, options)
}
export type PartnerDeleteCompanyDocumentsByIndividualIdMutationHookResult =
  ReturnType<typeof usePartnerDeleteCompanyDocumentsByIndividualIdMutation>
export type PartnerDeleteCompanyDocumentsByIndividualIdMutationResult =
  Apollo.MutationResult<PartnerDeleteCompanyDocumentsByIndividualIdMutation>
export type PartnerDeleteCompanyDocumentsByIndividualIdMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCompanyDocumentsByIndividualIdMutation,
    PartnerDeleteCompanyDocumentsByIndividualIdMutationVariables
  >
export const PartnerCreateCompanyIndividualUploadLinkDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCompanyIndividualUploadLink($individualID: ID!) {
    PartnerCreateCompanyIndividualUploadLink(individualID: $individualID) {
      id
      partnerID
      individualID
      expirationDate
    }
  }
`
export type PartnerCreateCompanyIndividualUploadLinkMutationFn =
  Apollo.MutationFunction<
    PartnerCreateCompanyIndividualUploadLinkMutation,
    PartnerCreateCompanyIndividualUploadLinkMutationVariables
  >

/**
 * __usePartnerCreateCompanyIndividualUploadLinkMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCompanyIndividualUploadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCompanyIndividualUploadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCompanyIndividualUploadLinkMutation, { data, loading, error }] = usePartnerCreateCompanyIndividualUploadLinkMutation({
 *   variables: {
 *      individualID: // value for 'individualID'
 *   },
 * });
 */
export function usePartnerCreateCompanyIndividualUploadLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCompanyIndividualUploadLinkMutation,
    PartnerCreateCompanyIndividualUploadLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCompanyIndividualUploadLinkMutation,
    PartnerCreateCompanyIndividualUploadLinkMutationVariables
  >(PartnerCreateCompanyIndividualUploadLinkDocument, options)
}
export type PartnerCreateCompanyIndividualUploadLinkMutationHookResult =
  ReturnType<typeof usePartnerCreateCompanyIndividualUploadLinkMutation>
export type PartnerCreateCompanyIndividualUploadLinkMutationResult =
  Apollo.MutationResult<PartnerCreateCompanyIndividualUploadLinkMutation>
export type PartnerCreateCompanyIndividualUploadLinkMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCompanyIndividualUploadLinkMutation,
    PartnerCreateCompanyIndividualUploadLinkMutationVariables
  >
export const UploadPartnerDocumentDocument = /*#__PURE__*/ gql`
  mutation UploadPartnerDocument($input: UploadPartnerDocumentInput!) {
    UploadPartnerDocument(input: $input)
  }
`
export type UploadPartnerDocumentMutationFn = Apollo.MutationFunction<
  UploadPartnerDocumentMutation,
  UploadPartnerDocumentMutationVariables
>

/**
 * __useUploadPartnerDocumentMutation__
 *
 * To run a mutation, you first call `useUploadPartnerDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPartnerDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPartnerDocumentMutation, { data, loading, error }] = useUploadPartnerDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadPartnerDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadPartnerDocumentMutation,
    UploadPartnerDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadPartnerDocumentMutation,
    UploadPartnerDocumentMutationVariables
  >(UploadPartnerDocumentDocument, options)
}
export type UploadPartnerDocumentMutationHookResult = ReturnType<
  typeof useUploadPartnerDocumentMutation
>
export type UploadPartnerDocumentMutationResult =
  Apollo.MutationResult<UploadPartnerDocumentMutation>
export type UploadPartnerDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadPartnerDocumentMutation,
  UploadPartnerDocumentMutationVariables
>
export const UpsertSupportPreferencesDocument = /*#__PURE__*/ gql`
  mutation UpsertSupportPreferences($input: UpsertSupportPreferencesInput!) {
    UpsertSupportPreferences(input: $input) {
      ...SupportPreferences
    }
  }
  ${SupportPreferencesFragmentDoc}
`
export type UpsertSupportPreferencesMutationFn = Apollo.MutationFunction<
  UpsertSupportPreferencesMutation,
  UpsertSupportPreferencesMutationVariables
>

/**
 * __useUpsertSupportPreferencesMutation__
 *
 * To run a mutation, you first call `useUpsertSupportPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSupportPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSupportPreferencesMutation, { data, loading, error }] = useUpsertSupportPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSupportPreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertSupportPreferencesMutation,
    UpsertSupportPreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertSupportPreferencesMutation,
    UpsertSupportPreferencesMutationVariables
  >(UpsertSupportPreferencesDocument, options)
}
export type UpsertSupportPreferencesMutationHookResult = ReturnType<
  typeof useUpsertSupportPreferencesMutation
>
export type UpsertSupportPreferencesMutationResult =
  Apollo.MutationResult<UpsertSupportPreferencesMutation>
export type UpsertSupportPreferencesMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertSupportPreferencesMutation,
    UpsertSupportPreferencesMutationVariables
  >
export const GetSupportPreferencesDocument = /*#__PURE__*/ gql`
  query GetSupportPreferences {
    GetSupportPreferences {
      ...SupportPreferences
    }
  }
  ${SupportPreferencesFragmentDoc}
`

/**
 * __useGetSupportPreferencesQuery__
 *
 * To run a query within a React component, call `useGetSupportPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >(GetSupportPreferencesDocument, options)
}
export function useGetSupportPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >(GetSupportPreferencesDocument, options)
}
export type GetSupportPreferencesQueryHookResult = ReturnType<
  typeof useGetSupportPreferencesQuery
>
export type GetSupportPreferencesLazyQueryHookResult = ReturnType<
  typeof useGetSupportPreferencesLazyQuery
>
export type GetSupportPreferencesQueryResult = Apollo.QueryResult<
  GetSupportPreferencesQuery,
  GetSupportPreferencesQueryVariables
>
export const GetUserPartnersDocument = /*#__PURE__*/ gql`
  query GetUserPartners {
    GetUserPartners {
      ...PartnerSidebarItem
    }
  }
  ${PartnerSidebarItemFragmentDoc}
`

/**
 * __useGetUserPartnersQuery__
 *
 * To run a query within a React component, call `useGetUserPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPartnersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserPartnersQuery,
    GetUserPartnersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserPartnersQuery, GetUserPartnersQueryVariables>(
    GetUserPartnersDocument,
    options
  )
}
export function useGetUserPartnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserPartnersQuery,
    GetUserPartnersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserPartnersQuery,
    GetUserPartnersQueryVariables
  >(GetUserPartnersDocument, options)
}
export type GetUserPartnersQueryHookResult = ReturnType<
  typeof useGetUserPartnersQuery
>
export type GetUserPartnersLazyQueryHookResult = ReturnType<
  typeof useGetUserPartnersLazyQuery
>
export type GetUserPartnersQueryResult = Apollo.QueryResult<
  GetUserPartnersQuery,
  GetUserPartnersQueryVariables
>
export const PartnerFinishOnboardingDocument = /*#__PURE__*/ gql`
  mutation PartnerFinishOnboarding {
    PartnerFinishOnboarding {
      id
      isOnboarded
    }
  }
`
export type PartnerFinishOnboardingMutationFn = Apollo.MutationFunction<
  PartnerFinishOnboardingMutation,
  PartnerFinishOnboardingMutationVariables
>

/**
 * __usePartnerFinishOnboardingMutation__
 *
 * To run a mutation, you first call `usePartnerFinishOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerFinishOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerFinishOnboardingMutation, { data, loading, error }] = usePartnerFinishOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function usePartnerFinishOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerFinishOnboardingMutation,
    PartnerFinishOnboardingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerFinishOnboardingMutation,
    PartnerFinishOnboardingMutationVariables
  >(PartnerFinishOnboardingDocument, options)
}
export type PartnerFinishOnboardingMutationHookResult = ReturnType<
  typeof usePartnerFinishOnboardingMutation
>
export type PartnerFinishOnboardingMutationResult =
  Apollo.MutationResult<PartnerFinishOnboardingMutation>
export type PartnerFinishOnboardingMutationOptions = Apollo.BaseMutationOptions<
  PartnerFinishOnboardingMutation,
  PartnerFinishOnboardingMutationVariables
>
export const PartnerUpdateDetailsDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateDetails($input: PartnerUpdateDetailsInput) {
    PartnerUpdateDetails(input: $input) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateDetailsMutationFn = Apollo.MutationFunction<
  PartnerUpdateDetailsMutation,
  PartnerUpdateDetailsMutationVariables
>

/**
 * __usePartnerUpdateDetailsMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateDetailsMutation, { data, loading, error }] = usePartnerUpdateDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateDetailsMutation,
    PartnerUpdateDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateDetailsMutation,
    PartnerUpdateDetailsMutationVariables
  >(PartnerUpdateDetailsDocument, options)
}
export type PartnerUpdateDetailsMutationHookResult = ReturnType<
  typeof usePartnerUpdateDetailsMutation
>
export type PartnerUpdateDetailsMutationResult =
  Apollo.MutationResult<PartnerUpdateDetailsMutation>
export type PartnerUpdateDetailsMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateDetailsMutation,
  PartnerUpdateDetailsMutationVariables
>
export const PartnerUpdateAddressDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateAddress($input: PartnerUpdateAddressInput) {
    PartnerUpdateAddress(input: $input) {
      id
      ...PartnerAddressDetails
    }
  }
  ${PartnerAddressDetailsFragmentDoc}
`
export type PartnerUpdateAddressMutationFn = Apollo.MutationFunction<
  PartnerUpdateAddressMutation,
  PartnerUpdateAddressMutationVariables
>

/**
 * __usePartnerUpdateAddressMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateAddressMutation, { data, loading, error }] = usePartnerUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateAddressMutation,
    PartnerUpdateAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateAddressMutation,
    PartnerUpdateAddressMutationVariables
  >(PartnerUpdateAddressDocument, options)
}
export type PartnerUpdateAddressMutationHookResult = ReturnType<
  typeof usePartnerUpdateAddressMutation
>
export type PartnerUpdateAddressMutationResult =
  Apollo.MutationResult<PartnerUpdateAddressMutation>
export type PartnerUpdateAddressMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateAddressMutation,
  PartnerUpdateAddressMutationVariables
>
export const PartnerTogglePaymentsPortalCustomInvoicesDocument = /*#__PURE__*/ gql`
  mutation PartnerTogglePaymentsPortalCustomInvoices(
    $paymentsPortalCustomInvoices: Boolean!
  ) {
    PartnerTogglePaymentsPortalCustomInvoices(
      paymentsPortalCustomInvoices: $paymentsPortalCustomInvoices
    ) {
      paymentsPortalCustomInvoices
    }
  }
`
export type PartnerTogglePaymentsPortalCustomInvoicesMutationFn =
  Apollo.MutationFunction<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >

/**
 * __usePartnerTogglePaymentsPortalCustomInvoicesMutation__
 *
 * To run a mutation, you first call `usePartnerTogglePaymentsPortalCustomInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerTogglePaymentsPortalCustomInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerTogglePaymentsPortalCustomInvoicesMutation, { data, loading, error }] = usePartnerTogglePaymentsPortalCustomInvoicesMutation({
 *   variables: {
 *      paymentsPortalCustomInvoices: // value for 'paymentsPortalCustomInvoices'
 *   },
 * });
 */
export function usePartnerTogglePaymentsPortalCustomInvoicesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >(PartnerTogglePaymentsPortalCustomInvoicesDocument, options)
}
export type PartnerTogglePaymentsPortalCustomInvoicesMutationHookResult =
  ReturnType<typeof usePartnerTogglePaymentsPortalCustomInvoicesMutation>
export type PartnerTogglePaymentsPortalCustomInvoicesMutationResult =
  Apollo.MutationResult<PartnerTogglePaymentsPortalCustomInvoicesMutation>
export type PartnerTogglePaymentsPortalCustomInvoicesMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >
export const PartnerToggleRequiresMfaDocument = /*#__PURE__*/ gql`
  mutation PartnerToggleRequiresMFA($requiresMFA: Boolean!) {
    PartnerToggleRequiresMFA(requiresMFA: $requiresMFA) {
      id
      requiresMFA
    }
  }
`
export type PartnerToggleRequiresMfaMutationFn = Apollo.MutationFunction<
  PartnerToggleRequiresMfaMutation,
  PartnerToggleRequiresMfaMutationVariables
>

/**
 * __usePartnerToggleRequiresMfaMutation__
 *
 * To run a mutation, you first call `usePartnerToggleRequiresMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerToggleRequiresMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerToggleRequiresMfaMutation, { data, loading, error }] = usePartnerToggleRequiresMfaMutation({
 *   variables: {
 *      requiresMFA: // value for 'requiresMFA'
 *   },
 * });
 */
export function usePartnerToggleRequiresMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerToggleRequiresMfaMutation,
    PartnerToggleRequiresMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerToggleRequiresMfaMutation,
    PartnerToggleRequiresMfaMutationVariables
  >(PartnerToggleRequiresMfaDocument, options)
}
export type PartnerToggleRequiresMfaMutationHookResult = ReturnType<
  typeof usePartnerToggleRequiresMfaMutation
>
export type PartnerToggleRequiresMfaMutationResult =
  Apollo.MutationResult<PartnerToggleRequiresMfaMutation>
export type PartnerToggleRequiresMfaMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerToggleRequiresMfaMutation,
    PartnerToggleRequiresMfaMutationVariables
  >
export const PartnerUpdateNameDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateName($input: UpdatePartnerNameInput!) {
    PartnerUpdateName(input: $input) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateNameMutationFn = Apollo.MutationFunction<
  PartnerUpdateNameMutation,
  PartnerUpdateNameMutationVariables
>

/**
 * __usePartnerUpdateNameMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateNameMutation, { data, loading, error }] = usePartnerUpdateNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateNameMutation,
    PartnerUpdateNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateNameMutation,
    PartnerUpdateNameMutationVariables
  >(PartnerUpdateNameDocument, options)
}
export type PartnerUpdateNameMutationHookResult = ReturnType<
  typeof usePartnerUpdateNameMutation
>
export type PartnerUpdateNameMutationResult =
  Apollo.MutationResult<PartnerUpdateNameMutation>
export type PartnerUpdateNameMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateNameMutation,
  PartnerUpdateNameMutationVariables
>
export const PartnerGetPartnerAutopayConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetPartnerAutopayConfig {
    PartnerGetPartnerAutopayConfig {
      id
      allowCustomerEdit
      customerPaymentFailureLimit
    }
  }
`

/**
 * __usePartnerGetPartnerAutopayConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetPartnerAutopayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPartnerAutopayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPartnerAutopayConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetPartnerAutopayConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >(PartnerGetPartnerAutopayConfigDocument, options)
}
export function usePartnerGetPartnerAutopayConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >(PartnerGetPartnerAutopayConfigDocument, options)
}
export type PartnerGetPartnerAutopayConfigQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerAutopayConfigQuery
>
export type PartnerGetPartnerAutopayConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerAutopayConfigLazyQuery
>
export type PartnerGetPartnerAutopayConfigQueryResult = Apollo.QueryResult<
  PartnerGetPartnerAutopayConfigQuery,
  PartnerGetPartnerAutopayConfigQueryVariables
>
export const PartnerChangePartnerAutopayConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangePartnerAutopayConfig(
    $partnerAutopayConfig: PartnerAutopayConfigUpdateInput!
  ) {
    PartnerChangePartnerAutopayConfig(
      partnerAutopayConfig: $partnerAutopayConfig
    )
  }
`
export type PartnerChangePartnerAutopayConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >

/**
 * __usePartnerChangePartnerAutopayConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangePartnerAutopayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangePartnerAutopayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangePartnerAutopayConfigMutation, { data, loading, error }] = usePartnerChangePartnerAutopayConfigMutation({
 *   variables: {
 *      partnerAutopayConfig: // value for 'partnerAutopayConfig'
 *   },
 * });
 */
export function usePartnerChangePartnerAutopayConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >(PartnerChangePartnerAutopayConfigDocument, options)
}
export type PartnerChangePartnerAutopayConfigMutationHookResult = ReturnType<
  typeof usePartnerChangePartnerAutopayConfigMutation
>
export type PartnerChangePartnerAutopayConfigMutationResult =
  Apollo.MutationResult<PartnerChangePartnerAutopayConfigMutation>
export type PartnerChangePartnerAutopayConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >
export const PartnerCancelScheduledPaymentDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelScheduledPayment($paymentID: UUID!) {
    PartnerCancelScheduledPayment(paymentID: $paymentID)
  }
`
export type PartnerCancelScheduledPaymentMutationFn = Apollo.MutationFunction<
  PartnerCancelScheduledPaymentMutation,
  PartnerCancelScheduledPaymentMutationVariables
>

/**
 * __usePartnerCancelScheduledPaymentMutation__
 *
 * To run a mutation, you first call `usePartnerCancelScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelScheduledPaymentMutation, { data, loading, error }] = usePartnerCancelScheduledPaymentMutation({
 *   variables: {
 *      paymentID: // value for 'paymentID'
 *   },
 * });
 */
export function usePartnerCancelScheduledPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelScheduledPaymentMutation,
    PartnerCancelScheduledPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelScheduledPaymentMutation,
    PartnerCancelScheduledPaymentMutationVariables
  >(PartnerCancelScheduledPaymentDocument, options)
}
export type PartnerCancelScheduledPaymentMutationHookResult = ReturnType<
  typeof usePartnerCancelScheduledPaymentMutation
>
export type PartnerCancelScheduledPaymentMutationResult =
  Apollo.MutationResult<PartnerCancelScheduledPaymentMutation>
export type PartnerCancelScheduledPaymentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCancelScheduledPaymentMutation,
    PartnerCancelScheduledPaymentMutationVariables
  >
export const PartnerReschedulePaymentDocument = /*#__PURE__*/ gql`
  mutation PartnerReschedulePayment($paymentID: UUID!, $newDueDate: Time!) {
    PartnerReschedulePayment(paymentID: $paymentID, newDueDate: $newDueDate)
  }
`
export type PartnerReschedulePaymentMutationFn = Apollo.MutationFunction<
  PartnerReschedulePaymentMutation,
  PartnerReschedulePaymentMutationVariables
>

/**
 * __usePartnerReschedulePaymentMutation__
 *
 * To run a mutation, you first call `usePartnerReschedulePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerReschedulePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerReschedulePaymentMutation, { data, loading, error }] = usePartnerReschedulePaymentMutation({
 *   variables: {
 *      paymentID: // value for 'paymentID'
 *      newDueDate: // value for 'newDueDate'
 *   },
 * });
 */
export function usePartnerReschedulePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerReschedulePaymentMutation,
    PartnerReschedulePaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerReschedulePaymentMutation,
    PartnerReschedulePaymentMutationVariables
  >(PartnerReschedulePaymentDocument, options)
}
export type PartnerReschedulePaymentMutationHookResult = ReturnType<
  typeof usePartnerReschedulePaymentMutation
>
export type PartnerReschedulePaymentMutationResult =
  Apollo.MutationResult<PartnerReschedulePaymentMutation>
export type PartnerReschedulePaymentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerReschedulePaymentMutation,
    PartnerReschedulePaymentMutationVariables
  >
export const PartnerPaymentConnectionDocument = /*#__PURE__*/ gql`
  query PartnerPaymentConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $paymentFilter: PaymentFilter
    $orderBy: PaymentOrder
  ) {
    PartnerPaymentConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      paymentFilter: $paymentFilter
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerPayment
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${PartnerPaymentFragmentDoc}
`

/**
 * __usePartnerPaymentConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerPaymentConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPaymentConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPaymentConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      paymentFilter: // value for 'paymentFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerPaymentConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >(PartnerPaymentConnectionDocument, options)
}
export function usePartnerPaymentConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >(PartnerPaymentConnectionDocument, options)
}
export type PartnerPaymentConnectionQueryHookResult = ReturnType<
  typeof usePartnerPaymentConnectionQuery
>
export type PartnerPaymentConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerPaymentConnectionLazyQuery
>
export type PartnerPaymentConnectionQueryResult = Apollo.QueryResult<
  PartnerPaymentConnectionQuery,
  PartnerPaymentConnectionQueryVariables
>
export const PartnerListPaymentsDocument = /*#__PURE__*/ gql`
  query PartnerListPayments(
    $paymentFilter: PaymentFilter
    $pagination: Pagination!
    $orderBy: PaymentOrder
  ) {
    PartnerListPayments(
      paymentFilter: $paymentFilter
      pagination: $pagination
      orderBy: $orderBy
    ) {
      data {
        ...PartnerPayment
      }
      total
      limit
      page
    }
  }
  ${PartnerPaymentFragmentDoc}
`

/**
 * __usePartnerListPaymentsQuery__
 *
 * To run a query within a React component, call `usePartnerListPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListPaymentsQuery({
 *   variables: {
 *      paymentFilter: // value for 'paymentFilter'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerListPaymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListPaymentsQuery,
    PartnerListPaymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListPaymentsQuery,
    PartnerListPaymentsQueryVariables
  >(PartnerListPaymentsDocument, options)
}
export function usePartnerListPaymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListPaymentsQuery,
    PartnerListPaymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListPaymentsQuery,
    PartnerListPaymentsQueryVariables
  >(PartnerListPaymentsDocument, options)
}
export type PartnerListPaymentsQueryHookResult = ReturnType<
  typeof usePartnerListPaymentsQuery
>
export type PartnerListPaymentsLazyQueryHookResult = ReturnType<
  typeof usePartnerListPaymentsLazyQuery
>
export type PartnerListPaymentsQueryResult = Apollo.QueryResult<
  PartnerListPaymentsQuery,
  PartnerListPaymentsQueryVariables
>
export const PartnerPaymentTotalsDocument = /*#__PURE__*/ gql`
  query PartnerPaymentTotals($paymentFilter: PaymentFilter) {
    PartnerPaymentTotals(paymentFilter: $paymentFilter) {
      count
      amount
      netAmount
    }
  }
`

/**
 * __usePartnerPaymentTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerPaymentTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPaymentTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPaymentTotalsQuery({
 *   variables: {
 *      paymentFilter: // value for 'paymentFilter'
 *   },
 * });
 */
export function usePartnerPaymentTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >(PartnerPaymentTotalsDocument, options)
}
export function usePartnerPaymentTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >(PartnerPaymentTotalsDocument, options)
}
export type PartnerPaymentTotalsQueryHookResult = ReturnType<
  typeof usePartnerPaymentTotalsQuery
>
export type PartnerPaymentTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerPaymentTotalsLazyQuery
>
export type PartnerPaymentTotalsQueryResult = Apollo.QueryResult<
  PartnerPaymentTotalsQuery,
  PartnerPaymentTotalsQueryVariables
>
export const PartnerCalculatePaymentFeeDocument = /*#__PURE__*/ gql`
  query PartnerCalculatePaymentFee($input: CalculatePaymentFeeInput!) {
    PartnerCalculatePaymentFee(input: $input) {
      relativeFeeAmountCustomer
      fixedFeeAmountCustomer
      relativeFeeAmountPartner
      fixedFeeAmountPartner
      feePercentageForCustomer
      feePercentageForPartner
    }
  }
`

/**
 * __usePartnerCalculatePaymentFeeQuery__
 *
 * To run a query within a React component, call `usePartnerCalculatePaymentFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCalculatePaymentFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCalculatePaymentFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCalculatePaymentFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerCalculatePaymentFeeQuery,
    PartnerCalculatePaymentFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCalculatePaymentFeeQuery,
    PartnerCalculatePaymentFeeQueryVariables
  >(PartnerCalculatePaymentFeeDocument, options)
}
export function usePartnerCalculatePaymentFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCalculatePaymentFeeQuery,
    PartnerCalculatePaymentFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCalculatePaymentFeeQuery,
    PartnerCalculatePaymentFeeQueryVariables
  >(PartnerCalculatePaymentFeeDocument, options)
}
export type PartnerCalculatePaymentFeeQueryHookResult = ReturnType<
  typeof usePartnerCalculatePaymentFeeQuery
>
export type PartnerCalculatePaymentFeeLazyQueryHookResult = ReturnType<
  typeof usePartnerCalculatePaymentFeeLazyQuery
>
export type PartnerCalculatePaymentFeeQueryResult = Apollo.QueryResult<
  PartnerCalculatePaymentFeeQuery,
  PartnerCalculatePaymentFeeQueryVariables
>
export const PartnerGetCustomerPaymentConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomerPaymentConfig($customerID: ID!) {
    PartnerGetCustomerPaymentConfig(customerID: $customerID) {
      ...CustomerPaymentMethod
    }
  }
  ${CustomerPaymentMethodFragmentDoc}
`

/**
 * __usePartnerGetCustomerPaymentConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomerPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerPaymentConfigQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerGetCustomerPaymentConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >(PartnerGetCustomerPaymentConfigDocument, options)
}
export function usePartnerGetCustomerPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >(PartnerGetCustomerPaymentConfigDocument, options)
}
export type PartnerGetCustomerPaymentConfigQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerPaymentConfigQuery
>
export type PartnerGetCustomerPaymentConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerPaymentConfigLazyQuery
>
export type PartnerGetCustomerPaymentConfigQueryResult = Apollo.QueryResult<
  PartnerGetCustomerPaymentConfigQuery,
  PartnerGetCustomerPaymentConfigQueryVariables
>
export const PartnerGetCustomersPaymentConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomersPaymentConfig($customerIDs: [ID!]) {
    PartnerGetCustomersPaymentConfig(customerIDs: $customerIDs) {
      ...CustomersPaymentMethod
    }
  }
  ${CustomersPaymentMethodFragmentDoc}
`

/**
 * __usePartnerGetCustomersPaymentConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomersPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomersPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomersPaymentConfigQuery({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerGetCustomersPaymentConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >(PartnerGetCustomersPaymentConfigDocument, options)
}
export function usePartnerGetCustomersPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >(PartnerGetCustomersPaymentConfigDocument, options)
}
export type PartnerGetCustomersPaymentConfigQueryHookResult = ReturnType<
  typeof usePartnerGetCustomersPaymentConfigQuery
>
export type PartnerGetCustomersPaymentConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomersPaymentConfigLazyQuery
>
export type PartnerGetCustomersPaymentConfigQueryResult = Apollo.QueryResult<
  PartnerGetCustomersPaymentConfigQuery,
  PartnerGetCustomersPaymentConfigQueryVariables
>
export const PartnerGetPaymentConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetPaymentConfig {
    PartnerGetPaymentConfig {
      ...PaymentConfig
    }
  }
  ${PaymentConfigFragmentDoc}
`

/**
 * __usePartnerGetPaymentConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPaymentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetPaymentConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >(PartnerGetPaymentConfigDocument, options)
}
export function usePartnerGetPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >(PartnerGetPaymentConfigDocument, options)
}
export type PartnerGetPaymentConfigQueryHookResult = ReturnType<
  typeof usePartnerGetPaymentConfigQuery
>
export type PartnerGetPaymentConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPaymentConfigLazyQuery
>
export type PartnerGetPaymentConfigQueryResult = Apollo.QueryResult<
  PartnerGetPaymentConfigQuery,
  PartnerGetPaymentConfigQueryVariables
>
export const PartnerChangePaymentConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangePaymentConfig(
    $paymentConfig: PaymentCompanyConfigUpdateInput!
  ) {
    PartnerChangePaymentConfig(paymentConfig: $paymentConfig)
  }
`
export type PartnerChangePaymentConfigMutationFn = Apollo.MutationFunction<
  PartnerChangePaymentConfigMutation,
  PartnerChangePaymentConfigMutationVariables
>

/**
 * __usePartnerChangePaymentConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangePaymentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangePaymentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangePaymentConfigMutation, { data, loading, error }] = usePartnerChangePaymentConfigMutation({
 *   variables: {
 *      paymentConfig: // value for 'paymentConfig'
 *   },
 * });
 */
export function usePartnerChangePaymentConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangePaymentConfigMutation,
    PartnerChangePaymentConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangePaymentConfigMutation,
    PartnerChangePaymentConfigMutationVariables
  >(PartnerChangePaymentConfigDocument, options)
}
export type PartnerChangePaymentConfigMutationHookResult = ReturnType<
  typeof usePartnerChangePaymentConfigMutation
>
export type PartnerChangePaymentConfigMutationResult =
  Apollo.MutationResult<PartnerChangePaymentConfigMutation>
export type PartnerChangePaymentConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangePaymentConfigMutation,
    PartnerChangePaymentConfigMutationVariables
  >
export const PartnerChangeCustomerPaymentConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeCustomerPaymentConfig(
    $paymentConfig: PaymentCompanyConfigUpdateInput!
    $customerID: ID!
  ) {
    PartnerChangeCustomerPaymentConfig(
      paymentConfig: $paymentConfig
      customerID: $customerID
    )
  }
`
export type PartnerChangeCustomerPaymentConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >

/**
 * __usePartnerChangeCustomerPaymentConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeCustomerPaymentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeCustomerPaymentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeCustomerPaymentConfigMutation, { data, loading, error }] = usePartnerChangeCustomerPaymentConfigMutation({
 *   variables: {
 *      paymentConfig: // value for 'paymentConfig'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerChangeCustomerPaymentConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >(PartnerChangeCustomerPaymentConfigDocument, options)
}
export type PartnerChangeCustomerPaymentConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeCustomerPaymentConfigMutation
>
export type PartnerChangeCustomerPaymentConfigMutationResult =
  Apollo.MutationResult<PartnerChangeCustomerPaymentConfigMutation>
export type PartnerChangeCustomerPaymentConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >
export const GetLogoUploadUrlDocument = /*#__PURE__*/ gql`
  query GetLogoUploadURL {
    PartnerLogoUploadURL {
      uploadURL
      uploadCDNURL
      uploadURLExpirationUTC
    }
  }
`

/**
 * __useGetLogoUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetLogoUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogoUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogoUploadUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLogoUploadUrlQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLogoUploadUrlQuery,
    GetLogoUploadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLogoUploadUrlQuery, GetLogoUploadUrlQueryVariables>(
    GetLogoUploadUrlDocument,
    options
  )
}
export function useGetLogoUploadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLogoUploadUrlQuery,
    GetLogoUploadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetLogoUploadUrlQuery,
    GetLogoUploadUrlQueryVariables
  >(GetLogoUploadUrlDocument, options)
}
export type GetLogoUploadUrlQueryHookResult = ReturnType<
  typeof useGetLogoUploadUrlQuery
>
export type GetLogoUploadUrlLazyQueryHookResult = ReturnType<
  typeof useGetLogoUploadUrlLazyQuery
>
export type GetLogoUploadUrlQueryResult = Apollo.QueryResult<
  GetLogoUploadUrlQuery,
  GetLogoUploadUrlQueryVariables
>
export const PartnerUpdatePaymentsPortalMethodsDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdatePaymentsPortalMethods(
    $methods: [PartnerPaymentsPortalMethod!]!
  ) {
    PartnerUpdatePaymentsPortalMethods(methods: $methods) {
      id
      paymentsPortalMethods
    }
  }
`
export type PartnerUpdatePaymentsPortalMethodsMutationFn =
  Apollo.MutationFunction<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >

/**
 * __usePartnerUpdatePaymentsPortalMethodsMutation__
 *
 * To run a mutation, you first call `usePartnerUpdatePaymentsPortalMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdatePaymentsPortalMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdatePaymentsPortalMethodsMutation, { data, loading, error }] = usePartnerUpdatePaymentsPortalMethodsMutation({
 *   variables: {
 *      methods: // value for 'methods'
 *   },
 * });
 */
export function usePartnerUpdatePaymentsPortalMethodsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >(PartnerUpdatePaymentsPortalMethodsDocument, options)
}
export type PartnerUpdatePaymentsPortalMethodsMutationHookResult = ReturnType<
  typeof usePartnerUpdatePaymentsPortalMethodsMutation
>
export type PartnerUpdatePaymentsPortalMethodsMutationResult =
  Apollo.MutationResult<PartnerUpdatePaymentsPortalMethodsMutation>
export type PartnerUpdatePaymentsPortalMethodsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >
export const PartnerUpdatePaymentsPortalCustomizationDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdatePaymentsPortalCustomization(
    $input: PartnerPaymentsPortalCustomizationInput
  ) {
    PartnerUpdatePaymentsPortalCustomization(input: $input) {
      id
      paymentsPortalCustomization {
        color
        logoUrl
      }
    }
  }
`
export type PartnerUpdatePaymentsPortalCustomizationMutationFn =
  Apollo.MutationFunction<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >

/**
 * __usePartnerUpdatePaymentsPortalCustomizationMutation__
 *
 * To run a mutation, you first call `usePartnerUpdatePaymentsPortalCustomizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdatePaymentsPortalCustomizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdatePaymentsPortalCustomizationMutation, { data, loading, error }] = usePartnerUpdatePaymentsPortalCustomizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdatePaymentsPortalCustomizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >(PartnerUpdatePaymentsPortalCustomizationDocument, options)
}
export type PartnerUpdatePaymentsPortalCustomizationMutationHookResult =
  ReturnType<typeof usePartnerUpdatePaymentsPortalCustomizationMutation>
export type PartnerUpdatePaymentsPortalCustomizationMutationResult =
  Apollo.MutationResult<PartnerUpdatePaymentsPortalCustomizationMutation>
export type PartnerUpdatePaymentsPortalCustomizationMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >
export const StagingEnablePartnerPaymentsPortalDocument = /*#__PURE__*/ gql`
  mutation StagingEnablePartnerPaymentsPortal($url: String!) {
    StagingEnablePartnerPaymentsPortal(url: $url) {
      id
      name
      paymentsPortalEnabled
      paymentsPortalUrl
    }
  }
`
export type StagingEnablePartnerPaymentsPortalMutationFn =
  Apollo.MutationFunction<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >

/**
 * __useStagingEnablePartnerPaymentsPortalMutation__
 *
 * To run a mutation, you first call `useStagingEnablePartnerPaymentsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStagingEnablePartnerPaymentsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stagingEnablePartnerPaymentsPortalMutation, { data, loading, error }] = useStagingEnablePartnerPaymentsPortalMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useStagingEnablePartnerPaymentsPortalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >(StagingEnablePartnerPaymentsPortalDocument, options)
}
export type StagingEnablePartnerPaymentsPortalMutationHookResult = ReturnType<
  typeof useStagingEnablePartnerPaymentsPortalMutation
>
export type StagingEnablePartnerPaymentsPortalMutationResult =
  Apollo.MutationResult<StagingEnablePartnerPaymentsPortalMutation>
export type StagingEnablePartnerPaymentsPortalMutationOptions =
  Apollo.BaseMutationOptions<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >
export const PartnerPayoutConnectionDocument = /*#__PURE__*/ gql`
  query PartnerPayoutConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $payoutFilter: PayoutFilter
    $orderBy: PayoutOrder
  ) {
    PartnerPayoutConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      payoutFilter: $payoutFilter
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerPayout
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerPayoutFragmentDoc}
`

/**
 * __usePartnerPayoutConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerPayoutConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayoutConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPayoutConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      payoutFilter: // value for 'payoutFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerPayoutConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >(PartnerPayoutConnectionDocument, options)
}
export function usePartnerPayoutConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >(PartnerPayoutConnectionDocument, options)
}
export type PartnerPayoutConnectionQueryHookResult = ReturnType<
  typeof usePartnerPayoutConnectionQuery
>
export type PartnerPayoutConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerPayoutConnectionLazyQuery
>
export type PartnerPayoutConnectionQueryResult = Apollo.QueryResult<
  PartnerPayoutConnectionQuery,
  PartnerPayoutConnectionQueryVariables
>
export const PartnerPayoutTotalsDocument = /*#__PURE__*/ gql`
  query PartnerPayoutTotals($payoutFilter: PayoutFilter) {
    PartnerPayoutTotals(payoutFilter: $payoutFilter) {
      count
      amount
    }
  }
`

/**
 * __usePartnerPayoutTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerPayoutTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayoutTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPayoutTotalsQuery({
 *   variables: {
 *      payoutFilter: // value for 'payoutFilter'
 *   },
 * });
 */
export function usePartnerPayoutTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >(PartnerPayoutTotalsDocument, options)
}
export function usePartnerPayoutTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >(PartnerPayoutTotalsDocument, options)
}
export type PartnerPayoutTotalsQueryHookResult = ReturnType<
  typeof usePartnerPayoutTotalsQuery
>
export type PartnerPayoutTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerPayoutTotalsLazyQuery
>
export type PartnerPayoutTotalsQueryResult = Apollo.QueryResult<
  PartnerPayoutTotalsQuery,
  PartnerPayoutTotalsQueryVariables
>
export const PartnerPayoutDetailsDocument = /*#__PURE__*/ gql`
  query PartnerPayoutDetails($payoutID: ID!) {
    PartnerPayoutDetails(payoutID: $payoutID) {
      ...PartnerPayoutDetails
    }
  }
  ${PartnerPayoutDetailsFragmentDoc}
`

/**
 * __usePartnerPayoutDetailsQuery__
 *
 * To run a query within a React component, call `usePartnerPayoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPayoutDetailsQuery({
 *   variables: {
 *      payoutID: // value for 'payoutID'
 *   },
 * });
 */
export function usePartnerPayoutDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >(PartnerPayoutDetailsDocument, options)
}
export function usePartnerPayoutDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >(PartnerPayoutDetailsDocument, options)
}
export type PartnerPayoutDetailsQueryHookResult = ReturnType<
  typeof usePartnerPayoutDetailsQuery
>
export type PartnerPayoutDetailsLazyQueryHookResult = ReturnType<
  typeof usePartnerPayoutDetailsLazyQuery
>
export type PartnerPayoutDetailsQueryResult = Apollo.QueryResult<
  PartnerPayoutDetailsQuery,
  PartnerPayoutDetailsQueryVariables
>
export const PartnerBreakdownListItemConnectionDocument = /*#__PURE__*/ gql`
  query PartnerBreakdownListItemConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $breakdownFilter: BreakdownFilter
  ) {
    PartnerPayoutBreakdownListItemConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      breakdownFilter: $breakdownFilter
    ) {
      edges {
        node {
          ...PartnerBreakdownListItem
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerBreakdownListItemFragmentDoc}
`

/**
 * __usePartnerBreakdownListItemConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerBreakdownListItemConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerBreakdownListItemConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerBreakdownListItemConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      breakdownFilter: // value for 'breakdownFilter'
 *   },
 * });
 */
export function usePartnerBreakdownListItemConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >(PartnerBreakdownListItemConnectionDocument, options)
}
export function usePartnerBreakdownListItemConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >(PartnerBreakdownListItemConnectionDocument, options)
}
export type PartnerBreakdownListItemConnectionQueryHookResult = ReturnType<
  typeof usePartnerBreakdownListItemConnectionQuery
>
export type PartnerBreakdownListItemConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerBreakdownListItemConnectionLazyQuery
>
export type PartnerBreakdownListItemConnectionQueryResult = Apollo.QueryResult<
  PartnerBreakdownListItemConnectionQuery,
  PartnerBreakdownListItemConnectionQueryVariables
>
export const GetPayoutConfigDocument = /*#__PURE__*/ gql`
  query GetPayoutConfig {
    PartnerGetPayoutConfig {
      id
      defaultBankingAccount {
        id
      }
    }
  }
`

/**
 * __useGetPayoutConfigQuery__
 *
 * To run a query within a React component, call `useGetPayoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutConfigQuery,
    GetPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPayoutConfigQuery, GetPayoutConfigQueryVariables>(
    GetPayoutConfigDocument,
    options
  )
}
export function useGetPayoutConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutConfigQuery,
    GetPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPayoutConfigQuery,
    GetPayoutConfigQueryVariables
  >(GetPayoutConfigDocument, options)
}
export type GetPayoutConfigQueryHookResult = ReturnType<
  typeof useGetPayoutConfigQuery
>
export type GetPayoutConfigLazyQueryHookResult = ReturnType<
  typeof useGetPayoutConfigLazyQuery
>
export type GetPayoutConfigQueryResult = Apollo.QueryResult<
  GetPayoutConfigQuery,
  GetPayoutConfigQueryVariables
>
export const GetReferralPayoutConfigDocument = /*#__PURE__*/ gql`
  query GetReferralPayoutConfig {
    PartnerGetPayoutConfig {
      id
      referralBankingAccount {
        id
      }
      defaultBankingAccount {
        id
      }
    }
  }
`

/**
 * __useGetReferralPayoutConfigQuery__
 *
 * To run a query within a React component, call `useGetReferralPayoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralPayoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralPayoutConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferralPayoutConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >(GetReferralPayoutConfigDocument, options)
}
export function useGetReferralPayoutConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >(GetReferralPayoutConfigDocument, options)
}
export type GetReferralPayoutConfigQueryHookResult = ReturnType<
  typeof useGetReferralPayoutConfigQuery
>
export type GetReferralPayoutConfigLazyQueryHookResult = ReturnType<
  typeof useGetReferralPayoutConfigLazyQuery
>
export type GetReferralPayoutConfigQueryResult = Apollo.QueryResult<
  GetReferralPayoutConfigQuery,
  GetReferralPayoutConfigQueryVariables
>
export const GetPayoutTimingConfigDocument = /*#__PURE__*/ gql`
  query GetPayoutTimingConfig {
    PartnerGetPayoutTimingCompanyConfig {
      activeConfig {
        canCompanyChange
        effectiveAt
        activatedAt
        payoutTimingPlanID
        businessDaysToHold
        payoutTimingFee {
          fixedFee
          percentageFee
          capFee
        }
      }
      upcomingConfig {
        canCompanyChange
        effectiveAt
        activatedAt
        payoutTimingPlanID
        businessDaysToHold
        payoutTimingFee {
          fixedFee
          percentageFee
          capFee
        }
      }
    }
    PartnerGetPayoutTimingPlans {
      id
      businessDaysToHold
      payoutTimingFee {
        fixedFee
        percentageFee
        capFee
      }
    }
  }
`

/**
 * __useGetPayoutTimingConfigQuery__
 *
 * To run a query within a React component, call `useGetPayoutTimingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutTimingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutTimingConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutTimingConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >(GetPayoutTimingConfigDocument, options)
}
export function useGetPayoutTimingConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >(GetPayoutTimingConfigDocument, options)
}
export type GetPayoutTimingConfigQueryHookResult = ReturnType<
  typeof useGetPayoutTimingConfigQuery
>
export type GetPayoutTimingConfigLazyQueryHookResult = ReturnType<
  typeof useGetPayoutTimingConfigLazyQuery
>
export type GetPayoutTimingConfigQueryResult = Apollo.QueryResult<
  GetPayoutTimingConfigQuery,
  GetPayoutTimingConfigQueryVariables
>
export const UpdatePayoutTimingConfigDocument = /*#__PURE__*/ gql`
  mutation UpdatePayoutTimingConfig($planID: ID!) {
    PartnerPayoutTimingUpsertCompanyConfig(planId: $planID)
  }
`
export type UpdatePayoutTimingConfigMutationFn = Apollo.MutationFunction<
  UpdatePayoutTimingConfigMutation,
  UpdatePayoutTimingConfigMutationVariables
>

/**
 * __useUpdatePayoutTimingConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutTimingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutTimingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutTimingConfigMutation, { data, loading, error }] = useUpdatePayoutTimingConfigMutation({
 *   variables: {
 *      planID: // value for 'planID'
 *   },
 * });
 */
export function useUpdatePayoutTimingConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePayoutTimingConfigMutation,
    UpdatePayoutTimingConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePayoutTimingConfigMutation,
    UpdatePayoutTimingConfigMutationVariables
  >(UpdatePayoutTimingConfigDocument, options)
}
export type UpdatePayoutTimingConfigMutationHookResult = ReturnType<
  typeof useUpdatePayoutTimingConfigMutation
>
export type UpdatePayoutTimingConfigMutationResult =
  Apollo.MutationResult<UpdatePayoutTimingConfigMutation>
export type UpdatePayoutTimingConfigMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePayoutTimingConfigMutation,
    UpdatePayoutTimingConfigMutationVariables
  >
export const PartnerListPendingCustomerUsersTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListPendingCustomerUsersTotals {
    PartnerListPendingCustomerUsersTotals {
      count
    }
  }
`

/**
 * __usePartnerListPendingCustomerUsersTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListPendingCustomerUsersTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListPendingCustomerUsersTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListPendingCustomerUsersTotalsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListPendingCustomerUsersTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >(PartnerListPendingCustomerUsersTotalsDocument, options)
}
export function usePartnerListPendingCustomerUsersTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >(PartnerListPendingCustomerUsersTotalsDocument, options)
}
export type PartnerListPendingCustomerUsersTotalsQueryHookResult = ReturnType<
  typeof usePartnerListPendingCustomerUsersTotalsQuery
>
export type PartnerListPendingCustomerUsersTotalsLazyQueryHookResult =
  ReturnType<typeof usePartnerListPendingCustomerUsersTotalsLazyQuery>
export type PartnerListPendingCustomerUsersTotalsQueryResult =
  Apollo.QueryResult<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >
export const PartnerPendingCustomerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerPendingCustomerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: PendingCustomerUserFilters
    $orderBy: PendingCustomerUserOrderBy
  ) {
    PartnerPendingCustomerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerListPendingCustomerUser
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`

/**
 * __usePartnerPendingCustomerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerPendingCustomerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPendingCustomerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPendingCustomerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerPendingCustomerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >(PartnerPendingCustomerUserConnectionDocument, options)
}
export function usePartnerPendingCustomerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >(PartnerPendingCustomerUserConnectionDocument, options)
}
export type PartnerPendingCustomerUserConnectionQueryHookResult = ReturnType<
  typeof usePartnerPendingCustomerUserConnectionQuery
>
export type PartnerPendingCustomerUserConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerPendingCustomerUserConnectionLazyQuery>
export type PartnerPendingCustomerUserConnectionQueryResult =
  Apollo.QueryResult<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >
export const PartnerRejectPendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerRejectPendingCustomerUser($id: ID!) {
    PartnerRejectPendingCustomerUser(id: $id) {
      ...PartnerListPendingCustomerUser
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`
export type PartnerRejectPendingCustomerUserMutationFn =
  Apollo.MutationFunction<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >

/**
 * __usePartnerRejectPendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerRejectPendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRejectPendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRejectPendingCustomerUserMutation, { data, loading, error }] = usePartnerRejectPendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerRejectPendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >(PartnerRejectPendingCustomerUserDocument, options)
}
export type PartnerRejectPendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerRejectPendingCustomerUserMutation
>
export type PartnerRejectPendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerRejectPendingCustomerUserMutation>
export type PartnerRejectPendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >
export const PartnerApprovePendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerApprovePendingCustomerUser($id: ID!) {
    PartnerApprovePendingCustomerUser(id: $id) {
      id
    }
  }
`
export type PartnerApprovePendingCustomerUserMutationFn =
  Apollo.MutationFunction<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >

/**
 * __usePartnerApprovePendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerApprovePendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerApprovePendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerApprovePendingCustomerUserMutation, { data, loading, error }] = usePartnerApprovePendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerApprovePendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >(PartnerApprovePendingCustomerUserDocument, options)
}
export type PartnerApprovePendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerApprovePendingCustomerUserMutation
>
export type PartnerApprovePendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerApprovePendingCustomerUserMutation>
export type PartnerApprovePendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >
export const PartnerLinkPendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerLinkPendingCustomerUser($id: ID!, $customerId: ID!) {
    PartnerLinkPendingCustomerUser(id: $id, customerId: $customerId) {
      ...PartnerListPendingCustomerUser
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`
export type PartnerLinkPendingCustomerUserMutationFn = Apollo.MutationFunction<
  PartnerLinkPendingCustomerUserMutation,
  PartnerLinkPendingCustomerUserMutationVariables
>

/**
 * __usePartnerLinkPendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerLinkPendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerLinkPendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerLinkPendingCustomerUserMutation, { data, loading, error }] = usePartnerLinkPendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function usePartnerLinkPendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerLinkPendingCustomerUserMutation,
    PartnerLinkPendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerLinkPendingCustomerUserMutation,
    PartnerLinkPendingCustomerUserMutationVariables
  >(PartnerLinkPendingCustomerUserDocument, options)
}
export type PartnerLinkPendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerLinkPendingCustomerUserMutation
>
export type PartnerLinkPendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerLinkPendingCustomerUserMutation>
export type PartnerLinkPendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerLinkPendingCustomerUserMutation,
    PartnerLinkPendingCustomerUserMutationVariables
  >
export const PartnerUnlinkPendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerUnlinkPendingCustomerUser($id: ID!, $customerId: ID!) {
    PartnerUnlinkPendingCustomerUser(id: $id, customerId: $customerId) {
      ...PartnerListPendingCustomerUser
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`
export type PartnerUnlinkPendingCustomerUserMutationFn =
  Apollo.MutationFunction<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >

/**
 * __usePartnerUnlinkPendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerUnlinkPendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUnlinkPendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUnlinkPendingCustomerUserMutation, { data, loading, error }] = usePartnerUnlinkPendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function usePartnerUnlinkPendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >(PartnerUnlinkPendingCustomerUserDocument, options)
}
export type PartnerUnlinkPendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerUnlinkPendingCustomerUserMutation
>
export type PartnerUnlinkPendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerUnlinkPendingCustomerUserMutation>
export type PartnerUnlinkPendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >
export const PartnerRecurringPaymentConnectionDocument = /*#__PURE__*/ gql`
  query PartnerRecurringPaymentConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: RecurringPaymentFilter
    $orderBy: RecurringPaymentOrderBy
  ) {
    PartnerRecurringPaymentConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerRecurringPayment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerRecurringPaymentFragmentDoc}
`

/**
 * __usePartnerRecurringPaymentConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerRecurringPaymentConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRecurringPaymentConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRecurringPaymentConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerRecurringPaymentConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >(PartnerRecurringPaymentConnectionDocument, options)
}
export function usePartnerRecurringPaymentConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >(PartnerRecurringPaymentConnectionDocument, options)
}
export type PartnerRecurringPaymentConnectionQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentConnectionQuery
>
export type PartnerRecurringPaymentConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentConnectionLazyQuery
>
export type PartnerRecurringPaymentConnectionQueryResult = Apollo.QueryResult<
  PartnerRecurringPaymentConnectionQuery,
  PartnerRecurringPaymentConnectionQueryVariables
>
export const PartnerRecurringPaymentTotalsDocument = /*#__PURE__*/ gql`
  query PartnerRecurringPaymentTotals($filters: RecurringPaymentFilter) {
    PartnerRecurringPaymentTotals(filters: $filters) {
      count
      amount
    }
  }
`

/**
 * __usePartnerRecurringPaymentTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerRecurringPaymentTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRecurringPaymentTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRecurringPaymentTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerRecurringPaymentTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >(PartnerRecurringPaymentTotalsDocument, options)
}
export function usePartnerRecurringPaymentTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >(PartnerRecurringPaymentTotalsDocument, options)
}
export type PartnerRecurringPaymentTotalsQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentTotalsQuery
>
export type PartnerRecurringPaymentTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentTotalsLazyQuery
>
export type PartnerRecurringPaymentTotalsQueryResult = Apollo.QueryResult<
  PartnerRecurringPaymentTotalsQuery,
  PartnerRecurringPaymentTotalsQueryVariables
>
export const RecurringPaymentCreateDocument = /*#__PURE__*/ gql`
  mutation RecurringPaymentCreate($input: RecurringPaymentCreateInput!) {
    PartnerRecurringPaymentCreate(input: $input) {
      ...PartnerRecurringPayment
    }
  }
  ${PartnerRecurringPaymentFragmentDoc}
`
export type RecurringPaymentCreateMutationFn = Apollo.MutationFunction<
  RecurringPaymentCreateMutation,
  RecurringPaymentCreateMutationVariables
>

/**
 * __useRecurringPaymentCreateMutation__
 *
 * To run a mutation, you first call `useRecurringPaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringPaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringPaymentCreateMutation, { data, loading, error }] = useRecurringPaymentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringPaymentCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecurringPaymentCreateMutation,
    RecurringPaymentCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecurringPaymentCreateMutation,
    RecurringPaymentCreateMutationVariables
  >(RecurringPaymentCreateDocument, options)
}
export type RecurringPaymentCreateMutationHookResult = ReturnType<
  typeof useRecurringPaymentCreateMutation
>
export type RecurringPaymentCreateMutationResult =
  Apollo.MutationResult<RecurringPaymentCreateMutation>
export type RecurringPaymentCreateMutationOptions = Apollo.BaseMutationOptions<
  RecurringPaymentCreateMutation,
  RecurringPaymentCreateMutationVariables
>
export const RecurringPaymentDeactivateDocument = /*#__PURE__*/ gql`
  mutation RecurringPaymentDeactivate(
    $input: RecurringPaymentDeactivateInput!
  ) {
    PartnerRecurringPaymentDeactivate(input: $input)
  }
`
export type RecurringPaymentDeactivateMutationFn = Apollo.MutationFunction<
  RecurringPaymentDeactivateMutation,
  RecurringPaymentDeactivateMutationVariables
>

/**
 * __useRecurringPaymentDeactivateMutation__
 *
 * To run a mutation, you first call `useRecurringPaymentDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringPaymentDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringPaymentDeactivateMutation, { data, loading, error }] = useRecurringPaymentDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringPaymentDeactivateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecurringPaymentDeactivateMutation,
    RecurringPaymentDeactivateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecurringPaymentDeactivateMutation,
    RecurringPaymentDeactivateMutationVariables
  >(RecurringPaymentDeactivateDocument, options)
}
export type RecurringPaymentDeactivateMutationHookResult = ReturnType<
  typeof useRecurringPaymentDeactivateMutation
>
export type RecurringPaymentDeactivateMutationResult =
  Apollo.MutationResult<RecurringPaymentDeactivateMutation>
export type RecurringPaymentDeactivateMutationOptions =
  Apollo.BaseMutationOptions<
    RecurringPaymentDeactivateMutation,
    RecurringPaymentDeactivateMutationVariables
  >
export const RecurringPaymentUpdateDocument = /*#__PURE__*/ gql`
  mutation RecurringPaymentUpdate($input: RecurringPaymentUpdateInput!) {
    PartnerRecurringPaymentUpdate(input: $input)
  }
`
export type RecurringPaymentUpdateMutationFn = Apollo.MutationFunction<
  RecurringPaymentUpdateMutation,
  RecurringPaymentUpdateMutationVariables
>

/**
 * __useRecurringPaymentUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringPaymentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringPaymentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringPaymentUpdateMutation, { data, loading, error }] = useRecurringPaymentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringPaymentUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecurringPaymentUpdateMutation,
    RecurringPaymentUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecurringPaymentUpdateMutation,
    RecurringPaymentUpdateMutationVariables
  >(RecurringPaymentUpdateDocument, options)
}
export type RecurringPaymentUpdateMutationHookResult = ReturnType<
  typeof useRecurringPaymentUpdateMutation
>
export type RecurringPaymentUpdateMutationResult =
  Apollo.MutationResult<RecurringPaymentUpdateMutation>
export type RecurringPaymentUpdateMutationOptions = Apollo.BaseMutationOptions<
  RecurringPaymentUpdateMutation,
  RecurringPaymentUpdateMutationVariables
>
export const PartnerReferralGetQuarterlyEarningsDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetQuarterlyEarningsData($input: GetReferralDataInput!) {
    PartnerReferralGetQuarterlyEarningsData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetQuarterlyEarningsDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetQuarterlyEarningsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetQuarterlyEarningsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetQuarterlyEarningsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetQuarterlyEarningsDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >(PartnerReferralGetQuarterlyEarningsDataDocument, options)
}
export function usePartnerReferralGetQuarterlyEarningsDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >(PartnerReferralGetQuarterlyEarningsDataDocument, options)
}
export type PartnerReferralGetQuarterlyEarningsDataQueryHookResult = ReturnType<
  typeof usePartnerReferralGetQuarterlyEarningsDataQuery
>
export type PartnerReferralGetQuarterlyEarningsDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetQuarterlyEarningsDataLazyQuery>
export type PartnerReferralGetQuarterlyEarningsDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >
export const PartnerReferralGetAvailableForPayoutDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetAvailableForPayoutData(
    $input: GetReferralDataInput!
  ) {
    PartnerReferralGetAvailableForPayoutData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetAvailableForPayoutDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetAvailableForPayoutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetAvailableForPayoutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetAvailableForPayoutDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetAvailableForPayoutDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >(PartnerReferralGetAvailableForPayoutDataDocument, options)
}
export function usePartnerReferralGetAvailableForPayoutDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >(PartnerReferralGetAvailableForPayoutDataDocument, options)
}
export type PartnerReferralGetAvailableForPayoutDataQueryHookResult =
  ReturnType<typeof usePartnerReferralGetAvailableForPayoutDataQuery>
export type PartnerReferralGetAvailableForPayoutDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetAvailableForPayoutDataLazyQuery>
export type PartnerReferralGetAvailableForPayoutDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >
export const PartnerReferralGetTotalReferralFeesDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetTotalReferralFeesData($input: GetReferralDataInput!) {
    PartnerReferralGetTotalReferralFeesData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetTotalReferralFeesDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetTotalReferralFeesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetTotalReferralFeesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetTotalReferralFeesDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetTotalReferralFeesDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >(PartnerReferralGetTotalReferralFeesDataDocument, options)
}
export function usePartnerReferralGetTotalReferralFeesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >(PartnerReferralGetTotalReferralFeesDataDocument, options)
}
export type PartnerReferralGetTotalReferralFeesDataQueryHookResult = ReturnType<
  typeof usePartnerReferralGetTotalReferralFeesDataQuery
>
export type PartnerReferralGetTotalReferralFeesDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetTotalReferralFeesDataLazyQuery>
export type PartnerReferralGetTotalReferralFeesDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >
export const PartnerReferralGetAvgQuarterlyFeesDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetAvgQuarterlyFeesData($input: GetReferralDataInput!) {
    PartnerReferralGetAvgQuarterlyFeesData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetAvgQuarterlyFeesDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetAvgQuarterlyFeesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetAvgQuarterlyFeesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetAvgQuarterlyFeesDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetAvgQuarterlyFeesDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >(PartnerReferralGetAvgQuarterlyFeesDataDocument, options)
}
export function usePartnerReferralGetAvgQuarterlyFeesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >(PartnerReferralGetAvgQuarterlyFeesDataDocument, options)
}
export type PartnerReferralGetAvgQuarterlyFeesDataQueryHookResult = ReturnType<
  typeof usePartnerReferralGetAvgQuarterlyFeesDataQuery
>
export type PartnerReferralGetAvgQuarterlyFeesDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetAvgQuarterlyFeesDataLazyQuery>
export type PartnerReferralGetAvgQuarterlyFeesDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >
export const PartnerGetReferralLinkDocument = /*#__PURE__*/ gql`
  query PartnerGetReferralLink {
    PartnerGetReferralLink
  }
`

/**
 * __usePartnerGetReferralLinkQuery__
 *
 * To run a query within a React component, call `usePartnerGetReferralLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetReferralLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetReferralLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetReferralLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >(PartnerGetReferralLinkDocument, options)
}
export function usePartnerGetReferralLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >(PartnerGetReferralLinkDocument, options)
}
export type PartnerGetReferralLinkQueryHookResult = ReturnType<
  typeof usePartnerGetReferralLinkQuery
>
export type PartnerGetReferralLinkLazyQueryHookResult = ReturnType<
  typeof usePartnerGetReferralLinkLazyQuery
>
export type PartnerGetReferralLinkQueryResult = Apollo.QueryResult<
  PartnerGetReferralLinkQuery,
  PartnerGetReferralLinkQueryVariables
>
export const PartnerGetReferralPayoutByPayoutIdDocument = /*#__PURE__*/ gql`
  query PartnerGetReferralPayoutByPayoutID($payoutID: ID!) {
    PartnerGetReferralPayoutByPayoutID(payoutID: $payoutID) {
      ...ReferralPayout
    }
  }
  ${ReferralPayoutFragmentDoc}
`

/**
 * __usePartnerGetReferralPayoutByPayoutIdQuery__
 *
 * To run a query within a React component, call `usePartnerGetReferralPayoutByPayoutIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetReferralPayoutByPayoutIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetReferralPayoutByPayoutIdQuery({
 *   variables: {
 *      payoutID: // value for 'payoutID'
 *   },
 * });
 */
export function usePartnerGetReferralPayoutByPayoutIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >(PartnerGetReferralPayoutByPayoutIdDocument, options)
}
export function usePartnerGetReferralPayoutByPayoutIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >(PartnerGetReferralPayoutByPayoutIdDocument, options)
}
export type PartnerGetReferralPayoutByPayoutIdQueryHookResult = ReturnType<
  typeof usePartnerGetReferralPayoutByPayoutIdQuery
>
export type PartnerGetReferralPayoutByPayoutIdLazyQueryHookResult = ReturnType<
  typeof usePartnerGetReferralPayoutByPayoutIdLazyQuery
>
export type PartnerGetReferralPayoutByPayoutIdQueryResult = Apollo.QueryResult<
  PartnerGetReferralPayoutByPayoutIdQuery,
  PartnerGetReferralPayoutByPayoutIdQueryVariables
>
export const PartnerReferralConnectionDocument = /*#__PURE__*/ gql`
  query PartnerReferralConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: ReferralFilter
    $orderBy: ReferralOrderBy
  ) {
    PartnerReferralConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...Referral
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ReferralFragmentDoc}
`

/**
 * __usePartnerReferralConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerReferralConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerReferralConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >(PartnerReferralConnectionDocument, options)
}
export function usePartnerReferralConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >(PartnerReferralConnectionDocument, options)
}
export type PartnerReferralConnectionQueryHookResult = ReturnType<
  typeof usePartnerReferralConnectionQuery
>
export type PartnerReferralConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerReferralConnectionLazyQuery
>
export type PartnerReferralConnectionQueryResult = Apollo.QueryResult<
  PartnerReferralConnectionQuery,
  PartnerReferralConnectionQueryVariables
>
export const PartnerCreateReferralDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateReferral($input: CreateReferralInput!) {
    PartnerCreateReferral(input: $input)
  }
`
export type PartnerCreateReferralMutationFn = Apollo.MutationFunction<
  PartnerCreateReferralMutation,
  PartnerCreateReferralMutationVariables
>

/**
 * __usePartnerCreateReferralMutation__
 *
 * To run a mutation, you first call `usePartnerCreateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateReferralMutation, { data, loading, error }] = usePartnerCreateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateReferralMutation,
    PartnerCreateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateReferralMutation,
    PartnerCreateReferralMutationVariables
  >(PartnerCreateReferralDocument, options)
}
export type PartnerCreateReferralMutationHookResult = ReturnType<
  typeof usePartnerCreateReferralMutation
>
export type PartnerCreateReferralMutationResult =
  Apollo.MutationResult<PartnerCreateReferralMutation>
export type PartnerCreateReferralMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateReferralMutation,
  PartnerCreateReferralMutationVariables
>
export const PartnerUpdateReferralDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateReferral($input: UpdateReferralInput!) {
    PartnerUpdateReferral(input: $input)
  }
`
export type PartnerUpdateReferralMutationFn = Apollo.MutationFunction<
  PartnerUpdateReferralMutation,
  PartnerUpdateReferralMutationVariables
>

/**
 * __usePartnerUpdateReferralMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateReferralMutation, { data, loading, error }] = usePartnerUpdateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateReferralMutation,
    PartnerUpdateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateReferralMutation,
    PartnerUpdateReferralMutationVariables
  >(PartnerUpdateReferralDocument, options)
}
export type PartnerUpdateReferralMutationHookResult = ReturnType<
  typeof usePartnerUpdateReferralMutation
>
export type PartnerUpdateReferralMutationResult =
  Apollo.MutationResult<PartnerUpdateReferralMutation>
export type PartnerUpdateReferralMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateReferralMutation,
  PartnerUpdateReferralMutationVariables
>
export const PartnerSendReferralDocument = /*#__PURE__*/ gql`
  mutation PartnerSendReferral($input: SendPartnerReferralInput!) {
    PartnerSendReferral(input: $input)
  }
`
export type PartnerSendReferralMutationFn = Apollo.MutationFunction<
  PartnerSendReferralMutation,
  PartnerSendReferralMutationVariables
>

/**
 * __usePartnerSendReferralMutation__
 *
 * To run a mutation, you first call `usePartnerSendReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendReferralMutation, { data, loading, error }] = usePartnerSendReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendReferralMutation,
    PartnerSendReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendReferralMutation,
    PartnerSendReferralMutationVariables
  >(PartnerSendReferralDocument, options)
}
export type PartnerSendReferralMutationHookResult = ReturnType<
  typeof usePartnerSendReferralMutation
>
export type PartnerSendReferralMutationResult =
  Apollo.MutationResult<PartnerSendReferralMutation>
export type PartnerSendReferralMutationOptions = Apollo.BaseMutationOptions<
  PartnerSendReferralMutation,
  PartnerSendReferralMutationVariables
>
export const UpdatePartnerReferralLinkDocument = /*#__PURE__*/ gql`
  mutation UpdatePartnerReferralLink($input: UpdateReferralLinkInput!) {
    UpdatePartnerReferralLink(input: $input)
  }
`
export type UpdatePartnerReferralLinkMutationFn = Apollo.MutationFunction<
  UpdatePartnerReferralLinkMutation,
  UpdatePartnerReferralLinkMutationVariables
>

/**
 * __useUpdatePartnerReferralLinkMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerReferralLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerReferralLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerReferralLinkMutation, { data, loading, error }] = useUpdatePartnerReferralLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartnerReferralLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePartnerReferralLinkMutation,
    UpdatePartnerReferralLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePartnerReferralLinkMutation,
    UpdatePartnerReferralLinkMutationVariables
  >(UpdatePartnerReferralLinkDocument, options)
}
export type UpdatePartnerReferralLinkMutationHookResult = ReturnType<
  typeof useUpdatePartnerReferralLinkMutation
>
export type UpdatePartnerReferralLinkMutationResult =
  Apollo.MutationResult<UpdatePartnerReferralLinkMutation>
export type UpdatePartnerReferralLinkMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePartnerReferralLinkMutation,
    UpdatePartnerReferralLinkMutationVariables
  >
export const PartnerGetReferralLinkInfoDocument = /*#__PURE__*/ gql`
  query PartnerGetReferralLinkInfo {
    PartnerGetReferralLinkInfo {
      sendLinkToOutgoingEmails
      url
    }
  }
`

/**
 * __usePartnerGetReferralLinkInfoQuery__
 *
 * To run a query within a React component, call `usePartnerGetReferralLinkInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetReferralLinkInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetReferralLinkInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetReferralLinkInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetReferralLinkInfoQuery,
    PartnerGetReferralLinkInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetReferralLinkInfoQuery,
    PartnerGetReferralLinkInfoQueryVariables
  >(PartnerGetReferralLinkInfoDocument, options)
}
export function usePartnerGetReferralLinkInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetReferralLinkInfoQuery,
    PartnerGetReferralLinkInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetReferralLinkInfoQuery,
    PartnerGetReferralLinkInfoQueryVariables
  >(PartnerGetReferralLinkInfoDocument, options)
}
export type PartnerGetReferralLinkInfoQueryHookResult = ReturnType<
  typeof usePartnerGetReferralLinkInfoQuery
>
export type PartnerGetReferralLinkInfoLazyQueryHookResult = ReturnType<
  typeof usePartnerGetReferralLinkInfoLazyQuery
>
export type PartnerGetReferralLinkInfoQueryResult = Apollo.QueryResult<
  PartnerGetReferralLinkInfoQuery,
  PartnerGetReferralLinkInfoQueryVariables
>
export const CreateRefundDocument = /*#__PURE__*/ gql`
  mutation CreateRefund($input: RefundCreateInput!) {
    createRefund(input: $input)
  }
`
export type CreateRefundMutationFn = Apollo.MutationFunction<
  CreateRefundMutation,
  CreateRefundMutationVariables
>

/**
 * __useCreateRefundMutation__
 *
 * To run a mutation, you first call `useCreateRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRefundMutation, { data, loading, error }] = useCreateRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRefundMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRefundMutation,
    CreateRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateRefundMutation,
    CreateRefundMutationVariables
  >(CreateRefundDocument, options)
}
export type CreateRefundMutationHookResult = ReturnType<
  typeof useCreateRefundMutation
>
export type CreateRefundMutationResult =
  Apollo.MutationResult<CreateRefundMutation>
export type CreateRefundMutationOptions = Apollo.BaseMutationOptions<
  CreateRefundMutation,
  CreateRefundMutationVariables
>
export const CancelRefundDocument = /*#__PURE__*/ gql`
  mutation CancelRefund($refundID: ID!) {
    cancelRefund(refundID: $refundID)
  }
`
export type CancelRefundMutationFn = Apollo.MutationFunction<
  CancelRefundMutation,
  CancelRefundMutationVariables
>

/**
 * __useCancelRefundMutation__
 *
 * To run a mutation, you first call `useCancelRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRefundMutation, { data, loading, error }] = useCancelRefundMutation({
 *   variables: {
 *      refundID: // value for 'refundID'
 *   },
 * });
 */
export function useCancelRefundMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelRefundMutation,
    CancelRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CancelRefundMutation,
    CancelRefundMutationVariables
  >(CancelRefundDocument, options)
}
export type CancelRefundMutationHookResult = ReturnType<
  typeof useCancelRefundMutation
>
export type CancelRefundMutationResult =
  Apollo.MutationResult<CancelRefundMutation>
export type CancelRefundMutationOptions = Apollo.BaseMutationOptions<
  CancelRefundMutation,
  CancelRefundMutationVariables
>
export const PartnerSendReportDocument = /*#__PURE__*/ gql`
  mutation PartnerSendReport(
    $reportType: ReportType!
    $dateFrom: String
    $dateTo: String
    $timezone: String
    $customerID: ID
    $customerIDs: [ID!]
    $searchTerm: String
    $isArchived: Boolean
    $tagIDs: [ID!]
    $format: ReportFormat
    $invoiceIDs: [ID!]
    $statuses: [InvoiceStatusEnum!]
    $dueDateStart: String
    $dueDateEnd: String
    $amountMin: Float
    $amountMax: Float
    $lastNotificationStart: String
    $lastNotificationEnd: String
    $recurringPaymentID: ID
    $isRecurring: Boolean
    $recurringFrequency: ArRecurringInvoiceFrequency
  ) {
    PartnerSendReport(
      reportType: $reportType
      dateFrom: $dateFrom
      dateTo: $dateTo
      timezone: $timezone
      customerID: $customerID
      customerIDs: $customerIDs
      searchTerm: $searchTerm
      isArchived: $isArchived
      tagIDs: $tagIDs
      format: $format
      invoiceIDs: $invoiceIDs
      statuses: $statuses
      dueDateStart: $dueDateStart
      dueDateEnd: $dueDateEnd
      amountMin: $amountMin
      amountMax: $amountMax
      lastNotificationStart: $lastNotificationStart
      lastNotificationEnd: $lastNotificationEnd
      recurringPaymentID: $recurringPaymentID
      isRecurring: $isRecurring
      recurringFrequency: $recurringFrequency
    )
  }
`
export type PartnerSendReportMutationFn = Apollo.MutationFunction<
  PartnerSendReportMutation,
  PartnerSendReportMutationVariables
>

/**
 * __usePartnerSendReportMutation__
 *
 * To run a mutation, you first call `usePartnerSendReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendReportMutation, { data, loading, error }] = usePartnerSendReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      timezone: // value for 'timezone'
 *      customerID: // value for 'customerID'
 *      customerIDs: // value for 'customerIDs'
 *      searchTerm: // value for 'searchTerm'
 *      isArchived: // value for 'isArchived'
 *      tagIDs: // value for 'tagIDs'
 *      format: // value for 'format'
 *      invoiceIDs: // value for 'invoiceIDs'
 *      statuses: // value for 'statuses'
 *      dueDateStart: // value for 'dueDateStart'
 *      dueDateEnd: // value for 'dueDateEnd'
 *      amountMin: // value for 'amountMin'
 *      amountMax: // value for 'amountMax'
 *      lastNotificationStart: // value for 'lastNotificationStart'
 *      lastNotificationEnd: // value for 'lastNotificationEnd'
 *      recurringPaymentID: // value for 'recurringPaymentID'
 *      isRecurring: // value for 'isRecurring'
 *      recurringFrequency: // value for 'recurringFrequency'
 *   },
 * });
 */
export function usePartnerSendReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendReportMutation,
    PartnerSendReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendReportMutation,
    PartnerSendReportMutationVariables
  >(PartnerSendReportDocument, options)
}
export type PartnerSendReportMutationHookResult = ReturnType<
  typeof usePartnerSendReportMutation
>
export type PartnerSendReportMutationResult =
  Apollo.MutationResult<PartnerSendReportMutation>
export type PartnerSendReportMutationOptions = Apollo.BaseMutationOptions<
  PartnerSendReportMutation,
  PartnerSendReportMutationVariables
>
export const PartnerListRoutinesDocument = /*#__PURE__*/ gql`
  query PartnerListRoutines(
    $page: Int!
    $pageSize: Int!
    $filters: RoutineFilter
    $order: RoutineOrder
  ) {
    PartnerListRoutines(
      page: $page
      pageSize: $pageSize
      filters: $filters
      order: $order
    ) {
      routines {
        ...RoutineListItem
      }
      pagination {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
  ${RoutineListItemFragmentDoc}
`

/**
 * __usePartnerListRoutinesQuery__
 *
 * To run a query within a React component, call `usePartnerListRoutinesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListRoutinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListRoutinesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePartnerListRoutinesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListRoutinesQuery,
    PartnerListRoutinesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListRoutinesQuery,
    PartnerListRoutinesQueryVariables
  >(PartnerListRoutinesDocument, options)
}
export function usePartnerListRoutinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListRoutinesQuery,
    PartnerListRoutinesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListRoutinesQuery,
    PartnerListRoutinesQueryVariables
  >(PartnerListRoutinesDocument, options)
}
export type PartnerListRoutinesQueryHookResult = ReturnType<
  typeof usePartnerListRoutinesQuery
>
export type PartnerListRoutinesLazyQueryHookResult = ReturnType<
  typeof usePartnerListRoutinesLazyQuery
>
export type PartnerListRoutinesQueryResult = Apollo.QueryResult<
  PartnerListRoutinesQuery,
  PartnerListRoutinesQueryVariables
>
export const PartnerGetRoutineDocument = /*#__PURE__*/ gql`
  query PartnerGetRoutine($id: ID!) {
    PartnerGetRoutine(id: $id) {
      ...RoutineDetail
    }
  }
  ${RoutineDetailFragmentDoc}
`

/**
 * __usePartnerGetRoutineQuery__
 *
 * To run a query within a React component, call `usePartnerGetRoutineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetRoutineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetRoutineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetRoutineQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetRoutineQuery,
    PartnerGetRoutineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetRoutineQuery,
    PartnerGetRoutineQueryVariables
  >(PartnerGetRoutineDocument, options)
}
export function usePartnerGetRoutineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetRoutineQuery,
    PartnerGetRoutineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetRoutineQuery,
    PartnerGetRoutineQueryVariables
  >(PartnerGetRoutineDocument, options)
}
export type PartnerGetRoutineQueryHookResult = ReturnType<
  typeof usePartnerGetRoutineQuery
>
export type PartnerGetRoutineLazyQueryHookResult = ReturnType<
  typeof usePartnerGetRoutineLazyQuery
>
export type PartnerGetRoutineQueryResult = Apollo.QueryResult<
  PartnerGetRoutineQuery,
  PartnerGetRoutineQueryVariables
>
export const PartnerListRoutineRunsDocument = /*#__PURE__*/ gql`
  query PartnerListRoutineRuns($routineID: ID!, $page: Int!, $pageSize: Int!) {
    PartnerListRoutineRuns(
      routineID: $routineID
      page: $page
      pageSize: $pageSize
    ) {
      runs {
        ...RoutineRunRow
      }
      pagination {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
  ${RoutineRunRowFragmentDoc}
`

/**
 * __usePartnerListRoutineRunsQuery__
 *
 * To run a query within a React component, call `usePartnerListRoutineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListRoutineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListRoutineRunsQuery({
 *   variables: {
 *      routineID: // value for 'routineID'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePartnerListRoutineRunsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListRoutineRunsQuery,
    PartnerListRoutineRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListRoutineRunsQuery,
    PartnerListRoutineRunsQueryVariables
  >(PartnerListRoutineRunsDocument, options)
}
export function usePartnerListRoutineRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListRoutineRunsQuery,
    PartnerListRoutineRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListRoutineRunsQuery,
    PartnerListRoutineRunsQueryVariables
  >(PartnerListRoutineRunsDocument, options)
}
export type PartnerListRoutineRunsQueryHookResult = ReturnType<
  typeof usePartnerListRoutineRunsQuery
>
export type PartnerListRoutineRunsLazyQueryHookResult = ReturnType<
  typeof usePartnerListRoutineRunsLazyQuery
>
export type PartnerListRoutineRunsQueryResult = Apollo.QueryResult<
  PartnerListRoutineRunsQuery,
  PartnerListRoutineRunsQueryVariables
>
export const PartnerGetRoutineRunDocument = /*#__PURE__*/ gql`
  query PartnerGetRoutineRun($routineID: ID!, $runID: ID!) {
    PartnerGetRoutineRun(routineID: $routineID, runID: $runID) {
      ...RoutineRunDetail
    }
  }
  ${RoutineRunDetailFragmentDoc}
`

/**
 * __usePartnerGetRoutineRunQuery__
 *
 * To run a query within a React component, call `usePartnerGetRoutineRunQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetRoutineRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetRoutineRunQuery({
 *   variables: {
 *      routineID: // value for 'routineID'
 *      runID: // value for 'runID'
 *   },
 * });
 */
export function usePartnerGetRoutineRunQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetRoutineRunQuery,
    PartnerGetRoutineRunQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetRoutineRunQuery,
    PartnerGetRoutineRunQueryVariables
  >(PartnerGetRoutineRunDocument, options)
}
export function usePartnerGetRoutineRunLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetRoutineRunQuery,
    PartnerGetRoutineRunQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetRoutineRunQuery,
    PartnerGetRoutineRunQueryVariables
  >(PartnerGetRoutineRunDocument, options)
}
export type PartnerGetRoutineRunQueryHookResult = ReturnType<
  typeof usePartnerGetRoutineRunQuery
>
export type PartnerGetRoutineRunLazyQueryHookResult = ReturnType<
  typeof usePartnerGetRoutineRunLazyQuery
>
export type PartnerGetRoutineRunQueryResult = Apollo.QueryResult<
  PartnerGetRoutineRunQuery,
  PartnerGetRoutineRunQueryVariables
>
export const PartnerRoutineRunFileDownloadUrlDocument = /*#__PURE__*/ gql`
  query PartnerRoutineRunFileDownloadURL(
    $routineID: ID!
    $runID: ID!
    $fileID: String
    $path: String
  ) {
    PartnerRoutineRunFileDownloadURL(
      routineID: $routineID
      runID: $runID
      fileID: $fileID
      path: $path
    )
  }
`

/**
 * __usePartnerRoutineRunFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `usePartnerRoutineRunFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRoutineRunFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRoutineRunFileDownloadUrlQuery({
 *   variables: {
 *      routineID: // value for 'routineID'
 *      runID: // value for 'runID'
 *      fileID: // value for 'fileID'
 *      path: // value for 'path'
 *   },
 * });
 */
export function usePartnerRoutineRunFileDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerRoutineRunFileDownloadUrlQuery,
    PartnerRoutineRunFileDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRoutineRunFileDownloadUrlQuery,
    PartnerRoutineRunFileDownloadUrlQueryVariables
  >(PartnerRoutineRunFileDownloadUrlDocument, options)
}
export function usePartnerRoutineRunFileDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRoutineRunFileDownloadUrlQuery,
    PartnerRoutineRunFileDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRoutineRunFileDownloadUrlQuery,
    PartnerRoutineRunFileDownloadUrlQueryVariables
  >(PartnerRoutineRunFileDownloadUrlDocument, options)
}
export type PartnerRoutineRunFileDownloadUrlQueryHookResult = ReturnType<
  typeof usePartnerRoutineRunFileDownloadUrlQuery
>
export type PartnerRoutineRunFileDownloadUrlLazyQueryHookResult = ReturnType<
  typeof usePartnerRoutineRunFileDownloadUrlLazyQuery
>
export type PartnerRoutineRunFileDownloadUrlQueryResult = Apollo.QueryResult<
  PartnerRoutineRunFileDownloadUrlQuery,
  PartnerRoutineRunFileDownloadUrlQueryVariables
>
export const PartnerUpdateRoutineDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateRoutine($input: PartnerUpdateRoutineInput!) {
    PartnerUpdateRoutine(input: $input) {
      ...RoutineDetail
    }
  }
  ${RoutineDetailFragmentDoc}
`
export type PartnerUpdateRoutineMutationFn = Apollo.MutationFunction<
  PartnerUpdateRoutineMutation,
  PartnerUpdateRoutineMutationVariables
>

/**
 * __usePartnerUpdateRoutineMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateRoutineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateRoutineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateRoutineMutation, { data, loading, error }] = usePartnerUpdateRoutineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateRoutineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateRoutineMutation,
    PartnerUpdateRoutineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateRoutineMutation,
    PartnerUpdateRoutineMutationVariables
  >(PartnerUpdateRoutineDocument, options)
}
export type PartnerUpdateRoutineMutationHookResult = ReturnType<
  typeof usePartnerUpdateRoutineMutation
>
export type PartnerUpdateRoutineMutationResult =
  Apollo.MutationResult<PartnerUpdateRoutineMutation>
export type PartnerUpdateRoutineMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateRoutineMutation,
  PartnerUpdateRoutineMutationVariables
>
export const PartnerDeleteRoutineDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteRoutine($id: ID!) {
    PartnerDeleteRoutine(id: $id)
  }
`
export type PartnerDeleteRoutineMutationFn = Apollo.MutationFunction<
  PartnerDeleteRoutineMutation,
  PartnerDeleteRoutineMutationVariables
>

/**
 * __usePartnerDeleteRoutineMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteRoutineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteRoutineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteRoutineMutation, { data, loading, error }] = usePartnerDeleteRoutineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteRoutineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteRoutineMutation,
    PartnerDeleteRoutineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteRoutineMutation,
    PartnerDeleteRoutineMutationVariables
  >(PartnerDeleteRoutineDocument, options)
}
export type PartnerDeleteRoutineMutationHookResult = ReturnType<
  typeof usePartnerDeleteRoutineMutation
>
export type PartnerDeleteRoutineMutationResult =
  Apollo.MutationResult<PartnerDeleteRoutineMutation>
export type PartnerDeleteRoutineMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeleteRoutineMutation,
  PartnerDeleteRoutineMutationVariables
>
export const PartnerRunRoutineNowDocument = /*#__PURE__*/ gql`
  mutation PartnerRunRoutineNow($routineID: ID!) {
    PartnerRunRoutineNow(routineID: $routineID) {
      ...RoutineRunDetail
    }
  }
  ${RoutineRunDetailFragmentDoc}
`
export type PartnerRunRoutineNowMutationFn = Apollo.MutationFunction<
  PartnerRunRoutineNowMutation,
  PartnerRunRoutineNowMutationVariables
>

/**
 * __usePartnerRunRoutineNowMutation__
 *
 * To run a mutation, you first call `usePartnerRunRoutineNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRunRoutineNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRunRoutineNowMutation, { data, loading, error }] = usePartnerRunRoutineNowMutation({
 *   variables: {
 *      routineID: // value for 'routineID'
 *   },
 * });
 */
export function usePartnerRunRoutineNowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRunRoutineNowMutation,
    PartnerRunRoutineNowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRunRoutineNowMutation,
    PartnerRunRoutineNowMutationVariables
  >(PartnerRunRoutineNowDocument, options)
}
export type PartnerRunRoutineNowMutationHookResult = ReturnType<
  typeof usePartnerRunRoutineNowMutation
>
export type PartnerRunRoutineNowMutationResult =
  Apollo.MutationResult<PartnerRunRoutineNowMutation>
export type PartnerRunRoutineNowMutationOptions = Apollo.BaseMutationOptions<
  PartnerRunRoutineNowMutation,
  PartnerRunRoutineNowMutationVariables
>
export const PartnerScheduledOneOffEmailConnectionDocument = /*#__PURE__*/ gql`
  query PartnerScheduledOneOffEmailConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
  ) {
    PartnerScheduledOneOffEmailConnection(
      after: $after
      first: $first
      before: $before
      last: $last
    ) {
      edges {
        cursor
        node {
          ...PartnerScheduledOneOffEmail
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${PartnerScheduledOneOffEmailFragmentDoc}
`

/**
 * __usePartnerScheduledOneOffEmailConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerScheduledOneOffEmailConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerScheduledOneOffEmailConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerScheduledOneOffEmailConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePartnerScheduledOneOffEmailConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerScheduledOneOffEmailConnectionQuery,
    PartnerScheduledOneOffEmailConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerScheduledOneOffEmailConnectionQuery,
    PartnerScheduledOneOffEmailConnectionQueryVariables
  >(PartnerScheduledOneOffEmailConnectionDocument, options)
}
export function usePartnerScheduledOneOffEmailConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerScheduledOneOffEmailConnectionQuery,
    PartnerScheduledOneOffEmailConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerScheduledOneOffEmailConnectionQuery,
    PartnerScheduledOneOffEmailConnectionQueryVariables
  >(PartnerScheduledOneOffEmailConnectionDocument, options)
}
export type PartnerScheduledOneOffEmailConnectionQueryHookResult = ReturnType<
  typeof usePartnerScheduledOneOffEmailConnectionQuery
>
export type PartnerScheduledOneOffEmailConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerScheduledOneOffEmailConnectionLazyQuery>
export type PartnerScheduledOneOffEmailConnectionQueryResult =
  Apollo.QueryResult<
    PartnerScheduledOneOffEmailConnectionQuery,
    PartnerScheduledOneOffEmailConnectionQueryVariables
  >
export const PartnerGetScheduledOneOffEmailDocument = /*#__PURE__*/ gql`
  query PartnerGetScheduledOneOffEmail($id: ID!) {
    PartnerGetScheduledOneOffEmail(id: $id) {
      ...PartnerScheduledOneOffEmail
    }
  }
  ${PartnerScheduledOneOffEmailFragmentDoc}
`

/**
 * __usePartnerGetScheduledOneOffEmailQuery__
 *
 * To run a query within a React component, call `usePartnerGetScheduledOneOffEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetScheduledOneOffEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetScheduledOneOffEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerGetScheduledOneOffEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetScheduledOneOffEmailQuery,
    PartnerGetScheduledOneOffEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetScheduledOneOffEmailQuery,
    PartnerGetScheduledOneOffEmailQueryVariables
  >(PartnerGetScheduledOneOffEmailDocument, options)
}
export function usePartnerGetScheduledOneOffEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetScheduledOneOffEmailQuery,
    PartnerGetScheduledOneOffEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetScheduledOneOffEmailQuery,
    PartnerGetScheduledOneOffEmailQueryVariables
  >(PartnerGetScheduledOneOffEmailDocument, options)
}
export type PartnerGetScheduledOneOffEmailQueryHookResult = ReturnType<
  typeof usePartnerGetScheduledOneOffEmailQuery
>
export type PartnerGetScheduledOneOffEmailLazyQueryHookResult = ReturnType<
  typeof usePartnerGetScheduledOneOffEmailLazyQuery
>
export type PartnerGetScheduledOneOffEmailQueryResult = Apollo.QueryResult<
  PartnerGetScheduledOneOffEmailQuery,
  PartnerGetScheduledOneOffEmailQueryVariables
>
export const PartnerDeleteScheduledOneOffEmailDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteScheduledOneOffEmail($id: ID!) {
    PartnerDeleteScheduledOneOffEmail(id: $id)
  }
`
export type PartnerDeleteScheduledOneOffEmailMutationFn =
  Apollo.MutationFunction<
    PartnerDeleteScheduledOneOffEmailMutation,
    PartnerDeleteScheduledOneOffEmailMutationVariables
  >

/**
 * __usePartnerDeleteScheduledOneOffEmailMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteScheduledOneOffEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteScheduledOneOffEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteScheduledOneOffEmailMutation, { data, loading, error }] = usePartnerDeleteScheduledOneOffEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteScheduledOneOffEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteScheduledOneOffEmailMutation,
    PartnerDeleteScheduledOneOffEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteScheduledOneOffEmailMutation,
    PartnerDeleteScheduledOneOffEmailMutationVariables
  >(PartnerDeleteScheduledOneOffEmailDocument, options)
}
export type PartnerDeleteScheduledOneOffEmailMutationHookResult = ReturnType<
  typeof usePartnerDeleteScheduledOneOffEmailMutation
>
export type PartnerDeleteScheduledOneOffEmailMutationResult =
  Apollo.MutationResult<PartnerDeleteScheduledOneOffEmailMutation>
export type PartnerDeleteScheduledOneOffEmailMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteScheduledOneOffEmailMutation,
    PartnerDeleteScheduledOneOffEmailMutationVariables
  >
export const PartnerUpdateScheduledOneOffEmailDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateScheduledOneOffEmail(
    $input: UpdateScheduledOneOffEmailInput!
  ) {
    PartnerUpdateScheduledOneOffEmail(input: $input) {
      ...PartnerScheduledOneOffEmail
    }
  }
  ${PartnerScheduledOneOffEmailFragmentDoc}
`
export type PartnerUpdateScheduledOneOffEmailMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateScheduledOneOffEmailMutation,
    PartnerUpdateScheduledOneOffEmailMutationVariables
  >

/**
 * __usePartnerUpdateScheduledOneOffEmailMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateScheduledOneOffEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateScheduledOneOffEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateScheduledOneOffEmailMutation, { data, loading, error }] = usePartnerUpdateScheduledOneOffEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateScheduledOneOffEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateScheduledOneOffEmailMutation,
    PartnerUpdateScheduledOneOffEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateScheduledOneOffEmailMutation,
    PartnerUpdateScheduledOneOffEmailMutationVariables
  >(PartnerUpdateScheduledOneOffEmailDocument, options)
}
export type PartnerUpdateScheduledOneOffEmailMutationHookResult = ReturnType<
  typeof usePartnerUpdateScheduledOneOffEmailMutation
>
export type PartnerUpdateScheduledOneOffEmailMutationResult =
  Apollo.MutationResult<PartnerUpdateScheduledOneOffEmailMutation>
export type PartnerUpdateScheduledOneOffEmailMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateScheduledOneOffEmailMutation,
    PartnerUpdateScheduledOneOffEmailMutationVariables
  >
export const PartnerSendScheduledOneOffEmailNowDocument = /*#__PURE__*/ gql`
  mutation PartnerSendScheduledOneOffEmailNow($id: ID!) {
    PartnerSendScheduledOneOffEmailNow(id: $id)
  }
`
export type PartnerSendScheduledOneOffEmailNowMutationFn =
  Apollo.MutationFunction<
    PartnerSendScheduledOneOffEmailNowMutation,
    PartnerSendScheduledOneOffEmailNowMutationVariables
  >

/**
 * __usePartnerSendScheduledOneOffEmailNowMutation__
 *
 * To run a mutation, you first call `usePartnerSendScheduledOneOffEmailNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendScheduledOneOffEmailNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendScheduledOneOffEmailNowMutation, { data, loading, error }] = usePartnerSendScheduledOneOffEmailNowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerSendScheduledOneOffEmailNowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendScheduledOneOffEmailNowMutation,
    PartnerSendScheduledOneOffEmailNowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendScheduledOneOffEmailNowMutation,
    PartnerSendScheduledOneOffEmailNowMutationVariables
  >(PartnerSendScheduledOneOffEmailNowDocument, options)
}
export type PartnerSendScheduledOneOffEmailNowMutationHookResult = ReturnType<
  typeof usePartnerSendScheduledOneOffEmailNowMutation
>
export type PartnerSendScheduledOneOffEmailNowMutationResult =
  Apollo.MutationResult<PartnerSendScheduledOneOffEmailNowMutation>
export type PartnerSendScheduledOneOffEmailNowMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSendScheduledOneOffEmailNowMutation,
    PartnerSendScheduledOneOffEmailNowMutationVariables
  >
export const PartnerListActiveSubscriptionsDocument = /*#__PURE__*/ gql`
  query PartnerListActiveSubscriptions {
    PartnerListActiveSubscriptions {
      ...PartnerSubscription
    }
  }
  ${PartnerSubscriptionFragmentDoc}
`

/**
 * __usePartnerListActiveSubscriptionsQuery__
 *
 * To run a query within a React component, call `usePartnerListActiveSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListActiveSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListActiveSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListActiveSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >(PartnerListActiveSubscriptionsDocument, options)
}
export function usePartnerListActiveSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >(PartnerListActiveSubscriptionsDocument, options)
}
export type PartnerListActiveSubscriptionsQueryHookResult = ReturnType<
  typeof usePartnerListActiveSubscriptionsQuery
>
export type PartnerListActiveSubscriptionsLazyQueryHookResult = ReturnType<
  typeof usePartnerListActiveSubscriptionsLazyQuery
>
export type PartnerListActiveSubscriptionsQueryResult = Apollo.QueryResult<
  PartnerListActiveSubscriptionsQuery,
  PartnerListActiveSubscriptionsQueryVariables
>
export const PartnerSubscriptionsPaymentsConnectionDocument = /*#__PURE__*/ gql`
  query PartnerSubscriptionsPaymentsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: SubscriptionPaymentFilter
    $orderBy: SubscriptionPaymentOrderBy
  ) {
    PartnerSubscriptionsPaymentsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...SubscriptionPayment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${SubscriptionPaymentFragmentDoc}
`

/**
 * __usePartnerSubscriptionsPaymentsConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerSubscriptionsPaymentsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerSubscriptionsPaymentsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerSubscriptionsPaymentsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerSubscriptionsPaymentsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >(PartnerSubscriptionsPaymentsConnectionDocument, options)
}
export function usePartnerSubscriptionsPaymentsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >(PartnerSubscriptionsPaymentsConnectionDocument, options)
}
export type PartnerSubscriptionsPaymentsConnectionQueryHookResult = ReturnType<
  typeof usePartnerSubscriptionsPaymentsConnectionQuery
>
export type PartnerSubscriptionsPaymentsConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerSubscriptionsPaymentsConnectionLazyQuery>
export type PartnerSubscriptionsPaymentsConnectionQueryResult =
  Apollo.QueryResult<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >
export const PartnerListSubscriptionPaymentsTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListSubscriptionPaymentsTotals {
    PartnerListSubscriptionPaymentsTotals {
      count
    }
  }
`

/**
 * __usePartnerListSubscriptionPaymentsTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListSubscriptionPaymentsTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListSubscriptionPaymentsTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListSubscriptionPaymentsTotalsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListSubscriptionPaymentsTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >(PartnerListSubscriptionPaymentsTotalsDocument, options)
}
export function usePartnerListSubscriptionPaymentsTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >(PartnerListSubscriptionPaymentsTotalsDocument, options)
}
export type PartnerListSubscriptionPaymentsTotalsQueryHookResult = ReturnType<
  typeof usePartnerListSubscriptionPaymentsTotalsQuery
>
export type PartnerListSubscriptionPaymentsTotalsLazyQueryHookResult =
  ReturnType<typeof usePartnerListSubscriptionPaymentsTotalsLazyQuery>
export type PartnerListSubscriptionPaymentsTotalsQueryResult =
  Apollo.QueryResult<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >
export const PartnerCancelSubscriptionDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelSubscription($input: CancelSubscriptionInput!) {
    PartnerCancelSubscription(input: $input) {
      ...PartnerSubscription
    }
  }
  ${PartnerSubscriptionFragmentDoc}
`
export type PartnerCancelSubscriptionMutationFn = Apollo.MutationFunction<
  PartnerCancelSubscriptionMutation,
  PartnerCancelSubscriptionMutationVariables
>

/**
 * __usePartnerCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `usePartnerCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelSubscriptionMutation, { data, loading, error }] = usePartnerCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCancelSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelSubscriptionMutation,
    PartnerCancelSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelSubscriptionMutation,
    PartnerCancelSubscriptionMutationVariables
  >(PartnerCancelSubscriptionDocument, options)
}
export type PartnerCancelSubscriptionMutationHookResult = ReturnType<
  typeof usePartnerCancelSubscriptionMutation
>
export type PartnerCancelSubscriptionMutationResult =
  Apollo.MutationResult<PartnerCancelSubscriptionMutation>
export type PartnerCancelSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCancelSubscriptionMutation,
    PartnerCancelSubscriptionMutationVariables
  >
export const PartnerAccountingSyncConfigGetDocument = /*#__PURE__*/ gql`
  query PartnerAccountingSyncConfigGet($input: SyncConfigGetInput!) {
    PartnerAccountingSyncConfigGet(input: $input) {
      partnerID
      sourcePlatformName
      targetPlatformName
      lastAutomaticSync
      options {
        optionKey
        optionType
        enumValue
        customValue
      }
      mappings {
        sourceID
        sourceName
        targetID
        targetName
        mappingType
      }
    }
  }
`

/**
 * __usePartnerAccountingSyncConfigGetQuery__
 *
 * To run a query within a React component, call `usePartnerAccountingSyncConfigGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncConfigGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAccountingSyncConfigGetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncConfigGetQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >(PartnerAccountingSyncConfigGetDocument, options)
}
export function usePartnerAccountingSyncConfigGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >(PartnerAccountingSyncConfigGetDocument, options)
}
export type PartnerAccountingSyncConfigGetQueryHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigGetQuery
>
export type PartnerAccountingSyncConfigGetLazyQueryHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigGetLazyQuery
>
export type PartnerAccountingSyncConfigGetQueryResult = Apollo.QueryResult<
  PartnerAccountingSyncConfigGetQuery,
  PartnerAccountingSyncConfigGetQueryVariables
>
export const PartnerAccountingSyncConfigCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingSyncConfigCreate($input: SyncConfigCreateInput!) {
    PartnerAccountingSyncConfigCreate(input: $input) {
      lastAutomaticSync
    }
  }
`
export type PartnerAccountingSyncConfigCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >

/**
 * __usePartnerAccountingSyncConfigCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingSyncConfigCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncConfigCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingSyncConfigCreateMutation, { data, loading, error }] = usePartnerAccountingSyncConfigCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncConfigCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >(PartnerAccountingSyncConfigCreateDocument, options)
}
export type PartnerAccountingSyncConfigCreateMutationHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigCreateMutation
>
export type PartnerAccountingSyncConfigCreateMutationResult =
  Apollo.MutationResult<PartnerAccountingSyncConfigCreateMutation>
export type PartnerAccountingSyncConfigCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >
export const PartnerAccountingSyncConfigUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingSyncConfigUpdate($input: SyncConfigUpdateInput!) {
    PartnerAccountingSyncConfigUpdate(input: $input) {
      lastAutomaticSync
    }
  }
`
export type PartnerAccountingSyncConfigUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >

/**
 * __usePartnerAccountingSyncConfigUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingSyncConfigUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncConfigUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingSyncConfigUpdateMutation, { data, loading, error }] = usePartnerAccountingSyncConfigUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncConfigUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >(PartnerAccountingSyncConfigUpdateDocument, options)
}
export type PartnerAccountingSyncConfigUpdateMutationHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigUpdateMutation
>
export type PartnerAccountingSyncConfigUpdateMutationResult =
  Apollo.MutationResult<PartnerAccountingSyncConfigUpdateMutation>
export type PartnerAccountingSyncConfigUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >
export const GetUserInfoDocument = /*#__PURE__*/ gql`
  query GetUserInfo {
    GetUserInfo {
      id
      userType
      users {
        ...UserInfo
      }
    }
  }
  ${UserInfoFragmentDoc}
`

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options
  )
}
export function useGetUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options
  )
}
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>
export type GetUserInfoLazyQueryHookResult = ReturnType<
  typeof useGetUserInfoLazyQuery
>
export type GetUserInfoQueryResult = Apollo.QueryResult<
  GetUserInfoQuery,
  GetUserInfoQueryVariables
>
export const GetUserInfoDetailsDocument = /*#__PURE__*/ gql`
  query GetUserInfoDetails {
    GetUserInfo {
      id
      users {
        ...UserInfoDetails
      }
    }
  }
  ${UserInfoDetailsFragmentDoc}
`

/**
 * __useGetUserInfoDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserInfoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >(GetUserInfoDetailsDocument, options)
}
export function useGetUserInfoDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >(GetUserInfoDetailsDocument, options)
}
export type GetUserInfoDetailsQueryHookResult = ReturnType<
  typeof useGetUserInfoDetailsQuery
>
export type GetUserInfoDetailsLazyQueryHookResult = ReturnType<
  typeof useGetUserInfoDetailsLazyQuery
>
export type GetUserInfoDetailsQueryResult = Apollo.QueryResult<
  GetUserInfoDetailsQuery,
  GetUserInfoDetailsQueryVariables
>
export const CreateUserAndPartnerDocument = /*#__PURE__*/ gql`
  query CreateUserAndPartner {
    CreateUserAndPartner {
      userId
      partnerId
    }
  }
`

/**
 * __useCreateUserAndPartnerQuery__
 *
 * To run a query within a React component, call `useCreateUserAndPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAndPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateUserAndPartnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateUserAndPartnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >(CreateUserAndPartnerDocument, options)
}
export function useCreateUserAndPartnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >(CreateUserAndPartnerDocument, options)
}
export type CreateUserAndPartnerQueryHookResult = ReturnType<
  typeof useCreateUserAndPartnerQuery
>
export type CreateUserAndPartnerLazyQueryHookResult = ReturnType<
  typeof useCreateUserAndPartnerLazyQuery
>
export type CreateUserAndPartnerQueryResult = Apollo.QueryResult<
  CreateUserAndPartnerQuery,
  CreateUserAndPartnerQueryVariables
>
export const PartnerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: PartnerUserOrderBy
  ) {
    PartnerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerUserList
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerUserListFragmentDoc}
`

/**
 * __usePartnerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >(PartnerUserConnectionDocument, options)
}
export function usePartnerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >(PartnerUserConnectionDocument, options)
}
export type PartnerUserConnectionQueryHookResult = ReturnType<
  typeof usePartnerUserConnectionQuery
>
export type PartnerUserConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerUserConnectionLazyQuery
>
export type PartnerUserConnectionQueryResult = Apollo.QueryResult<
  PartnerUserConnectionQuery,
  PartnerUserConnectionQueryVariables
>
export const PartnerUpdateMyUserDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateMyUser($input: PartnerUpdateMyUserInput) {
    PartnerUpdateMyUser(input: $input) {
      id
      firstName
      lastName
      phone
      jobTitle
    }
  }
`
export type PartnerUpdateMyUserMutationFn = Apollo.MutationFunction<
  PartnerUpdateMyUserMutation,
  PartnerUpdateMyUserMutationVariables
>

/**
 * __usePartnerUpdateMyUserMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateMyUserMutation, { data, loading, error }] = usePartnerUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateMyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateMyUserMutation,
    PartnerUpdateMyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateMyUserMutation,
    PartnerUpdateMyUserMutationVariables
  >(PartnerUpdateMyUserDocument, options)
}
export type PartnerUpdateMyUserMutationHookResult = ReturnType<
  typeof usePartnerUpdateMyUserMutation
>
export type PartnerUpdateMyUserMutationResult =
  Apollo.MutationResult<PartnerUpdateMyUserMutation>
export type PartnerUpdateMyUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateMyUserMutation,
  PartnerUpdateMyUserMutationVariables
>
export const PartnerInviteUserDocument = /*#__PURE__*/ gql`
  mutation PartnerInviteUser($input: PartnerInviteUserInput!) {
    PartnerInviteUser(input: $input) {
      ...PartnerUserList
    }
  }
  ${PartnerUserListFragmentDoc}
`
export type PartnerInviteUserMutationFn = Apollo.MutationFunction<
  PartnerInviteUserMutation,
  PartnerInviteUserMutationVariables
>

/**
 * __usePartnerInviteUserMutation__
 *
 * To run a mutation, you first call `usePartnerInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInviteUserMutation, { data, loading, error }] = usePartnerInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInviteUserMutation,
    PartnerInviteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInviteUserMutation,
    PartnerInviteUserMutationVariables
  >(PartnerInviteUserDocument, options)
}
export type PartnerInviteUserMutationHookResult = ReturnType<
  typeof usePartnerInviteUserMutation
>
export type PartnerInviteUserMutationResult =
  Apollo.MutationResult<PartnerInviteUserMutation>
export type PartnerInviteUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerInviteUserMutation,
  PartnerInviteUserMutationVariables
>
export const PartnerUpdateUserDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateUser($input: PartnerUpdateUserInput) {
    PartnerUpdateUser(input: $input) {
      ...PartnerUserList
    }
  }
  ${PartnerUserListFragmentDoc}
`
export type PartnerUpdateUserMutationFn = Apollo.MutationFunction<
  PartnerUpdateUserMutation,
  PartnerUpdateUserMutationVariables
>

/**
 * __usePartnerUpdateUserMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateUserMutation, { data, loading, error }] = usePartnerUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateUserMutation,
    PartnerUpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateUserMutation,
    PartnerUpdateUserMutationVariables
  >(PartnerUpdateUserDocument, options)
}
export type PartnerUpdateUserMutationHookResult = ReturnType<
  typeof usePartnerUpdateUserMutation
>
export type PartnerUpdateUserMutationResult =
  Apollo.MutationResult<PartnerUpdateUserMutation>
export type PartnerUpdateUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateUserMutation,
  PartnerUpdateUserMutationVariables
>
export const PartnerDeleteUserDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteUser($id: ID!) {
    PartnerDeleteUser(id: $id)
  }
`
export type PartnerDeleteUserMutationFn = Apollo.MutationFunction<
  PartnerDeleteUserMutation,
  PartnerDeleteUserMutationVariables
>

/**
 * __usePartnerDeleteUserMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteUserMutation, { data, loading, error }] = usePartnerDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteUserMutation,
    PartnerDeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteUserMutation,
    PartnerDeleteUserMutationVariables
  >(PartnerDeleteUserDocument, options)
}
export type PartnerDeleteUserMutationHookResult = ReturnType<
  typeof usePartnerDeleteUserMutation
>
export type PartnerDeleteUserMutationResult =
  Apollo.MutationResult<PartnerDeleteUserMutation>
export type PartnerDeleteUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeleteUserMutation,
  PartnerDeleteUserMutationVariables
>
export const GraphQLOperations = {
  Query: {
    PartnerGetCompanyIndividualByUploadLink:
      'PartnerGetCompanyIndividualByUploadLink',
    BillsConnection: 'BillsConnection',
    BillList: 'BillList',
    PartnerVendorSearch: 'PartnerVendorSearch',
    VendorsConnection: 'VendorsConnection',
    PartnerFindPaymentPreferenceByVendorID:
      'PartnerFindPaymentPreferenceByVendorID',
    PartnerFindBillByID: 'PartnerFindBillByID',
    PartnerGetBillVendorPayment: 'PartnerGetBillVendorPayment',
    PartnerCountBills: 'PartnerCountBills',
    PartnerNextValidPayDate: 'PartnerNextValidPayDate',
    PartnerFindVendorByID: 'PartnerFindVendorByID',
    PartnerVendorPaymentHistory: 'PartnerVendorPaymentHistory',
    PartnerGetAccountsPayableConfig: 'PartnerGetAccountsPayableConfig',
    PartnerDownloadBillDocument: 'PartnerDownloadBillDocument',
    PartnerGetAccountsPayableNotificationPolicy:
      'PartnerGetAccountsPayableNotificationPolicy',
    PartnerSearchAccountingItems: 'PartnerSearchAccountingItems',
    PartnerGetAccountsPayableFundingAccount:
      'PartnerGetAccountsPayableFundingAccount',
    PartnerListVendorDataRequests: 'PartnerListVendorDataRequests',
    GetVendorDataRequestByToken: 'GetVendorDataRequestByToken',
    PartnerListVendorAuditLog: 'PartnerListVendorAuditLog',
    PartnerGetVendorSimilarityGroups: 'PartnerGetVendorSimilarityGroups',
    PartnerGetVendorTotals: 'PartnerGetVendorTotals',
    PartnerListMergedVendors: 'PartnerListMergedVendors',
    GetVendorCardView: 'GetVendorCardView',
    PartnerFindInboundEmailByBillID: 'PartnerFindInboundEmailByBillID',
    PartnerGetBillAggregates: 'PartnerGetBillAggregates',
    PartnerGetVendorSpend: 'PartnerGetVendorSpend',
    PartnerGetSpendByCategory: 'PartnerGetSpendByCategory',
    PartnerGetPaymentMethodUsage: 'PartnerGetPaymentMethodUsage',
    PartnerGetRecentActivity: 'PartnerGetRecentActivity',
    AccountsPayablePaymentAggregates: 'AccountsPayablePaymentAggregates',
    GetAdyenDocumentTypes: 'GetAdyenDocumentTypes',
    GetAdyenRemediationActions: 'GetAdyenRemediationActions',
    GetAdyenHostedOnboardingLink: 'GetAdyenHostedOnboardingLink',
    GetAdyenPciForms: 'GetAdyenPciForms',
    GetAdyenTermsOfService: 'GetAdyenTermsOfService',
    GetAdyenOnboardingStatus: 'GetAdyenOnboardingStatus',
    GetAnalyticsSyncState: 'GetAnalyticsSyncState',
    GetClientTrendsSummary: 'GetClientTrendsSummary',
    GetClientTrendsRankings: 'GetClientTrendsRankings',
    GetClientTrendsTrendData: 'GetClientTrendsTrendData',
    GetClientTrendsBreakdown: 'GetClientTrendsBreakdown',
    GetAnalyticsClientById: 'GetAnalyticsClientById',
    GetClientTrendsClients: 'GetClientTrendsClients',
    GetClientTrendsFilterValues: 'GetClientTrendsFilterValues',
    PartnerListClientTrendsPresets: 'PartnerListClientTrendsPresets',
    PartnerGetClientTrendsPreset: 'PartnerGetClientTrendsPreset',
    PartnerGetAgentLoads: 'PartnerGetAgentLoads',
    PartnerGetUtilizationFilterValues: 'PartnerGetUtilizationFilterValues',
    PartnerGetUtilizationPercentage: 'PartnerGetUtilizationPercentage',
    PartnerGetUtilizationOverview: 'PartnerGetUtilizationOverview',
    PartnerGetUtilizationSummary: 'PartnerGetUtilizationSummary',
    PartnerGetUtilizationSeries: 'PartnerGetUtilizationSeries',
    PartnerGetUtilizationBreakdown: 'PartnerGetUtilizationBreakdown',
    PartnerGetUtilizationKPIs: 'PartnerGetUtilizationKPIs',
    PartnerGetClientKPIs: 'PartnerGetClientKPIs',
    PartnerListUtilizationPresets: 'PartnerListUtilizationPresets',
    PartnerGetUtilizationPreset: 'PartnerGetUtilizationPreset',
    GetClientTicketCounts: 'GetClientTicketCounts',
    GetAgentTicketCounts: 'GetAgentTicketCounts',
    GetTicketList: 'GetTicketList',
    PartnerScopeCatalog: 'PartnerScopeCatalog',
    PartnerApiKeyConnection: 'PartnerApiKeyConnection',
    PartnerArHome: 'PartnerArHome',
    PartnerHomePerformanceCard: 'PartnerHomePerformanceCard',
    PartnerHomeCashFlowCard: 'PartnerHomeCashFlowCard',
    PartnerHomeCustomersNeedingAttentionPage:
      'PartnerHomeCustomersNeedingAttentionPage',
    ListAssistantConversations: 'ListAssistantConversations',
    GetAssistantConversation: 'GetAssistantConversation',
    ListAssistantV2Conversations: 'ListAssistantV2Conversations',
    GetAssistantV2Conversation: 'GetAssistantV2Conversation',
    GetAssistantV2ConversationHistory: 'GetAssistantV2ConversationHistory',
    GetAssistantV2TurnStatus: 'GetAssistantV2TurnStatus',
    GetAssistantV2FileDownloadURL: 'GetAssistantV2FileDownloadURL',
    AssistantPageSuggestionCustomer: 'AssistantPageSuggestionCustomer',
    AssistantPageSuggestionInvoice: 'AssistantPageSuggestionInvoice',
    OAuth2Url: 'OAuth2Url',
    PartnerListAutopayExcludedInvoices: 'PartnerListAutopayExcludedInvoices',
    FindAutopayRule: 'FindAutopayRule',
    PartnerGetCoveredInvoicesForRule: 'PartnerGetCoveredInvoicesForRule',
    PartnerGlobalAutopayRuleConnection: 'PartnerGlobalAutopayRuleConnection',
    PartnerCustomerAutopayRuleWithBankingAndCardConnection:
      'PartnerCustomerAutopayRuleWithBankingAndCardConnection',
    PartnerCustomerAutopayRuleConnection:
      'PartnerCustomerAutopayRuleConnection',
    PartnerCustomerTagsAutopayRuleConnection:
      'PartnerCustomerTagsAutopayRuleConnection',
    PartnerListCustomerRulesTotals: 'PartnerListCustomerRulesTotals',
    PartnerAutopayExcludedCustomerConnection:
      'PartnerAutopayExcludedCustomerConnection',
    PartnerAutopayExcludedCustomerListTotals:
      'PartnerAutopayExcludedCustomerListTotals',
    GetCustomerAutopayConfig: 'GetCustomerAutopayConfig',
    PartnerInvoiceBnplConnection: 'PartnerInvoiceBnplConnection',
    PartnerListBankingIntegrations: 'PartnerListBankingIntegrations',
    PartnerListBankingIntegrationsWithVerification:
      'PartnerListBankingIntegrationsWithVerification',
    PartnerListCustomerBankingIntegrations:
      'PartnerListCustomerBankingIntegrations',
    PartnerGetBankAccount: 'PartnerGetBankAccount',
    PartnerGetInvoiceBulkCharges: 'PartnerGetInvoiceBulkCharges',
    FindOverdueInvoiceDetail: 'FindOverdueInvoiceDetail',
    FindOverdueInvoices: 'FindOverdueInvoices',
    PartnerCollectionConnection: 'PartnerCollectionConnection',
    FindCollectionDetail: 'FindCollectionDetail',
    PartnerCollectionTotals: 'PartnerCollectionTotals',
    PartnerGetFeeRates: 'PartnerGetFeeRates',
    PartnerListCards: 'PartnerListCards',
    PartnerListCustomerCards: 'PartnerListCustomerCards',
    PartnerGetCardFee: 'PartnerGetCardFee',
    PartnerGetCustomerCardFee: 'PartnerGetCustomerCardFee',
    PartnerGetCreditMemoConfig: 'PartnerGetCreditMemoConfig',
    PartnerGetCustomerCreditMemoBalance: 'PartnerGetCustomerCreditMemoBalance',
    PartnerListCreditMemos: 'PartnerListCreditMemos',
    PartnerListCreditMemosByCustomerId: 'PartnerListCreditMemosByCustomerId',
    PartnerGetCreditMemoDetails: 'PartnerGetCreditMemoDetails',
    PartnerListCustomerTags: 'PartnerListCustomerTags',
    PartnerCustomerWithInvoicesDataConnection:
      'PartnerCustomerWithInvoicesDataConnection',
    PartnerCustomerWithCustomerUserConnection:
      'PartnerCustomerWithCustomerUserConnection',
    PartnerCustomerConnection: 'PartnerCustomerConnection',
    PartnerCustomerConnectionWithRelations:
      'PartnerCustomerConnectionWithRelations',
    PartnerListCustomersTotals: 'PartnerListCustomersTotals',
    PartnerListCustomersV2: 'PartnerListCustomersV2',
    PartnerGetCustomerV2: 'PartnerGetCustomerV2',
    PartnerGetCustomerSummary: 'PartnerGetCustomerSummary',
    PartnerGetCustomersSummary: 'PartnerGetCustomersSummary',
    PartnerCustomerSearch: 'PartnerCustomerSearch',
    PartnerCustomerUserConnection: 'PartnerCustomerUserConnection',
    PartnerEmailActivityConnection: 'PartnerEmailActivityConnection',
    PartnerListEmailTemplates: 'PartnerListEmailTemplates',
    PartnerGetPartnerFeeConfig: 'PartnerGetPartnerFeeConfig',
    PartnerGetCustomPartnerFeeConfigs: 'PartnerGetCustomPartnerFeeConfigs',
    PartnerListCustomerFeeExceptions: 'PartnerListCustomerFeeExceptions',
    PartnerGetPassThroughFees: 'PartnerGetPassThroughFees',
    PartnerGetAdminCardFeesConfig: 'PartnerGetAdminCardFeesConfig',
    GetCustomerInsightsGraphs: 'GetCustomerInsightsGraphs',
    GetCustomerInsightsMetrics: 'GetCustomerInsightsMetrics',
    GetInsightOverviewMetrics: 'GetInsightOverviewMetrics',
    GetOverdueRateCohort: 'GetOverdueRateCohort',
    GetCollectionsTimeComparison: 'GetCollectionsTimeComparison',
    GetInsightOverviewGraphs: 'GetInsightOverviewGraphs',
    GetInvoicesInsightsMetrics: 'GetInvoicesInsightsMetrics',
    GetInvoicesInsightsARMetrics: 'GetInvoicesInsightsARMetrics',
    GetInvoicesInsightsGraphs: 'GetInvoicesInsightsGraphs',
    GetInvoicesInsightsARGraphs: 'GetInvoicesInsightsARGraphs',
    GetPaymentsInsightsMetrics: 'GetPaymentsInsightsMetrics',
    GetPaymentsInsightsGraphs: 'GetPaymentsInsightsGraphs',
    GetCollectionsInsightsMetrics: 'GetCollectionsInsightsMetrics',
    GetCollectionsInsightsGraphs: 'GetCollectionsInsightsGraphs',
    GetAutomationsInsightsMetrics: 'GetAutomationsInsightsMetrics',
    GetAutomationsInsightsGraphs: 'GetAutomationsInsightsGraphs',
    GetAutomationsLastMonthInsightsGraphs:
      'GetAutomationsLastMonthInsightsGraphs',
    PartnerAutotaskGetFilters: 'PartnerAutotaskGetFilters',
    PartnerContractTypeConnection: 'PartnerContractTypeConnection',
    PartnerAutotaskContractConnection: 'PartnerAutotaskContractConnection',
    PartnerAutotaskGetConnection: 'PartnerAutotaskGetConnection',
    PartnerConnectWiseGetConnection: 'PartnerConnectWiseGetConnection',
    PartnerConnectWiseGetFilters: 'PartnerConnectWiseGetFilters',
    PartnerAgreementTypeConnection: 'PartnerAgreementTypeConnection',
    PartnerConnectWiseBillingTermsConnection:
      'PartnerConnectWiseBillingTermsConnection',
    PartnerConnectWiseAgreementConnection:
      'PartnerConnectWiseAgreementConnection',
    PartnerConnectWiseTaxCodeGet: 'PartnerConnectWiseTaxCodeGet',
    PartnerConnectWiseGlSegmentsGet: 'PartnerConnectWiseGlSegmentsGet',
    PartnerHaloPSATopLevelList: 'PartnerHaloPSATopLevelList',
    PartnerContractSubtypeConnection: 'PartnerContractSubtypeConnection',
    PartnerHaloPSAContractConnection: 'PartnerHaloPSAContractConnection',
    PartnerIntegrationIssueConnection: 'PartnerIntegrationIssueConnection',
    PartnerIntegrationIssueCounts: 'PartnerIntegrationIssueCounts',
    PartnerIntegrationJobConnection: 'PartnerIntegrationJobConnection',
    PartnerIntegrationJobQueueConnection:
      'PartnerIntegrationJobQueueConnection',
    PartnerIntegrationJobFailureCount: 'PartnerIntegrationJobFailureCount',
    PartnerListIntegrations: 'PartnerListIntegrations',
    PartnerListUnsyncedInvoices: 'PartnerListUnsyncedInvoices',
    PartnerGetUnsyncedInvoiceTotals: 'PartnerGetUnsyncedInvoiceTotals',
    PartnerGetAccountingSyncBatch: 'PartnerGetAccountingSyncBatch',
    PartnerListAccountingSyncBatches: 'PartnerListAccountingSyncBatches',
    PartnerListAccountingSyncJobs: 'PartnerListAccountingSyncJobs',
    PartnerGetLastRefreshTriggered: 'PartnerGetLastRefreshTriggered',
    PartnerListAvailableIntegrations: 'PartnerListAvailableIntegrations',
    PartnerResolveCustomerIntegrationIDs:
      'PartnerResolveCustomerIntegrationIDs',
    PartnerGetAccountingPreferences: 'PartnerGetAccountingPreferences',
    PartnerQuickbooksConnectionURL: 'PartnerQuickbooksConnectionURL',
    PartnerQuickbooksAccountList: 'PartnerQuickbooksAccountList',
    PartnerQuickbooksAccountRetrieve: 'PartnerQuickbooksAccountRetrieve',
    PartnerQuickbooksConnectionRead: 'PartnerQuickbooksConnectionRead',
    PartnerListExpenseAccounts: 'PartnerListExpenseAccounts',
    PartnerListVisibleExpenseAccounts: 'PartnerListVisibleExpenseAccounts',
    PartnerRecurringTransactionConnection:
      'PartnerRecurringTransactionConnection',
    PartnerQuickbooksTaxCodeGet: 'PartnerQuickbooksTaxCodeGet',
    PartnerQuickbooksCustomerTypeList: 'PartnerQuickbooksCustomerTypeList',
    PartnerQuickbooksInvoiceCustomFieldsList:
      'PartnerQuickbooksInvoiceCustomFieldsList',
    PartnerRutterAccountList: 'PartnerRutterAccountList',
    PartnerRutterAccountRead: 'PartnerRutterAccountRead',
    PartnerRutterConnectionRead: 'PartnerRutterConnectionRead',
    PartnerRutterPaymentTermsConnection: 'PartnerRutterPaymentTermsConnection',
    PartnerRutterSubsidiaryList: 'PartnerRutterSubsidiaryList',
    IntegrationPermissions: 'IntegrationPermissions',
    PartnerGetInvoicesSummary: 'PartnerGetInvoicesSummary',
    PartnerGetInvoiceLedgerMovements: 'PartnerGetInvoiceLedgerMovements',
    PartnerFindInvoice: 'PartnerFindInvoice',
    PartnerGetInvoicePdfLink: 'PartnerGetInvoicePdfLink',
    PartnerInvoiceListTotals: 'PartnerInvoiceListTotals',
    PartnerInvoiceSearch: 'PartnerInvoiceSearch',
    PartnerInvoiceConnection: 'PartnerInvoiceConnection',
    PartnerArInvoiceList: 'PartnerArInvoiceList',
    PartnerGetInvoicePreferences: 'PartnerGetInvoicePreferences',
    PartnerListInvoiceReminders: 'PartnerListInvoiceReminders',
    PartnerFindReminder: 'PartnerFindReminder',
    PartnerListInvoiceReminderExcludedCustomers:
      'PartnerListInvoiceReminderExcludedCustomers',
    PartnerListInvoiceSummaries: 'PartnerListInvoiceSummaries',
    PartnerFindSummary: 'PartnerFindSummary',
    PartnerListInvoiceSummaryExcludedCustomers:
      'PartnerListInvoiceSummaryExcludedCustomers',
    PartnerGetNotificationsEnabled: 'PartnerGetNotificationsEnabled',
    OpenPayoutSummary: 'OpenPayoutSummary',
    OpenPayoutsConnection: 'OpenPayoutsConnection',
    OpenPayoutDetails: 'OpenPayoutDetails',
    OpenPayoutBreakdownItemsConnection: 'OpenPayoutBreakdownItemsConnection',
    GetOverviewSummary: 'GetOverviewSummary',
    GetOverviewProfitability: 'GetOverviewProfitability',
    GetOverviewMrr: 'GetOverviewMrr',
    GetOverviewEfficiency: 'GetOverviewEfficiency',
    GetPartnerDocuments: 'GetPartnerDocuments',
    GetCompanyIndividuals: 'GetCompanyIndividuals',
    GetCompanyIndividualsWithDocuments: 'GetCompanyIndividualsWithDocuments',
    GetSupportPreferences: 'GetSupportPreferences',
    GetUserPartners: 'GetUserPartners',
    PartnerGetPartnerAutopayConfig: 'PartnerGetPartnerAutopayConfig',
    PartnerPaymentConnection: 'PartnerPaymentConnection',
    PartnerListPayments: 'PartnerListPayments',
    PartnerPaymentTotals: 'PartnerPaymentTotals',
    PartnerCalculatePaymentFee: 'PartnerCalculatePaymentFee',
    PartnerGetCustomerPaymentConfig: 'PartnerGetCustomerPaymentConfig',
    PartnerGetCustomersPaymentConfig: 'PartnerGetCustomersPaymentConfig',
    PartnerGetPaymentConfig: 'PartnerGetPaymentConfig',
    GetLogoUploadURL: 'GetLogoUploadURL',
    PartnerPayoutConnection: 'PartnerPayoutConnection',
    PartnerPayoutTotals: 'PartnerPayoutTotals',
    PartnerPayoutDetails: 'PartnerPayoutDetails',
    PartnerBreakdownListItemConnection: 'PartnerBreakdownListItemConnection',
    GetPayoutConfig: 'GetPayoutConfig',
    GetReferralPayoutConfig: 'GetReferralPayoutConfig',
    GetPayoutTimingConfig: 'GetPayoutTimingConfig',
    PartnerListPendingCustomerUsersTotals:
      'PartnerListPendingCustomerUsersTotals',
    PartnerPendingCustomerUserConnection:
      'PartnerPendingCustomerUserConnection',
    PartnerRecurringPaymentConnection: 'PartnerRecurringPaymentConnection',
    PartnerRecurringPaymentTotals: 'PartnerRecurringPaymentTotals',
    PartnerReferralGetQuarterlyEarningsData:
      'PartnerReferralGetQuarterlyEarningsData',
    PartnerReferralGetAvailableForPayoutData:
      'PartnerReferralGetAvailableForPayoutData',
    PartnerReferralGetTotalReferralFeesData:
      'PartnerReferralGetTotalReferralFeesData',
    PartnerReferralGetAvgQuarterlyFeesData:
      'PartnerReferralGetAvgQuarterlyFeesData',
    PartnerGetReferralLink: 'PartnerGetReferralLink',
    PartnerGetReferralPayoutByPayoutID: 'PartnerGetReferralPayoutByPayoutID',
    PartnerReferralConnection: 'PartnerReferralConnection',
    PartnerGetReferralLinkInfo: 'PartnerGetReferralLinkInfo',
    PartnerListRoutines: 'PartnerListRoutines',
    PartnerGetRoutine: 'PartnerGetRoutine',
    PartnerListRoutineRuns: 'PartnerListRoutineRuns',
    PartnerGetRoutineRun: 'PartnerGetRoutineRun',
    PartnerRoutineRunFileDownloadURL: 'PartnerRoutineRunFileDownloadURL',
    PartnerScheduledOneOffEmailConnection:
      'PartnerScheduledOneOffEmailConnection',
    PartnerGetScheduledOneOffEmail: 'PartnerGetScheduledOneOffEmail',
    PartnerListActiveSubscriptions: 'PartnerListActiveSubscriptions',
    PartnerSubscriptionsPaymentsConnection:
      'PartnerSubscriptionsPaymentsConnection',
    PartnerListSubscriptionPaymentsTotals:
      'PartnerListSubscriptionPaymentsTotals',
    PartnerAccountingSyncConfigGet: 'PartnerAccountingSyncConfigGet',
    GetUserInfo: 'GetUserInfo',
    GetUserInfoDetails: 'GetUserInfoDetails',
    CreateUserAndPartner: 'CreateUserAndPartner',
    PartnerUserConnection: 'PartnerUserConnection'
  },
  Mutation: {
    PartnerUploadDocumentByUploadLinkId: 'PartnerUploadDocumentByUploadLinkId',
    PartnerCreateCardRevealToken: 'PartnerCreateCardRevealToken',
    PartnerCreateBill: 'PartnerCreateBill',
    PartnerCreateVendor: 'PartnerCreateVendor',
    PartnerUpdateVendor: 'PartnerUpdateVendor',
    PartnerCreateVendorPaymentPreference:
      'PartnerCreateVendorPaymentPreference',
    PartnerUpdateBill: 'PartnerUpdateBill',
    PartnerSubmitBillForApproval: 'PartnerSubmitBillForApproval',
    PartnerBulkSubmitBillsForApproval: 'PartnerBulkSubmitBillsForApproval',
    PartnerRejectBill: 'PartnerRejectBill',
    PartnerMarkBillPaidExternally: 'PartnerMarkBillPaidExternally',
    PartnerUpdateVendorPaymentPreference:
      'PartnerUpdateVendorPaymentPreference',
    PartnerStartAccountsPayableOnboarding:
      'PartnerStartAccountsPayableOnboarding',
    PartnerCreateFundingAttempts: 'PartnerCreateFundingAttempts',
    PartnerChangeBillReceivingMethod: 'PartnerChangeBillReceivingMethod',
    PartnerRevealVirtualCard: 'PartnerRevealVirtualCard',
    PartnerUpdateBillPayDate: 'PartnerUpdateBillPayDate',
    PartnerCancelVendorPayment: 'PartnerCancelVendorPayment',
    PartnerBulkCancelVendorPayments: 'PartnerBulkCancelVendorPayments',
    PartnerBulkCancelBillSchedule: 'PartnerBulkCancelBillSchedule',
    PartnerUpdateAccountsPayableNotificationPolicy:
      'PartnerUpdateAccountsPayableNotificationPolicy',
    PartnerDeleteBills: 'PartnerDeleteBills',
    PartnerChangeAccountsPayableFundingAccount:
      'PartnerChangeAccountsPayableFundingAccount',
    PartnerCreateVendorDataRequest: 'PartnerCreateVendorDataRequest',
    PartnerResendVendorDataRequest: 'PartnerResendVendorDataRequest',
    SubmitVendorData: 'SubmitVendorData',
    PartnerDeactivateVendor: 'PartnerDeactivateVendor',
    PartnerReactivateVendor: 'PartnerReactivateVendor',
    PartnerBatchDeactivateVendors: 'PartnerBatchDeactivateVendors',
    PartnerBatchReactivateVendors: 'PartnerBatchReactivateVendors',
    PartnerSetAccountingIntegration: 'PartnerSetAccountingIntegration',
    PartnerUploadBillDocument: 'PartnerUploadBillDocument',
    PartnerExtractBillData: 'PartnerExtractBillData',
    PartnerMergeVendors: 'PartnerMergeVendors',
    PartnerDismissVendorSimilarityGroup: 'PartnerDismissVendorSimilarityGroup',
    PartnerRetryPaymentQboSync: 'PartnerRetryPaymentQboSync',
    RequestVendorCardOTP: 'RequestVendorCardOTP',
    RevealVendorCardData: 'RevealVendorCardData',
    SolveRemediationActionsByIDs: 'SolveRemediationActionsByIDs',
    SolveAdyenRemediationActions: 'SolveAdyenRemediationActions',
    UploadAdyenDocument: 'UploadAdyenDocument',
    StagingStartAdyenOnboarding: 'StagingStartAdyenOnboarding',
    PartnerCreateClientTrendsPreset: 'PartnerCreateClientTrendsPreset',
    PartnerUpdateClientTrendsPreset: 'PartnerUpdateClientTrendsPreset',
    PartnerDeleteClientTrendsPreset: 'PartnerDeleteClientTrendsPreset',
    ExportClientTrendsCSV: 'ExportClientTrendsCSV',
    ExportClientTrendsBreakdownCSV: 'ExportClientTrendsBreakdownCSV',
    PartnerCreateUtilizationPreset: 'PartnerCreateUtilizationPreset',
    PartnerUpdateUtilizationPreset: 'PartnerUpdateUtilizationPreset',
    PartnerDeleteUtilizationPreset: 'PartnerDeleteUtilizationPreset',
    ExportUtilizationCSV: 'ExportUtilizationCSV',
    ExportUtilizationBreakdownCSV: 'ExportUtilizationBreakdownCSV',
    PartnerCreateApiKey: 'PartnerCreateApiKey',
    PartnerUpdateApiKey: 'PartnerUpdateApiKey',
    PartnerRevokeApiKey: 'PartnerRevokeApiKey',
    CreateAssistantConversation: 'CreateAssistantConversation',
    DeleteAssistantConversation: 'DeleteAssistantConversation',
    ConfirmAssistantAction: 'ConfirmAssistantAction',
    CreateAssistantV2Conversation: 'CreateAssistantV2Conversation',
    DeleteAssistantV2Conversation: 'DeleteAssistantV2Conversation',
    RenameAssistantV2Conversation: 'RenameAssistantV2Conversation',
    ConfirmAssistantV2Action: 'ConfirmAssistantV2Action',
    UploadAssistantV2File: 'UploadAssistantV2File',
    OAuth2Exchange: 'OAuth2Exchange',
    OAuth2Refresh: 'OAuth2Refresh',
    PartnerAutopayExcludedInvoiceDelete: 'PartnerAutopayExcludedInvoiceDelete',
    PartnerAutopayExcludedInvoiceCreate: 'PartnerAutopayExcludedInvoiceCreate',
    PartnerAutopayExcludedInvoiceBatchCreate:
      'PartnerAutopayExcludedInvoiceBatchCreate',
    PartnerCreateAutopayRule: 'PartnerCreateAutopayRule',
    PartnerUpdateAutopayRule: 'PartnerUpdateAutopayRule',
    PartnerDeleteAutopayRule: 'PartnerDeleteAutopayRule',
    PartnerAutopayExcludedCustomerCreate:
      'PartnerAutopayExcludedCustomerCreate',
    PartnerAutopayExcludedCustomerUpdate:
      'PartnerAutopayExcludedCustomerUpdate',
    PartnerAutopayExcludedCustomerDelete:
      'PartnerAutopayExcludedCustomerDelete',
    SetCustomerAutopayConfig: 'SetCustomerAutopayConfig',
    BNPLOfferConfirmByToken: 'BNPLOfferConfirmByToken',
    PartnerBNPLOfferConfirm: 'PartnerBNPLOfferConfirm',
    PartnerChangeReferralPayoutBankingAccount:
      'PartnerChangeReferralPayoutBankingAccount',
    PartnerArchiveAccount: 'PartnerArchiveAccount',
    PartnerAddManualBankingConnection: 'PartnerAddManualBankingConnection',
    PartnerAddManualBankingConnectionV2: 'PartnerAddManualBankingConnectionV2',
    PartnerAddCustomerBankingConnection: 'PartnerAddCustomerBankingConnection',
    PartnerChangeDefaultPayoutBankingAccount:
      'PartnerChangeDefaultPayoutBankingAccount',
    PartnerAddBankAccount: 'PartnerAddBankAccount',
    PartnerAddCustomerBankAccount: 'PartnerAddCustomerBankAccount',
    PartnerUploadBankAccountDocument: 'PartnerUploadBankAccountDocument',
    PartnerUpdateBankAccount: 'PartnerUpdateBankAccount',
    PartnerUpdateBankAccountV2: 'PartnerUpdateBankAccountV2',
    PartnerUpdateBankAccountCustomName: 'PartnerUpdateBankAccountCustomName',
    PartnerCollectMandateConsent: 'PartnerCollectMandateConsent',
    PartnerInvoiceBulkChargeOnDate: 'PartnerInvoiceBulkChargeOnDate',
    PartnerInvoiceBulkChargeOnDueDate: 'PartnerInvoiceBulkChargeOnDueDate',
    PartnerCreateCollection: 'PartnerCreateCollection',
    PartnerCancelCollection: 'PartnerCancelCollection',
    PartnerCreateCard: 'PartnerCreateCard',
    PartnerCreateCustomerCard: 'PartnerCreateCustomerCard',
    PartnerDeleteCard: 'PartnerDeleteCard',
    PartnerDeleteCustomerCard: 'PartnerDeleteCustomerCard',
    PartnerUpdateCardCustomName: 'PartnerUpdateCardCustomName',
    PartnerUpdateCard: 'PartnerUpdateCard',
    PartnerUpdateCreditMemoConfig: 'PartnerUpdateCreditMemoConfig',
    PartnerUpdateCreditMemoConfigExceptions:
      'PartnerUpdateCreditMemoConfigExceptions',
    PartnerResyncCustomerCreditMemoBalance:
      'PartnerResyncCustomerCreditMemoBalance',
    PartnerBatchTagCustomers: 'PartnerBatchTagCustomers',
    PartnerDeleteCustomerTag: 'PartnerDeleteCustomerTag',
    PartnerUpdateCustomerTag: 'PartnerUpdateCustomerTag',
    PartnerTagCustomer: 'PartnerTagCustomer',
    PartnerUntagCustomer: 'PartnerUntagCustomer',
    PartnerCreateCustomerTag: 'PartnerCreateCustomerTag',
    PartnerArchiveCustomer: 'PartnerArchiveCustomer',
    PartnerUnarchiveCustomer: 'PartnerUnarchiveCustomer',
    PartnerCreateCustomer: 'PartnerCreateCustomer',
    UpdateCustomer: 'UpdateCustomer',
    PartnerBulkToggleArchiveCustomers: 'PartnerBulkToggleArchiveCustomers',
    PartnerArchiveCustomerAccount: 'PartnerArchiveCustomerAccount',
    PartnerCreateCustomerUser: 'PartnerCreateCustomerUser',
    PartnerDeleteCustomerUser: 'PartnerDeleteCustomerUser',
    UpdateCustomerUser: 'UpdateCustomerUser',
    PartnerCreateEmailTemplate: 'PartnerCreateEmailTemplate',
    PartnerUpdateEmailTemplate: 'PartnerUpdateEmailTemplate',
    PartnerDeleteEmailTemplate: 'PartnerDeleteEmailTemplate',
    PartnerToggleEmailTemplateFavorite: 'PartnerToggleEmailTemplateFavorite',
    PartnerChangeCustomPartnerFeeConfig: 'PartnerChangeCustomPartnerFeeConfig',
    PartnerChangeCustomerFeeConfig: 'PartnerChangeCustomerFeeConfig',
    PartnerChangePartnerFeeConfig: 'PartnerChangePartnerFeeConfig',
    PartnerChangeBulkCustomerFeeConfig: 'PartnerChangeBulkCustomerFeeConfig',
    PartnerUpsertPassThroughFees: 'PartnerUpsertPassThroughFees',
    PartnerAutotaskConnectionCreate: 'PartnerAutotaskConnectionCreate',
    PartnerAutotaskConnectionUpdate: 'PartnerAutotaskConnectionUpdate',
    PartnerConnectWiseConnectionCreate: 'PartnerConnectWiseConnectionCreate',
    PartnerConnectWiseConnectionUpdate: 'PartnerConnectWiseConnectionUpdate',
    PartnerDatagateConnectionCreate: 'PartnerDatagateConnectionCreate',
    PartnerHaloPSAConnectionCreate: 'PartnerHaloPSAConnectionCreate',
    PartnerHaloPSAConnectionQueryFiltersUpdate:
      'PartnerHaloPSAConnectionQueryFiltersUpdate',
    PartnerRetryIntegrationIssue: 'PartnerRetryIntegrationIssue',
    PartnerJobRetry: 'PartnerJobRetry',
    PartnerJobQueueRetry: 'PartnerJobQueueRetry',
    ExplainIntegrationError: 'ExplainIntegrationError',
    ExplainIntegrationErrorFeedback: 'ExplainIntegrationErrorFeedback',
    PartnerIntegrationDisconnect: 'PartnerIntegrationDisconnect',
    PartnerIntegrationSync: 'PartnerIntegrationSync',
    PartnerAccountingSyncBatchCreate: 'PartnerAccountingSyncBatchCreate',
    PartnerSecondaryIntegrationDelete: 'PartnerSecondaryIntegrationDelete',
    PartnerRefreshUnsyncedInvoices: 'PartnerRefreshUnsyncedInvoices',
    PartnerAccountingPreferencesUpdate: 'PartnerAccountingPreferencesUpdate',
    PartnerQuickbooksAccountUpdate: 'PartnerQuickbooksAccountUpdate',
    PartnerQuickbooksConnectionCreate: 'PartnerQuickbooksConnectionCreate',
    PartnerQuickbooksConnectionUpdate: 'PartnerQuickbooksConnectionUpdate',
    PartnerUpdateExpenseAccountVisibility:
      'PartnerUpdateExpenseAccountVisibility',
    PartnerQuickbooksConnectionQueryFiltersUpdate:
      'PartnerQuickbooksConnectionQueryFiltersUpdate',
    PartnerRutterConnectionCreate: 'PartnerRutterConnectionCreate',
    PartnerRutterAccountUpsert: 'PartnerRutterAccountUpsert',
    PartnerRutterConnectionUpdate: 'PartnerRutterConnectionUpdate',
    PartnerRutterAccountUnset: 'PartnerRutterAccountUnset',
    PartnerRutterAccountUpsertMany: 'PartnerRutterAccountUpsertMany',
    PartnerRutterConnectionFiltersUpdate:
      'PartnerRutterConnectionFiltersUpdate',
    PartnerRutterConnectionCreateDepositsUpdate:
      'PartnerRutterConnectionCreateDepositsUpdate',
    PartnerSuperopsConnectionCreate: 'PartnerSuperopsConnectionCreate',
    RefreshIntegrationPermissions: 'RefreshIntegrationPermissions',
    PartnerInvoiceArchive: 'PartnerInvoiceArchive',
    PartnerInvoiceUnarchive: 'PartnerInvoiceUnarchive',
    PartnerInvoiceCreate: 'PartnerInvoiceCreate',
    PartnerInvoicePaidUpdate: 'PartnerInvoicePaidUpdate',
    PartnerInvoiceRemind: 'PartnerInvoiceRemind',
    PartnerPayInvoice: 'PartnerPayInvoice',
    PartnerUpsertInvoicePreferences: 'PartnerUpsertInvoicePreferences',
    PartnerUpdateReminder: 'PartnerUpdateReminder',
    PartnerCreateInvoiceReminder: 'PartnerCreateInvoiceReminder',
    PartnerDeleteInvoiceReminder: 'PartnerDeleteInvoiceReminder',
    PartnerCreateInvoiceReminderExcludedCustomer:
      'PartnerCreateInvoiceReminderExcludedCustomer',
    PartnerUpdateInvoiceReminderExcludedCustomer:
      'PartnerUpdateInvoiceReminderExcludedCustomer',
    PartnerDeleteInvoiceReminderExcludedCustomer:
      'PartnerDeleteInvoiceReminderExcludedCustomer',
    PartnerSendInvoiceReminderPreview: 'PartnerSendInvoiceReminderPreview',
    PartnerToggleReminderEnabled: 'PartnerToggleReminderEnabled',
    PartnerBulkInvoiceRemind: 'PartnerBulkInvoiceRemind',
    PartnerUpdateSummary: 'PartnerUpdateSummary',
    PartnerCreateInvoiceSummary: 'PartnerCreateInvoiceSummary',
    PartnerDeleteInvoiceSummary: 'PartnerDeleteInvoiceSummary',
    PartnerCreateInvoiceSummaryExcludedCustomer:
      'PartnerCreateInvoiceSummaryExcludedCustomer',
    PartnerUpdateInvoiceSummaryExcludedCustomer:
      'PartnerUpdateInvoiceSummaryExcludedCustomer',
    PartnerDeleteInvoiceSummaryExcludedCustomer:
      'PartnerDeleteInvoiceSummaryExcludedCustomer',
    PartnerSendInvoiceSummaryPreview: 'PartnerSendInvoiceSummaryPreview',
    PartnerToggleSummaryEnabled: 'PartnerToggleSummaryEnabled',
    PartnerUpdateNotificationsEnabled: 'PartnerUpdateNotificationsEnabled',
    PartnerSendOneOffEmail: 'PartnerSendOneOffEmail',
    PartnerUpdateInvoicePdfSettings: 'PartnerUpdateInvoicePdfSettings',
    PartnerUpdateInformation: 'PartnerUpdateInformation',
    PartnerUpdateTimezone: 'PartnerUpdateTimezone',
    ActivatePartnerPaymentsPortal: 'ActivatePartnerPaymentsPortal',
    CreateCompanyIndividual: 'CreateCompanyIndividual',
    UpdateCompanyIndividual: 'UpdateCompanyIndividual',
    DeleteCompanyIndividual: 'DeleteCompanyIndividual',
    PartnerDeleteCompanyDocumentsByIndividualId:
      'PartnerDeleteCompanyDocumentsByIndividualId',
    PartnerCreateCompanyIndividualUploadLink:
      'PartnerCreateCompanyIndividualUploadLink',
    UploadPartnerDocument: 'UploadPartnerDocument',
    UpsertSupportPreferences: 'UpsertSupportPreferences',
    PartnerFinishOnboarding: 'PartnerFinishOnboarding',
    PartnerUpdateDetails: 'PartnerUpdateDetails',
    PartnerUpdateAddress: 'PartnerUpdateAddress',
    PartnerTogglePaymentsPortalCustomInvoices:
      'PartnerTogglePaymentsPortalCustomInvoices',
    PartnerToggleRequiresMFA: 'PartnerToggleRequiresMFA',
    PartnerUpdateName: 'PartnerUpdateName',
    PartnerChangePartnerAutopayConfig: 'PartnerChangePartnerAutopayConfig',
    PartnerCancelScheduledPayment: 'PartnerCancelScheduledPayment',
    PartnerReschedulePayment: 'PartnerReschedulePayment',
    PartnerChangePaymentConfig: 'PartnerChangePaymentConfig',
    PartnerChangeCustomerPaymentConfig: 'PartnerChangeCustomerPaymentConfig',
    PartnerUpdatePaymentsPortalMethods: 'PartnerUpdatePaymentsPortalMethods',
    PartnerUpdatePaymentsPortalCustomization:
      'PartnerUpdatePaymentsPortalCustomization',
    StagingEnablePartnerPaymentsPortal: 'StagingEnablePartnerPaymentsPortal',
    UpdatePayoutTimingConfig: 'UpdatePayoutTimingConfig',
    PartnerRejectPendingCustomerUser: 'PartnerRejectPendingCustomerUser',
    PartnerApprovePendingCustomerUser: 'PartnerApprovePendingCustomerUser',
    PartnerLinkPendingCustomerUser: 'PartnerLinkPendingCustomerUser',
    PartnerUnlinkPendingCustomerUser: 'PartnerUnlinkPendingCustomerUser',
    RecurringPaymentCreate: 'RecurringPaymentCreate',
    RecurringPaymentDeactivate: 'RecurringPaymentDeactivate',
    RecurringPaymentUpdate: 'RecurringPaymentUpdate',
    PartnerCreateReferral: 'PartnerCreateReferral',
    PartnerUpdateReferral: 'PartnerUpdateReferral',
    PartnerSendReferral: 'PartnerSendReferral',
    UpdatePartnerReferralLink: 'UpdatePartnerReferralLink',
    CreateRefund: 'CreateRefund',
    CancelRefund: 'CancelRefund',
    PartnerSendReport: 'PartnerSendReport',
    PartnerUpdateRoutine: 'PartnerUpdateRoutine',
    PartnerDeleteRoutine: 'PartnerDeleteRoutine',
    PartnerRunRoutineNow: 'PartnerRunRoutineNow',
    PartnerDeleteScheduledOneOffEmail: 'PartnerDeleteScheduledOneOffEmail',
    PartnerUpdateScheduledOneOffEmail: 'PartnerUpdateScheduledOneOffEmail',
    PartnerSendScheduledOneOffEmailNow: 'PartnerSendScheduledOneOffEmailNow',
    PartnerCancelSubscription: 'PartnerCancelSubscription',
    PartnerAccountingSyncConfigCreate: 'PartnerAccountingSyncConfigCreate',
    PartnerAccountingSyncConfigUpdate: 'PartnerAccountingSyncConfigUpdate',
    PartnerUpdateMyUser: 'PartnerUpdateMyUser',
    PartnerInviteUser: 'PartnerInviteUser',
    PartnerUpdateUser: 'PartnerUpdateUser',
    PartnerDeleteUser: 'PartnerDeleteUser'
  },
  Subscription: {
    SendAssistantMessage: 'SendAssistantMessage',
    SendAssistantV2Message: 'SendAssistantV2Message',
    ReattachAssistantV2Message: 'ReattachAssistantV2Message'
  },
  Fragment: {
    APNotificationPolicy: 'APNotificationPolicy',
    PaymentPreference: 'PaymentPreference',
    PartnerVendorSearch: 'PartnerVendorSearch',
    VendorListItem: 'VendorListItem',
    Vendor: 'Vendor',
    BillVendor: 'BillVendor',
    BillLastStatus: 'BillLastStatus',
    VendorPaymentFragment: 'VendorPaymentFragment',
    BillLineItem: 'BillLineItem',
    BillConnection: 'BillConnection',
    Bill: 'Bill',
    PartialCompanyIndividual: 'PartialCompanyIndividual',
    AccountingItemFragment: 'AccountingItemFragment',
    AccountsPayableConfig: 'AccountsPayableConfig',
    ApFundingAccount: 'ApFundingAccount',
    VendorAuditLogEntry: 'VendorAuditLogEntry',
    VendorSimilarityGroupFields: 'VendorSimilarityGroupFields',
    MergedVendorFields: 'MergedVendorFields',
    InboundEmailAttachment: 'InboundEmailAttachment',
    InboundEmail: 'InboundEmail',
    ClientTrendsPresetFields: 'ClientTrendsPresetFields',
    ApiKey: 'ApiKey',
    HomeDeltaFields: 'HomeDeltaFields',
    HomeCashFlowFields: 'HomeCashFlowFields',
    HomeAttentionCustomerFields: 'HomeAttentionCustomerFields',
    Token: 'Token',
    AutopayExcludedList: 'AutopayExcludedList',
    AutopayRulesWithBankingAndCard: 'AutopayRulesWithBankingAndCard',
    AutopayRulesWithCustomerTags: 'AutopayRulesWithCustomerTags',
    AutopayRules: 'AutopayRules',
    CustomerAutopayConfig: 'CustomerAutopayConfig',
    InvoiceCovered: 'InvoiceCovered',
    FindAutopayRule: 'FindAutopayRule',
    PartnerCustomerBNPL: 'PartnerCustomerBNPL',
    PartnerCustomerOffer: 'PartnerCustomerOffer',
    PartnerCustomerSchedule: 'PartnerCustomerSchedule',
    PartnerCustomerInstallment: 'PartnerCustomerInstallment',
    Bank: 'Bank',
    BankAccount: 'BankAccount',
    BankWithVerification: 'BankWithVerification',
    BankAccountWithVerification: 'BankAccountWithVerification',
    BankAccountInfo: 'BankAccountInfo',
    PartnerInvoiceBulkCharge: 'PartnerInvoiceBulkCharge',
    PaymentRequest: 'PaymentRequest',
    PartnerCollectionInvoice: 'PartnerCollectionInvoice',
    UpfrontFeePayment: 'UpfrontFeePayment',
    PartnerCollectionListing: 'PartnerCollectionListing',
    PartnerCollectionDetail: 'PartnerCollectionDetail',
    PartnerOverdueInvoice: 'PartnerOverdueInvoice',
    CreditCard: 'CreditCard',
    PartnerCreditMemoConfig: 'PartnerCreditMemoConfig',
    PartnerCustomerCreditMemoBalance: 'PartnerCustomerCreditMemoBalance',
    CreditMemoDetailFields: 'CreditMemoDetailFields',
    CustomerV2Fields: 'CustomerV2Fields',
    PartnerCustomerAddress: 'PartnerCustomerAddress',
    PartnerCustomerBasic: 'PartnerCustomerBasic',
    PartnerCustomer: 'PartnerCustomer',
    PartnerCustomerListWithInvoicesData: 'PartnerCustomerListWithInvoicesData',
    CustomerWithCustomerUserList: 'CustomerWithCustomerUserList',
    PartnerCustomerList: 'PartnerCustomerList',
    PartnerCustomerSearch: 'PartnerCustomerSearch',
    PartnerListCustomerUsers: 'PartnerListCustomerUsers',
    PartnerCustomerUserCreation: 'PartnerCustomerUserCreation',
    PartnerEmailActivity: 'PartnerEmailActivity',
    EmailTemplate: 'EmailTemplate',
    PartnerCustomerFeeConfig: 'PartnerCustomerFeeConfig',
    BucketCountData: 'BucketCountData',
    BucketAmountData: 'BucketAmountData',
    DataPoint: 'DataPoint',
    InvoiceCountMonth: 'InvoiceCountMonth',
    InvoiceAmountMonth: 'InvoiceAmountMonth',
    CWQueryFilters: 'CWQueryFilters',
    HaloQueryFilters: 'HaloQueryFilters',
    PartnerIntegrationIssue: 'PartnerIntegrationIssue',
    PartnerIntegrationJob: 'PartnerIntegrationJob',
    PartnerIntegrationJobQueue: 'PartnerIntegrationJobQueue',
    PartnerIntegration: 'PartnerIntegration',
    PartnerUnsyncedInvoice: 'PartnerUnsyncedInvoice',
    AccountingSyncBatch: 'AccountingSyncBatch',
    QuickbooksAccount: 'QuickbooksAccount',
    RutterAccountList: 'RutterAccountList',
    PartnerInvoiceSearch: 'PartnerInvoiceSearch',
    PartnerInvoiceEmailActivity: 'PartnerInvoiceEmailActivity',
    PartnerInvoiceBasic: 'PartnerInvoiceBasic',
    PartnerInvoiceListing: 'PartnerInvoiceListing',
    PartnerInvoice: 'PartnerInvoice',
    PartnerInvoiceOffer: 'PartnerInvoiceOffer',
    PartnerInvoiceReminder: 'PartnerInvoiceReminder',
    PartnerInvoiceReminderExcludedCustomer:
      'PartnerInvoiceReminderExcludedCustomer',
    PartnerInvoiceSummary: 'PartnerInvoiceSummary',
    PartnerInvoiceSummaryExcludedCustomer:
      'PartnerInvoiceSummaryExcludedCustomer',
    PartnerOpenPayoutDetails: 'PartnerOpenPayoutDetails',
    PartnerOpenPayoutBreakdownItem: 'PartnerOpenPayoutBreakdownItem',
    CompanyDocument: 'CompanyDocument',
    CompanyIndividual: 'CompanyIndividual',
    CompanyIndividualWithDocuments: 'CompanyIndividualWithDocuments',
    PartnerBase: 'PartnerBase',
    PartnerSidebarItem: 'PartnerSidebarItem',
    PartnerDetails: 'PartnerDetails',
    PartnerConfig: 'PartnerConfig',
    PartnerAddressDetails: 'PartnerAddressDetails',
    SupportPreferences: 'SupportPreferences',
    PartnerPayment: 'PartnerPayment',
    PaymentConfig: 'PaymentConfig',
    CustomerPaymentMethod: 'CustomerPaymentMethod',
    CustomersPaymentMethod: 'CustomersPaymentMethod',
    PayoutBreakdownTotals: 'PayoutBreakdownTotals',
    PartnerPayoutDetails: 'PartnerPayoutDetails',
    Transaction: 'Transaction',
    PartnerPayout: 'PartnerPayout',
    PartnerBreakdownListItem: 'PartnerBreakdownListItem',
    PartnerListPendingCustomerUser: 'PartnerListPendingCustomerUser',
    PartnerListPendingCustomer: 'PartnerListPendingCustomer',
    PartnerRecurringPayment: 'PartnerRecurringPayment',
    GetReferralDataReply: 'GetReferralDataReply',
    Referral: 'Referral',
    ReferralPayout: 'ReferralPayout',
    ReferralBonus: 'ReferralBonus',
    RoutineListItem: 'RoutineListItem',
    RoutineDetail: 'RoutineDetail',
    RoutineRunRow: 'RoutineRunRow',
    RoutineRunDetail: 'RoutineRunDetail',
    PartnerScheduledOneOffEmail: 'PartnerScheduledOneOffEmail',
    SubscriptionPayment: 'SubscriptionPayment',
    PartnerSubscription: 'PartnerSubscription',
    PartnerSubscriptionPaymentBasic: 'PartnerSubscriptionPaymentBasic',
    PartnerUserList: 'PartnerUserList',
    BasicUserInfo: 'BasicUserInfo',
    BasicPartnerUserInfo: 'BasicPartnerUserInfo',
    PartnerUserConfigDetails: 'PartnerUserConfigDetails',
    PartnerUserInfoDetails: 'PartnerUserInfoDetails',
    PartnerAddressInfo: 'PartnerAddressInfo',
    UserInfo: 'UserInfo',
    UserInfoDetails: 'UserInfoDetails',
    PartnerBaseUser: 'PartnerBaseUser',
    PartnerListUser: 'PartnerListUser'
  }
}
